/**
 * Per-character ROUTE MAP, derived from the played archive.
 *
 * Generated by scripts/build-route-map.py from rp_history
 * (158,540 passages, 407 channels, 2016-2026). Do not hand-edit —
 * regenerate instead.
 *
 * kind: 'canon'  largest non-AU, non-OOC cluster for that character
 *       'route'  another route they were genuinely played in
 *       'au'     channel declares itself an AU; never canon
 *       'ooc'    players talking about them, not in character
 *
 * knownCharacters is drawn from CANON routes only, so an AU
 * acquaintance does not leak into a scene it never happened in.
 */

export const CHARACTER_ROUTES = {
 "kya_sg1": {
  "canonRoute": "siren-places",
  "totalPassages": 1529,
  "routes": [
   {
    "channel": "siren-places",
    "passages": 233,
    "share": 0.1524,
    "first": "2020-06-30",
    "last": "2020-07-23",
    "kind": "canon",
    "castWith": [
     "sebastian_vamp",
     "sebastian_siren",
     "kya_sg3",
     "polly",
     "kaleb",
     "evelyn",
     "ever",
     "midori_naga",
     "skipper",
     "kyo"
    ]
   },
   {
    "channel": "val",
    "passages": 68,
    "share": 0.0445,
    "first": "2020-04-15",
    "last": "2020-12-27",
    "kind": "route",
    "castWith": [
     "val",
     "kya_sg3",
     "kaleb",
     "alistair",
     "alistair_turayne",
     "evelyn",
     "vanessa",
     "ezra",
     "raye",
     "alan",
     "tyrion",
     "mr_han_sr"
    ]
   },
   {
    "channel": "siren-raye",
    "passages": 60,
    "share": 0.0392,
    "first": "2023-10-16",
    "last": "2023-10-25",
    "kind": "route",
    "castWith": [
     "raye",
     "kya_sg3",
     "sebastian_vamp",
     "sebastian_siren",
     "apollo",
     "aphrodite",
     "kaleb",
     "cupid_eros",
     "hermes",
     "ezra",
     "ares",
     "may"
    ]
   },
   {
    "channel": "brothel",
    "passages": 56,
    "share": 0.0366,
    "first": "2020-04-18",
    "last": "2020-04-28",
    "kind": "route",
    "castWith": [
     "ezra",
     "evelyn",
     "rowan",
     "kya_sg3",
     "primrose",
     "lily",
     "kaleb",
     "nellie",
     "lissa",
     "raye",
     "ace",
     "mr_han_sr"
    ]
   },
   {
    "channel": "kya-college-2",
    "passages": 55,
    "share": 0.036,
    "first": "2020-12-27",
    "last": "2021-01-28",
    "kind": "route",
    "castWith": [
     "lily",
     "zander",
     "kya_sg3",
     "ari",
     "sebastian_siren",
     "raye",
     "prince_zed",
     "sebastian_vamp",
     "midori_naga",
     "penelope_valk",
     "bell_lily_of_fell",
     "agnar"
    ]
   },
   {
    "channel": "super-siren-cruise-ship",
    "passages": 46,
    "share": 0.0301,
    "first": "2023-07-24",
    "last": "2023-08-03",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "sebastian_vamp",
     "sebastian_siren",
     "evelyn",
     "kaleb",
     "dillon",
     "ezra",
     "raye",
     "uncle_khan",
     "alistair",
     "alistair_turayne",
     "aaron"
    ]
   },
   {
    "channel": "kaleb-kya-finally",
    "passages": 43,
    "share": 0.0281,
    "first": "2021-02-06",
    "last": "2021-02-17",
    "kind": "route",
    "castWith": [
     "kaleb",
     "kya_sg3",
     "evelyn",
     "sebastian_siren",
     "sebastian_vamp",
     "apollo",
     "gabs",
     "uncle_khan",
     "alexander",
     "dimitri",
     "kyo",
     "ami"
    ]
   },
   {
    "channel": "dorms",
    "passages": 41,
    "share": 0.0268,
    "first": "2020-04-29",
    "last": "2020-05-16",
    "kind": "route",
    "castWith": [
     "agnar",
     "kya_sg3",
     "agmund",
     "evelyn",
     "raye",
     "cole",
     "riku",
     "kaleb",
     "penelope_valk",
     "loki",
     "svira",
     "darren"
    ]
   },
   {
    "channel": "kya-senior-year",
    "passages": 32,
    "share": 0.0209,
    "first": "2021-06-14",
    "last": "2021-07-07",
    "kind": "route",
    "castWith": [
     "callan",
     "ezra",
     "leiden",
     "melody",
     "kya_sg3",
     "kaleb",
     "raye",
     "tate",
     "sebastian_vamp",
     "dillon",
     "sebastian_siren",
     "evelyn"
    ]
   },
   {
    "channel": "kya-war-au",
    "passages": 29,
    "share": 0.019,
    "first": "2021-11-24",
    "last": "2021-12-06",
    "kind": "au",
    "castWith": [
     "ezra",
     "kya_sg3",
     "james",
     "val",
     "vanessa",
     "kaleb",
     "raye",
     "sebastian_vamp",
     "sebastian_siren",
     "lily",
     "junta",
     "evelyn"
    ]
   },
   {
    "channel": "kya-werewolf",
    "passages": 27,
    "share": 0.0177,
    "first": "2021-08-17",
    "last": "2021-09-25",
    "kind": "route",
    "castWith": [
     "jace",
     "raphael",
     "trey",
     "dillon",
     "kya_sg3",
     "scott",
     "ezra",
     "sebastian_siren",
     "kaleb",
     "sebastian_vamp",
     "evelyn",
     "will"
    ]
   },
   {
    "channel": "not-a-landbond-route",
    "passages": 25,
    "share": 0.0164,
    "first": "2021-12-22",
    "last": "2022-01-28",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "sebastian_siren",
     "evelyn",
     "sebastian_vamp",
     "ezra",
     "jack",
     "raye",
     "kaleb",
     "alistair",
     "alistair_turayne",
     "uncle_khan",
     "polly"
    ]
   }
  ],
  "knownCharacters": [
   "sebastian_vamp",
   "sebastian_siren",
   "kya_sg3",
   "polly",
   "kaleb",
   "evelyn",
   "ever",
   "midori_naga",
   "skipper",
   "kyo"
  ]
 },
 "kieran": {
  "canonRoute": "kieran-is-a-hoe-for-raz",
  "totalPassages": 730,
  "routes": [
   {
    "channel": "kieran-is-a-hoe-for-raz",
    "passages": 119,
    "share": 0.163,
    "first": "2026-02-04",
    "last": "2026-03-03",
    "kind": "canon",
    "castWith": [
     "raz",
     "peter",
     "will",
     "james"
    ]
   },
   {
    "channel": "junta-tim-soulmates",
    "passages": 96,
    "share": 0.1315,
    "first": "2023-09-10",
    "last": "2023-09-23",
    "kind": "route",
    "castWith": [
     "junta",
     "tim",
     "raz",
     "peter",
     "kris",
     "dalton",
     "val",
     "vanessa",
     "ever",
     "aphrodite",
     "natasha",
     "will"
    ]
   },
   {
    "channel": "human-kieran",
    "passages": 93,
    "share": 0.1274,
    "first": "2023-12-31",
    "last": "2024-01-10",
    "kind": "route",
    "castWith": [
     "peter",
     "raz",
     "evan",
     "mei",
     "gemma",
     "ms_tia",
     "will"
    ]
   },
   {
    "channel": "raz-the-assbro",
    "passages": 82,
    "share": 0.1123,
    "first": "2023-10-29",
    "last": "2023-11-11",
    "kind": "route",
    "castWith": [
     "raz",
     "peter",
     "junta",
     "will"
    ]
   },
   {
    "channel": "kieran-ezra",
    "passages": 75,
    "share": 0.1027,
    "first": "2023-10-07",
    "last": "2023-10-12",
    "kind": "route",
    "castWith": [
     "ezra",
     "raz",
     "lily",
     "peter",
     "primrose",
     "rosalie",
     "ace",
     "gemma"
    ]
   },
   {
    "channel": "kierans-back",
    "passages": 66,
    "share": 0.0904,
    "first": "2025-03-12",
    "last": "2025-04-13",
    "kind": "route",
    "castWith": [
     "raz",
     "peter",
     "evan",
     "may"
    ]
   },
   {
    "channel": "raz-knows",
    "passages": 45,
    "share": 0.0616,
    "first": "2024-01-10",
    "last": "2024-01-16",
    "kind": "route",
    "castWith": [
     "raz",
     "peter",
     "may",
     "will"
    ]
   },
   {
    "channel": "kierans-lives",
    "passages": 33,
    "share": 0.0452,
    "first": "2024-01-17",
    "last": "2024-01-22",
    "kind": "route",
    "castWith": [
     "peter",
     "frederick",
     "may"
    ]
   },
   {
    "channel": "raz-and-kieran",
    "passages": 32,
    "share": 0.0438,
    "first": "2023-09-23",
    "last": "2023-09-25",
    "kind": "route",
    "castWith": [
     "raz",
     "peter",
     "ever"
    ]
   },
   {
    "channel": "peter",
    "passages": 25,
    "share": 0.0342,
    "first": "2023-09-25",
    "last": "2023-09-28",
    "kind": "route",
    "castWith": [
     "peter",
     "raz",
     "george_campbell",
     "paul"
    ]
   },
   {
    "channel": "apollo-loving",
    "passages": 23,
    "share": 0.0315,
    "first": "2024-02-16",
    "last": "2024-02-20",
    "kind": "route",
    "castWith": [
     "apollo",
     "raz",
     "aphrodite",
     "cupid_eros"
    ]
   },
   {
    "channel": "cupid-and-kieran-sitting-in-a-tree",
    "passages": 21,
    "share": 0.0288,
    "first": "2026-01-20",
    "last": "2026-02-03",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "peter",
     "roman",
     "aphrodite",
     "apollo",
     "hera",
     "may"
    ]
   }
  ],
  "knownCharacters": [
   "raz",
   "peter",
   "will",
   "james"
  ]
 },
 "atropos": {
  "canonRoute": "moros-commits",
  "totalPassages": 413,
  "routes": [
   {
    "channel": "moros-commits",
    "passages": 56,
    "share": 0.1356,
    "first": "2021-10-06",
    "last": "2021-10-25",
    "kind": "canon",
    "castWith": [
     "apollo",
     "moros",
     "lachesis",
     "aphrodite",
     "clothos",
     "will",
     "cupid_eros",
     "hera",
     "may",
     "zeus"
    ]
   },
   {
    "channel": "atropos-in-hell",
    "passages": 56,
    "share": 0.1356,
    "first": "2021-05-24",
    "last": "2021-06-10",
    "kind": "route",
    "castWith": [
     "lucifer",
     "moros",
     "lachesis",
     "haley_wolf",
     "god",
     "clothos",
     "gabriel",
     "lance",
     "hades",
     "mary_cataldi",
     "haley_human",
     "cupid_eros"
    ]
   },
   {
    "channel": "switched-roles-lachesis",
    "passages": 43,
    "share": 0.1041,
    "first": "2023-10-09",
    "last": "2023-11-19",
    "kind": "au",
    "castWith": [
     "lachesis",
     "ford",
     "god",
     "lucifer",
     "cruz",
     "clothos",
     "rowan",
     "vaughn",
     "ryder",
     "brax",
     "dimitri",
     "ramiel"
    ]
   },
   {
    "channel": "haley-finds-out-shes-cool-2",
    "passages": 24,
    "share": 0.0581,
    "first": "2022-12-01",
    "last": "2022-12-09",
    "kind": "route",
    "castWith": [
     "moros",
     "gracie",
     "haley_human",
     "jinko",
     "lance",
     "may",
     "lachesis",
     "athena",
     "clothos",
     "haley_wolf",
     "peter",
     "apollo"
    ]
   },
   {
    "channel": "wtf-happened",
    "passages": 20,
    "share": 0.0484,
    "first": "2023-08-08",
    "last": "2023-09-01",
    "kind": "route",
    "castWith": [
     "apollo",
     "cupid_eros",
     "moros",
     "alistair",
     "alistair_turayne",
     "haley_wolf",
     "haley_human",
     "lachesis",
     "aphrodite",
     "zeus",
     "ezra",
     "god"
    ]
   },
   {
    "channel": "lachesis-off-the-rails",
    "passages": 19,
    "share": 0.046,
    "first": "2025-09-01",
    "last": "2025-09-25",
    "kind": "route",
    "castWith": [
     "lance",
     "vaughn",
     "brax",
     "lucifer",
     "james",
     "cruz",
     "lachesis",
     "ace",
     "lindon",
     "hades",
     "ezra",
     "nicole_human"
    ]
   },
   {
    "channel": "lance-mating",
    "passages": 18,
    "share": 0.0436,
    "first": "2021-08-24",
    "last": "2021-09-21",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "clothos",
     "ryder",
     "hades",
     "nolan",
     "nicole_human",
     "audrey",
     "moros",
     "nicole_wolf",
     "nicole_sg3"
    ]
   },
   {
    "channel": "atropos-reincarnated",
    "passages": 18,
    "share": 0.0436,
    "first": "2022-06-12",
    "last": "2022-06-28",
    "kind": "route",
    "castWith": [
     "moros",
     "apollo",
     "haley_wolf",
     "zeus",
     "zephyr",
     "dante",
     "lachesis",
     "clothos",
     "aphrodite",
     "hera",
     "haley_human",
     "nicole_human"
    ]
   },
   {
    "channel": "plz-love-lachesis",
    "passages": 16,
    "share": 0.0387,
    "first": "2022-11-12",
    "last": "2022-11-23",
    "kind": "route",
    "castWith": [
     "lachesis",
     "ramiel",
     "lance",
     "god",
     "lucifer",
     "apollo",
     "levi",
     "aion",
     "zeus",
     "zadkiel",
     "clothos",
     "asrius"
    ]
   },
   {
    "channel": "cruz-nicole-dollar-store",
    "passages": 15,
    "share": 0.0363,
    "first": "2020-09-12",
    "last": "2020-09-21",
    "kind": "route",
    "castWith": [
     "cruz",
     "raz",
     "lance",
     "lachesis",
     "bryce",
     "nolan",
     "renee",
     "aphrodite",
     "clothos",
     "nicole_wolf",
     "nicole_sg3",
     "moros"
    ]
   },
   {
    "channel": "atropos-goes-to-second-hell",
    "passages": 14,
    "share": 0.0339,
    "first": "2022-07-02",
    "last": "2022-07-08",
    "kind": "route",
    "castWith": [
     "dante",
     "moros",
     "lachesis",
     "ares",
     "clothos",
     "may",
     "aphrodite",
     "apollo",
     "hermes",
     "god"
    ]
   },
   {
    "channel": "human-lachesis",
    "passages": 14,
    "share": 0.0339,
    "first": "2024-09-13",
    "last": "2024-10-01",
    "kind": "route",
    "castWith": [
     "nicole_human",
     "brax",
     "lachesis",
     "lance",
     "vaughn",
     "rowan",
     "god",
     "alyce_char",
     "moros",
     "ford",
     "cruz",
     "nicole_wolf"
    ]
   }
  ],
  "knownCharacters": [
   "apollo",
   "moros",
   "lachesis",
   "aphrodite",
   "clothos",
   "will",
   "cupid_eros",
   "hera",
   "may",
   "zeus"
  ]
 },
 "layla": {
  "canonRoute": "elders-layla",
  "totalPassages": 25,
  "routes": [
   {
    "channel": "elders-layla",
    "passages": 20,
    "share": 0.8,
    "first": "2020-09-08",
    "last": "2020-09-10",
    "kind": "canon",
    "castWith": [
     "vanessa",
     "val",
     "tim",
     "james",
     "junta",
     "sebastian_vamp",
     "sebastian_siren",
     "apollo",
     "theo_uoki",
     "will"
    ]
   },
   {
    "channel": "kya-senior-year",
    "passages": 2,
    "share": 0.08,
    "first": "2021-07-08",
    "last": "2021-07-08",
    "kind": "route",
    "castWith": [
     "callan",
     "ezra",
     "leiden",
     "melody",
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "raye",
     "tate",
     "sebastian_vamp",
     "dillon",
     "sebastian_siren"
    ]
   },
   {
    "channel": "an-accidentally-valerian-summer-with-cordelia",
    "passages": 2,
    "share": 0.08,
    "first": "2021-05-09",
    "last": "2021-05-09",
    "kind": "route",
    "castWith": [
     "ciel",
     "nolan",
     "lupe",
     "arsene",
     "delia",
     "dale",
     "jessica",
     "cruz",
     "clairette",
     "may",
     "tina",
     "cyrena"
    ]
   },
   {
    "channel": "ooc",
    "passages": 1,
    "share": 0.04,
    "first": "2020-11-22",
    "last": "2020-11-22",
    "kind": "route",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   }
  ],
  "knownCharacters": [
   "vanessa",
   "val",
   "tim",
   "james",
   "junta",
   "sebastian_vamp",
   "sebastian_siren",
   "apollo",
   "theo_uoki",
   "will"
  ]
 },
 "claire": {
  "canonRoute": "new-fairy-route",
  "totalPassages": 11,
  "routes": [
   {
    "channel": "new-fairy-route",
    "passages": 11,
    "share": 1.0,
    "first": "2023-02-28",
    "last": "2023-03-02",
    "kind": "canon",
    "castWith": [
     "holt",
     "archie",
     "sabrina_witch",
     "kieran",
     "dutch",
     "cair",
     "atropos",
     "ever",
     "may"
    ]
   }
  ],
  "knownCharacters": [
   "holt",
   "archie",
   "sabrina_witch",
   "kieran",
   "dutch",
   "cair",
   "atropos",
   "ever",
   "may"
  ]
 },
 "kira": {
  "canonRoute": "the-great-husbando-race",
  "totalPassages": 5,
  "routes": [
   {
    "channel": "the-great-husbando-race",
    "passages": 4,
    "share": 0.8,
    "first": "2020-05-26",
    "last": "2020-05-26",
    "kind": "canon",
    "castWith": [
     "ray",
     "leon",
     "cupid_eros",
     "loki",
     "riku",
     "victor",
     "evelyn",
     "junta",
     "ben",
     "hyun_ryu",
     "jack",
     "kent"
    ]
   },
   {
    "channel": "AU: Ford Steele \u2014 Branched at msg 89/600 (5/1/2026) (branched at msg 638)",
    "passages": 1,
    "share": 0.2,
    "first": "2026-05-03",
    "last": "2026-05-03",
    "kind": "au",
    "castWith": [
     "ford",
     "cruz",
     "ryder",
     "nicole_human",
     "audrey",
     "nolan",
     "may",
     "haley_human",
     "diana",
     "porscha_steele",
     "evelyn",
     "dimitri"
    ]
   }
  ],
  "knownCharacters": [
   "ray",
   "leon",
   "cupid_eros",
   "loki",
   "riku",
   "victor",
   "evelyn",
   "junta",
   "ben",
   "hyun_ryu",
   "jack",
   "kent"
  ]
 },
 "evelyn": {
  "canonRoute": "1-real-cruz",
  "totalPassages": 8107,
  "routes": [
   {
    "channel": "1-real-cruz",
    "passages": 405,
    "share": 0.05,
    "first": "2022-10-03",
    "last": "2023-01-29",
    "kind": "canon",
    "castWith": [
     "cruz",
     "bryce",
     "ares",
     "lance",
     "selma",
     "zeus",
     "lindon",
     "hera",
     "ryder",
     "apollo",
     "nolan",
     "diana"
    ]
   },
   {
    "channel": "frau-collin",
    "passages": 382,
    "share": 0.0471,
    "first": "2020-04-15",
    "last": "2020-12-27",
    "kind": "route",
    "castWith": [
     "cruz",
     "rowan",
     "frau",
     "collin_keller",
     "arland_rees",
     "ezra",
     "felix_fairy",
     "rikki",
     "park",
     "alyce_char",
     "myra",
     "allie"
    ]
   },
   {
    "channel": "evelyn-college-2",
    "passages": 332,
    "share": 0.041,
    "first": "2020-12-27",
    "last": "2021-01-29",
    "kind": "canon",
    "castWith": [
     "darren",
     "dimitri",
     "lex",
     "hades",
     "raye",
     "jon",
     "ares",
     "kaleb",
     "cruz",
     "kya_sg3",
     "ari",
     "aibell"
    ]
   },
   {
    "channel": "lets-abduct-evie",
    "passages": 319,
    "share": 0.0393,
    "first": "2021-06-14",
    "last": "2021-07-29",
    "kind": "canon",
    "castWith": [
     "dimitri",
     "ryoto",
     "dodge",
     "ms_tia",
     "kaleb",
     "frau",
     "aki",
     "cruz",
     "talbot",
     "ares",
     "zeus",
     "hera"
    ]
   },
   {
    "channel": "cruz-is-not-dead",
    "passages": 282,
    "share": 0.0348,
    "first": "2022-04-06",
    "last": "2022-05-18",
    "kind": "canon",
    "castWith": [
     "cruz",
     "ford",
     "ryder",
     "lucifer",
     "bryce",
     "audrey",
     "apollo",
     "ares",
     "god",
     "clint",
     "hades",
     "nolan"
    ]
   },
   {
    "channel": "dimitri-castle",
    "passages": 272,
    "share": 0.0336,
    "first": "2020-06-30",
    "last": "2020-07-25",
    "kind": "route",
    "castWith": [
     "dimitri",
     "stella",
     "ronin_tempus",
     "kaleb",
     "melisende",
     "mr_han_sr",
     "gambit",
     "frau",
     "silas_mirace",
     "theo_uoki",
     "toko",
     "raye"
    ]
   },
   {
    "channel": "human-evie",
    "passages": 255,
    "share": 0.0315,
    "first": "2020-09-22",
    "last": "2021-02-27",
    "kind": "route",
    "castWith": [
     "kaleb",
     "frau",
     "cruz",
     "mr_han_sr",
     "audrey",
     "richard_antore",
     "diana",
     "ares",
     "quincy_antore",
     "nereda",
     "elizabeth_the_third",
     "ever"
    ]
   },
   {
    "channel": "northwest-pack-lodge",
    "passages": 238,
    "share": 0.0294,
    "first": "2020-04-14",
    "last": "2020-04-29",
    "kind": "route",
    "castWith": [
     "rowan",
     "lucius",
     "nellie",
     "myra",
     "cruz",
     "bryce",
     "will",
     "dimitri",
     "kaleb",
     "rio",
     "may",
     "mr_han_sr"
    ]
   },
   {
    "channel": "ww-war-au",
    "passages": 209,
    "share": 0.0258,
    "first": "2021-11-18",
    "last": "2021-12-16",
    "kind": "au",
    "castWith": [
     "cruz",
     "ace",
     "ezra",
     "lindon",
     "kaleb",
     "rowan",
     "bryce",
     "lance",
     "raye",
     "nolan",
     "primrose",
     "ryder"
    ]
   },
   {
    "channel": "hot-boi-arena-cruz",
    "passages": 205,
    "share": 0.0253,
    "first": "2022-05-18",
    "last": "2022-06-11",
    "kind": "route",
    "castWith": [
     "cruz",
     "frau",
     "lyden",
     "crom",
     "ezra",
     "junta",
     "alyce_char",
     "ryder",
     "may",
     "rowan",
     "ares",
     "hades"
    ]
   },
   {
    "channel": "brothel",
    "passages": 194,
    "share": 0.0239,
    "first": "2020-04-18",
    "last": "2020-04-27",
    "kind": "route",
    "castWith": [
     "ezra",
     "rowan",
     "kya_sg3",
     "kya_sg1",
     "primrose",
     "lily",
     "kaleb",
     "nellie",
     "lissa",
     "raye",
     "ace",
     "mr_han_sr"
    ]
   },
   {
    "channel": "dimitri-route-end",
    "passages": 181,
    "share": 0.0223,
    "first": "2021-01-29",
    "last": "2021-02-16",
    "kind": "route",
    "castWith": [
     "dimitri",
     "uri",
     "gambit",
     "jones",
     "ares",
     "bryce",
     "kaleb",
     "frau",
     "mr_han_sr",
     "zeus",
     "kya_sg3",
     "uncle_khan"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "bryce",
   "dimitri",
   "darren",
   "ryoto",
   "ares",
   "ford",
   "lex",
   "hades",
   "ryder",
   "raye",
   "jon",
   "dodge",
   "kaleb",
   "lucifer",
   "zeus",
   "lance",
   "hera",
   "selma",
   "ms_tia",
   "lindon",
   "apollo",
   "nolan",
   "kya_sg3",
   "ari",
   "audrey",
   "frau",
   "aibell",
   "diana",
   "aki",
   "talbot",
   "god",
   "clint"
  ],
  "canonRoutes": [
   "1-real-cruz",
   "evelyn-college-2",
   "lets-abduct-evie",
   "cruz-is-not-dead"
  ]
 },
 "lachesis": {
  "canonRoute": "haggle-for-the-girl",
  "totalPassages": 1991,
  "routes": [
   {
    "channel": "switched-roles-lachesis",
    "passages": 434,
    "share": 0.218,
    "first": "2023-10-09",
    "last": "2023-11-26",
    "kind": "au",
    "castWith": [
     "ford",
     "god",
     "lucifer",
     "cruz",
     "clothos",
     "atropos",
     "rowan",
     "vaughn",
     "ryder",
     "brax",
     "dimitri",
     "ramiel"
    ]
   },
   {
    "channel": "haggle-for-the-girl",
    "passages": 333,
    "share": 0.1673,
    "first": "2023-12-12",
    "last": "2024-01-22",
    "kind": "canon",
    "castWith": [
     "lucifer",
     "asrius",
     "god",
     "lonnie",
     "ramiel",
     "gabriel",
     "lance",
     "hades",
     "alyk",
     "aphrodite",
     "atropos",
     "zeus"
    ]
   },
   {
    "channel": "fordsplosion",
    "passages": 259,
    "share": 0.1301,
    "first": "2024-02-09",
    "last": "2024-03-19",
    "kind": "route",
    "castWith": [
     "ford",
     "lucifer",
     "cruz",
     "clothos",
     "ryder",
     "god",
     "asrius",
     "ethan",
     "eva",
     "atropos",
     "may",
     "evelyn"
    ]
   },
   {
    "channel": "chance-route-ft-lance",
    "passages": 177,
    "share": 0.0889,
    "first": "2021-09-25",
    "last": "2021-10-27",
    "kind": "route",
    "castWith": [
     "chance",
     "lance",
     "god",
     "aphrodite",
     "atropos",
     "clothos",
     "zeus",
     "moros",
     "ares",
     "hades",
     "may",
     "will"
    ]
   },
   {
    "channel": "plz-love-lachesis",
    "passages": 174,
    "share": 0.0874,
    "first": "2022-11-11",
    "last": "2022-11-26",
    "kind": "route",
    "castWith": [
     "ramiel",
     "lance",
     "god",
     "lucifer",
     "apollo",
     "levi",
     "aion",
     "atropos",
     "zeus",
     "zadkiel",
     "clothos",
     "asrius"
    ]
   },
   {
    "channel": "lance-mating",
    "passages": 110,
    "share": 0.0552,
    "first": "2021-08-18",
    "last": "2021-09-25",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "clothos",
     "ryder",
     "hades",
     "nolan",
     "nicole_human",
     "audrey",
     "moros",
     "atropos",
     "nicole_wolf",
     "nicole_sg3"
    ]
   },
   {
    "channel": "human-lachesis",
    "passages": 86,
    "share": 0.0432,
    "first": "2024-09-12",
    "last": "2024-11-20",
    "kind": "route",
    "castWith": [
     "nicole_human",
     "brax",
     "lance",
     "vaughn",
     "rowan",
     "god",
     "alyce_char",
     "moros",
     "ford",
     "atropos",
     "cruz",
     "nicole_wolf"
    ]
   },
   {
    "channel": "oops-its-heaven",
    "passages": 78,
    "share": 0.0392,
    "first": "2022-08-09",
    "last": "2022-09-10",
    "kind": "route",
    "castWith": [
     "lance",
     "god",
     "ramiel",
     "aldo",
     "lucifer",
     "atropos",
     "mary_cataldi",
     "hades",
     "clothos",
     "zeus"
    ]
   },
   {
    "channel": "lance-origin-route",
    "passages": 60,
    "share": 0.0301,
    "first": "2021-05-19",
    "last": "2021-05-27",
    "kind": "route",
    "castWith": [
     "lance",
     "clothos",
     "nicole_human",
     "ryder",
     "moros",
     "atropos",
     "god",
     "nicole_wolf",
     "nicole_sg3",
     "hades",
     "haley_human",
     "cruz"
    ]
   },
   {
    "channel": "cruz-nicole-dollar-store",
    "passages": 54,
    "share": 0.0271,
    "first": "2020-09-15",
    "last": "2020-09-21",
    "kind": "route",
    "castWith": [
     "cruz",
     "raz",
     "lance",
     "bryce",
     "nolan",
     "renee",
     "aphrodite",
     "clothos",
     "atropos",
     "nicole_wolf",
     "nicole_sg3",
     "moros"
    ]
   },
   {
    "channel": "atropos-in-hell",
    "passages": 27,
    "share": 0.0136,
    "first": "2021-05-24",
    "last": "2021-06-02",
    "kind": "route",
    "castWith": [
     "lucifer",
     "atropos",
     "moros",
     "haley_wolf",
     "god",
     "clothos",
     "gabriel",
     "lance",
     "hades",
     "mary_cataldi",
     "haley_human",
     "cupid_eros"
    ]
   },
   {
    "channel": "lachesis-reincarnated",
    "passages": 22,
    "share": 0.011,
    "first": "2022-06-11",
    "last": "2022-07-06",
    "kind": "route",
    "castWith": [
     "lance",
     "alyk",
     "haley_wolf",
     "clothos",
     "demeter",
     "moros",
     "haley_human",
     "nicole_human",
     "atropos",
     "cruz",
     "apollo",
     "arthur_turayne"
    ]
   }
  ],
  "knownCharacters": [
   "lucifer",
   "asrius",
   "god",
   "lonnie",
   "ramiel",
   "gabriel",
   "lance",
   "hades",
   "alyk",
   "aphrodite",
   "atropos",
   "zeus"
  ]
 },
 "cruz": {
  "canonRoute": "1-real-cruz",
  "totalPassages": 6118,
  "routes": [
   {
    "channel": "1-real-cruz",
    "passages": 404,
    "share": 0.066,
    "first": "2022-10-03",
    "last": "2024-04-29",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "bryce",
     "ares",
     "lance",
     "selma",
     "zeus",
     "lindon",
     "hera",
     "ryder",
     "apollo",
     "nolan",
     "diana"
    ]
   },
   {
    "channel": "frau-collin",
    "passages": 281,
    "share": 0.0459,
    "first": "2020-04-15",
    "last": "2020-12-24",
    "kind": "route",
    "castWith": [
     "evelyn",
     "rowan",
     "frau",
     "collin_keller",
     "arland_rees",
     "ezra",
     "felix_fairy",
     "rikki",
     "park",
     "alyce_char",
     "myra",
     "allie"
    ]
   },
   {
    "channel": "Nicole - 7/21/2026",
    "passages": 259,
    "share": 0.0423,
    "first": "2026-07-21",
    "last": "2026-08-01",
    "kind": "route",
    "castWith": [
     "ford",
     "audrey",
     "trix",
     "ryder",
     "nicole_human",
     "nicole_wolf",
     "nicole_sg3",
     "nolan",
     "ace",
     "jack",
     "lira",
     "mr_han_sr"
    ]
   },
   {
    "channel": "cruz-x-nicole",
    "passages": 255,
    "share": 0.0417,
    "first": "2020-08-02",
    "last": "2020-08-22",
    "kind": "route",
    "castWith": [
     "lance",
     "hermes",
     "audrey",
     "peter",
     "ares",
     "nicole_wolf",
     "nicole_sg3",
     "alyce_char",
     "red",
     "trix",
     "nicole_human",
     "moros"
    ]
   },
   {
    "channel": "cruz-is-not-dead",
    "passages": 249,
    "share": 0.0407,
    "first": "2022-04-06",
    "last": "2022-05-17",
    "kind": "route",
    "castWith": [
     "evelyn",
     "ford",
     "ryder",
     "lucifer",
     "bryce",
     "audrey",
     "apollo",
     "ares",
     "god",
     "clint",
     "hades",
     "nolan"
    ]
   },
   {
    "channel": "hot-boi-arena-cruz",
    "passages": 208,
    "share": 0.034,
    "first": "2022-05-18",
    "last": "2022-06-11",
    "kind": "route",
    "castWith": [
     "evelyn",
     "frau",
     "lyden",
     "crom",
     "ezra",
     "junta",
     "alyce_char",
     "ryder",
     "may",
     "rowan",
     "ares",
     "hades"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 203,
    "share": 0.0332,
    "first": "2024-01-23",
    "last": "2025-02-25",
    "kind": "route",
    "castWith": [
     "brax",
     "ryder",
     "ford",
     "vaughn",
     "lance",
     "bryce",
     "shane",
     "dimitri",
     "allie",
     "micah",
     "audrey",
     "moros"
    ]
   },
   {
    "channel": "cruz-x-human",
    "passages": 202,
    "share": 0.033,
    "first": "2021-03-31",
    "last": "2021-05-19",
    "kind": "route",
    "castWith": [
     "skye",
     "nolan",
     "ryder",
     "audrey",
     "troy",
     "adrien",
     "bryce",
     "airi",
     "natasha",
     "diana",
     "will",
     "allie"
    ]
   },
   {
    "channel": "a-tricky-micah-cruz-route",
    "passages": 190,
    "share": 0.0311,
    "first": "2023-08-10",
    "last": "2023-09-23",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "ryder",
     "micah",
     "trix",
     "allie",
     "evelyn",
     "roger",
     "audrey",
     "god",
     "bryce",
     "diana"
    ]
   },
   {
    "channel": "cruz-nicole-dollar-store",
    "passages": 180,
    "share": 0.0294,
    "first": "2020-09-08",
    "last": "2020-09-17",
    "kind": "route",
    "castWith": [
     "raz",
     "lance",
     "lachesis",
     "bryce",
     "nolan",
     "renee",
     "aphrodite",
     "clothos",
     "atropos",
     "nicole_wolf",
     "nicole_sg3",
     "moros"
    ]
   },
   {
    "channel": "rogue-wolf-hot-cruz",
    "passages": 178,
    "share": 0.0291,
    "first": "2021-02-27",
    "last": "2021-03-31",
    "kind": "route",
    "castWith": [
     "hunter",
     "ryder",
     "trix",
     "audrey",
     "lance",
     "alyce_char",
     "bryce",
     "nolan",
     "diana",
     "will",
     "ever",
     "aphrodite"
    ]
   },
   {
    "channel": "lance-mating",
    "passages": 175,
    "share": 0.0286,
    "first": "2021-08-24",
    "last": "2021-09-25",
    "kind": "route",
    "castWith": [
     "lance",
     "lachesis",
     "clothos",
     "ryder",
     "hades",
     "nolan",
     "nicole_human",
     "audrey",
     "moros",
     "atropos",
     "nicole_wolf",
     "nicole_sg3"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "bryce",
   "ares",
   "lance",
   "selma",
   "zeus",
   "lindon",
   "hera",
   "ryder",
   "apollo",
   "nolan",
   "diana"
  ]
 },
 "alistair": {
  "canonRoute": "val",
  "totalPassages": 543,
  "routes": [
   {
    "channel": "val",
    "passages": 112,
    "share": 0.2063,
    "first": "2020-04-15",
    "last": "2020-12-19",
    "kind": "canon",
    "castWith": [
     "val",
     "kya_sg3",
     "kaleb",
     "alistair_turayne",
     "kya_sg1",
     "evelyn",
     "vanessa",
     "ezra",
     "raye",
     "alan",
     "tyrion",
     "mr_han_sr"
    ]
   },
   {
    "channel": "alistair-x-human-kya",
    "passages": 59,
    "share": 0.1087,
    "first": "2020-08-03",
    "last": "2020-08-13",
    "kind": "route",
    "castWith": [
     "haley_human",
     "alistair_turayne",
     "apollo",
     "nicole_human",
     "ezra",
     "raye",
     "james",
     "atropos",
     "hades",
     "beatrice",
     "cruz",
     "haley_wolf"
    ]
   },
   {
    "channel": "alistair-reboot2",
    "passages": 41,
    "share": 0.0755,
    "first": "2022-04-13",
    "last": "2022-05-04",
    "kind": "au",
    "castWith": [
     "alistair_turayne",
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "sebastian_vamp",
     "evelyn",
     "sebastian_siren",
     "dillon",
     "ezra",
     "kyo",
     "uncle_khan",
     "skipper"
    ]
   },
   {
    "channel": "meeting-room",
    "passages": 34,
    "share": 0.0626,
    "first": "2020-03-26",
    "last": "2020-07-31",
    "kind": "route",
    "castWith": [
     "kaleb",
     "ezra",
     "kya_sg3",
     "raye",
     "evelyn",
     "alistair_turayne",
     "mr_han_sr",
     "kya_sg1",
     "thorne",
     "prince_zain",
     "sune",
     "yuri_rekovich"
    ]
   },
   {
    "channel": "kyas_penthouse",
    "passages": 33,
    "share": 0.0608,
    "first": "2020-03-26",
    "last": "2020-03-29",
    "kind": "route",
    "castWith": [
     "kaleb",
     "evelyn",
     "raye",
     "ezra",
     "kya_sg3",
     "alistair_turayne",
     "kya_sg1",
     "mr_han_sr",
     "bryce",
     "god",
     "cruz",
     "will"
    ]
   },
   {
    "channel": "haley-nolan",
    "passages": 31,
    "share": 0.0571,
    "first": "2020-09-13",
    "last": "2020-09-17",
    "kind": "route",
    "castWith": [
     "nolan",
     "charlie",
     "alistair_turayne",
     "caroline",
     "alyce_char",
     "ryder",
     "cruz",
     "moros",
     "lachesis",
     "renee",
     "clothos",
     "audrey"
    ]
   },
   {
    "channel": "reincarnation-with-alistair",
    "passages": 26,
    "share": 0.0479,
    "first": "2025-02-03",
    "last": "2025-02-07",
    "kind": "route",
    "castWith": [
     "james",
     "dillon",
     "alistair_turayne",
     "kya_sg3",
     "sebastian_vamp",
     "kya_sg1",
     "evelyn",
     "val",
     "haley_human",
     "sebastian_siren",
     "athena",
     "junta"
    ]
   },
   {
    "channel": "alistair-tailbond",
    "passages": 24,
    "share": 0.0442,
    "first": "2024-04-24",
    "last": "2024-05-10",
    "kind": "route",
    "castWith": [
     "kaleb",
     "kya_sg3",
     "alistair_turayne",
     "ezra",
     "dillon",
     "kya_sg1",
     "sebastian_vamp",
     "raye",
     "uncle_khan",
     "evelyn",
     "sebastian_siren",
     "poseidon"
    ]
   },
   {
    "channel": "1920s-boardwalk",
    "passages": 23,
    "share": 0.0424,
    "first": "2022-05-20",
    "last": "2022-05-27",
    "kind": "route",
    "castWith": [
     "val",
     "ezra",
     "kya_sg3",
     "james",
     "alistair_turayne",
     "kya_sg1",
     "vanessa",
     "sebastian_vamp",
     "sebastian_siren",
     "amelda",
     "junta",
     "dillon"
    ]
   },
   {
    "channel": "haleys-alistair-wish",
    "passages": 18,
    "share": 0.0331,
    "first": "2023-04-27",
    "last": "2023-05-10",
    "kind": "route",
    "castWith": [
     "ezra",
     "evelyn",
     "alistair_turayne",
     "raye",
     "kaleb",
     "james",
     "dimitri",
     "haley_wolf",
     "haley_sg3",
     "uncle_khan",
     "haley_human",
     "bryce"
    ]
   },
   {
    "channel": "cafe",
    "passages": 13,
    "share": 0.0239,
    "first": "2020-04-14",
    "last": "2020-04-14",
    "kind": "route",
    "castWith": [
     "alistair_turayne",
     "evelyn",
     "kya_sg3",
     "kya_sg1",
     "mr_han_sr",
     "ray"
    ]
   },
   {
    "channel": "cell-block-tango",
    "passages": 13,
    "share": 0.0239,
    "first": "2020-03-30",
    "last": "2020-03-30",
    "kind": "route",
    "castWith": [
     "ezra",
     "kya_sg3",
     "alistair_turayne",
     "evelyn",
     "bryce",
     "thorne",
     "kya_sg1",
     "kaleb",
     "cruz",
     "rika",
     "thor",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "val",
   "kya_sg3",
   "kaleb",
   "alistair_turayne",
   "kya_sg1",
   "evelyn",
   "vanessa",
   "ezra",
   "raye",
   "alan",
   "tyrion",
   "mr_han_sr"
  ]
 },
 "sebastian_vamp": {
  "canonRoute": "siren-places",
  "totalPassages": 732,
  "routes": [
   {
    "channel": "siren-places",
    "passages": 244,
    "share": 0.3333,
    "first": "2020-06-30",
    "last": "2020-07-23",
    "kind": "canon",
    "castWith": [
     "sebastian_siren",
     "kya_sg1",
     "kya_sg3",
     "polly",
     "kaleb",
     "evelyn",
     "ever",
     "midori_naga",
     "skipper",
     "kyo"
    ]
   },
   {
    "channel": "super-siren-cruise-ship",
    "passages": 30,
    "share": 0.041,
    "first": "2023-07-24",
    "last": "2023-08-03",
    "kind": "route",
    "castWith": [
     "kya_sg1",
     "kya_sg3",
     "sebastian_siren",
     "evelyn",
     "kaleb",
     "dillon",
     "ezra",
     "raye",
     "uncle_khan",
     "alistair",
     "alistair_turayne",
     "aaron"
    ]
   },
   {
    "channel": "siren-raye",
    "passages": 30,
    "share": 0.041,
    "first": "2023-10-16",
    "last": "2023-10-25",
    "kind": "route",
    "castWith": [
     "raye",
     "kya_sg1",
     "kya_sg3",
     "sebastian_siren",
     "apollo",
     "aphrodite",
     "kaleb",
     "cupid_eros",
     "hermes",
     "ezra",
     "ares",
     "may"
    ]
   },
   {
    "channel": "kya-college-2",
    "passages": 29,
    "share": 0.0396,
    "first": "2021-01-10",
    "last": "2021-01-28",
    "kind": "route",
    "castWith": [
     "lily",
     "zander",
     "kya_sg3",
     "kya_sg1",
     "ari",
     "sebastian_siren",
     "raye",
     "prince_zed",
     "midori_naga",
     "penelope_valk",
     "bell_lily_of_fell",
     "agnar"
    ]
   },
   {
    "channel": "almost-kya-x-sebastian",
    "passages": 29,
    "share": 0.0396,
    "first": "2020-10-23",
    "last": "2020-11-02",
    "kind": "route",
    "castWith": [
     "sebastian_siren",
     "polly",
     "kya_sg3",
     "kya_sg1",
     "evelyn",
     "ethan",
     "haley_human",
     "alistair",
     "ezra",
     "haley_wolf",
     "haley_sg3",
     "miya"
    ]
   },
   {
    "channel": "kya-senior-year",
    "passages": 23,
    "share": 0.0314,
    "first": "2021-06-14",
    "last": "2021-07-08",
    "kind": "route",
    "castWith": [
     "callan",
     "ezra",
     "leiden",
     "melody",
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "raye",
     "tate",
     "dillon",
     "sebastian_siren",
     "evelyn"
    ]
   },
   {
    "channel": "kya-war-au",
    "passages": 18,
    "share": 0.0246,
    "first": "2021-11-24",
    "last": "2021-12-02",
    "kind": "au",
    "castWith": [
     "ezra",
     "kya_sg3",
     "james",
     "val",
     "kya_sg1",
     "vanessa",
     "kaleb",
     "raye",
     "sebastian_siren",
     "lily",
     "junta",
     "evelyn"
    ]
   },
   {
    "channel": "aquarium",
    "passages": 18,
    "share": 0.0246,
    "first": "2020-04-14",
    "last": "2020-04-29",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "ezra",
     "kya_sg1",
     "polly",
     "skipper",
     "sebastian_siren",
     "lira",
     "kyo",
     "crom",
     "evelyn",
     "kaleb",
     "kris"
    ]
   },
   {
    "channel": "kaleb-kya-finally",
    "passages": 15,
    "share": 0.0205,
    "first": "2021-02-12",
    "last": "2021-02-17",
    "kind": "route",
    "castWith": [
     "kaleb",
     "kya_sg3",
     "kya_sg1",
     "evelyn",
     "sebastian_siren",
     "apollo",
     "gabs",
     "uncle_khan",
     "alexander",
     "dimitri",
     "kyo",
     "ami"
    ]
   },
   {
    "channel": "aquarium-seb",
    "passages": 15,
    "share": 0.0205,
    "first": "2025-01-17",
    "last": "2025-02-02",
    "kind": "route",
    "castWith": [
     "sebastian_siren",
     "skipper",
     "kya_sg3",
     "kya_sg1",
     "polly",
     "ezra",
     "dillon",
     "reed"
    ]
   },
   {
    "channel": "1920s-boardwalk",
    "passages": 13,
    "share": 0.0178,
    "first": "2022-05-22",
    "last": "2022-05-30",
    "kind": "route",
    "castWith": [
     "val",
     "ezra",
     "kya_sg3",
     "james",
     "alistair_turayne",
     "kya_sg1",
     "alistair",
     "vanessa",
     "sebastian_siren",
     "amelda",
     "junta",
     "dillon"
    ]
   },
   {
    "channel": "flirty-sebastian-immortuos",
    "passages": 13,
    "share": 0.0178,
    "first": "2021-12-16",
    "last": "2021-12-21",
    "kind": "route",
    "castWith": [
     "amelda",
     "kya_sg3",
     "sebastian_siren",
     "kya_sg1",
     "aurelia",
     "crom",
     "may",
     "val",
     "kaleb",
     "james",
     "dillon"
    ]
   }
  ],
  "knownCharacters": [
   "sebastian_siren",
   "kya_sg1",
   "kya_sg3",
   "polly",
   "kaleb",
   "evelyn",
   "ever",
   "midori_naga",
   "skipper",
   "kyo"
  ]
 },
 "bryce": {
  "canonRoute": "1-real-cruz",
  "totalPassages": 1792,
  "routes": [
   {
    "channel": "1-real-cruz",
    "passages": 400,
    "share": 0.2232,
    "first": "2022-10-04",
    "last": "2023-01-29",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "cruz",
     "ares",
     "lance",
     "selma",
     "zeus",
     "lindon",
     "hera",
     "ryder",
     "apollo",
     "nolan",
     "diana"
    ]
   },
   {
    "channel": "indifference",
    "passages": 140,
    "share": 0.0781,
    "first": "2023-03-27",
    "last": "2024-04-28",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "alyce_char",
     "dimitri",
     "ryder",
     "rio",
     "ace",
     "moros",
     "geo",
     "nolan",
     "audrey",
     "lachesis"
    ]
   },
   {
    "channel": "tyrant-evie",
    "passages": 138,
    "share": 0.077,
    "first": "2021-12-16",
    "last": "2022-01-09",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "myra",
     "ares",
     "hermes",
     "rio",
     "hades",
     "frau",
     "zeus",
     "nolan",
     "audrey",
     "apollo"
    ]
   },
   {
    "channel": "the-von-dabb-castle",
    "passages": 104,
    "share": 0.058,
    "first": "2020-04-01",
    "last": "2020-04-07",
    "kind": "route",
    "castWith": [
     "evelyn",
     "rio",
     "frau",
     "geo",
     "alexei",
     "mr_han_sr",
     "kaleb",
     "ezra",
     "bradshaw",
     "may",
     "kya_sg3",
     "will"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 86,
    "share": 0.048,
    "first": "2020-03-25",
    "last": "2020-07-23",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika",
     "nolan"
    ]
   },
   {
    "channel": "bryces-quarters",
    "passages": 76,
    "share": 0.0424,
    "first": "2020-04-01",
    "last": "2020-04-07",
    "kind": "route",
    "castWith": [
     "evelyn",
     "frau",
     "geo",
     "rio",
     "celine",
     "ezra",
     "raye",
     "god",
     "mr_han_sr"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 75,
    "share": 0.0419,
    "first": "2020-04-01",
    "last": "2023-10-25",
    "kind": "ooc",
    "castWith": [
     "stella",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz",
     "eric"
    ]
   },
   {
    "channel": "tyrant-evie-runs-away",
    "passages": 56,
    "share": 0.0312,
    "first": "2022-01-10",
    "last": "2022-01-28",
    "kind": "route",
    "castWith": [
     "evelyn",
     "aspen",
     "rio",
     "ace",
     "kaleb",
     "myra",
     "kya_sg3",
     "alistair",
     "alistair_turayne",
     "ezra",
     "rowan",
     "eva"
    ]
   },
   {
    "channel": "cruz-nicole-dollar-store",
    "passages": 49,
    "share": 0.0273,
    "first": "2020-09-10",
    "last": "2020-09-18",
    "kind": "route",
    "castWith": [
     "cruz",
     "raz",
     "lance",
     "lachesis",
     "nolan",
     "renee",
     "aphrodite",
     "clothos",
     "atropos",
     "nicole_wolf",
     "nicole_sg3",
     "moros"
    ]
   },
   {
    "channel": "ooc",
    "passages": 47,
    "share": 0.0262,
    "first": "2020-04-14",
    "last": "2020-12-21",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "darren",
     "lex",
     "rex",
     "agnar"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 45,
    "share": 0.0251,
    "first": "2024-01-26",
    "last": "2025-01-31",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "ryder",
     "ford",
     "vaughn",
     "lance",
     "shane",
     "dimitri",
     "allie",
     "micah",
     "audrey",
     "moros"
    ]
   },
   {
    "channel": "forest",
    "passages": 35,
    "share": 0.0195,
    "first": "2020-03-26",
    "last": "2020-03-27",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "luca",
     "nolan"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "cruz",
   "ares",
   "lance",
   "selma",
   "zeus",
   "lindon",
   "hera",
   "ryder",
   "apollo",
   "nolan",
   "diana"
  ]
 },
 "peter": {
  "canonRoute": "human-kieran",
  "totalPassages": 343,
  "routes": [
   {
    "channel": "human-kieran",
    "passages": 84,
    "share": 0.2449,
    "first": "2023-12-31",
    "last": "2024-01-09",
    "kind": "canon",
    "castWith": [
     "kieran",
     "raz",
     "evan",
     "mei",
     "gemma",
     "ms_tia",
     "will"
    ]
   },
   {
    "channel": "kierans-back",
    "passages": 44,
    "share": 0.1283,
    "first": "2025-03-12",
    "last": "2025-04-14",
    "kind": "route",
    "castWith": [
     "raz",
     "kieran",
     "evan",
     "may"
    ]
   },
   {
    "channel": "raz-knows",
    "passages": 42,
    "share": 0.1224,
    "first": "2024-01-10",
    "last": "2024-01-16",
    "kind": "route",
    "castWith": [
     "kieran",
     "raz",
     "may",
     "will"
    ]
   },
   {
    "channel": "peter",
    "passages": 38,
    "share": 0.1108,
    "first": "2023-09-25",
    "last": "2023-09-28",
    "kind": "route",
    "castWith": [
     "kieran",
     "raz",
     "george_campbell",
     "paul"
    ]
   },
   {
    "channel": "cruz-x-nicole",
    "passages": 36,
    "share": 0.105,
    "first": "2020-08-18",
    "last": "2020-08-21",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "hermes",
     "audrey",
     "ares",
     "nicole_wolf",
     "nicole_sg3",
     "alyce_char",
     "red",
     "trix",
     "nicole_human",
     "moros"
    ]
   },
   {
    "channel": "raz-the-assbro",
    "passages": 21,
    "share": 0.0612,
    "first": "2023-10-30",
    "last": "2023-11-11",
    "kind": "route",
    "castWith": [
     "kieran",
     "raz",
     "junta",
     "will"
    ]
   },
   {
    "channel": "kierans-lives",
    "passages": 15,
    "share": 0.0437,
    "first": "2024-01-16",
    "last": "2024-01-22",
    "kind": "route",
    "castWith": [
     "kieran",
     "frederick",
     "may"
    ]
   },
   {
    "channel": "kieran-ezra",
    "passages": 13,
    "share": 0.0379,
    "first": "2023-10-11",
    "last": "2023-10-12",
    "kind": "route",
    "castWith": [
     "kieran",
     "ezra",
     "raz",
     "lily",
     "primrose",
     "rosalie",
     "ace",
     "gemma"
    ]
   },
   {
    "channel": "junta-tim-soulmates",
    "passages": 13,
    "share": 0.0379,
    "first": "2023-09-22",
    "last": "2023-09-23",
    "kind": "route",
    "castWith": [
     "junta",
     "tim",
     "kieran",
     "raz",
     "kris",
     "dalton",
     "val",
     "vanessa",
     "ever",
     "aphrodite",
     "natasha",
     "will"
    ]
   },
   {
    "channel": "kieran-is-a-hoe-for-raz",
    "passages": 12,
    "share": 0.035,
    "first": "2026-02-04",
    "last": "2026-03-03",
    "kind": "route",
    "castWith": [
     "raz",
     "kieran",
     "will",
     "james"
    ]
   },
   {
    "channel": "raz-and-kieran",
    "passages": 11,
    "share": 0.0321,
    "first": "2023-09-25",
    "last": "2023-09-25",
    "kind": "route",
    "castWith": [
     "raz",
     "kieran",
     "ever"
    ]
   },
   {
    "channel": "cupid-and-kieran-sitting-in-a-tree",
    "passages": 9,
    "share": 0.0262,
    "first": "2026-01-20",
    "last": "2026-01-26",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "kieran",
     "roman",
     "aphrodite",
     "apollo",
     "hera",
     "may"
    ]
   }
  ],
  "knownCharacters": [
   "kieran",
   "raz",
   "evan",
   "mei",
   "gemma",
   "ms_tia",
   "will"
  ]
 },
 "nolan": {
  "canonRoute": "haley-nolan",
  "totalPassages": 589,
  "routes": [
   {
    "channel": "haley-nolan",
    "passages": 133,
    "share": 0.2258,
    "first": "2020-09-10",
    "last": "2020-09-15",
    "kind": "canon",
    "castWith": [
     "charlie",
     "alistair",
     "alistair_turayne",
     "caroline",
     "alyce_char",
     "ryder",
     "cruz",
     "moros",
     "lachesis",
     "renee",
     "clothos",
     "audrey"
    ]
   },
   {
    "channel": "an-accidentally-valerian-summer-with-cordelia",
    "passages": 83,
    "share": 0.1409,
    "first": "2021-03-01",
    "last": "2021-03-16",
    "kind": "route",
    "castWith": [
     "ciel",
     "lupe",
     "arsene",
     "delia",
     "dale",
     "jessica",
     "cruz",
     "clairette",
     "may",
     "tina",
     "cyrena",
     "will"
    ]
   },
   {
    "channel": "kyatropos",
    "passages": 54,
    "share": 0.0917,
    "first": "2023-04-05",
    "last": "2023-04-21",
    "kind": "route",
    "castWith": [
     "maxen_bryers",
     "kya_sg3",
     "audrey",
     "kya_sg1",
     "atropos",
     "cruz",
     "alyce_char",
     "evelyn",
     "moros",
     "diana",
     "may"
    ]
   },
   {
    "channel": "cruz-nicole-dollar-store",
    "passages": 38,
    "share": 0.0645,
    "first": "2020-09-08",
    "last": "2020-09-14",
    "kind": "route",
    "castWith": [
     "cruz",
     "raz",
     "lance",
     "lachesis",
     "bryce",
     "renee",
     "aphrodite",
     "clothos",
     "atropos",
     "nicole_wolf",
     "nicole_sg3",
     "moros"
    ]
   },
   {
    "channel": "cruz-x-human",
    "passages": 31,
    "share": 0.0526,
    "first": "2021-03-31",
    "last": "2021-05-17",
    "kind": "route",
    "castWith": [
     "cruz",
     "skye",
     "ryder",
     "audrey",
     "troy",
     "adrien",
     "bryce",
     "airi",
     "natasha",
     "diana",
     "will",
     "allie"
    ]
   },
   {
    "channel": "pack_house",
    "passages": 29,
    "share": 0.0492,
    "first": "2020-03-25",
    "last": "2020-03-31",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "bryce",
     "audrey",
     "allie",
     "alyce_char",
     "luca",
     "trix",
     "asmodeus",
     "ryder",
     "kaleb",
     "ezra"
    ]
   },
   {
    "channel": "lance-mating",
    "passages": 27,
    "share": 0.0458,
    "first": "2021-09-02",
    "last": "2021-09-25",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "clothos",
     "ryder",
     "hades",
     "nicole_human",
     "audrey",
     "moros",
     "atropos",
     "nicole_wolf",
     "nicole_sg3"
    ]
   },
   {
    "channel": "dimitri-ralidanti",
    "passages": 19,
    "share": 0.0323,
    "first": "2023-02-20",
    "last": "2023-03-01",
    "kind": "route",
    "castWith": [
     "ryder",
     "evelyn",
     "dimitri",
     "cruz",
     "bryce",
     "audrey",
     "trix",
     "lyden",
     "alyce_char",
     "kya_sg3",
     "diana",
     "frau"
    ]
   },
   {
    "channel": "1-real-cruz",
    "passages": 17,
    "share": 0.0289,
    "first": "2022-10-17",
    "last": "2023-01-27",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "ares",
     "lance",
     "selma",
     "zeus",
     "lindon",
     "hera",
     "ryder",
     "apollo",
     "diana"
    ]
   },
   {
    "channel": "ww-war-au",
    "passages": 14,
    "share": 0.0238,
    "first": "2021-12-03",
    "last": "2021-12-14",
    "kind": "au",
    "castWith": [
     "evelyn",
     "cruz",
     "ace",
     "ezra",
     "lindon",
     "kaleb",
     "rowan",
     "bryce",
     "lance",
     "raye",
     "primrose",
     "ryder"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 13,
    "share": 0.0221,
    "first": "2025-01-28",
    "last": "2025-02-09",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "ryder",
     "ford",
     "vaughn",
     "lance",
     "bryce",
     "shane",
     "dimitri",
     "allie",
     "micah",
     "audrey"
    ]
   },
   {
    "channel": "nicolexcruz-true-mates",
    "passages": 13,
    "share": 0.0221,
    "first": "2024-03-19",
    "last": "2024-03-21",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "clothos",
     "trix",
     "diana",
     "nicole_human",
     "audrey",
     "asrius",
     "lucifer",
     "atropos",
     "bryce"
    ]
   }
  ],
  "knownCharacters": [
   "charlie",
   "alistair",
   "alistair_turayne",
   "caroline",
   "alyce_char",
   "ryder",
   "cruz",
   "moros",
   "lachesis",
   "renee",
   "clothos",
   "audrey"
  ]
 },
 "dimitri": {
  "canonRoute": "dimitri-castle",
  "totalPassages": 1692,
  "routes": [
   {
    "channel": "dimitri-castle",
    "passages": 322,
    "share": 0.1903,
    "first": "2020-04-06",
    "last": "2020-07-24",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "stella",
     "ronin_tempus",
     "kaleb",
     "melisende",
     "mr_han_sr",
     "gambit",
     "frau",
     "silas_mirace",
     "theo_uoki",
     "toko",
     "raye"
    ]
   },
   {
    "channel": "lets-abduct-evie",
    "passages": 191,
    "share": 0.1129,
    "first": "2021-06-14",
    "last": "2021-07-29",
    "kind": "route",
    "castWith": [
     "evelyn",
     "ryoto",
     "dodge",
     "ms_tia",
     "kaleb",
     "frau",
     "aki",
     "cruz",
     "talbot",
     "ares",
     "zeus",
     "hera"
    ]
   },
   {
    "channel": "dimitri-route-end",
    "passages": 169,
    "share": 0.0999,
    "first": "2021-01-29",
    "last": "2021-02-16",
    "kind": "route",
    "castWith": [
     "evelyn",
     "uri",
     "gambit",
     "jones",
     "ares",
     "bryce",
     "kaleb",
     "frau",
     "mr_han_sr",
     "zeus",
     "kya_sg3",
     "uncle_khan"
    ]
   },
   {
    "channel": "evelyn-college-2",
    "passages": 107,
    "share": 0.0632,
    "first": "2021-01-22",
    "last": "2021-01-29",
    "kind": "route",
    "castWith": [
     "evelyn",
     "darren",
     "lex",
     "hades",
     "raye",
     "jon",
     "ares",
     "kaleb",
     "cruz",
     "kya_sg3",
     "ari",
     "aibell"
    ]
   },
   {
    "channel": "dimitri-ralidanti",
    "passages": 96,
    "share": 0.0567,
    "first": "2023-02-20",
    "last": "2023-03-26",
    "kind": "route",
    "castWith": [
     "ryder",
     "evelyn",
     "cruz",
     "nolan",
     "bryce",
     "audrey",
     "trix",
     "lyden",
     "alyce_char",
     "kya_sg3",
     "diana",
     "frau"
    ]
   },
   {
    "channel": "dimitri-saves-the-day",
    "passages": 86,
    "share": 0.0508,
    "first": "2022-03-20",
    "last": "2022-04-03",
    "kind": "route",
    "castWith": [
     "evelyn",
     "frau",
     "raz",
     "uncle_khan",
     "renee",
     "will"
    ]
   },
   {
    "channel": "ocroute2-cruz-in-for-love",
    "passages": 77,
    "share": 0.0455,
    "first": "2022-01-28",
    "last": "2022-02-17",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "hades",
     "zeus",
     "hera",
     "aphrodite",
     "god",
     "bryce",
     "amanda",
     "lachesis",
     "hermes",
     "nolan"
    ]
   },
   {
    "channel": "werewolf-dimitri",
    "passages": 72,
    "share": 0.0426,
    "first": "2021-10-27",
    "last": "2021-11-17",
    "kind": "route",
    "castWith": [
     "evelyn",
     "kaleb",
     "slater",
     "kya_sg3",
     "frau",
     "god",
     "lionel",
     "byron",
     "gambit",
     "uncle_khan",
     "kelli",
     "liera"
    ]
   },
   {
    "channel": "nicoles-wish-brax-brother",
    "passages": 53,
    "share": 0.0313,
    "first": "2023-05-01",
    "last": "2023-06-02",
    "kind": "route",
    "castWith": [
     "ford",
     "cruz",
     "brax",
     "lance",
     "hades",
     "vaughn",
     "rowan",
     "nicole_human",
     "audrey",
     "diana",
     "evelyn",
     "nicole_wolf"
    ]
   },
   {
    "channel": "ghouls-and-goals",
    "passages": 44,
    "share": 0.026,
    "first": "2022-09-10",
    "last": "2022-09-24",
    "kind": "route",
    "castWith": [
     "evelyn",
     "bryce",
     "lyden",
     "kaleb",
     "will"
    ]
   },
   {
    "channel": "indifference",
    "passages": 43,
    "share": 0.0254,
    "first": "2023-03-30",
    "last": "2024-04-27",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "alyce_char",
     "ryder",
     "rio",
     "ace",
     "moros",
     "geo",
     "nolan",
     "audrey",
     "lachesis"
    ]
   },
   {
    "channel": "row-dimitri",
    "passages": 41,
    "share": 0.0242,
    "first": "2022-12-15",
    "last": "2022-12-20",
    "kind": "route",
    "castWith": [
     "rowan",
     "evelyn",
     "myra",
     "kaleb",
     "ezra",
     "kya_sg3",
     "april"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "stella",
   "ronin_tempus",
   "kaleb",
   "melisende",
   "mr_han_sr",
   "gambit",
   "frau",
   "silas_mirace",
   "theo_uoki",
   "toko",
   "raye"
  ]
 },
 "lance": {
  "canonRoute": "lachesis-reincarnated",
  "totalPassages": 1974,
  "routes": [
   {
    "channel": "lachesis-reincarnated",
    "passages": 131,
    "share": 0.0664,
    "first": "2022-06-11",
    "last": "2022-07-06",
    "kind": "canon",
    "castWith": [
     "alyk",
     "lachesis",
     "haley_wolf",
     "clothos",
     "demeter",
     "moros",
     "haley_human",
     "nicole_human",
     "atropos",
     "cruz",
     "apollo",
     "arthur_turayne"
    ]
   },
   {
    "channel": "lance-is-a-family-man",
    "passages": 123,
    "share": 0.0623,
    "first": "2024-04-30",
    "last": "2024-05-18",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "audrey",
     "luca",
     "bryce",
     "lyden",
     "hermes",
     "roger",
     "dimitri",
     "hades",
     "diana",
     "zeus"
    ]
   },
   {
    "channel": "lance-mating",
    "passages": 118,
    "share": 0.0598,
    "first": "2021-08-18",
    "last": "2021-09-25",
    "kind": "route",
    "castWith": [
     "cruz",
     "lachesis",
     "clothos",
     "ryder",
     "hades",
     "nolan",
     "nicole_human",
     "audrey",
     "moros",
     "atropos",
     "nicole_wolf",
     "nicole_sg3"
    ]
   },
   {
    "channel": "chance-route-ft-lance",
    "passages": 111,
    "share": 0.0562,
    "first": "2021-09-25",
    "last": "2021-10-18",
    "kind": "route",
    "castWith": [
     "lachesis",
     "chance",
     "god",
     "aphrodite",
     "atropos",
     "clothos",
     "zeus",
     "moros",
     "ares",
     "hades",
     "may",
     "will"
    ]
   },
   {
    "channel": "lachesis-off-the-rails",
    "passages": 109,
    "share": 0.0552,
    "first": "2025-08-31",
    "last": "2025-09-27",
    "kind": "route",
    "castWith": [
     "vaughn",
     "brax",
     "lucifer",
     "james",
     "atropos",
     "cruz",
     "lachesis",
     "ace",
     "lindon",
     "hades",
     "ezra",
     "nicole_human"
    ]
   },
   {
    "channel": "cruz-x-nicole",
    "passages": 109,
    "share": 0.0552,
    "first": "2020-08-11",
    "last": "2020-08-22",
    "kind": "route",
    "castWith": [
     "cruz",
     "hermes",
     "audrey",
     "peter",
     "ares",
     "nicole_wolf",
     "nicole_sg3",
     "alyce_char",
     "red",
     "trix",
     "nicole_human",
     "moros"
    ]
   },
   {
    "channel": "no-time-like-the-present",
    "passages": 104,
    "share": 0.0527,
    "first": "2023-09-26",
    "last": "2023-10-09",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "ryder",
     "allie",
     "cruz",
     "micah",
     "god",
     "aspen",
     "trix",
     "diana",
     "evelyn",
     "audrey"
    ]
   },
   {
    "channel": "nicoles-wish-brax-brother",
    "passages": 100,
    "share": 0.0507,
    "first": "2023-04-26",
    "last": "2023-07-17",
    "kind": "route",
    "castWith": [
     "ford",
     "cruz",
     "brax",
     "dimitri",
     "hades",
     "vaughn",
     "rowan",
     "nicole_human",
     "audrey",
     "diana",
     "evelyn",
     "nicole_wolf"
    ]
   },
   {
    "channel": "yandere-cruz",
    "passages": 98,
    "share": 0.0496,
    "first": "2022-10-26",
    "last": "2022-11-11",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "moros",
     "ares",
     "alyce_char",
     "clothos",
     "atropos",
     "dimitri",
     "lachesis",
     "cupid_eros",
     "hades",
     "diana"
    ]
   },
   {
    "channel": "plz-love-lachesis",
    "passages": 97,
    "share": 0.0491,
    "first": "2022-11-11",
    "last": "2022-11-22",
    "kind": "route",
    "castWith": [
     "lachesis",
     "ramiel",
     "god",
     "lucifer",
     "apollo",
     "levi",
     "aion",
     "atropos",
     "zeus",
     "zadkiel",
     "clothos",
     "asrius"
    ]
   },
   {
    "channel": "lance-origin-route",
    "passages": 95,
    "share": 0.0481,
    "first": "2021-05-19",
    "last": "2021-05-27",
    "kind": "route",
    "castWith": [
     "lachesis",
     "clothos",
     "nicole_human",
     "ryder",
     "moros",
     "atropos",
     "god",
     "nicole_wolf",
     "nicole_sg3",
     "hades",
     "haley_human",
     "cruz"
    ]
   },
   {
    "channel": "human-lachesis",
    "passages": 75,
    "share": 0.038,
    "first": "2024-09-16",
    "last": "2024-11-20",
    "kind": "route",
    "castWith": [
     "nicole_human",
     "brax",
     "lachesis",
     "vaughn",
     "rowan",
     "god",
     "alyce_char",
     "moros",
     "ford",
     "atropos",
     "cruz",
     "nicole_wolf"
    ]
   }
  ],
  "knownCharacters": [
   "alyk",
   "lachesis",
   "haley_wolf",
   "clothos",
   "demeter",
   "moros",
   "haley_human",
   "nicole_human",
   "atropos",
   "cruz",
   "apollo",
   "arthur_turayne"
  ]
 },
 "raye": {
  "canonRoute": "evelyn-college-2",
  "totalPassages": 778,
  "routes": [
   {
    "channel": "evelyn-college-2",
    "passages": 75,
    "share": 0.0964,
    "first": "2020-12-28",
    "last": "2021-01-29",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "darren",
     "dimitri",
     "lex",
     "hades",
     "jon",
     "ares",
     "kaleb",
     "cruz",
     "kya_sg3",
     "ari",
     "aibell"
    ]
   },
   {
    "channel": "siren-raye",
    "passages": 63,
    "share": 0.081,
    "first": "2023-10-16",
    "last": "2023-10-25",
    "kind": "route",
    "castWith": [
     "kya_sg1",
     "kya_sg3",
     "sebastian_vamp",
     "sebastian_siren",
     "apollo",
     "aphrodite",
     "kaleb",
     "cupid_eros",
     "hermes",
     "ezra",
     "ares",
     "may"
    ]
   },
   {
    "channel": "dorms",
    "passages": 61,
    "share": 0.0784,
    "first": "2020-04-29",
    "last": "2020-05-14",
    "kind": "route",
    "castWith": [
     "agnar",
     "kya_sg3",
     "agmund",
     "evelyn",
     "cole",
     "kya_sg1",
     "riku",
     "kaleb",
     "penelope_valk",
     "loki",
     "svira",
     "darren"
    ]
   },
   {
    "channel": "ooc",
    "passages": 60,
    "share": 0.0771,
    "first": "2020-04-14",
    "last": "2020-11-05",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "bryce",
     "darren",
     "lex",
     "rex",
     "agnar"
    ]
   },
   {
    "channel": "kyas_penthouse",
    "passages": 54,
    "share": 0.0694,
    "first": "2020-03-27",
    "last": "2020-03-29",
    "kind": "route",
    "castWith": [
     "kaleb",
     "evelyn",
     "ezra",
     "kya_sg3",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "mr_han_sr",
     "bryce",
     "god",
     "cruz",
     "will"
    ]
   },
   {
    "channel": "meeting-room",
    "passages": 53,
    "share": 0.0681,
    "first": "2020-03-26",
    "last": "2020-04-20",
    "kind": "route",
    "castWith": [
     "kaleb",
     "ezra",
     "kya_sg3",
     "evelyn",
     "alistair_turayne",
     "alistair",
     "mr_han_sr",
     "kya_sg1",
     "thorne",
     "prince_zain",
     "sune",
     "yuri_rekovich"
    ]
   },
   {
    "channel": "rayes-bro",
    "passages": 38,
    "share": 0.0488,
    "first": "2023-10-25",
    "last": "2023-10-29",
    "kind": "route",
    "castWith": [
     "reed",
     "kya_sg3",
     "evelyn",
     "kaleb",
     "uncle_khan",
     "ezra",
     "dillon"
    ]
   },
   {
    "channel": "kya-college-2",
    "passages": 34,
    "share": 0.0437,
    "first": "2020-12-27",
    "last": "2021-01-14",
    "kind": "route",
    "castWith": [
     "lily",
     "zander",
     "kya_sg3",
     "kya_sg1",
     "ari",
     "sebastian_siren",
     "prince_zed",
     "sebastian_vamp",
     "midori_naga",
     "penelope_valk",
     "bell_lily_of_fell",
     "agnar"
    ]
   },
   {
    "channel": "kya-senior-year",
    "passages": 28,
    "share": 0.036,
    "first": "2021-06-14",
    "last": "2021-06-21",
    "kind": "route",
    "castWith": [
     "callan",
     "ezra",
     "leiden",
     "melody",
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "tate",
     "sebastian_vamp",
     "dillon",
     "sebastian_siren",
     "evelyn"
    ]
   },
   {
    "channel": "val",
    "passages": 26,
    "share": 0.0334,
    "first": "2020-04-15",
    "last": "2020-11-11",
    "kind": "route",
    "castWith": [
     "val",
     "kya_sg3",
     "kaleb",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "evelyn",
     "vanessa",
     "ezra",
     "alan",
     "tyrion",
     "mr_han_sr"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 26,
    "share": 0.0334,
    "first": "2020-03-26",
    "last": "2020-04-01",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika",
     "nolan"
    ]
   },
   {
    "channel": "surf-shack",
    "passages": 25,
    "share": 0.0321,
    "first": "2020-04-30",
    "last": "2020-05-01",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "kya_sg1",
     "skipper",
     "evelyn",
     "sebastian_vamp",
     "sebastian_siren"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "darren",
   "dimitri",
   "lex",
   "hades",
   "jon",
   "ares",
   "kaleb",
   "cruz",
   "kya_sg3",
   "ari",
   "aibell"
  ]
 },
 "ezra": {
  "canonRoute": "brothel",
  "totalPassages": 2732,
  "routes": [
   {
    "channel": "brothel",
    "passages": 296,
    "share": 0.1083,
    "first": "2020-04-18",
    "last": "2020-04-28",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "rowan",
     "kya_sg3",
     "kya_sg1",
     "primrose",
     "lily",
     "kaleb",
     "nellie",
     "lissa",
     "raye",
     "ace",
     "mr_han_sr"
    ]
   },
   {
    "channel": "haley-james-yessss",
    "passages": 248,
    "share": 0.0908,
    "first": "2020-08-14",
    "last": "2020-08-29",
    "kind": "route",
    "castWith": [
     "james",
     "haley_human",
     "kaleb",
     "ace",
     "nicole_human",
     "primrose",
     "mr_han_sr",
     "evelyn",
     "lily",
     "haley_wolf",
     "haley_sg3",
     "aphrodite"
    ]
   },
   {
    "channel": "ooc",
    "passages": 134,
    "share": 0.049,
    "first": "2020-04-14",
    "last": "2020-12-15",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex",
     "agnar"
    ]
   },
   {
    "channel": "don\u2019t-buy-me-love",
    "passages": 118,
    "share": 0.0432,
    "first": "2023-12-12",
    "last": "2023-12-28",
    "kind": "route",
    "castWith": [
     "trace_spellbook",
     "primrose",
     "madison_astor",
     "kya_sg3",
     "kya_sg1",
     "dimitri",
     "hades",
     "evelyn",
     "junta",
     "jane",
     "may",
     "reginald"
    ]
   },
   {
    "channel": "50-shades-of-ezra",
    "passages": 93,
    "share": 0.034,
    "first": "2021-09-26",
    "last": "2021-10-06",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "dillon",
     "evelyn",
     "sebastian_vamp",
     "sebastian_siren",
     "primrose",
     "uncle_khan",
     "celestine",
     "alistair",
     "raye"
    ]
   },
   {
    "channel": "junta-is-best-boi",
    "passages": 92,
    "share": 0.0337,
    "first": "2023-11-24",
    "last": "2023-12-12",
    "kind": "route",
    "castWith": [
     "junta",
     "madison_astor",
     "lily",
     "val",
     "natasha",
     "primrose",
     "belinda",
     "james",
     "may",
     "sebastian_vamp",
     "tim",
     "ace"
    ]
   },
   {
    "channel": "high-school-ezra-kya",
    "passages": 86,
    "share": 0.0315,
    "first": "2021-02-17",
    "last": "2021-02-26",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "maria",
     "rachel",
     "kaleb",
     "kya_sg1",
     "evelyn",
     "willie",
     "jane",
     "primrose",
     "lily",
     "ace",
     "uncle_khan"
    ]
   },
   {
    "channel": "ww-war-au",
    "passages": 84,
    "share": 0.0307,
    "first": "2021-11-18",
    "last": "2021-12-15",
    "kind": "au",
    "castWith": [
     "evelyn",
     "cruz",
     "ace",
     "lindon",
     "kaleb",
     "rowan",
     "bryce",
     "lance",
     "raye",
     "nolan",
     "primrose",
     "ryder"
    ]
   },
   {
    "channel": "evel-icole-x-ethan",
    "passages": 81,
    "share": 0.0296,
    "first": "2020-10-23",
    "last": "2020-11-02",
    "kind": "route",
    "castWith": [
     "evelyn",
     "ethan",
     "kaleb",
     "alistair",
     "alistair_turayne",
     "kya_sg3",
     "ace",
     "nicole_human",
     "zantium",
     "bryce",
     "mr_han_sr",
     "kya_sg1"
    ]
   },
   {
    "channel": "kya-war-au",
    "passages": 80,
    "share": 0.0293,
    "first": "2021-11-28",
    "last": "2021-12-06",
    "kind": "au",
    "castWith": [
     "kya_sg3",
     "james",
     "val",
     "kya_sg1",
     "vanessa",
     "kaleb",
     "raye",
     "sebastian_vamp",
     "sebastian_siren",
     "lily",
     "junta",
     "evelyn"
    ]
   },
   {
    "channel": "fantastical-ezra",
    "passages": 80,
    "share": 0.0293,
    "first": "2025-02-15",
    "last": "2025-03-04",
    "kind": "route",
    "castWith": [
     "dillon",
     "kaleb",
     "apollo",
     "kya_sg3",
     "james",
     "sebastian_vamp",
     "evelyn",
     "kya_sg1",
     "haley_human",
     "sebastian_siren",
     "skipper",
     "polly"
    ]
   },
   {
    "channel": "kieran-ezra",
    "passages": 73,
    "share": 0.0267,
    "first": "2023-10-07",
    "last": "2023-10-12",
    "kind": "route",
    "castWith": [
     "kieran",
     "raz",
     "lily",
     "peter",
     "primrose",
     "rosalie",
     "ace",
     "gemma"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "rowan",
   "kya_sg3",
   "kya_sg1",
   "primrose",
   "lily",
   "kaleb",
   "nellie",
   "lissa",
   "raye",
   "ace",
   "mr_han_sr"
  ]
 },
 "ryder": {
  "canonRoute": "a-tricky-micah-cruz-route",
  "totalPassages": 1039,
  "routes": [
   {
    "channel": "a-tricky-micah-cruz-route",
    "passages": 210,
    "share": 0.2021,
    "first": "2023-08-10",
    "last": "2023-09-23",
    "kind": "canon",
    "castWith": [
     "eva",
     "shane",
     "cruz",
     "micah",
     "trix",
     "allie",
     "evelyn",
     "roger",
     "audrey",
     "god",
     "bryce",
     "diana"
    ]
   },
   {
    "channel": "dimitri-ralidanti",
    "passages": 115,
    "share": 0.1107,
    "first": "2023-02-20",
    "last": "2023-03-27",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "cruz",
     "nolan",
     "bryce",
     "audrey",
     "trix",
     "lyden",
     "alyce_char",
     "kya_sg3",
     "diana",
     "frau"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 108,
    "share": 0.1039,
    "first": "2024-01-23",
    "last": "2025-02-22",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "ford",
     "vaughn",
     "lance",
     "bryce",
     "shane",
     "dimitri",
     "allie",
     "micah",
     "audrey",
     "moros"
    ]
   },
   {
    "channel": "no-time-like-the-present",
    "passages": 98,
    "share": 0.0943,
    "first": "2023-09-24",
    "last": "2023-10-09",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "lance",
     "allie",
     "cruz",
     "micah",
     "god",
     "aspen",
     "trix",
     "diana",
     "evelyn",
     "audrey"
    ]
   },
   {
    "channel": "cruz-is-not-dead",
    "passages": 64,
    "share": 0.0616,
    "first": "2022-04-11",
    "last": "2022-05-17",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "ford",
     "lucifer",
     "bryce",
     "audrey",
     "apollo",
     "ares",
     "god",
     "clint",
     "hades",
     "nolan"
    ]
   },
   {
    "channel": "indifference",
    "passages": 40,
    "share": 0.0385,
    "first": "2023-03-29",
    "last": "2024-04-28",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "alyce_char",
     "dimitri",
     "rio",
     "ace",
     "moros",
     "geo",
     "nolan",
     "audrey",
     "lachesis"
    ]
   },
   {
    "channel": "lance-mating",
    "passages": 36,
    "share": 0.0346,
    "first": "2021-08-31",
    "last": "2021-09-24",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "clothos",
     "hades",
     "nolan",
     "nicole_human",
     "audrey",
     "moros",
     "atropos",
     "nicole_wolf",
     "nicole_sg3"
    ]
   },
   {
    "channel": "micah\u2019s-experiment",
    "passages": 31,
    "share": 0.0298,
    "first": "2024-11-30",
    "last": "2024-12-11",
    "kind": "route",
    "castWith": [
     "shane",
     "eva",
     "cruz",
     "micah",
     "god",
     "trix",
     "may",
     "audrey",
     "diana"
    ]
   },
   {
    "channel": "1-real-cruz",
    "passages": 27,
    "share": 0.026,
    "first": "2022-10-03",
    "last": "2023-01-29",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "ares",
     "lance",
     "selma",
     "zeus",
     "lindon",
     "hera",
     "apollo",
     "nolan",
     "diana"
    ]
   },
   {
    "channel": "vamperwolves",
    "passages": 26,
    "share": 0.025,
    "first": "2023-04-21",
    "last": "2023-04-24",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "ares",
     "ford",
     "sebastian_vamp",
     "audrey",
     "alyce_char",
     "sebastian_siren",
     "rowan",
     "kaleb",
     "allie",
     "frau"
    ]
   },
   {
    "channel": "fordsplosion",
    "passages": 24,
    "share": 0.0231,
    "first": "2024-02-09",
    "last": "2024-03-11",
    "kind": "route",
    "castWith": [
     "ford",
     "lachesis",
     "lucifer",
     "cruz",
     "clothos",
     "god",
     "asrius",
     "ethan",
     "eva",
     "atropos",
     "may",
     "evelyn"
    ]
   },
   {
    "channel": "rogue-wolf-hot-cruz",
    "passages": 23,
    "share": 0.0221,
    "first": "2021-03-07",
    "last": "2021-03-10",
    "kind": "route",
    "castWith": [
     "cruz",
     "hunter",
     "trix",
     "audrey",
     "lance",
     "alyce_char",
     "bryce",
     "nolan",
     "diana",
     "will",
     "ever",
     "aphrodite"
    ]
   }
  ],
  "knownCharacters": [
   "eva",
   "shane",
   "cruz",
   "micah",
   "trix",
   "allie",
   "evelyn",
   "roger",
   "audrey",
   "god",
   "bryce",
   "diana"
  ]
 },
 "val": {
  "canonRoute": "val",
  "totalPassages": 442,
  "routes": [
   {
    "channel": "val",
    "passages": 153,
    "share": 0.3462,
    "first": "2020-11-12",
    "last": "2020-12-27",
    "kind": "canon",
    "castWith": [
     "kya_sg3",
     "kaleb",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "evelyn",
     "vanessa",
     "ezra",
     "raye",
     "alan",
     "tyrion",
     "mr_han_sr"
    ]
   },
   {
    "channel": "immortuos",
    "passages": 86,
    "share": 0.1946,
    "first": "2021-12-08",
    "last": "2021-12-16",
    "kind": "route",
    "castWith": [
     "james",
     "vanessa",
     "will",
     "kya_sg3",
     "kya_sg1",
     "sebastian_vamp",
     "sebastian_siren",
     "junta",
     "kaleb",
     "aurelia",
     "may",
     "tim"
    ]
   },
   {
    "channel": "1920s-boardwalk",
    "passages": 46,
    "share": 0.1041,
    "first": "2022-05-26",
    "last": "2022-05-30",
    "kind": "route",
    "castWith": [
     "ezra",
     "kya_sg3",
     "james",
     "alistair_turayne",
     "kya_sg1",
     "alistair",
     "vanessa",
     "sebastian_vamp",
     "sebastian_siren",
     "amelda",
     "junta",
     "dillon"
    ]
   },
   {
    "channel": "kya-war-au",
    "passages": 37,
    "share": 0.0837,
    "first": "2021-12-02",
    "last": "2021-12-06",
    "kind": "au",
    "castWith": [
     "ezra",
     "kya_sg3",
     "james",
     "kya_sg1",
     "vanessa",
     "kaleb",
     "raye",
     "sebastian_vamp",
     "sebastian_siren",
     "lily",
     "junta",
     "evelyn"
    ]
   },
   {
    "channel": "elders-layla",
    "passages": 35,
    "share": 0.0792,
    "first": "2020-09-08",
    "last": "2020-09-10",
    "kind": "route",
    "castWith": [
     "vanessa",
     "layla",
     "tim",
     "james",
     "junta",
     "sebastian_vamp",
     "sebastian_siren",
     "apollo",
     "theo_uoki",
     "will"
    ]
   },
   {
    "channel": "ooc",
    "passages": 15,
    "share": 0.0339,
    "first": "2020-11-12",
    "last": "2020-12-26",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "junta-is-best-boi",
    "passages": 14,
    "share": 0.0317,
    "first": "2023-12-01",
    "last": "2023-12-03",
    "kind": "route",
    "castWith": [
     "junta",
     "ezra",
     "madison_astor",
     "lily",
     "natasha",
     "primrose",
     "belinda",
     "james",
     "may",
     "sebastian_vamp",
     "tim",
     "ace"
    ]
   },
   {
    "channel": "love-the-good-bois",
    "passages": 9,
    "share": 0.0204,
    "first": "2022-11-20",
    "last": "2022-11-26",
    "kind": "route",
    "castWith": [
     "ezra",
     "junta",
     "kya_sg3",
     "raz",
     "kya_sg1",
     "tim",
     "sebastian_vamp",
     "evelyn",
     "kaleb",
     "skipper",
     "james",
     "primrose"
    ]
   },
   {
    "channel": "kya-x-james",
    "passages": 7,
    "share": 0.0158,
    "first": "2020-09-03",
    "last": "2020-09-07",
    "kind": "route",
    "castWith": [
     "james",
     "kya_sg3",
     "kya_sg1",
     "vanessa",
     "junta",
     "tim",
     "raz",
     "dalton",
     "evelyn",
     "sebastian_vamp",
     "raye",
     "sebastian_siren"
    ]
   },
   {
    "channel": "reincarnation-with-alistair",
    "passages": 7,
    "share": 0.0158,
    "first": "2025-02-05",
    "last": "2025-02-09",
    "kind": "route",
    "castWith": [
     "james",
     "dillon",
     "alistair",
     "alistair_turayne",
     "kya_sg3",
     "sebastian_vamp",
     "kya_sg1",
     "evelyn",
     "haley_human",
     "sebastian_siren",
     "athena",
     "junta"
    ]
   },
   {
    "channel": "Haley - 7/26/2026",
    "passages": 6,
    "share": 0.0136,
    "first": "2026-07-27",
    "last": "2026-07-27",
    "kind": "route",
    "castWith": [
     "james",
     "dillon",
     "kya_sg3",
     "vanessa",
     "sebastian_vamp",
     "kya_sg1",
     "junta",
     "sebastian_siren",
     "tim",
     "raz",
     "coral",
     "will"
    ]
   },
   {
    "channel": "ezra-normalish-life",
    "passages": 4,
    "share": 0.009,
    "first": "2022-09-07",
    "last": "2022-09-10",
    "kind": "route",
    "castWith": [
     "ezra",
     "sam",
     "kya_sg3",
     "kya_sg1",
     "raz",
     "james",
     "evelyn",
     "kaleb",
     "bell_lily_of_fell",
     "vanessa",
     "jane",
     "tim"
    ]
   }
  ],
  "knownCharacters": [
   "kya_sg3",
   "kaleb",
   "alistair",
   "alistair_turayne",
   "kya_sg1",
   "evelyn",
   "vanessa",
   "ezra",
   "raye",
   "alan",
   "tyrion",
   "mr_han_sr"
  ]
 },
 "tim": {
  "canonRoute": "junta-tim-soulmates",
  "totalPassages": 303,
  "routes": [
   {
    "channel": "junta-tim-soulmates",
    "passages": 131,
    "share": 0.4323,
    "first": "2023-09-10",
    "last": "2023-09-22",
    "kind": "canon",
    "castWith": [
     "junta",
     "kieran",
     "raz",
     "peter",
     "kris",
     "dalton",
     "val",
     "vanessa",
     "ever",
     "aphrodite",
     "natasha",
     "will"
    ]
   },
   {
    "channel": "Lindon + Ford",
    "passages": 102,
    "share": 0.3366,
    "first": "2026-05-20",
    "last": "2026-05-28",
    "kind": "route",
    "castWith": [
     "ford",
     "lindon",
     "dante",
     "felix_fairy",
     "nicole_human",
     "park",
     "nicole_wolf",
     "nicole_sg3",
     "ben",
     "may",
     "will",
     "ezra"
    ]
   },
   {
    "channel": "cupid-hq",
    "passages": 14,
    "share": 0.0462,
    "first": "2020-06-03",
    "last": "2020-06-04",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "sabrina_witch",
     "drake",
     "halo",
     "god",
     "aphrodite",
     "pam",
     "stan",
     "tom",
     "hiro",
     "ares",
     "hades"
    ]
   },
   {
    "channel": "love-the-good-bois",
    "passages": 12,
    "share": 0.0396,
    "first": "2022-11-20",
    "last": "2022-11-26",
    "kind": "route",
    "castWith": [
     "ezra",
     "junta",
     "kya_sg3",
     "raz",
     "kya_sg1",
     "sebastian_vamp",
     "val",
     "evelyn",
     "kaleb",
     "skipper",
     "james",
     "primrose"
    ]
   },
   {
    "channel": "kya-x-james",
    "passages": 11,
    "share": 0.0363,
    "first": "2020-09-04",
    "last": "2020-09-07",
    "kind": "route",
    "castWith": [
     "james",
     "kya_sg3",
     "kya_sg1",
     "vanessa",
     "junta",
     "val",
     "raz",
     "dalton",
     "evelyn",
     "sebastian_vamp",
     "raye",
     "sebastian_siren"
    ]
   },
   {
    "channel": "elders-layla",
    "passages": 8,
    "share": 0.0264,
    "first": "2020-09-08",
    "last": "2020-09-10",
    "kind": "route",
    "castWith": [
     "vanessa",
     "val",
     "layla",
     "james",
     "junta",
     "sebastian_vamp",
     "sebastian_siren",
     "apollo",
     "theo_uoki",
     "will"
    ]
   },
   {
    "channel": "normal-ish-to-not-kya",
    "passages": 5,
    "share": 0.0165,
    "first": "2022-06-08",
    "last": "2022-06-11",
    "kind": "route",
    "castWith": [
     "junta",
     "kya_sg3",
     "evelyn",
     "val",
     "mary_cataldi",
     "dimitri",
     "vanessa"
    ]
   },
   {
    "channel": "ezra-normalish-life",
    "passages": 3,
    "share": 0.0099,
    "first": "2022-09-07",
    "last": "2022-09-07",
    "kind": "route",
    "castWith": [
     "ezra",
     "sam",
     "kya_sg3",
     "kya_sg1",
     "raz",
     "james",
     "evelyn",
     "kaleb",
     "bell_lily_of_fell",
     "vanessa",
     "val",
     "jane"
    ]
   },
   {
    "channel": "kya-war-au",
    "passages": 3,
    "share": 0.0099,
    "first": "2021-12-02",
    "last": "2021-12-06",
    "kind": "au",
    "castWith": [
     "ezra",
     "kya_sg3",
     "james",
     "val",
     "kya_sg1",
     "vanessa",
     "kaleb",
     "raye",
     "sebastian_vamp",
     "sebastian_siren",
     "lily",
     "junta"
    ]
   },
   {
    "channel": "Haley - 7/26/2026",
    "passages": 3,
    "share": 0.0099,
    "first": "2026-07-27",
    "last": "2026-07-27",
    "kind": "route",
    "castWith": [
     "james",
     "dillon",
     "kya_sg3",
     "vanessa",
     "sebastian_vamp",
     "kya_sg1",
     "val",
     "junta",
     "sebastian_siren",
     "raz",
     "coral",
     "will"
    ]
   },
   {
    "channel": "elder-boi-romance-cause-why-not",
    "passages": 2,
    "share": 0.0066,
    "first": "2022-10-23",
    "last": "2022-10-23",
    "kind": "route",
    "castWith": [
     "james",
     "kya_sg3",
     "sebastian_vamp",
     "sebastian_siren",
     "kya_sg1",
     "vanessa",
     "val",
     "junta",
     "aphrodite"
    ]
   },
   {
    "channel": "val",
    "passages": 2,
    "share": 0.0066,
    "first": "2020-11-12",
    "last": "2020-11-12",
    "kind": "route",
    "castWith": [
     "val",
     "kya_sg3",
     "kaleb",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "evelyn",
     "vanessa",
     "ezra",
     "raye",
     "alan",
     "tyrion"
    ]
   }
  ],
  "knownCharacters": [
   "junta",
   "kieran",
   "raz",
   "peter",
   "kris",
   "dalton",
   "val",
   "vanessa",
   "ever",
   "aphrodite",
   "natasha",
   "will"
  ]
 },
 "junta": {
  "canonRoute": "junta-tim-soulmates",
  "totalPassages": 444,
  "routes": [
   {
    "channel": "junta-tim-soulmates",
    "passages": 161,
    "share": 0.3626,
    "first": "2023-09-10",
    "last": "2023-09-23",
    "kind": "canon",
    "castWith": [
     "tim",
     "kieran",
     "raz",
     "peter",
     "kris",
     "dalton",
     "val",
     "vanessa",
     "ever",
     "aphrodite",
     "natasha",
     "will"
    ]
   },
   {
    "channel": "junta-is-best-boi",
    "passages": 109,
    "share": 0.2455,
    "first": "2023-12-01",
    "last": "2023-12-12",
    "kind": "route",
    "castWith": [
     "ezra",
     "madison_astor",
     "lily",
     "val",
     "natasha",
     "primrose",
     "belinda",
     "james",
     "may",
     "sebastian_vamp",
     "tim",
     "ace"
    ]
   },
   {
    "channel": "love-the-good-bois",
    "passages": 49,
    "share": 0.1104,
    "first": "2022-11-20",
    "last": "2022-11-27",
    "kind": "route",
    "castWith": [
     "ezra",
     "kya_sg3",
     "raz",
     "kya_sg1",
     "tim",
     "sebastian_vamp",
     "val",
     "evelyn",
     "kaleb",
     "skipper",
     "james",
     "primrose"
    ]
   },
   {
    "channel": "junta-route",
    "passages": 30,
    "share": 0.0676,
    "first": "2022-11-27",
    "last": "2022-11-28",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "james",
     "natasha",
     "kya_sg1",
     "apollo",
     "athena",
     "dillon",
     "kyo",
     "hermes",
     "belinda"
    ]
   },
   {
    "channel": "normal-ish-to-not-kya",
    "passages": 15,
    "share": 0.0338,
    "first": "2022-06-08",
    "last": "2022-06-11",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "tim",
     "evelyn",
     "val",
     "mary_cataldi",
     "dimitri",
     "vanessa"
    ]
   },
   {
    "channel": "kya-x-james",
    "passages": 12,
    "share": 0.027,
    "first": "2020-09-04",
    "last": "2020-09-08",
    "kind": "route",
    "castWith": [
     "james",
     "kya_sg3",
     "kya_sg1",
     "vanessa",
     "tim",
     "val",
     "raz",
     "dalton",
     "evelyn",
     "sebastian_vamp",
     "raye",
     "sebastian_siren"
    ]
   },
   {
    "channel": "kya-war-au",
    "passages": 9,
    "share": 0.0203,
    "first": "2021-12-02",
    "last": "2021-12-05",
    "kind": "au",
    "castWith": [
     "ezra",
     "kya_sg3",
     "james",
     "val",
     "kya_sg1",
     "vanessa",
     "kaleb",
     "raye",
     "sebastian_vamp",
     "sebastian_siren",
     "lily",
     "evelyn"
    ]
   },
   {
    "channel": "alistair-immortuous-gone-wrong",
    "passages": 8,
    "share": 0.018,
    "first": "2025-10-29",
    "last": "2025-10-29",
    "kind": "route",
    "castWith": [
     "raz",
     "james",
     "kya_sg3",
     "dillon",
     "kya_sg1",
     "alistair",
     "alistair_turayne",
     "val",
     "vanessa",
     "sebastian_vamp",
     "tim",
     "sebastian_siren"
    ]
   },
   {
    "channel": "elders-layla",
    "passages": 7,
    "share": 0.0158,
    "first": "2020-09-08",
    "last": "2020-09-09",
    "kind": "route",
    "castWith": [
     "vanessa",
     "val",
     "layla",
     "tim",
     "james",
     "sebastian_vamp",
     "sebastian_siren",
     "apollo",
     "theo_uoki",
     "will"
    ]
   },
   {
    "channel": "val",
    "passages": 7,
    "share": 0.0158,
    "first": "2020-11-12",
    "last": "2020-12-07",
    "kind": "route",
    "castWith": [
     "val",
     "kya_sg3",
     "kaleb",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "evelyn",
     "vanessa",
     "ezra",
     "raye",
     "alan",
     "tyrion"
    ]
   },
   {
    "channel": "1920s-boardwalk",
    "passages": 5,
    "share": 0.0113,
    "first": "2022-05-26",
    "last": "2022-05-26",
    "kind": "route",
    "castWith": [
     "val",
     "ezra",
     "kya_sg3",
     "james",
     "alistair_turayne",
     "kya_sg1",
     "alistair",
     "vanessa",
     "sebastian_vamp",
     "sebastian_siren",
     "amelda",
     "dillon"
    ]
   },
   {
    "channel": "hot-boi-arena-cruz",
    "passages": 4,
    "share": 0.009,
    "first": "2022-06-02",
    "last": "2022-06-03",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "frau",
     "lyden",
     "crom",
     "ezra",
     "alyce_char",
     "ryder",
     "may",
     "rowan",
     "ares",
     "hades"
    ]
   }
  ],
  "knownCharacters": [
   "tim",
   "kieran",
   "raz",
   "peter",
   "kris",
   "dalton",
   "val",
   "vanessa",
   "ever",
   "aphrodite",
   "natasha",
   "will"
  ]
 },
 "audrey": {
  "canonRoute": "cruz-x-nicole",
  "totalPassages": 394,
  "routes": [
   {
    "channel": "cruz-x-nicole",
    "passages": 38,
    "share": 0.0964,
    "first": "2020-08-06",
    "last": "2020-08-11",
    "kind": "canon",
    "castWith": [
     "cruz",
     "lance",
     "hermes",
     "peter",
     "ares",
     "nicole_wolf",
     "nicole_sg3",
     "alyce_char",
     "red",
     "trix",
     "nicole_human",
     "moros"
    ]
   },
   {
    "channel": "lance-mating",
    "passages": 25,
    "share": 0.0635,
    "first": "2021-09-07",
    "last": "2021-09-25",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "clothos",
     "ryder",
     "hades",
     "nolan",
     "nicole_human",
     "moros",
     "atropos",
     "nicole_wolf",
     "nicole_sg3"
    ]
   },
   {
    "channel": "Nicole - 7/21/2026",
    "passages": 23,
    "share": 0.0584,
    "first": "2026-07-21",
    "last": "2026-07-26",
    "kind": "route",
    "castWith": [
     "ford",
     "cruz",
     "trix",
     "ryder",
     "nicole_human",
     "nicole_wolf",
     "nicole_sg3",
     "nolan",
     "ace",
     "jack",
     "lira",
     "mr_han_sr"
    ]
   },
   {
    "channel": "pack_house",
    "passages": 20,
    "share": 0.0508,
    "first": "2020-03-25",
    "last": "2020-03-31",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "nolan",
     "bryce",
     "allie",
     "alyce_char",
     "luca",
     "trix",
     "asmodeus",
     "ryder",
     "kaleb",
     "ezra"
    ]
   },
   {
    "channel": "cruz-is-not-dead",
    "passages": 19,
    "share": 0.0482,
    "first": "2022-04-06",
    "last": "2022-05-17",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "ford",
     "ryder",
     "lucifer",
     "bryce",
     "apollo",
     "ares",
     "god",
     "clint",
     "hades",
     "nolan"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 19,
    "share": 0.0482,
    "first": "2025-01-27",
    "last": "2025-02-09",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "ryder",
     "ford",
     "vaughn",
     "lance",
     "bryce",
     "shane",
     "dimitri",
     "allie",
     "micah",
     "moros"
    ]
   },
   {
    "channel": "rogue-wolf-hot-cruz",
    "passages": 18,
    "share": 0.0457,
    "first": "2021-03-01",
    "last": "2021-03-07",
    "kind": "route",
    "castWith": [
     "cruz",
     "hunter",
     "ryder",
     "trix",
     "lance",
     "alyce_char",
     "bryce",
     "nolan",
     "diana",
     "will",
     "ever",
     "aphrodite"
    ]
   },
   {
    "channel": "human-evie",
    "passages": 17,
    "share": 0.0431,
    "first": "2020-10-13",
    "last": "2020-10-21",
    "kind": "route",
    "castWith": [
     "evelyn",
     "kaleb",
     "frau",
     "cruz",
     "mr_han_sr",
     "richard_antore",
     "diana",
     "ares",
     "quincy_antore",
     "nereda",
     "elizabeth_the_third",
     "ever"
    ]
   },
   {
    "channel": "cruz-sucks-ford-fucks",
    "passages": 17,
    "share": 0.0431,
    "first": "2024-05-22",
    "last": "2024-09-09",
    "kind": "route",
    "castWith": [
     "ford",
     "cruz",
     "evelyn",
     "bryce",
     "jack",
     "dimitri",
     "rowan",
     "nolan",
     "ryder",
     "lonnie",
     "lyden",
     "alyce_char"
    ]
   },
   {
    "channel": "a-tricky-micah-cruz-route",
    "passages": 16,
    "share": 0.0406,
    "first": "2023-08-29",
    "last": "2023-09-18",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "ryder",
     "cruz",
     "micah",
     "trix",
     "allie",
     "evelyn",
     "roger",
     "god",
     "bryce",
     "diana"
    ]
   },
   {
    "channel": "cruz-x-human",
    "passages": 15,
    "share": 0.0381,
    "first": "2021-04-10",
    "last": "2021-05-03",
    "kind": "route",
    "castWith": [
     "cruz",
     "skye",
     "nolan",
     "ryder",
     "troy",
     "adrien",
     "bryce",
     "airi",
     "natasha",
     "diana",
     "will",
     "allie"
    ]
   },
   {
    "channel": "cruzin-for-a-brusin-texts",
    "passages": 13,
    "share": 0.033,
    "first": "2022-09-28",
    "last": "2022-10-06",
    "kind": "route",
    "castWith": [
     "cruz",
     "ford",
     "evelyn",
     "ryder",
     "lance",
     "nolan",
     "alyce_char",
     "bryce"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "lance",
   "hermes",
   "peter",
   "ares",
   "nicole_wolf",
   "nicole_sg3",
   "alyce_char",
   "red",
   "trix",
   "nicole_human",
   "moros"
  ]
 },
 "alva": {
  "canonRoute": "haley-is-haley",
  "totalPassages": 40,
  "routes": [
   {
    "channel": "haley-is-haley",
    "passages": 39,
    "share": 0.975,
    "first": "2024-01-23",
    "last": "2024-02-02",
    "kind": "canon",
    "castWith": [
     "moros",
     "atropos",
     "nolan",
     "alyce_char",
     "haley_wolf",
     "lachesis",
     "ryder",
     "haley_sg3",
     "drey",
     "bryce",
     "apollo",
     "cruz"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 1,
    "share": 0.025,
    "first": "2024-01-27",
    "last": "2024-01-27",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "ryder",
     "ford",
     "vaughn",
     "lance",
     "bryce",
     "shane",
     "dimitri",
     "allie",
     "micah",
     "audrey"
    ]
   }
  ],
  "knownCharacters": [
   "moros",
   "atropos",
   "nolan",
   "alyce_char",
   "haley_wolf",
   "lachesis",
   "ryder",
   "haley_sg3",
   "drey",
   "bryce",
   "apollo",
   "cruz"
  ]
 },
 "pierce": {
  "canonRoute": "kya-goddess-route",
  "totalPassages": 15,
  "routes": [
   {
    "channel": "kya-goddess-route",
    "passages": 15,
    "share": 1.0,
    "first": "2020-12-31",
    "last": "2021-01-04",
    "kind": "canon",
    "castWith": [
     "kya_sg3",
     "aphrodite",
     "cupid_eros",
     "kya_sg1"
    ]
   }
  ],
  "knownCharacters": [
   "kya_sg3",
   "aphrodite",
   "cupid_eros",
   "kya_sg1"
  ]
 },
 "moros": {
  "canonRoute": "moros-commits",
  "totalPassages": 517,
  "routes": [
   {
    "channel": "moros-commits",
    "passages": 70,
    "share": 0.1354,
    "first": "2021-10-06",
    "last": "2021-10-25",
    "kind": "canon",
    "castWith": [
     "apollo",
     "atropos",
     "lachesis",
     "aphrodite",
     "clothos",
     "will",
     "cupid_eros",
     "hera",
     "may",
     "zeus"
    ]
   },
   {
    "channel": "atropos-reincarnated",
    "passages": 63,
    "share": 0.1219,
    "first": "2022-06-12",
    "last": "2022-07-01",
    "kind": "route",
    "castWith": [
     "apollo",
     "haley_wolf",
     "atropos",
     "zeus",
     "zephyr",
     "dante",
     "lachesis",
     "clothos",
     "aphrodite",
     "hera",
     "haley_human",
     "nicole_human"
    ]
   },
   {
    "channel": "atropos-in-hell",
    "passages": 45,
    "share": 0.087,
    "first": "2021-05-24",
    "last": "2021-06-03",
    "kind": "route",
    "castWith": [
     "lucifer",
     "atropos",
     "lachesis",
     "haley_wolf",
     "god",
     "clothos",
     "gabriel",
     "lance",
     "hades",
     "mary_cataldi",
     "haley_human",
     "cupid_eros"
    ]
   },
   {
    "channel": "haley-finds-out-shes-cool-2",
    "passages": 41,
    "share": 0.0793,
    "first": "2022-12-01",
    "last": "2022-12-09",
    "kind": "route",
    "castWith": [
     "atropos",
     "gracie",
     "haley_human",
     "jinko",
     "lance",
     "may",
     "lachesis",
     "athena",
     "clothos",
     "haley_wolf",
     "peter",
     "apollo"
    ]
   },
   {
    "channel": "college-possessive",
    "passages": 39,
    "share": 0.0754,
    "first": "2024-12-18",
    "last": "2025-01-03",
    "kind": "route",
    "castWith": [
     "leon",
     "apollo",
     "atropos",
     "lachesis",
     "haley_human",
     "haley_wolf",
     "sabrina_witch",
     "clothos",
     "god",
     "may",
     "will",
     "zeus"
    ]
   },
   {
    "channel": "wtf-happened",
    "passages": 34,
    "share": 0.0658,
    "first": "2023-08-24",
    "last": "2023-09-01",
    "kind": "route",
    "castWith": [
     "apollo",
     "cupid_eros",
     "atropos",
     "alistair",
     "alistair_turayne",
     "haley_wolf",
     "haley_human",
     "lachesis",
     "aphrodite",
     "zeus",
     "ezra",
     "god"
    ]
   },
   {
    "channel": "lance-mating",
    "passages": 25,
    "share": 0.0484,
    "first": "2021-08-24",
    "last": "2021-08-30",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "clothos",
     "ryder",
     "hades",
     "nolan",
     "nicole_human",
     "audrey",
     "atropos",
     "nicole_wolf",
     "nicole_sg3"
    ]
   },
   {
    "channel": "human-lachesis",
    "passages": 25,
    "share": 0.0484,
    "first": "2024-09-12",
    "last": "2024-10-11",
    "kind": "route",
    "castWith": [
     "nicole_human",
     "brax",
     "lachesis",
     "lance",
     "vaughn",
     "rowan",
     "god",
     "alyce_char",
     "ford",
     "atropos",
     "cruz",
     "nicole_wolf"
    ]
   },
   {
    "channel": "yandere-cruz",
    "passages": 23,
    "share": 0.0445,
    "first": "2022-10-29",
    "last": "2022-11-11",
    "kind": "route",
    "castWith": [
     "lance",
     "cruz",
     "evelyn",
     "ares",
     "alyce_char",
     "clothos",
     "atropos",
     "dimitri",
     "lachesis",
     "cupid_eros",
     "hades",
     "diana"
    ]
   },
   {
    "channel": "atropos-goes-to-second-hell",
    "passages": 19,
    "share": 0.0368,
    "first": "2022-07-02",
    "last": "2022-07-08",
    "kind": "route",
    "castWith": [
     "dante",
     "atropos",
     "lachesis",
     "ares",
     "clothos",
     "may",
     "aphrodite",
     "apollo",
     "hermes",
     "god"
    ]
   },
   {
    "channel": "indifference",
    "passages": 19,
    "share": 0.0368,
    "first": "2023-04-03",
    "last": "2024-04-24",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "alyce_char",
     "dimitri",
     "ryder",
     "rio",
     "ace",
     "geo",
     "nolan",
     "audrey",
     "lachesis"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 16,
    "share": 0.0309,
    "first": "2024-01-23",
    "last": "2025-02-07",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "ryder",
     "ford",
     "vaughn",
     "lance",
     "bryce",
     "shane",
     "dimitri",
     "allie",
     "micah",
     "audrey"
    ]
   }
  ],
  "knownCharacters": [
   "apollo",
   "atropos",
   "lachesis",
   "aphrodite",
   "clothos",
   "will",
   "cupid_eros",
   "hera",
   "may",
   "zeus"
  ]
 },
 "octa": {
  "canonRoute": "kinley-story",
  "totalPassages": 1,
  "routes": [
   {
    "channel": "kinley-story",
    "passages": 1,
    "share": 1.0,
    "first": "2022-03-22",
    "last": "2022-03-22",
    "kind": "canon",
    "castWith": [
     "aaron",
     "kinley",
     "haley_human"
    ]
   }
  ],
  "knownCharacters": [
   "aaron",
   "kinley",
   "haley_human"
  ]
 },
 "trix": {
  "canonRoute": "a-tricky-micah-cruz-route",
  "totalPassages": 164,
  "routes": [
   {
    "channel": "a-tricky-micah-cruz-route",
    "passages": 41,
    "share": 0.25,
    "first": "2023-08-10",
    "last": "2023-09-23",
    "kind": "canon",
    "castWith": [
     "eva",
     "shane",
     "ryder",
     "cruz",
     "micah",
     "allie",
     "evelyn",
     "roger",
     "audrey",
     "god",
     "bryce",
     "diana"
    ]
   },
   {
    "channel": "rogue-wolf-hot-cruz",
    "passages": 19,
    "share": 0.1159,
    "first": "2021-03-02",
    "last": "2021-03-14",
    "kind": "route",
    "castWith": [
     "cruz",
     "hunter",
     "ryder",
     "audrey",
     "lance",
     "alyce_char",
     "bryce",
     "nolan",
     "diana",
     "will",
     "ever",
     "aphrodite"
    ]
   },
   {
    "channel": "cruz-x-nicole",
    "passages": 16,
    "share": 0.0976,
    "first": "2020-08-09",
    "last": "2020-08-11",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "hermes",
     "audrey",
     "peter",
     "ares",
     "nicole_wolf",
     "nicole_sg3",
     "alyce_char",
     "red",
     "nicole_human",
     "moros"
    ]
   },
   {
    "channel": "Ford",
    "passages": 15,
    "share": 0.0915,
    "first": "2026-04-07",
    "last": "2026-04-09",
    "kind": "route",
    "castWith": [
     "ford",
     "cruz",
     "nicole_human",
     "nolan",
     "alyce_char",
     "ryder",
     "richard_antore",
     "bryce",
     "allie",
     "diana",
     "audrey",
     "nicole_wolf"
    ]
   },
   {
    "channel": "Nicole - 7/21/2026",
    "passages": 13,
    "share": 0.0793,
    "first": "2026-07-21",
    "last": "2026-07-22",
    "kind": "route",
    "castWith": [
     "ford",
     "cruz",
     "audrey",
     "ryder",
     "nicole_human",
     "nicole_wolf",
     "nicole_sg3",
     "nolan",
     "ace",
     "jack",
     "lira",
     "mr_han_sr"
    ]
   },
   {
    "channel": "no-time-like-the-present",
    "passages": 9,
    "share": 0.0549,
    "first": "2023-09-24",
    "last": "2023-10-02",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "lance",
     "ryder",
     "allie",
     "cruz",
     "micah",
     "god",
     "aspen",
     "diana",
     "evelyn",
     "audrey"
    ]
   },
   {
    "channel": "nicolexcruz-true-mates",
    "passages": 9,
    "share": 0.0549,
    "first": "2024-03-23",
    "last": "2024-04-05",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "nolan",
     "clothos",
     "diana",
     "nicole_human",
     "audrey",
     "asrius",
     "lucifer",
     "atropos",
     "bryce"
    ]
   },
   {
    "channel": "shane-micah-wish",
    "passages": 7,
    "share": 0.0427,
    "first": "2023-11-28",
    "last": "2023-12-08",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "cruz",
     "micah",
     "ryder",
     "god",
     "ever",
     "diana",
     "lucifer",
     "rex",
     "jack",
     "keller"
    ]
   },
   {
    "channel": "pack_house",
    "passages": 6,
    "share": 0.0366,
    "first": "2020-03-25",
    "last": "2020-03-25",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "nolan",
     "bryce",
     "audrey",
     "allie",
     "alyce_char",
     "luca",
     "asmodeus",
     "ryder",
     "kaleb",
     "ezra"
    ]
   },
   {
    "channel": "ww-war-au",
    "passages": 5,
    "share": 0.0305,
    "first": "2021-12-10",
    "last": "2021-12-14",
    "kind": "au",
    "castWith": [
     "evelyn",
     "cruz",
     "ace",
     "ezra",
     "lindon",
     "kaleb",
     "rowan",
     "bryce",
     "lance",
     "raye",
     "nolan",
     "primrose"
    ]
   },
   {
    "channel": "indifference",
    "passages": 5,
    "share": 0.0305,
    "first": "2023-04-07",
    "last": "2024-04-28",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "alyce_char",
     "dimitri",
     "ryder",
     "rio",
     "ace",
     "moros",
     "geo",
     "nolan",
     "audrey"
    ]
   },
   {
    "channel": "growing-up-cruz",
    "passages": 4,
    "share": 0.0244,
    "first": "2023-01-31",
    "last": "2023-02-15",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "allie",
     "kaleb",
     "audrey",
     "raquel_ratchet",
     "dimitri",
     "ford",
     "ryder",
     "lyden",
     "frau",
     "uncle_khan"
    ]
   }
  ],
  "knownCharacters": [
   "eva",
   "shane",
   "ryder",
   "cruz",
   "micah",
   "allie",
   "evelyn",
   "roger",
   "audrey",
   "god",
   "bryce",
   "diana"
  ]
 },
 "alyce_char": {
  "canonRoute": "indifference",
  "totalPassages": 268,
  "routes": [
   {
    "channel": "indifference",
    "passages": 62,
    "share": 0.2313,
    "first": "2023-04-03",
    "last": "2024-04-27",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "dimitri",
     "ryder",
     "rio",
     "ace",
     "moros",
     "geo",
     "nolan",
     "audrey",
     "lachesis"
    ]
   },
   {
    "channel": "human-lachesis",
    "passages": 26,
    "share": 0.097,
    "first": "2024-09-12",
    "last": "2024-09-24",
    "kind": "route",
    "castWith": [
     "nicole_human",
     "brax",
     "lachesis",
     "lance",
     "vaughn",
     "rowan",
     "god",
     "moros",
     "ford",
     "atropos",
     "cruz",
     "nicole_wolf"
    ]
   },
   {
    "channel": "cruz-x-nicole",
    "passages": 23,
    "share": 0.0858,
    "first": "2020-08-06",
    "last": "2020-08-11",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "hermes",
     "audrey",
     "peter",
     "ares",
     "nicole_wolf",
     "nicole_sg3",
     "red",
     "trix",
     "nicole_human",
     "moros"
    ]
   },
   {
    "channel": "haley-nolan",
    "passages": 22,
    "share": 0.0821,
    "first": "2020-09-10",
    "last": "2020-09-13",
    "kind": "route",
    "castWith": [
     "nolan",
     "charlie",
     "alistair",
     "alistair_turayne",
     "caroline",
     "ryder",
     "cruz",
     "moros",
     "lachesis",
     "renee",
     "clothos",
     "audrey"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 16,
    "share": 0.0597,
    "first": "2024-01-23",
    "last": "2025-02-09",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "ryder",
     "ford",
     "vaughn",
     "lance",
     "bryce",
     "shane",
     "dimitri",
     "allie",
     "micah",
     "audrey"
    ]
   },
   {
    "channel": "rogue-wolf-hot-cruz",
    "passages": 13,
    "share": 0.0485,
    "first": "2021-03-01",
    "last": "2021-03-07",
    "kind": "route",
    "castWith": [
     "cruz",
     "hunter",
     "ryder",
     "trix",
     "audrey",
     "lance",
     "bryce",
     "nolan",
     "diana",
     "will",
     "ever",
     "aphrodite"
    ]
   },
   {
    "channel": "frau-collin",
    "passages": 11,
    "share": 0.041,
    "first": "2020-04-15",
    "last": "2020-11-21",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "rowan",
     "frau",
     "collin_keller",
     "arland_rees",
     "ezra",
     "felix_fairy",
     "rikki",
     "park",
     "myra",
     "allie"
    ]
   },
   {
    "channel": "lance-mating",
    "passages": 10,
    "share": 0.0373,
    "first": "2021-08-24",
    "last": "2021-09-12",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "clothos",
     "ryder",
     "hades",
     "nolan",
     "nicole_human",
     "audrey",
     "moros",
     "atropos",
     "nicole_wolf"
    ]
   },
   {
    "channel": "yandere-cruz",
    "passages": 10,
    "share": 0.0373,
    "first": "2022-11-03",
    "last": "2022-11-11",
    "kind": "route",
    "castWith": [
     "lance",
     "cruz",
     "evelyn",
     "moros",
     "ares",
     "clothos",
     "atropos",
     "dimitri",
     "lachesis",
     "cupid_eros",
     "hades",
     "diana"
    ]
   },
   {
    "channel": "ww-war-au",
    "passages": 8,
    "share": 0.0299,
    "first": "2021-12-11",
    "last": "2021-12-16",
    "kind": "au",
    "castWith": [
     "evelyn",
     "cruz",
     "ace",
     "ezra",
     "lindon",
     "kaleb",
     "rowan",
     "bryce",
     "lance",
     "raye",
     "nolan",
     "primrose"
    ]
   },
   {
    "channel": "pack_house",
    "passages": 8,
    "share": 0.0299,
    "first": "2020-03-25",
    "last": "2020-03-26",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "nolan",
     "bryce",
     "audrey",
     "allie",
     "luca",
     "trix",
     "asmodeus",
     "ryder",
     "kaleb",
     "ezra"
    ]
   },
   {
    "channel": "1-real-cruz",
    "passages": 7,
    "share": 0.0261,
    "first": "2022-10-13",
    "last": "2022-10-23",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "ares",
     "lance",
     "selma",
     "zeus",
     "lindon",
     "hera",
     "ryder",
     "apollo",
     "nolan"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "cruz",
   "bryce",
   "dimitri",
   "ryder",
   "rio",
   "ace",
   "moros",
   "geo",
   "nolan",
   "audrey",
   "lachesis"
  ]
 },
 "ethan": {
  "canonRoute": "evel-icole-x-ethan",
  "totalPassages": 61,
  "routes": [
   {
    "channel": "evel-icole-x-ethan",
    "passages": 42,
    "share": 0.6885,
    "first": "2020-10-29",
    "last": "2020-11-02",
    "kind": "canon",
    "castWith": [
     "ezra",
     "evelyn",
     "kaleb",
     "alistair",
     "alistair_turayne",
     "kya_sg3",
     "ace",
     "nicole_human",
     "zantium",
     "bryce",
     "mr_han_sr",
     "kya_sg1"
    ]
   },
   {
    "channel": "fordsplosion",
    "passages": 12,
    "share": 0.1967,
    "first": "2024-03-11",
    "last": "2024-03-14",
    "kind": "route",
    "castWith": [
     "ford",
     "lachesis",
     "lucifer",
     "cruz",
     "clothos",
     "ryder",
     "god",
     "asrius",
     "eva",
     "atropos",
     "may",
     "evelyn"
    ]
   },
   {
    "channel": "almost-kya-x-sebastian",
    "passages": 7,
    "share": 0.1148,
    "first": "2020-11-02",
    "last": "2020-11-02",
    "kind": "route",
    "castWith": [
     "sebastian_siren",
     "sebastian_vamp",
     "polly",
     "kya_sg3",
     "kya_sg1",
     "evelyn",
     "haley_human",
     "alistair",
     "ezra",
     "haley_wolf",
     "haley_sg3",
     "miya"
    ]
   }
  ],
  "knownCharacters": [
   "ezra",
   "evelyn",
   "kaleb",
   "alistair",
   "alistair_turayne",
   "kya_sg3",
   "ace",
   "nicole_human",
   "zantium",
   "bryce",
   "mr_han_sr",
   "kya_sg1"
  ]
 },
 "dutch": {
  "canonRoute": "new-fairy-route",
  "totalPassages": 21,
  "routes": [
   {
    "channel": "new-fairy-route",
    "passages": 20,
    "share": 0.9524,
    "first": "2023-02-28",
    "last": "2023-03-02",
    "kind": "canon",
    "castWith": [
     "holt",
     "archie",
     "sabrina_witch",
     "kieran",
     "cair",
     "claire",
     "atropos",
     "ever",
     "may"
    ]
   },
   {
    "channel": "human-evie",
    "passages": 1,
    "share": 0.0476,
    "first": "2020-10-06",
    "last": "2020-10-06",
    "kind": "route",
    "castWith": [
     "evelyn",
     "kaleb",
     "frau",
     "cruz",
     "mr_han_sr",
     "audrey",
     "richard_antore",
     "diana",
     "ares",
     "quincy_antore",
     "nereda",
     "elizabeth_the_third"
    ]
   }
  ],
  "knownCharacters": [
   "holt",
   "archie",
   "sabrina_witch",
   "kieran",
   "cair",
   "claire",
   "atropos",
   "ever",
   "may"
  ]
 },
 "holt": {
  "canonRoute": "new-fairy-route",
  "totalPassages": 101,
  "routes": [
   {
    "channel": "new-fairy-route",
    "passages": 101,
    "share": 1.0,
    "first": "2023-02-28",
    "last": "2023-04-05",
    "kind": "canon",
    "castWith": [
     "archie",
     "sabrina_witch",
     "kieran",
     "dutch",
     "cair",
     "claire",
     "atropos",
     "ever",
     "may"
    ]
   }
  ],
  "knownCharacters": [
   "archie",
   "sabrina_witch",
   "kieran",
   "dutch",
   "cair",
   "claire",
   "atropos",
   "ever",
   "may"
  ]
 },
 "archie": {
  "canonRoute": "new-fairy-route",
  "totalPassages": 81,
  "routes": [
   {
    "channel": "new-fairy-route",
    "passages": 79,
    "share": 0.9753,
    "first": "2023-03-01",
    "last": "2023-04-05",
    "kind": "canon",
    "castWith": [
     "holt",
     "sabrina_witch",
     "kieran",
     "dutch",
     "cair",
     "claire",
     "atropos",
     "ever",
     "may"
    ]
   },
   {
    "channel": "cruz-x-human",
    "passages": 1,
    "share": 0.0123,
    "first": "2021-05-05",
    "last": "2021-05-05",
    "kind": "route",
    "castWith": [
     "cruz",
     "skye",
     "nolan",
     "ryder",
     "audrey",
     "troy",
     "adrien",
     "bryce",
     "airi",
     "natasha",
     "diana",
     "will"
    ]
   },
   {
    "channel": "ooc",
    "passages": 1,
    "share": 0.0123,
    "first": "2020-05-04",
    "last": "2020-05-04",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   }
  ],
  "knownCharacters": [
   "holt",
   "sabrina_witch",
   "kieran",
   "dutch",
   "cair",
   "claire",
   "atropos",
   "ever",
   "may"
  ]
 },
 "jon": {
  "canonRoute": "evelyn-college-2",
  "totalPassages": 101,
  "routes": [
   {
    "channel": "evelyn-college-2",
    "passages": 68,
    "share": 0.6733,
    "first": "2020-12-28",
    "last": "2021-01-24",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "darren",
     "dimitri",
     "lex",
     "hades",
     "raye",
     "ares",
     "kaleb",
     "cruz",
     "kya_sg3",
     "ari",
     "aibell"
    ]
   },
   {
    "channel": "college-campus",
    "passages": 12,
    "share": 0.1188,
    "first": "2020-04-26",
    "last": "2020-05-25",
    "kind": "route",
    "castWith": [
     "agnar",
     "agmund",
     "kya_sg3",
     "penelope_valk",
     "evelyn",
     "svira",
     "rowan",
     "may",
     "kya_sg1",
     "kaleb",
     "darren",
     "cole"
    ]
   },
   {
    "channel": "dorms",
    "passages": 8,
    "share": 0.0792,
    "first": "2020-04-29",
    "last": "2020-04-29",
    "kind": "route",
    "castWith": [
     "agnar",
     "kya_sg3",
     "agmund",
     "evelyn",
     "raye",
     "cole",
     "kya_sg1",
     "riku",
     "kaleb",
     "penelope_valk",
     "loki",
     "svira"
    ]
   },
   {
    "channel": "darren-professor-starter",
    "passages": 6,
    "share": 0.0594,
    "first": "2020-12-27",
    "last": "2020-12-27",
    "kind": "route",
    "castWith": [
     "evelyn",
     "raye",
     "kaleb",
     "kya_sg3",
     "kya_sg1",
     "will"
    ]
   },
   {
    "channel": "ooc",
    "passages": 4,
    "share": 0.0396,
    "first": "2020-04-29",
    "last": "2020-04-29",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "kya-college-2",
    "passages": 1,
    "share": 0.0099,
    "first": "2020-12-27",
    "last": "2020-12-27",
    "kind": "route",
    "castWith": [
     "lily",
     "zander",
     "kya_sg3",
     "kya_sg1",
     "ari",
     "sebastian_siren",
     "raye",
     "prince_zed",
     "sebastian_vamp",
     "midori_naga",
     "penelope_valk",
     "bell_lily_of_fell"
    ]
   },
   {
    "channel": "brothel",
    "passages": 1,
    "share": 0.0099,
    "first": "2020-04-26",
    "last": "2020-04-26",
    "kind": "route",
    "castWith": [
     "ezra",
     "evelyn",
     "rowan",
     "kya_sg3",
     "kya_sg1",
     "primrose",
     "lily",
     "kaleb",
     "nellie",
     "lissa",
     "raye",
     "ace"
    ]
   },
   {
    "channel": "greek-house",
    "passages": 1,
    "share": 0.0099,
    "first": "2020-04-29",
    "last": "2020-04-29",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hiro",
     "darren",
     "lex",
     "kiro",
     "raye",
     "kya_sg3",
     "ares",
     "riku",
     "kya_sg1",
     "lacie",
     "aphrodite"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "darren",
   "dimitri",
   "lex",
   "hades",
   "raye",
   "ares",
   "kaleb",
   "cruz",
   "kya_sg3",
   "ari",
   "aibell"
  ]
 },
 "darren": {
  "canonRoute": "evelyn-college-2",
  "totalPassages": 382,
  "routes": [
   {
    "channel": "evelyn-college-2",
    "passages": 212,
    "share": 0.555,
    "first": "2020-12-27",
    "last": "2021-01-29",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "dimitri",
     "lex",
     "hades",
     "raye",
     "jon",
     "ares",
     "kaleb",
     "cruz",
     "kya_sg3",
     "ari",
     "aibell"
    ]
   },
   {
    "channel": "ooc",
    "passages": 40,
    "share": 0.1047,
    "first": "2020-04-26",
    "last": "2020-12-26",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "lex",
     "rex",
     "agnar"
    ]
   },
   {
    "channel": "the-blacklight",
    "passages": 36,
    "share": 0.0942,
    "first": "2020-04-30",
    "last": "2020-05-01",
    "kind": "route",
    "castWith": [
     "evelyn",
     "lucius",
     "lacie",
     "kiro",
     "lex",
     "milo",
     "kya_sg3",
     "kya_sg1",
     "cruz",
     "rowan",
     "kaleb",
     "aphrodite"
    ]
   },
   {
    "channel": "greek-house",
    "passages": 31,
    "share": 0.0812,
    "first": "2020-04-29",
    "last": "2020-05-09",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hiro",
     "lex",
     "kiro",
     "raye",
     "kya_sg3",
     "ares",
     "riku",
     "kya_sg1",
     "lacie",
     "aphrodite",
     "god"
    ]
   },
   {
    "channel": "dorms",
    "passages": 13,
    "share": 0.034,
    "first": "2020-04-30",
    "last": "2020-05-05",
    "kind": "route",
    "castWith": [
     "agnar",
     "kya_sg3",
     "agmund",
     "evelyn",
     "raye",
     "cole",
     "kya_sg1",
     "riku",
     "kaleb",
     "penelope_valk",
     "loki",
     "svira"
    ]
   },
   {
    "channel": "natalia-reset-route",
    "passages": 9,
    "share": 0.0236,
    "first": "2022-02-19",
    "last": "2022-02-21",
    "kind": "route",
    "castWith": [
     "natalia",
     "parks",
     "god",
     "kinley",
     "lucifer",
     "may"
    ]
   },
   {
    "channel": "nevada",
    "passages": 9,
    "share": 0.0236,
    "first": "2020-05-19",
    "last": "2020-05-20",
    "kind": "route",
    "castWith": [
     "hiro",
     "evelyn",
     "dike",
     "cupid_eros",
     "apollo",
     "ares",
     "hades",
     "will",
     "athena",
     "lucius",
     "god",
     "zeus"
    ]
   },
   {
    "channel": "college-campus",
    "passages": 6,
    "share": 0.0157,
    "first": "2020-04-14",
    "last": "2020-05-25",
    "kind": "route",
    "castWith": [
     "agnar",
     "agmund",
     "kya_sg3",
     "penelope_valk",
     "evelyn",
     "svira",
     "rowan",
     "may",
     "jon",
     "kya_sg1",
     "kaleb",
     "cole"
    ]
   },
   {
    "channel": "misc-location",
    "passages": 5,
    "share": 0.0131,
    "first": "2020-05-04",
    "last": "2020-05-12",
    "kind": "route",
    "castWith": [
     "evelyn",
     "riku",
     "ares",
     "kiro",
     "hiro",
     "lex",
     "lance",
     "ezra",
     "lucius",
     "kaleb",
     "raye",
     "kya_sg3"
    ]
   },
   {
    "channel": "hiros-room",
    "passages": 5,
    "share": 0.0131,
    "first": "2020-05-09",
    "last": "2020-05-10",
    "kind": "route",
    "castWith": [
     "hiro",
     "evelyn",
     "ares",
     "riku",
     "kiro",
     "lex",
     "hades",
     "lacie",
     "zeus"
    ]
   },
   {
    "channel": "3-angry-rawr",
    "passages": 4,
    "share": 0.0105,
    "first": "2022-12-28",
    "last": "2022-12-30",
    "kind": "route",
    "castWith": [
     "evelyn"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 4,
    "share": 0.0105,
    "first": "2020-05-22",
    "last": "2020-05-30",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "dimitri",
   "lex",
   "hades",
   "raye",
   "jon",
   "ares",
   "kaleb",
   "cruz",
   "kya_sg3",
   "ari",
   "aibell"
  ]
 },
 "haley_wolf": {
  "canonRoute": "atropos-reincarnated",
  "totalPassages": 121,
  "routes": [
   {
    "channel": "atropos-reincarnated",
    "passages": 28,
    "share": 0.2314,
    "first": "2022-06-12",
    "last": "2022-06-22",
    "kind": "canon",
    "castWith": [
     "moros",
     "apollo",
     "atropos",
     "zeus",
     "zephyr",
     "dante",
     "lachesis",
     "clothos",
     "aphrodite",
     "hera",
     "haley_human",
     "nicole_human"
    ]
   },
   {
    "channel": "lachesis-reincarnated",
    "passages": 16,
    "share": 0.1322,
    "first": "2022-06-11",
    "last": "2022-06-14",
    "kind": "route",
    "castWith": [
     "lance",
     "alyk",
     "lachesis",
     "clothos",
     "demeter",
     "moros",
     "haley_human",
     "nicole_human",
     "atropos",
     "cruz",
     "apollo",
     "arthur_turayne"
    ]
   },
   {
    "channel": "atropos-in-hell",
    "passages": 15,
    "share": 0.124,
    "first": "2021-05-24",
    "last": "2021-06-03",
    "kind": "route",
    "castWith": [
     "lucifer",
     "atropos",
     "moros",
     "lachesis",
     "god",
     "clothos",
     "gabriel",
     "lance",
     "hades",
     "mary_cataldi",
     "haley_human",
     "cupid_eros"
    ]
   },
   {
    "channel": "haley-is-haley",
    "passages": 6,
    "share": 0.0496,
    "first": "2024-01-22",
    "last": "2024-01-30",
    "kind": "route",
    "castWith": [
     "alva",
     "moros",
     "atropos",
     "nolan",
     "alyce_char",
     "lachesis",
     "ryder",
     "haley_sg3",
     "drey",
     "bryce",
     "apollo",
     "cruz"
    ]
   },
   {
    "channel": "wtf-happened",
    "passages": 6,
    "share": 0.0496,
    "first": "2023-08-10",
    "last": "2023-09-01",
    "kind": "route",
    "castWith": [
     "apollo",
     "cupid_eros",
     "moros",
     "atropos",
     "alistair",
     "alistair_turayne",
     "haley_human",
     "lachesis",
     "aphrodite",
     "zeus",
     "ezra",
     "god"
    ]
   },
   {
    "channel": "the-werewolf-harem-bandwagon",
    "passages": 5,
    "share": 0.0413,
    "first": "2022-12-09",
    "last": "2022-12-14",
    "kind": "route",
    "castWith": [
     "declan",
     "koda",
     "haley_sg3",
     "diana",
     "god",
     "may",
     "mia"
    ]
   },
   {
    "channel": "haley-nolan",
    "passages": 5,
    "share": 0.0413,
    "first": "2020-09-10",
    "last": "2020-09-16",
    "kind": "route",
    "castWith": [
     "nolan",
     "charlie",
     "alistair",
     "alistair_turayne",
     "caroline",
     "alyce_char",
     "ryder",
     "cruz",
     "moros",
     "lachesis",
     "renee",
     "clothos"
    ]
   },
   {
    "channel": "haleys-alistair-wish",
    "passages": 4,
    "share": 0.0331,
    "first": "2023-05-01",
    "last": "2023-05-09",
    "kind": "route",
    "castWith": [
     "ezra",
     "evelyn",
     "alistair_turayne",
     "alistair",
     "raye",
     "kaleb",
     "james",
     "dimitri",
     "haley_sg3",
     "uncle_khan",
     "haley_human",
     "bryce"
    ]
   },
   {
    "channel": "haleys-wish",
    "passages": 3,
    "share": 0.0248,
    "first": "2023-04-26",
    "last": "2023-04-26",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "evelyn",
     "sebastian_siren",
     "kya_sg1",
     "sebastian_vamp",
     "haley_human",
     "polly",
     "cruz",
     "dimitri",
     "haley_sg3",
     "skipper",
     "kaleb"
    ]
   },
   {
    "channel": "nicolexcruz-true-mates",
    "passages": 3,
    "share": 0.0248,
    "first": "2024-03-19",
    "last": "2024-03-19",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "nolan",
     "clothos",
     "trix",
     "diana",
     "nicole_human",
     "audrey",
     "asrius",
     "lucifer",
     "atropos"
    ]
   },
   {
    "channel": "alistair-x-human-kya",
    "passages": 3,
    "share": 0.0248,
    "first": "2020-08-11",
    "last": "2020-08-12",
    "kind": "route",
    "castWith": [
     "haley_human",
     "alistair_turayne",
     "alistair",
     "apollo",
     "nicole_human",
     "ezra",
     "raye",
     "james",
     "atropos",
     "hades",
     "beatrice",
     "cruz"
    ]
   },
   {
    "channel": "lance-nicole-2",
    "passages": 2,
    "share": 0.0165,
    "first": "2022-11-26",
    "last": "2022-11-28",
    "kind": "route",
    "castWith": [
     "brax",
     "vaughn",
     "lance",
     "jenning",
     "cruz",
     "lachesis",
     "nicole_human",
     "nicole_wolf",
     "nicole_sg3",
     "clothos",
     "atropos",
     "rowan"
    ]
   }
  ],
  "knownCharacters": [
   "moros",
   "apollo",
   "atropos",
   "zeus",
   "zephyr",
   "dante",
   "lachesis",
   "clothos",
   "aphrodite",
   "hera",
   "haley_human",
   "nicole_human"
  ]
 },
 "haley_human": {
  "canonRoute": "alistair-x-human-kya",
  "totalPassages": 310,
  "routes": [
   {
    "channel": "alistair-x-human-kya",
    "passages": 136,
    "share": 0.4387,
    "first": "2020-08-02",
    "last": "2020-08-13",
    "kind": "canon",
    "castWith": [
     "alistair_turayne",
     "alistair",
     "apollo",
     "nicole_human",
     "ezra",
     "raye",
     "james",
     "atropos",
     "hades",
     "beatrice",
     "cruz",
     "haley_wolf"
    ]
   },
   {
    "channel": "aaron-haley",
    "passages": 48,
    "share": 0.1548,
    "first": "2023-01-13",
    "last": "2023-01-25",
    "kind": "route",
    "castWith": [
     "aaron",
     "lula",
     "kya_sg3",
     "rowan",
     "kya_sg1",
     "trev",
     "god",
     "may"
    ]
   },
   {
    "channel": "haley-james-yessss",
    "passages": 31,
    "share": 0.1,
    "first": "2020-08-14",
    "last": "2020-08-27",
    "kind": "route",
    "castWith": [
     "ezra",
     "james",
     "kaleb",
     "ace",
     "nicole_human",
     "primrose",
     "mr_han_sr",
     "evelyn",
     "lily",
     "haley_wolf",
     "haley_sg3",
     "aphrodite"
    ]
   },
   {
    "channel": "i-cant-ride-this-river",
    "passages": 11,
    "share": 0.0355,
    "first": "2023-06-02",
    "last": "2023-07-15",
    "kind": "route",
    "castWith": [
     "nicole_human",
     "celestine",
     "ever",
     "god",
     "may",
     "zeus"
    ]
   },
   {
    "channel": "human-lachesis",
    "passages": 8,
    "share": 0.0258,
    "first": "2024-09-13",
    "last": "2024-09-20",
    "kind": "route",
    "castWith": [
     "nicole_human",
     "brax",
     "lachesis",
     "lance",
     "vaughn",
     "rowan",
     "god",
     "alyce_char",
     "moros",
     "ford",
     "atropos",
     "cruz"
    ]
   },
   {
    "channel": "fantastical-ezra",
    "passages": 8,
    "share": 0.0258,
    "first": "2025-02-20",
    "last": "2025-03-04",
    "kind": "route",
    "castWith": [
     "ezra",
     "dillon",
     "kaleb",
     "apollo",
     "kya_sg3",
     "james",
     "sebastian_vamp",
     "evelyn",
     "kya_sg1",
     "sebastian_siren",
     "skipper",
     "polly"
    ]
   },
   {
    "channel": "haley-finds-out-shes-cool-2",
    "passages": 6,
    "share": 0.0194,
    "first": "2022-11-28",
    "last": "2022-12-05",
    "kind": "route",
    "castWith": [
     "moros",
     "atropos",
     "gracie",
     "jinko",
     "lance",
     "may",
     "lachesis",
     "athena",
     "clothos",
     "haley_wolf",
     "peter",
     "apollo"
    ]
   },
   {
    "channel": "starry-night",
    "passages": 6,
    "share": 0.0194,
    "first": "2025-07-03",
    "last": "2025-07-13",
    "kind": "route",
    "castWith": [
     "adrien",
     "haley_wolf",
     "haley_sg3",
     "dillon",
     "jack",
     "may"
    ]
   },
   {
    "channel": "reincarnation-with-alistair",
    "passages": 6,
    "share": 0.0194,
    "first": "2025-02-05",
    "last": "2025-02-13",
    "kind": "route",
    "castWith": [
     "james",
     "dillon",
     "alistair",
     "alistair_turayne",
     "kya_sg3",
     "sebastian_vamp",
     "kya_sg1",
     "evelyn",
     "val",
     "sebastian_siren",
     "athena",
     "junta"
    ]
   },
   {
    "channel": "wtf-happened",
    "passages": 6,
    "share": 0.0194,
    "first": "2023-08-08",
    "last": "2023-08-17",
    "kind": "route",
    "castWith": [
     "apollo",
     "cupid_eros",
     "moros",
     "atropos",
     "alistair",
     "alistair_turayne",
     "haley_wolf",
     "lachesis",
     "aphrodite",
     "zeus",
     "ezra",
     "god"
    ]
   },
   {
    "channel": "alistares-at-his-phone-in-confusion",
    "passages": 5,
    "share": 0.0161,
    "first": "2024-06-10",
    "last": "2024-06-29",
    "kind": "route",
    "castWith": [
     "tate",
     "alistair",
     "alistair_turayne",
     "ezra"
    ]
   },
   {
    "channel": "haleys-wish",
    "passages": 5,
    "share": 0.0161,
    "first": "2023-04-26",
    "last": "2023-04-26",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "evelyn",
     "sebastian_siren",
     "kya_sg1",
     "sebastian_vamp",
     "polly",
     "cruz",
     "dimitri",
     "haley_wolf",
     "haley_sg3",
     "skipper",
     "kaleb"
    ]
   }
  ],
  "knownCharacters": [
   "alistair_turayne",
   "alistair",
   "apollo",
   "nicole_human",
   "ezra",
   "raye",
   "james",
   "atropos",
   "hades",
   "beatrice",
   "cruz",
   "haley_wolf"
  ]
 },
 "nicole_human": {
  "canonRoute": "human-lachesis",
  "totalPassages": 475,
  "routes": [
   {
    "channel": "human-lachesis",
    "passages": 196,
    "share": 0.4126,
    "first": "2024-09-12",
    "last": "2024-11-22",
    "kind": "canon",
    "castWith": [
     "brax",
     "lachesis",
     "lance",
     "vaughn",
     "rowan",
     "god",
     "alyce_char",
     "moros",
     "ford",
     "atropos",
     "cruz",
     "nicole_wolf"
    ]
   },
   {
    "channel": "lance-mating",
    "passages": 26,
    "share": 0.0547,
    "first": "2021-08-18",
    "last": "2021-09-24",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "clothos",
     "ryder",
     "hades",
     "nolan",
     "audrey",
     "moros",
     "atropos",
     "nicole_wolf",
     "nicole_sg3"
    ]
   },
   {
    "channel": "alistair-x-human-kya",
    "passages": 25,
    "share": 0.0526,
    "first": "2020-08-02",
    "last": "2020-08-12",
    "kind": "route",
    "castWith": [
     "haley_human",
     "alistair_turayne",
     "alistair",
     "apollo",
     "ezra",
     "raye",
     "james",
     "atropos",
     "hades",
     "beatrice",
     "cruz",
     "haley_wolf"
    ]
   },
   {
    "channel": "nicole-x-cruz",
    "passages": 17,
    "share": 0.0358,
    "first": "2020-08-28",
    "last": "2021-02-17",
    "kind": "route",
    "castWith": [
     "otto",
     "cruz",
     "jones",
     "duran",
     "sorsha",
     "kya_sg1",
     "lucifer",
     "nicole_wolf",
     "kya_sg3",
     "nicole_sg3",
     "christopher_donovan",
     "jonathan_donovan"
    ]
   },
   {
    "channel": "Ford",
    "passages": 17,
    "share": 0.0358,
    "first": "2026-04-07",
    "last": "2026-04-12",
    "kind": "route",
    "castWith": [
     "ford",
     "cruz",
     "trix",
     "nolan",
     "alyce_char",
     "ryder",
     "richard_antore",
     "bryce",
     "allie",
     "diana",
     "audrey",
     "nicole_wolf"
    ]
   },
   {
    "channel": "nicoles-wish-brax-brother",
    "passages": 15,
    "share": 0.0316,
    "first": "2023-04-26",
    "last": "2023-07-29",
    "kind": "route",
    "castWith": [
     "ford",
     "cruz",
     "brax",
     "lance",
     "dimitri",
     "hades",
     "vaughn",
     "rowan",
     "audrey",
     "diana",
     "evelyn",
     "nicole_wolf"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 13,
    "share": 0.0274,
    "first": "2024-01-27",
    "last": "2025-02-20",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "ryder",
     "ford",
     "vaughn",
     "lance",
     "bryce",
     "shane",
     "dimitri",
     "allie",
     "micah",
     "audrey"
    ]
   },
   {
    "channel": "AU: Ford Steele \u2014 Branched at msg 89/600 (5/1/2026) (branched at msg 638)",
    "passages": 13,
    "share": 0.0274,
    "first": "2026-05-03",
    "last": "2026-05-11",
    "kind": "au",
    "castWith": [
     "ford",
     "cruz",
     "ryder",
     "audrey",
     "nolan",
     "may",
     "haley_human",
     "diana",
     "porscha_steele",
     "evelyn",
     "dimitri",
     "aaron"
    ]
   },
   {
    "channel": "Lindon + Ford",
    "passages": 13,
    "share": 0.0274,
    "first": "2026-05-20",
    "last": "2026-05-23",
    "kind": "route",
    "castWith": [
     "ford",
     "lindon",
     "tim",
     "dante",
     "felix_fairy",
     "park",
     "nicole_wolf",
     "nicole_sg3",
     "ben",
     "may",
     "will",
     "ezra"
    ]
   },
   {
    "channel": "cruz-x-nicole",
    "passages": 12,
    "share": 0.0253,
    "first": "2020-08-05",
    "last": "2020-08-19",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "hermes",
     "audrey",
     "peter",
     "ares",
     "nicole_wolf",
     "nicole_sg3",
     "alyce_char",
     "red",
     "trix",
     "moros"
    ]
   },
   {
    "channel": "cruz-nicole-dollar-store",
    "passages": 11,
    "share": 0.0232,
    "first": "2020-09-08",
    "last": "2020-09-15",
    "kind": "route",
    "castWith": [
     "cruz",
     "raz",
     "lance",
     "lachesis",
     "bryce",
     "nolan",
     "renee",
     "aphrodite",
     "clothos",
     "atropos",
     "nicole_wolf",
     "nicole_sg3"
    ]
   },
   {
    "channel": "daddy-lindon-hates-brax",
    "passages": 11,
    "share": 0.0232,
    "first": "2025-05-02",
    "last": "2025-05-14",
    "kind": "route",
    "castWith": [
     "ben",
     "lindon",
     "brax",
     "vaughn",
     "ezra",
     "will",
     "nicole_wolf",
     "nicole_sg3",
     "ace"
    ]
   }
  ],
  "knownCharacters": [
   "brax",
   "lachesis",
   "lance",
   "vaughn",
   "rowan",
   "god",
   "alyce_char",
   "moros",
   "ford",
   "atropos",
   "cruz",
   "nicole_wolf"
  ]
 },
 "nicole_wolf": {
  "canonRoute": "cruz-x-nicole",
  "totalPassages": 126,
  "routes": [
   {
    "channel": "cruz-x-nicole",
    "passages": 24,
    "share": 0.1905,
    "first": "2020-08-05",
    "last": "2020-08-22",
    "kind": "canon",
    "castWith": [
     "cruz",
     "lance",
     "hermes",
     "audrey",
     "peter",
     "ares",
     "nicole_sg3",
     "alyce_char",
     "red",
     "trix",
     "nicole_human",
     "moros"
    ]
   },
   {
    "channel": "cruz-nicole-dollar-store",
    "passages": 14,
    "share": 0.1111,
    "first": "2020-09-10",
    "last": "2020-09-14",
    "kind": "route",
    "castWith": [
     "cruz",
     "raz",
     "lance",
     "lachesis",
     "bryce",
     "nolan",
     "renee",
     "aphrodite",
     "clothos",
     "atropos",
     "nicole_sg3",
     "moros"
    ]
   },
   {
    "channel": "lance-mating",
    "passages": 12,
    "share": 0.0952,
    "first": "2021-08-24",
    "last": "2021-09-15",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "clothos",
     "ryder",
     "hades",
     "nolan",
     "nicole_human",
     "audrey",
     "moros",
     "atropos",
     "nicole_sg3"
    ]
   },
   {
    "channel": "human-lachesis",
    "passages": 11,
    "share": 0.0873,
    "first": "2024-10-15",
    "last": "2024-11-13",
    "kind": "route",
    "castWith": [
     "nicole_human",
     "brax",
     "lachesis",
     "lance",
     "vaughn",
     "rowan",
     "god",
     "alyce_char",
     "moros",
     "ford",
     "atropos",
     "cruz"
    ]
   },
   {
    "channel": "nicoles-wish-brax-brother",
    "passages": 10,
    "share": 0.0794,
    "first": "2023-04-26",
    "last": "2023-06-15",
    "kind": "route",
    "castWith": [
     "ford",
     "cruz",
     "brax",
     "lance",
     "dimitri",
     "hades",
     "vaughn",
     "rowan",
     "nicole_human",
     "audrey",
     "diana",
     "evelyn"
    ]
   },
   {
    "channel": "lance-nicole-2",
    "passages": 9,
    "share": 0.0714,
    "first": "2022-11-28",
    "last": "2022-12-15",
    "kind": "route",
    "castWith": [
     "brax",
     "vaughn",
     "lance",
     "jenning",
     "cruz",
     "lachesis",
     "nicole_human",
     "nicole_sg3",
     "clothos",
     "atropos",
     "rowan",
     "roman"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 8,
    "share": 0.0635,
    "first": "2024-01-23",
    "last": "2025-02-11",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "ryder",
     "ford",
     "vaughn",
     "lance",
     "bryce",
     "shane",
     "dimitri",
     "allie",
     "micah",
     "audrey"
    ]
   },
   {
    "channel": "nicole-x-cruz",
    "passages": 4,
    "share": 0.0317,
    "first": "2020-09-02",
    "last": "2020-09-04",
    "kind": "route",
    "castWith": [
     "otto",
     "cruz",
     "jones",
     "nicole_human",
     "duran",
     "sorsha",
     "kya_sg1",
     "lucifer",
     "kya_sg3",
     "nicole_sg3",
     "christopher_donovan",
     "jonathan_donovan"
    ]
   },
   {
    "channel": "lance-origin-route",
    "passages": 3,
    "share": 0.0238,
    "first": "2021-05-26",
    "last": "2021-05-26",
    "kind": "route",
    "castWith": [
     "lance",
     "lachesis",
     "clothos",
     "nicole_human",
     "ryder",
     "moros",
     "atropos",
     "god",
     "nicole_sg3",
     "hades",
     "haley_human",
     "cruz"
    ]
   },
   {
    "channel": "reunited-with-vaughn",
    "passages": 3,
    "share": 0.0238,
    "first": "2025-05-27",
    "last": "2025-06-03",
    "kind": "route",
    "castWith": [
     "vaughn",
     "brax",
     "nicole_human",
     "lindon",
     "nicole_sg3",
     "ben",
     "moros",
     "ezra",
     "parks",
     "will"
    ]
   },
   {
    "channel": "nicolexcruz-true-mates",
    "passages": 3,
    "share": 0.0238,
    "first": "2024-03-19",
    "last": "2024-03-19",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "nolan",
     "clothos",
     "trix",
     "diana",
     "nicole_human",
     "audrey",
     "asrius",
     "lucifer",
     "atropos"
    ]
   },
   {
    "channel": "nicole-werewolf-fanfic",
    "passages": 3,
    "share": 0.0238,
    "first": "2020-08-06",
    "last": "2020-08-08",
    "kind": "au",
    "castWith": [
     "nicole_sg3",
     "haley_wolf",
     "haley_sg3"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "lance",
   "hermes",
   "audrey",
   "peter",
   "ares",
   "nicole_sg3",
   "alyce_char",
   "red",
   "trix",
   "nicole_human",
   "moros"
  ]
 },
 "aaron": {
  "canonRoute": "teacher-dormitory",
  "totalPassages": 337,
  "routes": [
   {
    "channel": "teacher-dormitory",
    "passages": 98,
    "share": 0.2908,
    "first": "2020-06-10",
    "last": "2020-06-30",
    "kind": "canon",
    "castWith": [
     "kya_sg3",
     "evelyn",
     "kya_sg1",
     "rex",
     "sebastian_siren",
     "sebastian_vamp",
     "kaleb",
     "dimitri",
     "cupid_eros",
     "boko",
     "mr_han_sr"
    ]
   },
   {
    "channel": "aaron-haley",
    "passages": 81,
    "share": 0.2404,
    "first": "2023-01-13",
    "last": "2023-01-25",
    "kind": "route",
    "castWith": [
     "haley_human",
     "lula",
     "kya_sg3",
     "rowan",
     "kya_sg1",
     "trev",
     "god",
     "may"
    ]
   },
   {
    "channel": "kya-seb-nice-uncle",
    "passages": 53,
    "share": 0.1573,
    "first": "2025-12-24",
    "last": "2026-01-20",
    "kind": "route",
    "castWith": [
     "dillon",
     "kaleb",
     "kyo",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "polly",
     "evelyn",
     "sebastian_vamp",
     "frau",
     "ami",
     "may"
    ]
   },
   {
    "channel": "school-gym",
    "passages": 22,
    "share": 0.0653,
    "first": "2020-06-08",
    "last": "2020-06-10",
    "kind": "route",
    "castWith": [
     "evelyn",
     "rex",
     "diana",
     "milo",
     "kya_sg3",
     "kya_sg1",
     "roman",
     "dike",
     "frau",
     "dimitri",
     "sebastian_vamp",
     "raye"
    ]
   },
   {
    "channel": "misc",
    "passages": 18,
    "share": 0.0534,
    "first": "2020-06-08",
    "last": "2020-06-08",
    "kind": "route",
    "castWith": [
     "rowan",
     "evelyn",
     "kya_sg3",
     "kya_sg1",
     "lucius",
     "sabrina_witch",
     "sebastian_vamp",
     "sebastian_siren",
     "rex",
     "cupid_eros",
     "george_campbell",
     "nellie"
    ]
   },
   {
    "channel": "kinley-reset-route",
    "passages": 14,
    "share": 0.0415,
    "first": "2022-02-27",
    "last": "2022-03-04",
    "kind": "route",
    "castWith": [
     "kinley",
     "lander",
     "shadow",
     "tate",
     "raye",
     "zain_demigod",
     "natalia",
     "apollo",
     "crom",
     "god",
     "jova",
     "aphrodite"
    ]
   },
   {
    "channel": "kinley-story",
    "passages": 13,
    "share": 0.0386,
    "first": "2022-03-20",
    "last": "2022-03-23",
    "kind": "route",
    "castWith": [
     "kinley",
     "octa",
     "haley_human"
    ]
   },
   {
    "channel": "ooc",
    "passages": 10,
    "share": 0.0297,
    "first": "2020-06-07",
    "last": "2020-12-15",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "dining-hall",
    "passages": 9,
    "share": 0.0267,
    "first": "2020-06-08",
    "last": "2020-06-08",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "bryce",
     "rex",
     "milo",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "lex",
     "sebastian_vamp",
     "dike",
     "agnar"
    ]
   },
   {
    "channel": "staff-break-room",
    "passages": 6,
    "share": 0.0178,
    "first": "2020-06-08",
    "last": "2020-06-08",
    "kind": "route",
    "castWith": [
     "dimitri",
     "rex",
     "evelyn",
     "saph",
     "diana",
     "kiro",
     "milo",
     "skipper",
     "roman",
     "sebastian_vamp",
     "kya_sg3",
     "sebastian_siren"
    ]
   },
   {
    "channel": "weresirens",
    "passages": 5,
    "share": 0.0148,
    "first": "2023-04-22",
    "last": "2023-04-24",
    "kind": "route",
    "castWith": [
     "james",
     "dillon",
     "sebastian_vamp",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren"
    ]
   },
   {
    "channel": "general",
    "passages": 3,
    "share": 0.0089,
    "first": "2020-08-19",
    "last": "2020-08-19",
    "kind": "ooc",
    "castWith": [
     "ezra",
     "eric",
     "cruz",
     "james",
     "apollo",
     "lance",
     "silas_mirace",
     "raye",
     "moros",
     "ace",
     "kaleb",
     "hermes"
    ]
   }
  ],
  "knownCharacters": [
   "kya_sg3",
   "evelyn",
   "kya_sg1",
   "rex",
   "sebastian_siren",
   "sebastian_vamp",
   "kaleb",
   "dimitri",
   "cupid_eros",
   "boko",
   "mr_han_sr"
  ]
 },
 "trey": {
  "canonRoute": "kya-werewolf",
  "totalPassages": 70,
  "routes": [
   {
    "channel": "kya-werewolf",
    "passages": 70,
    "share": 1.0,
    "first": "2021-08-17",
    "last": "2021-09-15",
    "kind": "canon",
    "castWith": [
     "jace",
     "raphael",
     "dillon",
     "kya_sg3",
     "scott",
     "kya_sg1",
     "ezra",
     "sebastian_siren",
     "kaleb",
     "sebastian_vamp",
     "evelyn",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "jace",
   "raphael",
   "dillon",
   "kya_sg3",
   "scott",
   "kya_sg1",
   "ezra",
   "sebastian_siren",
   "kaleb",
   "sebastian_vamp",
   "evelyn",
   "will"
  ]
 },
 "kinley": {
  "canonRoute": "kinley-reset-route",
  "totalPassages": 100,
  "routes": [
   {
    "channel": "kinley-reset-route",
    "passages": 46,
    "share": 0.46,
    "first": "2022-02-17",
    "last": "2022-03-04",
    "kind": "canon",
    "castWith": [
     "lander",
     "shadow",
     "tate",
     "aaron",
     "raye",
     "zain_demigod",
     "natalia",
     "apollo",
     "crom",
     "god",
     "jova",
     "aphrodite"
    ]
   },
   {
    "channel": "kinley-is-a-nondecisive-butt",
    "passages": 42,
    "share": 0.42,
    "first": "2022-03-24",
    "last": "2022-04-09",
    "kind": "route",
    "castWith": [
     "zain_demigod",
     "apollo",
     "lex",
     "cupid_eros",
     "hera",
     "lachesis",
     "sebastian_vamp",
     "sebastian_siren",
     "ben",
     "god",
     "will",
     "zeus"
    ]
   },
   {
    "channel": "kinley-story",
    "passages": 10,
    "share": 0.1,
    "first": "2022-03-21",
    "last": "2022-03-23",
    "kind": "route",
    "castWith": [
     "aaron",
     "octa",
     "haley_human"
    ]
   },
   {
    "channel": "natalia-reset-route",
    "passages": 2,
    "share": 0.02,
    "first": "2022-02-17",
    "last": "2022-02-19",
    "kind": "route",
    "castWith": [
     "natalia",
     "darren",
     "parks",
     "god",
     "lucifer",
     "may"
    ]
   }
  ],
  "knownCharacters": [
   "lander",
   "shadow",
   "tate",
   "aaron",
   "raye",
   "zain_demigod",
   "natalia",
   "apollo",
   "crom",
   "god",
   "jova",
   "aphrodite"
  ]
 },
 "kya_sg3": {
  "canonRoute": "siren-places",
  "totalPassages": 2493,
  "routes": [
   {
    "channel": "siren-places",
    "passages": 233,
    "share": 0.0935,
    "first": "2020-06-30",
    "last": "2020-07-23",
    "kind": "canon",
    "castWith": [
     "sebastian_vamp",
     "sebastian_siren",
     "kya_sg1",
     "polly",
     "kaleb",
     "evelyn",
     "ever",
     "midori_naga",
     "skipper",
     "kyo"
    ]
   },
   {
    "channel": "val",
    "passages": 144,
    "share": 0.0578,
    "first": "2020-04-15",
    "last": "2020-12-27",
    "kind": "route",
    "castWith": [
     "val",
     "kaleb",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "evelyn",
     "vanessa",
     "ezra",
     "raye",
     "alan",
     "tyrion",
     "mr_han_sr"
    ]
   },
   {
    "channel": "brothel",
    "passages": 93,
    "share": 0.0373,
    "first": "2020-04-18",
    "last": "2020-04-28",
    "kind": "route",
    "castWith": [
     "ezra",
     "evelyn",
     "rowan",
     "kya_sg1",
     "primrose",
     "lily",
     "kaleb",
     "nellie",
     "lissa",
     "raye",
     "ace",
     "mr_han_sr"
    ]
   },
   {
    "channel": "dorms",
    "passages": 84,
    "share": 0.0337,
    "first": "2020-04-29",
    "last": "2020-05-18",
    "kind": "route",
    "castWith": [
     "agnar",
     "agmund",
     "evelyn",
     "raye",
     "cole",
     "kya_sg1",
     "riku",
     "kaleb",
     "penelope_valk",
     "loki",
     "svira",
     "darren"
    ]
   },
   {
    "channel": "kya-college-2",
    "passages": 69,
    "share": 0.0277,
    "first": "2020-12-27",
    "last": "2021-01-28",
    "kind": "route",
    "castWith": [
     "lily",
     "zander",
     "kya_sg1",
     "ari",
     "sebastian_siren",
     "raye",
     "prince_zed",
     "sebastian_vamp",
     "midori_naga",
     "penelope_valk",
     "bell_lily_of_fell",
     "agnar"
    ]
   },
   {
    "channel": "kaleb-kya-finally",
    "passages": 61,
    "share": 0.0245,
    "first": "2021-02-06",
    "last": "2021-02-17",
    "kind": "route",
    "castWith": [
     "kaleb",
     "kya_sg1",
     "evelyn",
     "sebastian_siren",
     "sebastian_vamp",
     "apollo",
     "gabs",
     "uncle_khan",
     "alexander",
     "dimitri",
     "kyo",
     "ami"
    ]
   },
   {
    "channel": "meeting-room",
    "passages": 61,
    "share": 0.0245,
    "first": "2020-03-26",
    "last": "2020-07-31",
    "kind": "route",
    "castWith": [
     "kaleb",
     "ezra",
     "raye",
     "evelyn",
     "alistair_turayne",
     "alistair",
     "mr_han_sr",
     "kya_sg1",
     "thorne",
     "prince_zain",
     "sune",
     "yuri_rekovich"
    ]
   },
   {
    "channel": "siren-raye",
    "passages": 60,
    "share": 0.0241,
    "first": "2023-10-16",
    "last": "2023-10-25",
    "kind": "route",
    "castWith": [
     "raye",
     "kya_sg1",
     "sebastian_vamp",
     "sebastian_siren",
     "apollo",
     "aphrodite",
     "kaleb",
     "cupid_eros",
     "hermes",
     "ezra",
     "ares",
     "may"
    ]
   },
   {
    "channel": "not-a-landbond-route",
    "passages": 56,
    "share": 0.0225,
    "first": "2021-12-21",
    "last": "2022-01-28",
    "kind": "route",
    "castWith": [
     "kya_sg1",
     "sebastian_siren",
     "evelyn",
     "sebastian_vamp",
     "ezra",
     "jack",
     "raye",
     "kaleb",
     "alistair",
     "alistair_turayne",
     "uncle_khan",
     "polly"
    ]
   },
   {
    "channel": "super-siren-cruise-ship",
    "passages": 46,
    "share": 0.0185,
    "first": "2023-07-24",
    "last": "2023-08-03",
    "kind": "route",
    "castWith": [
     "kya_sg1",
     "sebastian_vamp",
     "sebastian_siren",
     "evelyn",
     "kaleb",
     "dillon",
     "ezra",
     "raye",
     "uncle_khan",
     "alistair",
     "alistair_turayne",
     "aaron"
    ]
   },
   {
    "channel": "kyas_penthouse",
    "passages": 44,
    "share": 0.0176,
    "first": "2016-09-10",
    "last": "2020-03-29",
    "kind": "route",
    "castWith": [
     "kaleb",
     "evelyn",
     "raye",
     "ezra",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "mr_han_sr",
     "bryce",
     "god",
     "cruz",
     "will"
    ]
   },
   {
    "channel": "kya-war-au",
    "passages": 43,
    "share": 0.0172,
    "first": "2021-11-24",
    "last": "2021-12-06",
    "kind": "au",
    "castWith": [
     "ezra",
     "james",
     "val",
     "kya_sg1",
     "vanessa",
     "kaleb",
     "raye",
     "sebastian_vamp",
     "sebastian_siren",
     "lily",
     "junta",
     "evelyn"
    ]
   }
  ],
  "knownCharacters": [
   "sebastian_vamp",
   "sebastian_siren",
   "kya_sg1",
   "polly",
   "kaleb",
   "evelyn",
   "ever",
   "midori_naga",
   "skipper",
   "kyo"
  ]
 },
 "haley_sg3": {
  "canonRoute": "the-werewolf-harem-bandwagon",
  "totalPassages": 34,
  "routes": [
   {
    "channel": "the-werewolf-harem-bandwagon",
    "passages": 5,
    "share": 0.1471,
    "first": "2022-12-09",
    "last": "2022-12-14",
    "kind": "canon",
    "castWith": [
     "declan",
     "koda",
     "haley_wolf",
     "diana",
     "god",
     "may",
     "mia"
    ]
   },
   {
    "channel": "haleys-alistair-wish",
    "passages": 4,
    "share": 0.1176,
    "first": "2023-05-01",
    "last": "2023-05-09",
    "kind": "route",
    "castWith": [
     "ezra",
     "evelyn",
     "alistair_turayne",
     "alistair",
     "raye",
     "kaleb",
     "james",
     "dimitri",
     "haley_wolf",
     "uncle_khan",
     "haley_human",
     "bryce"
    ]
   },
   {
    "channel": "haleys-wish",
    "passages": 3,
    "share": 0.0882,
    "first": "2023-04-26",
    "last": "2023-04-26",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "evelyn",
     "sebastian_siren",
     "kya_sg1",
     "sebastian_vamp",
     "haley_human",
     "polly",
     "cruz",
     "dimitri",
     "haley_wolf",
     "skipper",
     "kaleb"
    ]
   },
   {
    "channel": "haley-is-haley",
    "passages": 3,
    "share": 0.0882,
    "first": "2024-01-22",
    "last": "2024-01-30",
    "kind": "route",
    "castWith": [
     "alva",
     "moros",
     "atropos",
     "nolan",
     "alyce_char",
     "haley_wolf",
     "lachesis",
     "ryder",
     "drey",
     "bryce",
     "apollo",
     "cruz"
    ]
   },
   {
    "channel": "lance-nicole-2",
    "passages": 2,
    "share": 0.0588,
    "first": "2022-11-26",
    "last": "2022-11-28",
    "kind": "route",
    "castWith": [
     "brax",
     "vaughn",
     "lance",
     "jenning",
     "cruz",
     "lachesis",
     "nicole_human",
     "nicole_wolf",
     "nicole_sg3",
     "clothos",
     "atropos",
     "rowan"
    ]
   },
   {
    "channel": "haley-nolan",
    "passages": 2,
    "share": 0.0588,
    "first": "2020-09-10",
    "last": "2020-09-11",
    "kind": "route",
    "castWith": [
     "nolan",
     "charlie",
     "alistair",
     "alistair_turayne",
     "caroline",
     "alyce_char",
     "ryder",
     "cruz",
     "moros",
     "lachesis",
     "renee",
     "clothos"
    ]
   },
   {
    "channel": "cruz-nicole-dollar-store",
    "passages": 2,
    "share": 0.0588,
    "first": "2020-09-08",
    "last": "2020-09-11",
    "kind": "route",
    "castWith": [
     "cruz",
     "raz",
     "lance",
     "lachesis",
     "bryce",
     "nolan",
     "renee",
     "aphrodite",
     "clothos",
     "atropos",
     "nicole_wolf",
     "nicole_sg3"
    ]
   },
   {
    "channel": "nicole-werewolf-fanfic",
    "passages": 2,
    "share": 0.0588,
    "first": "2020-08-06",
    "last": "2020-08-08",
    "kind": "au",
    "castWith": [
     "nicole_wolf",
     "nicole_sg3",
     "haley_wolf"
    ]
   },
   {
    "channel": "the-wish-starter",
    "passages": 1,
    "share": 0.0294,
    "first": "2023-04-25",
    "last": "2023-04-25",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "nicole_wolf",
     "nicole_sg3",
     "haley_wolf",
     "haley_human",
     "nicole_human"
    ]
   },
   {
    "channel": "almost-kya-x-sebastian",
    "passages": 1,
    "share": 0.0294,
    "first": "2020-11-02",
    "last": "2020-11-02",
    "kind": "route",
    "castWith": [
     "sebastian_siren",
     "sebastian_vamp",
     "polly",
     "kya_sg3",
     "kya_sg1",
     "evelyn",
     "ethan",
     "haley_human",
     "alistair",
     "ezra",
     "haley_wolf",
     "miya"
    ]
   },
   {
    "channel": "pos-brax-food-wine-route",
    "passages": 1,
    "share": 0.0294,
    "first": "2024-05-08",
    "last": "2024-05-08",
    "kind": "route",
    "castWith": [
     "brax",
     "vaughn",
     "nicole_human",
     "haley_wolf",
     "nicole_wolf",
     "nicole_sg3",
     "diana",
     "god",
     "may"
    ]
   },
   {
    "channel": "1-declan-only",
    "passages": 1,
    "share": 0.0294,
    "first": "2023-01-11",
    "last": "2023-01-11",
    "kind": "route",
    "castWith": [
     "declan",
     "haley_wolf",
     "noah",
     "koda",
     "diana",
     "hercules"
    ]
   }
  ],
  "knownCharacters": [
   "declan",
   "koda",
   "haley_wolf",
   "diana",
   "god",
   "may",
   "mia"
  ]
 },
 "nicole_sg3": {
  "canonRoute": "cruz-x-nicole",
  "totalPassages": 126,
  "routes": [
   {
    "channel": "cruz-x-nicole",
    "passages": 24,
    "share": 0.1905,
    "first": "2020-08-05",
    "last": "2020-08-22",
    "kind": "canon",
    "castWith": [
     "cruz",
     "lance",
     "hermes",
     "audrey",
     "peter",
     "ares",
     "nicole_wolf",
     "alyce_char",
     "red",
     "trix",
     "nicole_human",
     "moros"
    ]
   },
   {
    "channel": "cruz-nicole-dollar-store",
    "passages": 14,
    "share": 0.1111,
    "first": "2020-09-10",
    "last": "2020-09-14",
    "kind": "route",
    "castWith": [
     "cruz",
     "raz",
     "lance",
     "lachesis",
     "bryce",
     "nolan",
     "renee",
     "aphrodite",
     "clothos",
     "atropos",
     "nicole_wolf",
     "moros"
    ]
   },
   {
    "channel": "lance-mating",
    "passages": 12,
    "share": 0.0952,
    "first": "2021-08-24",
    "last": "2021-09-15",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "clothos",
     "ryder",
     "hades",
     "nolan",
     "nicole_human",
     "audrey",
     "moros",
     "atropos",
     "nicole_wolf"
    ]
   },
   {
    "channel": "human-lachesis",
    "passages": 11,
    "share": 0.0873,
    "first": "2024-10-15",
    "last": "2024-11-13",
    "kind": "route",
    "castWith": [
     "nicole_human",
     "brax",
     "lachesis",
     "lance",
     "vaughn",
     "rowan",
     "god",
     "alyce_char",
     "moros",
     "ford",
     "atropos",
     "cruz"
    ]
   },
   {
    "channel": "nicoles-wish-brax-brother",
    "passages": 10,
    "share": 0.0794,
    "first": "2023-04-26",
    "last": "2023-06-15",
    "kind": "route",
    "castWith": [
     "ford",
     "cruz",
     "brax",
     "lance",
     "dimitri",
     "hades",
     "vaughn",
     "rowan",
     "nicole_human",
     "audrey",
     "diana",
     "evelyn"
    ]
   },
   {
    "channel": "lance-nicole-2",
    "passages": 9,
    "share": 0.0714,
    "first": "2022-11-28",
    "last": "2022-12-15",
    "kind": "route",
    "castWith": [
     "brax",
     "vaughn",
     "lance",
     "jenning",
     "cruz",
     "lachesis",
     "nicole_human",
     "nicole_wolf",
     "clothos",
     "atropos",
     "rowan",
     "roman"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 8,
    "share": 0.0635,
    "first": "2024-01-23",
    "last": "2025-02-11",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "ryder",
     "ford",
     "vaughn",
     "lance",
     "bryce",
     "shane",
     "dimitri",
     "allie",
     "micah",
     "audrey"
    ]
   },
   {
    "channel": "nicole-x-cruz",
    "passages": 4,
    "share": 0.0317,
    "first": "2020-09-02",
    "last": "2020-09-04",
    "kind": "route",
    "castWith": [
     "otto",
     "cruz",
     "jones",
     "nicole_human",
     "duran",
     "sorsha",
     "kya_sg1",
     "lucifer",
     "nicole_wolf",
     "kya_sg3",
     "christopher_donovan",
     "jonathan_donovan"
    ]
   },
   {
    "channel": "lance-origin-route",
    "passages": 3,
    "share": 0.0238,
    "first": "2021-05-26",
    "last": "2021-05-26",
    "kind": "route",
    "castWith": [
     "lance",
     "lachesis",
     "clothos",
     "nicole_human",
     "ryder",
     "moros",
     "atropos",
     "god",
     "nicole_wolf",
     "hades",
     "haley_human",
     "cruz"
    ]
   },
   {
    "channel": "reunited-with-vaughn",
    "passages": 3,
    "share": 0.0238,
    "first": "2025-05-27",
    "last": "2025-06-03",
    "kind": "route",
    "castWith": [
     "vaughn",
     "brax",
     "nicole_human",
     "lindon",
     "nicole_wolf",
     "ben",
     "moros",
     "ezra",
     "parks",
     "will"
    ]
   },
   {
    "channel": "nicolexcruz-true-mates",
    "passages": 3,
    "share": 0.0238,
    "first": "2024-03-19",
    "last": "2024-03-19",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "nolan",
     "clothos",
     "trix",
     "diana",
     "nicole_human",
     "audrey",
     "asrius",
     "lucifer",
     "atropos"
    ]
   },
   {
    "channel": "nicole-werewolf-fanfic",
    "passages": 3,
    "share": 0.0238,
    "first": "2020-08-06",
    "last": "2020-08-08",
    "kind": "au",
    "castWith": [
     "nicole_wolf",
     "haley_wolf",
     "haley_sg3"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "lance",
   "hermes",
   "audrey",
   "peter",
   "ares",
   "nicole_wolf",
   "alyce_char",
   "red",
   "trix",
   "nicole_human",
   "moros"
  ]
 },
 "sebastian_siren": {
  "canonRoute": "siren-places",
  "totalPassages": 752,
  "routes": [
   {
    "channel": "siren-places",
    "passages": 244,
    "share": 0.3245,
    "first": "2020-06-30",
    "last": "2020-07-23",
    "kind": "canon",
    "castWith": [
     "sebastian_vamp",
     "kya_sg1",
     "kya_sg3",
     "polly",
     "kaleb",
     "evelyn",
     "ever",
     "midori_naga",
     "skipper",
     "kyo"
    ]
   },
   {
    "channel": "kya-college-2",
    "passages": 42,
    "share": 0.0559,
    "first": "2021-01-10",
    "last": "2021-01-28",
    "kind": "route",
    "castWith": [
     "lily",
     "zander",
     "kya_sg3",
     "kya_sg1",
     "ari",
     "raye",
     "prince_zed",
     "sebastian_vamp",
     "midori_naga",
     "penelope_valk",
     "bell_lily_of_fell",
     "agnar"
    ]
   },
   {
    "channel": "almost-kya-x-sebastian",
    "passages": 32,
    "share": 0.0426,
    "first": "2020-10-23",
    "last": "2020-11-02",
    "kind": "route",
    "castWith": [
     "sebastian_vamp",
     "polly",
     "kya_sg3",
     "kya_sg1",
     "evelyn",
     "ethan",
     "haley_human",
     "alistair",
     "ezra",
     "haley_wolf",
     "haley_sg3",
     "miya"
    ]
   },
   {
    "channel": "super-siren-cruise-ship",
    "passages": 30,
    "share": 0.0399,
    "first": "2023-07-24",
    "last": "2023-08-03",
    "kind": "route",
    "castWith": [
     "kya_sg1",
     "kya_sg3",
     "sebastian_vamp",
     "evelyn",
     "kaleb",
     "dillon",
     "ezra",
     "raye",
     "uncle_khan",
     "alistair",
     "alistair_turayne",
     "aaron"
    ]
   },
   {
    "channel": "siren-raye",
    "passages": 30,
    "share": 0.0399,
    "first": "2023-10-16",
    "last": "2023-10-25",
    "kind": "route",
    "castWith": [
     "raye",
     "kya_sg1",
     "kya_sg3",
     "sebastian_vamp",
     "apollo",
     "aphrodite",
     "kaleb",
     "cupid_eros",
     "hermes",
     "ezra",
     "ares",
     "may"
    ]
   },
   {
    "channel": "cutie-prince-dream",
    "passages": 26,
    "share": 0.0346,
    "first": "2022-07-13",
    "last": "2022-08-05",
    "kind": "route",
    "castWith": [
     "donnelly_macdonagh",
     "oliver_macdonagh",
     "kya_sg3",
     "kya_sg1",
     "sebastian_vamp",
     "raz",
     "dillon",
     "kaleb",
     "may",
     "atropos",
     "val",
     "vanessa"
    ]
   },
   {
    "channel": "kaleb-kya-finally",
    "passages": 20,
    "share": 0.0266,
    "first": "2021-02-12",
    "last": "2021-02-17",
    "kind": "route",
    "castWith": [
     "kaleb",
     "kya_sg3",
     "kya_sg1",
     "evelyn",
     "sebastian_vamp",
     "apollo",
     "gabs",
     "uncle_khan",
     "alexander",
     "dimitri",
     "kyo",
     "ami"
    ]
   },
   {
    "channel": "kya-war-au",
    "passages": 18,
    "share": 0.0239,
    "first": "2021-11-24",
    "last": "2021-12-02",
    "kind": "au",
    "castWith": [
     "ezra",
     "kya_sg3",
     "james",
     "val",
     "kya_sg1",
     "vanessa",
     "kaleb",
     "raye",
     "sebastian_vamp",
     "lily",
     "junta",
     "evelyn"
    ]
   },
   {
    "channel": "kya-senior-year",
    "passages": 17,
    "share": 0.0226,
    "first": "2021-06-14",
    "last": "2021-07-08",
    "kind": "route",
    "castWith": [
     "callan",
     "ezra",
     "leiden",
     "melody",
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "raye",
     "tate",
     "sebastian_vamp",
     "dillon",
     "evelyn"
    ]
   },
   {
    "channel": "aquarium-seb",
    "passages": 16,
    "share": 0.0213,
    "first": "2025-01-17",
    "last": "2025-02-02",
    "kind": "route",
    "castWith": [
     "sebastian_vamp",
     "skipper",
     "kya_sg3",
     "kya_sg1",
     "polly",
     "ezra",
     "dillon",
     "reed"
    ]
   },
   {
    "channel": "human-not-human",
    "passages": 16,
    "share": 0.0213,
    "first": "2022-10-15",
    "last": "2022-10-23",
    "kind": "route",
    "castWith": [
     "dillon",
     "kya_sg3",
     "kya_sg1",
     "sebastian_vamp",
     "drisella",
     "god",
     "blair",
     "madeline",
     "tanya",
     "topps",
     "starlet",
     "ever"
    ]
   },
   {
    "channel": "flirty-sebastian-immortuos",
    "passages": 13,
    "share": 0.0173,
    "first": "2021-12-16",
    "last": "2021-12-21",
    "kind": "route",
    "castWith": [
     "amelda",
     "sebastian_vamp",
     "kya_sg3",
     "kya_sg1",
     "aurelia",
     "crom",
     "may",
     "val",
     "kaleb",
     "james",
     "dillon"
    ]
   }
  ],
  "knownCharacters": [
   "sebastian_vamp",
   "kya_sg1",
   "kya_sg3",
   "polly",
   "kaleb",
   "evelyn",
   "ever",
   "midori_naga",
   "skipper",
   "kyo"
  ]
 },
 "noah": {
  "canonRoute": "2-noah-christmas-time",
  "totalPassages": 19,
  "routes": [
   {
    "channel": "2-noah-christmas-time",
    "passages": 17,
    "share": 0.8947,
    "first": "2022-12-26",
    "last": "2022-12-29",
    "kind": "canon",
    "castWith": [
     "dillon",
     "kya_sg1",
     "kya_sg3"
    ]
   },
   {
    "channel": "1-declan-only",
    "passages": 1,
    "share": 0.0526,
    "first": "2023-01-09",
    "last": "2023-01-09",
    "kind": "route",
    "castWith": [
     "declan",
     "haley_wolf",
     "haley_sg3",
     "koda",
     "diana",
     "hercules"
    ]
   },
   {
    "channel": "val",
    "passages": 1,
    "share": 0.0526,
    "first": "2020-04-16",
    "last": "2020-04-16",
    "kind": "route",
    "castWith": [
     "val",
     "kya_sg3",
     "kaleb",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "evelyn",
     "vanessa",
     "ezra",
     "raye",
     "alan",
     "tyrion"
    ]
   }
  ],
  "knownCharacters": [
   "dillon",
   "kya_sg1",
   "kya_sg3"
  ]
 },
 "cordelia": {
  "canonRoute": null,
  "routes": [],
  "knownCharacters": [],
  "totalPassages": 0
 },
 "reed": {
  "canonRoute": "reed-vamp-werecheetah",
  "totalPassages": 101,
  "routes": [
   {
    "channel": "reed-vamp-werecheetah",
    "passages": 65,
    "share": 0.6436,
    "first": "2023-11-11",
    "last": "2023-11-24",
    "kind": "canon",
    "castWith": [
     "madison_astor",
     "kale",
     "raye",
     "arnold_astor",
     "may",
     "paul",
     "xavier",
     "zeke"
    ]
   },
   {
    "channel": "rayes-bro",
    "passages": 34,
    "share": 0.3366,
    "first": "2023-10-25",
    "last": "2023-10-29",
    "kind": "route",
    "castWith": [
     "raye",
     "kya_sg3",
     "evelyn",
     "kaleb",
     "uncle_khan",
     "ezra",
     "dillon"
    ]
   },
   {
    "channel": "aquarium-seb",
    "passages": 1,
    "share": 0.0099,
    "first": "2025-01-18",
    "last": "2025-01-18",
    "kind": "route",
    "castWith": [
     "sebastian_siren",
     "sebastian_vamp",
     "skipper",
     "kya_sg3",
     "kya_sg1",
     "polly",
     "ezra",
     "dillon"
    ]
   },
   {
    "channel": "cruz-x-nicole",
    "passages": 1,
    "share": 0.0099,
    "first": "2020-08-18",
    "last": "2020-08-18",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "hermes",
     "audrey",
     "peter",
     "ares",
     "nicole_wolf",
     "nicole_sg3",
     "alyce_char",
     "red",
     "trix",
     "nicole_human"
    ]
   }
  ],
  "knownCharacters": [
   "madison_astor",
   "kale",
   "raye",
   "arnold_astor",
   "may",
   "paul",
   "xavier",
   "zeke"
  ]
 },
 "ace": {
  "canonRoute": "ace-route",
  "totalPassages": 416,
  "routes": [
   {
    "channel": "ace-route",
    "passages": 130,
    "share": 0.3125,
    "first": "2020-08-05",
    "last": "2020-08-28",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "ezra",
     "sebastian_vamp",
     "sebastian_siren",
     "kaleb",
     "kya_sg3",
     "kya_sg1",
     "felix_fairy",
     "mr_han_sr",
     "frau",
     "rosie",
     "will"
    ]
   },
   {
    "channel": "ww-war-au",
    "passages": 102,
    "share": 0.2452,
    "first": "2021-11-24",
    "last": "2021-12-15",
    "kind": "au",
    "castWith": [
     "evelyn",
     "cruz",
     "ezra",
     "lindon",
     "kaleb",
     "rowan",
     "bryce",
     "lance",
     "raye",
     "nolan",
     "primrose",
     "ryder"
    ]
   },
   {
    "channel": "indifference",
    "passages": 27,
    "share": 0.0649,
    "first": "2023-04-05",
    "last": "2024-04-28",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "alyce_char",
     "dimitri",
     "ryder",
     "rio",
     "moros",
     "geo",
     "nolan",
     "audrey",
     "lachesis"
    ]
   },
   {
    "channel": "haley-james-yessss",
    "passages": 26,
    "share": 0.0625,
    "first": "2020-08-14",
    "last": "2020-08-29",
    "kind": "route",
    "castWith": [
     "ezra",
     "james",
     "haley_human",
     "kaleb",
     "nicole_human",
     "primrose",
     "mr_han_sr",
     "evelyn",
     "lily",
     "haley_wolf",
     "haley_sg3",
     "aphrodite"
    ]
   },
   {
    "channel": "ooc",
    "passages": 22,
    "share": 0.0529,
    "first": "2020-04-25",
    "last": "2020-06-30",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "containment-cells",
    "passages": 21,
    "share": 0.0505,
    "first": "2020-04-21",
    "last": "2020-04-23",
    "kind": "route",
    "castWith": [
     "ezra",
     "evelyn",
     "kya_sg3",
     "rowan",
     "kya_sg1",
     "lira",
     "sebastian_vamp",
     "cruz",
     "sebastian_siren",
     "alistair",
     "alistair_turayne",
     "may"
    ]
   },
   {
    "channel": "vampire-ww-war",
    "passages": 16,
    "share": 0.0385,
    "first": "2025-04-15",
    "last": "2025-04-21",
    "kind": "route",
    "castWith": [
     "lindon",
     "rowan",
     "ezra",
     "evelyn",
     "ares",
     "cruz",
     "kaleb",
     "ever",
     "frau",
     "rikki"
    ]
   },
   {
    "channel": "lachesis-off-the-rails",
    "passages": 15,
    "share": 0.0361,
    "first": "2025-08-20",
    "last": "2025-08-29",
    "kind": "route",
    "castWith": [
     "lance",
     "vaughn",
     "brax",
     "lucifer",
     "james",
     "atropos",
     "cruz",
     "lachesis",
     "lindon",
     "hades",
     "ezra",
     "nicole_human"
    ]
   },
   {
    "channel": "tyrant-evie-runs-away",
    "passages": 6,
    "share": 0.0144,
    "first": "2022-01-25",
    "last": "2022-01-26",
    "kind": "route",
    "castWith": [
     "evelyn",
     "bryce",
     "aspen",
     "rio",
     "kaleb",
     "myra",
     "kya_sg3",
     "alistair",
     "alistair_turayne",
     "ezra",
     "rowan",
     "eva"
    ]
   },
   {
    "channel": "evel-icole-x-ethan",
    "passages": 6,
    "share": 0.0144,
    "first": "2020-11-02",
    "last": "2020-11-02",
    "kind": "route",
    "castWith": [
     "ezra",
     "evelyn",
     "ethan",
     "kaleb",
     "alistair",
     "alistair_turayne",
     "kya_sg3",
     "nicole_human",
     "zantium",
     "bryce",
     "mr_han_sr",
     "kya_sg1"
    ]
   },
   {
    "channel": "brothel",
    "passages": 6,
    "share": 0.0144,
    "first": "2020-04-21",
    "last": "2020-04-25",
    "kind": "route",
    "castWith": [
     "ezra",
     "evelyn",
     "rowan",
     "kya_sg3",
     "kya_sg1",
     "primrose",
     "lily",
     "kaleb",
     "nellie",
     "lissa",
     "raye",
     "mr_han_sr"
    ]
   },
   {
    "channel": "frau-collin",
    "passages": 4,
    "share": 0.0096,
    "first": "2020-11-15",
    "last": "2020-11-18",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "rowan",
     "frau",
     "collin_keller",
     "arland_rees",
     "ezra",
     "felix_fairy",
     "rikki",
     "park",
     "alyce_char",
     "myra"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "ezra",
   "sebastian_vamp",
   "sebastian_siren",
   "kaleb",
   "kya_sg3",
   "kya_sg1",
   "felix_fairy",
   "mr_han_sr",
   "frau",
   "rosie",
   "will"
  ]
 },
 "rowan": {
  "canonRoute": "northwest-pack-lodge",
  "totalPassages": 1111,
  "routes": [
   {
    "channel": "northwest-pack-lodge",
    "passages": 243,
    "share": 0.2187,
    "first": "2020-04-14",
    "last": "2020-04-29",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "lucius",
     "nellie",
     "myra",
     "cruz",
     "bryce",
     "will",
     "dimitri",
     "kaleb",
     "rio",
     "may",
     "mr_han_sr"
    ]
   },
   {
    "channel": "brothel",
    "passages": 161,
    "share": 0.1449,
    "first": "2020-04-22",
    "last": "2020-04-27",
    "kind": "route",
    "castWith": [
     "ezra",
     "evelyn",
     "kya_sg3",
     "kya_sg1",
     "primrose",
     "lily",
     "kaleb",
     "nellie",
     "lissa",
     "raye",
     "ace",
     "mr_han_sr"
    ]
   },
   {
    "channel": "ooc",
    "passages": 155,
    "share": 0.1395,
    "first": "2020-04-14",
    "last": "2020-12-26",
    "kind": "ooc",
    "castWith": [
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex",
     "agnar"
    ]
   },
   {
    "channel": "frau-collin",
    "passages": 99,
    "share": 0.0891,
    "first": "2020-04-15",
    "last": "2020-11-14",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "frau",
     "collin_keller",
     "arland_rees",
     "ezra",
     "felix_fairy",
     "rikki",
     "park",
     "alyce_char",
     "myra",
     "allie"
    ]
   },
   {
    "channel": "switched-roles-lachesis",
    "passages": 43,
    "share": 0.0387,
    "first": "2023-10-10",
    "last": "2023-10-21",
    "kind": "au",
    "castWith": [
     "lachesis",
     "ford",
     "god",
     "lucifer",
     "cruz",
     "clothos",
     "atropos",
     "vaughn",
     "ryder",
     "brax",
     "dimitri",
     "ramiel"
    ]
   },
   {
    "channel": "row-dimitri",
    "passages": 43,
    "share": 0.0387,
    "first": "2022-12-15",
    "last": "2022-12-20",
    "kind": "route",
    "castWith": [
     "dimitri",
     "evelyn",
     "myra",
     "kaleb",
     "ezra",
     "kya_sg3",
     "april"
    ]
   },
   {
    "channel": "ww-war-au",
    "passages": 41,
    "share": 0.0369,
    "first": "2021-11-18",
    "last": "2021-12-12",
    "kind": "au",
    "castWith": [
     "evelyn",
     "cruz",
     "ace",
     "ezra",
     "lindon",
     "kaleb",
     "bryce",
     "lance",
     "raye",
     "nolan",
     "primrose",
     "ryder"
    ]
   },
   {
    "channel": "amnesia-world",
    "passages": 32,
    "share": 0.0288,
    "first": "2025-03-13",
    "last": "2025-04-11",
    "kind": "route",
    "castWith": [
     "dimitri",
     "lance",
     "ford",
     "kaleb",
     "cruz",
     "brax",
     "vaughn",
     "ryder",
     "bryce",
     "nicole_human",
     "kya_sg3",
     "alex"
    ]
   },
   {
    "channel": "vampire-ww-war",
    "passages": 31,
    "share": 0.0279,
    "first": "2025-04-14",
    "last": "2025-04-29",
    "kind": "route",
    "castWith": [
     "lindon",
     "ezra",
     "evelyn",
     "ace",
     "ares",
     "cruz",
     "kaleb",
     "ever",
     "frau",
     "rikki"
    ]
   },
   {
    "channel": "human-lachesis",
    "passages": 31,
    "share": 0.0279,
    "first": "2024-10-18",
    "last": "2024-11-12",
    "kind": "route",
    "castWith": [
     "nicole_human",
     "brax",
     "lachesis",
     "lance",
     "vaughn",
     "god",
     "alyce_char",
     "moros",
     "ford",
     "atropos",
     "cruz",
     "nicole_wolf"
    ]
   },
   {
    "channel": "pack-house",
    "passages": 28,
    "share": 0.0252,
    "first": "2020-04-18",
    "last": "2020-04-18",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "myra",
     "allie",
     "raye"
    ]
   },
   {
    "channel": "parabus",
    "passages": 27,
    "share": 0.0243,
    "first": "2020-06-03",
    "last": "2020-06-07",
    "kind": "route",
    "castWith": [
     "evelyn",
     "lucius",
     "rex",
     "laito",
     "boko",
     "ryan",
     "stash",
     "raye",
     "mr_han_sr",
     "cruz",
     "kya_sg3",
     "kaleb"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "lucius",
   "nellie",
   "myra",
   "cruz",
   "bryce",
   "will",
   "dimitri",
   "kaleb",
   "rio",
   "may",
   "mr_han_sr"
  ]
 },
 "lucius": {
  "canonRoute": "northwest-pack-lodge",
  "totalPassages": 358,
  "routes": [
   {
    "channel": "ooc",
    "passages": 90,
    "share": 0.2514,
    "first": "2020-04-19",
    "last": "2020-12-26",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex",
     "agnar"
    ]
   },
   {
    "channel": "northwest-pack-lodge",
    "passages": 80,
    "share": 0.2235,
    "first": "2020-04-15",
    "last": "2020-04-29",
    "kind": "canon",
    "castWith": [
     "rowan",
     "evelyn",
     "nellie",
     "myra",
     "cruz",
     "bryce",
     "will",
     "dimitri",
     "kaleb",
     "rio",
     "may",
     "mr_han_sr"
    ]
   },
   {
    "channel": "parabus",
    "passages": 75,
    "share": 0.2095,
    "first": "2020-06-03",
    "last": "2020-06-07",
    "kind": "route",
    "castWith": [
     "evelyn",
     "rex",
     "rowan",
     "laito",
     "boko",
     "ryan",
     "stash",
     "raye",
     "mr_han_sr",
     "cruz",
     "kya_sg3",
     "kaleb"
    ]
   },
   {
    "channel": "bonfire",
    "passages": 25,
    "share": 0.0698,
    "first": "2020-06-05",
    "last": "2020-06-06",
    "kind": "route",
    "castWith": [
     "rex",
     "evelyn",
     "boko",
     "rowan",
     "may",
     "stash"
    ]
   },
   {
    "channel": "the-blacklight",
    "passages": 25,
    "share": 0.0698,
    "first": "2020-04-30",
    "last": "2020-05-01",
    "kind": "route",
    "castWith": [
     "evelyn",
     "darren",
     "lacie",
     "kiro",
     "lex",
     "milo",
     "kya_sg3",
     "kya_sg1",
     "cruz",
     "rowan",
     "kaleb",
     "aphrodite"
    ]
   },
   {
    "channel": "the-wilderness",
    "passages": 14,
    "share": 0.0391,
    "first": "2020-06-03",
    "last": "2020-06-03",
    "kind": "route",
    "castWith": [
     "evelyn",
     "rowan",
     "aria"
    ]
   },
   {
    "channel": "luscious-lucius",
    "passages": 8,
    "share": 0.0223,
    "first": "2022-10-05",
    "last": "2022-10-06",
    "kind": "route",
    "castWith": [
     "rowan",
     "evelyn",
     "god"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 8,
    "share": 0.0223,
    "first": "2020-05-22",
    "last": "2020-06-03",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "rowan-rocks",
    "passages": 7,
    "share": 0.0196,
    "first": "2022-09-28",
    "last": "2022-09-28",
    "kind": "route",
    "castWith": [
     "rowan",
     "god"
    ]
   },
   {
    "channel": "misc-location",
    "passages": 6,
    "share": 0.0168,
    "first": "2020-05-04",
    "last": "2020-05-11",
    "kind": "route",
    "castWith": [
     "evelyn",
     "riku",
     "ares",
     "kiro",
     "hiro",
     "lex",
     "lance",
     "ezra",
     "darren",
     "kaleb",
     "raye",
     "kya_sg3"
    ]
   },
   {
    "channel": "misc",
    "passages": 4,
    "share": 0.0112,
    "first": "2020-06-07",
    "last": "2020-06-07",
    "kind": "route",
    "castWith": [
     "aaron",
     "rowan",
     "evelyn",
     "kya_sg3",
     "kya_sg1",
     "sabrina_witch",
     "sebastian_vamp",
     "sebastian_siren",
     "rex",
     "cupid_eros",
     "george_campbell",
     "nellie"
    ]
   },
   {
    "channel": "brothel",
    "passages": 4,
    "share": 0.0112,
    "first": "2020-04-23",
    "last": "2020-04-27",
    "kind": "route",
    "castWith": [
     "ezra",
     "evelyn",
     "rowan",
     "kya_sg3",
     "kya_sg1",
     "primrose",
     "lily",
     "kaleb",
     "nellie",
     "lissa",
     "raye",
     "ace"
    ]
   }
  ],
  "knownCharacters": [
   "rowan",
   "evelyn",
   "nellie",
   "myra",
   "cruz",
   "bryce",
   "will",
   "dimitri",
   "kaleb",
   "rio",
   "may",
   "mr_han_sr"
  ]
 },
 "hiro": {
  "canonRoute": "nevada",
  "totalPassages": 398,
  "routes": [
   {
    "channel": "nevada",
    "passages": 87,
    "share": 0.2186,
    "first": "2020-05-18",
    "last": "2020-05-20",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "dike",
     "darren",
     "cupid_eros",
     "apollo",
     "ares",
     "hades",
     "will",
     "athena",
     "lucius",
     "god",
     "zeus"
    ]
   },
   {
    "channel": "greek-house",
    "passages": 62,
    "share": 0.1558,
    "first": "2020-05-07",
    "last": "2020-05-21",
    "kind": "route",
    "castWith": [
     "evelyn",
     "darren",
     "lex",
     "kiro",
     "raye",
     "kya_sg3",
     "ares",
     "riku",
     "kya_sg1",
     "lacie",
     "aphrodite",
     "god"
    ]
   },
   {
    "channel": "california",
    "passages": 59,
    "share": 0.1482,
    "first": "2020-05-13",
    "last": "2020-05-14",
    "kind": "route",
    "castWith": [
     "evelyn",
     "ares",
     "ezra",
     "bryce",
     "ace",
     "harley",
     "kiro",
     "will"
    ]
   },
   {
    "channel": "washington",
    "passages": 36,
    "share": 0.0905,
    "first": "2020-05-14",
    "last": "2020-05-16",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cupid_eros"
    ]
   },
   {
    "channel": "hiros-room",
    "passages": 35,
    "share": 0.0879,
    "first": "2020-05-09",
    "last": "2020-05-11",
    "kind": "route",
    "castWith": [
     "evelyn",
     "darren",
     "ares",
     "riku",
     "kiro",
     "lex",
     "hades",
     "lacie",
     "zeus"
    ]
   },
   {
    "channel": "misc-location",
    "passages": 27,
    "share": 0.0678,
    "first": "2020-05-10",
    "last": "2020-05-13",
    "kind": "route",
    "castWith": [
     "evelyn",
     "riku",
     "ares",
     "kiro",
     "lex",
     "lance",
     "ezra",
     "lucius",
     "darren",
     "kaleb",
     "raye",
     "kya_sg3"
    ]
   },
   {
    "channel": "ooc",
    "passages": 26,
    "share": 0.0653,
    "first": "2020-05-07",
    "last": "2020-06-20",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "car",
    "passages": 26,
    "share": 0.0653,
    "first": "2020-05-13",
    "last": "2020-05-17",
    "kind": "route",
    "castWith": [
     "evelyn",
     "athena",
     "lucius",
     "apollo",
     "riku",
     "cruz",
     "ares",
     "will"
    ]
   },
   {
    "channel": "cafeteria",
    "passages": 14,
    "share": 0.0352,
    "first": "2020-05-13",
    "last": "2020-05-13",
    "kind": "route",
    "castWith": [
     "evelyn",
     "agnar",
     "agmund",
     "kya_sg3",
     "lex",
     "kaleb",
     "penelope_valk",
     "svira",
     "ares",
     "riku",
     "darren",
     "kya_sg1"
    ]
   },
   {
    "channel": "texas",
    "passages": 13,
    "share": 0.0327,
    "first": "2020-05-17",
    "last": "2020-05-18",
    "kind": "route",
    "castWith": [
     "evelyn",
     "darren",
     "athena",
     "lacie"
    ]
   },
   {
    "channel": "calls",
    "passages": 3,
    "share": 0.0075,
    "first": "2020-05-19",
    "last": "2020-05-19",
    "kind": "route",
    "castWith": [
     "evelyn",
     "agnar",
     "kya_sg1",
     "kya_sg3",
     "rowan",
     "ezra"
    ]
   },
   {
    "channel": "sabrinas-apartment",
    "passages": 2,
    "share": 0.005,
    "first": "2020-06-06",
    "last": "2020-06-06",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "sabrina_witch",
     "aphrodite",
     "halo",
     "ares",
     "athena",
     "demeter",
     "god",
     "roman"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "dike",
   "darren",
   "cupid_eros",
   "apollo",
   "ares",
   "hades",
   "will",
   "athena",
   "lucius",
   "god",
   "zeus"
  ]
 },
 "raz": {
  "canonRoute": "kieran-is-a-hoe-for-raz",
  "totalPassages": 728,
  "routes": [
   {
    "channel": "kieran-is-a-hoe-for-raz",
    "passages": 120,
    "share": 0.1648,
    "first": "2026-02-04",
    "last": "2026-03-03",
    "kind": "canon",
    "castWith": [
     "kieran",
     "peter",
     "will",
     "james"
    ]
   },
   {
    "channel": "kierans-back",
    "passages": 88,
    "share": 0.1209,
    "first": "2025-03-12",
    "last": "2025-04-14",
    "kind": "route",
    "castWith": [
     "kieran",
     "peter",
     "evan",
     "may"
    ]
   },
   {
    "channel": "cruz-nicole-dollar-store",
    "passages": 85,
    "share": 0.1168,
    "first": "2020-09-13",
    "last": "2020-09-21",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "bryce",
     "nolan",
     "renee",
     "aphrodite",
     "clothos",
     "atropos",
     "nicole_wolf",
     "nicole_sg3",
     "moros"
    ]
   },
   {
    "channel": "human-kieran",
    "passages": 58,
    "share": 0.0797,
    "first": "2024-01-03",
    "last": "2024-01-10",
    "kind": "route",
    "castWith": [
     "kieran",
     "peter",
     "evan",
     "mei",
     "gemma",
     "ms_tia",
     "will"
    ]
   },
   {
    "channel": "raz-the-assbro",
    "passages": 57,
    "share": 0.0783,
    "first": "2023-10-29",
    "last": "2023-11-11",
    "kind": "route",
    "castWith": [
     "kieran",
     "peter",
     "junta",
     "will"
    ]
   },
   {
    "channel": "kieran-ezra",
    "passages": 51,
    "share": 0.0701,
    "first": "2023-10-07",
    "last": "2023-10-12",
    "kind": "route",
    "castWith": [
     "kieran",
     "ezra",
     "lily",
     "peter",
     "primrose",
     "rosalie",
     "ace",
     "gemma"
    ]
   },
   {
    "channel": "junta-tim-soulmates",
    "passages": 47,
    "share": 0.0646,
    "first": "2023-09-10",
    "last": "2023-09-22",
    "kind": "route",
    "castWith": [
     "junta",
     "tim",
     "kieran",
     "peter",
     "kris",
     "dalton",
     "val",
     "vanessa",
     "ever",
     "aphrodite",
     "natasha",
     "will"
    ]
   },
   {
    "channel": "raz-knows",
    "passages": 44,
    "share": 0.0604,
    "first": "2024-01-10",
    "last": "2024-01-16",
    "kind": "route",
    "castWith": [
     "kieran",
     "peter",
     "may",
     "will"
    ]
   },
   {
    "channel": "raz-and-kieran",
    "passages": 40,
    "share": 0.0549,
    "first": "2023-09-23",
    "last": "2023-09-25",
    "kind": "route",
    "castWith": [
     "kieran",
     "peter",
     "ever"
    ]
   },
   {
    "channel": "love-the-good-bois",
    "passages": 26,
    "share": 0.0357,
    "first": "2022-11-20",
    "last": "2022-11-26",
    "kind": "route",
    "castWith": [
     "ezra",
     "junta",
     "kya_sg3",
     "kya_sg1",
     "tim",
     "sebastian_vamp",
     "val",
     "evelyn",
     "kaleb",
     "skipper",
     "james",
     "primrose"
    ]
   },
   {
    "channel": "alistair-immortuous-gone-wrong",
    "passages": 26,
    "share": 0.0357,
    "first": "2025-10-29",
    "last": "2025-11-02",
    "kind": "route",
    "castWith": [
     "james",
     "kya_sg3",
     "dillon",
     "junta",
     "kya_sg1",
     "alistair",
     "alistair_turayne",
     "val",
     "vanessa",
     "sebastian_vamp",
     "tim",
     "sebastian_siren"
    ]
   },
   {
    "channel": "peter",
    "passages": 18,
    "share": 0.0247,
    "first": "2023-09-25",
    "last": "2023-09-28",
    "kind": "route",
    "castWith": [
     "peter",
     "kieran",
     "george_campbell",
     "paul"
    ]
   }
  ],
  "knownCharacters": [
   "kieran",
   "peter",
   "will",
   "james"
  ]
 },
 "rex": {
  "canonRoute": "school-gym",
  "totalPassages": 262,
  "routes": [
   {
    "channel": "school-gym",
    "passages": 39,
    "share": 0.1489,
    "first": "2020-06-08",
    "last": "2020-06-11",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "aaron",
     "diana",
     "milo",
     "kya_sg3",
     "kya_sg1",
     "roman",
     "dike",
     "frau",
     "dimitri",
     "sebastian_vamp",
     "raye"
    ]
   },
   {
    "channel": "bonfire",
    "passages": 35,
    "share": 0.1336,
    "first": "2020-06-05",
    "last": "2020-06-06",
    "kind": "route",
    "castWith": [
     "evelyn",
     "lucius",
     "boko",
     "rowan",
     "may",
     "stash"
    ]
   },
   {
    "channel": "ooc",
    "passages": 34,
    "share": 0.1298,
    "first": "2020-06-04",
    "last": "2020-12-15",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "agnar"
    ]
   },
   {
    "channel": "parabus",
    "passages": 30,
    "share": 0.1145,
    "first": "2020-06-04",
    "last": "2020-06-07",
    "kind": "route",
    "castWith": [
     "evelyn",
     "lucius",
     "rowan",
     "laito",
     "boko",
     "ryan",
     "stash",
     "raye",
     "mr_han_sr",
     "cruz",
     "kya_sg3",
     "kaleb"
    ]
   },
   {
    "channel": "staff-break-room",
    "passages": 30,
    "share": 0.1145,
    "first": "2020-06-14",
    "last": "2020-06-18",
    "kind": "route",
    "castWith": [
     "dimitri",
     "evelyn",
     "saph",
     "diana",
     "aaron",
     "kiro",
     "milo",
     "skipper",
     "roman",
     "sebastian_vamp",
     "kya_sg3",
     "sebastian_siren"
    ]
   },
   {
    "channel": "auditorium",
    "passages": 24,
    "share": 0.0916,
    "first": "2020-06-11",
    "last": "2020-06-14",
    "kind": "route",
    "castWith": [
     "evelyn",
     "diana",
     "milo",
     "dimitri",
     "athena",
     "dike",
     "audrey",
     "saph",
     "bryce",
     "kaleb",
     "roman",
     "rio"
    ]
   },
   {
    "channel": "athena-class",
    "passages": 19,
    "share": 0.0725,
    "first": "2020-06-18",
    "last": "2020-06-19",
    "kind": "route",
    "castWith": [
     "evelyn",
     "kiro",
     "diana",
     "milo",
     "cupid_eros",
     "athena",
     "dimitri",
     "dike",
     "kya_sg1",
     "aaron",
     "kya_sg3",
     "hiro"
    ]
   },
   {
    "channel": "mt-olympus",
    "passages": 19,
    "share": 0.0725,
    "first": "2020-06-19",
    "last": "2020-06-30",
    "kind": "route",
    "castWith": [
     "evelyn",
     "libion",
     "ares",
     "persephone",
     "bion",
     "hades",
     "aphrodite",
     "hercules",
     "demeter",
     "zeus",
     "athena",
     "zerden"
    ]
   },
   {
    "channel": "dining-hall",
    "passages": 12,
    "share": 0.0458,
    "first": "2020-06-08",
    "last": "2020-06-08",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "bryce",
     "milo",
     "aaron",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "lex",
     "sebastian_vamp",
     "dike",
     "agnar"
    ]
   },
   {
    "channel": "teacher-dormitory",
    "passages": 10,
    "share": 0.0382,
    "first": "2020-06-08",
    "last": "2020-06-08",
    "kind": "route",
    "castWith": [
     "aaron",
     "kya_sg3",
     "evelyn",
     "kya_sg1",
     "sebastian_siren",
     "sebastian_vamp",
     "kaleb",
     "dimitri",
     "cupid_eros",
     "boko",
     "mr_han_sr"
    ]
   },
   {
    "channel": "father-time",
    "passages": 3,
    "share": 0.0115,
    "first": "2023-10-04",
    "last": "2023-10-04",
    "kind": "route",
    "castWith": []
   },
   {
    "channel": "shane-micah-wish",
    "passages": 2,
    "share": 0.0076,
    "first": "2023-11-28",
    "last": "2023-11-28",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "cruz",
     "micah",
     "ryder",
     "god",
     "trix",
     "ever",
     "diana",
     "lucifer",
     "jack",
     "keller"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "aaron",
   "diana",
   "milo",
   "kya_sg3",
   "kya_sg1",
   "roman",
   "dike",
   "frau",
   "dimitri",
   "sebastian_vamp",
   "raye"
  ]
 },
 "kaleb": {
  "canonRoute": "kyas_penthouse",
  "totalPassages": 2464,
  "routes": [
   {
    "channel": "kyas_penthouse",
    "passages": 225,
    "share": 0.0913,
    "first": "2016-09-17",
    "last": "2020-03-29",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "raye",
     "ezra",
     "kya_sg3",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "mr_han_sr",
     "bryce",
     "god",
     "cruz",
     "will"
    ]
   },
   {
    "channel": "kaleb-kya-finally",
    "passages": 152,
    "share": 0.0617,
    "first": "2021-02-06",
    "last": "2021-02-17",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "kya_sg1",
     "evelyn",
     "sebastian_siren",
     "sebastian_vamp",
     "apollo",
     "gabs",
     "uncle_khan",
     "alexander",
     "dimitri",
     "kyo",
     "ami"
    ]
   },
   {
    "channel": "val",
    "passages": 143,
    "share": 0.058,
    "first": "2020-04-15",
    "last": "2020-12-20",
    "kind": "route",
    "castWith": [
     "val",
     "kya_sg3",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "evelyn",
     "vanessa",
     "ezra",
     "raye",
     "alan",
     "tyrion",
     "mr_han_sr"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 135,
    "share": 0.0548,
    "first": "2016-09-08",
    "last": "2020-07-16",
    "kind": "ooc",
    "castWith": [
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika",
     "nolan"
    ]
   },
   {
    "channel": "human-evie",
    "passages": 105,
    "share": 0.0426,
    "first": "2020-09-22",
    "last": "2021-02-27",
    "kind": "route",
    "castWith": [
     "evelyn",
     "frau",
     "cruz",
     "mr_han_sr",
     "audrey",
     "richard_antore",
     "diana",
     "ares",
     "quincy_antore",
     "nereda",
     "elizabeth_the_third",
     "ever"
    ]
   },
   {
    "channel": "evelyns_mansion",
    "passages": 98,
    "share": 0.0398,
    "first": "2016-09-25",
    "last": "2020-03-23",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "kya_sg3",
     "ivy_morris",
     "marta",
     "kya_sg1",
     "frau",
     "mr_han_sr",
     "sebastian_vamp",
     "god",
     "seuk",
     "dimitri"
    ]
   },
   {
    "channel": "meeting-room",
    "passages": 88,
    "share": 0.0357,
    "first": "2020-03-26",
    "last": "2020-08-01",
    "kind": "route",
    "castWith": [
     "ezra",
     "kya_sg3",
     "raye",
     "evelyn",
     "alistair_turayne",
     "alistair",
     "mr_han_sr",
     "kya_sg1",
     "thorne",
     "prince_zain",
     "sune",
     "yuri_rekovich"
    ]
   },
   {
    "channel": "bday-kaleb",
    "passages": 78,
    "share": 0.0317,
    "first": "2024-05-06",
    "last": "2024-05-22",
    "kind": "route",
    "castWith": [
     "god",
     "evelyn",
     "haley_human",
     "kya_sg3",
     "ever",
     "frau",
     "may"
    ]
   },
   {
    "channel": "ooc",
    "passages": 78,
    "share": 0.0317,
    "first": "2020-04-14",
    "last": "2020-12-26",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex",
     "agnar"
    ]
   },
   {
    "channel": "mm_chatroom",
    "passages": 67,
    "share": 0.0272,
    "first": "2016-09-08",
    "last": "2020-03-31",
    "kind": "route",
    "castWith": [
     "evelyn",
     "rika",
     "mr_han_sr",
     "cruz",
     "elizabeth_the_third",
     "god",
     "mr_clien",
     "bryce",
     "ever",
     "marie_antoinette",
     "tom"
    ]
   },
   {
    "channel": "double-bro-seb-cole",
    "passages": 64,
    "share": 0.026,
    "first": "2025-04-30",
    "last": "2025-05-22",
    "kind": "route",
    "castWith": [
     "cole",
     "dillon",
     "kya_sg3",
     "kya_sg1",
     "kyo",
     "evelyn",
     "sebastian_siren",
     "amoura",
     "may",
     "sebastian_vamp",
     "uncle_khan",
     "ace"
    ]
   },
   {
    "channel": "fantastical-ezra",
    "passages": 52,
    "share": 0.0211,
    "first": "2025-02-18",
    "last": "2025-03-04",
    "kind": "route",
    "castWith": [
     "ezra",
     "dillon",
     "apollo",
     "kya_sg3",
     "james",
     "sebastian_vamp",
     "evelyn",
     "kya_sg1",
     "haley_human",
     "sebastian_siren",
     "skipper",
     "polly"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "raye",
   "ezra",
   "kya_sg3",
   "alistair",
   "alistair_turayne",
   "kya_sg1",
   "mr_han_sr",
   "bryce",
   "god",
   "cruz",
   "will"
  ]
 },
 "james": {
  "canonRoute": "kya-x-james",
  "totalPassages": 714,
  "routes": [
   {
    "channel": "kya-x-james",
    "passages": 137,
    "share": 0.1919,
    "first": "2020-08-29",
    "last": "2020-09-08",
    "kind": "canon",
    "castWith": [
     "kya_sg3",
     "kya_sg1",
     "vanessa",
     "junta",
     "tim",
     "val",
     "raz",
     "dalton",
     "evelyn",
     "sebastian_vamp",
     "raye",
     "sebastian_siren"
    ]
   },
   {
    "channel": "haley-james-yessss",
    "passages": 110,
    "share": 0.1541,
    "first": "2020-08-15",
    "last": "2022-10-24",
    "kind": "route",
    "castWith": [
     "ezra",
     "haley_human",
     "kaleb",
     "ace",
     "nicole_human",
     "primrose",
     "mr_han_sr",
     "evelyn",
     "lily",
     "haley_wolf",
     "haley_sg3",
     "aphrodite"
    ]
   },
   {
    "channel": "immortuos",
    "passages": 71,
    "share": 0.0994,
    "first": "2021-12-08",
    "last": "2021-12-15",
    "kind": "route",
    "castWith": [
     "val",
     "vanessa",
     "will",
     "kya_sg3",
     "kya_sg1",
     "sebastian_vamp",
     "sebastian_siren",
     "junta",
     "kaleb",
     "aurelia",
     "may",
     "tim"
    ]
   },
   {
    "channel": "reincarnation-with-alistair",
    "passages": 59,
    "share": 0.0826,
    "first": "2025-02-05",
    "last": "2025-02-15",
    "kind": "route",
    "castWith": [
     "dillon",
     "alistair",
     "alistair_turayne",
     "kya_sg3",
     "sebastian_vamp",
     "kya_sg1",
     "evelyn",
     "val",
     "haley_human",
     "sebastian_siren",
     "athena",
     "junta"
    ]
   },
   {
    "channel": "Haley - 7/26/2026",
    "passages": 47,
    "share": 0.0658,
    "first": "2026-07-27",
    "last": "2026-07-28",
    "kind": "route",
    "castWith": [
     "dillon",
     "kya_sg3",
     "vanessa",
     "sebastian_vamp",
     "kya_sg1",
     "val",
     "junta",
     "sebastian_siren",
     "tim",
     "raz",
     "coral",
     "will"
    ]
   },
   {
    "channel": "kya-war-au",
    "passages": 43,
    "share": 0.0602,
    "first": "2021-12-02",
    "last": "2021-12-06",
    "kind": "au",
    "castWith": [
     "ezra",
     "kya_sg3",
     "val",
     "kya_sg1",
     "vanessa",
     "kaleb",
     "raye",
     "sebastian_vamp",
     "sebastian_siren",
     "lily",
     "junta",
     "evelyn"
    ]
   },
   {
    "channel": "trident-and-the-elders",
    "passages": 32,
    "share": 0.0448,
    "first": "2022-10-24",
    "last": "2022-10-26",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "raz",
     "kya_sg1",
     "val",
     "apollo",
     "sebastian_vamp",
     "junta",
     "sebastian_siren",
     "vanessa",
     "tim",
     "kaleb",
     "ever"
    ]
   },
   {
    "channel": "elder-boi-romance-cause-why-not",
    "passages": 28,
    "share": 0.0392,
    "first": "2022-10-23",
    "last": "2022-10-24",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "sebastian_vamp",
     "sebastian_siren",
     "kya_sg1",
     "vanessa",
     "val",
     "tim",
     "junta",
     "aphrodite"
    ]
   },
   {
    "channel": "1920s-boardwalk",
    "passages": 26,
    "share": 0.0364,
    "first": "2022-05-26",
    "last": "2022-05-30",
    "kind": "route",
    "castWith": [
     "val",
     "ezra",
     "kya_sg3",
     "alistair_turayne",
     "kya_sg1",
     "alistair",
     "vanessa",
     "sebastian_vamp",
     "sebastian_siren",
     "amelda",
     "junta",
     "dillon"
    ]
   },
   {
    "channel": "weresirens",
    "passages": 25,
    "share": 0.035,
    "first": "2023-04-22",
    "last": "2023-04-25",
    "kind": "route",
    "castWith": [
     "dillon",
     "sebastian_vamp",
     "aaron",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren"
    ]
   },
   {
    "channel": "lachesis-off-the-rails",
    "passages": 23,
    "share": 0.0322,
    "first": "2025-08-21",
    "last": "2025-08-29",
    "kind": "route",
    "castWith": [
     "lance",
     "vaughn",
     "brax",
     "lucifer",
     "atropos",
     "cruz",
     "lachesis",
     "ace",
     "lindon",
     "hades",
     "ezra",
     "nicole_human"
    ]
   },
   {
    "channel": "alistair-immortuous-gone-wrong",
    "passages": 17,
    "share": 0.0238,
    "first": "2025-10-29",
    "last": "2025-10-30",
    "kind": "route",
    "castWith": [
     "raz",
     "kya_sg3",
     "dillon",
     "junta",
     "kya_sg1",
     "alistair",
     "alistair_turayne",
     "val",
     "vanessa",
     "sebastian_vamp",
     "tim",
     "sebastian_siren"
    ]
   }
  ],
  "knownCharacters": [
   "kya_sg3",
   "kya_sg1",
   "vanessa",
   "junta",
   "tim",
   "val",
   "raz",
   "dalton",
   "evelyn",
   "sebastian_vamp",
   "raye",
   "sebastian_siren"
  ]
 },
 "vanessa": {
  "canonRoute": "elders-layla",
  "totalPassages": 274,
  "routes": [
   {
    "channel": "elders-layla",
    "passages": 45,
    "share": 0.1642,
    "first": "2020-09-08",
    "last": "2020-09-10",
    "kind": "canon",
    "castWith": [
     "val",
     "layla",
     "tim",
     "james",
     "junta",
     "sebastian_vamp",
     "sebastian_siren",
     "apollo",
     "theo_uoki",
     "will"
    ]
   },
   {
    "channel": "immortuos",
    "passages": 38,
    "share": 0.1387,
    "first": "2021-12-08",
    "last": "2021-12-15",
    "kind": "route",
    "castWith": [
     "val",
     "james",
     "will",
     "kya_sg3",
     "kya_sg1",
     "sebastian_vamp",
     "sebastian_siren",
     "junta",
     "kaleb",
     "aurelia",
     "may",
     "tim"
    ]
   },
   {
    "channel": "val",
    "passages": 33,
    "share": 0.1204,
    "first": "2020-11-12",
    "last": "2020-12-27",
    "kind": "route",
    "castWith": [
     "val",
     "kya_sg3",
     "kaleb",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "evelyn",
     "ezra",
     "raye",
     "alan",
     "tyrion",
     "mr_han_sr"
    ]
   },
   {
    "channel": "bitchy-vaughn",
    "passages": 32,
    "share": 0.1168,
    "first": "2025-06-07",
    "last": "2025-06-29",
    "kind": "route",
    "castWith": [
     "brax",
     "vaughn",
     "lindon",
     "nicole_human",
     "diana",
     "god"
    ]
   },
   {
    "channel": "kya-war-au",
    "passages": 29,
    "share": 0.1058,
    "first": "2021-12-02",
    "last": "2021-12-06",
    "kind": "au",
    "castWith": [
     "ezra",
     "kya_sg3",
     "james",
     "val",
     "kya_sg1",
     "kaleb",
     "raye",
     "sebastian_vamp",
     "sebastian_siren",
     "lily",
     "junta",
     "evelyn"
    ]
   },
   {
    "channel": "unknown-soulmate",
    "passages": 20,
    "share": 0.073,
    "first": "2025-06-30",
    "last": "2025-08-07",
    "kind": "route",
    "castWith": [
     "brax",
     "vaughn",
     "lindon",
     "nicole_human",
     "moros",
     "ares",
     "ben",
     "god"
    ]
   },
   {
    "channel": "1920s-boardwalk",
    "passages": 18,
    "share": 0.0657,
    "first": "2022-05-26",
    "last": "2022-05-29",
    "kind": "route",
    "castWith": [
     "val",
     "ezra",
     "kya_sg3",
     "james",
     "alistair_turayne",
     "kya_sg1",
     "alistair",
     "sebastian_vamp",
     "sebastian_siren",
     "amelda",
     "junta",
     "dillon"
    ]
   },
   {
    "channel": "kya-x-james",
    "passages": 14,
    "share": 0.0511,
    "first": "2020-09-03",
    "last": "2020-09-07",
    "kind": "route",
    "castWith": [
     "james",
     "kya_sg3",
     "kya_sg1",
     "junta",
     "tim",
     "val",
     "raz",
     "dalton",
     "evelyn",
     "sebastian_vamp",
     "raye",
     "sebastian_siren"
    ]
   },
   {
    "channel": "Haley - 7/26/2026",
    "passages": 9,
    "share": 0.0328,
    "first": "2026-07-27",
    "last": "2026-07-27",
    "kind": "route",
    "castWith": [
     "james",
     "dillon",
     "kya_sg3",
     "sebastian_vamp",
     "kya_sg1",
     "val",
     "junta",
     "sebastian_siren",
     "tim",
     "raz",
     "coral",
     "will"
    ]
   },
   {
    "channel": "ooc",
    "passages": 6,
    "share": 0.0219,
    "first": "2020-11-22",
    "last": "2020-12-26",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "lachesis-off-the-rails",
    "passages": 5,
    "share": 0.0182,
    "first": "2025-08-25",
    "last": "2025-09-03",
    "kind": "route",
    "castWith": [
     "lance",
     "vaughn",
     "brax",
     "lucifer",
     "james",
     "atropos",
     "cruz",
     "lachesis",
     "ace",
     "lindon",
     "hades",
     "ezra"
    ]
   },
   {
    "channel": "ezra-normalish-life",
    "passages": 5,
    "share": 0.0182,
    "first": "2022-09-07",
    "last": "2022-09-10",
    "kind": "route",
    "castWith": [
     "ezra",
     "sam",
     "kya_sg3",
     "kya_sg1",
     "raz",
     "james",
     "evelyn",
     "kaleb",
     "bell_lily_of_fell",
     "val",
     "jane",
     "tim"
    ]
   }
  ],
  "knownCharacters": [
   "val",
   "layla",
   "tim",
   "james",
   "junta",
   "sebastian_vamp",
   "sebastian_siren",
   "apollo",
   "theo_uoki",
   "will"
  ]
 },
 "lily": {
  "canonRoute": "kya-college-2",
  "totalPassages": 184,
  "routes": [
   {
    "channel": "kya-college-2",
    "passages": 98,
    "share": 0.5326,
    "first": "2021-01-21",
    "last": "2021-01-28",
    "kind": "canon",
    "castWith": [
     "zander",
     "kya_sg3",
     "kya_sg1",
     "ari",
     "sebastian_siren",
     "raye",
     "prince_zed",
     "sebastian_vamp",
     "midori_naga",
     "penelope_valk",
     "bell_lily_of_fell",
     "agnar"
    ]
   },
   {
    "channel": "kieran-ezra",
    "passages": 28,
    "share": 0.1522,
    "first": "2023-10-09",
    "last": "2023-10-11",
    "kind": "route",
    "castWith": [
     "kieran",
     "ezra",
     "raz",
     "peter",
     "primrose",
     "rosalie",
     "ace",
     "gemma"
    ]
   },
   {
    "channel": "brothel",
    "passages": 24,
    "share": 0.1304,
    "first": "2020-04-19",
    "last": "2020-04-27",
    "kind": "route",
    "castWith": [
     "ezra",
     "evelyn",
     "rowan",
     "kya_sg3",
     "kya_sg1",
     "primrose",
     "kaleb",
     "nellie",
     "lissa",
     "raye",
     "ace",
     "mr_han_sr"
    ]
   },
   {
    "channel": "junta-is-best-boi",
    "passages": 18,
    "share": 0.0978,
    "first": "2023-11-28",
    "last": "2023-12-12",
    "kind": "route",
    "castWith": [
     "junta",
     "ezra",
     "madison_astor",
     "val",
     "natasha",
     "primrose",
     "belinda",
     "james",
     "may",
     "sebastian_vamp",
     "tim",
     "ace"
    ]
   },
   {
    "channel": "kya-war-au",
    "passages": 10,
    "share": 0.0543,
    "first": "2021-11-28",
    "last": "2021-11-29",
    "kind": "au",
    "castWith": [
     "ezra",
     "kya_sg3",
     "james",
     "val",
     "kya_sg1",
     "vanessa",
     "kaleb",
     "raye",
     "sebastian_vamp",
     "sebastian_siren",
     "junta",
     "evelyn"
    ]
   },
   {
    "channel": "high-school-ezra-kya",
    "passages": 2,
    "share": 0.0109,
    "first": "2021-02-20",
    "last": "2021-02-20",
    "kind": "route",
    "castWith": [
     "ezra",
     "kya_sg3",
     "maria",
     "rachel",
     "kaleb",
     "kya_sg1",
     "evelyn",
     "willie",
     "jane",
     "primrose",
     "ace",
     "uncle_khan"
    ]
   },
   {
    "channel": "haley-james-yessss",
    "passages": 2,
    "share": 0.0109,
    "first": "2020-08-14",
    "last": "2020-08-18",
    "kind": "route",
    "castWith": [
     "ezra",
     "james",
     "haley_human",
     "kaleb",
     "ace",
     "nicole_human",
     "primrose",
     "mr_han_sr",
     "evelyn",
     "haley_wolf",
     "haley_sg3",
     "aphrodite"
    ]
   },
   {
    "channel": "fantastical-ezra",
    "passages": 1,
    "share": 0.0054,
    "first": "2025-02-24",
    "last": "2025-02-24",
    "kind": "route",
    "castWith": [
     "ezra",
     "dillon",
     "kaleb",
     "apollo",
     "kya_sg3",
     "james",
     "sebastian_vamp",
     "evelyn",
     "kya_sg1",
     "haley_human",
     "sebastian_siren",
     "skipper"
    ]
   },
   {
    "channel": "ooc",
    "passages": 1,
    "share": 0.0054,
    "first": "2020-11-22",
    "last": "2020-11-22",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   }
  ],
  "knownCharacters": [
   "zander",
   "kya_sg3",
   "kya_sg1",
   "ari",
   "sebastian_siren",
   "raye",
   "prince_zed",
   "sebastian_vamp",
   "midori_naga",
   "penelope_valk",
   "bell_lily_of_fell",
   "agnar"
  ]
 },
 "coral": {
  "canonRoute": "dorms",
  "totalPassages": 3,
  "routes": [
   {
    "channel": "kya-war-au",
    "passages": 1,
    "share": 0.3333,
    "first": "2021-11-28",
    "last": "2021-11-28",
    "kind": "au",
    "castWith": [
     "ezra",
     "kya_sg3",
     "james",
     "val",
     "kya_sg1",
     "vanessa",
     "kaleb",
     "raye",
     "sebastian_vamp",
     "sebastian_siren",
     "lily",
     "junta"
    ]
   },
   {
    "channel": "dorms",
    "passages": 1,
    "share": 0.3333,
    "first": "2020-05-09",
    "last": "2020-05-09",
    "kind": "canon",
    "castWith": [
     "agnar",
     "kya_sg3",
     "agmund",
     "evelyn",
     "raye",
     "cole",
     "kya_sg1",
     "riku",
     "kaleb",
     "penelope_valk",
     "loki",
     "svira"
    ]
   },
   {
    "channel": "Haley - 7/26/2026",
    "passages": 1,
    "share": 0.3333,
    "first": "2026-07-27",
    "last": "2026-07-27",
    "kind": "route",
    "castWith": [
     "james",
     "dillon",
     "kya_sg3",
     "vanessa",
     "sebastian_vamp",
     "kya_sg1",
     "val",
     "junta",
     "sebastian_siren",
     "tim",
     "raz",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "agnar",
   "kya_sg3",
   "agmund",
   "evelyn",
   "raye",
   "cole",
   "kya_sg1",
   "riku",
   "kaleb",
   "penelope_valk",
   "loki",
   "svira"
  ]
 },
 "solana": {
  "canonRoute": "european-vampires",
  "totalPassages": 76,
  "routes": [
   {
    "channel": "european-vampires",
    "passages": 76,
    "share": 1.0,
    "first": "2024-02-22",
    "last": "2024-03-14",
    "kind": "canon",
    "castWith": [
     "beau",
     "leon",
     "khione",
     "will",
     "may"
    ]
   }
  ],
  "knownCharacters": [
   "beau",
   "leon",
   "khione",
   "will",
   "may"
  ]
 },
 "leon": {
  "canonRoute": "esu",
  "totalPassages": 146,
  "routes": [
   {
    "channel": "esu",
    "passages": 75,
    "share": 0.5137,
    "first": "2025-01-03",
    "last": "2025-01-16",
    "kind": "canon",
    "castWith": [
     "trenton",
     "bennett",
     "richard_antore",
     "will"
    ]
   },
   {
    "channel": "college-possessive",
    "passages": 54,
    "share": 0.3699,
    "first": "2024-12-11",
    "last": "2025-01-03",
    "kind": "route",
    "castWith": [
     "moros",
     "apollo",
     "atropos",
     "lachesis",
     "haley_human",
     "haley_wolf",
     "sabrina_witch",
     "clothos",
     "god",
     "may",
     "will",
     "zeus"
    ]
   },
   {
    "channel": "european-vampires",
    "passages": 9,
    "share": 0.0616,
    "first": "2024-02-22",
    "last": "2024-02-27",
    "kind": "route",
    "castWith": [
     "beau",
     "solana",
     "khione",
     "will",
     "may"
    ]
   },
   {
    "channel": "cruz-x-nicole",
    "passages": 4,
    "share": 0.0274,
    "first": "2020-08-10",
    "last": "2020-08-10",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "hermes",
     "audrey",
     "peter",
     "ares",
     "nicole_wolf",
     "nicole_sg3",
     "alyce_char",
     "red",
     "trix",
     "nicole_human"
    ]
   },
   {
    "channel": "the-great-husbando-race",
    "passages": 2,
    "share": 0.0137,
    "first": "2020-05-26",
    "last": "2020-06-15",
    "kind": "route",
    "castWith": [
     "kira",
     "ray",
     "cupid_eros",
     "loki",
     "riku",
     "victor",
     "evelyn",
     "junta",
     "ben",
     "hyun_ryu",
     "jack",
     "kent"
    ]
   },
   {
    "channel": "lets-abduct-evie",
    "passages": 1,
    "share": 0.0068,
    "first": "2021-07-03",
    "last": "2021-07-03",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "ryoto",
     "dodge",
     "ms_tia",
     "kaleb",
     "frau",
     "aki",
     "cruz",
     "talbot",
     "ares",
     "zeus"
    ]
   },
   {
    "channel": "nicolexcruz-true-mates",
    "passages": 1,
    "share": 0.0068,
    "first": "2024-03-20",
    "last": "2024-03-20",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "nolan",
     "clothos",
     "trix",
     "diana",
     "nicole_human",
     "audrey",
     "asrius",
     "lucifer",
     "atropos"
    ]
   }
  ],
  "knownCharacters": [
   "trenton",
   "bennett",
   "richard_antore",
   "will"
  ]
 },
 "khione": {
  "canonRoute": "european-vampires",
  "totalPassages": 3,
  "routes": [
   {
    "channel": "european-vampires",
    "passages": 3,
    "share": 1.0,
    "first": "2024-02-23",
    "last": "2024-02-23",
    "kind": "canon",
    "castWith": [
     "beau",
     "solana",
     "leon",
     "will",
     "may"
    ]
   }
  ],
  "knownCharacters": [
   "beau",
   "solana",
   "leon",
   "will",
   "may"
  ]
 },
 "miya": {
  "canonRoute": "almost-kya-x-sebastian",
  "totalPassages": 4,
  "routes": [
   {
    "channel": "kya-war-au",
    "passages": 3,
    "share": 0.75,
    "first": "2021-11-28",
    "last": "2021-11-28",
    "kind": "au",
    "castWith": [
     "ezra",
     "kya_sg3",
     "james",
     "val",
     "kya_sg1",
     "vanessa",
     "kaleb",
     "raye",
     "sebastian_vamp",
     "sebastian_siren",
     "lily",
     "junta"
    ]
   },
   {
    "channel": "almost-kya-x-sebastian",
    "passages": 1,
    "share": 0.25,
    "first": "2020-10-23",
    "last": "2020-10-23",
    "kind": "canon",
    "castWith": [
     "sebastian_siren",
     "sebastian_vamp",
     "polly",
     "kya_sg3",
     "kya_sg1",
     "evelyn",
     "ethan",
     "haley_human",
     "alistair",
     "ezra",
     "haley_wolf",
     "haley_sg3"
    ]
   }
  ],
  "knownCharacters": [
   "sebastian_siren",
   "sebastian_vamp",
   "polly",
   "kya_sg3",
   "kya_sg1",
   "evelyn",
   "ethan",
   "haley_human",
   "alistair",
   "ezra",
   "haley_wolf",
   "haley_sg3"
  ]
 },
 "scarlett": {
  "canonRoute": "love-hate-and-war",
  "totalPassages": 91,
  "routes": [
   {
    "channel": "love-hate-and-war",
    "passages": 91,
    "share": 1.0,
    "first": "2022-07-07",
    "last": "2022-08-06",
    "kind": "canon",
    "castWith": [
     "sett",
     "lance",
     "cruz",
     "diana",
     "lachesis",
     "hades",
     "alyce_char",
     "raz",
     "cupid_eros",
     "roman",
     "apollo",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "sett",
   "lance",
   "cruz",
   "diana",
   "lachesis",
   "hades",
   "alyce_char",
   "raz",
   "cupid_eros",
   "roman",
   "apollo",
   "will"
  ]
 },
 "sett": {
  "canonRoute": "love-hate-and-war",
  "totalPassages": 55,
  "routes": [
   {
    "channel": "love-hate-and-war",
    "passages": 54,
    "share": 0.9818,
    "first": "2022-07-08",
    "last": "2022-08-05",
    "kind": "canon",
    "castWith": [
     "scarlett",
     "lance",
     "cruz",
     "diana",
     "lachesis",
     "hades",
     "alyce_char",
     "raz",
     "cupid_eros",
     "roman",
     "apollo",
     "will"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 1,
    "share": 0.0182,
    "first": "2025-02-02",
    "last": "2025-02-02",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "ryder",
     "ford",
     "vaughn",
     "lance",
     "bryce",
     "shane",
     "dimitri",
     "allie",
     "micah",
     "audrey"
    ]
   }
  ],
  "knownCharacters": [
   "scarlett",
   "lance",
   "cruz",
   "diana",
   "lachesis",
   "hades",
   "alyce_char",
   "raz",
   "cupid_eros",
   "roman",
   "apollo",
   "will"
  ]
 },
 "koda": {
  "canonRoute": "2-koda",
  "totalPassages": 80,
  "routes": [
   {
    "channel": "2-koda",
    "passages": 64,
    "share": 0.8,
    "first": "2022-12-15",
    "last": "2023-01-09",
    "kind": "canon",
    "castWith": [
     "dillon",
     "polly",
     "kya_sg1",
     "kya_sg3",
     "declan",
     "sebastian_siren",
     "sebastian_vamp",
     "kaleb",
     "rowan",
     "diana"
    ]
   },
   {
    "channel": "the-werewolf-harem-bandwagon",
    "passages": 15,
    "share": 0.1875,
    "first": "2022-12-12",
    "last": "2022-12-15",
    "kind": "route",
    "castWith": [
     "declan",
     "haley_wolf",
     "haley_sg3",
     "diana",
     "god",
     "may",
     "mia"
    ]
   },
   {
    "channel": "1-declan-only",
    "passages": 1,
    "share": 0.0125,
    "first": "2023-01-10",
    "last": "2023-01-10",
    "kind": "route",
    "castWith": [
     "declan",
     "haley_wolf",
     "haley_sg3",
     "noah",
     "diana",
     "hercules"
    ]
   }
  ],
  "knownCharacters": [
   "dillon",
   "polly",
   "kya_sg1",
   "kya_sg3",
   "declan",
   "sebastian_siren",
   "sebastian_vamp",
   "kaleb",
   "rowan",
   "diana"
  ]
 },
 "shane": {
  "canonRoute": "a-tricky-micah-cruz-route",
  "totalPassages": 644,
  "routes": [
   {
    "channel": "a-tricky-micah-cruz-route",
    "passages": 227,
    "share": 0.3525,
    "first": "2023-08-11",
    "last": "2023-09-23",
    "kind": "canon",
    "castWith": [
     "eva",
     "ryder",
     "cruz",
     "micah",
     "trix",
     "allie",
     "evelyn",
     "roger",
     "audrey",
     "god",
     "bryce",
     "diana"
    ]
   },
   {
    "channel": "shane-micah-wish",
    "passages": 142,
    "share": 0.2205,
    "first": "2023-11-27",
    "last": "2023-12-12",
    "kind": "route",
    "castWith": [
     "eva",
     "cruz",
     "micah",
     "ryder",
     "god",
     "trix",
     "ever",
     "diana",
     "lucifer",
     "rex",
     "jack",
     "keller"
    ]
   },
   {
    "channel": "no-time-like-the-present",
    "passages": 107,
    "share": 0.1661,
    "first": "2023-09-24",
    "last": "2023-10-08",
    "kind": "route",
    "castWith": [
     "eva",
     "lance",
     "ryder",
     "allie",
     "cruz",
     "micah",
     "god",
     "aspen",
     "trix",
     "diana",
     "evelyn",
     "audrey"
    ]
   },
   {
    "channel": "micah\u2019s-experiment",
    "passages": 67,
    "share": 0.104,
    "first": "2024-11-28",
    "last": "2024-12-11",
    "kind": "route",
    "castWith": [
     "eva",
     "cruz",
     "ryder",
     "micah",
     "god",
     "trix",
     "may",
     "audrey",
     "diana"
    ]
   },
   {
    "channel": "ares-phones-home",
    "passages": 57,
    "share": 0.0885,
    "first": "2024-06-13",
    "last": "2024-11-27",
    "kind": "route",
    "castWith": [
     "eva",
     "cruz",
     "ryder",
     "ares",
     "roger",
     "diana",
     "allie",
     "micah",
     "cupid_eros",
     "penelope_valk",
     "evelyn",
     "lance"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 35,
    "share": 0.0543,
    "first": "2024-01-23",
    "last": "2025-02-05",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "ryder",
     "ford",
     "vaughn",
     "lance",
     "bryce",
     "dimitri",
     "allie",
     "micah",
     "audrey",
     "moros"
    ]
   },
   {
    "channel": "almost-alpha-eva",
    "passages": 8,
    "share": 0.0124,
    "first": "2025-10-01",
    "last": "2025-10-07",
    "kind": "route",
    "castWith": [
     "eva",
     "cruz",
     "ford",
     "bryce",
     "ryder",
     "robert",
     "roger",
     "red",
     "audrey",
     "rowan",
     "diana",
     "myra"
    ]
   },
   {
    "channel": "the-restaurant-chat-channel",
    "passages": 1,
    "share": 0.0016,
    "first": "2024-06-18",
    "last": "2024-06-18",
    "kind": "ooc",
    "castWith": [
     "cruz",
     "eric",
     "brooke",
     "eva",
     "will",
     "evelyn",
     "micah",
     "god",
     "may"
    ]
   }
  ],
  "knownCharacters": [
   "eva",
   "ryder",
   "cruz",
   "micah",
   "trix",
   "allie",
   "evelyn",
   "roger",
   "audrey",
   "god",
   "bryce",
   "diana"
  ]
 },
 "eva": {
  "canonRoute": "a-tricky-micah-cruz-route",
  "totalPassages": 974,
  "routes": [
   {
    "channel": "a-tricky-micah-cruz-route",
    "passages": 375,
    "share": 0.385,
    "first": "2023-08-10",
    "last": "2023-09-23",
    "kind": "canon",
    "castWith": [
     "shane",
     "ryder",
     "cruz",
     "micah",
     "trix",
     "allie",
     "evelyn",
     "roger",
     "audrey",
     "god",
     "bryce",
     "diana"
    ]
   },
   {
    "channel": "no-time-like-the-present",
    "passages": 197,
    "share": 0.2023,
    "first": "2023-09-24",
    "last": "2023-10-09",
    "kind": "route",
    "castWith": [
     "shane",
     "lance",
     "ryder",
     "allie",
     "cruz",
     "micah",
     "god",
     "aspen",
     "trix",
     "diana",
     "evelyn",
     "audrey"
    ]
   },
   {
    "channel": "shane-micah-wish",
    "passages": 172,
    "share": 0.1766,
    "first": "2023-11-27",
    "last": "2023-12-12",
    "kind": "route",
    "castWith": [
     "shane",
     "cruz",
     "micah",
     "ryder",
     "god",
     "trix",
     "ever",
     "diana",
     "lucifer",
     "rex",
     "jack",
     "keller"
    ]
   },
   {
    "channel": "ares-phones-home",
    "passages": 72,
    "share": 0.0739,
    "first": "2024-06-12",
    "last": "2024-11-28",
    "kind": "route",
    "castWith": [
     "shane",
     "cruz",
     "ryder",
     "ares",
     "roger",
     "diana",
     "allie",
     "micah",
     "cupid_eros",
     "penelope_valk",
     "evelyn",
     "lance"
    ]
   },
   {
    "channel": "micah\u2019s-experiment",
    "passages": 64,
    "share": 0.0657,
    "first": "2024-11-28",
    "last": "2024-12-11",
    "kind": "route",
    "castWith": [
     "shane",
     "cruz",
     "ryder",
     "micah",
     "god",
     "trix",
     "may",
     "audrey",
     "diana"
    ]
   },
   {
    "channel": "almost-alpha-eva",
    "passages": 43,
    "share": 0.0441,
    "first": "2025-09-30",
    "last": "2025-10-07",
    "kind": "route",
    "castWith": [
     "cruz",
     "ford",
     "bryce",
     "shane",
     "ryder",
     "robert",
     "roger",
     "red",
     "audrey",
     "rowan",
     "diana",
     "myra"
    ]
   },
   {
    "channel": "the-kingdom-fallon",
    "passages": 28,
    "share": 0.0287,
    "first": "2021-06-01",
    "last": "2021-06-14",
    "kind": "route",
    "castWith": [
     "evelyn",
     "rory",
     "raye",
     "fiadh",
     "ciarnan",
     "finn",
     "cailte",
     "senan",
     "diarmund",
     "fiann",
     "goll",
     "kaleb"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 10,
    "share": 0.0103,
    "first": "2025-02-03",
    "last": "2025-02-04",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "ryder",
     "ford",
     "vaughn",
     "lance",
     "bryce",
     "shane",
     "dimitri",
     "allie",
     "micah",
     "audrey"
    ]
   },
   {
    "channel": "fordsplosion",
    "passages": 8,
    "share": 0.0082,
    "first": "2024-03-11",
    "last": "2024-03-14",
    "kind": "route",
    "castWith": [
     "ford",
     "lachesis",
     "lucifer",
     "cruz",
     "clothos",
     "ryder",
     "god",
     "asrius",
     "ethan",
     "atropos",
     "may",
     "evelyn"
    ]
   },
   {
    "channel": "the-restaurant-chat-channel",
    "passages": 4,
    "share": 0.0041,
    "first": "2024-06-18",
    "last": "2024-06-18",
    "kind": "route",
    "castWith": [
     "cruz",
     "eric",
     "brooke",
     "will",
     "evelyn",
     "shane",
     "micah",
     "god",
     "may"
    ]
   },
   {
    "channel": "tyrant-evie-runs-away",
    "passages": 1,
    "share": 0.001,
    "first": "2022-01-14",
    "last": "2022-01-14",
    "kind": "route",
    "castWith": [
     "evelyn",
     "bryce",
     "aspen",
     "rio",
     "ace",
     "kaleb",
     "myra",
     "kya_sg3",
     "alistair",
     "alistair_turayne",
     "ezra",
     "rowan"
    ]
   }
  ],
  "knownCharacters": [
   "shane",
   "ryder",
   "cruz",
   "micah",
   "trix",
   "allie",
   "evelyn",
   "roger",
   "audrey",
   "god",
   "bryce",
   "diana"
  ]
 },
 "micah": {
  "canonRoute": "a-tricky-micah-cruz-route",
  "totalPassages": 247,
  "routes": [
   {
    "channel": "a-tricky-micah-cruz-route",
    "passages": 93,
    "share": 0.3765,
    "first": "2023-09-17",
    "last": "2023-09-23",
    "kind": "canon",
    "castWith": [
     "eva",
     "shane",
     "ryder",
     "cruz",
     "trix",
     "allie",
     "evelyn",
     "roger",
     "audrey",
     "god",
     "bryce",
     "diana"
    ]
   },
   {
    "channel": "shane-micah-wish",
    "passages": 74,
    "share": 0.2996,
    "first": "2023-11-27",
    "last": "2023-12-12",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "cruz",
     "ryder",
     "god",
     "trix",
     "ever",
     "diana",
     "lucifer",
     "rex",
     "jack",
     "keller"
    ]
   },
   {
    "channel": "no-time-like-the-present",
    "passages": 43,
    "share": 0.1741,
    "first": "2023-09-25",
    "last": "2023-10-08",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "lance",
     "ryder",
     "allie",
     "cruz",
     "god",
     "aspen",
     "trix",
     "diana",
     "evelyn",
     "audrey"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 20,
    "share": 0.081,
    "first": "2024-01-24",
    "last": "2025-02-23",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "ryder",
     "ford",
     "vaughn",
     "lance",
     "bryce",
     "shane",
     "dimitri",
     "allie",
     "audrey",
     "moros"
    ]
   },
   {
    "channel": "micah\u2019s-experiment",
    "passages": 11,
    "share": 0.0445,
    "first": "2024-11-30",
    "last": "2024-12-11",
    "kind": "route",
    "castWith": [
     "shane",
     "eva",
     "cruz",
     "ryder",
     "god",
     "trix",
     "may",
     "audrey",
     "diana"
    ]
   },
   {
    "channel": "switched-roles-lachesis",
    "passages": 3,
    "share": 0.0121,
    "first": "2023-10-12",
    "last": "2023-10-12",
    "kind": "au",
    "castWith": [
     "lachesis",
     "ford",
     "god",
     "lucifer",
     "cruz",
     "clothos",
     "atropos",
     "rowan",
     "vaughn",
     "ryder",
     "brax",
     "dimitri"
    ]
   },
   {
    "channel": "ares-phones-home",
    "passages": 2,
    "share": 0.0081,
    "first": "2024-11-25",
    "last": "2024-11-25",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "cruz",
     "ryder",
     "ares",
     "roger",
     "diana",
     "allie",
     "cupid_eros",
     "penelope_valk",
     "evelyn",
     "lance"
    ]
   },
   {
    "channel": "the-restaurant-chat-channel",
    "passages": 1,
    "share": 0.004,
    "first": "2024-06-18",
    "last": "2024-06-18",
    "kind": "ooc",
    "castWith": [
     "cruz",
     "eric",
     "brooke",
     "eva",
     "will",
     "evelyn",
     "shane",
     "god",
     "may"
    ]
   }
  ],
  "knownCharacters": [
   "eva",
   "shane",
   "ryder",
   "cruz",
   "trix",
   "allie",
   "evelyn",
   "roger",
   "audrey",
   "god",
   "bryce",
   "diana"
  ]
 },
 "cupid_eros": {
  "canonRoute": "cupid-hq",
  "totalPassages": 295,
  "routes": [
   {
    "channel": "cupid-hq",
    "passages": 50,
    "share": 0.1695,
    "first": "2020-06-03",
    "last": "2020-06-06",
    "kind": "canon",
    "castWith": [
     "sabrina_witch",
     "tim",
     "drake",
     "halo",
     "god",
     "aphrodite",
     "pam",
     "stan",
     "tom",
     "hiro",
     "ares",
     "hades"
    ]
   },
   {
    "channel": "wtf-happened",
    "passages": 39,
    "share": 0.1322,
    "first": "2023-08-29",
    "last": "2023-09-01",
    "kind": "route",
    "castWith": [
     "apollo",
     "moros",
     "atropos",
     "alistair",
     "alistair_turayne",
     "haley_wolf",
     "haley_human",
     "lachesis",
     "aphrodite",
     "zeus",
     "ezra",
     "god"
    ]
   },
   {
    "channel": "sabrinas-apartment",
    "passages": 34,
    "share": 0.1153,
    "first": "2020-06-03",
    "last": "2020-06-06",
    "kind": "route",
    "castWith": [
     "sabrina_witch",
     "aphrodite",
     "halo",
     "hiro",
     "ares",
     "athena",
     "demeter",
     "god",
     "roman"
    ]
   },
   {
    "channel": "mount-olympus",
    "passages": 26,
    "share": 0.0881,
    "first": "2020-06-06",
    "last": "2020-06-07",
    "kind": "route",
    "castWith": [
     "sabrina_witch",
     "dike",
     "hiro",
     "stella",
     "hades",
     "will"
    ]
   },
   {
    "channel": "cupid-and-kieran-sitting-in-a-tree",
    "passages": 23,
    "share": 0.078,
    "first": "2026-01-20",
    "last": "2026-02-03",
    "kind": "route",
    "castWith": [
     "kieran",
     "peter",
     "roman",
     "aphrodite",
     "apollo",
     "hera",
     "may"
    ]
   },
   {
    "channel": "ooc",
    "passages": 20,
    "share": 0.0678,
    "first": "2020-05-08",
    "last": "2020-06-21",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "kinley-is-a-nondecisive-butt",
    "passages": 12,
    "share": 0.0407,
    "first": "2022-03-24",
    "last": "2022-03-31",
    "kind": "route",
    "castWith": [
     "zain_demigod",
     "kinley",
     "apollo",
     "lex",
     "hera",
     "lachesis",
     "sebastian_vamp",
     "sebastian_siren",
     "ben",
     "god",
     "will",
     "zeus"
    ]
   },
   {
    "channel": "dream-dude",
    "passages": 7,
    "share": 0.0237,
    "first": "2024-04-08",
    "last": "2024-04-13",
    "kind": "route",
    "castWith": [
     "hermes",
     "moros",
     "atropos",
     "zeus",
     "lachesis",
     "apollo",
     "hercules",
     "haley_wolf",
     "haley_human",
     "nicole_human",
     "roman",
     "aphrodite"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 7,
    "share": 0.0237,
    "first": "2020-05-22",
    "last": "2020-06-03",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "nevada",
    "passages": 6,
    "share": 0.0203,
    "first": "2020-05-18",
    "last": "2020-05-20",
    "kind": "route",
    "castWith": [
     "hiro",
     "evelyn",
     "dike",
     "darren",
     "apollo",
     "ares",
     "hades",
     "will",
     "athena",
     "lucius",
     "god",
     "zeus"
    ]
   },
   {
    "channel": "lance-mating",
    "passages": 5,
    "share": 0.0169,
    "first": "2021-08-24",
    "last": "2021-08-24",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "clothos",
     "ryder",
     "hades",
     "nolan",
     "nicole_human",
     "audrey",
     "moros",
     "atropos",
     "nicole_wolf"
    ]
   },
   {
    "channel": "athena-class",
    "passages": 5,
    "share": 0.0169,
    "first": "2020-06-18",
    "last": "2020-06-19",
    "kind": "route",
    "castWith": [
     "rex",
     "evelyn",
     "kiro",
     "diana",
     "milo",
     "athena",
     "dimitri",
     "dike",
     "kya_sg1",
     "aaron",
     "kya_sg3",
     "hiro"
    ]
   }
  ],
  "knownCharacters": [
   "sabrina_witch",
   "tim",
   "drake",
   "halo",
   "god",
   "aphrodite",
   "pam",
   "stan",
   "tom",
   "hiro",
   "ares",
   "hades"
  ]
 },
 "halo": {
  "canonRoute": "cupid-hq",
  "totalPassages": 23,
  "routes": [
   {
    "channel": "cupid-hq",
    "passages": 8,
    "share": 0.3478,
    "first": "2020-06-04",
    "last": "2020-06-05",
    "kind": "canon",
    "castWith": [
     "cupid_eros",
     "sabrina_witch",
     "tim",
     "drake",
     "god",
     "aphrodite",
     "pam",
     "stan",
     "tom",
     "hiro",
     "ares",
     "hades"
    ]
   },
   {
    "channel": "ooc",
    "passages": 5,
    "share": 0.2174,
    "first": "2020-06-04",
    "last": "2020-06-05",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "sabrinas-apartment",
    "passages": 4,
    "share": 0.1739,
    "first": "2020-06-06",
    "last": "2020-06-06",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "sabrina_witch",
     "aphrodite",
     "hiro",
     "ares",
     "athena",
     "demeter",
     "god",
     "roman"
    ]
   },
   {
    "channel": "eat-speak-rp-repeat",
    "passages": 2,
    "share": 0.087,
    "first": "2026-04-02",
    "last": "2026-04-02",
    "kind": "ooc",
    "castWith": [
     "eric",
     "cruz",
     "lindon",
     "april",
     "lance",
     "felix_fairy",
     "brooke",
     "cyrus_fairy",
     "malakai",
     "god",
     "jack",
     "pam"
    ]
   },
   {
    "channel": "bios",
    "passages": 2,
    "share": 0.087,
    "first": "2020-06-04",
    "last": "2020-06-04",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "evelyn",
     "lucius",
     "athena",
     "bryce",
     "val",
     "hiro",
     "raz",
     "rex",
     "vanessa",
     "dalton",
     "cruz"
    ]
   },
   {
    "channel": "greek-house",
    "passages": 2,
    "share": 0.087,
    "first": "2020-05-08",
    "last": "2020-05-08",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hiro",
     "darren",
     "lex",
     "kiro",
     "raye",
     "kya_sg3",
     "ares",
     "riku",
     "kya_sg1",
     "lacie",
     "aphrodite"
    ]
   }
  ],
  "knownCharacters": [
   "cupid_eros",
   "sabrina_witch",
   "tim",
   "drake",
   "god",
   "aphrodite",
   "pam",
   "stan",
   "tom",
   "hiro",
   "ares",
   "hades"
  ]
 },
 "sabrina_witch": {
  "canonRoute": "new-fairy-route",
  "totalPassages": 141,
  "routes": [
   {
    "channel": "new-fairy-route",
    "passages": 57,
    "share": 0.4043,
    "first": "2023-03-02",
    "last": "2023-04-05",
    "kind": "canon",
    "castWith": [
     "holt",
     "archie",
     "kieran",
     "dutch",
     "cair",
     "claire",
     "atropos",
     "ever",
     "may"
    ]
   },
   {
    "channel": "cupid-hq",
    "passages": 30,
    "share": 0.2128,
    "first": "2020-06-03",
    "last": "2020-06-05",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "tim",
     "drake",
     "halo",
     "god",
     "aphrodite",
     "pam",
     "stan",
     "tom",
     "hiro",
     "ares",
     "hades"
    ]
   },
   {
    "channel": "sabrinas-apartment",
    "passages": 19,
    "share": 0.1348,
    "first": "2020-06-03",
    "last": "2020-06-06",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "aphrodite",
     "halo",
     "hiro",
     "ares",
     "athena",
     "demeter",
     "god",
     "roman"
    ]
   },
   {
    "channel": "mount-olympus",
    "passages": 16,
    "share": 0.1135,
    "first": "2020-06-06",
    "last": "2020-06-07",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "dike",
     "hiro",
     "stella",
     "hades",
     "will"
    ]
   },
   {
    "channel": "ooc",
    "passages": 9,
    "share": 0.0638,
    "first": "2020-06-04",
    "last": "2020-06-21",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "misc",
    "passages": 4,
    "share": 0.0284,
    "first": "2020-06-06",
    "last": "2020-06-06",
    "kind": "route",
    "castWith": [
     "aaron",
     "rowan",
     "evelyn",
     "kya_sg3",
     "kya_sg1",
     "lucius",
     "sebastian_vamp",
     "sebastian_siren",
     "rex",
     "cupid_eros",
     "george_campbell",
     "nellie"
    ]
   },
   {
    "channel": "cruz-x-human",
    "passages": 1,
    "share": 0.0071,
    "first": "2021-04-01",
    "last": "2021-04-01",
    "kind": "route",
    "castWith": [
     "cruz",
     "skye",
     "nolan",
     "ryder",
     "audrey",
     "troy",
     "adrien",
     "bryce",
     "airi",
     "natasha",
     "diana",
     "will"
    ]
   },
   {
    "channel": "college-possessive",
    "passages": 1,
    "share": 0.0071,
    "first": "2024-12-20",
    "last": "2024-12-20",
    "kind": "route",
    "castWith": [
     "leon",
     "moros",
     "apollo",
     "atropos",
     "lachesis",
     "haley_human",
     "haley_wolf",
     "clothos",
     "god",
     "may",
     "will",
     "zeus"
    ]
   },
   {
    "channel": "bios",
    "passages": 1,
    "share": 0.0071,
    "first": "2020-06-03",
    "last": "2020-06-03",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "evelyn",
     "lucius",
     "athena",
     "bryce",
     "val",
     "hiro",
     "raz",
     "rex",
     "vanessa",
     "halo",
     "dalton"
    ]
   },
   {
    "channel": "athena-class",
    "passages": 1,
    "share": 0.0071,
    "first": "2020-06-19",
    "last": "2020-06-19",
    "kind": "route",
    "castWith": [
     "rex",
     "evelyn",
     "kiro",
     "diana",
     "milo",
     "cupid_eros",
     "athena",
     "dimitri",
     "dike",
     "kya_sg1",
     "aaron",
     "kya_sg3"
    ]
   },
   {
    "channel": "dining-hall",
    "passages": 1,
    "share": 0.0071,
    "first": "2020-06-08",
    "last": "2020-06-08",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "bryce",
     "rex",
     "milo",
     "aaron",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "lex",
     "sebastian_vamp",
     "dike"
    ]
   },
   {
    "channel": "mt-olympus",
    "passages": 1,
    "share": 0.0071,
    "first": "2020-06-21",
    "last": "2020-06-21",
    "kind": "route",
    "castWith": [
     "evelyn",
     "libion",
     "ares",
     "rex",
     "persephone",
     "bion",
     "hades",
     "aphrodite",
     "hercules",
     "demeter",
     "zeus",
     "athena"
    ]
   }
  ],
  "knownCharacters": [
   "holt",
   "archie",
   "kieran",
   "dutch",
   "cair",
   "claire",
   "atropos",
   "ever",
   "may"
  ]
 },
 "agnar": {
  "canonRoute": "dorms",
  "totalPassages": 370,
  "routes": [
   {
    "channel": "dorms",
    "passages": 102,
    "share": 0.2757,
    "first": "2020-05-08",
    "last": "2020-05-18",
    "kind": "canon",
    "castWith": [
     "kya_sg3",
     "agmund",
     "evelyn",
     "raye",
     "cole",
     "kya_sg1",
     "riku",
     "kaleb",
     "penelope_valk",
     "loki",
     "svira",
     "darren"
    ]
   },
   {
    "channel": "college-campus",
    "passages": 95,
    "share": 0.2568,
    "first": "2020-05-10",
    "last": "2020-05-14",
    "kind": "route",
    "castWith": [
     "agmund",
     "kya_sg3",
     "penelope_valk",
     "evelyn",
     "svira",
     "rowan",
     "may",
     "jon",
     "kya_sg1",
     "kaleb",
     "darren",
     "cole"
    ]
   },
   {
    "channel": "asgard",
    "passages": 58,
    "share": 0.1568,
    "first": "2020-05-17",
    "last": "2020-05-21",
    "kind": "route",
    "castWith": [
     "agmund",
     "loki",
     "kya_sg3",
     "odin",
     "svira",
     "penelope_valk",
     "kya_sg1",
     "sif",
     "thor",
     "freya",
     "god",
     "frigg"
    ]
   },
   {
    "channel": "ag-ag",
    "passages": 42,
    "share": 0.1135,
    "first": "2022-10-01",
    "last": "2022-10-08",
    "kind": "route",
    "castWith": [
     "agmund",
     "loki",
     "frigg",
     "odin",
     "kya_sg3",
     "freya",
     "penelope_valk",
     "will",
     "evelyn",
     "sebastian_vamp",
     "sebastian_siren",
     "hiro"
    ]
   },
   {
    "channel": "ooc",
    "passages": 33,
    "share": 0.0892,
    "first": "2020-05-08",
    "last": "2020-06-08",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "cafeteria",
    "passages": 13,
    "share": 0.0351,
    "first": "2020-05-13",
    "last": "2020-05-13",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hiro",
     "agmund",
     "kya_sg3",
     "lex",
     "kaleb",
     "penelope_valk",
     "svira",
     "ares",
     "riku",
     "darren",
     "kya_sg1"
    ]
   },
   {
    "channel": "kya-college-2",
    "passages": 9,
    "share": 0.0243,
    "first": "2020-12-28",
    "last": "2020-12-28",
    "kind": "route",
    "castWith": [
     "lily",
     "zander",
     "kya_sg3",
     "kya_sg1",
     "ari",
     "sebastian_siren",
     "raye",
     "prince_zed",
     "sebastian_vamp",
     "midori_naga",
     "penelope_valk",
     "bell_lily_of_fell"
    ]
   },
   {
    "channel": "agnar-agmus-house",
    "passages": 9,
    "share": 0.0243,
    "first": "2020-05-18",
    "last": "2020-05-19",
    "kind": "route",
    "castWith": [
     "agmund",
     "loki",
     "kya_sg3"
    ]
   },
   {
    "channel": "calls",
    "passages": 4,
    "share": 0.0108,
    "first": "2020-05-19",
    "last": "2020-05-19",
    "kind": "route",
    "castWith": [
     "evelyn",
     "kya_sg1",
     "kya_sg3",
     "hiro",
     "rowan",
     "ezra"
    ]
   },
   {
    "channel": "dining-hall",
    "passages": 3,
    "share": 0.0081,
    "first": "2020-06-08",
    "last": "2020-06-08",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "bryce",
     "rex",
     "milo",
     "aaron",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "lex",
     "sebastian_vamp",
     "dike"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 1,
    "share": 0.0027,
    "first": "2020-05-22",
    "last": "2020-05-22",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "greek-house",
    "passages": 1,
    "share": 0.0027,
    "first": "2020-05-09",
    "last": "2020-05-09",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hiro",
     "darren",
     "lex",
     "kiro",
     "raye",
     "kya_sg3",
     "ares",
     "riku",
     "kya_sg1",
     "lacie",
     "aphrodite"
    ]
   }
  ],
  "knownCharacters": [
   "kya_sg3",
   "agmund",
   "evelyn",
   "raye",
   "cole",
   "kya_sg1",
   "riku",
   "kaleb",
   "penelope_valk",
   "loki",
   "svira",
   "darren"
  ]
 },
 "agmund": {
  "canonRoute": "dorms",
  "totalPassages": 253,
  "routes": [
   {
    "channel": "dorms",
    "passages": 75,
    "share": 0.2964,
    "first": "2020-05-08",
    "last": "2020-05-18",
    "kind": "canon",
    "castWith": [
     "agnar",
     "kya_sg3",
     "evelyn",
     "raye",
     "cole",
     "kya_sg1",
     "riku",
     "kaleb",
     "penelope_valk",
     "loki",
     "svira",
     "darren"
    ]
   },
   {
    "channel": "asgard",
    "passages": 58,
    "share": 0.2292,
    "first": "2020-05-17",
    "last": "2020-05-21",
    "kind": "route",
    "castWith": [
     "agnar",
     "loki",
     "kya_sg3",
     "odin",
     "svira",
     "penelope_valk",
     "kya_sg1",
     "sif",
     "thor",
     "freya",
     "god",
     "frigg"
    ]
   },
   {
    "channel": "college-campus",
    "passages": 37,
    "share": 0.1462,
    "first": "2020-05-10",
    "last": "2020-05-14",
    "kind": "route",
    "castWith": [
     "agnar",
     "kya_sg3",
     "penelope_valk",
     "evelyn",
     "svira",
     "rowan",
     "may",
     "jon",
     "kya_sg1",
     "kaleb",
     "darren",
     "cole"
    ]
   },
   {
    "channel": "ag-ag",
    "passages": 35,
    "share": 0.1383,
    "first": "2022-10-03",
    "last": "2022-10-08",
    "kind": "route",
    "castWith": [
     "agnar",
     "loki",
     "frigg",
     "odin",
     "kya_sg3",
     "freya",
     "penelope_valk",
     "will",
     "evelyn",
     "sebastian_vamp",
     "sebastian_siren",
     "hiro"
    ]
   },
   {
    "channel": "ooc",
    "passages": 17,
    "share": 0.0672,
    "first": "2020-05-13",
    "last": "2020-06-08",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "cafeteria",
    "passages": 11,
    "share": 0.0435,
    "first": "2020-05-13",
    "last": "2020-05-13",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hiro",
     "agnar",
     "kya_sg3",
     "lex",
     "kaleb",
     "penelope_valk",
     "svira",
     "ares",
     "riku",
     "darren",
     "kya_sg1"
    ]
   },
   {
    "channel": "agnar-agmus-house",
    "passages": 10,
    "share": 0.0395,
    "first": "2020-05-18",
    "last": "2020-05-19",
    "kind": "route",
    "castWith": [
     "agnar",
     "loki",
     "kya_sg3"
    ]
   },
   {
    "channel": "kya-college-2",
    "passages": 8,
    "share": 0.0316,
    "first": "2020-12-28",
    "last": "2020-12-28",
    "kind": "route",
    "castWith": [
     "lily",
     "zander",
     "kya_sg3",
     "kya_sg1",
     "ari",
     "sebastian_siren",
     "raye",
     "prince_zed",
     "sebastian_vamp",
     "midori_naga",
     "penelope_valk",
     "bell_lily_of_fell"
    ]
   },
   {
    "channel": "dining-hall",
    "passages": 2,
    "share": 0.0079,
    "first": "2020-06-08",
    "last": "2020-06-08",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "bryce",
     "rex",
     "milo",
     "aaron",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "lex",
     "sebastian_vamp",
     "dike"
    ]
   }
  ],
  "knownCharacters": [
   "agnar",
   "kya_sg3",
   "evelyn",
   "raye",
   "cole",
   "kya_sg1",
   "riku",
   "kaleb",
   "penelope_valk",
   "loki",
   "svira",
   "darren"
  ]
 },
 "penelope_valk": {
  "canonRoute": "college-campus",
  "totalPassages": 87,
  "routes": [
   {
    "channel": "college-campus",
    "passages": 30,
    "share": 0.3448,
    "first": "2020-05-10",
    "last": "2020-05-14",
    "kind": "canon",
    "castWith": [
     "agnar",
     "agmund",
     "kya_sg3",
     "evelyn",
     "svira",
     "rowan",
     "may",
     "jon",
     "kya_sg1",
     "kaleb",
     "darren",
     "cole"
    ]
   },
   {
    "channel": "dorms",
    "passages": 19,
    "share": 0.2184,
    "first": "2020-05-07",
    "last": "2020-05-18",
    "kind": "route",
    "castWith": [
     "agnar",
     "kya_sg3",
     "agmund",
     "evelyn",
     "raye",
     "cole",
     "kya_sg1",
     "riku",
     "kaleb",
     "loki",
     "svira",
     "darren"
    ]
   },
   {
    "channel": "kya-college-2",
    "passages": 12,
    "share": 0.1379,
    "first": "2020-12-27",
    "last": "2020-12-28",
    "kind": "route",
    "castWith": [
     "lily",
     "zander",
     "kya_sg3",
     "kya_sg1",
     "ari",
     "sebastian_siren",
     "raye",
     "prince_zed",
     "sebastian_vamp",
     "midori_naga",
     "bell_lily_of_fell",
     "agnar"
    ]
   },
   {
    "channel": "asgard",
    "passages": 8,
    "share": 0.092,
    "first": "2020-05-18",
    "last": "2020-05-20",
    "kind": "route",
    "castWith": [
     "agnar",
     "agmund",
     "loki",
     "kya_sg3",
     "odin",
     "svira",
     "kya_sg1",
     "sif",
     "thor",
     "freya",
     "god",
     "frigg"
    ]
   },
   {
    "channel": "ooc",
    "passages": 5,
    "share": 0.0575,
    "first": "2020-05-08",
    "last": "2020-06-07",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "cafeteria",
    "passages": 5,
    "share": 0.0575,
    "first": "2020-05-13",
    "last": "2020-05-13",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hiro",
     "agnar",
     "agmund",
     "kya_sg3",
     "lex",
     "kaleb",
     "svira",
     "ares",
     "riku",
     "darren",
     "kya_sg1"
    ]
   },
   {
    "channel": "ag-ag",
    "passages": 3,
    "share": 0.0345,
    "first": "2022-10-08",
    "last": "2022-10-08",
    "kind": "route",
    "castWith": [
     "agnar",
     "agmund",
     "loki",
     "frigg",
     "odin",
     "kya_sg3",
     "freya",
     "will",
     "evelyn",
     "sebastian_vamp",
     "sebastian_siren",
     "hiro"
    ]
   },
   {
    "channel": "ares-phones-home",
    "passages": 2,
    "share": 0.023,
    "first": "2024-11-25",
    "last": "2024-11-26",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "cruz",
     "ryder",
     "ares",
     "roger",
     "diana",
     "allie",
     "micah",
     "cupid_eros",
     "evelyn",
     "lance"
    ]
   },
   {
    "channel": "cruz-x-human",
    "passages": 1,
    "share": 0.0115,
    "first": "2021-05-02",
    "last": "2021-05-02",
    "kind": "route",
    "castWith": [
     "cruz",
     "skye",
     "nolan",
     "ryder",
     "audrey",
     "troy",
     "adrien",
     "bryce",
     "airi",
     "natasha",
     "diana",
     "will"
    ]
   },
   {
    "channel": "kya-gets-dillon",
    "passages": 1,
    "share": 0.0115,
    "first": "2024-02-13",
    "last": "2024-02-13",
    "kind": "route",
    "castWith": [
     "dillon",
     "kya_sg3",
     "sebastian_siren",
     "kya_sg1"
    ]
   },
   {
    "channel": "dining-hall",
    "passages": 1,
    "share": 0.0115,
    "first": "2020-06-08",
    "last": "2020-06-08",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "bryce",
     "rex",
     "milo",
     "aaron",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "lex",
     "sebastian_vamp",
     "dike"
    ]
   }
  ],
  "knownCharacters": [
   "agnar",
   "agmund",
   "kya_sg3",
   "evelyn",
   "svira",
   "rowan",
   "may",
   "jon",
   "kya_sg1",
   "kaleb",
   "darren",
   "cole"
  ]
 },
 "svira": {
  "canonRoute": "college-campus",
  "totalPassages": 73,
  "routes": [
   {
    "channel": "college-campus",
    "passages": 22,
    "share": 0.3014,
    "first": "2020-05-09",
    "last": "2020-05-14",
    "kind": "canon",
    "castWith": [
     "agnar",
     "agmund",
     "kya_sg3",
     "penelope_valk",
     "evelyn",
     "rowan",
     "may",
     "jon",
     "kya_sg1",
     "kaleb",
     "darren",
     "cole"
    ]
   },
   {
    "channel": "dorms",
    "passages": 18,
    "share": 0.2466,
    "first": "2020-05-07",
    "last": "2020-05-09",
    "kind": "route",
    "castWith": [
     "agnar",
     "kya_sg3",
     "agmund",
     "evelyn",
     "raye",
     "cole",
     "kya_sg1",
     "riku",
     "kaleb",
     "penelope_valk",
     "loki",
     "darren"
    ]
   },
   {
    "channel": "asgard",
    "passages": 15,
    "share": 0.2055,
    "first": "2020-05-20",
    "last": "2020-05-21",
    "kind": "route",
    "castWith": [
     "agnar",
     "agmund",
     "loki",
     "kya_sg3",
     "odin",
     "penelope_valk",
     "kya_sg1",
     "sif",
     "thor",
     "freya",
     "god",
     "frigg"
    ]
   },
   {
    "channel": "kya-college-2",
    "passages": 9,
    "share": 0.1233,
    "first": "2020-12-27",
    "last": "2020-12-28",
    "kind": "route",
    "castWith": [
     "lily",
     "zander",
     "kya_sg3",
     "kya_sg1",
     "ari",
     "sebastian_siren",
     "raye",
     "prince_zed",
     "sebastian_vamp",
     "midori_naga",
     "penelope_valk",
     "bell_lily_of_fell"
    ]
   },
   {
    "channel": "ooc",
    "passages": 5,
    "share": 0.0685,
    "first": "2020-05-09",
    "last": "2020-05-14",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "cafeteria",
    "passages": 3,
    "share": 0.0411,
    "first": "2020-05-13",
    "last": "2020-05-13",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hiro",
     "agnar",
     "agmund",
     "kya_sg3",
     "lex",
     "kaleb",
     "penelope_valk",
     "ares",
     "riku",
     "darren",
     "kya_sg1"
    ]
   },
   {
    "channel": "ag-ag",
    "passages": 1,
    "share": 0.0137,
    "first": "2022-10-08",
    "last": "2022-10-08",
    "kind": "route",
    "castWith": [
     "agnar",
     "agmund",
     "loki",
     "frigg",
     "odin",
     "kya_sg3",
     "freya",
     "penelope_valk",
     "will",
     "evelyn",
     "sebastian_vamp",
     "sebastian_siren"
    ]
   }
  ],
  "knownCharacters": [
   "agnar",
   "agmund",
   "kya_sg3",
   "penelope_valk",
   "evelyn",
   "rowan",
   "may",
   "jon",
   "kya_sg1",
   "kaleb",
   "darren",
   "cole"
  ]
 },
 "bennett": {
  "canonRoute": "kingdom-of-temprum",
  "totalPassages": 228,
  "routes": [
   {
    "channel": "kingdom-of-temprum",
    "passages": 83,
    "share": 0.364,
    "first": "2020-05-22",
    "last": "2020-06-01",
    "kind": "canon",
    "castWith": [
     "aria",
     "benji",
     "ajax",
     "naveed",
     "fawn",
     "bast",
     "solum",
     "caria",
     "neitl",
     "batiuba",
     "will",
     "kaleb"
    ]
   },
   {
    "channel": "foyer-living-room",
    "passages": 65,
    "share": 0.2851,
    "first": "2020-04-07",
    "last": "2020-05-22",
    "kind": "route",
    "castWith": [
     "aria",
     "benji",
     "ajax",
     "ragland",
     "rin",
     "kent",
     "miles",
     "may"
    ]
   },
   {
    "channel": "kingdom-of-wellis",
    "passages": 36,
    "share": 0.1579,
    "first": "2020-06-01",
    "last": "2020-06-03",
    "kind": "route",
    "castWith": [
     "aria",
     "benji",
     "caria",
     "ajax",
     "ever",
     "ben",
     "solum"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 20,
    "share": 0.0877,
    "first": "2020-04-09",
    "last": "2020-06-03",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "geo",
     "cruz",
     "eric"
    ]
   },
   {
    "channel": "bennett-and-benji-wing",
    "passages": 11,
    "share": 0.0482,
    "first": "2020-05-21",
    "last": "2020-05-21",
    "kind": "route",
    "castWith": [
     "benji",
     "aria",
     "ben",
     "will"
    ]
   },
   {
    "channel": "memory-char-bios",
    "passages": 3,
    "share": 0.0132,
    "first": "2020-04-01",
    "last": "2020-05-22",
    "kind": "route",
    "castWith": [
     "benji",
     "miles",
     "ajax",
     "kent",
     "ragland",
     "rin",
     "aria"
    ]
   },
   {
    "channel": "makeshift-attic-bedroom",
    "passages": 3,
    "share": 0.0132,
    "first": "2020-04-08",
    "last": "2020-04-08",
    "kind": "route",
    "castWith": [
     "aria",
     "benji",
     "ragland",
     "ajax",
     "miles"
    ]
   },
   {
    "channel": "eros-and-kent-wing",
    "passages": 3,
    "share": 0.0132,
    "first": "2020-04-10",
    "last": "2020-04-12",
    "kind": "route",
    "castWith": [
     "aria",
     "ragland",
     "benji",
     "ajax",
     "kent",
     "miles",
     "will"
    ]
   },
   {
    "channel": "mansion-grounds",
    "passages": 2,
    "share": 0.0088,
    "first": "2020-04-09",
    "last": "2020-04-09",
    "kind": "route",
    "castWith": [
     "aria",
     "kent",
     "miles",
     "ajax",
     "benji",
     "rin",
     "ever"
    ]
   },
   {
    "channel": "esu",
    "passages": 1,
    "share": 0.0044,
    "first": "2025-01-06",
    "last": "2025-01-06",
    "kind": "route",
    "castWith": [
     "leon",
     "trenton",
     "richard_antore",
     "will"
    ]
   },
   {
    "channel": "ooc",
    "passages": 1,
    "share": 0.0044,
    "first": "2020-05-18",
    "last": "2020-05-18",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   }
  ],
  "knownCharacters": [
   "aria",
   "benji",
   "ajax",
   "naveed",
   "fawn",
   "bast",
   "solum",
   "caria",
   "neitl",
   "batiuba",
   "will",
   "kaleb"
  ]
 },
 "benji": {
  "canonRoute": "foyer-living-room",
  "totalPassages": 196,
  "routes": [
   {
    "channel": "foyer-living-room",
    "passages": 67,
    "share": 0.3418,
    "first": "2020-04-08",
    "last": "2020-05-22",
    "kind": "canon",
    "castWith": [
     "aria",
     "bennett",
     "ajax",
     "ragland",
     "rin",
     "kent",
     "miles",
     "may"
    ]
   },
   {
    "channel": "kingdom-of-temprum",
    "passages": 63,
    "share": 0.3214,
    "first": "2020-05-22",
    "last": "2020-05-31",
    "kind": "route",
    "castWith": [
     "aria",
     "bennett",
     "ajax",
     "naveed",
     "fawn",
     "bast",
     "solum",
     "caria",
     "neitl",
     "batiuba",
     "will",
     "kaleb"
    ]
   },
   {
    "channel": "kingdom-of-wellis",
    "passages": 28,
    "share": 0.1429,
    "first": "2020-06-01",
    "last": "2020-06-03",
    "kind": "route",
    "castWith": [
     "aria",
     "bennett",
     "caria",
     "ajax",
     "ever",
     "ben",
     "solum"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 14,
    "share": 0.0714,
    "first": "2020-04-12",
    "last": "2020-05-31",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "bennett-and-benji-wing",
    "passages": 9,
    "share": 0.0459,
    "first": "2020-05-21",
    "last": "2020-05-21",
    "kind": "route",
    "castWith": [
     "bennett",
     "aria",
     "ben",
     "will"
    ]
   },
   {
    "channel": "makeshift-attic-bedroom",
    "passages": 5,
    "share": 0.0255,
    "first": "2020-04-08",
    "last": "2020-04-08",
    "kind": "route",
    "castWith": [
     "aria",
     "ragland",
     "bennett",
     "ajax",
     "miles"
    ]
   },
   {
    "channel": "mansion-grounds",
    "passages": 4,
    "share": 0.0204,
    "first": "2020-04-09",
    "last": "2020-04-09",
    "kind": "route",
    "castWith": [
     "aria",
     "kent",
     "miles",
     "ajax",
     "rin",
     "bennett",
     "ever"
    ]
   },
   {
    "channel": "memory-char-bios",
    "passages": 3,
    "share": 0.0153,
    "first": "2020-04-01",
    "last": "2020-05-22",
    "kind": "route",
    "castWith": [
     "bennett",
     "miles",
     "ajax",
     "kent",
     "ragland",
     "rin",
     "aria"
    ]
   },
   {
    "channel": "eros-and-kent-wing",
    "passages": 2,
    "share": 0.0102,
    "first": "2020-04-10",
    "last": "2020-04-12",
    "kind": "route",
    "castWith": [
     "aria",
     "bennett",
     "ragland",
     "ajax",
     "kent",
     "miles",
     "will"
    ]
   },
   {
    "channel": "ooc",
    "passages": 1,
    "share": 0.0051,
    "first": "2020-05-18",
    "last": "2020-05-18",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   }
  ],
  "knownCharacters": [
   "aria",
   "bennett",
   "ajax",
   "ragland",
   "rin",
   "kent",
   "miles",
   "may"
  ]
 },
 "aria": {
  "canonRoute": "kingdom-of-temprum",
  "totalPassages": 595,
  "routes": [
   {
    "channel": "kingdom-of-temprum",
    "passages": 157,
    "share": 0.2639,
    "first": "2020-05-22",
    "last": "2020-06-01",
    "kind": "canon",
    "castWith": [
     "bennett",
     "benji",
     "ajax",
     "naveed",
     "fawn",
     "bast",
     "solum",
     "caria",
     "neitl",
     "batiuba",
     "will",
     "kaleb"
    ]
   },
   {
    "channel": "foyer-living-room",
    "passages": 103,
    "share": 0.1731,
    "first": "2020-04-07",
    "last": "2020-05-22",
    "kind": "route",
    "castWith": [
     "benji",
     "bennett",
     "ajax",
     "ragland",
     "rin",
     "kent",
     "miles",
     "may"
    ]
   },
   {
    "channel": "kingdom-of-welis",
    "passages": 73,
    "share": 0.1227,
    "first": "2020-04-12",
    "last": "2020-04-14",
    "kind": "route",
    "castWith": [
     "caria",
     "ajax",
     "batiuba",
     "ragland",
     "kent",
     "will"
    ]
   },
   {
    "channel": "kingdom-of-wellis",
    "passages": 64,
    "share": 0.1076,
    "first": "2020-06-01",
    "last": "2020-06-03",
    "kind": "route",
    "castWith": [
     "bennett",
     "benji",
     "caria",
     "ajax",
     "ever",
     "ben",
     "solum"
    ]
   },
   {
    "channel": "mansion-grounds",
    "passages": 51,
    "share": 0.0857,
    "first": "2020-04-09",
    "last": "2020-04-09",
    "kind": "route",
    "castWith": [
     "kent",
     "miles",
     "ajax",
     "benji",
     "rin",
     "bennett",
     "ever"
    ]
   },
   {
    "channel": "eros-and-kent-wing",
    "passages": 34,
    "share": 0.0571,
    "first": "2020-04-09",
    "last": "2020-04-12",
    "kind": "route",
    "castWith": [
     "bennett",
     "ragland",
     "benji",
     "ajax",
     "kent",
     "miles",
     "will"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 33,
    "share": 0.0555,
    "first": "2020-04-08",
    "last": "2020-06-01",
    "kind": "route",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz",
     "eric"
    ]
   },
   {
    "channel": "rin-and-ragland-wing",
    "passages": 23,
    "share": 0.0387,
    "first": "2020-04-11",
    "last": "2020-04-12",
    "kind": "route",
    "castWith": [
     "ragland",
     "rin",
     "ajax",
     "miles",
     "kent"
    ]
   },
   {
    "channel": "ajax-and-miles-wing",
    "passages": 22,
    "share": 0.037,
    "first": "2020-04-10",
    "last": "2020-04-11",
    "kind": "route",
    "castWith": [
     "ajax",
     "ragland"
    ]
   },
   {
    "channel": "ooc",
    "passages": 10,
    "share": 0.0168,
    "first": "2020-04-23",
    "last": "2020-12-15",
    "kind": "route",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "makeshift-attic-bedroom",
    "passages": 10,
    "share": 0.0168,
    "first": "2020-04-08",
    "last": "2020-04-08",
    "kind": "route",
    "castWith": [
     "benji",
     "ragland",
     "bennett",
     "ajax",
     "miles"
    ]
   },
   {
    "channel": "bennett-and-benji-wing",
    "passages": 9,
    "share": 0.0151,
    "first": "2020-05-21",
    "last": "2020-05-21",
    "kind": "route",
    "castWith": [
     "bennett",
     "benji",
     "ben",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "bennett",
   "benji",
   "ajax",
   "naveed",
   "fawn",
   "bast",
   "solum",
   "caria",
   "neitl",
   "batiuba",
   "will",
   "kaleb"
  ]
 },
 "talon_char": {
  "canonRoute": "ramesville",
  "totalPassages": 454,
  "routes": [
   {
    "channel": "ramesville",
    "passages": 194,
    "share": 0.4273,
    "first": "2020-04-10",
    "last": "2020-06-01",
    "kind": "canon",
    "castWith": [
     "stella",
     "ronin_tempus",
     "melisende",
     "exis",
     "raze",
     "satella",
     "dimitri",
     "vanessa",
     "raye",
     "raz",
     "will"
    ]
   },
   {
    "channel": "country-road-take-me-home",
    "passages": 79,
    "share": 0.174,
    "first": "2020-04-09",
    "last": "2020-04-13",
    "kind": "route",
    "castWith": [
     "stella",
     "ronin_tempus",
     "melisende",
     "dimitri",
     "raze",
     "exis",
     "yuu",
     "god",
     "will"
    ]
   },
   {
    "channel": "troterra-kingdom",
    "passages": 76,
    "share": 0.1674,
    "first": "2020-04-05",
    "last": "2020-06-03",
    "kind": "route",
    "castWith": [
     "stella",
     "ronin_tempus",
     "raze",
     "melisende",
     "dimitri",
     "satella",
     "silas_mirace",
     "vincent",
     "exis",
     "god",
     "may",
     "mikaela_hyakuya"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 63,
    "share": 0.1388,
    "first": "2020-04-04",
    "last": "2020-06-03",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz",
     "eric"
    ]
   },
   {
    "channel": "ooc",
    "passages": 24,
    "share": 0.0529,
    "first": "2020-04-26",
    "last": "2020-06-07",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "abandoned-building",
    "passages": 7,
    "share": 0.0154,
    "first": "2020-04-13",
    "last": "2020-04-13",
    "kind": "route",
    "castWith": [
     "stella",
     "ronin_tempus",
     "exis",
     "satella",
     "melisende",
     "raze"
    ]
   },
   {
    "channel": "ronin-tempus-castle",
    "passages": 4,
    "share": 0.0088,
    "first": "2020-04-04",
    "last": "2020-04-04",
    "kind": "route",
    "castWith": [
     "stella",
     "ronin_tempus",
     "raze",
     "melisende",
     "kya_sg3",
     "may",
     "silas_mirace",
     "will"
    ]
   },
   {
    "channel": "mages-tower",
    "passages": 3,
    "share": 0.0066,
    "first": "2020-04-11",
    "last": "2020-04-11",
    "kind": "route",
    "castWith": [
     "exis",
     "stella",
     "melisende",
     "ronin_tempus"
    ]
   },
   {
    "channel": "prince-char-bios",
    "passages": 2,
    "share": 0.0044,
    "first": "2020-04-01",
    "last": "2020-05-22",
    "kind": "route",
    "castWith": [
     "ronin_tempus",
     "stella",
     "dimitri",
     "melisende",
     "mikaela_hyakuya",
     "raze",
     "silas_mirace",
     "theo_uoki",
     "yuu",
     "vincent"
    ]
   },
   {
    "channel": "college-campus",
    "passages": 1,
    "share": 0.0022,
    "first": "2020-05-25",
    "last": "2020-05-25",
    "kind": "route",
    "castWith": [
     "agnar",
     "agmund",
     "kya_sg3",
     "penelope_valk",
     "evelyn",
     "svira",
     "rowan",
     "may",
     "jon",
     "kya_sg1",
     "kaleb",
     "darren"
    ]
   },
   {
    "channel": "dimitri-castle",
    "passages": 1,
    "share": 0.0022,
    "first": "2020-04-06",
    "last": "2020-04-06",
    "kind": "route",
    "castWith": [
     "dimitri",
     "evelyn",
     "stella",
     "ronin_tempus",
     "kaleb",
     "melisende",
     "mr_han_sr",
     "gambit",
     "frau",
     "silas_mirace",
     "theo_uoki",
     "toko"
    ]
   }
  ],
  "knownCharacters": [
   "stella",
   "ronin_tempus",
   "melisende",
   "exis",
   "raze",
   "satella",
   "dimitri",
   "vanessa",
   "raye",
   "raz",
   "will"
  ]
 },
 "stella": {
  "canonRoute": "troterra-kingdom",
  "totalPassages": 881,
  "routes": [
   {
    "channel": "troterra-kingdom",
    "passages": 209,
    "share": 0.2372,
    "first": "2020-04-01",
    "last": "2020-06-03",
    "kind": "canon",
    "castWith": [
     "ronin_tempus",
     "raze",
     "talon_char",
     "melisende",
     "dimitri",
     "satella",
     "silas_mirace",
     "vincent",
     "exis",
     "god",
     "may",
     "mikaela_hyakuya"
    ]
   },
   {
    "channel": "ramesville",
    "passages": 206,
    "share": 0.2338,
    "first": "2020-04-01",
    "last": "2020-06-01",
    "kind": "route",
    "castWith": [
     "talon_char",
     "ronin_tempus",
     "melisende",
     "exis",
     "raze",
     "satella",
     "dimitri",
     "vanessa",
     "raye",
     "raz",
     "will"
    ]
   },
   {
    "channel": "country-road-take-me-home",
    "passages": 114,
    "share": 0.1294,
    "first": "2020-04-09",
    "last": "2020-04-13",
    "kind": "route",
    "castWith": [
     "ronin_tempus",
     "talon_char",
     "melisende",
     "dimitri",
     "raze",
     "exis",
     "yuu",
     "god",
     "will"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 89,
    "share": 0.101,
    "first": "2020-04-01",
    "last": "2020-06-02",
    "kind": "ooc",
    "castWith": [
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz",
     "eric"
    ]
   },
   {
    "channel": "silas-mirace-castle",
    "passages": 61,
    "share": 0.0692,
    "first": "2020-04-02",
    "last": "2020-04-03",
    "kind": "route",
    "castWith": [
     "silas_mirace",
     "melisende",
     "raze",
     "may"
    ]
   },
   {
    "channel": "ronin-tempus-castle",
    "passages": 53,
    "share": 0.0602,
    "first": "2020-04-03",
    "last": "2020-04-04",
    "kind": "route",
    "castWith": [
     "ronin_tempus",
     "raze",
     "melisende",
     "talon_char",
     "kya_sg3",
     "may",
     "silas_mirace",
     "will"
    ]
   },
   {
    "channel": "dimitri-castle",
    "passages": 52,
    "share": 0.059,
    "first": "2020-04-06",
    "last": "2020-04-07",
    "kind": "route",
    "castWith": [
     "dimitri",
     "evelyn",
     "ronin_tempus",
     "kaleb",
     "melisende",
     "mr_han_sr",
     "gambit",
     "frau",
     "silas_mirace",
     "theo_uoki",
     "toko",
     "raye"
    ]
   },
   {
    "channel": "theo-uoki-castle",
    "passages": 32,
    "share": 0.0363,
    "first": "2020-04-03",
    "last": "2020-04-03",
    "kind": "route",
    "castWith": [
     "theo_uoki",
     "raze",
     "melisende",
     "frank",
     "tom",
     "yuu",
     "silas_mirace",
     "vincent",
     "ronin_tempus"
    ]
   },
   {
    "channel": "abandoned-building",
    "passages": 24,
    "share": 0.0272,
    "first": "2020-04-13",
    "last": "2020-04-13",
    "kind": "route",
    "castWith": [
     "ronin_tempus",
     "exis",
     "satella",
     "talon_char",
     "melisende",
     "raze"
    ]
   },
   {
    "channel": "mikaera-hyakuya-castle",
    "passages": 23,
    "share": 0.0261,
    "first": "2020-04-02",
    "last": "2020-04-02",
    "kind": "route",
    "castWith": [
     "yuu",
     "melisende",
     "raze",
     "may"
    ]
   },
   {
    "channel": "ooc",
    "passages": 7,
    "share": 0.0079,
    "first": "2020-04-16",
    "last": "2020-12-15",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "mages-tower",
    "passages": 7,
    "share": 0.0079,
    "first": "2020-04-11",
    "last": "2020-04-11",
    "kind": "route",
    "castWith": [
     "exis",
     "talon_char",
     "melisende",
     "ronin_tempus"
    ]
   }
  ],
  "knownCharacters": [
   "ronin_tempus",
   "raze",
   "talon_char",
   "melisende",
   "dimitri",
   "satella",
   "silas_mirace",
   "vincent",
   "exis",
   "god",
   "may",
   "mikaela_hyakuya"
  ]
 },
 "dillon": {
  "canonRoute": "dillon-knows",
  "totalPassages": 1154,
  "routes": [
   {
    "channel": "dillon-knows",
    "passages": 170,
    "share": 0.1473,
    "first": "2025-11-10",
    "last": "2025-12-17",
    "kind": "canon",
    "castWith": [
     "kyo",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "kaleb",
     "sebastian_vamp",
     "ever",
     "will",
     "lachesis",
     "amoura",
     "hadrian",
     "may"
    ]
   },
   {
    "channel": "hottie-seb-is-dead",
    "passages": 81,
    "share": 0.0702,
    "first": "2022-10-26",
    "last": "2022-11-04",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "mateo_aurlease",
     "kya_sg1",
     "sebastian_vamp",
     "sebastian_siren",
     "evelyn",
     "ever",
     "apollo",
     "roger"
    ]
   },
   {
    "channel": "kya-seb-nice-uncle",
    "passages": 70,
    "share": 0.0607,
    "first": "2025-12-20",
    "last": "2026-01-16",
    "kind": "route",
    "castWith": [
     "aaron",
     "kaleb",
     "kyo",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "polly",
     "evelyn",
     "sebastian_vamp",
     "frau",
     "ami",
     "may"
    ]
   },
   {
    "channel": "fantastical-ezra",
    "passages": 63,
    "share": 0.0546,
    "first": "2025-02-19",
    "last": "2025-03-04",
    "kind": "route",
    "castWith": [
     "ezra",
     "kaleb",
     "apollo",
     "kya_sg3",
     "james",
     "sebastian_vamp",
     "evelyn",
     "kya_sg1",
     "haley_human",
     "sebastian_siren",
     "skipper",
     "polly"
    ]
   },
   {
    "channel": "separated-seb",
    "passages": 56,
    "share": 0.0485,
    "first": "2023-09-02",
    "last": "2024-02-20",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "kya_sg1",
     "sebastian_vamp",
     "sebastian_siren",
     "evelyn",
     "amelda",
     "uncle_khan",
     "kaleb",
     "ezra"
    ]
   },
   {
    "channel": "dilley-a-ship-name-of-dillon-and-haley",
    "passages": 54,
    "share": 0.0468,
    "first": "2025-03-05",
    "last": "2025-03-12",
    "kind": "route",
    "castWith": [
     "kyo",
     "ezra",
     "kya_sg3",
     "kya_sg1",
     "sebastian_vamp",
     "sebastian_siren",
     "haley_human"
    ]
   },
   {
    "channel": "double-bro-seb-cole",
    "passages": 49,
    "share": 0.0425,
    "first": "2025-04-30",
    "last": "2025-05-22",
    "kind": "route",
    "castWith": [
     "cole",
     "kaleb",
     "kya_sg3",
     "kya_sg1",
     "kyo",
     "evelyn",
     "sebastian_siren",
     "amoura",
     "may",
     "sebastian_vamp",
     "uncle_khan",
     "ace"
    ]
   },
   {
    "channel": "kya-werewolf",
    "passages": 46,
    "share": 0.0399,
    "first": "2021-09-04",
    "last": "2021-09-22",
    "kind": "route",
    "castWith": [
     "jace",
     "raphael",
     "trey",
     "kya_sg3",
     "scott",
     "kya_sg1",
     "ezra",
     "sebastian_siren",
     "kaleb",
     "sebastian_vamp",
     "evelyn",
     "will"
    ]
   },
   {
    "channel": "2-koda",
    "passages": 45,
    "share": 0.039,
    "first": "2022-12-19",
    "last": "2022-12-30",
    "kind": "route",
    "castWith": [
     "koda",
     "polly",
     "kya_sg1",
     "kya_sg3",
     "declan",
     "sebastian_siren",
     "sebastian_vamp",
     "kaleb",
     "rowan",
     "diana"
    ]
   },
   {
    "channel": "kya-werewolf-summit",
    "passages": 45,
    "share": 0.039,
    "first": "2024-10-22",
    "last": "2024-11-17",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "rowan",
     "maxen_bryers",
     "evelyn",
     "ever",
     "diana",
     "cruz",
     "bryce",
     "ezra",
     "ryder"
    ]
   },
   {
    "channel": "ezra-with-good-parents",
    "passages": 42,
    "share": 0.0364,
    "first": "2024-05-23",
    "last": "2024-06-05",
    "kind": "route",
    "castWith": [
     "ezra",
     "kya_sg3",
     "kya_sg1",
     "jane",
     "alistair",
     "kaleb",
     "uncle_khan",
     "alistair_turayne",
     "may"
    ]
   },
   {
    "channel": "kya-gets-dillon",
    "passages": 39,
    "share": 0.0338,
    "first": "2024-02-12",
    "last": "2024-02-16",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "sebastian_siren",
     "kya_sg1",
     "penelope_valk"
    ]
   }
  ],
  "knownCharacters": [
   "kyo",
   "kya_sg3",
   "kya_sg1",
   "sebastian_siren",
   "kaleb",
   "sebastian_vamp",
   "ever",
   "will",
   "lachesis",
   "amoura",
   "hadrian",
   "may"
  ]
 },
 "ford": {
  "canonRoute": "Nicole - 7/21/2026",
  "totalPassages": 2786,
  "routes": [
   {
    "channel": "AU: Ford Steele \u2014 Branched at msg 89/600 (5/1/2026) (branched at msg 638)",
    "passages": 522,
    "share": 0.1874,
    "first": "2026-05-02",
    "last": "2026-05-14",
    "kind": "au",
    "castWith": [
     "cruz",
     "ryder",
     "nicole_human",
     "audrey",
     "nolan",
     "may",
     "haley_human",
     "diana",
     "porscha_steele",
     "evelyn",
     "dimitri",
     "aaron"
    ]
   },
   {
    "channel": "Nicole - 7/21/2026",
    "passages": 328,
    "share": 0.1177,
    "first": "2026-07-21",
    "last": "2026-08-01",
    "kind": "canon",
    "castWith": [
     "cruz",
     "audrey",
     "trix",
     "ryder",
     "nicole_human",
     "nicole_wolf",
     "nicole_sg3",
     "nolan",
     "ace",
     "jack",
     "lira",
     "mr_han_sr"
    ]
   },
   {
    "channel": "switched-roles-lachesis",
    "passages": 318,
    "share": 0.1141,
    "first": "2023-10-09",
    "last": "2023-11-26",
    "kind": "au",
    "castWith": [
     "lachesis",
     "god",
     "lucifer",
     "cruz",
     "clothos",
     "atropos",
     "rowan",
     "vaughn",
     "ryder",
     "brax",
     "dimitri",
     "ramiel"
    ]
   },
   {
    "channel": "fordsplosion",
    "passages": 276,
    "share": 0.0991,
    "first": "2024-02-09",
    "last": "2024-03-19",
    "kind": "route",
    "castWith": [
     "lachesis",
     "lucifer",
     "cruz",
     "clothos",
     "ryder",
     "god",
     "asrius",
     "ethan",
     "eva",
     "atropos",
     "may",
     "evelyn"
    ]
   },
   {
    "channel": "Lindon + Ford",
    "passages": 209,
    "share": 0.075,
    "first": "2026-05-22",
    "last": "2026-06-01",
    "kind": "route",
    "castWith": [
     "lindon",
     "tim",
     "dante",
     "felix_fairy",
     "nicole_human",
     "park",
     "nicole_wolf",
     "nicole_sg3",
     "ben",
     "may",
     "will",
     "ezra"
    ]
   },
   {
    "channel": "cruz-sucks-ford-fucks",
    "passages": 199,
    "share": 0.0714,
    "first": "2024-05-21",
    "last": "2024-09-12",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "audrey",
     "bryce",
     "jack",
     "dimitri",
     "rowan",
     "nolan",
     "ryder",
     "lonnie",
     "lyden",
     "alyce_char"
    ]
   },
   {
    "channel": "Ford",
    "passages": 195,
    "share": 0.07,
    "first": "2026-04-07",
    "last": "2026-04-13",
    "kind": "route",
    "castWith": [
     "cruz",
     "nicole_human",
     "trix",
     "nolan",
     "alyce_char",
     "ryder",
     "richard_antore",
     "bryce",
     "allie",
     "diana",
     "audrey",
     "nicole_wolf"
    ]
   },
   {
    "channel": "nicoles-wish-brax-brother",
    "passages": 145,
    "share": 0.052,
    "first": "2023-04-26",
    "last": "2023-08-02",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "lance",
     "dimitri",
     "hades",
     "vaughn",
     "rowan",
     "nicole_human",
     "audrey",
     "diana",
     "evelyn",
     "nicole_wolf"
    ]
   },
   {
    "channel": "cruz-is-not-dead",
    "passages": 124,
    "share": 0.0445,
    "first": "2022-04-25",
    "last": "2024-05-24",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "ryder",
     "lucifer",
     "bryce",
     "audrey",
     "apollo",
     "ares",
     "god",
     "clint",
     "hades",
     "nolan"
    ]
   },
   {
    "channel": "Ford Steele \u2014 Branched at msg 121/121 (5/15/2026)",
    "passages": 93,
    "share": 0.0334,
    "first": "2026-05-15",
    "last": "2026-05-19",
    "kind": "au",
    "castWith": [
     "cruz",
     "audrey",
     "ryder",
     "nicole_human",
     "may",
     "alyce_char",
     "ever"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 85,
    "share": 0.0305,
    "first": "2024-01-27",
    "last": "2025-02-25",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "ryder",
     "vaughn",
     "lance",
     "bryce",
     "shane",
     "dimitri",
     "allie",
     "micah",
     "audrey",
     "moros"
    ]
   },
   {
    "channel": "Ford Steele \u2014 Branched at msg 89/600 (5/1/2026)",
    "passages": 68,
    "share": 0.0244,
    "first": "2026-05-01",
    "last": "2026-05-02",
    "kind": "au",
    "castWith": [
     "cruz",
     "nolan",
     "audrey",
     "evelyn"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "audrey",
   "trix",
   "ryder",
   "nicole_human",
   "nicole_wolf",
   "nicole_sg3",
   "nolan",
   "ace",
   "jack",
   "lira",
   "mr_han_sr"
  ]
 },
 "brax": {
  "canonRoute": "vaughneo-and-juliet",
  "totalPassages": 1306,
  "routes": [
   {
    "channel": "vaughneo-and-juliet",
    "passages": 206,
    "share": 0.1577,
    "first": "2025-10-23",
    "last": "2026-02-02",
    "kind": "canon",
    "castWith": [
     "vaughn",
     "lindon",
     "declan",
     "ares",
     "skye",
     "roman",
     "mary_cataldi",
     "liz",
     "nicole_human",
     "aphrodite",
     "ace",
     "ben"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 196,
    "share": 0.1501,
    "first": "2024-01-29",
    "last": "2025-02-25",
    "kind": "route",
    "castWith": [
     "cruz",
     "ryder",
     "ford",
     "vaughn",
     "lance",
     "bryce",
     "shane",
     "dimitri",
     "allie",
     "micah",
     "audrey",
     "moros"
    ]
   },
   {
    "channel": "lance-nicole-2",
    "passages": 132,
    "share": 0.1011,
    "first": "2022-11-26",
    "last": "2022-12-15",
    "kind": "route",
    "castWith": [
     "vaughn",
     "lance",
     "jenning",
     "cruz",
     "lachesis",
     "nicole_human",
     "nicole_wolf",
     "nicole_sg3",
     "clothos",
     "atropos",
     "rowan",
     "roman"
    ]
   },
   {
    "channel": "unknown-soulmate",
    "passages": 129,
    "share": 0.0988,
    "first": "2025-06-30",
    "last": "2025-08-15",
    "kind": "route",
    "castWith": [
     "vaughn",
     "vanessa",
     "lindon",
     "nicole_human",
     "moros",
     "ares",
     "ben",
     "god"
    ]
   },
   {
    "channel": "nicoles-wish-brax-brother",
    "passages": 118,
    "share": 0.0904,
    "first": "2023-05-01",
    "last": "2023-08-02",
    "kind": "route",
    "castWith": [
     "ford",
     "cruz",
     "lance",
     "dimitri",
     "hades",
     "vaughn",
     "rowan",
     "nicole_human",
     "audrey",
     "diana",
     "evelyn",
     "nicole_wolf"
    ]
   },
   {
    "channel": "human-lachesis",
    "passages": 113,
    "share": 0.0865,
    "first": "2024-10-18",
    "last": "2024-11-20",
    "kind": "route",
    "castWith": [
     "nicole_human",
     "lachesis",
     "lance",
     "vaughn",
     "rowan",
     "god",
     "alyce_char",
     "moros",
     "ford",
     "atropos",
     "cruz",
     "nicole_wolf"
    ]
   },
   {
    "channel": "pos-brax-food-wine-route",
    "passages": 94,
    "share": 0.072,
    "first": "2024-05-05",
    "last": "2024-06-09",
    "kind": "route",
    "castWith": [
     "vaughn",
     "nicole_human",
     "haley_wolf",
     "nicole_wolf",
     "haley_sg3",
     "nicole_sg3",
     "diana",
     "god",
     "may"
    ]
   },
   {
    "channel": "bitchy-vaughn",
    "passages": 89,
    "share": 0.0681,
    "first": "2025-06-07",
    "last": "2025-06-30",
    "kind": "route",
    "castWith": [
     "vaughn",
     "vanessa",
     "lindon",
     "nicole_human",
     "diana",
     "god"
    ]
   },
   {
    "channel": "lachesis-off-the-rails",
    "passages": 46,
    "share": 0.0352,
    "first": "2025-08-20",
    "last": "2025-09-30",
    "kind": "route",
    "castWith": [
     "lance",
     "vaughn",
     "lucifer",
     "james",
     "atropos",
     "cruz",
     "lachesis",
     "ace",
     "lindon",
     "hades",
     "ezra",
     "nicole_human"
    ]
   },
   {
    "channel": "Brax + Vaughn 4/3/26",
    "passages": 32,
    "share": 0.0245,
    "first": "2026-04-03",
    "last": "2026-04-07",
    "kind": "route",
    "castWith": [
     "vaughn",
     "ever",
     "celestine"
    ]
   },
   {
    "channel": "daddy-lindon-hates-brax",
    "passages": 29,
    "share": 0.0222,
    "first": "2025-05-11",
    "last": "2025-05-26",
    "kind": "route",
    "castWith": [
     "ben",
     "lindon",
     "vaughn",
     "nicole_human",
     "ezra",
     "will",
     "nicole_wolf",
     "nicole_sg3",
     "ace"
    ]
   },
   {
    "channel": "brax-soulmate",
    "passages": 28,
    "share": 0.0214,
    "first": "2025-03-05",
    "last": "2025-03-11",
    "kind": "route",
    "castWith": [
     "vaughn",
     "rowan",
     "nicole_human",
     "ryder",
     "nicole_wolf",
     "nicole_sg3",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "vaughn",
   "lindon",
   "declan",
   "ares",
   "skye",
   "roman",
   "mary_cataldi",
   "liz",
   "nicole_human",
   "aphrodite",
   "ace",
   "ben"
  ]
 },
 "vaughn": {
  "canonRoute": "vaughneo-and-juliet",
  "totalPassages": 1236,
  "routes": [
   {
    "channel": "vaughneo-and-juliet",
    "passages": 275,
    "share": 0.2225,
    "first": "2025-10-23",
    "last": "2026-01-20",
    "kind": "canon",
    "castWith": [
     "brax",
     "lindon",
     "declan",
     "ares",
     "skye",
     "roman",
     "mary_cataldi",
     "liz",
     "nicole_human",
     "aphrodite",
     "ace",
     "ben"
    ]
   },
   {
    "channel": "lance-nicole-2",
    "passages": 128,
    "share": 0.1036,
    "first": "2022-11-26",
    "last": "2022-12-14",
    "kind": "route",
    "castWith": [
     "brax",
     "lance",
     "jenning",
     "cruz",
     "lachesis",
     "nicole_human",
     "nicole_wolf",
     "nicole_sg3",
     "clothos",
     "atropos",
     "rowan",
     "roman"
    ]
   },
   {
    "channel": "unknown-soulmate",
    "passages": 122,
    "share": 0.0987,
    "first": "2025-07-01",
    "last": "2025-08-19",
    "kind": "route",
    "castWith": [
     "brax",
     "vanessa",
     "lindon",
     "nicole_human",
     "moros",
     "ares",
     "ben",
     "god"
    ]
   },
   {
    "channel": "pos-brax-food-wine-route",
    "passages": 90,
    "share": 0.0728,
    "first": "2024-05-05",
    "last": "2024-06-09",
    "kind": "route",
    "castWith": [
     "brax",
     "nicole_human",
     "haley_wolf",
     "nicole_wolf",
     "haley_sg3",
     "nicole_sg3",
     "diana",
     "god",
     "may"
    ]
   },
   {
    "channel": "lachesis-off-the-rails",
    "passages": 81,
    "share": 0.0655,
    "first": "2025-08-25",
    "last": "2025-09-26",
    "kind": "route",
    "castWith": [
     "lance",
     "brax",
     "lucifer",
     "james",
     "atropos",
     "cruz",
     "lachesis",
     "ace",
     "lindon",
     "hades",
     "ezra",
     "nicole_human"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 78,
    "share": 0.0631,
    "first": "2024-02-05",
    "last": "2025-02-25",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "ryder",
     "ford",
     "lance",
     "bryce",
     "shane",
     "dimitri",
     "allie",
     "micah",
     "audrey",
     "moros"
    ]
   },
   {
    "channel": "bitchy-vaughn",
    "passages": 71,
    "share": 0.0574,
    "first": "2025-06-07",
    "last": "2025-06-30",
    "kind": "route",
    "castWith": [
     "brax",
     "vanessa",
     "lindon",
     "nicole_human",
     "diana",
     "god"
    ]
   },
   {
    "channel": "reunited-with-vaughn",
    "passages": 70,
    "share": 0.0566,
    "first": "2025-05-26",
    "last": "2025-06-06",
    "kind": "route",
    "castWith": [
     "brax",
     "nicole_human",
     "lindon",
     "nicole_wolf",
     "nicole_sg3",
     "ben",
     "moros",
     "ezra",
     "parks",
     "will"
    ]
   },
   {
    "channel": "human-lachesis",
    "passages": 61,
    "share": 0.0494,
    "first": "2024-10-22",
    "last": "2024-11-20",
    "kind": "route",
    "castWith": [
     "nicole_human",
     "brax",
     "lachesis",
     "lance",
     "rowan",
     "god",
     "alyce_char",
     "moros",
     "ford",
     "atropos",
     "cruz",
     "nicole_wolf"
    ]
   },
   {
    "channel": "heavenbound-missions",
    "passages": 56,
    "share": 0.0453,
    "first": "2025-10-07",
    "last": "2025-10-23",
    "kind": "route",
    "castWith": [
     "lindon",
     "god",
     "ares",
     "brax",
     "primrose",
     "aphrodite",
     "nicole_human",
     "nicole_wolf",
     "nicole_sg3",
     "beatrice",
     "will",
     "cruz"
    ]
   },
   {
    "channel": "nicoles-wish-brax-brother",
    "passages": 42,
    "share": 0.034,
    "first": "2023-05-29",
    "last": "2023-07-16",
    "kind": "route",
    "castWith": [
     "ford",
     "cruz",
     "brax",
     "lance",
     "dimitri",
     "hades",
     "rowan",
     "nicole_human",
     "audrey",
     "diana",
     "evelyn",
     "nicole_wolf"
    ]
   },
   {
    "channel": "Brax + Vaughn 4/3/26",
    "passages": 32,
    "share": 0.0259,
    "first": "2026-04-03",
    "last": "2026-04-07",
    "kind": "route",
    "castWith": [
     "brax",
     "ever",
     "celestine"
    ]
   }
  ],
  "knownCharacters": [
   "brax",
   "lindon",
   "declan",
   "ares",
   "skye",
   "roman",
   "mary_cataldi",
   "liz",
   "nicole_human",
   "aphrodite",
   "ace",
   "ben"
  ]
 },
 "lindon": {
  "canonRoute": "Lindon + Ford",
  "totalPassages": 570,
  "routes": [
   {
    "channel": "Lindon + Ford",
    "passages": 164,
    "share": 0.2877,
    "first": "2026-05-20",
    "last": "2026-06-01",
    "kind": "canon",
    "castWith": [
     "ford",
     "tim",
     "dante",
     "felix_fairy",
     "nicole_human",
     "park",
     "nicole_wolf",
     "nicole_sg3",
     "ben",
     "may",
     "will",
     "ezra"
    ]
   },
   {
    "channel": "vampire-ww-war",
    "passages": 90,
    "share": 0.1579,
    "first": "2025-04-14",
    "last": "2025-04-29",
    "kind": "route",
    "castWith": [
     "rowan",
     "ezra",
     "evelyn",
     "ace",
     "ares",
     "cruz",
     "kaleb",
     "ever",
     "frau",
     "rikki"
    ]
   },
   {
    "channel": "heavenbound-missions",
    "passages": 52,
    "share": 0.0912,
    "first": "2025-10-07",
    "last": "2025-10-23",
    "kind": "route",
    "castWith": [
     "vaughn",
     "god",
     "ares",
     "brax",
     "primrose",
     "aphrodite",
     "nicole_human",
     "nicole_wolf",
     "nicole_sg3",
     "beatrice",
     "will",
     "cruz"
    ]
   },
   {
    "channel": "ww-war-au",
    "passages": 51,
    "share": 0.0895,
    "first": "2021-11-29",
    "last": "2021-12-13",
    "kind": "au",
    "castWith": [
     "evelyn",
     "cruz",
     "ace",
     "ezra",
     "kaleb",
     "rowan",
     "bryce",
     "lance",
     "raye",
     "nolan",
     "primrose",
     "ryder"
    ]
   },
   {
    "channel": "daddy-lindon-hates-brax",
    "passages": 48,
    "share": 0.0842,
    "first": "2025-04-30",
    "last": "2025-05-21",
    "kind": "route",
    "castWith": [
     "ben",
     "brax",
     "vaughn",
     "nicole_human",
     "ezra",
     "will",
     "nicole_wolf",
     "nicole_sg3",
     "ace"
    ]
   },
   {
    "channel": "vaughneo-and-juliet",
    "passages": 36,
    "share": 0.0632,
    "first": "2025-10-23",
    "last": "2026-02-02",
    "kind": "route",
    "castWith": [
     "vaughn",
     "brax",
     "declan",
     "ares",
     "skye",
     "roman",
     "mary_cataldi",
     "liz",
     "nicole_human",
     "aphrodite",
     "ace",
     "ben"
    ]
   },
   {
    "channel": "1-real-cruz",
    "passages": 35,
    "share": 0.0614,
    "first": "2022-10-12",
    "last": "2022-12-21",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "ares",
     "lance",
     "selma",
     "zeus",
     "hera",
     "ryder",
     "apollo",
     "nolan",
     "diana"
    ]
   },
   {
    "channel": "lindon\u2019s-a-dad",
    "passages": 28,
    "share": 0.0491,
    "first": "2026-02-03",
    "last": "2026-03-25",
    "kind": "route",
    "castWith": [
     "brax",
     "vaughn",
     "aphrodite",
     "ares",
     "will"
    ]
   },
   {
    "channel": "lachesis-off-the-rails",
    "passages": 15,
    "share": 0.0263,
    "first": "2025-08-20",
    "last": "2025-09-11",
    "kind": "route",
    "castWith": [
     "lance",
     "vaughn",
     "brax",
     "lucifer",
     "james",
     "atropos",
     "cruz",
     "lachesis",
     "ace",
     "hades",
     "ezra",
     "nicole_human"
    ]
   },
   {
    "channel": "bitchy-vaughn",
    "passages": 11,
    "share": 0.0193,
    "first": "2025-06-09",
    "last": "2025-06-23",
    "kind": "route",
    "castWith": [
     "brax",
     "vaughn",
     "vanessa",
     "nicole_human",
     "diana",
     "god"
    ]
   },
   {
    "channel": "unknown-soulmate",
    "passages": 10,
    "share": 0.0175,
    "first": "2025-07-06",
    "last": "2025-07-31",
    "kind": "route",
    "castWith": [
     "brax",
     "vaughn",
     "vanessa",
     "nicole_human",
     "moros",
     "ares",
     "ben",
     "god"
    ]
   },
   {
    "channel": "eat-speak-rp-repeat",
    "passages": 8,
    "share": 0.014,
    "first": "2026-03-08",
    "last": "2026-04-03",
    "kind": "ooc",
    "castWith": [
     "eric",
     "cruz",
     "april",
     "lance",
     "felix_fairy",
     "brooke",
     "cyrus_fairy",
     "malakai",
     "god",
     "jack",
     "pam",
     "ezra"
    ]
   }
  ],
  "knownCharacters": [
   "ford",
   "tim",
   "dante",
   "felix_fairy",
   "nicole_human",
   "park",
   "nicole_wolf",
   "nicole_sg3",
   "ben",
   "may",
   "will",
   "ezra"
  ]
 },
 "terrance": {
  "canonRoute": "terrance-and-the-forest",
  "totalPassages": 101,
  "routes": [
   {
    "channel": "terrance-and-the-forest",
    "passages": 94,
    "share": 0.9307,
    "first": "2025-10-07",
    "last": "2025-10-26",
    "kind": "canon",
    "castWith": [
     "aelira",
     "killian",
     "arthur_turayne",
     "may",
     "ford",
     "arnold_astor",
     "god",
     "lira"
    ]
   },
   {
    "channel": "werewolf-dimitri",
    "passages": 3,
    "share": 0.0297,
    "first": "2021-10-28",
    "last": "2021-10-28",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "kaleb",
     "slater",
     "kya_sg3",
     "frau",
     "god",
     "lionel",
     "byron",
     "gambit",
     "uncle_khan",
     "kelli"
    ]
   },
   {
    "channel": "tyrant-evie",
    "passages": 1,
    "share": 0.0099,
    "first": "2021-12-21",
    "last": "2021-12-21",
    "kind": "route",
    "castWith": [
     "evelyn",
     "bryce",
     "cruz",
     "myra",
     "ares",
     "hermes",
     "rio",
     "hades",
     "frau",
     "zeus",
     "nolan",
     "audrey"
    ]
   },
   {
    "channel": "warring-men",
    "passages": 1,
    "share": 0.0099,
    "first": "2025-08-08",
    "last": "2025-08-08",
    "kind": "route",
    "castWith": [
     "aelira",
     "killian",
     "arthur_turayne",
     "autumn",
     "summer",
     "may",
     "ragland",
     "will"
    ]
   },
   {
    "channel": "kya-in-the-abyss",
    "passages": 1,
    "share": 0.0099,
    "first": "2025-10-26",
    "last": "2025-10-26",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "kya_sg1",
     "god",
     "poseidon",
     "kaleb",
     "dillon",
     "will"
    ]
   },
   {
    "channel": "human-lachesis",
    "passages": 1,
    "share": 0.0099,
    "first": "2024-11-15",
    "last": "2024-11-15",
    "kind": "route",
    "castWith": [
     "nicole_human",
     "brax",
     "lachesis",
     "lance",
     "vaughn",
     "rowan",
     "god",
     "alyce_char",
     "moros",
     "ford",
     "atropos",
     "cruz"
    ]
   }
  ],
  "knownCharacters": [
   "aelira",
   "killian",
   "arthur_turayne",
   "may",
   "ford",
   "arnold_astor",
   "god",
   "lira"
  ]
 },
 "natalia": {
  "canonRoute": "natalia-reset-route",
  "totalPassages": 73,
  "routes": [
   {
    "channel": "natalia-reset-route",
    "passages": 68,
    "share": 0.9315,
    "first": "2022-02-17",
    "last": "2022-03-07",
    "kind": "canon",
    "castWith": [
     "darren",
     "parks",
     "god",
     "kinley",
     "lucifer",
     "may"
    ]
   },
   {
    "channel": "kinley-reset-route",
    "passages": 4,
    "share": 0.0548,
    "first": "2022-02-17",
    "last": "2022-02-17",
    "kind": "route",
    "castWith": [
     "kinley",
     "lander",
     "shadow",
     "tate",
     "aaron",
     "raye",
     "zain_demigod",
     "apollo",
     "crom",
     "god",
     "jova",
     "aphrodite"
    ]
   },
   {
    "channel": "cruz-is-not-dead",
    "passages": 1,
    "share": 0.0137,
    "first": "2022-04-25",
    "last": "2022-04-25",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "ford",
     "ryder",
     "lucifer",
     "bryce",
     "audrey",
     "apollo",
     "ares",
     "god",
     "clint",
     "hades"
    ]
   }
  ],
  "knownCharacters": [
   "darren",
   "parks",
   "god",
   "kinley",
   "lucifer",
   "may"
  ]
 },
 "skye": {
  "canonRoute": "cruz-x-human",
  "totalPassages": 244,
  "routes": [
   {
    "channel": "cruz-x-human",
    "passages": 195,
    "share": 0.7992,
    "first": "2021-03-31",
    "last": "2021-05-19",
    "kind": "canon",
    "castWith": [
     "cruz",
     "nolan",
     "ryder",
     "audrey",
     "troy",
     "adrien",
     "bryce",
     "airi",
     "natasha",
     "diana",
     "will",
     "allie"
    ]
   },
   {
    "channel": "skye-part-2",
    "passages": 34,
    "share": 0.1393,
    "first": "2023-09-23",
    "last": "2023-09-24",
    "kind": "route",
    "castWith": [
     "cruz"
    ]
   },
   {
    "channel": "vaughneo-and-juliet",
    "passages": 15,
    "share": 0.0615,
    "first": "2026-01-22",
    "last": "2026-02-02",
    "kind": "route",
    "castWith": [
     "vaughn",
     "brax",
     "lindon",
     "declan",
     "ares",
     "roman",
     "mary_cataldi",
     "liz",
     "nicole_human",
     "aphrodite",
     "ace",
     "ben"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "nolan",
   "ryder",
   "audrey",
   "troy",
   "adrien",
   "bryce",
   "airi",
   "natasha",
   "diana",
   "will",
   "allie"
  ]
 },
 "brooke": {
  "canonRoute": "atropos-reincarnated",
  "totalPassages": 23,
  "routes": [
   {
    "channel": "out_of_character",
    "passages": 8,
    "share": 0.3478,
    "first": "2016-09-28",
    "last": "2020-07-11",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika"
    ]
   },
   {
    "channel": "the-restaurant-chat-channel",
    "passages": 5,
    "share": 0.2174,
    "first": "2024-06-10",
    "last": "2025-07-20",
    "kind": "ooc",
    "castWith": [
     "cruz",
     "eric",
     "eva",
     "will",
     "evelyn",
     "shane",
     "micah",
     "god",
     "may"
    ]
   },
   {
    "channel": "eat-speak-rp-repeat",
    "passages": 5,
    "share": 0.2174,
    "first": "2026-03-11",
    "last": "2026-03-25",
    "kind": "ooc",
    "castWith": [
     "eric",
     "cruz",
     "lindon",
     "april",
     "lance",
     "felix_fairy",
     "cyrus_fairy",
     "malakai",
     "god",
     "jack",
     "pam",
     "ezra"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 2,
    "share": 0.087,
    "first": "2020-04-07",
    "last": "2020-04-07",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "ooc",
    "passages": 2,
    "share": 0.087,
    "first": "2020-05-14",
    "last": "2020-05-20",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "atropos-reincarnated",
    "passages": 1,
    "share": 0.0435,
    "first": "2022-06-13",
    "last": "2022-06-13",
    "kind": "canon",
    "castWith": [
     "moros",
     "apollo",
     "haley_wolf",
     "atropos",
     "zeus",
     "zephyr",
     "dante",
     "lachesis",
     "clothos",
     "aphrodite",
     "hera",
     "haley_human"
    ]
   }
  ],
  "knownCharacters": [
   "moros",
   "apollo",
   "haley_wolf",
   "atropos",
   "zeus",
   "zephyr",
   "dante",
   "lachesis",
   "clothos",
   "aphrodite",
   "hera",
   "haley_human"
  ]
 },
 "beau": {
  "canonRoute": "european-vampires",
  "totalPassages": 104,
  "routes": [
   {
    "channel": "european-vampires",
    "passages": 94,
    "share": 0.9038,
    "first": "2024-02-23",
    "last": "2024-03-15",
    "kind": "canon",
    "castWith": [
     "solana",
     "leon",
     "khione",
     "will",
     "may"
    ]
   },
   {
    "channel": "beau-kills-for-kya",
    "passages": 9,
    "share": 0.0865,
    "first": "2024-03-15",
    "last": "2024-03-18",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "dillon",
     "kyo"
    ]
   },
   {
    "channel": "ooc",
    "passages": 1,
    "share": 0.0096,
    "first": "2020-05-04",
    "last": "2020-05-04",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   }
  ],
  "knownCharacters": [
   "solana",
   "leon",
   "khione",
   "will",
   "may"
  ]
 },
 "declan": {
  "canonRoute": "vaughneo-and-juliet",
  "totalPassages": 85,
  "routes": [
   {
    "channel": "vaughneo-and-juliet",
    "passages": 28,
    "share": 0.3294,
    "first": "2025-12-18",
    "last": "2026-01-21",
    "kind": "canon",
    "castWith": [
     "vaughn",
     "brax",
     "lindon",
     "ares",
     "skye",
     "roman",
     "mary_cataldi",
     "liz",
     "nicole_human",
     "aphrodite",
     "ace",
     "ben"
    ]
   },
   {
    "channel": "the-werewolf-harem-bandwagon",
    "passages": 26,
    "share": 0.3059,
    "first": "2022-12-09",
    "last": "2022-12-14",
    "kind": "route",
    "castWith": [
     "koda",
     "haley_wolf",
     "haley_sg3",
     "diana",
     "god",
     "may",
     "mia"
    ]
   },
   {
    "channel": "1-declan-only",
    "passages": 19,
    "share": 0.2235,
    "first": "2023-01-09",
    "last": "2023-01-12",
    "kind": "route",
    "castWith": [
     "haley_wolf",
     "haley_sg3",
     "noah",
     "koda",
     "diana",
     "hercules"
    ]
   },
   {
    "channel": "2-koda",
    "passages": 12,
    "share": 0.1412,
    "first": "2022-12-22",
    "last": "2023-01-09",
    "kind": "route",
    "castWith": [
     "koda",
     "dillon",
     "polly",
     "kya_sg1",
     "kya_sg3",
     "sebastian_siren",
     "sebastian_vamp",
     "kaleb",
     "rowan",
     "diana"
    ]
   }
  ],
  "knownCharacters": [
   "vaughn",
   "brax",
   "lindon",
   "ares",
   "skye",
   "roman",
   "mary_cataldi",
   "liz",
   "nicole_human",
   "aphrodite",
   "ace",
   "ben"
  ]
 },
 "cole": {
  "canonRoute": "double-bro-seb-cole",
  "totalPassages": 313,
  "routes": [
   {
    "channel": "double-bro-seb-cole",
    "passages": 143,
    "share": 0.4569,
    "first": "2025-04-30",
    "last": "2025-05-25",
    "kind": "canon",
    "castWith": [
     "kaleb",
     "dillon",
     "kya_sg3",
     "kya_sg1",
     "kyo",
     "evelyn",
     "sebastian_siren",
     "amoura",
     "may",
     "sebastian_vamp",
     "uncle_khan",
     "ace"
    ]
   },
   {
    "channel": "dorms",
    "passages": 44,
    "share": 0.1406,
    "first": "2020-05-02",
    "last": "2020-05-14",
    "kind": "route",
    "castWith": [
     "agnar",
     "kya_sg3",
     "agmund",
     "evelyn",
     "raye",
     "kya_sg1",
     "riku",
     "kaleb",
     "penelope_valk",
     "loki",
     "svira",
     "darren"
    ]
   },
   {
    "channel": "coles-room",
    "passages": 37,
    "share": 0.1182,
    "first": "2020-05-06",
    "last": "2020-05-09",
    "kind": "route",
    "castWith": [
     "abraham",
     "kya_sg3",
     "hades",
     "lacie",
     "raye",
     "riku"
    ]
   },
   {
    "channel": "ooc",
    "passages": 31,
    "share": 0.099,
    "first": "2020-05-02",
    "last": "2020-06-19",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "beach-and-boardwalk",
    "passages": 31,
    "share": 0.099,
    "first": "2020-05-03",
    "last": "2020-05-05",
    "kind": "route",
    "castWith": [
     "ezra",
     "kya_sg3",
     "kya_sg1",
     "skipper",
     "evelyn",
     "alistair",
     "alistair_turayne",
     "riku",
     "raye",
     "kaleb",
     "sebastian_vamp",
     "darren"
    ]
   },
   {
    "channel": "hell",
    "passages": 12,
    "share": 0.0383,
    "first": "2020-05-07",
    "last": "2020-05-07",
    "kind": "route",
    "castWith": [
     "atropos",
     "lachesis",
     "kya_sg3",
     "hades"
    ]
   },
   {
    "channel": "college-campus",
    "passages": 6,
    "share": 0.0192,
    "first": "2020-05-10",
    "last": "2020-05-11",
    "kind": "route",
    "castWith": [
     "agnar",
     "agmund",
     "kya_sg3",
     "penelope_valk",
     "evelyn",
     "svira",
     "rowan",
     "may",
     "jon",
     "kya_sg1",
     "kaleb",
     "darren"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 4,
    "share": 0.0128,
    "first": "2020-05-22",
    "last": "2020-05-30",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "greek-house",
    "passages": 3,
    "share": 0.0096,
    "first": "2020-05-09",
    "last": "2020-05-09",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hiro",
     "darren",
     "lex",
     "kiro",
     "raye",
     "kya_sg3",
     "ares",
     "riku",
     "kya_sg1",
     "lacie",
     "aphrodite"
    ]
   },
   {
    "channel": "misc-location",
    "passages": 2,
    "share": 0.0064,
    "first": "2020-05-04",
    "last": "2020-05-04",
    "kind": "route",
    "castWith": [
     "evelyn",
     "riku",
     "ares",
     "kiro",
     "hiro",
     "lex",
     "lance",
     "ezra",
     "lucius",
     "darren",
     "kaleb",
     "raye"
    ]
   }
  ],
  "knownCharacters": [
   "kaleb",
   "dillon",
   "kya_sg3",
   "kya_sg1",
   "kyo",
   "evelyn",
   "sebastian_siren",
   "amoura",
   "may",
   "sebastian_vamp",
   "uncle_khan",
   "ace"
  ]
 },
 "lyden": {
  "canonRoute": "cruz-undercover",
  "totalPassages": 209,
  "routes": [
   {
    "channel": "cruz-undercover",
    "passages": 86,
    "share": 0.4115,
    "first": "2025-01-02",
    "last": "2025-01-16",
    "kind": "canon",
    "castWith": [
     "cruz",
     "evelyn",
     "frau",
     "ford",
     "bryce",
     "malakai",
     "dimitri",
     "kaleb",
     "uncle_khan",
     "brax",
     "ever",
     "diana"
    ]
   },
   {
    "channel": "cruzzing-with-lyden",
    "passages": 59,
    "share": 0.2823,
    "first": "2025-01-17",
    "last": "2025-01-27",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "dimitri"
    ]
   },
   {
    "channel": "hot-boi-arena-cruz",
    "passages": 27,
    "share": 0.1292,
    "first": "2022-05-18",
    "last": "2022-06-09",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "frau",
     "crom",
     "ezra",
     "junta",
     "alyce_char",
     "ryder",
     "may",
     "rowan",
     "ares",
     "hades"
    ]
   },
   {
    "channel": "lance-is-a-family-man",
    "passages": 5,
    "share": 0.0239,
    "first": "2024-05-17",
    "last": "2024-05-18",
    "kind": "route",
    "castWith": [
     "lance",
     "evelyn",
     "cruz",
     "audrey",
     "luca",
     "bryce",
     "hermes",
     "roger",
     "dimitri",
     "hades",
     "diana",
     "zeus"
    ]
   },
   {
    "channel": "ghouls-and-goals",
    "passages": 5,
    "share": 0.0239,
    "first": "2022-09-10",
    "last": "2022-09-11",
    "kind": "route",
    "castWith": [
     "dimitri",
     "evelyn",
     "bryce",
     "kaleb",
     "will"
    ]
   },
   {
    "channel": "cruz-sucks-ford-fucks",
    "passages": 5,
    "share": 0.0239,
    "first": "2024-05-31",
    "last": "2024-07-15",
    "kind": "route",
    "castWith": [
     "ford",
     "cruz",
     "evelyn",
     "audrey",
     "bryce",
     "jack",
     "dimitri",
     "rowan",
     "nolan",
     "ryder",
     "lonnie",
     "alyce_char"
    ]
   },
   {
    "channel": "lets-abduct-evie",
    "passages": 3,
    "share": 0.0144,
    "first": "2021-07-01",
    "last": "2021-07-02",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "ryoto",
     "dodge",
     "ms_tia",
     "kaleb",
     "frau",
     "aki",
     "cruz",
     "talbot",
     "ares",
     "zeus"
    ]
   },
   {
    "channel": "growing-up-cruz",
    "passages": 3,
    "share": 0.0144,
    "first": "2023-01-30",
    "last": "2023-01-31",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "allie",
     "kaleb",
     "audrey",
     "raquel_ratchet",
     "dimitri",
     "trix",
     "ford",
     "ryder",
     "frau",
     "uncle_khan"
    ]
   },
   {
    "channel": "dimitri-ralidanti",
    "passages": 3,
    "share": 0.0144,
    "first": "2023-02-20",
    "last": "2023-02-25",
    "kind": "route",
    "castWith": [
     "ryder",
     "evelyn",
     "dimitri",
     "cruz",
     "nolan",
     "bryce",
     "audrey",
     "trix",
     "alyce_char",
     "kya_sg3",
     "diana",
     "frau"
    ]
   },
   {
    "channel": "1-real-cruz",
    "passages": 2,
    "share": 0.0096,
    "first": "2023-01-02",
    "last": "2023-01-05",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "ares",
     "lance",
     "selma",
     "zeus",
     "lindon",
     "hera",
     "ryder",
     "apollo",
     "nolan"
    ]
   },
   {
    "channel": "haleys-wish",
    "passages": 2,
    "share": 0.0096,
    "first": "2023-04-26",
    "last": "2023-04-26",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "evelyn",
     "sebastian_siren",
     "kya_sg1",
     "sebastian_vamp",
     "haley_human",
     "polly",
     "cruz",
     "dimitri",
     "haley_wolf",
     "haley_sg3",
     "skipper"
    ]
   },
   {
    "channel": "haleys-alistair-wish",
    "passages": 2,
    "share": 0.0096,
    "first": "2023-05-03",
    "last": "2023-05-03",
    "kind": "route",
    "castWith": [
     "ezra",
     "evelyn",
     "alistair_turayne",
     "alistair",
     "raye",
     "kaleb",
     "james",
     "dimitri",
     "haley_wolf",
     "haley_sg3",
     "uncle_khan",
     "haley_human"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "evelyn",
   "frau",
   "ford",
   "bryce",
   "malakai",
   "dimitri",
   "kaleb",
   "uncle_khan",
   "brax",
   "ever",
   "diana"
  ]
 },
 "fallon": {
  "canonRoute": null,
  "routes": [],
  "knownCharacters": [],
  "totalPassages": 0
 },
 "trev": {
  "canonRoute": "aaron-haley",
  "totalPassages": 1,
  "routes": [
   {
    "channel": "aaron-haley",
    "passages": 1,
    "share": 1.0,
    "first": "2023-01-25",
    "last": "2023-01-25",
    "kind": "canon",
    "castWith": [
     "aaron",
     "haley_human",
     "lula",
     "kya_sg3",
     "rowan",
     "kya_sg1",
     "god",
     "may"
    ]
   }
  ],
  "knownCharacters": [
   "aaron",
   "haley_human",
   "lula",
   "kya_sg3",
   "rowan",
   "kya_sg1",
   "god",
   "may"
  ]
 },
 "kyo": {
  "canonRoute": "twins-princes-and-murder",
  "totalPassages": 200,
  "routes": [
   {
    "channel": "twins-princes-and-murder",
    "passages": 89,
    "share": 0.445,
    "first": "2023-02-09",
    "last": "2023-02-23",
    "kind": "canon",
    "castWith": [
     "hadrian",
     "amoura",
     "eli",
     "amelda"
    ]
   },
   {
    "channel": "dillon-knows",
    "passages": 29,
    "share": 0.145,
    "first": "2025-11-18",
    "last": "2025-12-13",
    "kind": "route",
    "castWith": [
     "dillon",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "kaleb",
     "sebastian_vamp",
     "ever",
     "will",
     "lachesis",
     "amoura",
     "hadrian",
     "may"
    ]
   },
   {
    "channel": "dilley-a-ship-name-of-dillon-and-haley",
    "passages": 20,
    "share": 0.1,
    "first": "2025-03-05",
    "last": "2025-03-08",
    "kind": "route",
    "castWith": [
     "dillon",
     "ezra",
     "kya_sg3",
     "kya_sg1",
     "sebastian_vamp",
     "sebastian_siren",
     "haley_human"
    ]
   },
   {
    "channel": "3-haleys-hades-fanfic",
    "passages": 11,
    "share": 0.055,
    "first": "2023-02-06",
    "last": "2023-02-27",
    "kind": "au",
    "castWith": [
     "hades",
     "persephone",
     "amoura",
     "kya_sg3",
     "kya_sg1",
     "kaleb",
     "dillon",
     "apollo",
     "sebastian_vamp",
     "sebastian_siren",
     "eli",
     "god"
    ]
   },
   {
    "channel": "double-bro-seb-cole",
    "passages": 10,
    "share": 0.05,
    "first": "2025-05-21",
    "last": "2025-05-25",
    "kind": "route",
    "castWith": [
     "cole",
     "kaleb",
     "dillon",
     "kya_sg3",
     "kya_sg1",
     "evelyn",
     "sebastian_siren",
     "amoura",
     "may",
     "sebastian_vamp",
     "uncle_khan",
     "ace"
    ]
   },
   {
    "channel": "kya-seb-nice-uncle",
    "passages": 8,
    "share": 0.04,
    "first": "2025-12-22",
    "last": "2025-12-31",
    "kind": "route",
    "castWith": [
     "dillon",
     "aaron",
     "kaleb",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "polly",
     "evelyn",
     "sebastian_vamp",
     "frau",
     "ami",
     "may"
    ]
   },
   {
    "channel": "aquarium",
    "passages": 8,
    "share": 0.04,
    "first": "2020-04-14",
    "last": "2020-04-27",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "ezra",
     "kya_sg1",
     "polly",
     "sebastian_vamp",
     "skipper",
     "sebastian_siren",
     "lira",
     "crom",
     "evelyn",
     "kaleb",
     "kris"
    ]
   },
   {
    "channel": "kaleb-kya-finally",
    "passages": 4,
    "share": 0.02,
    "first": "2021-02-13",
    "last": "2021-02-16",
    "kind": "route",
    "castWith": [
     "kaleb",
     "kya_sg3",
     "kya_sg1",
     "evelyn",
     "sebastian_siren",
     "sebastian_vamp",
     "apollo",
     "gabs",
     "uncle_khan",
     "alexander",
     "dimitri",
     "ami"
    ]
   },
   {
    "channel": "when-denial-ends",
    "passages": 4,
    "share": 0.02,
    "first": "2023-01-01",
    "last": "2023-01-04",
    "kind": "route",
    "castWith": [
     "dillon",
     "kya_sg3",
     "sebastian_siren",
     "kya_sg1",
     "sebastian_vamp",
     "ever"
    ]
   },
   {
    "channel": "ooc",
    "passages": 3,
    "share": 0.015,
    "first": "2020-04-14",
    "last": "2020-11-17",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "alistair-reboot2",
    "passages": 2,
    "share": 0.01,
    "first": "2022-05-02",
    "last": "2022-05-02",
    "kind": "au",
    "castWith": [
     "alistair",
     "alistair_turayne",
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "sebastian_vamp",
     "evelyn",
     "sebastian_siren",
     "dillon",
     "ezra",
     "uncle_khan",
     "skipper"
    ]
   },
   {
    "channel": "forced-mate-college",
    "passages": 2,
    "share": 0.01,
    "first": "2025-11-02",
    "last": "2025-11-07",
    "kind": "route",
    "castWith": [
     "dillon",
     "polly",
     "kya_sg3",
     "kya_sg1",
     "sebastian_vamp",
     "sebastian_siren",
     "ever",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "hadrian",
   "amoura",
   "eli",
   "amelda"
  ]
 },
 "ever": {
  "canonRoute": "shark-bait",
  "totalPassages": 157,
  "routes": [
   {
    "channel": "shark-bait",
    "passages": 60,
    "share": 0.3822,
    "first": "2024-11-23",
    "last": "2024-12-11",
    "kind": "canon",
    "castWith": [
     "kya_sg3",
     "kya_sg1",
     "dillon",
     "sebastian_siren",
     "kaleb",
     "evelyn",
     "sebastian_vamp",
     "kyo"
    ]
   },
   {
    "channel": "shane-micah-wish",
    "passages": 3,
    "share": 0.0191,
    "first": "2023-12-01",
    "last": "2023-12-11",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "cruz",
     "micah",
     "ryder",
     "god",
     "trix",
     "diana",
     "lucifer",
     "rex",
     "jack",
     "keller"
    ]
   },
   {
    "channel": "siren-places",
    "passages": 3,
    "share": 0.0191,
    "first": "2020-07-05",
    "last": "2020-07-12",
    "kind": "route",
    "castWith": [
     "sebastian_vamp",
     "sebastian_siren",
     "kya_sg1",
     "kya_sg3",
     "polly",
     "kaleb",
     "evelyn",
     "midori_naga",
     "skipper",
     "kyo"
    ]
   },
   {
    "channel": "switched-roles-lachesis",
    "passages": 2,
    "share": 0.0127,
    "first": "2023-10-12",
    "last": "2023-10-12",
    "kind": "au",
    "castWith": [
     "lachesis",
     "ford",
     "god",
     "lucifer",
     "cruz",
     "clothos",
     "atropos",
     "rowan",
     "vaughn",
     "ryder",
     "brax",
     "dimitri"
    ]
   },
   {
    "channel": "rogue-wolf-hot-cruz",
    "passages": 2,
    "share": 0.0127,
    "first": "2021-02-28",
    "last": "2021-03-04",
    "kind": "route",
    "castWith": [
     "cruz",
     "hunter",
     "ryder",
     "trix",
     "audrey",
     "lance",
     "alyce_char",
     "bryce",
     "nolan",
     "diana",
     "will",
     "aphrodite"
    ]
   },
   {
    "channel": "human-evie",
    "passages": 2,
    "share": 0.0127,
    "first": "2020-10-02",
    "last": "2020-10-06",
    "kind": "route",
    "castWith": [
     "evelyn",
     "kaleb",
     "frau",
     "cruz",
     "mr_han_sr",
     "audrey",
     "richard_antore",
     "diana",
     "ares",
     "quincy_antore",
     "nereda",
     "elizabeth_the_third"
    ]
   },
   {
    "channel": "kya-college-2",
    "passages": 2,
    "share": 0.0127,
    "first": "2021-01-21",
    "last": "2021-01-25",
    "kind": "route",
    "castWith": [
     "lily",
     "zander",
     "kya_sg3",
     "kya_sg1",
     "ari",
     "sebastian_siren",
     "raye",
     "prince_zed",
     "sebastian_vamp",
     "midori_naga",
     "penelope_valk",
     "bell_lily_of_fell"
    ]
   },
   {
    "channel": "dillon-knows",
    "passages": 2,
    "share": 0.0127,
    "first": "2025-11-12",
    "last": "2025-11-21",
    "kind": "route",
    "castWith": [
     "dillon",
     "kyo",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "kaleb",
     "sebastian_vamp",
     "will",
     "lachesis",
     "amoura",
     "hadrian",
     "may"
    ]
   },
   {
    "channel": "kya-x-james",
    "passages": 2,
    "share": 0.0127,
    "first": "2020-08-29",
    "last": "2020-09-02",
    "kind": "route",
    "castWith": [
     "james",
     "kya_sg3",
     "kya_sg1",
     "vanessa",
     "junta",
     "tim",
     "val",
     "raz",
     "dalton",
     "evelyn",
     "sebastian_vamp",
     "raye"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 2,
    "share": 0.0127,
    "first": "2025-02-24",
    "last": "2025-02-25",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "ryder",
     "ford",
     "vaughn",
     "lance",
     "bryce",
     "shane",
     "dimitri",
     "allie",
     "micah",
     "audrey"
    ]
   },
   {
    "channel": "kya-werewolf-summit",
    "passages": 2,
    "share": 0.0127,
    "first": "2024-10-24",
    "last": "2024-11-17",
    "kind": "route",
    "castWith": [
     "dillon",
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "rowan",
     "maxen_bryers",
     "evelyn",
     "diana",
     "cruz",
     "bryce",
     "ezra",
     "ryder"
    ]
   },
   {
    "channel": "frau-collin",
    "passages": 2,
    "share": 0.0127,
    "first": "2020-04-18",
    "last": "2020-11-29",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "rowan",
     "frau",
     "collin_keller",
     "arland_rees",
     "ezra",
     "felix_fairy",
     "rikki",
     "park",
     "alyce_char",
     "myra"
    ]
   }
  ],
  "knownCharacters": [
   "kya_sg3",
   "kya_sg1",
   "dillon",
   "sebastian_siren",
   "kaleb",
   "evelyn",
   "sebastian_vamp",
   "kyo"
  ]
 },
 "parks": {
  "canonRoute": "natalia-reset-route",
  "totalPassages": 5,
  "routes": [
   {
    "channel": "natalia-reset-route",
    "passages": 4,
    "share": 0.8,
    "first": "2022-02-17",
    "last": "2022-02-18",
    "kind": "canon",
    "castWith": [
     "natalia",
     "darren",
     "god",
     "kinley",
     "lucifer",
     "may"
    ]
   },
   {
    "channel": "reunited-with-vaughn",
    "passages": 1,
    "share": 0.2,
    "first": "2025-05-29",
    "last": "2025-05-29",
    "kind": "route",
    "castWith": [
     "vaughn",
     "brax",
     "nicole_human",
     "lindon",
     "nicole_wolf",
     "nicole_sg3",
     "ben",
     "moros",
     "ezra",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "natalia",
   "darren",
   "god",
   "kinley",
   "lucifer",
   "may"
  ]
 },
 "titus": {
  "canonRoute": "you-have-me-roman",
  "totalPassages": 37,
  "routes": [
   {
    "channel": "you-have-me-roman",
    "passages": 37,
    "share": 1.0,
    "first": "2022-11-07",
    "last": "2022-11-16",
    "kind": "canon",
    "castWith": [
     "darius",
     "roman",
     "kya_sg3",
     "dillon",
     "kya_sg1",
     "evelyn",
     "stellar",
     "easton",
     "deven",
     "will",
     "lachesis",
     "darren"
    ]
   }
  ],
  "knownCharacters": [
   "darius",
   "roman",
   "kya_sg3",
   "dillon",
   "kya_sg1",
   "evelyn",
   "stellar",
   "easton",
   "deven",
   "will",
   "lachesis",
   "darren"
  ]
 },
 "dalton": {
  "canonRoute": "kya-x-james",
  "totalPassages": 13,
  "routes": [
   {
    "channel": "kya-x-james",
    "passages": 7,
    "share": 0.5385,
    "first": "2020-09-03",
    "last": "2020-09-07",
    "kind": "canon",
    "castWith": [
     "james",
     "kya_sg3",
     "kya_sg1",
     "vanessa",
     "junta",
     "tim",
     "val",
     "raz",
     "evelyn",
     "sebastian_vamp",
     "raye",
     "sebastian_siren"
    ]
   },
   {
    "channel": "junta-tim-soulmates",
    "passages": 3,
    "share": 0.2308,
    "first": "2023-09-11",
    "last": "2023-09-17",
    "kind": "route",
    "castWith": [
     "junta",
     "tim",
     "kieran",
     "raz",
     "peter",
     "kris",
     "val",
     "vanessa",
     "ever",
     "aphrodite",
     "natasha",
     "will"
    ]
   },
   {
    "channel": "bios",
    "passages": 2,
    "share": 0.1538,
    "first": "2020-08-28",
    "last": "2020-09-03",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "evelyn",
     "lucius",
     "athena",
     "bryce",
     "val",
     "hiro",
     "raz",
     "rex",
     "vanessa",
     "halo",
     "cruz"
    ]
   },
   {
    "channel": "cruz-nicole-dollar-store",
    "passages": 1,
    "share": 0.0769,
    "first": "2020-09-14",
    "last": "2020-09-14",
    "kind": "route",
    "castWith": [
     "cruz",
     "raz",
     "lance",
     "lachesis",
     "bryce",
     "nolan",
     "renee",
     "aphrodite",
     "clothos",
     "atropos",
     "nicole_wolf",
     "nicole_sg3"
    ]
   }
  ],
  "knownCharacters": [
   "james",
   "kya_sg3",
   "kya_sg1",
   "vanessa",
   "junta",
   "tim",
   "val",
   "raz",
   "evelyn",
   "sebastian_vamp",
   "raye",
   "sebastian_siren"
  ]
 },
 "otto": {
  "canonRoute": "nicole-x-cruz",
  "totalPassages": 136,
  "routes": [
   {
    "channel": "nicole-x-cruz",
    "passages": 135,
    "share": 0.9926,
    "first": "2020-09-02",
    "last": "2021-02-18",
    "kind": "canon",
    "castWith": [
     "cruz",
     "jones",
     "nicole_human",
     "duran",
     "sorsha",
     "kya_sg1",
     "lucifer",
     "nicole_wolf",
     "kya_sg3",
     "nicole_sg3",
     "christopher_donovan",
     "jonathan_donovan"
    ]
   },
   {
    "channel": "bios",
    "passages": 1,
    "share": 0.0074,
    "first": "2020-09-04",
    "last": "2020-09-04",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "evelyn",
     "lucius",
     "athena",
     "bryce",
     "val",
     "hiro",
     "raz",
     "rex",
     "vanessa",
     "halo",
     "dalton"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "jones",
   "nicole_human",
   "duran",
   "sorsha",
   "kya_sg1",
   "lucifer",
   "nicole_wolf",
   "kya_sg3",
   "nicole_sg3",
   "christopher_donovan",
   "jonathan_donovan"
  ]
 },
 "roman": {
  "canonRoute": "you-have-me-roman",
  "totalPassages": 72,
  "routes": [
   {
    "channel": "you-have-me-roman",
    "passages": 31,
    "share": 0.4306,
    "first": "2022-11-07",
    "last": "2022-11-16",
    "kind": "canon",
    "castWith": [
     "darius",
     "titus",
     "kya_sg3",
     "dillon",
     "kya_sg1",
     "evelyn",
     "stellar",
     "easton",
     "deven",
     "will",
     "lachesis",
     "darren"
    ]
   },
   {
    "channel": "vaughneo-and-juliet",
    "passages": 11,
    "share": 0.1528,
    "first": "2026-01-20",
    "last": "2026-02-02",
    "kind": "route",
    "castWith": [
     "vaughn",
     "brax",
     "lindon",
     "declan",
     "ares",
     "skye",
     "mary_cataldi",
     "liz",
     "nicole_human",
     "aphrodite",
     "ace",
     "ben"
    ]
   },
   {
    "channel": "school-gym",
    "passages": 5,
    "share": 0.0694,
    "first": "2020-06-10",
    "last": "2020-06-10",
    "kind": "route",
    "castWith": [
     "evelyn",
     "rex",
     "aaron",
     "diana",
     "milo",
     "kya_sg3",
     "kya_sg1",
     "dike",
     "frau",
     "dimitri",
     "sebastian_vamp",
     "raye"
    ]
   },
   {
    "channel": "lance-nicole-2",
    "passages": 3,
    "share": 0.0417,
    "first": "2022-12-08",
    "last": "2022-12-11",
    "kind": "route",
    "castWith": [
     "brax",
     "vaughn",
     "lance",
     "jenning",
     "cruz",
     "lachesis",
     "nicole_human",
     "nicole_wolf",
     "nicole_sg3",
     "clothos",
     "atropos",
     "rowan"
    ]
   },
   {
    "channel": "a-tricky-micah-cruz-route",
    "passages": 2,
    "share": 0.0278,
    "first": "2023-09-14",
    "last": "2023-09-17",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "ryder",
     "cruz",
     "micah",
     "trix",
     "allie",
     "evelyn",
     "roger",
     "audrey",
     "god",
     "bryce"
    ]
   },
   {
    "channel": "lance-decides",
    "passages": 2,
    "share": 0.0278,
    "first": "2024-12-15",
    "last": "2024-12-15",
    "kind": "route",
    "castWith": [
     "lance",
     "rin",
     "lucifer",
     "lachesis",
     "nicole_human",
     "god",
     "chiara",
     "cupid_eros",
     "asrius",
     "hera",
     "zeus",
     "aphrodite"
    ]
   },
   {
    "channel": "staff-break-room",
    "passages": 2,
    "share": 0.0278,
    "first": "2020-06-14",
    "last": "2020-06-15",
    "kind": "route",
    "castWith": [
     "dimitri",
     "rex",
     "evelyn",
     "saph",
     "diana",
     "aaron",
     "kiro",
     "milo",
     "skipper",
     "sebastian_vamp",
     "kya_sg3",
     "sebastian_siren"
    ]
   },
   {
    "channel": "ocroute2-cruz-in-for-love",
    "passages": 1,
    "share": 0.0139,
    "first": "2022-02-01",
    "last": "2022-02-01",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "dimitri",
     "hades",
     "zeus",
     "hera",
     "aphrodite",
     "god",
     "bryce",
     "amanda",
     "lachesis",
     "hermes"
    ]
   },
   {
    "channel": "fall-fairies",
    "passages": 1,
    "share": 0.0139,
    "first": "2021-10-25",
    "last": "2021-10-25",
    "kind": "route",
    "castWith": [
     "damien",
     "matare",
     "autumn",
     "retin",
     "draven",
     "fayette",
     "sir_tyde",
     "may",
     "maleos",
     "silvia",
     "jaden",
     "will"
    ]
   },
   {
    "channel": "lance-origin-route",
    "passages": 1,
    "share": 0.0139,
    "first": "2021-05-26",
    "last": "2021-05-26",
    "kind": "route",
    "castWith": [
     "lance",
     "lachesis",
     "clothos",
     "nicole_human",
     "ryder",
     "moros",
     "atropos",
     "god",
     "nicole_wolf",
     "nicole_sg3",
     "hades",
     "haley_human"
    ]
   },
   {
    "channel": "nicole-x-cruz",
    "passages": 1,
    "share": 0.0139,
    "first": "2020-09-03",
    "last": "2020-09-03",
    "kind": "route",
    "castWith": [
     "otto",
     "cruz",
     "jones",
     "nicole_human",
     "duran",
     "sorsha",
     "kya_sg1",
     "lucifer",
     "nicole_wolf",
     "kya_sg3",
     "nicole_sg3",
     "christopher_donovan"
    ]
   },
   {
    "channel": "evelyn-college-2",
    "passages": 1,
    "share": 0.0139,
    "first": "2021-01-23",
    "last": "2021-01-23",
    "kind": "route",
    "castWith": [
     "evelyn",
     "darren",
     "dimitri",
     "lex",
     "hades",
     "raye",
     "jon",
     "ares",
     "kaleb",
     "cruz",
     "kya_sg3",
     "ari"
    ]
   }
  ],
  "knownCharacters": [
   "darius",
   "titus",
   "kya_sg3",
   "dillon",
   "kya_sg1",
   "evelyn",
   "stellar",
   "easton",
   "deven",
   "will",
   "lachesis",
   "darren"
  ]
 },
 "chance": {
  "canonRoute": "chance-route-ft-lance",
  "totalPassages": 134,
  "routes": [
   {
    "channel": "chance-route-ft-lance",
    "passages": 133,
    "share": 0.9925,
    "first": "2021-09-28",
    "last": "2021-10-27",
    "kind": "canon",
    "castWith": [
     "lachesis",
     "lance",
     "god",
     "aphrodite",
     "atropos",
     "clothos",
     "zeus",
     "moros",
     "ares",
     "hades",
     "may",
     "will"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 1,
    "share": 0.0075,
    "first": "2024-02-05",
    "last": "2024-02-05",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "ryder",
     "ford",
     "vaughn",
     "lance",
     "bryce",
     "shane",
     "dimitri",
     "allie",
     "micah",
     "audrey"
    ]
   }
  ],
  "knownCharacters": [
   "lachesis",
   "lance",
   "god",
   "aphrodite",
   "atropos",
   "clothos",
   "zeus",
   "moros",
   "ares",
   "hades",
   "may",
   "will"
  ]
 },
 "juliette_fairy": {
  "canonRoute": "fairy-fresh",
  "totalPassages": 60,
  "routes": [
   {
    "channel": "fairy-au",
    "passages": 31,
    "share": 0.5167,
    "first": "2026-03-03",
    "last": "2026-03-16",
    "kind": "au",
    "castWith": [
     "malakai",
     "felix_fairy",
     "cyrus_fairy",
     "nia_fairy",
     "gus_fairy",
     "langley",
     "god",
     "haley_human",
     "will"
    ]
   },
   {
    "channel": "fairy-fresh",
    "passages": 16,
    "share": 0.2667,
    "first": "2026-03-18",
    "last": "2026-03-27",
    "kind": "canon",
    "castWith": [
     "cyrus_fairy",
     "felix_fairy",
     "nia_fairy",
     "gus_fairy",
     "ever",
     "god"
    ]
   },
   {
    "channel": "Malakai \u2014 DM to RP (5/22/2026)",
    "passages": 9,
    "share": 0.15,
    "first": "2026-05-24",
    "last": "2026-06-02",
    "kind": "route",
    "castWith": [
     "malakai",
     "god"
    ]
   },
   {
    "channel": "fairy-au-bios",
    "passages": 4,
    "share": 0.0667,
    "first": "2026-03-13",
    "last": "2026-03-13",
    "kind": "au",
    "castWith": [
     "malakai",
     "felix_fairy",
     "langley",
     "cyrus_fairy",
     "nia_fairy",
     "gus_fairy"
    ]
   }
  ],
  "knownCharacters": [
   "cyrus_fairy",
   "felix_fairy",
   "nia_fairy",
   "gus_fairy",
   "ever",
   "god"
  ]
 },
 "malakai": {
  "canonRoute": "cruz-undercover",
  "totalPassages": 72,
  "routes": [
   {
    "channel": "fairy-au",
    "passages": 51,
    "share": 0.7083,
    "first": "2026-03-05",
    "last": "2026-03-16",
    "kind": "au",
    "castWith": [
     "felix_fairy",
     "juliette_fairy",
     "cyrus_fairy",
     "nia_fairy",
     "gus_fairy",
     "langley",
     "god",
     "haley_human",
     "will"
    ]
   },
   {
    "channel": "cruz-undercover",
    "passages": 7,
    "share": 0.0972,
    "first": "2025-01-03",
    "last": "2025-01-04",
    "kind": "canon",
    "castWith": [
     "cruz",
     "lyden",
     "evelyn",
     "frau",
     "ford",
     "bryce",
     "dimitri",
     "kaleb",
     "uncle_khan",
     "brax",
     "ever",
     "diana"
    ]
   },
   {
    "channel": "Haley - 7/30/2026",
    "passages": 5,
    "share": 0.0694,
    "first": "2026-07-30",
    "last": "2026-07-30",
    "kind": "route",
    "castWith": [
     "cruz",
     "alistair",
     "sebastian_vamp",
     "bryce",
     "nolan",
     "dimitri",
     "audrey",
     "alistair_turayne"
    ]
   },
   {
    "channel": "fairy-au-bios",
    "passages": 3,
    "share": 0.0417,
    "first": "2026-03-13",
    "last": "2026-03-13",
    "kind": "au",
    "castWith": [
     "juliette_fairy",
     "felix_fairy",
     "langley",
     "cyrus_fairy",
     "nia_fairy",
     "gus_fairy"
    ]
   },
   {
    "channel": "eat-speak-rp-repeat",
    "passages": 3,
    "share": 0.0417,
    "first": "2026-03-11",
    "last": "2026-03-18",
    "kind": "ooc",
    "castWith": [
     "eric",
     "cruz",
     "lindon",
     "april",
     "lance",
     "felix_fairy",
     "brooke",
     "cyrus_fairy",
     "god",
     "jack",
     "pam",
     "ezra"
    ]
   },
   {
    "channel": "Malakai \u2014 DM to RP (5/22/2026)",
    "passages": 2,
    "share": 0.0278,
    "first": "2026-05-24",
    "last": "2026-05-28",
    "kind": "route",
    "castWith": [
     "juliette_fairy",
     "god"
    ]
   },
   {
    "channel": "future-route-ideas",
    "passages": 1,
    "share": 0.0139,
    "first": "2026-03-09",
    "last": "2026-03-09",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "vaughn",
     "felix_fairy",
     "cyrus_fairy",
     "nia_fairy",
     "gus_fairy"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "lyden",
   "evelyn",
   "frau",
   "ford",
   "bryce",
   "dimitri",
   "kaleb",
   "uncle_khan",
   "brax",
   "ever",
   "diana"
  ]
 },
 "felix_fairy": {
  "canonRoute": "fairy-fresh",
  "totalPassages": 126,
  "routes": [
   {
    "channel": "fairy-au",
    "passages": 47,
    "share": 0.373,
    "first": "2026-03-03",
    "last": "2026-03-18",
    "kind": "au",
    "castWith": [
     "malakai",
     "juliette_fairy",
     "cyrus_fairy",
     "nia_fairy",
     "gus_fairy",
     "langley",
     "god",
     "haley_human",
     "will"
    ]
   },
   {
    "channel": "fairy-fresh",
    "passages": 25,
    "share": 0.1984,
    "first": "2026-03-18",
    "last": "2026-03-30",
    "kind": "canon",
    "castWith": [
     "cyrus_fairy",
     "juliette_fairy",
     "nia_fairy",
     "gus_fairy",
     "ever",
     "god"
    ]
   },
   {
    "channel": "frau-collin",
    "passages": 24,
    "share": 0.1905,
    "first": "2020-11-23",
    "last": "2020-12-07",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "rowan",
     "frau",
     "collin_keller",
     "arland_rees",
     "ezra",
     "rikki",
     "park",
     "alyce_char",
     "myra",
     "allie"
    ]
   },
   {
    "channel": "Lindon + Ford",
    "passages": 16,
    "share": 0.127,
    "first": "2026-05-23",
    "last": "2026-05-27",
    "kind": "route",
    "castWith": [
     "ford",
     "lindon",
     "tim",
     "dante",
     "nicole_human",
     "park",
     "nicole_wolf",
     "nicole_sg3",
     "ben",
     "may",
     "will",
     "ezra"
    ]
   },
   {
    "channel": "eat-speak-rp-repeat",
    "passages": 6,
    "share": 0.0476,
    "first": "2026-03-13",
    "last": "2026-03-23",
    "kind": "ooc",
    "castWith": [
     "eric",
     "cruz",
     "lindon",
     "april",
     "lance",
     "brooke",
     "cyrus_fairy",
     "malakai",
     "god",
     "jack",
     "pam",
     "ezra"
    ]
   },
   {
    "channel": "fairy-au-bios",
    "passages": 3,
    "share": 0.0238,
    "first": "2026-03-13",
    "last": "2026-03-13",
    "kind": "au",
    "castWith": [
     "juliette_fairy",
     "malakai",
     "langley",
     "cyrus_fairy",
     "nia_fairy",
     "gus_fairy"
    ]
   },
   {
    "channel": "ace-route",
    "passages": 3,
    "share": 0.0238,
    "first": "2020-08-04",
    "last": "2020-08-04",
    "kind": "route",
    "castWith": [
     "evelyn",
     "ace",
     "ezra",
     "sebastian_vamp",
     "sebastian_siren",
     "kaleb",
     "kya_sg3",
     "kya_sg1",
     "mr_han_sr",
     "frau",
     "rosie",
     "will"
    ]
   },
   {
    "channel": "you-have-me-roman",
    "passages": 1,
    "share": 0.0079,
    "first": "2022-11-08",
    "last": "2022-11-08",
    "kind": "route",
    "castWith": [
     "darius",
     "titus",
     "roman",
     "kya_sg3",
     "dillon",
     "kya_sg1",
     "evelyn",
     "stellar",
     "easton",
     "deven",
     "will",
     "lachesis"
    ]
   },
   {
    "channel": "future-route-ideas",
    "passages": 1,
    "share": 0.0079,
    "first": "2026-03-09",
    "last": "2026-03-09",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "vaughn",
     "malakai",
     "cyrus_fairy",
     "nia_fairy",
     "gus_fairy"
    ]
   }
  ],
  "knownCharacters": [
   "cyrus_fairy",
   "juliette_fairy",
   "nia_fairy",
   "gus_fairy",
   "ever",
   "god"
  ]
 },
 "cyrus_fairy": {
  "canonRoute": "fairy-fresh",
  "totalPassages": 71,
  "routes": [
   {
    "channel": "fairy-fresh",
    "passages": 47,
    "share": 0.662,
    "first": "2026-03-18",
    "last": "2026-03-31",
    "kind": "canon",
    "castWith": [
     "felix_fairy",
     "juliette_fairy",
     "nia_fairy",
     "gus_fairy",
     "ever",
     "god"
    ]
   },
   {
    "channel": "fairy-au",
    "passages": 16,
    "share": 0.2254,
    "first": "2026-03-03",
    "last": "2026-03-11",
    "kind": "au",
    "castWith": [
     "malakai",
     "felix_fairy",
     "juliette_fairy",
     "nia_fairy",
     "gus_fairy",
     "langley",
     "god",
     "haley_human",
     "will"
    ]
   },
   {
    "channel": "eat-speak-rp-repeat",
    "passages": 5,
    "share": 0.0704,
    "first": "2026-03-18",
    "last": "2026-03-25",
    "kind": "ooc",
    "castWith": [
     "eric",
     "cruz",
     "lindon",
     "april",
     "lance",
     "felix_fairy",
     "brooke",
     "malakai",
     "god",
     "jack",
     "pam",
     "ezra"
    ]
   },
   {
    "channel": "fairy-au-bios",
    "passages": 2,
    "share": 0.0282,
    "first": "2026-03-13",
    "last": "2026-03-13",
    "kind": "au",
    "castWith": [
     "juliette_fairy",
     "malakai",
     "felix_fairy",
     "langley",
     "nia_fairy",
     "gus_fairy"
    ]
   },
   {
    "channel": "future-route-ideas",
    "passages": 1,
    "share": 0.0141,
    "first": "2026-03-09",
    "last": "2026-03-09",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "vaughn",
     "malakai",
     "felix_fairy",
     "nia_fairy",
     "gus_fairy"
    ]
   }
  ],
  "knownCharacters": [
   "felix_fairy",
   "juliette_fairy",
   "nia_fairy",
   "gus_fairy",
   "ever",
   "god"
  ]
 },
 "nia_fairy": {
  "canonRoute": "fairy-fresh",
  "totalPassages": 23,
  "routes": [
   {
    "channel": "fairy-fresh",
    "passages": 13,
    "share": 0.5652,
    "first": "2026-03-23",
    "last": "2026-03-25",
    "kind": "canon",
    "castWith": [
     "cyrus_fairy",
     "felix_fairy",
     "juliette_fairy",
     "gus_fairy",
     "ever",
     "god"
    ]
   },
   {
    "channel": "fairy-au",
    "passages": 7,
    "share": 0.3043,
    "first": "2026-03-03",
    "last": "2026-03-10",
    "kind": "au",
    "castWith": [
     "malakai",
     "felix_fairy",
     "juliette_fairy",
     "cyrus_fairy",
     "gus_fairy",
     "langley",
     "god",
     "haley_human",
     "will"
    ]
   },
   {
    "channel": "fairy-au-bios",
    "passages": 2,
    "share": 0.087,
    "first": "2026-03-13",
    "last": "2026-03-13",
    "kind": "au",
    "castWith": [
     "juliette_fairy",
     "malakai",
     "felix_fairy",
     "langley",
     "cyrus_fairy",
     "gus_fairy"
    ]
   },
   {
    "channel": "future-route-ideas",
    "passages": 1,
    "share": 0.0435,
    "first": "2026-03-09",
    "last": "2026-03-09",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "vaughn",
     "malakai",
     "felix_fairy",
     "cyrus_fairy",
     "gus_fairy"
    ]
   }
  ],
  "knownCharacters": [
   "cyrus_fairy",
   "felix_fairy",
   "juliette_fairy",
   "gus_fairy",
   "ever",
   "god"
  ]
 },
 "gus_fairy": {
  "canonRoute": "fairy-fresh",
  "totalPassages": 22,
  "routes": [
   {
    "channel": "fairy-fresh",
    "passages": 11,
    "share": 0.5,
    "first": "2026-03-23",
    "last": "2026-03-25",
    "kind": "canon",
    "castWith": [
     "cyrus_fairy",
     "felix_fairy",
     "juliette_fairy",
     "nia_fairy",
     "ever",
     "god"
    ]
   },
   {
    "channel": "fairy-au",
    "passages": 6,
    "share": 0.2727,
    "first": "2026-03-03",
    "last": "2026-03-10",
    "kind": "au",
    "castWith": [
     "malakai",
     "felix_fairy",
     "juliette_fairy",
     "cyrus_fairy",
     "nia_fairy",
     "langley",
     "god",
     "haley_human",
     "will"
    ]
   },
   {
    "channel": "fairy-au-bios",
    "passages": 2,
    "share": 0.0909,
    "first": "2026-03-13",
    "last": "2026-03-13",
    "kind": "au",
    "castWith": [
     "juliette_fairy",
     "malakai",
     "felix_fairy",
     "langley",
     "cyrus_fairy",
     "nia_fairy"
    ]
   },
   {
    "channel": "cruz-x-human",
    "passages": 1,
    "share": 0.0455,
    "first": "2021-04-01",
    "last": "2021-04-01",
    "kind": "route",
    "castWith": [
     "cruz",
     "skye",
     "nolan",
     "ryder",
     "audrey",
     "troy",
     "adrien",
     "bryce",
     "airi",
     "natasha",
     "diana",
     "will"
    ]
   },
   {
    "channel": "eat-speak-rp-repeat",
    "passages": 1,
    "share": 0.0455,
    "first": "2026-03-13",
    "last": "2026-03-13",
    "kind": "ooc",
    "castWith": [
     "eric",
     "cruz",
     "lindon",
     "april",
     "lance",
     "felix_fairy",
     "brooke",
     "cyrus_fairy",
     "malakai",
     "god",
     "jack",
     "pam"
    ]
   },
   {
    "channel": "future-route-ideas",
    "passages": 1,
    "share": 0.0455,
    "first": "2026-03-09",
    "last": "2026-03-09",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "vaughn",
     "malakai",
     "felix_fairy",
     "cyrus_fairy",
     "nia_fairy"
    ]
   }
  ],
  "knownCharacters": [
   "cyrus_fairy",
   "felix_fairy",
   "juliette_fairy",
   "nia_fairy",
   "ever",
   "god"
  ]
 },
 "aelira": {
  "canonRoute": "warring-men",
  "totalPassages": 229,
  "routes": [
   {
    "channel": "warring-men",
    "passages": 124,
    "share": 0.5415,
    "first": "2025-08-07",
    "last": "2025-10-05",
    "kind": "canon",
    "castWith": [
     "killian",
     "arthur_turayne",
     "autumn",
     "summer",
     "terrance",
     "may",
     "ragland",
     "will"
    ]
   },
   {
    "channel": "terrance-and-the-forest",
    "passages": 104,
    "share": 0.4541,
    "first": "2025-10-07",
    "last": "2025-10-26",
    "kind": "route",
    "castWith": [
     "terrance",
     "killian",
     "arthur_turayne",
     "may",
     "ford",
     "arnold_astor",
     "god",
     "lira"
    ]
   },
   {
    "channel": "alistair-immortuous-gone-wrong",
    "passages": 1,
    "share": 0.0044,
    "first": "2025-10-30",
    "last": "2025-10-30",
    "kind": "route",
    "castWith": [
     "raz",
     "james",
     "kya_sg3",
     "dillon",
     "junta",
     "kya_sg1",
     "alistair",
     "alistair_turayne",
     "val",
     "vanessa",
     "sebastian_vamp",
     "tim"
    ]
   }
  ],
  "knownCharacters": [
   "killian",
   "arthur_turayne",
   "autumn",
   "summer",
   "terrance",
   "may",
   "ragland",
   "will"
  ]
 },
 "alexei": {
  "canonRoute": "the-von-dabb-castle",
  "totalPassages": 24,
  "routes": [
   {
    "channel": "the-von-dabb-castle",
    "passages": 16,
    "share": 0.6667,
    "first": "2020-04-06",
    "last": "2020-04-07",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "bryce",
     "rio",
     "frau",
     "geo",
     "mr_han_sr",
     "kaleb",
     "ezra",
     "bradshaw",
     "may",
     "kya_sg3",
     "will"
    ]
   },
   {
    "channel": "the-king",
    "passages": 7,
    "share": 0.2917,
    "first": "2022-10-01",
    "last": "2022-10-03",
    "kind": "route",
    "castWith": [
     "evelyn",
     "bryce"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 1,
    "share": 0.0417,
    "first": "2020-04-07",
    "last": "2020-04-07",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "bryce",
   "rio",
   "frau",
   "geo",
   "mr_han_sr",
   "kaleb",
   "ezra",
   "bradshaw",
   "may",
   "kya_sg3",
   "will"
  ]
 },
 "allie": {
  "canonRoute": "no-time-like-the-present",
  "totalPassages": 204,
  "routes": [
   {
    "channel": "no-time-like-the-present",
    "passages": 70,
    "share": 0.3431,
    "first": "2023-09-25",
    "last": "2023-10-09",
    "kind": "canon",
    "castWith": [
     "eva",
     "shane",
     "lance",
     "ryder",
     "cruz",
     "micah",
     "god",
     "aspen",
     "trix",
     "diana",
     "evelyn",
     "audrey"
    ]
   },
   {
    "channel": "a-tricky-micah-cruz-route",
    "passages": 31,
    "share": 0.152,
    "first": "2023-08-17",
    "last": "2023-09-19",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "ryder",
     "cruz",
     "micah",
     "trix",
     "evelyn",
     "roger",
     "audrey",
     "god",
     "bryce",
     "diana"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 22,
    "share": 0.1078,
    "first": "2024-01-25",
    "last": "2025-02-25",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "ryder",
     "ford",
     "vaughn",
     "lance",
     "bryce",
     "shane",
     "dimitri",
     "micah",
     "audrey",
     "moros"
    ]
   },
   {
    "channel": "growing-up-cruz",
    "passages": 20,
    "share": 0.098,
    "first": "2023-01-29",
    "last": "2023-02-09",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "kaleb",
     "audrey",
     "raquel_ratchet",
     "dimitri",
     "trix",
     "ford",
     "ryder",
     "lyden",
     "frau",
     "uncle_khan"
    ]
   },
   {
    "channel": "pack_house",
    "passages": 11,
    "share": 0.0539,
    "first": "2020-03-25",
    "last": "2020-03-25",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "nolan",
     "bryce",
     "audrey",
     "alyce_char",
     "luca",
     "trix",
     "asmodeus",
     "ryder",
     "kaleb",
     "ezra"
    ]
   },
   {
    "channel": "frau-collin",
    "passages": 10,
    "share": 0.049,
    "first": "2020-04-15",
    "last": "2020-11-03",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "rowan",
     "frau",
     "collin_keller",
     "arland_rees",
     "ezra",
     "felix_fairy",
     "rikki",
     "park",
     "alyce_char",
     "myra"
    ]
   },
   {
    "channel": "lance-mating",
    "passages": 8,
    "share": 0.0392,
    "first": "2021-09-07",
    "last": "2021-09-13",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "clothos",
     "ryder",
     "hades",
     "nolan",
     "nicole_human",
     "audrey",
     "moros",
     "atropos",
     "nicole_wolf"
    ]
   },
   {
    "channel": "cruz-x-nicole",
    "passages": 6,
    "share": 0.0294,
    "first": "2020-08-06",
    "last": "2020-08-08",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "hermes",
     "audrey",
     "peter",
     "ares",
     "nicole_wolf",
     "nicole_sg3",
     "alyce_char",
     "red",
     "trix",
     "nicole_human"
    ]
   },
   {
    "channel": "ww-war-au",
    "passages": 4,
    "share": 0.0196,
    "first": "2021-12-11",
    "last": "2021-12-12",
    "kind": "au",
    "castWith": [
     "evelyn",
     "cruz",
     "ace",
     "ezra",
     "lindon",
     "kaleb",
     "rowan",
     "bryce",
     "lance",
     "raye",
     "nolan",
     "primrose"
    ]
   },
   {
    "channel": "ares-phones-home",
    "passages": 3,
    "share": 0.0147,
    "first": "2024-06-18",
    "last": "2024-11-26",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "cruz",
     "ryder",
     "ares",
     "roger",
     "diana",
     "micah",
     "cupid_eros",
     "penelope_valk",
     "evelyn",
     "lance"
    ]
   },
   {
    "channel": "1-real-cruz",
    "passages": 2,
    "share": 0.0098,
    "first": "2022-10-23",
    "last": "2022-10-23",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "ares",
     "lance",
     "selma",
     "zeus",
     "lindon",
     "hera",
     "ryder",
     "apollo",
     "nolan"
    ]
   },
   {
    "channel": "cruz-x-human",
    "passages": 2,
    "share": 0.0098,
    "first": "2021-04-23",
    "last": "2021-04-29",
    "kind": "route",
    "castWith": [
     "cruz",
     "skye",
     "nolan",
     "ryder",
     "audrey",
     "troy",
     "adrien",
     "bryce",
     "airi",
     "natasha",
     "diana",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "eva",
   "shane",
   "lance",
   "ryder",
   "cruz",
   "micah",
   "god",
   "aspen",
   "trix",
   "diana",
   "evelyn",
   "audrey"
  ]
 },
 "aphrodite": {
  "canonRoute": "chance-route-ft-lance",
  "totalPassages": 204,
  "routes": [
   {
    "channel": "chance-route-ft-lance",
    "passages": 18,
    "share": 0.0882,
    "first": "2021-09-29",
    "last": "2021-10-18",
    "kind": "canon",
    "castWith": [
     "lachesis",
     "chance",
     "lance",
     "god",
     "atropos",
     "clothos",
     "zeus",
     "moros",
     "ares",
     "hades",
     "may",
     "will"
    ]
   },
   {
    "channel": "cruz-nicole-dollar-store",
    "passages": 16,
    "share": 0.0784,
    "first": "2020-09-16",
    "last": "2020-09-21",
    "kind": "route",
    "castWith": [
     "cruz",
     "raz",
     "lance",
     "lachesis",
     "bryce",
     "nolan",
     "renee",
     "clothos",
     "atropos",
     "nicole_wolf",
     "nicole_sg3",
     "moros"
    ]
   },
   {
    "channel": "mt-olympus",
    "passages": 15,
    "share": 0.0735,
    "first": "2020-03-30",
    "last": "2020-06-29",
    "kind": "route",
    "castWith": [
     "evelyn",
     "libion",
     "ares",
     "rex",
     "persephone",
     "bion",
     "hades",
     "hercules",
     "demeter",
     "zeus",
     "athena",
     "zerden"
    ]
   },
   {
    "channel": "haggle-for-the-girl",
    "passages": 13,
    "share": 0.0637,
    "first": "2023-12-13",
    "last": "2024-01-02",
    "kind": "route",
    "castWith": [
     "lachesis",
     "lucifer",
     "asrius",
     "god",
     "lonnie",
     "ramiel",
     "gabriel",
     "lance",
     "hades",
     "alyk",
     "atropos",
     "zeus"
    ]
   },
   {
    "channel": "lance-mating",
    "passages": 11,
    "share": 0.0539,
    "first": "2021-08-30",
    "last": "2021-08-30",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "clothos",
     "ryder",
     "hades",
     "nolan",
     "nicole_human",
     "audrey",
     "moros",
     "atropos",
     "nicole_wolf"
    ]
   },
   {
    "channel": "kya-goddess-route",
    "passages": 11,
    "share": 0.0539,
    "first": "2021-01-01",
    "last": "2021-01-03",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "pierce",
     "cupid_eros",
     "kya_sg1"
    ]
   },
   {
    "channel": "sabrinas-apartment",
    "passages": 10,
    "share": 0.049,
    "first": "2020-06-06",
    "last": "2020-06-06",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "sabrina_witch",
     "halo",
     "hiro",
     "ares",
     "athena",
     "demeter",
     "god",
     "roman"
    ]
   },
   {
    "channel": "ocroute2-cruz-in-for-love",
    "passages": 9,
    "share": 0.0441,
    "first": "2022-01-30",
    "last": "2022-02-17",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "dimitri",
     "hades",
     "zeus",
     "hera",
     "god",
     "bryce",
     "amanda",
     "lachesis",
     "hermes",
     "nolan"
    ]
   },
   {
    "channel": "siren-raye",
    "passages": 8,
    "share": 0.0392,
    "first": "2023-10-19",
    "last": "2023-10-23",
    "kind": "route",
    "castWith": [
     "raye",
     "kya_sg1",
     "kya_sg3",
     "sebastian_vamp",
     "sebastian_siren",
     "apollo",
     "kaleb",
     "cupid_eros",
     "hermes",
     "ezra",
     "ares",
     "may"
    ]
   },
   {
    "channel": "heavenbound-missions",
    "passages": 7,
    "share": 0.0343,
    "first": "2025-10-08",
    "last": "2025-10-08",
    "kind": "route",
    "castWith": [
     "vaughn",
     "lindon",
     "god",
     "ares",
     "brax",
     "primrose",
     "nicole_human",
     "nicole_wolf",
     "nicole_sg3",
     "beatrice",
     "will",
     "cruz"
    ]
   },
   {
    "channel": "1-real-cruz",
    "passages": 6,
    "share": 0.0294,
    "first": "2023-01-13",
    "last": "2023-01-24",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "ares",
     "lance",
     "selma",
     "zeus",
     "lindon",
     "hera",
     "ryder",
     "apollo",
     "nolan"
    ]
   },
   {
    "channel": "greek-house",
    "passages": 5,
    "share": 0.0245,
    "first": "2020-05-06",
    "last": "2020-05-07",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hiro",
     "darren",
     "lex",
     "kiro",
     "raye",
     "kya_sg3",
     "ares",
     "riku",
     "kya_sg1",
     "lacie",
     "god"
    ]
   }
  ],
  "knownCharacters": [
   "lachesis",
   "chance",
   "lance",
   "god",
   "atropos",
   "clothos",
   "zeus",
   "moros",
   "ares",
   "hades",
   "may",
   "will"
  ]
 },
 "apollo": {
  "canonRoute": "moros-commits",
  "totalPassages": 587,
  "routes": [
   {
    "channel": "moros-commits",
    "passages": 79,
    "share": 0.1346,
    "first": "2021-10-06",
    "last": "2021-10-23",
    "kind": "canon",
    "castWith": [
     "moros",
     "atropos",
     "lachesis",
     "aphrodite",
     "clothos",
     "will",
     "cupid_eros",
     "hera",
     "may",
     "zeus"
    ]
   },
   {
    "channel": "the-bachelorette-season-kya",
    "passages": 53,
    "share": 0.0903,
    "first": "2021-05-19",
    "last": "2021-05-24",
    "kind": "route",
    "castWith": [
     "evelyn",
     "kya_sg3",
     "kya_sg1",
     "carole",
     "hermes",
     "aphrodite",
     "ares",
     "may",
     "skipper",
     "god",
     "hera",
     "jessica"
    ]
   },
   {
    "channel": "plz-love-lachesis",
    "passages": 51,
    "share": 0.0869,
    "first": "2022-11-11",
    "last": "2022-11-23",
    "kind": "route",
    "castWith": [
     "lachesis",
     "ramiel",
     "lance",
     "god",
     "lucifer",
     "levi",
     "aion",
     "atropos",
     "zeus",
     "zadkiel",
     "clothos",
     "asrius"
    ]
   },
   {
    "channel": "atropos-reincarnated",
    "passages": 50,
    "share": 0.0852,
    "first": "2022-06-13",
    "last": "2022-06-30",
    "kind": "route",
    "castWith": [
     "moros",
     "haley_wolf",
     "atropos",
     "zeus",
     "zephyr",
     "dante",
     "lachesis",
     "clothos",
     "aphrodite",
     "hera",
     "haley_human",
     "nicole_human"
    ]
   },
   {
    "channel": "wtf-happened",
    "passages": 48,
    "share": 0.0818,
    "first": "2023-08-24",
    "last": "2023-09-01",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "moros",
     "atropos",
     "alistair",
     "alistair_turayne",
     "haley_wolf",
     "haley_human",
     "lachesis",
     "aphrodite",
     "zeus",
     "ezra",
     "god"
    ]
   },
   {
    "channel": "fantastical-ezra",
    "passages": 39,
    "share": 0.0664,
    "first": "2025-02-21",
    "last": "2025-03-04",
    "kind": "route",
    "castWith": [
     "ezra",
     "dillon",
     "kaleb",
     "kya_sg3",
     "james",
     "sebastian_vamp",
     "evelyn",
     "kya_sg1",
     "haley_human",
     "sebastian_siren",
     "skipper",
     "polly"
    ]
   },
   {
    "channel": "kinley-is-a-nondecisive-butt",
    "passages": 36,
    "share": 0.0613,
    "first": "2022-03-24",
    "last": "2022-04-08",
    "kind": "route",
    "castWith": [
     "zain_demigod",
     "kinley",
     "lex",
     "cupid_eros",
     "hera",
     "lachesis",
     "sebastian_vamp",
     "sebastian_siren",
     "ben",
     "god",
     "will",
     "zeus"
    ]
   },
   {
    "channel": "alistair-x-human-kya",
    "passages": 36,
    "share": 0.0613,
    "first": "2020-08-09",
    "last": "2020-08-13",
    "kind": "route",
    "castWith": [
     "haley_human",
     "alistair_turayne",
     "alistair",
     "nicole_human",
     "ezra",
     "raye",
     "james",
     "atropos",
     "hades",
     "beatrice",
     "cruz",
     "haley_wolf"
    ]
   },
   {
    "channel": "college-possessive",
    "passages": 28,
    "share": 0.0477,
    "first": "2024-12-24",
    "last": "2025-01-03",
    "kind": "route",
    "castWith": [
     "leon",
     "moros",
     "atropos",
     "lachesis",
     "haley_human",
     "haley_wolf",
     "sabrina_witch",
     "clothos",
     "god",
     "may",
     "will",
     "zeus"
    ]
   },
   {
    "channel": "1-real-cruz",
    "passages": 19,
    "share": 0.0324,
    "first": "2023-01-13",
    "last": "2023-01-26",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "ares",
     "lance",
     "selma",
     "zeus",
     "lindon",
     "hera",
     "ryder",
     "nolan",
     "diana"
    ]
   },
   {
    "channel": "apollo-loving",
    "passages": 19,
    "share": 0.0324,
    "first": "2024-02-16",
    "last": "2024-02-19",
    "kind": "route",
    "castWith": [
     "kieran",
     "raz",
     "aphrodite",
     "cupid_eros"
    ]
   },
   {
    "channel": "cruz-is-not-dead",
    "passages": 14,
    "share": 0.0239,
    "first": "2022-05-15",
    "last": "2022-05-17",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "ford",
     "ryder",
     "lucifer",
     "bryce",
     "audrey",
     "ares",
     "god",
     "clint",
     "hades",
     "nolan"
    ]
   }
  ],
  "knownCharacters": [
   "moros",
   "atropos",
   "lachesis",
   "aphrodite",
   "clothos",
   "will",
   "cupid_eros",
   "hera",
   "may",
   "zeus"
  ]
 },
 "ares": {
  "canonRoute": "evelyn-college-2",
  "totalPassages": 421,
  "routes": [
   {
    "channel": "evelyn-college-2",
    "passages": 56,
    "share": 0.133,
    "first": "2021-01-01",
    "last": "2021-01-26",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "darren",
     "dimitri",
     "lex",
     "hades",
     "raye",
     "jon",
     "kaleb",
     "cruz",
     "kya_sg3",
     "ari",
     "aibell"
    ]
   },
   {
    "channel": "1-real-cruz",
    "passages": 54,
    "share": 0.1283,
    "first": "2023-01-09",
    "last": "2023-01-24",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "lance",
     "selma",
     "zeus",
     "lindon",
     "hera",
     "ryder",
     "apollo",
     "nolan",
     "diana"
    ]
   },
   {
    "channel": "cruz-x-nicole",
    "passages": 34,
    "share": 0.0808,
    "first": "2020-08-17",
    "last": "2020-08-19",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "hermes",
     "audrey",
     "peter",
     "nicole_wolf",
     "nicole_sg3",
     "alyce_char",
     "red",
     "trix",
     "nicole_human",
     "moros"
    ]
   },
   {
    "channel": "misc-location",
    "passages": 29,
    "share": 0.0689,
    "first": "2020-05-03",
    "last": "2020-05-12",
    "kind": "route",
    "castWith": [
     "evelyn",
     "riku",
     "kiro",
     "hiro",
     "lex",
     "lance",
     "ezra",
     "lucius",
     "darren",
     "kaleb",
     "raye",
     "kya_sg3"
    ]
   },
   {
    "channel": "vaughneo-and-juliet",
    "passages": 28,
    "share": 0.0665,
    "first": "2025-11-25",
    "last": "2026-01-23",
    "kind": "route",
    "castWith": [
     "vaughn",
     "brax",
     "lindon",
     "declan",
     "skye",
     "roman",
     "mary_cataldi",
     "liz",
     "nicole_human",
     "aphrodite",
     "ace",
     "ben"
    ]
   },
   {
    "channel": "mt-olympus",
    "passages": 21,
    "share": 0.0499,
    "first": "2020-06-19",
    "last": "2020-06-29",
    "kind": "route",
    "castWith": [
     "evelyn",
     "libion",
     "rex",
     "persephone",
     "bion",
     "hades",
     "aphrodite",
     "hercules",
     "demeter",
     "zeus",
     "athena",
     "zerden"
    ]
   },
   {
    "channel": "ooc",
    "passages": 18,
    "share": 0.0428,
    "first": "2020-05-04",
    "last": "2020-06-20",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "yandere-cruz",
    "passages": 14,
    "share": 0.0333,
    "first": "2022-10-29",
    "last": "2022-11-11",
    "kind": "route",
    "castWith": [
     "lance",
     "cruz",
     "evelyn",
     "moros",
     "alyce_char",
     "clothos",
     "atropos",
     "dimitri",
     "lachesis",
     "cupid_eros",
     "hades",
     "diana"
    ]
   },
   {
    "channel": "greek-house",
    "passages": 14,
    "share": 0.0333,
    "first": "2020-05-06",
    "last": "2020-05-21",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hiro",
     "darren",
     "lex",
     "kiro",
     "raye",
     "kya_sg3",
     "riku",
     "kya_sg1",
     "lacie",
     "aphrodite",
     "god"
    ]
   },
   {
    "channel": "cruz-is-not-dead",
    "passages": 13,
    "share": 0.0309,
    "first": "2022-05-10",
    "last": "2022-05-17",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "ford",
     "ryder",
     "lucifer",
     "bryce",
     "audrey",
     "apollo",
     "god",
     "clint",
     "hades",
     "nolan"
    ]
   },
   {
    "channel": "tyrant-evie",
    "passages": 12,
    "share": 0.0285,
    "first": "2022-01-01",
    "last": "2022-01-08",
    "kind": "route",
    "castWith": [
     "evelyn",
     "bryce",
     "cruz",
     "myra",
     "hermes",
     "rio",
     "hades",
     "frau",
     "zeus",
     "nolan",
     "audrey",
     "apollo"
    ]
   },
   {
    "channel": "cruz-nicole-dollar-store",
    "passages": 12,
    "share": 0.0285,
    "first": "2020-09-15",
    "last": "2020-09-16",
    "kind": "route",
    "castWith": [
     "cruz",
     "raz",
     "lance",
     "lachesis",
     "bryce",
     "nolan",
     "renee",
     "aphrodite",
     "clothos",
     "atropos",
     "nicole_wolf",
     "nicole_sg3"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "darren",
   "dimitri",
   "lex",
   "hades",
   "raye",
   "jon",
   "kaleb",
   "cruz",
   "kya_sg3",
   "ari",
   "aibell"
  ]
 },
 "bradshaw": {
  "canonRoute": "the-von-dabb-castle",
  "totalPassages": 4,
  "routes": [
   {
    "channel": "the-von-dabb-castle",
    "passages": 3,
    "share": 0.75,
    "first": "2020-04-07",
    "last": "2020-04-07",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "bryce",
     "rio",
     "frau",
     "geo",
     "alexei",
     "mr_han_sr",
     "kaleb",
     "ezra",
     "may",
     "kya_sg3",
     "will"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 1,
    "share": 0.25,
    "first": "2020-04-06",
    "last": "2020-04-06",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "bryce",
   "rio",
   "frau",
   "geo",
   "alexei",
   "mr_han_sr",
   "kaleb",
   "ezra",
   "may",
   "kya_sg3",
   "will"
  ]
 },
 "carole": {
  "canonRoute": "the-bachelorette-season-kya",
  "totalPassages": 5,
  "routes": [
   {
    "channel": "the-bachelorette-season-kya",
    "passages": 5,
    "share": 1.0,
    "first": "2021-05-20",
    "last": "2021-05-21",
    "kind": "canon",
    "castWith": [
     "apollo",
     "evelyn",
     "kya_sg3",
     "kya_sg1",
     "hermes",
     "aphrodite",
     "ares",
     "may",
     "skipper",
     "god",
     "hera",
     "jessica"
    ]
   }
  ],
  "knownCharacters": [
   "apollo",
   "evelyn",
   "kya_sg3",
   "kya_sg1",
   "hermes",
   "aphrodite",
   "ares",
   "may",
   "skipper",
   "god",
   "hera",
   "jessica"
  ]
 },
 "diana": {
  "canonRoute": "school-gym",
  "totalPassages": 217,
  "routes": [
   {
    "channel": "switched-roles-kya",
    "passages": 20,
    "share": 0.0922,
    "first": "2023-10-12",
    "last": "2023-10-16",
    "kind": "au",
    "castWith": [
     "kya_sg3",
     "raye",
     "ezra",
     "tate",
     "emanuel",
     "kya_sg1",
     "aphrodite",
     "alistair_turayne",
     "alistair",
     "kaleb",
     "cupid_eros",
     "emmanuel"
    ]
   },
   {
    "channel": "school-gym",
    "passages": 17,
    "share": 0.0783,
    "first": "2020-06-10",
    "last": "2020-06-11",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "rex",
     "aaron",
     "milo",
     "kya_sg3",
     "kya_sg1",
     "roman",
     "dike",
     "frau",
     "dimitri",
     "sebastian_vamp",
     "raye"
    ]
   },
   {
    "channel": "1-real-cruz",
    "passages": 15,
    "share": 0.0691,
    "first": "2022-10-07",
    "last": "2023-01-15",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "ares",
     "lance",
     "selma",
     "zeus",
     "lindon",
     "hera",
     "ryder",
     "apollo",
     "nolan"
    ]
   },
   {
    "channel": "human-evie",
    "passages": 12,
    "share": 0.0553,
    "first": "2020-10-14",
    "last": "2021-02-27",
    "kind": "route",
    "castWith": [
     "evelyn",
     "kaleb",
     "frau",
     "cruz",
     "mr_han_sr",
     "audrey",
     "richard_antore",
     "ares",
     "quincy_antore",
     "nereda",
     "elizabeth_the_third",
     "ever"
    ]
   },
   {
    "channel": "love-hate-and-war",
    "passages": 12,
    "share": 0.0553,
    "first": "2022-07-07",
    "last": "2022-08-05",
    "kind": "route",
    "castWith": [
     "scarlett",
     "sett",
     "lance",
     "cruz",
     "lachesis",
     "hades",
     "alyce_char",
     "raz",
     "cupid_eros",
     "roman",
     "apollo",
     "will"
    ]
   },
   {
    "channel": "nicoles-wish-brax-brother",
    "passages": 11,
    "share": 0.0507,
    "first": "2023-04-26",
    "last": "2023-07-16",
    "kind": "route",
    "castWith": [
     "ford",
     "cruz",
     "brax",
     "lance",
     "dimitri",
     "hades",
     "vaughn",
     "rowan",
     "nicole_human",
     "audrey",
     "evelyn",
     "nicole_wolf"
    ]
   },
   {
    "channel": "auditorium",
    "passages": 11,
    "share": 0.0507,
    "first": "2020-06-11",
    "last": "2020-06-14",
    "kind": "route",
    "castWith": [
     "rex",
     "evelyn",
     "milo",
     "dimitri",
     "athena",
     "dike",
     "audrey",
     "saph",
     "bryce",
     "kaleb",
     "roman",
     "rio"
    ]
   },
   {
    "channel": "staff-break-room",
    "passages": 9,
    "share": 0.0415,
    "first": "2020-06-14",
    "last": "2020-06-17",
    "kind": "route",
    "castWith": [
     "dimitri",
     "rex",
     "evelyn",
     "saph",
     "aaron",
     "kiro",
     "milo",
     "skipper",
     "roman",
     "sebastian_vamp",
     "kya_sg3",
     "sebastian_siren"
    ]
   },
   {
    "channel": "athena-class",
    "passages": 9,
    "share": 0.0415,
    "first": "2020-06-18",
    "last": "2020-06-18",
    "kind": "route",
    "castWith": [
     "rex",
     "evelyn",
     "kiro",
     "milo",
     "cupid_eros",
     "athena",
     "dimitri",
     "dike",
     "kya_sg1",
     "aaron",
     "kya_sg3",
     "hiro"
    ]
   },
   {
    "channel": "a-tricky-micah-cruz-route",
    "passages": 8,
    "share": 0.0369,
    "first": "2023-08-25",
    "last": "2023-09-13",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "ryder",
     "cruz",
     "micah",
     "trix",
     "allie",
     "evelyn",
     "roger",
     "audrey",
     "god",
     "bryce"
    ]
   },
   {
    "channel": "storm-peak",
    "passages": 8,
    "share": 0.0369,
    "first": "2025-04-21",
    "last": "2025-04-24",
    "kind": "route",
    "castWith": [
     "rory"
    ]
   },
   {
    "channel": "nicolexcruz-true-mates",
    "passages": 8,
    "share": 0.0369,
    "first": "2024-03-26",
    "last": "2024-04-05",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "nolan",
     "clothos",
     "trix",
     "nicole_human",
     "audrey",
     "asrius",
     "lucifer",
     "atropos",
     "bryce"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "rex",
   "aaron",
   "milo",
   "kya_sg3",
   "kya_sg1",
   "roman",
   "dike",
   "frau",
   "dimitri",
   "sebastian_vamp",
   "raye"
  ]
 },
 "erza": {
  "canonRoute": null,
  "routes": [],
  "knownCharacters": [],
  "totalPassages": 0
 },
 "freya": {
  "canonRoute": "ag-ag",
  "totalPassages": 10,
  "routes": [
   {
    "channel": "ag-ag",
    "passages": 5,
    "share": 0.5,
    "first": "2022-10-07",
    "last": "2022-10-07",
    "kind": "canon",
    "castWith": [
     "agnar",
     "agmund",
     "loki",
     "frigg",
     "odin",
     "kya_sg3",
     "penelope_valk",
     "will",
     "evelyn",
     "sebastian_vamp",
     "sebastian_siren",
     "hiro"
    ]
   },
   {
    "channel": "ooc",
    "passages": 3,
    "share": 0.3,
    "first": "2020-05-19",
    "last": "2020-05-19",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "asgard",
    "passages": 2,
    "share": 0.2,
    "first": "2020-05-19",
    "last": "2020-05-19",
    "kind": "route",
    "castWith": [
     "agnar",
     "agmund",
     "loki",
     "kya_sg3",
     "odin",
     "svira",
     "penelope_valk",
     "kya_sg1",
     "sif",
     "thor",
     "god",
     "frigg"
    ]
   }
  ],
  "knownCharacters": [
   "agnar",
   "agmund",
   "loki",
   "frigg",
   "odin",
   "kya_sg3",
   "penelope_valk",
   "will",
   "evelyn",
   "sebastian_vamp",
   "sebastian_siren",
   "hiro"
  ]
 },
 "frigg": {
  "canonRoute": "ag-ag",
  "totalPassages": 16,
  "routes": [
   {
    "channel": "ag-ag",
    "passages": 12,
    "share": 0.75,
    "first": "2022-10-04",
    "last": "2022-10-07",
    "kind": "canon",
    "castWith": [
     "agnar",
     "agmund",
     "loki",
     "odin",
     "kya_sg3",
     "freya",
     "penelope_valk",
     "will",
     "evelyn",
     "sebastian_vamp",
     "sebastian_siren",
     "hiro"
    ]
   },
   {
    "channel": "ooc",
    "passages": 3,
    "share": 0.1875,
    "first": "2020-05-19",
    "last": "2020-05-19",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "asgard",
    "passages": 1,
    "share": 0.0625,
    "first": "2020-05-19",
    "last": "2020-05-19",
    "kind": "route",
    "castWith": [
     "agnar",
     "agmund",
     "loki",
     "kya_sg3",
     "odin",
     "svira",
     "penelope_valk",
     "kya_sg1",
     "sif",
     "thor",
     "freya",
     "god"
    ]
   }
  ],
  "knownCharacters": [
   "agnar",
   "agmund",
   "loki",
   "odin",
   "kya_sg3",
   "freya",
   "penelope_valk",
   "will",
   "evelyn",
   "sebastian_vamp",
   "sebastian_siren",
   "hiro"
  ]
 },
 "frau": {
  "canonRoute": "frau-collin",
  "totalPassages": 463,
  "routes": [
   {
    "channel": "hot-boi-arena-cruz",
    "passages": 106,
    "share": 0.2289,
    "first": "2022-05-20",
    "last": "2022-06-10",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "lyden",
     "crom",
     "ezra",
     "junta",
     "alyce_char",
     "ryder",
     "may",
     "rowan",
     "ares",
     "hades"
    ]
   },
   {
    "channel": "frau-collin",
    "passages": 76,
    "share": 0.1641,
    "first": "2020-11-10",
    "last": "2020-12-26",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "cruz",
     "rowan",
     "collin_keller",
     "arland_rees",
     "ezra",
     "felix_fairy",
     "rikki",
     "park",
     "alyce_char",
     "myra",
     "allie"
    ]
   },
   {
    "channel": "human-evie",
    "passages": 41,
    "share": 0.0886,
    "first": "2020-10-04",
    "last": "2021-02-27",
    "kind": "route",
    "castWith": [
     "evelyn",
     "kaleb",
     "cruz",
     "mr_han_sr",
     "audrey",
     "richard_antore",
     "diana",
     "ares",
     "quincy_antore",
     "nereda",
     "elizabeth_the_third",
     "ever"
    ]
   },
   {
    "channel": "the-von-dabb-castle",
    "passages": 40,
    "share": 0.0864,
    "first": "2020-04-01",
    "last": "2020-04-07",
    "kind": "route",
    "castWith": [
     "evelyn",
     "bryce",
     "rio",
     "geo",
     "alexei",
     "mr_han_sr",
     "kaleb",
     "ezra",
     "bradshaw",
     "may",
     "kya_sg3",
     "will"
    ]
   },
   {
    "channel": "bryces-quarters",
    "passages": 24,
    "share": 0.0518,
    "first": "2020-04-01",
    "last": "2020-04-07",
    "kind": "route",
    "castWith": [
     "bryce",
     "evelyn",
     "geo",
     "rio",
     "celine",
     "ezra",
     "raye",
     "god",
     "mr_han_sr"
    ]
   },
   {
    "channel": "dimitri-saves-the-day",
    "passages": 20,
    "share": 0.0432,
    "first": "2022-03-21",
    "last": "2022-04-04",
    "kind": "route",
    "castWith": [
     "dimitri",
     "evelyn",
     "raz",
     "uncle_khan",
     "renee",
     "will"
    ]
   },
   {
    "channel": "lets-abduct-evie",
    "passages": 17,
    "share": 0.0367,
    "first": "2021-06-16",
    "last": "2021-07-13",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "ryoto",
     "dodge",
     "ms_tia",
     "kaleb",
     "aki",
     "cruz",
     "talbot",
     "ares",
     "zeus",
     "hera"
    ]
   },
   {
    "channel": "cruz-undercover",
    "passages": 16,
    "share": 0.0346,
    "first": "2025-01-02",
    "last": "2025-01-15",
    "kind": "route",
    "castWith": [
     "cruz",
     "lyden",
     "evelyn",
     "ford",
     "bryce",
     "malakai",
     "dimitri",
     "kaleb",
     "uncle_khan",
     "brax",
     "ever",
     "diana"
    ]
   },
   {
    "channel": "evelyn-college-2",
    "passages": 10,
    "share": 0.0216,
    "first": "2020-12-27",
    "last": "2021-01-29",
    "kind": "route",
    "castWith": [
     "evelyn",
     "darren",
     "dimitri",
     "lex",
     "hades",
     "raye",
     "jon",
     "ares",
     "kaleb",
     "cruz",
     "kya_sg3",
     "ari"
    ]
   },
   {
    "channel": "ww-war-au",
    "passages": 9,
    "share": 0.0194,
    "first": "2021-11-18",
    "last": "2021-12-06",
    "kind": "au",
    "castWith": [
     "evelyn",
     "cruz",
     "ace",
     "ezra",
     "lindon",
     "kaleb",
     "rowan",
     "bryce",
     "lance",
     "raye",
     "nolan",
     "primrose"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 8,
    "share": 0.0173,
    "first": "2020-04-01",
    "last": "2020-04-06",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "dimitri-route-end",
    "passages": 7,
    "share": 0.0151,
    "first": "2021-02-01",
    "last": "2021-02-13",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "uri",
     "gambit",
     "jones",
     "ares",
     "bryce",
     "kaleb",
     "mr_han_sr",
     "zeus",
     "kya_sg3",
     "uncle_khan"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "cruz",
   "rowan",
   "collin_keller",
   "arland_rees",
   "ezra",
   "felix_fairy",
   "rikki",
   "park",
   "alyce_char",
   "myra",
   "allie"
  ]
 },
 "geo": {
  "canonRoute": "the-spa",
  "totalPassages": 186,
  "routes": [
   {
    "channel": "the-spa",
    "passages": 53,
    "share": 0.2849,
    "first": "2020-04-05",
    "last": "2020-04-06",
    "kind": "canon",
    "castWith": [
     "rio",
     "evelyn",
     "bryce",
     "estella",
     "frau"
    ]
   },
   {
    "channel": "evies-harem",
    "passages": 45,
    "share": 0.2419,
    "first": "2020-04-03",
    "last": "2020-04-04",
    "kind": "route",
    "castWith": [
     "evelyn",
     "bryce",
     "rio"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 20,
    "share": 0.1075,
    "first": "2020-04-02",
    "last": "2020-04-07",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "cruz",
     "eric"
    ]
   },
   {
    "channel": "the-von-dabb-castle",
    "passages": 20,
    "share": 0.1075,
    "first": "2020-04-02",
    "last": "2020-04-07",
    "kind": "route",
    "castWith": [
     "evelyn",
     "bryce",
     "rio",
     "frau",
     "alexei",
     "mr_han_sr",
     "kaleb",
     "ezra",
     "bradshaw",
     "may",
     "kya_sg3",
     "will"
    ]
   },
   {
    "channel": "indifference",
    "passages": 14,
    "share": 0.0753,
    "first": "2023-03-27",
    "last": "2024-04-25",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "alyce_char",
     "dimitri",
     "ryder",
     "rio",
     "ace",
     "moros",
     "nolan",
     "audrey",
     "lachesis"
    ]
   },
   {
    "channel": "ooc",
    "passages": 10,
    "share": 0.0538,
    "first": "2020-04-20",
    "last": "2020-11-05",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "bryces-quarters",
    "passages": 9,
    "share": 0.0484,
    "first": "2020-04-04",
    "last": "2020-04-05",
    "kind": "route",
    "castWith": [
     "bryce",
     "evelyn",
     "frau",
     "rio",
     "celine",
     "ezra",
     "raye",
     "god",
     "mr_han_sr"
    ]
   },
   {
    "channel": "local-park",
    "passages": 8,
    "share": 0.043,
    "first": "2020-04-02",
    "last": "2020-04-03",
    "kind": "route",
    "castWith": [
     "evelyn",
     "bryce",
     "rio"
    ]
   },
   {
    "channel": "tyrant-evie",
    "passages": 2,
    "share": 0.0108,
    "first": "2021-12-16",
    "last": "2021-12-22",
    "kind": "route",
    "castWith": [
     "evelyn",
     "bryce",
     "cruz",
     "myra",
     "ares",
     "hermes",
     "rio",
     "hades",
     "frau",
     "zeus",
     "nolan",
     "audrey"
    ]
   },
   {
    "channel": "phone-calls",
    "passages": 2,
    "share": 0.0108,
    "first": "2020-04-04",
    "last": "2020-04-04",
    "kind": "route",
    "castWith": [
     "evelyn",
     "kaleb",
     "bryce",
     "mr_han_sr",
     "kya_sg3",
     "kya_sg1",
     "frau",
     "raye",
     "ever"
    ]
   },
   {
    "channel": "tyrant-evie-runs-away",
    "passages": 1,
    "share": 0.0054,
    "first": "2022-01-14",
    "last": "2022-01-14",
    "kind": "route",
    "castWith": [
     "evelyn",
     "bryce",
     "aspen",
     "rio",
     "ace",
     "kaleb",
     "myra",
     "kya_sg3",
     "alistair",
     "alistair_turayne",
     "ezra",
     "rowan"
    ]
   },
   {
    "channel": "hall-of-portraits",
    "passages": 1,
    "share": 0.0054,
    "first": "2020-04-04",
    "last": "2020-04-04",
    "kind": "route",
    "castWith": [
     "bryce",
     "evelyn",
     "frau",
     "reginald"
    ]
   }
  ],
  "knownCharacters": [
   "rio",
   "evelyn",
   "bryce",
   "estella",
   "frau"
  ]
 },
 "hades": {
  "canonRoute": "evelyn-college-2",
  "totalPassages": 557,
  "routes": [
   {
    "channel": "3-haleys-hades-fanfic",
    "passages": 98,
    "share": 0.1759,
    "first": "2022-02-03",
    "last": "2023-02-27",
    "kind": "au",
    "castWith": [
     "kyo",
     "persephone",
     "amoura",
     "kya_sg3",
     "kya_sg1",
     "kaleb",
     "dillon",
     "apollo",
     "sebastian_vamp",
     "sebastian_siren",
     "eli",
     "god"
    ]
   },
   {
    "channel": "evelyn-college-2",
    "passages": 92,
    "share": 0.1652,
    "first": "2020-12-27",
    "last": "2021-01-25",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "darren",
     "dimitri",
     "lex",
     "raye",
     "jon",
     "ares",
     "kaleb",
     "cruz",
     "kya_sg3",
     "ari",
     "aibell"
    ]
   },
   {
    "channel": "nicoles-wish-brax-brother",
    "passages": 48,
    "share": 0.0862,
    "first": "2023-06-06",
    "last": "2023-07-19",
    "kind": "route",
    "castWith": [
     "ford",
     "cruz",
     "brax",
     "lance",
     "dimitri",
     "vaughn",
     "rowan",
     "nicole_human",
     "audrey",
     "diana",
     "evelyn",
     "nicole_wolf"
    ]
   },
   {
    "channel": "hades-palace",
    "passages": 43,
    "share": 0.0772,
    "first": "2020-03-28",
    "last": "2020-03-29",
    "kind": "route",
    "castWith": [
     "evelyn",
     "libion",
     "cruz",
     "bryce",
     "bion",
     "persephone",
     "will",
     "hercules",
     "hermes",
     "god"
    ]
   },
   {
    "channel": "ocroute2-cruz-in-for-love",
    "passages": 39,
    "share": 0.07,
    "first": "2022-01-30",
    "last": "2022-02-12",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "dimitri",
     "zeus",
     "hera",
     "aphrodite",
     "god",
     "bryce",
     "amanda",
     "lachesis",
     "hermes",
     "nolan"
    ]
   },
   {
    "channel": "haggle-for-the-girl",
    "passages": 32,
    "share": 0.0575,
    "first": "2023-12-12",
    "last": "2024-01-20",
    "kind": "route",
    "castWith": [
     "lachesis",
     "lucifer",
     "asrius",
     "god",
     "lonnie",
     "ramiel",
     "gabriel",
     "lance",
     "alyk",
     "aphrodite",
     "atropos",
     "zeus"
    ]
   },
   {
    "channel": "lance-mating",
    "passages": 32,
    "share": 0.0575,
    "first": "2021-08-26",
    "last": "2021-08-30",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "clothos",
     "ryder",
     "nolan",
     "nicole_human",
     "audrey",
     "moros",
     "atropos",
     "nicole_wolf",
     "nicole_sg3"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 19,
    "share": 0.0341,
    "first": "2020-03-28",
    "last": "2020-04-01",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "god",
     "rika",
     "nolan"
    ]
   },
   {
    "channel": "mt-olympus",
    "passages": 16,
    "share": 0.0287,
    "first": "2020-03-29",
    "last": "2020-03-30",
    "kind": "route",
    "castWith": [
     "evelyn",
     "libion",
     "ares",
     "rex",
     "persephone",
     "bion",
     "aphrodite",
     "hercules",
     "demeter",
     "zeus",
     "athena",
     "zerden"
    ]
   },
   {
    "channel": "ooc",
    "passages": 13,
    "share": 0.0233,
    "first": "2020-04-19",
    "last": "2020-06-19",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "1-real-cruz",
    "passages": 10,
    "share": 0.018,
    "first": "2022-10-23",
    "last": "2022-10-25",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "ares",
     "lance",
     "selma",
     "zeus",
     "lindon",
     "hera",
     "ryder",
     "apollo",
     "nolan"
    ]
   },
   {
    "channel": "lachesis-off-the-rails",
    "passages": 9,
    "share": 0.0162,
    "first": "2025-09-04",
    "last": "2025-09-09",
    "kind": "route",
    "castWith": [
     "lance",
     "vaughn",
     "brax",
     "lucifer",
     "james",
     "atropos",
     "cruz",
     "lachesis",
     "ace",
     "lindon",
     "ezra",
     "nicole_human"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "darren",
   "dimitri",
   "lex",
   "raye",
   "jon",
   "ares",
   "kaleb",
   "cruz",
   "kya_sg3",
   "ari",
   "aibell"
  ]
 },
 "hercules": {
  "canonRoute": "1-real-cruz",
  "totalPassages": 54,
  "routes": [
   {
    "channel": "1-real-cruz",
    "passages": 15,
    "share": 0.2778,
    "first": "2023-01-15",
    "last": "2023-01-19",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "ares",
     "lance",
     "selma",
     "zeus",
     "lindon",
     "hera",
     "ryder",
     "apollo",
     "nolan"
    ]
   },
   {
    "channel": "mt-olympus",
    "passages": 11,
    "share": 0.2037,
    "first": "2020-03-28",
    "last": "2020-03-29",
    "kind": "route",
    "castWith": [
     "evelyn",
     "libion",
     "ares",
     "rex",
     "persephone",
     "bion",
     "hades",
     "aphrodite",
     "demeter",
     "zeus",
     "athena",
     "zerden"
    ]
   },
   {
    "channel": "cruz-nicole-dollar-store",
    "passages": 8,
    "share": 0.1481,
    "first": "2020-09-15",
    "last": "2020-09-16",
    "kind": "route",
    "castWith": [
     "cruz",
     "raz",
     "lance",
     "lachesis",
     "bryce",
     "nolan",
     "renee",
     "aphrodite",
     "clothos",
     "atropos",
     "nicole_wolf",
     "nicole_sg3"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 3,
    "share": 0.0556,
    "first": "2020-03-28",
    "last": "2020-03-29",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika"
    ]
   },
   {
    "channel": "vaughneo-and-juliet",
    "passages": 2,
    "share": 0.037,
    "first": "2025-11-24",
    "last": "2025-11-24",
    "kind": "route",
    "castWith": [
     "vaughn",
     "brax",
     "lindon",
     "declan",
     "ares",
     "skye",
     "roman",
     "mary_cataldi",
     "liz",
     "nicole_human",
     "aphrodite",
     "ace"
    ]
   },
   {
    "channel": "dream-dude",
    "passages": 2,
    "share": 0.037,
    "first": "2024-04-09",
    "last": "2024-04-09",
    "kind": "route",
    "castWith": [
     "hermes",
     "cupid_eros",
     "moros",
     "atropos",
     "zeus",
     "lachesis",
     "apollo",
     "haley_wolf",
     "haley_human",
     "nicole_human",
     "roman",
     "aphrodite"
    ]
   },
   {
    "channel": "ooc",
    "passages": 2,
    "share": 0.037,
    "first": "2020-06-06",
    "last": "2020-06-06",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "tyrant-evie",
    "passages": 1,
    "share": 0.0185,
    "first": "2022-01-04",
    "last": "2022-01-04",
    "kind": "route",
    "castWith": [
     "evelyn",
     "bryce",
     "cruz",
     "myra",
     "ares",
     "hermes",
     "rio",
     "hades",
     "frau",
     "zeus",
     "nolan",
     "audrey"
    ]
   },
   {
    "channel": "lets-abduct-evie",
    "passages": 1,
    "share": 0.0185,
    "first": "2021-06-15",
    "last": "2021-06-15",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "ryoto",
     "dodge",
     "ms_tia",
     "kaleb",
     "frau",
     "aki",
     "cruz",
     "talbot",
     "ares",
     "zeus"
    ]
   },
   {
    "channel": "lance-decides",
    "passages": 1,
    "share": 0.0185,
    "first": "2024-12-13",
    "last": "2024-12-13",
    "kind": "route",
    "castWith": [
     "lance",
     "rin",
     "lucifer",
     "lachesis",
     "nicole_human",
     "god",
     "chiara",
     "cupid_eros",
     "roman",
     "asrius",
     "hera",
     "zeus"
    ]
   },
   {
    "channel": "1-declan-only",
    "passages": 1,
    "share": 0.0185,
    "first": "2023-01-11",
    "last": "2023-01-11",
    "kind": "route",
    "castWith": [
     "declan",
     "haley_wolf",
     "haley_sg3",
     "noah",
     "koda",
     "diana"
    ]
   },
   {
    "channel": "trident-and-the-elders",
    "passages": 1,
    "share": 0.0185,
    "first": "2022-10-26",
    "last": "2022-10-26",
    "kind": "route",
    "castWith": [
     "james",
     "kya_sg3",
     "raz",
     "kya_sg1",
     "val",
     "apollo",
     "sebastian_vamp",
     "junta",
     "sebastian_siren",
     "vanessa",
     "tim",
     "kaleb"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "cruz",
   "bryce",
   "ares",
   "lance",
   "selma",
   "zeus",
   "lindon",
   "hera",
   "ryder",
   "apollo",
   "nolan"
  ]
 },
 "hermes": {
  "canonRoute": "cruz-x-nicole",
  "totalPassages": 131,
  "routes": [
   {
    "channel": "cruz-x-nicole",
    "passages": 42,
    "share": 0.3206,
    "first": "2020-08-17",
    "last": "2020-08-21",
    "kind": "canon",
    "castWith": [
     "cruz",
     "lance",
     "audrey",
     "peter",
     "ares",
     "nicole_wolf",
     "nicole_sg3",
     "alyce_char",
     "red",
     "trix",
     "nicole_human",
     "moros"
    ]
   },
   {
    "channel": "dream-dude",
    "passages": 18,
    "share": 0.1374,
    "first": "2024-04-19",
    "last": "2024-04-23",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "moros",
     "atropos",
     "zeus",
     "lachesis",
     "apollo",
     "hercules",
     "haley_wolf",
     "haley_human",
     "nicole_human",
     "roman",
     "aphrodite"
    ]
   },
   {
    "channel": "1-real-cruz",
    "passages": 8,
    "share": 0.0611,
    "first": "2023-01-13",
    "last": "2023-01-19",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "ares",
     "lance",
     "selma",
     "zeus",
     "lindon",
     "hera",
     "ryder",
     "apollo",
     "nolan"
    ]
   },
   {
    "channel": "tyrant-evie",
    "passages": 8,
    "share": 0.0611,
    "first": "2022-01-07",
    "last": "2022-01-08",
    "kind": "route",
    "castWith": [
     "evelyn",
     "bryce",
     "cruz",
     "myra",
     "ares",
     "rio",
     "hades",
     "frau",
     "zeus",
     "nolan",
     "audrey",
     "apollo"
    ]
   },
   {
    "channel": "cruz-nicole-dollar-store",
    "passages": 8,
    "share": 0.0611,
    "first": "2020-09-15",
    "last": "2020-09-16",
    "kind": "route",
    "castWith": [
     "cruz",
     "raz",
     "lance",
     "lachesis",
     "bryce",
     "nolan",
     "renee",
     "aphrodite",
     "clothos",
     "atropos",
     "nicole_wolf",
     "nicole_sg3"
    ]
   },
   {
    "channel": "ooc",
    "passages": 6,
    "share": 0.0458,
    "first": "2020-05-08",
    "last": "2020-06-19",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "lance-is-a-family-man",
    "passages": 5,
    "share": 0.0382,
    "first": "2024-05-01",
    "last": "2024-05-03",
    "kind": "route",
    "castWith": [
     "lance",
     "evelyn",
     "cruz",
     "audrey",
     "luca",
     "bryce",
     "lyden",
     "roger",
     "dimitri",
     "hades",
     "diana",
     "zeus"
    ]
   },
   {
    "channel": "purgatory",
    "passages": 5,
    "share": 0.0382,
    "first": "2020-03-28",
    "last": "2020-03-28",
    "kind": "route",
    "castWith": [
     "evelyn",
     "bryce"
    ]
   },
   {
    "channel": "the-bachelorette-season-kya",
    "passages": 4,
    "share": 0.0305,
    "first": "2021-05-22",
    "last": "2021-05-23",
    "kind": "route",
    "castWith": [
     "apollo",
     "evelyn",
     "kya_sg3",
     "kya_sg1",
     "carole",
     "aphrodite",
     "ares",
     "may",
     "skipper",
     "god",
     "hera",
     "jessica"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 4,
    "share": 0.0305,
    "first": "2020-05-22",
    "last": "2020-05-30",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "ocroute2-cruz-in-for-love",
    "passages": 3,
    "share": 0.0229,
    "first": "2022-02-01",
    "last": "2022-02-03",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "dimitri",
     "hades",
     "zeus",
     "hera",
     "aphrodite",
     "god",
     "bryce",
     "amanda",
     "lachesis",
     "nolan"
    ]
   },
   {
    "channel": "lance-mating",
    "passages": 2,
    "share": 0.0153,
    "first": "2021-08-19",
    "last": "2021-08-27",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "clothos",
     "ryder",
     "hades",
     "nolan",
     "nicole_human",
     "audrey",
     "moros",
     "atropos",
     "nicole_wolf"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "lance",
   "audrey",
   "peter",
   "ares",
   "nicole_wolf",
   "nicole_sg3",
   "alyce_char",
   "red",
   "trix",
   "nicole_human",
   "moros"
  ]
 },
 "polly": {
  "canonRoute": "siren-places",
  "totalPassages": 146,
  "routes": [
   {
    "channel": "siren-places",
    "passages": 33,
    "share": 0.226,
    "first": "2020-07-03",
    "last": "2020-07-09",
    "kind": "canon",
    "castWith": [
     "sebastian_vamp",
     "sebastian_siren",
     "kya_sg1",
     "kya_sg3",
     "kaleb",
     "evelyn",
     "ever",
     "midori_naga",
     "skipper",
     "kyo"
    ]
   },
   {
    "channel": "almost-kya-x-sebastian",
    "passages": 29,
    "share": 0.1986,
    "first": "2020-10-29",
    "last": "2020-11-03",
    "kind": "route",
    "castWith": [
     "sebastian_siren",
     "sebastian_vamp",
     "kya_sg3",
     "kya_sg1",
     "evelyn",
     "ethan",
     "haley_human",
     "alistair",
     "ezra",
     "haley_wolf",
     "haley_sg3",
     "miya"
    ]
   },
   {
    "channel": "aquarium",
    "passages": 23,
    "share": 0.1575,
    "first": "2020-04-27",
    "last": "2020-04-29",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "ezra",
     "kya_sg1",
     "sebastian_vamp",
     "skipper",
     "sebastian_siren",
     "lira",
     "kyo",
     "crom",
     "evelyn",
     "kaleb",
     "kris"
    ]
   },
   {
    "channel": "forced-mate-college",
    "passages": 22,
    "share": 0.1507,
    "first": "2025-11-02",
    "last": "2025-11-10",
    "kind": "route",
    "castWith": [
     "dillon",
     "kya_sg3",
     "kya_sg1",
     "sebastian_vamp",
     "sebastian_siren",
     "kyo",
     "ever",
     "will"
    ]
   },
   {
    "channel": "2-koda",
    "passages": 14,
    "share": 0.0959,
    "first": "2022-12-19",
    "last": "2022-12-22",
    "kind": "route",
    "castWith": [
     "koda",
     "dillon",
     "kya_sg1",
     "kya_sg3",
     "declan",
     "sebastian_siren",
     "sebastian_vamp",
     "kaleb",
     "rowan",
     "diana"
    ]
   },
   {
    "channel": "aquarium-seb",
    "passages": 8,
    "share": 0.0548,
    "first": "2025-01-21",
    "last": "2025-01-29",
    "kind": "route",
    "castWith": [
     "sebastian_siren",
     "sebastian_vamp",
     "skipper",
     "kya_sg3",
     "kya_sg1",
     "ezra",
     "dillon",
     "reed"
    ]
   },
   {
    "channel": "haleys-wish",
    "passages": 5,
    "share": 0.0342,
    "first": "2023-04-26",
    "last": "2023-04-27",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "evelyn",
     "sebastian_siren",
     "kya_sg1",
     "sebastian_vamp",
     "haley_human",
     "cruz",
     "dimitri",
     "haley_wolf",
     "haley_sg3",
     "skipper",
     "kaleb"
    ]
   },
   {
    "channel": "fantastical-ezra",
    "passages": 3,
    "share": 0.0205,
    "first": "2025-02-20",
    "last": "2025-02-28",
    "kind": "route",
    "castWith": [
     "ezra",
     "dillon",
     "kaleb",
     "apollo",
     "kya_sg3",
     "james",
     "sebastian_vamp",
     "evelyn",
     "kya_sg1",
     "haley_human",
     "sebastian_siren",
     "skipper"
    ]
   },
   {
    "channel": "kya-seb-nice-uncle",
    "passages": 2,
    "share": 0.0137,
    "first": "2025-12-23",
    "last": "2025-12-23",
    "kind": "route",
    "castWith": [
     "dillon",
     "aaron",
     "kaleb",
     "kyo",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "evelyn",
     "sebastian_vamp",
     "frau",
     "ami",
     "may"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 2,
    "share": 0.0137,
    "first": "2020-07-03",
    "last": "2020-07-04",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika"
    ]
   },
   {
    "channel": "sebby",
    "passages": 1,
    "share": 0.0068,
    "first": "2022-10-07",
    "last": "2022-10-07",
    "kind": "route",
    "castWith": [
     "kya_sg1",
     "kya_sg3",
     "sebastian_vamp",
     "sebastian_siren",
     "paul"
    ]
   },
   {
    "channel": "sad-elder-seb",
    "passages": 1,
    "share": 0.0068,
    "first": "2022-10-05",
    "last": "2022-10-05",
    "kind": "route",
    "castWith": [
     "kya_sg1",
     "sebastian_vamp",
     "kya_sg3",
     "sebastian_siren"
    ]
   }
  ],
  "knownCharacters": [
   "sebastian_vamp",
   "sebastian_siren",
   "kya_sg1",
   "kya_sg3",
   "kaleb",
   "evelyn",
   "ever",
   "midori_naga",
   "skipper",
   "kyo"
  ]
 },
 "primrose": {
  "canonRoute": "brothel",
  "totalPassages": 140,
  "routes": [
   {
    "channel": "brothel",
    "passages": 45,
    "share": 0.3214,
    "first": "2020-04-18",
    "last": "2020-04-28",
    "kind": "canon",
    "castWith": [
     "ezra",
     "evelyn",
     "rowan",
     "kya_sg3",
     "kya_sg1",
     "lily",
     "kaleb",
     "nellie",
     "lissa",
     "raye",
     "ace",
     "mr_han_sr"
    ]
   },
   {
    "channel": "ww-war-au",
    "passages": 12,
    "share": 0.0857,
    "first": "2021-11-28",
    "last": "2021-11-28",
    "kind": "au",
    "castWith": [
     "evelyn",
     "cruz",
     "ace",
     "ezra",
     "lindon",
     "kaleb",
     "rowan",
     "bryce",
     "lance",
     "raye",
     "nolan",
     "ryder"
    ]
   },
   {
    "channel": "don\u2019t-buy-me-love",
    "passages": 12,
    "share": 0.0857,
    "first": "2023-12-13",
    "last": "2023-12-16",
    "kind": "route",
    "castWith": [
     "ezra",
     "trace_spellbook",
     "madison_astor",
     "kya_sg3",
     "kya_sg1",
     "dimitri",
     "hades",
     "evelyn",
     "junta",
     "jane",
     "may",
     "reginald"
    ]
   },
   {
    "channel": "kya-senior-year",
    "passages": 11,
    "share": 0.0786,
    "first": "2021-06-15",
    "last": "2021-06-18",
    "kind": "route",
    "castWith": [
     "callan",
     "ezra",
     "leiden",
     "melody",
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "raye",
     "tate",
     "sebastian_vamp",
     "dillon",
     "sebastian_siren"
    ]
   },
   {
    "channel": "kieran-ezra",
    "passages": 11,
    "share": 0.0786,
    "first": "2023-10-07",
    "last": "2023-10-11",
    "kind": "route",
    "castWith": [
     "kieran",
     "ezra",
     "raz",
     "lily",
     "peter",
     "rosalie",
     "ace",
     "gemma"
    ]
   },
   {
    "channel": "heavenbound-missions",
    "passages": 8,
    "share": 0.0571,
    "first": "2025-10-11",
    "last": "2025-10-12",
    "kind": "route",
    "castWith": [
     "vaughn",
     "lindon",
     "god",
     "ares",
     "brax",
     "aphrodite",
     "nicole_human",
     "nicole_wolf",
     "nicole_sg3",
     "beatrice",
     "will",
     "cruz"
    ]
   },
   {
    "channel": "junta-is-best-boi",
    "passages": 7,
    "share": 0.05,
    "first": "2023-11-24",
    "last": "2023-11-29",
    "kind": "route",
    "castWith": [
     "junta",
     "ezra",
     "madison_astor",
     "lily",
     "val",
     "natasha",
     "belinda",
     "james",
     "may",
     "sebastian_vamp",
     "tim",
     "ace"
    ]
   },
   {
    "channel": "growing-up-ezra",
    "passages": 7,
    "share": 0.05,
    "first": "2023-01-31",
    "last": "2023-02-01",
    "kind": "route",
    "castWith": [
     "ezra",
     "kya_sg3",
     "dillon",
     "jane",
     "kya_sg1",
     "kaleb",
     "edward",
     "sebastian_vamp",
     "raye",
     "sebastian_siren",
     "ace",
     "uncle_khan"
    ]
   },
   {
    "channel": "love-the-good-bois",
    "passages": 5,
    "share": 0.0357,
    "first": "2022-11-23",
    "last": "2022-11-26",
    "kind": "route",
    "castWith": [
     "ezra",
     "junta",
     "kya_sg3",
     "raz",
     "kya_sg1",
     "tim",
     "sebastian_vamp",
     "val",
     "evelyn",
     "kaleb",
     "skipper",
     "james"
    ]
   },
   {
    "channel": "haley-james-yessss",
    "passages": 5,
    "share": 0.0357,
    "first": "2020-08-13",
    "last": "2020-08-14",
    "kind": "route",
    "castWith": [
     "ezra",
     "james",
     "haley_human",
     "kaleb",
     "ace",
     "nicole_human",
     "mr_han_sr",
     "evelyn",
     "lily",
     "haley_wolf",
     "haley_sg3",
     "aphrodite"
    ]
   },
   {
    "channel": "wizards-chamber",
    "passages": 5,
    "share": 0.0357,
    "first": "2020-04-29",
    "last": "2020-04-29",
    "kind": "route",
    "castWith": [
     "ezra",
     "crom",
     "kya_sg3",
     "kya_sg1",
     "jane",
     "kris",
     "kyo",
     "polly",
     "will"
    ]
   },
   {
    "channel": "50-shades-of-ezra",
    "passages": 4,
    "share": 0.0286,
    "first": "2021-09-29",
    "last": "2021-09-29",
    "kind": "route",
    "castWith": [
     "ezra",
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "dillon",
     "evelyn",
     "sebastian_vamp",
     "sebastian_siren",
     "uncle_khan",
     "celestine",
     "alistair",
     "raye"
    ]
   }
  ],
  "knownCharacters": [
   "ezra",
   "evelyn",
   "rowan",
   "kya_sg3",
   "kya_sg1",
   "lily",
   "kaleb",
   "nellie",
   "lissa",
   "raye",
   "ace",
   "mr_han_sr"
  ]
 },
 "rio": {
  "canonRoute": "the-spa",
  "totalPassages": 218,
  "routes": [
   {
    "channel": "the-spa",
    "passages": 59,
    "share": 0.2706,
    "first": "2020-04-05",
    "last": "2020-04-06",
    "kind": "canon",
    "castWith": [
     "geo",
     "evelyn",
     "bryce",
     "estella",
     "frau"
    ]
   },
   {
    "channel": "the-von-dabb-castle",
    "passages": 46,
    "share": 0.211,
    "first": "2020-04-02",
    "last": "2020-04-07",
    "kind": "route",
    "castWith": [
     "evelyn",
     "bryce",
     "frau",
     "geo",
     "alexei",
     "mr_han_sr",
     "kaleb",
     "ezra",
     "bradshaw",
     "may",
     "kya_sg3",
     "will"
    ]
   },
   {
    "channel": "indifference",
    "passages": 36,
    "share": 0.1651,
    "first": "2023-03-27",
    "last": "2024-04-25",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "alyce_char",
     "dimitri",
     "ryder",
     "ace",
     "moros",
     "geo",
     "nolan",
     "audrey",
     "lachesis"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 21,
    "share": 0.0963,
    "first": "2020-04-02",
    "last": "2020-04-07",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "kaleb",
     "bennett",
     "geo",
     "cruz",
     "eric"
    ]
   },
   {
    "channel": "tyrant-evie-runs-away",
    "passages": 12,
    "share": 0.055,
    "first": "2022-01-10",
    "last": "2022-01-28",
    "kind": "route",
    "castWith": [
     "evelyn",
     "bryce",
     "aspen",
     "ace",
     "kaleb",
     "myra",
     "kya_sg3",
     "alistair",
     "alistair_turayne",
     "ezra",
     "rowan",
     "eva"
    ]
   },
   {
    "channel": "bryces-quarters",
    "passages": 9,
    "share": 0.0413,
    "first": "2020-04-05",
    "last": "2020-04-05",
    "kind": "route",
    "castWith": [
     "bryce",
     "evelyn",
     "frau",
     "geo",
     "celine",
     "ezra",
     "raye",
     "god",
     "mr_han_sr"
    ]
   },
   {
    "channel": "tyrant-evie",
    "passages": 8,
    "share": 0.0367,
    "first": "2021-12-16",
    "last": "2021-12-23",
    "kind": "route",
    "castWith": [
     "evelyn",
     "bryce",
     "cruz",
     "myra",
     "ares",
     "hermes",
     "hades",
     "frau",
     "zeus",
     "nolan",
     "audrey",
     "apollo"
    ]
   },
   {
    "channel": "ooc",
    "passages": 6,
    "share": 0.0275,
    "first": "2020-04-20",
    "last": "2020-11-05",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "evies-harem",
    "passages": 5,
    "share": 0.0229,
    "first": "2020-04-03",
    "last": "2020-04-04",
    "kind": "route",
    "castWith": [
     "geo",
     "evelyn",
     "bryce"
    ]
   },
   {
    "channel": "northwest-pack-lodge",
    "passages": 3,
    "share": 0.0138,
    "first": "2020-04-20",
    "last": "2020-04-20",
    "kind": "route",
    "castWith": [
     "rowan",
     "evelyn",
     "lucius",
     "nellie",
     "myra",
     "cruz",
     "bryce",
     "will",
     "dimitri",
     "kaleb",
     "may",
     "mr_han_sr"
    ]
   },
   {
    "channel": "the-arena",
    "passages": 3,
    "share": 0.0138,
    "first": "2020-04-02",
    "last": "2020-04-02",
    "kind": "route",
    "castWith": [
     "bryce",
     "evelyn",
     "killian",
     "mr_han_sr",
     "ever",
     "may"
    ]
   },
   {
    "channel": "1-real-cruz",
    "passages": 2,
    "share": 0.0092,
    "first": "2022-10-15",
    "last": "2022-10-15",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "ares",
     "lance",
     "selma",
     "zeus",
     "lindon",
     "hera",
     "ryder",
     "apollo",
     "nolan"
    ]
   }
  ],
  "knownCharacters": [
   "geo",
   "evelyn",
   "bryce",
   "estella",
   "frau"
  ]
 },
 "trenton": {
  "canonRoute": "esu",
  "totalPassages": 22,
  "routes": [
   {
    "channel": "esu",
    "passages": 22,
    "share": 1.0,
    "first": "2025-01-09",
    "last": "2025-01-15",
    "kind": "canon",
    "castWith": [
     "leon",
     "bennett",
     "richard_antore",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "leon",
   "bennett",
   "richard_antore",
   "will"
  ]
 },
 "uncle_khan": {
  "canonRoute": "kaleb-kya-finally",
  "totalPassages": 94,
  "routes": [
   {
    "channel": "ww-war-au",
    "passages": 8,
    "share": 0.0851,
    "first": "2021-11-18",
    "last": "2021-12-14",
    "kind": "au",
    "castWith": [
     "evelyn",
     "cruz",
     "ace",
     "ezra",
     "lindon",
     "kaleb",
     "rowan",
     "bryce",
     "lance",
     "raye",
     "nolan",
     "primrose"
    ]
   },
   {
    "channel": "kaleb-kya-finally",
    "passages": 5,
    "share": 0.0532,
    "first": "2021-02-14",
    "last": "2021-02-16",
    "kind": "canon",
    "castWith": [
     "kaleb",
     "kya_sg3",
     "kya_sg1",
     "evelyn",
     "sebastian_siren",
     "sebastian_vamp",
     "apollo",
     "gabs",
     "alexander",
     "dimitri",
     "kyo",
     "ami"
    ]
   },
   {
    "channel": "alistair-tailbond",
    "passages": 5,
    "share": 0.0532,
    "first": "2024-04-26",
    "last": "2024-05-07",
    "kind": "route",
    "castWith": [
     "kaleb",
     "kya_sg3",
     "alistair",
     "alistair_turayne",
     "ezra",
     "dillon",
     "kya_sg1",
     "sebastian_vamp",
     "raye",
     "evelyn",
     "sebastian_siren",
     "poseidon"
    ]
   },
   {
    "channel": "lets-abduct-evie",
    "passages": 4,
    "share": 0.0426,
    "first": "2021-06-14",
    "last": "2021-06-27",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "ryoto",
     "dodge",
     "ms_tia",
     "kaleb",
     "frau",
     "aki",
     "cruz",
     "talbot",
     "ares",
     "zeus"
    ]
   },
   {
    "channel": "dimitri-route-end",
    "passages": 4,
    "share": 0.0426,
    "first": "2021-01-29",
    "last": "2021-02-04",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "uri",
     "gambit",
     "jones",
     "ares",
     "bryce",
     "kaleb",
     "frau",
     "mr_han_sr",
     "zeus",
     "kya_sg3"
    ]
   },
   {
    "channel": "werewolf-dimitri",
    "passages": 4,
    "share": 0.0426,
    "first": "2021-10-28",
    "last": "2021-11-16",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "kaleb",
     "slater",
     "kya_sg3",
     "frau",
     "god",
     "lionel",
     "byron",
     "gambit",
     "kelli",
     "liera"
    ]
   },
   {
    "channel": "50-shades-of-ezra",
    "passages": 4,
    "share": 0.0426,
    "first": "2021-09-26",
    "last": "2021-09-27",
    "kind": "route",
    "castWith": [
     "ezra",
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "dillon",
     "evelyn",
     "sebastian_vamp",
     "sebastian_siren",
     "primrose",
     "celestine",
     "alistair",
     "raye"
    ]
   },
   {
    "channel": "bryce-birthday",
    "passages": 4,
    "share": 0.0426,
    "first": "2021-08-05",
    "last": "2021-08-09",
    "kind": "route",
    "castWith": [
     "bryce",
     "evelyn",
     "kaleb",
     "dimitri",
     "frau"
    ]
   },
   {
    "channel": "haleys-alistair-wish",
    "passages": 4,
    "share": 0.0426,
    "first": "2023-05-01",
    "last": "2023-05-05",
    "kind": "route",
    "castWith": [
     "ezra",
     "evelyn",
     "alistair_turayne",
     "alistair",
     "raye",
     "kaleb",
     "james",
     "dimitri",
     "haley_wolf",
     "haley_sg3",
     "haley_human",
     "bryce"
    ]
   },
   {
    "channel": "evelyn-college-2",
    "passages": 3,
    "share": 0.0319,
    "first": "2021-01-25",
    "last": "2021-01-28",
    "kind": "route",
    "castWith": [
     "evelyn",
     "darren",
     "dimitri",
     "lex",
     "hades",
     "raye",
     "jon",
     "ares",
     "kaleb",
     "cruz",
     "kya_sg3",
     "ari"
    ]
   },
   {
    "channel": "growing-up-cruz",
    "passages": 3,
    "share": 0.0319,
    "first": "2023-01-29",
    "last": "2023-02-09",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "allie",
     "kaleb",
     "audrey",
     "raquel_ratchet",
     "dimitri",
     "trix",
     "ford",
     "ryder",
     "lyden",
     "frau"
    ]
   },
   {
    "channel": "separated-seb",
    "passages": 3,
    "share": 0.0319,
    "first": "2023-09-03",
    "last": "2023-09-08",
    "kind": "route",
    "castWith": [
     "dillon",
     "kya_sg3",
     "kya_sg1",
     "sebastian_vamp",
     "sebastian_siren",
     "evelyn",
     "amelda",
     "kaleb",
     "ezra"
    ]
   }
  ],
  "knownCharacters": [
   "kaleb",
   "kya_sg3",
   "kya_sg1",
   "evelyn",
   "sebastian_siren",
   "sebastian_vamp",
   "apollo",
   "gabs",
   "alexander",
   "dimitri",
   "kyo",
   "ami"
  ]
 },
 "abraham": {
  "canonRoute": "coles-room",
  "totalPassages": 6,
  "routes": [
   {
    "channel": "coles-room",
    "passages": 6,
    "share": 1.0,
    "first": "2020-05-06",
    "last": "2020-05-06",
    "kind": "canon",
    "castWith": [
     "cole",
     "kya_sg3",
     "hades",
     "lacie",
     "raye",
     "riku"
    ]
   }
  ],
  "knownCharacters": [
   "cole",
   "kya_sg3",
   "hades",
   "lacie",
   "raye",
   "riku"
  ]
 },
 "achelois": {
  "canonRoute": "dorms",
  "totalPassages": 1,
  "routes": [
   {
    "channel": "dorms",
    "passages": 1,
    "share": 1.0,
    "first": "2020-05-01",
    "last": "2020-05-01",
    "kind": "canon",
    "castWith": [
     "agnar",
     "kya_sg3",
     "agmund",
     "evelyn",
     "raye",
     "cole",
     "kya_sg1",
     "riku",
     "kaleb",
     "penelope_valk",
     "loki",
     "svira"
    ]
   }
  ],
  "knownCharacters": [
   "agnar",
   "kya_sg3",
   "agmund",
   "evelyn",
   "raye",
   "cole",
   "kya_sg1",
   "riku",
   "kaleb",
   "penelope_valk",
   "loki",
   "svira"
  ]
 },
 "adathan": {
  "canonRoute": "haggle-for-the-girl",
  "totalPassages": 2,
  "routes": [
   {
    "channel": "haggle-for-the-girl",
    "passages": 2,
    "share": 1.0,
    "first": "2024-01-11",
    "last": "2024-01-11",
    "kind": "canon",
    "castWith": [
     "lachesis",
     "lucifer",
     "asrius",
     "god",
     "lonnie",
     "ramiel",
     "gabriel",
     "lance",
     "hades",
     "alyk",
     "aphrodite",
     "atropos"
    ]
   }
  ],
  "knownCharacters": [
   "lachesis",
   "lucifer",
   "asrius",
   "god",
   "lonnie",
   "ramiel",
   "gabriel",
   "lance",
   "hades",
   "alyk",
   "aphrodite",
   "atropos"
  ]
 },
 "addison": {
  "canonRoute": "to-the-max",
  "totalPassages": 19,
  "routes": [
   {
    "channel": "to-the-max",
    "passages": 19,
    "share": 1.0,
    "first": "2023-05-17",
    "last": "2023-05-29",
    "kind": "canon",
    "castWith": [
     "maxen_bryers",
     "trace_renton",
     "kya_sg3",
     "kya_sg1",
     "rick",
     "evelyn",
     "beatrice",
     "dillon",
     "budd",
     "lore",
     "paula",
     "diana"
    ]
   }
  ],
  "knownCharacters": [
   "maxen_bryers",
   "trace_renton",
   "kya_sg3",
   "kya_sg1",
   "rick",
   "evelyn",
   "beatrice",
   "dillon",
   "budd",
   "lore",
   "paula",
   "diana"
  ]
 },
 "adrianne": {
  "canonRoute": "a-demons-jewel",
  "totalPassages": 17,
  "routes": [
   {
    "channel": "a-demons-jewel",
    "passages": 17,
    "share": 1.0,
    "first": "2022-01-29",
    "last": "2022-02-11",
    "kind": "canon",
    "castWith": [
     "tallia",
     "lucifer",
     "god",
     "will",
     "may",
     "gabriel",
     "prince_teregan"
    ]
   }
  ],
  "knownCharacters": [
   "tallia",
   "lucifer",
   "god",
   "will",
   "may",
   "gabriel",
   "prince_teregan"
  ]
 },
 "adrien": {
  "canonRoute": "cruz-x-human",
  "totalPassages": 13,
  "routes": [
   {
    "channel": "cruz-x-human",
    "passages": 10,
    "share": 0.7692,
    "first": "2021-03-31",
    "last": "2021-04-25",
    "kind": "canon",
    "castWith": [
     "cruz",
     "skye",
     "nolan",
     "ryder",
     "audrey",
     "troy",
     "bryce",
     "airi",
     "natasha",
     "diana",
     "will",
     "allie"
    ]
   },
   {
    "channel": "starry-night",
    "passages": 3,
    "share": 0.2308,
    "first": "2025-07-07",
    "last": "2025-07-09",
    "kind": "route",
    "castWith": [
     "haley_human",
     "haley_wolf",
     "haley_sg3",
     "dillon",
     "jack",
     "may"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "skye",
   "nolan",
   "ryder",
   "audrey",
   "troy",
   "bryce",
   "airi",
   "natasha",
   "diana",
   "will",
   "allie"
  ]
 },
 "aibell": {
  "canonRoute": "evelyn-college-2",
  "totalPassages": 16,
  "routes": [
   {
    "channel": "evelyn-college-2",
    "passages": 16,
    "share": 1.0,
    "first": "2020-12-28",
    "last": "2021-01-17",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "darren",
     "dimitri",
     "lex",
     "hades",
     "raye",
     "jon",
     "ares",
     "kaleb",
     "cruz",
     "kya_sg3",
     "ari"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "darren",
   "dimitri",
   "lex",
   "hades",
   "raye",
   "jon",
   "ares",
   "kaleb",
   "cruz",
   "kya_sg3",
   "ari"
  ]
 },
 "airi": {
  "canonRoute": "cruz-x-human",
  "totalPassages": 6,
  "routes": [
   {
    "channel": "cruz-x-human",
    "passages": 6,
    "share": 1.0,
    "first": "2021-05-05",
    "last": "2021-05-06",
    "kind": "canon",
    "castWith": [
     "cruz",
     "skye",
     "nolan",
     "ryder",
     "audrey",
     "troy",
     "adrien",
     "bryce",
     "natasha",
     "diana",
     "will",
     "allie"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "skye",
   "nolan",
   "ryder",
   "audrey",
   "troy",
   "adrien",
   "bryce",
   "natasha",
   "diana",
   "will",
   "allie"
  ]
 },
 "ajax": {
  "canonRoute": "foyer-living-room",
  "totalPassages": 123,
  "routes": [
   {
    "channel": "foyer-living-room",
    "passages": 35,
    "share": 0.2846,
    "first": "2020-04-08",
    "last": "2020-05-22",
    "kind": "canon",
    "castWith": [
     "aria",
     "benji",
     "bennett",
     "ragland",
     "rin",
     "kent",
     "miles",
     "may"
    ]
   },
   {
    "channel": "ajax-and-miles-wing",
    "passages": 34,
    "share": 0.2764,
    "first": "2020-04-10",
    "last": "2020-04-11",
    "kind": "route",
    "castWith": [
     "aria",
     "ragland"
    ]
   },
   {
    "channel": "kingdom-of-temprum",
    "passages": 17,
    "share": 0.1382,
    "first": "2020-05-22",
    "last": "2020-05-31",
    "kind": "route",
    "castWith": [
     "aria",
     "bennett",
     "benji",
     "naveed",
     "fawn",
     "bast",
     "solum",
     "caria",
     "neitl",
     "batiuba",
     "will",
     "kaleb"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 10,
    "share": 0.0813,
    "first": "2020-04-09",
    "last": "2020-05-30",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "kingdom-of-welis",
    "passages": 6,
    "share": 0.0488,
    "first": "2020-04-12",
    "last": "2020-04-13",
    "kind": "route",
    "castWith": [
     "aria",
     "caria",
     "batiuba",
     "ragland",
     "kent",
     "will"
    ]
   },
   {
    "channel": "mansion-grounds",
    "passages": 5,
    "share": 0.0407,
    "first": "2020-04-09",
    "last": "2020-04-09",
    "kind": "route",
    "castWith": [
     "aria",
     "kent",
     "miles",
     "benji",
     "rin",
     "bennett",
     "ever"
    ]
   },
   {
    "channel": "rin-and-ragland-wing",
    "passages": 5,
    "share": 0.0407,
    "first": "2020-04-11",
    "last": "2020-04-12",
    "kind": "route",
    "castWith": [
     "ragland",
     "aria",
     "rin",
     "miles",
     "kent"
    ]
   },
   {
    "channel": "ooc",
    "passages": 3,
    "share": 0.0244,
    "first": "2020-06-04",
    "last": "2020-06-19",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "makeshift-attic-bedroom",
    "passages": 3,
    "share": 0.0244,
    "first": "2020-04-08",
    "last": "2020-04-08",
    "kind": "route",
    "castWith": [
     "aria",
     "benji",
     "ragland",
     "bennett",
     "miles"
    ]
   },
   {
    "channel": "memory-char-bios",
    "passages": 2,
    "share": 0.0163,
    "first": "2020-04-01",
    "last": "2020-05-22",
    "kind": "route",
    "castWith": [
     "bennett",
     "benji",
     "miles",
     "kent",
     "ragland",
     "rin",
     "aria"
    ]
   },
   {
    "channel": "kingdom-of-wellis",
    "passages": 2,
    "share": 0.0163,
    "first": "2020-06-02",
    "last": "2020-06-02",
    "kind": "route",
    "castWith": [
     "aria",
     "bennett",
     "benji",
     "caria",
     "ever",
     "ben",
     "solum"
    ]
   },
   {
    "channel": "eros-and-kent-wing",
    "passages": 1,
    "share": 0.0081,
    "first": "2020-04-12",
    "last": "2020-04-12",
    "kind": "route",
    "castWith": [
     "aria",
     "bennett",
     "ragland",
     "benji",
     "kent",
     "miles",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "aria",
   "benji",
   "bennett",
   "ragland",
   "rin",
   "kent",
   "miles",
   "may"
  ]
 },
 "aki": {
  "canonRoute": "lets-abduct-evie",
  "totalPassages": 12,
  "routes": [
   {
    "channel": "lets-abduct-evie",
    "passages": 12,
    "share": 1.0,
    "first": "2021-06-16",
    "last": "2021-06-26",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "dimitri",
     "ryoto",
     "dodge",
     "ms_tia",
     "kaleb",
     "frau",
     "cruz",
     "talbot",
     "ares",
     "zeus",
     "hera"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "dimitri",
   "ryoto",
   "dodge",
   "ms_tia",
   "kaleb",
   "frau",
   "cruz",
   "talbot",
   "ares",
   "zeus",
   "hera"
  ]
 },
 "alan": {
  "canonRoute": "val",
  "totalPassages": 26,
  "routes": [
   {
    "channel": "val",
    "passages": 26,
    "share": 1.0,
    "first": "2020-12-03",
    "last": "2020-12-27",
    "kind": "canon",
    "castWith": [
     "val",
     "kya_sg3",
     "kaleb",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "evelyn",
     "vanessa",
     "ezra",
     "raye",
     "tyrion",
     "mr_han_sr"
    ]
   }
  ],
  "knownCharacters": [
   "val",
   "kya_sg3",
   "kaleb",
   "alistair",
   "alistair_turayne",
   "kya_sg1",
   "evelyn",
   "vanessa",
   "ezra",
   "raye",
   "tyrion",
   "mr_han_sr"
  ]
 },
 "aldo": {
  "canonRoute": "oops-its-heaven",
  "totalPassages": 7,
  "routes": [
   {
    "channel": "oops-its-heaven",
    "passages": 7,
    "share": 1.0,
    "first": "2022-08-10",
    "last": "2022-08-15",
    "kind": "canon",
    "castWith": [
     "lachesis",
     "lance",
     "god",
     "ramiel",
     "lucifer",
     "atropos",
     "mary_cataldi",
     "hades",
     "clothos",
     "zeus"
    ]
   }
  ],
  "knownCharacters": [
   "lachesis",
   "lance",
   "god",
   "ramiel",
   "lucifer",
   "atropos",
   "mary_cataldi",
   "hades",
   "clothos",
   "zeus"
  ]
 },
 "aldrix": {
  "canonRoute": null,
  "routes": [],
  "knownCharacters": [],
  "totalPassages": 0
 },
 "alex": {
  "canonRoute": "frau-collin",
  "totalPassages": 10,
  "routes": [
   {
    "channel": "frau-collin",
    "passages": 3,
    "share": 0.3,
    "first": "2020-11-24",
    "last": "2020-11-25",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "cruz",
     "rowan",
     "frau",
     "collin_keller",
     "arland_rees",
     "ezra",
     "felix_fairy",
     "rikki",
     "park",
     "alyce_char",
     "myra"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 3,
    "share": 0.3,
    "first": "2020-05-28",
    "last": "2020-05-28",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "amnesia-world",
    "passages": 2,
    "share": 0.2,
    "first": "2025-03-15",
    "last": "2025-03-15",
    "kind": "route",
    "castWith": [
     "dimitri",
     "lance",
     "ford",
     "rowan",
     "kaleb",
     "cruz",
     "brax",
     "vaughn",
     "ryder",
     "bryce",
     "nicole_human",
     "kya_sg3"
    ]
   },
   {
    "channel": "ooc",
    "passages": 1,
    "share": 0.1,
    "first": "2020-06-09",
    "last": "2020-06-09",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "greek-house",
    "passages": 1,
    "share": 0.1,
    "first": "2020-05-06",
    "last": "2020-05-06",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hiro",
     "darren",
     "lex",
     "kiro",
     "raye",
     "kya_sg3",
     "ares",
     "riku",
     "kya_sg1",
     "lacie",
     "aphrodite"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "cruz",
   "rowan",
   "frau",
   "collin_keller",
   "arland_rees",
   "ezra",
   "felix_fairy",
   "rikki",
   "park",
   "alyce_char",
   "myra"
  ]
 },
 "alexander": {
  "canonRoute": "kaleb-kya-finally",
  "totalPassages": 6,
  "routes": [
   {
    "channel": "kaleb-kya-finally",
    "passages": 5,
    "share": 0.8333,
    "first": "2021-02-16",
    "last": "2021-02-17",
    "kind": "canon",
    "castWith": [
     "kaleb",
     "kya_sg3",
     "kya_sg1",
     "evelyn",
     "sebastian_siren",
     "sebastian_vamp",
     "apollo",
     "gabs",
     "uncle_khan",
     "dimitri",
     "kyo",
     "ami"
    ]
   },
   {
    "channel": "an-accidentally-valerian-summer-with-cordelia",
    "passages": 1,
    "share": 0.1667,
    "first": "2021-03-06",
    "last": "2021-03-06",
    "kind": "route",
    "castWith": [
     "ciel",
     "nolan",
     "lupe",
     "arsene",
     "delia",
     "dale",
     "jessica",
     "cruz",
     "clairette",
     "may",
     "tina",
     "cyrena"
    ]
   }
  ],
  "knownCharacters": [
   "kaleb",
   "kya_sg3",
   "kya_sg1",
   "evelyn",
   "sebastian_siren",
   "sebastian_vamp",
   "apollo",
   "gabs",
   "uncle_khan",
   "dimitri",
   "kyo",
   "ami"
  ]
 },
 "alistair_turayne": {
  "canonRoute": "val",
  "totalPassages": 550,
  "routes": [
   {
    "channel": "val",
    "passages": 112,
    "share": 0.2036,
    "first": "2020-04-15",
    "last": "2020-12-19",
    "kind": "canon",
    "castWith": [
     "val",
     "kya_sg3",
     "kaleb",
     "alistair",
     "kya_sg1",
     "evelyn",
     "vanessa",
     "ezra",
     "raye",
     "alan",
     "tyrion",
     "mr_han_sr"
    ]
   },
   {
    "channel": "alistair-x-human-kya",
    "passages": 60,
    "share": 0.1091,
    "first": "2020-08-03",
    "last": "2020-08-13",
    "kind": "route",
    "castWith": [
     "haley_human",
     "alistair",
     "apollo",
     "nicole_human",
     "ezra",
     "raye",
     "james",
     "atropos",
     "hades",
     "beatrice",
     "cruz",
     "haley_wolf"
    ]
   },
   {
    "channel": "alistair-reboot2",
    "passages": 41,
    "share": 0.0745,
    "first": "2022-04-13",
    "last": "2022-05-04",
    "kind": "au",
    "castWith": [
     "alistair",
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "sebastian_vamp",
     "evelyn",
     "sebastian_siren",
     "dillon",
     "ezra",
     "kyo",
     "uncle_khan",
     "skipper"
    ]
   },
   {
    "channel": "meeting-room",
    "passages": 35,
    "share": 0.0636,
    "first": "2020-03-26",
    "last": "2020-07-31",
    "kind": "route",
    "castWith": [
     "kaleb",
     "ezra",
     "kya_sg3",
     "raye",
     "evelyn",
     "alistair",
     "mr_han_sr",
     "kya_sg1",
     "thorne",
     "prince_zain",
     "sune",
     "yuri_rekovich"
    ]
   },
   {
    "channel": "kyas_penthouse",
    "passages": 33,
    "share": 0.06,
    "first": "2020-03-26",
    "last": "2020-03-29",
    "kind": "route",
    "castWith": [
     "kaleb",
     "evelyn",
     "raye",
     "ezra",
     "kya_sg3",
     "alistair",
     "kya_sg1",
     "mr_han_sr",
     "bryce",
     "god",
     "cruz",
     "will"
    ]
   },
   {
    "channel": "haley-nolan",
    "passages": 31,
    "share": 0.0564,
    "first": "2020-09-13",
    "last": "2020-09-17",
    "kind": "route",
    "castWith": [
     "nolan",
     "charlie",
     "alistair",
     "caroline",
     "alyce_char",
     "ryder",
     "cruz",
     "moros",
     "lachesis",
     "renee",
     "clothos",
     "audrey"
    ]
   },
   {
    "channel": "reincarnation-with-alistair",
    "passages": 25,
    "share": 0.0455,
    "first": "2025-02-03",
    "last": "2025-02-07",
    "kind": "route",
    "castWith": [
     "james",
     "dillon",
     "alistair",
     "kya_sg3",
     "sebastian_vamp",
     "kya_sg1",
     "evelyn",
     "val",
     "haley_human",
     "sebastian_siren",
     "athena",
     "junta"
    ]
   },
   {
    "channel": "1920s-boardwalk",
    "passages": 24,
    "share": 0.0436,
    "first": "2022-05-20",
    "last": "2022-05-27",
    "kind": "route",
    "castWith": [
     "val",
     "ezra",
     "kya_sg3",
     "james",
     "kya_sg1",
     "alistair",
     "vanessa",
     "sebastian_vamp",
     "sebastian_siren",
     "amelda",
     "junta",
     "dillon"
    ]
   },
   {
    "channel": "alistair-tailbond",
    "passages": 24,
    "share": 0.0436,
    "first": "2024-04-24",
    "last": "2024-05-10",
    "kind": "route",
    "castWith": [
     "kaleb",
     "kya_sg3",
     "alistair",
     "ezra",
     "dillon",
     "kya_sg1",
     "sebastian_vamp",
     "raye",
     "uncle_khan",
     "evelyn",
     "sebastian_siren",
     "poseidon"
    ]
   },
   {
    "channel": "haleys-alistair-wish",
    "passages": 19,
    "share": 0.0345,
    "first": "2023-04-27",
    "last": "2023-05-10",
    "kind": "route",
    "castWith": [
     "ezra",
     "evelyn",
     "alistair",
     "raye",
     "kaleb",
     "james",
     "dimitri",
     "haley_wolf",
     "haley_sg3",
     "uncle_khan",
     "haley_human",
     "bryce"
    ]
   },
   {
    "channel": "cafe",
    "passages": 14,
    "share": 0.0255,
    "first": "2020-04-14",
    "last": "2020-04-14",
    "kind": "route",
    "castWith": [
     "alistair",
     "evelyn",
     "kya_sg3",
     "kya_sg1",
     "mr_han_sr",
     "ray"
    ]
   },
   {
    "channel": "cell-block-tango",
    "passages": 13,
    "share": 0.0236,
    "first": "2020-03-30",
    "last": "2020-03-30",
    "kind": "route",
    "castWith": [
     "ezra",
     "kya_sg3",
     "alistair",
     "evelyn",
     "bryce",
     "thorne",
     "kya_sg1",
     "kaleb",
     "cruz",
     "rika",
     "thor",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "val",
   "kya_sg3",
   "kaleb",
   "alistair",
   "kya_sg1",
   "evelyn",
   "vanessa",
   "ezra",
   "raye",
   "alan",
   "tyrion",
   "mr_han_sr"
  ]
 },
 "alleda": {
  "canonRoute": "mt-olympus",
  "totalPassages": 1,
  "routes": [
   {
    "channel": "mt-olympus",
    "passages": 1,
    "share": 1.0,
    "first": "2020-06-23",
    "last": "2020-06-23",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "libion",
     "ares",
     "rex",
     "persephone",
     "bion",
     "hades",
     "aphrodite",
     "hercules",
     "demeter",
     "zeus",
     "athena"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "libion",
   "ares",
   "rex",
   "persephone",
   "bion",
   "hades",
   "aphrodite",
   "hercules",
   "demeter",
   "zeus",
   "athena"
  ]
 },
 "alyk": {
  "canonRoute": "lachesis-reincarnated",
  "totalPassages": 52,
  "routes": [
   {
    "channel": "lachesis-reincarnated",
    "passages": 33,
    "share": 0.6346,
    "first": "2022-06-21",
    "last": "2022-07-05",
    "kind": "canon",
    "castWith": [
     "lance",
     "lachesis",
     "haley_wolf",
     "clothos",
     "demeter",
     "moros",
     "haley_human",
     "nicole_human",
     "atropos",
     "cruz",
     "apollo",
     "arthur_turayne"
    ]
   },
   {
    "channel": "haggle-for-the-girl",
    "passages": 17,
    "share": 0.3269,
    "first": "2024-01-03",
    "last": "2024-01-04",
    "kind": "route",
    "castWith": [
     "lachesis",
     "lucifer",
     "asrius",
     "god",
     "lonnie",
     "ramiel",
     "gabriel",
     "lance",
     "hades",
     "aphrodite",
     "atropos",
     "zeus"
    ]
   },
   {
    "channel": "nicoles-wish-brax-brother",
    "passages": 1,
    "share": 0.0192,
    "first": "2023-05-01",
    "last": "2023-05-01",
    "kind": "route",
    "castWith": [
     "ford",
     "cruz",
     "brax",
     "lance",
     "dimitri",
     "hades",
     "vaughn",
     "rowan",
     "nicole_human",
     "audrey",
     "diana",
     "evelyn"
    ]
   },
   {
    "channel": "menu-special",
    "passages": 1,
    "share": 0.0192,
    "first": "2022-08-08",
    "last": "2022-08-08",
    "kind": "route",
    "castWith": [
     "lance",
     "lachesis",
     "atropos",
     "moros",
     "ares",
     "hades"
    ]
   }
  ],
  "knownCharacters": [
   "lance",
   "lachesis",
   "haley_wolf",
   "clothos",
   "demeter",
   "moros",
   "haley_human",
   "nicole_human",
   "atropos",
   "cruz",
   "apollo",
   "arthur_turayne"
  ]
 },
 "amanda": {
  "canonRoute": "ocroute2-cruz-in-for-love",
  "totalPassages": 6,
  "routes": [
   {
    "channel": "ocroute2-cruz-in-for-love",
    "passages": 4,
    "share": 0.6667,
    "first": "2022-02-08",
    "last": "2022-02-10",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "cruz",
     "dimitri",
     "hades",
     "zeus",
     "hera",
     "aphrodite",
     "god",
     "bryce",
     "lachesis",
     "hermes",
     "nolan"
    ]
   },
   {
    "channel": "cruz-is-not-dead",
    "passages": 1,
    "share": 0.1667,
    "first": "2022-05-14",
    "last": "2022-05-14",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "ford",
     "ryder",
     "lucifer",
     "bryce",
     "audrey",
     "apollo",
     "ares",
     "god",
     "clint",
     "hades"
    ]
   },
   {
    "channel": "dimitri-ralidanti",
    "passages": 1,
    "share": 0.1667,
    "first": "2023-03-01",
    "last": "2023-03-01",
    "kind": "route",
    "castWith": [
     "ryder",
     "evelyn",
     "dimitri",
     "cruz",
     "nolan",
     "bryce",
     "audrey",
     "trix",
     "lyden",
     "alyce_char",
     "kya_sg3",
     "diana"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "cruz",
   "dimitri",
   "hades",
   "zeus",
   "hera",
   "aphrodite",
   "god",
   "bryce",
   "lachesis",
   "hermes",
   "nolan"
  ]
 },
 "amelda": {
  "canonRoute": "flirty-sebastian-immortuos",
  "totalPassages": 32,
  "routes": [
   {
    "channel": "flirty-sebastian-immortuos",
    "passages": 17,
    "share": 0.5312,
    "first": "2021-12-20",
    "last": "2021-12-21",
    "kind": "canon",
    "castWith": [
     "sebastian_vamp",
     "kya_sg3",
     "sebastian_siren",
     "kya_sg1",
     "aurelia",
     "crom",
     "may",
     "val",
     "kaleb",
     "james",
     "dillon"
    ]
   },
   {
    "channel": "1920s-boardwalk",
    "passages": 8,
    "share": 0.25,
    "first": "2022-05-25",
    "last": "2022-05-26",
    "kind": "route",
    "castWith": [
     "val",
     "ezra",
     "kya_sg3",
     "james",
     "alistair_turayne",
     "kya_sg1",
     "alistair",
     "vanessa",
     "sebastian_vamp",
     "sebastian_siren",
     "junta",
     "dillon"
    ]
   },
   {
    "channel": "separated-seb",
    "passages": 4,
    "share": 0.125,
    "first": "2023-09-09",
    "last": "2023-09-09",
    "kind": "route",
    "castWith": [
     "dillon",
     "kya_sg3",
     "kya_sg1",
     "sebastian_vamp",
     "sebastian_siren",
     "evelyn",
     "uncle_khan",
     "kaleb",
     "ezra"
    ]
   },
   {
    "channel": "twins-princes-and-murder",
    "passages": 2,
    "share": 0.0625,
    "first": "2023-02-18",
    "last": "2023-02-18",
    "kind": "route",
    "castWith": [
     "hadrian",
     "kyo",
     "amoura",
     "eli"
    ]
   },
   {
    "channel": "immortuos",
    "passages": 1,
    "share": 0.0312,
    "first": "2021-12-15",
    "last": "2021-12-15",
    "kind": "route",
    "castWith": [
     "val",
     "james",
     "vanessa",
     "will",
     "kya_sg3",
     "kya_sg1",
     "sebastian_vamp",
     "sebastian_siren",
     "junta",
     "kaleb",
     "aurelia",
     "may"
    ]
   }
  ],
  "knownCharacters": [
   "sebastian_vamp",
   "kya_sg3",
   "sebastian_siren",
   "kya_sg1",
   "aurelia",
   "crom",
   "may",
   "val",
   "kaleb",
   "james",
   "dillon"
  ]
 },
 "ami": {
  "canonRoute": "kaleb-kya-finally",
  "totalPassages": 5,
  "routes": [
   {
    "channel": "kaleb-kya-finally",
    "passages": 4,
    "share": 0.8,
    "first": "2021-02-16",
    "last": "2021-02-16",
    "kind": "canon",
    "castWith": [
     "kaleb",
     "kya_sg3",
     "kya_sg1",
     "evelyn",
     "sebastian_siren",
     "sebastian_vamp",
     "apollo",
     "gabs",
     "uncle_khan",
     "alexander",
     "dimitri",
     "kyo"
    ]
   },
   {
    "channel": "kya-seb-nice-uncle",
    "passages": 1,
    "share": 0.2,
    "first": "2025-12-20",
    "last": "2025-12-20",
    "kind": "route",
    "castWith": [
     "dillon",
     "aaron",
     "kaleb",
     "kyo",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "polly",
     "evelyn",
     "sebastian_vamp",
     "frau",
     "may"
    ]
   }
  ],
  "knownCharacters": [
   "kaleb",
   "kya_sg3",
   "kya_sg1",
   "evelyn",
   "sebastian_siren",
   "sebastian_vamp",
   "apollo",
   "gabs",
   "uncle_khan",
   "alexander",
   "dimitri",
   "kyo"
  ]
 },
 "amoura": {
  "canonRoute": "twins-princes-and-murder",
  "totalPassages": 93,
  "routes": [
   {
    "channel": "twins-princes-and-murder",
    "passages": 79,
    "share": 0.8495,
    "first": "2023-02-09",
    "last": "2023-02-23",
    "kind": "canon",
    "castWith": [
     "hadrian",
     "kyo",
     "eli",
     "amelda"
    ]
   },
   {
    "channel": "double-bro-seb-cole",
    "passages": 6,
    "share": 0.0645,
    "first": "2025-05-21",
    "last": "2025-05-23",
    "kind": "route",
    "castWith": [
     "cole",
     "kaleb",
     "dillon",
     "kya_sg3",
     "kya_sg1",
     "kyo",
     "evelyn",
     "sebastian_siren",
     "may",
     "sebastian_vamp",
     "uncle_khan",
     "ace"
    ]
   },
   {
    "channel": "3-haleys-hades-fanfic",
    "passages": 6,
    "share": 0.0645,
    "first": "2023-02-23",
    "last": "2023-02-27",
    "kind": "au",
    "castWith": [
     "hades",
     "kyo",
     "persephone",
     "kya_sg3",
     "kya_sg1",
     "kaleb",
     "dillon",
     "apollo",
     "sebastian_vamp",
     "sebastian_siren",
     "eli",
     "god"
    ]
   },
   {
    "channel": "dillon-knows",
    "passages": 1,
    "share": 0.0108,
    "first": "2025-12-12",
    "last": "2025-12-12",
    "kind": "route",
    "castWith": [
     "dillon",
     "kyo",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "kaleb",
     "sebastian_vamp",
     "ever",
     "will",
     "lachesis",
     "hadrian",
     "may"
    ]
   },
   {
    "channel": "switched-roles-kya",
    "passages": 1,
    "share": 0.0108,
    "first": "2023-10-14",
    "last": "2023-10-14",
    "kind": "au",
    "castWith": [
     "diana",
     "kya_sg3",
     "raye",
     "ezra",
     "tate",
     "emanuel",
     "kya_sg1",
     "aphrodite",
     "alistair_turayne",
     "alistair",
     "kaleb",
     "cupid_eros"
    ]
   }
  ],
  "knownCharacters": [
   "hadrian",
   "kyo",
   "eli",
   "amelda"
  ]
 },
 "anii": {
  "canonRoute": "mt-olympus",
  "totalPassages": 1,
  "routes": [
   {
    "channel": "mt-olympus",
    "passages": 1,
    "share": 1.0,
    "first": "2020-06-23",
    "last": "2020-06-23",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "libion",
     "ares",
     "rex",
     "persephone",
     "bion",
     "hades",
     "aphrodite",
     "hercules",
     "demeter",
     "zeus",
     "athena"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "libion",
   "ares",
   "rex",
   "persephone",
   "bion",
   "hades",
   "aphrodite",
   "hercules",
   "demeter",
   "zeus",
   "athena"
  ]
 },
 "aion": {
  "canonRoute": "plz-love-lachesis",
  "totalPassages": 21,
  "routes": [
   {
    "channel": "plz-love-lachesis",
    "passages": 21,
    "share": 1.0,
    "first": "2022-11-11",
    "last": "2022-11-20",
    "kind": "canon",
    "castWith": [
     "lachesis",
     "ramiel",
     "lance",
     "god",
     "lucifer",
     "apollo",
     "levi",
     "atropos",
     "zeus",
     "zadkiel",
     "clothos",
     "asrius"
    ]
   }
  ],
  "knownCharacters": [
   "lachesis",
   "ramiel",
   "lance",
   "god",
   "lucifer",
   "apollo",
   "levi",
   "atropos",
   "zeus",
   "zadkiel",
   "clothos",
   "asrius"
  ]
 },
 "apate": {
  "canonRoute": "mt-olympus",
  "totalPassages": 1,
  "routes": [
   {
    "channel": "mt-olympus",
    "passages": 1,
    "share": 1.0,
    "first": "2020-06-23",
    "last": "2020-06-23",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "libion",
     "ares",
     "rex",
     "persephone",
     "bion",
     "hades",
     "aphrodite",
     "hercules",
     "demeter",
     "zeus",
     "athena"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "libion",
   "ares",
   "rex",
   "persephone",
   "bion",
   "hades",
   "aphrodite",
   "hercules",
   "demeter",
   "zeus",
   "athena"
  ]
 },
 "ari": {
  "canonRoute": "kya-college-2",
  "totalPassages": 79,
  "routes": [
   {
    "channel": "kya-college-2",
    "passages": 45,
    "share": 0.5696,
    "first": "2020-12-28",
    "last": "2021-01-07",
    "kind": "canon",
    "castWith": [
     "lily",
     "zander",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "raye",
     "prince_zed",
     "sebastian_vamp",
     "midori_naga",
     "penelope_valk",
     "bell_lily_of_fell",
     "agnar"
    ]
   },
   {
    "channel": "evelyn-college-2",
    "passages": 22,
    "share": 0.2785,
    "first": "2021-01-05",
    "last": "2021-01-22",
    "kind": "route",
    "castWith": [
     "evelyn",
     "darren",
     "dimitri",
     "lex",
     "hades",
     "raye",
     "jon",
     "ares",
     "kaleb",
     "cruz",
     "kya_sg3",
     "aibell"
    ]
   },
   {
    "channel": "ooc",
    "passages": 6,
    "share": 0.0759,
    "first": "2020-05-08",
    "last": "2020-06-19",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 4,
    "share": 0.0506,
    "first": "2020-05-22",
    "last": "2020-05-30",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "college-campus",
    "passages": 2,
    "share": 0.0253,
    "first": "2020-05-10",
    "last": "2020-05-10",
    "kind": "route",
    "castWith": [
     "agnar",
     "agmund",
     "kya_sg3",
     "penelope_valk",
     "evelyn",
     "svira",
     "rowan",
     "may",
     "jon",
     "kya_sg1",
     "kaleb",
     "darren"
    ]
   }
  ],
  "knownCharacters": [
   "lily",
   "zander",
   "kya_sg3",
   "kya_sg1",
   "sebastian_siren",
   "raye",
   "prince_zed",
   "sebastian_vamp",
   "midori_naga",
   "penelope_valk",
   "bell_lily_of_fell",
   "agnar"
  ]
 },
 "arland_rees": {
  "canonRoute": "frau-collin",
  "totalPassages": 33,
  "routes": [
   {
    "channel": "frau-collin",
    "passages": 33,
    "share": 1.0,
    "first": "2020-11-23",
    "last": "2020-12-13",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "cruz",
     "rowan",
     "frau",
     "collin_keller",
     "ezra",
     "felix_fairy",
     "rikki",
     "park",
     "alyce_char",
     "myra",
     "allie"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "cruz",
   "rowan",
   "frau",
   "collin_keller",
   "ezra",
   "felix_fairy",
   "rikki",
   "park",
   "alyce_char",
   "myra",
   "allie"
  ]
 },
 "arnold_astor": {
  "canonRoute": "junta-is-best-boi",
  "totalPassages": 3,
  "routes": [
   {
    "channel": "junta-is-best-boi",
    "passages": 1,
    "share": 0.3333,
    "first": "2023-11-24",
    "last": "2023-11-24",
    "kind": "canon",
    "castWith": [
     "junta",
     "ezra",
     "madison_astor",
     "lily",
     "val",
     "natasha",
     "primrose",
     "belinda",
     "james",
     "may",
     "sebastian_vamp",
     "tim"
    ]
   },
   {
    "channel": "reed-vamp-werecheetah",
    "passages": 1,
    "share": 0.3333,
    "first": "2023-11-12",
    "last": "2023-11-12",
    "kind": "route",
    "castWith": [
     "reed",
     "madison_astor",
     "kale",
     "raye",
     "may",
     "paul",
     "xavier",
     "zeke"
    ]
   },
   {
    "channel": "terrance-and-the-forest",
    "passages": 1,
    "share": 0.3333,
    "first": "2025-10-07",
    "last": "2025-10-07",
    "kind": "route",
    "castWith": [
     "aelira",
     "terrance",
     "killian",
     "arthur_turayne",
     "may",
     "ford",
     "god",
     "lira"
    ]
   }
  ],
  "knownCharacters": [
   "junta",
   "ezra",
   "madison_astor",
   "lily",
   "val",
   "natasha",
   "primrose",
   "belinda",
   "james",
   "may",
   "sebastian_vamp",
   "tim"
  ]
 },
 "arsene": {
  "canonRoute": "an-accidentally-valerian-summer-with-cordelia",
  "totalPassages": 30,
  "routes": [
   {
    "channel": "an-accidentally-valerian-summer-with-cordelia",
    "passages": 30,
    "share": 1.0,
    "first": "2021-04-18",
    "last": "2021-05-08",
    "kind": "canon",
    "castWith": [
     "ciel",
     "nolan",
     "lupe",
     "delia",
     "dale",
     "jessica",
     "cruz",
     "clairette",
     "may",
     "tina",
     "cyrena",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "ciel",
   "nolan",
   "lupe",
   "delia",
   "dale",
   "jessica",
   "cruz",
   "clairette",
   "may",
   "tina",
   "cyrena",
   "will"
  ]
 },
 "arthur_turayne": {
  "canonRoute": "terrance-and-the-forest",
  "totalPassages": 63,
  "routes": [
   {
    "channel": "terrance-and-the-forest",
    "passages": 40,
    "share": 0.6349,
    "first": "2025-10-07",
    "last": "2025-10-17",
    "kind": "canon",
    "castWith": [
     "aelira",
     "terrance",
     "killian",
     "may",
     "ford",
     "arnold_astor",
     "god",
     "lira"
    ]
   },
   {
    "channel": "warring-men",
    "passages": 18,
    "share": 0.2857,
    "first": "2025-09-30",
    "last": "2025-10-06",
    "kind": "route",
    "castWith": [
     "aelira",
     "killian",
     "autumn",
     "summer",
     "terrance",
     "may",
     "ragland",
     "will"
    ]
   },
   {
    "channel": "a-tricky-micah-cruz-route",
    "passages": 2,
    "share": 0.0317,
    "first": "2023-08-31",
    "last": "2023-09-03",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "ryder",
     "cruz",
     "micah",
     "trix",
     "allie",
     "evelyn",
     "roger",
     "audrey",
     "god",
     "bryce"
    ]
   },
   {
    "channel": "lachesis-reincarnated",
    "passages": 2,
    "share": 0.0317,
    "first": "2022-06-13",
    "last": "2022-07-05",
    "kind": "route",
    "castWith": [
     "lance",
     "alyk",
     "lachesis",
     "haley_wolf",
     "clothos",
     "demeter",
     "moros",
     "haley_human",
     "nicole_human",
     "atropos",
     "cruz",
     "apollo"
    ]
   },
   {
    "channel": "meeting-room",
    "passages": 1,
    "share": 0.0159,
    "first": "2020-04-17",
    "last": "2020-04-17",
    "kind": "route",
    "castWith": [
     "kaleb",
     "ezra",
     "kya_sg3",
     "raye",
     "evelyn",
     "alistair_turayne",
     "alistair",
     "mr_han_sr",
     "kya_sg1",
     "thorne",
     "prince_zain",
     "sune"
    ]
   }
  ],
  "knownCharacters": [
   "aelira",
   "terrance",
   "killian",
   "may",
   "ford",
   "arnold_astor",
   "god",
   "lira"
  ]
 },
 "asmodeus": {
  "canonRoute": "pack-beachhouse",
  "totalPassages": 22,
  "routes": [
   {
    "channel": "pack-beachhouse",
    "passages": 7,
    "share": 0.3182,
    "first": "2020-04-03",
    "last": "2020-04-03",
    "kind": "canon",
    "castWith": [
     "thorne",
     "kaleb",
     "evelyn"
    ]
   },
   {
    "channel": "pack_house",
    "passages": 6,
    "share": 0.2727,
    "first": "2020-04-01",
    "last": "2020-04-02",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "nolan",
     "bryce",
     "audrey",
     "allie",
     "alyce_char",
     "luca",
     "trix",
     "ryder",
     "kaleb",
     "ezra"
    ]
   },
   {
    "channel": "alistairs-familys-castle",
    "passages": 3,
    "share": 0.1364,
    "first": "2020-04-03",
    "last": "2020-04-03",
    "kind": "route",
    "castWith": [
     "thorne",
     "kaleb",
     "evelyn",
     "cruz",
     "ezra",
     "kya_sg3",
     "alistair",
     "alistair_turayne",
     "bryce",
     "kya_sg1",
     "hades",
     "thor"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 2,
    "share": 0.0909,
    "first": "2020-04-07",
    "last": "2020-04-07",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "ooc",
    "passages": 2,
    "share": 0.0909,
    "first": "2020-06-09",
    "last": "2020-06-09",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 2,
    "share": 0.0909,
    "first": "2020-04-01",
    "last": "2020-04-01",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika"
    ]
   }
  ],
  "knownCharacters": [
   "thorne",
   "kaleb",
   "evelyn"
  ]
 },
 "aspen": {
  "canonRoute": "tyrant-evie-runs-away",
  "totalPassages": 61,
  "routes": [
   {
    "channel": "tyrant-evie-runs-away",
    "passages": 44,
    "share": 0.7213,
    "first": "2022-01-10",
    "last": "2022-01-28",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "bryce",
     "rio",
     "ace",
     "kaleb",
     "myra",
     "kya_sg3",
     "alistair",
     "alistair_turayne",
     "ezra",
     "rowan",
     "eva"
    ]
   },
   {
    "channel": "no-time-like-the-present",
    "passages": 11,
    "share": 0.1803,
    "first": "2023-09-25",
    "last": "2023-09-26",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "lance",
     "ryder",
     "allie",
     "cruz",
     "micah",
     "god",
     "trix",
     "diana",
     "evelyn",
     "audrey"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 3,
    "share": 0.0492,
    "first": "2025-02-05",
    "last": "2025-02-05",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "ryder",
     "ford",
     "vaughn",
     "lance",
     "bryce",
     "shane",
     "dimitri",
     "allie",
     "micah",
     "audrey"
    ]
   },
   {
    "channel": "a-tricky-micah-cruz-route",
    "passages": 2,
    "share": 0.0328,
    "first": "2023-09-03",
    "last": "2023-09-03",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "ryder",
     "cruz",
     "micah",
     "trix",
     "allie",
     "evelyn",
     "roger",
     "audrey",
     "god",
     "bryce"
    ]
   },
   {
    "channel": "ooc",
    "passages": 1,
    "share": 0.0164,
    "first": "2020-04-21",
    "last": "2020-04-21",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "bryce",
   "rio",
   "ace",
   "kaleb",
   "myra",
   "kya_sg3",
   "alistair",
   "alistair_turayne",
   "ezra",
   "rowan",
   "eva"
  ]
 },
 "asrius": {
  "canonRoute": "haggle-for-the-girl",
  "totalPassages": 159,
  "routes": [
   {
    "channel": "haggle-for-the-girl",
    "passages": 127,
    "share": 0.7987,
    "first": "2023-12-13",
    "last": "2024-01-21",
    "kind": "canon",
    "castWith": [
     "lachesis",
     "lucifer",
     "god",
     "lonnie",
     "ramiel",
     "gabriel",
     "lance",
     "hades",
     "alyk",
     "aphrodite",
     "atropos",
     "zeus"
    ]
   },
   {
    "channel": "fordsplosion",
    "passages": 16,
    "share": 0.1006,
    "first": "2024-03-06",
    "last": "2024-03-15",
    "kind": "route",
    "castWith": [
     "ford",
     "lachesis",
     "lucifer",
     "cruz",
     "clothos",
     "ryder",
     "god",
     "ethan",
     "eva",
     "atropos",
     "may",
     "evelyn"
    ]
   },
   {
    "channel": "nicolexcruz-true-mates",
    "passages": 5,
    "share": 0.0314,
    "first": "2024-03-27",
    "last": "2024-04-10",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "nolan",
     "clothos",
     "trix",
     "diana",
     "nicole_human",
     "audrey",
     "lucifer",
     "atropos",
     "bryce"
    ]
   },
   {
    "channel": "plz-love-lachesis",
    "passages": 4,
    "share": 0.0252,
    "first": "2022-11-14",
    "last": "2022-11-22",
    "kind": "route",
    "castWith": [
     "lachesis",
     "ramiel",
     "lance",
     "god",
     "lucifer",
     "apollo",
     "levi",
     "aion",
     "atropos",
     "zeus",
     "zadkiel",
     "clothos"
    ]
   },
   {
    "channel": "lachesis-off-the-rails",
    "passages": 3,
    "share": 0.0189,
    "first": "2025-09-08",
    "last": "2025-09-11",
    "kind": "route",
    "castWith": [
     "lance",
     "vaughn",
     "brax",
     "lucifer",
     "james",
     "atropos",
     "cruz",
     "lachesis",
     "ace",
     "lindon",
     "hades",
     "ezra"
    ]
   },
   {
    "channel": "lance-decides",
    "passages": 2,
    "share": 0.0126,
    "first": "2024-12-18",
    "last": "2024-12-18",
    "kind": "route",
    "castWith": [
     "lance",
     "rin",
     "lucifer",
     "lachesis",
     "nicole_human",
     "god",
     "chiara",
     "cupid_eros",
     "roman",
     "hera",
     "zeus",
     "aphrodite"
    ]
   },
   {
    "channel": "lance-nicole-2",
    "passages": 1,
    "share": 0.0063,
    "first": "2022-12-12",
    "last": "2022-12-12",
    "kind": "route",
    "castWith": [
     "brax",
     "vaughn",
     "lance",
     "jenning",
     "cruz",
     "lachesis",
     "nicole_human",
     "nicole_wolf",
     "nicole_sg3",
     "clothos",
     "atropos",
     "rowan"
    ]
   },
   {
    "channel": "human-lachesis",
    "passages": 1,
    "share": 0.0063,
    "first": "2024-09-30",
    "last": "2024-09-30",
    "kind": "route",
    "castWith": [
     "nicole_human",
     "brax",
     "lachesis",
     "lance",
     "vaughn",
     "rowan",
     "god",
     "alyce_char",
     "moros",
     "ford",
     "atropos",
     "cruz"
    ]
   }
  ],
  "knownCharacters": [
   "lachesis",
   "lucifer",
   "god",
   "lonnie",
   "ramiel",
   "gabriel",
   "lance",
   "hades",
   "alyk",
   "aphrodite",
   "atropos",
   "zeus"
  ]
 },
 "athena": {
  "canonRoute": "car",
  "totalPassages": 60,
  "routes": [
   {
    "channel": "car",
    "passages": 10,
    "share": 0.1667,
    "first": "2020-05-17",
    "last": "2020-05-17",
    "kind": "canon",
    "castWith": [
     "hiro",
     "evelyn",
     "lucius",
     "apollo",
     "riku",
     "cruz",
     "ares",
     "will"
    ]
   },
   {
    "channel": "ooc",
    "passages": 7,
    "share": 0.1167,
    "first": "2020-05-07",
    "last": "2020-06-20",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "reincarnation-with-alistair",
    "passages": 5,
    "share": 0.0833,
    "first": "2025-02-10",
    "last": "2025-02-13",
    "kind": "route",
    "castWith": [
     "james",
     "dillon",
     "alistair",
     "alistair_turayne",
     "kya_sg3",
     "sebastian_vamp",
     "kya_sg1",
     "evelyn",
     "val",
     "haley_human",
     "sebastian_siren",
     "junta"
    ]
   },
   {
    "channel": "mt-olympus",
    "passages": 5,
    "share": 0.0833,
    "first": "2020-03-29",
    "last": "2020-06-23",
    "kind": "route",
    "castWith": [
     "evelyn",
     "libion",
     "ares",
     "rex",
     "persephone",
     "bion",
     "hades",
     "aphrodite",
     "hercules",
     "demeter",
     "zeus",
     "zerden"
    ]
   },
   {
    "channel": "haley-finds-out-shes-cool-2",
    "passages": 3,
    "share": 0.05,
    "first": "2022-12-05",
    "last": "2022-12-05",
    "kind": "route",
    "castWith": [
     "moros",
     "atropos",
     "gracie",
     "haley_human",
     "jinko",
     "lance",
     "may",
     "lachesis",
     "clothos",
     "haley_wolf",
     "peter",
     "apollo"
    ]
   },
   {
    "channel": "lachesis-off-the-rails",
    "passages": 3,
    "share": 0.05,
    "first": "2025-09-09",
    "last": "2025-09-11",
    "kind": "route",
    "castWith": [
     "lance",
     "vaughn",
     "brax",
     "lucifer",
     "james",
     "atropos",
     "cruz",
     "lachesis",
     "ace",
     "lindon",
     "hades",
     "ezra"
    ]
   },
   {
    "channel": "bios",
    "passages": 3,
    "share": 0.05,
    "first": "2020-06-03",
    "last": "2020-06-04",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "evelyn",
     "lucius",
     "bryce",
     "val",
     "hiro",
     "raz",
     "rex",
     "vanessa",
     "halo",
     "dalton",
     "cruz"
    ]
   },
   {
    "channel": "auditorium",
    "passages": 3,
    "share": 0.05,
    "first": "2020-06-08",
    "last": "2020-06-08",
    "kind": "route",
    "castWith": [
     "rex",
     "evelyn",
     "diana",
     "milo",
     "dimitri",
     "dike",
     "audrey",
     "saph",
     "bryce",
     "kaleb",
     "roman",
     "rio"
    ]
   },
   {
    "channel": "athena-class",
    "passages": 3,
    "share": 0.05,
    "first": "2020-06-18",
    "last": "2020-06-19",
    "kind": "route",
    "castWith": [
     "rex",
     "evelyn",
     "kiro",
     "diana",
     "milo",
     "cupid_eros",
     "dimitri",
     "dike",
     "kya_sg1",
     "aaron",
     "kya_sg3",
     "hiro"
    ]
   },
   {
    "channel": "junta-route",
    "passages": 2,
    "share": 0.0333,
    "first": "2022-11-28",
    "last": "2022-11-28",
    "kind": "route",
    "castWith": [
     "junta",
     "kya_sg3",
     "james",
     "natasha",
     "kya_sg1",
     "apollo",
     "dillon",
     "kyo",
     "hermes",
     "belinda"
    ]
   },
   {
    "channel": "sabrinas-apartment",
    "passages": 2,
    "share": 0.0333,
    "first": "2020-06-06",
    "last": "2020-06-06",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "sabrina_witch",
     "aphrodite",
     "halo",
     "hiro",
     "ares",
     "demeter",
     "god",
     "roman"
    ]
   },
   {
    "channel": "greek-house",
    "passages": 2,
    "share": 0.0333,
    "first": "2020-05-07",
    "last": "2020-05-08",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hiro",
     "darren",
     "lex",
     "kiro",
     "raye",
     "kya_sg3",
     "ares",
     "riku",
     "kya_sg1",
     "lacie",
     "aphrodite"
    ]
   }
  ],
  "knownCharacters": [
   "hiro",
   "evelyn",
   "lucius",
   "apollo",
   "riku",
   "cruz",
   "ares",
   "will"
  ]
 },
 "atrius": {
  "canonRoute": "frau-collin",
  "totalPassages": 2,
  "routes": [
   {
    "channel": "frau-collin",
    "passages": 2,
    "share": 1.0,
    "first": "2020-12-27",
    "last": "2020-12-27",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "cruz",
     "rowan",
     "frau",
     "collin_keller",
     "arland_rees",
     "ezra",
     "felix_fairy",
     "rikki",
     "park",
     "alyce_char",
     "myra"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "cruz",
   "rowan",
   "frau",
   "collin_keller",
   "arland_rees",
   "ezra",
   "felix_fairy",
   "rikki",
   "park",
   "alyce_char",
   "myra"
  ]
 },
 "aurelia": {
  "canonRoute": "flirty-sebastian-immortuos",
  "totalPassages": 13,
  "routes": [
   {
    "channel": "flirty-sebastian-immortuos",
    "passages": 9,
    "share": 0.6923,
    "first": "2021-12-20",
    "last": "2021-12-21",
    "kind": "canon",
    "castWith": [
     "amelda",
     "sebastian_vamp",
     "kya_sg3",
     "sebastian_siren",
     "kya_sg1",
     "crom",
     "may",
     "val",
     "kaleb",
     "james",
     "dillon"
    ]
   },
   {
    "channel": "1920s-boardwalk",
    "passages": 2,
    "share": 0.1538,
    "first": "2022-05-25",
    "last": "2022-05-26",
    "kind": "route",
    "castWith": [
     "val",
     "ezra",
     "kya_sg3",
     "james",
     "alistair_turayne",
     "kya_sg1",
     "alistair",
     "vanessa",
     "sebastian_vamp",
     "sebastian_siren",
     "amelda",
     "junta"
    ]
   },
   {
    "channel": "immortuos",
    "passages": 2,
    "share": 0.1538,
    "first": "2021-12-09",
    "last": "2021-12-09",
    "kind": "route",
    "castWith": [
     "val",
     "james",
     "vanessa",
     "will",
     "kya_sg3",
     "kya_sg1",
     "sebastian_vamp",
     "sebastian_siren",
     "junta",
     "kaleb",
     "may",
     "tim"
    ]
   }
  ],
  "knownCharacters": [
   "amelda",
   "sebastian_vamp",
   "kya_sg3",
   "sebastian_siren",
   "kya_sg1",
   "crom",
   "may",
   "val",
   "kaleb",
   "james",
   "dillon"
  ]
 },
 "aurielis": {
  "canonRoute": "haggle-for-the-girl",
  "totalPassages": 1,
  "routes": [
   {
    "channel": "haggle-for-the-girl",
    "passages": 1,
    "share": 1.0,
    "first": "2024-01-17",
    "last": "2024-01-17",
    "kind": "canon",
    "castWith": [
     "lachesis",
     "lucifer",
     "asrius",
     "god",
     "lonnie",
     "ramiel",
     "gabriel",
     "lance",
     "hades",
     "alyk",
     "aphrodite",
     "atropos"
    ]
   }
  ],
  "knownCharacters": [
   "lachesis",
   "lucifer",
   "asrius",
   "god",
   "lonnie",
   "ramiel",
   "gabriel",
   "lance",
   "hades",
   "alyk",
   "aphrodite",
   "atropos"
  ]
 },
 "autumn": {
  "canonRoute": "fall-fairies",
  "totalPassages": 41,
  "routes": [
   {
    "channel": "fall-fairies",
    "passages": 35,
    "share": 0.8537,
    "first": "2021-10-25",
    "last": "2021-11-16",
    "kind": "canon",
    "castWith": [
     "damien",
     "matare",
     "retin",
     "draven",
     "fayette",
     "sir_tyde",
     "may",
     "maleos",
     "silvia",
     "jaden",
     "will",
     "roman"
    ]
   },
   {
    "channel": "warring-men",
    "passages": 6,
    "share": 0.1463,
    "first": "2025-08-07",
    "last": "2025-09-25",
    "kind": "route",
    "castWith": [
     "aelira",
     "killian",
     "arthur_turayne",
     "summer",
     "terrance",
     "may",
     "ragland",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "damien",
   "matare",
   "retin",
   "draven",
   "fayette",
   "sir_tyde",
   "may",
   "maleos",
   "silvia",
   "jaden",
   "will",
   "roman"
  ]
 },
 "aztioso": {
  "canonRoute": "mt-olympus",
  "totalPassages": 1,
  "routes": [
   {
    "channel": "mt-olympus",
    "passages": 1,
    "share": 1.0,
    "first": "2020-06-23",
    "last": "2020-06-23",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "libion",
     "ares",
     "rex",
     "persephone",
     "bion",
     "hades",
     "aphrodite",
     "hercules",
     "demeter",
     "zeus",
     "athena"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "libion",
   "ares",
   "rex",
   "persephone",
   "bion",
   "hades",
   "aphrodite",
   "hercules",
   "demeter",
   "zeus",
   "athena"
  ]
 },
 "bash": {
  "canonRoute": null,
  "totalPassages": 6,
  "routes": [
   {
    "channel": "switched-roles-lachesis",
    "passages": 6,
    "share": 1.0,
    "first": "2023-11-21",
    "last": "2023-11-21",
    "kind": "au",
    "castWith": [
     "lachesis",
     "ford",
     "god",
     "lucifer",
     "cruz",
     "clothos",
     "atropos",
     "rowan",
     "vaughn",
     "ryder",
     "brax",
     "dimitri"
    ]
   }
  ],
  "knownCharacters": []
 },
 "bast": {
  "canonRoute": "kingdom-of-temprum",
  "totalPassages": 13,
  "routes": [
   {
    "channel": "kingdom-of-temprum",
    "passages": 6,
    "share": 0.4615,
    "first": "2020-05-25",
    "last": "2020-05-25",
    "kind": "canon",
    "castWith": [
     "aria",
     "bennett",
     "benji",
     "ajax",
     "naveed",
     "fawn",
     "solum",
     "caria",
     "neitl",
     "batiuba",
     "will",
     "kaleb"
    ]
   },
   {
    "channel": "ooc",
    "passages": 3,
    "share": 0.2308,
    "first": "2020-06-04",
    "last": "2020-06-19",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 3,
    "share": 0.2308,
    "first": "2020-05-26",
    "last": "2020-05-31",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "surprise-nicole",
    "passages": 1,
    "share": 0.0769,
    "first": "2021-08-18",
    "last": "2021-08-18",
    "kind": "route",
    "castWith": [
     "nicole_human"
    ]
   }
  ],
  "knownCharacters": [
   "aria",
   "bennett",
   "benji",
   "ajax",
   "naveed",
   "fawn",
   "solum",
   "caria",
   "neitl",
   "batiuba",
   "will",
   "kaleb"
  ]
 },
 "batiuba": {
  "canonRoute": "kingdom-of-welis",
  "totalPassages": 12,
  "routes": [
   {
    "channel": "kingdom-of-welis",
    "passages": 6,
    "share": 0.5,
    "first": "2020-04-13",
    "last": "2020-04-13",
    "kind": "canon",
    "castWith": [
     "aria",
     "caria",
     "ajax",
     "ragland",
     "kent",
     "will"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 3,
    "share": 0.25,
    "first": "2020-05-26",
    "last": "2020-05-31",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "kingdom-of-temprum",
    "passages": 2,
    "share": 0.1667,
    "first": "2020-05-28",
    "last": "2020-05-31",
    "kind": "route",
    "castWith": [
     "aria",
     "bennett",
     "benji",
     "ajax",
     "naveed",
     "fawn",
     "bast",
     "solum",
     "caria",
     "neitl",
     "will",
     "kaleb"
    ]
   },
   {
    "channel": "ooc",
    "passages": 1,
    "share": 0.0833,
    "first": "2020-06-07",
    "last": "2020-06-07",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   }
  ],
  "knownCharacters": [
   "aria",
   "caria",
   "ajax",
   "ragland",
   "kent",
   "will"
  ]
 },
 "beatrice": {
  "canonRoute": "to-the-max",
  "totalPassages": 10,
  "routes": [
   {
    "channel": "to-the-max",
    "passages": 4,
    "share": 0.4,
    "first": "2023-05-28",
    "last": "2023-05-29",
    "kind": "canon",
    "castWith": [
     "maxen_bryers",
     "addison",
     "trace_renton",
     "kya_sg3",
     "kya_sg1",
     "rick",
     "evelyn",
     "dillon",
     "budd",
     "lore",
     "paula",
     "diana"
    ]
   },
   {
    "channel": "alistair-x-human-kya",
    "passages": 4,
    "share": 0.4,
    "first": "2020-08-07",
    "last": "2020-08-07",
    "kind": "route",
    "castWith": [
     "haley_human",
     "alistair_turayne",
     "alistair",
     "apollo",
     "nicole_human",
     "ezra",
     "raye",
     "james",
     "atropos",
     "hades",
     "cruz",
     "haley_wolf"
    ]
   },
   {
    "channel": "heavenbound-missions",
    "passages": 2,
    "share": 0.2,
    "first": "2025-10-12",
    "last": "2025-10-13",
    "kind": "route",
    "castWith": [
     "vaughn",
     "lindon",
     "god",
     "ares",
     "brax",
     "primrose",
     "aphrodite",
     "nicole_human",
     "nicole_wolf",
     "nicole_sg3",
     "will",
     "cruz"
    ]
   }
  ],
  "knownCharacters": [
   "maxen_bryers",
   "addison",
   "trace_renton",
   "kya_sg3",
   "kya_sg1",
   "rick",
   "evelyn",
   "dillon",
   "budd",
   "lore",
   "paula",
   "diana"
  ]
 },
 "becca": {
  "canonRoute": "mystery-do-over",
  "totalPassages": 10,
  "routes": [
   {
    "channel": "mystery-do-over",
    "passages": 3,
    "share": 0.3,
    "first": "2024-02-06",
    "last": "2024-02-06",
    "kind": "canon",
    "castWith": [
     "dillon",
     "kaleb",
     "york",
     "evelyn",
     "camren",
     "toren",
     "kya_sg3",
     "kya_sg1",
     "uncle_khan"
    ]
   },
   {
    "channel": "cruz-is-not-dead",
    "passages": 2,
    "share": 0.2,
    "first": "2022-05-17",
    "last": "2022-05-17",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "ford",
     "ryder",
     "lucifer",
     "bryce",
     "audrey",
     "apollo",
     "ares",
     "god",
     "clint",
     "hades"
    ]
   },
   {
    "channel": "han-family-mansion",
    "passages": 2,
    "share": 0.2,
    "first": "2020-04-14",
    "last": "2020-04-14",
    "kind": "route",
    "castWith": [
     "evelyn",
     "ezra",
     "kaleb",
     "kya_sg3",
     "rowan",
     "mr_han_sr",
     "raye",
     "kya_sg1",
     "sune",
     "alistair",
     "alistair_turayne",
     "marta"
    ]
   },
   {
    "channel": "alistair-reboot2",
    "passages": 1,
    "share": 0.1,
    "first": "2022-04-28",
    "last": "2022-04-28",
    "kind": "au",
    "castWith": [
     "alistair",
     "alistair_turayne",
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "sebastian_vamp",
     "evelyn",
     "sebastian_siren",
     "dillon",
     "ezra",
     "kyo",
     "uncle_khan"
    ]
   },
   {
    "channel": "lance-is-a-family-man",
    "passages": 1,
    "share": 0.1,
    "first": "2024-04-30",
    "last": "2024-04-30",
    "kind": "route",
    "castWith": [
     "lance",
     "evelyn",
     "cruz",
     "audrey",
     "luca",
     "bryce",
     "lyden",
     "hermes",
     "roger",
     "dimitri",
     "hades",
     "diana"
    ]
   },
   {
    "channel": "eat-speak-rp-repeat",
    "passages": 1,
    "share": 0.1,
    "first": "2026-03-15",
    "last": "2026-03-15",
    "kind": "ooc",
    "castWith": [
     "eric",
     "cruz",
     "lindon",
     "april",
     "lance",
     "felix_fairy",
     "brooke",
     "cyrus_fairy",
     "malakai",
     "god",
     "jack",
     "pam"
    ]
   }
  ],
  "knownCharacters": [
   "dillon",
   "kaleb",
   "york",
   "evelyn",
   "camren",
   "toren",
   "kya_sg3",
   "kya_sg1",
   "uncle_khan"
  ]
 },
 "belinda": {
  "canonRoute": "junta-is-best-boi",
  "totalPassages": 10,
  "routes": [
   {
    "channel": "junta-is-best-boi",
    "passages": 5,
    "share": 0.5,
    "first": "2023-12-07",
    "last": "2023-12-10",
    "kind": "canon",
    "castWith": [
     "junta",
     "ezra",
     "madison_astor",
     "lily",
     "val",
     "natasha",
     "primrose",
     "james",
     "may",
     "sebastian_vamp",
     "tim",
     "ace"
    ]
   },
   {
    "channel": "love-the-good-bois",
    "passages": 4,
    "share": 0.4,
    "first": "2022-11-21",
    "last": "2022-11-22",
    "kind": "route",
    "castWith": [
     "ezra",
     "junta",
     "kya_sg3",
     "raz",
     "kya_sg1",
     "tim",
     "sebastian_vamp",
     "val",
     "evelyn",
     "kaleb",
     "skipper",
     "james"
    ]
   },
   {
    "channel": "junta-route",
    "passages": 1,
    "share": 0.1,
    "first": "2022-11-28",
    "last": "2022-11-28",
    "kind": "route",
    "castWith": [
     "junta",
     "kya_sg3",
     "james",
     "natasha",
     "kya_sg1",
     "apollo",
     "athena",
     "dillon",
     "kyo",
     "hermes"
    ]
   }
  ],
  "knownCharacters": [
   "junta",
   "ezra",
   "madison_astor",
   "lily",
   "val",
   "natasha",
   "primrose",
   "james",
   "may",
   "sebastian_vamp",
   "tim",
   "ace"
  ]
 },
 "bell_lily_of_fell": {
  "canonRoute": "kya-college-2",
  "totalPassages": 21,
  "routes": [
   {
    "channel": "kya-college-2",
    "passages": 11,
    "share": 0.5238,
    "first": "2021-01-21",
    "last": "2021-01-28",
    "kind": "canon",
    "castWith": [
     "lily",
     "zander",
     "kya_sg3",
     "kya_sg1",
     "ari",
     "sebastian_siren",
     "raye",
     "prince_zed",
     "sebastian_vamp",
     "midori_naga",
     "penelope_valk",
     "agnar"
    ]
   },
   {
    "channel": "ezra-normalish-life",
    "passages": 9,
    "share": 0.4286,
    "first": "2022-08-16",
    "last": "2022-08-20",
    "kind": "route",
    "castWith": [
     "ezra",
     "sam",
     "kya_sg3",
     "kya_sg1",
     "raz",
     "james",
     "evelyn",
     "kaleb",
     "vanessa",
     "val",
     "jane",
     "tim"
    ]
   },
   {
    "channel": "cruz-x-human",
    "passages": 1,
    "share": 0.0476,
    "first": "2021-04-17",
    "last": "2021-04-17",
    "kind": "route",
    "castWith": [
     "cruz",
     "skye",
     "nolan",
     "ryder",
     "audrey",
     "troy",
     "adrien",
     "bryce",
     "airi",
     "natasha",
     "diana",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "lily",
   "zander",
   "kya_sg3",
   "kya_sg1",
   "ari",
   "sebastian_siren",
   "raye",
   "prince_zed",
   "sebastian_vamp",
   "midori_naga",
   "penelope_valk",
   "agnar"
  ]
 },
 "ben": {
  "canonRoute": "daddy-lindon-hates-brax",
  "totalPassages": 102,
  "routes": [
   {
    "channel": "daddy-lindon-hates-brax",
    "passages": 77,
    "share": 0.7549,
    "first": "2025-05-05",
    "last": "2025-05-19",
    "kind": "canon",
    "castWith": [
     "lindon",
     "brax",
     "vaughn",
     "nicole_human",
     "ezra",
     "will",
     "nicole_wolf",
     "nicole_sg3",
     "ace"
    ]
   },
   {
    "channel": "dorms",
    "passages": 6,
    "share": 0.0588,
    "first": "2020-05-01",
    "last": "2020-05-01",
    "kind": "route",
    "castWith": [
     "agnar",
     "kya_sg3",
     "agmund",
     "evelyn",
     "raye",
     "cole",
     "kya_sg1",
     "riku",
     "kaleb",
     "penelope_valk",
     "loki",
     "svira"
    ]
   },
   {
    "channel": "reunited-with-vaughn",
    "passages": 3,
    "share": 0.0294,
    "first": "2025-05-27",
    "last": "2025-05-31",
    "kind": "route",
    "castWith": [
     "vaughn",
     "brax",
     "nicole_human",
     "lindon",
     "nicole_wolf",
     "nicole_sg3",
     "moros",
     "ezra",
     "parks",
     "will"
    ]
   },
   {
    "channel": "vaughneo-and-juliet",
    "passages": 3,
    "share": 0.0294,
    "first": "2025-12-13",
    "last": "2025-12-17",
    "kind": "route",
    "castWith": [
     "vaughn",
     "brax",
     "lindon",
     "declan",
     "ares",
     "skye",
     "roman",
     "mary_cataldi",
     "liz",
     "nicole_human",
     "aphrodite",
     "ace"
    ]
   },
   {
    "channel": "misc-location",
    "passages": 2,
    "share": 0.0196,
    "first": "2020-05-05",
    "last": "2020-05-05",
    "kind": "route",
    "castWith": [
     "evelyn",
     "riku",
     "ares",
     "kiro",
     "hiro",
     "lex",
     "lance",
     "ezra",
     "lucius",
     "darren",
     "kaleb",
     "raye"
    ]
   },
   {
    "channel": "Lindon + Ford",
    "passages": 2,
    "share": 0.0196,
    "first": "2026-05-28",
    "last": "2026-05-28",
    "kind": "route",
    "castWith": [
     "ford",
     "lindon",
     "tim",
     "dante",
     "felix_fairy",
     "nicole_human",
     "park",
     "nicole_wolf",
     "nicole_sg3",
     "may",
     "will",
     "ezra"
    ]
   },
   {
    "channel": "lets-abduct-evie",
    "passages": 1,
    "share": 0.0098,
    "first": "2021-06-14",
    "last": "2021-06-14",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "ryoto",
     "dodge",
     "ms_tia",
     "kaleb",
     "frau",
     "aki",
     "cruz",
     "talbot",
     "ares",
     "zeus"
    ]
   },
   {
    "channel": "unknown-soulmate",
    "passages": 1,
    "share": 0.0098,
    "first": "2025-07-03",
    "last": "2025-07-03",
    "kind": "route",
    "castWith": [
     "brax",
     "vaughn",
     "vanessa",
     "lindon",
     "nicole_human",
     "moros",
     "ares",
     "god"
    ]
   },
   {
    "channel": "kinley-is-a-nondecisive-butt",
    "passages": 1,
    "share": 0.0098,
    "first": "2022-03-29",
    "last": "2022-03-29",
    "kind": "route",
    "castWith": [
     "zain_demigod",
     "kinley",
     "apollo",
     "lex",
     "cupid_eros",
     "hera",
     "lachesis",
     "sebastian_vamp",
     "sebastian_siren",
     "god",
     "will",
     "zeus"
    ]
   },
   {
    "channel": "eat-speak-rp-repeat",
    "passages": 1,
    "share": 0.0098,
    "first": "2026-03-11",
    "last": "2026-03-11",
    "kind": "ooc",
    "castWith": [
     "eric",
     "cruz",
     "lindon",
     "april",
     "lance",
     "felix_fairy",
     "brooke",
     "cyrus_fairy",
     "malakai",
     "god",
     "jack",
     "pam"
    ]
   },
   {
    "channel": "cupid-hq",
    "passages": 1,
    "share": 0.0098,
    "first": "2020-06-04",
    "last": "2020-06-04",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "sabrina_witch",
     "tim",
     "drake",
     "halo",
     "god",
     "aphrodite",
     "pam",
     "stan",
     "tom",
     "hiro",
     "ares"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 1,
    "share": 0.0098,
    "first": "2020-05-26",
    "last": "2020-05-26",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   }
  ],
  "knownCharacters": [
   "lindon",
   "brax",
   "vaughn",
   "nicole_human",
   "ezra",
   "will",
   "nicole_wolf",
   "nicole_sg3",
   "ace"
  ]
 },
 "bion": {
  "canonRoute": "mt-olympus",
  "totalPassages": 38,
  "routes": [
   {
    "channel": "mt-olympus",
    "passages": 17,
    "share": 0.4474,
    "first": "2020-03-29",
    "last": "2020-03-30",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "libion",
     "ares",
     "rex",
     "persephone",
     "hades",
     "aphrodite",
     "hercules",
     "demeter",
     "zeus",
     "athena",
     "zerden"
    ]
   },
   {
    "channel": "heaven",
    "passages": 9,
    "share": 0.2368,
    "first": "2020-03-30",
    "last": "2020-03-30",
    "kind": "route",
    "castWith": [
     "evelyn",
     "libion",
     "cruz",
     "bryce",
     "hades",
     "persephone",
     "demeter",
     "god",
     "aphrodite",
     "apollo",
     "rika"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 6,
    "share": 0.1579,
    "first": "2020-03-29",
    "last": "2020-03-30",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika"
    ]
   },
   {
    "channel": "hades-palace",
    "passages": 5,
    "share": 0.1316,
    "first": "2020-03-29",
    "last": "2020-03-29",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hades",
     "libion",
     "cruz",
     "bryce",
     "persephone",
     "will",
     "hercules",
     "hermes",
     "god"
    ]
   },
   {
    "channel": "pack-cabin",
    "passages": 1,
    "share": 0.0263,
    "first": "2020-03-31",
    "last": "2020-03-31",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "kaleb",
     "bryce",
     "kya_sg3",
     "rika",
     "alistair",
     "ezra",
     "hades",
     "alistair_turayne",
     "ryder",
     "kya_sg1"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "libion",
   "ares",
   "rex",
   "persephone",
   "hades",
   "aphrodite",
   "hercules",
   "demeter",
   "zeus",
   "athena",
   "zerden"
  ]
 },
 "blair": {
  "canonRoute": "human-not-human",
  "totalPassages": 5,
  "routes": [
   {
    "channel": "human-not-human",
    "passages": 4,
    "share": 0.8,
    "first": "2022-10-17",
    "last": "2022-10-17",
    "kind": "canon",
    "castWith": [
     "dillon",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "sebastian_vamp",
     "drisella",
     "god",
     "madeline",
     "tanya",
     "topps",
     "starlet",
     "ever"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 1,
    "share": 0.2,
    "first": "2020-07-25",
    "last": "2020-07-25",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika"
    ]
   }
  ],
  "knownCharacters": [
   "dillon",
   "kya_sg3",
   "kya_sg1",
   "sebastian_siren",
   "sebastian_vamp",
   "drisella",
   "god",
   "madeline",
   "tanya",
   "topps",
   "starlet",
   "ever"
  ]
 },
 "bobby": {
  "canonRoute": "a-tricky-micah-cruz-route",
  "totalPassages": 5,
  "routes": [
   {
    "channel": "a-tricky-micah-cruz-route",
    "passages": 3,
    "share": 0.6,
    "first": "2023-09-03",
    "last": "2023-09-03",
    "kind": "canon",
    "castWith": [
     "eva",
     "shane",
     "ryder",
     "cruz",
     "micah",
     "trix",
     "allie",
     "evelyn",
     "roger",
     "audrey",
     "god",
     "bryce"
    ]
   },
   {
    "channel": "haley-finds-out-shes-cool-2",
    "passages": 1,
    "share": 0.2,
    "first": "2022-12-04",
    "last": "2022-12-04",
    "kind": "route",
    "castWith": [
     "moros",
     "atropos",
     "gracie",
     "haley_human",
     "jinko",
     "lance",
     "may",
     "lachesis",
     "athena",
     "clothos",
     "haley_wolf",
     "peter"
    ]
   },
   {
    "channel": "cruz-nicole-dollar-store",
    "passages": 1,
    "share": 0.2,
    "first": "2020-09-08",
    "last": "2020-09-08",
    "kind": "route",
    "castWith": [
     "cruz",
     "raz",
     "lance",
     "lachesis",
     "bryce",
     "nolan",
     "renee",
     "aphrodite",
     "clothos",
     "atropos",
     "nicole_wolf",
     "nicole_sg3"
    ]
   }
  ],
  "knownCharacters": [
   "eva",
   "shane",
   "ryder",
   "cruz",
   "micah",
   "trix",
   "allie",
   "evelyn",
   "roger",
   "audrey",
   "god",
   "bryce"
  ]
 },
 "boko": {
  "canonRoute": "parabus",
  "totalPassages": 26,
  "routes": [
   {
    "channel": "parabus",
    "passages": 14,
    "share": 0.5385,
    "first": "2020-06-03",
    "last": "2020-06-06",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "lucius",
     "rex",
     "rowan",
     "laito",
     "ryan",
     "stash",
     "raye",
     "mr_han_sr",
     "cruz",
     "kya_sg3",
     "kaleb"
    ]
   },
   {
    "channel": "bonfire",
    "passages": 10,
    "share": 0.3846,
    "first": "2020-06-05",
    "last": "2020-06-06",
    "kind": "route",
    "castWith": [
     "rex",
     "evelyn",
     "lucius",
     "rowan",
     "may",
     "stash"
    ]
   },
   {
    "channel": "bios",
    "passages": 1,
    "share": 0.0385,
    "first": "2020-06-05",
    "last": "2020-06-05",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "evelyn",
     "lucius",
     "athena",
     "bryce",
     "val",
     "hiro",
     "raz",
     "rex",
     "vanessa",
     "halo",
     "dalton"
    ]
   },
   {
    "channel": "teacher-dormitory",
    "passages": 1,
    "share": 0.0385,
    "first": "2020-06-08",
    "last": "2020-06-08",
    "kind": "route",
    "castWith": [
     "aaron",
     "kya_sg3",
     "evelyn",
     "kya_sg1",
     "rex",
     "sebastian_siren",
     "sebastian_vamp",
     "kaleb",
     "dimitri",
     "cupid_eros",
     "mr_han_sr"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "lucius",
   "rex",
   "rowan",
   "laito",
   "ryan",
   "stash",
   "raye",
   "mr_han_sr",
   "cruz",
   "kya_sg3",
   "kaleb"
  ]
 },
 "bryant_jones": {
  "canonRoute": "nicole-x-cruz",
  "totalPassages": 1,
  "routes": [
   {
    "channel": "nicole-x-cruz",
    "passages": 1,
    "share": 1.0,
    "first": "2020-08-29",
    "last": "2020-08-29",
    "kind": "canon",
    "castWith": [
     "otto",
     "cruz",
     "jones",
     "nicole_human",
     "duran",
     "sorsha",
     "kya_sg1",
     "lucifer",
     "nicole_wolf",
     "kya_sg3",
     "nicole_sg3",
     "christopher_donovan"
    ]
   }
  ],
  "knownCharacters": [
   "otto",
   "cruz",
   "jones",
   "nicole_human",
   "duran",
   "sorsha",
   "kya_sg1",
   "lucifer",
   "nicole_wolf",
   "kya_sg3",
   "nicole_sg3",
   "christopher_donovan"
  ]
 },
 "budd": {
  "canonRoute": "to-the-max",
  "totalPassages": 2,
  "routes": [
   {
    "channel": "to-the-max",
    "passages": 2,
    "share": 1.0,
    "first": "2023-05-28",
    "last": "2023-05-29",
    "kind": "canon",
    "castWith": [
     "maxen_bryers",
     "addison",
     "trace_renton",
     "kya_sg3",
     "kya_sg1",
     "rick",
     "evelyn",
     "beatrice",
     "dillon",
     "lore",
     "paula",
     "diana"
    ]
   }
  ],
  "knownCharacters": [
   "maxen_bryers",
   "addison",
   "trace_renton",
   "kya_sg3",
   "kya_sg1",
   "rick",
   "evelyn",
   "beatrice",
   "dillon",
   "lore",
   "paula",
   "diana"
  ]
 },
 "byron": {
  "canonRoute": "werewolf-dimitri",
  "totalPassages": 5,
  "routes": [
   {
    "channel": "werewolf-dimitri",
    "passages": 5,
    "share": 1.0,
    "first": "2021-10-28",
    "last": "2021-11-08",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "dimitri",
     "kaleb",
     "slater",
     "kya_sg3",
     "frau",
     "god",
     "lionel",
     "gambit",
     "uncle_khan",
     "kelli",
     "liera"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "dimitri",
   "kaleb",
   "slater",
   "kya_sg3",
   "frau",
   "god",
   "lionel",
   "gambit",
   "uncle_khan",
   "kelli",
   "liera"
  ]
 },
 "cailte": {
  "canonRoute": "the-kingdom-fallon",
  "totalPassages": 7,
  "routes": [
   {
    "channel": "the-kingdom-fallon",
    "passages": 7,
    "share": 1.0,
    "first": "2021-06-01",
    "last": "2021-06-04",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "eva",
     "rory",
     "raye",
     "fiadh",
     "ciarnan",
     "finn",
     "senan",
     "diarmund",
     "fiann",
     "goll",
     "kaleb"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "eva",
   "rory",
   "raye",
   "fiadh",
   "ciarnan",
   "finn",
   "senan",
   "diarmund",
   "fiann",
   "goll",
   "kaleb"
  ]
 },
 "cair": {
  "canonRoute": "new-fairy-route",
  "totalPassages": 19,
  "routes": [
   {
    "channel": "new-fairy-route",
    "passages": 19,
    "share": 1.0,
    "first": "2023-03-23",
    "last": "2023-04-05",
    "kind": "canon",
    "castWith": [
     "holt",
     "archie",
     "sabrina_witch",
     "kieran",
     "dutch",
     "claire",
     "atropos",
     "ever",
     "may"
    ]
   }
  ],
  "knownCharacters": [
   "holt",
   "archie",
   "sabrina_witch",
   "kieran",
   "dutch",
   "claire",
   "atropos",
   "ever",
   "may"
  ]
 },
 "callan": {
  "canonRoute": "kya-senior-year",
  "totalPassages": 181,
  "routes": [
   {
    "channel": "kya-senior-year",
    "passages": 149,
    "share": 0.8232,
    "first": "2021-06-24",
    "last": "2021-07-14",
    "kind": "canon",
    "castWith": [
     "ezra",
     "leiden",
     "melody",
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "raye",
     "tate",
     "sebastian_vamp",
     "dillon",
     "sebastian_siren",
     "evelyn"
    ]
   },
   {
    "channel": "kya-sold-off",
    "passages": 32,
    "share": 0.1768,
    "first": "2021-07-18",
    "last": "2021-08-08",
    "kind": "route",
    "castWith": [
     "leiden",
     "melody",
     "kya_sg3",
     "frank",
     "kya_sg1",
     "umu",
     "evelyn",
     "kaleb",
     "garrett",
     "god",
     "may",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "ezra",
   "leiden",
   "melody",
   "kya_sg3",
   "kaleb",
   "kya_sg1",
   "raye",
   "tate",
   "sebastian_vamp",
   "dillon",
   "sebastian_siren",
   "evelyn"
  ]
 },
 "camren": {
  "canonRoute": "mystery-do-over",
  "totalPassages": 3,
  "routes": [
   {
    "channel": "mystery-do-over",
    "passages": 3,
    "share": 1.0,
    "first": "2024-02-06",
    "last": "2024-02-06",
    "kind": "canon",
    "castWith": [
     "dillon",
     "kaleb",
     "york",
     "evelyn",
     "becca",
     "toren",
     "kya_sg3",
     "kya_sg1",
     "uncle_khan"
    ]
   }
  ],
  "knownCharacters": [
   "dillon",
   "kaleb",
   "york",
   "evelyn",
   "becca",
   "toren",
   "kya_sg3",
   "kya_sg1",
   "uncle_khan"
  ]
 },
 "caria": {
  "canonRoute": "kingdom-of-wellis",
  "totalPassages": 44,
  "routes": [
   {
    "channel": "kingdom-of-wellis",
    "passages": 25,
    "share": 0.5682,
    "first": "2020-06-01",
    "last": "2020-06-02",
    "kind": "canon",
    "castWith": [
     "aria",
     "bennett",
     "benji",
     "ajax",
     "ever",
     "ben",
     "solum"
    ]
   },
   {
    "channel": "kingdom-of-welis",
    "passages": 13,
    "share": 0.2955,
    "first": "2020-04-13",
    "last": "2020-04-13",
    "kind": "route",
    "castWith": [
     "aria",
     "ajax",
     "batiuba",
     "ragland",
     "kent",
     "will"
    ]
   },
   {
    "channel": "kingdom-of-temprum",
    "passages": 4,
    "share": 0.0909,
    "first": "2020-05-22",
    "last": "2020-05-28",
    "kind": "route",
    "castWith": [
     "aria",
     "bennett",
     "benji",
     "ajax",
     "naveed",
     "fawn",
     "bast",
     "solum",
     "neitl",
     "batiuba",
     "will",
     "kaleb"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 2,
    "share": 0.0455,
    "first": "2020-04-13",
    "last": "2020-05-21",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   }
  ],
  "knownCharacters": [
   "aria",
   "bennett",
   "benji",
   "ajax",
   "ever",
   "ben",
   "solum"
  ]
 },
 "caroline": {
  "canonRoute": "haley-nolan",
  "totalPassages": 24,
  "routes": [
   {
    "channel": "haley-nolan",
    "passages": 23,
    "share": 0.9583,
    "first": "2020-09-14",
    "last": "2020-09-17",
    "kind": "canon",
    "castWith": [
     "nolan",
     "charlie",
     "alistair",
     "alistair_turayne",
     "alyce_char",
     "ryder",
     "cruz",
     "moros",
     "lachesis",
     "renee",
     "clothos",
     "audrey"
    ]
   },
   {
    "channel": "human-evie",
    "passages": 1,
    "share": 0.0417,
    "first": "2021-02-26",
    "last": "2021-02-26",
    "kind": "route",
    "castWith": [
     "evelyn",
     "kaleb",
     "frau",
     "cruz",
     "mr_han_sr",
     "audrey",
     "richard_antore",
     "diana",
     "ares",
     "quincy_antore",
     "nereda",
     "elizabeth_the_third"
    ]
   }
  ],
  "knownCharacters": [
   "nolan",
   "charlie",
   "alistair",
   "alistair_turayne",
   "alyce_char",
   "ryder",
   "cruz",
   "moros",
   "lachesis",
   "renee",
   "clothos",
   "audrey"
  ]
 },
 "celestine": {
  "canonRoute": "i-cant-ride-this-river",
  "totalPassages": 9,
  "routes": [
   {
    "channel": "i-cant-ride-this-river",
    "passages": 5,
    "share": 0.5556,
    "first": "2023-06-06",
    "last": "2023-06-19",
    "kind": "canon",
    "castWith": [
     "haley_human",
     "nicole_human",
     "ever",
     "god",
     "may",
     "zeus"
    ]
   },
   {
    "channel": "50-shades-of-ezra",
    "passages": 3,
    "share": 0.3333,
    "first": "2021-09-30",
    "last": "2021-09-30",
    "kind": "route",
    "castWith": [
     "ezra",
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "dillon",
     "evelyn",
     "sebastian_vamp",
     "sebastian_siren",
     "primrose",
     "uncle_khan",
     "alistair",
     "raye"
    ]
   },
   {
    "channel": "Brax + Vaughn 4/3/26",
    "passages": 1,
    "share": 0.1111,
    "first": "2026-04-03",
    "last": "2026-04-03",
    "kind": "route",
    "castWith": [
     "brax",
     "vaughn",
     "ever"
    ]
   }
  ],
  "knownCharacters": [
   "haley_human",
   "nicole_human",
   "ever",
   "god",
   "may",
   "zeus"
  ]
 },
 "celine": {
  "canonRoute": "bryces-quarters",
  "totalPassages": 7,
  "routes": [
   {
    "channel": "bryces-quarters",
    "passages": 7,
    "share": 1.0,
    "first": "2020-04-06",
    "last": "2020-04-06",
    "kind": "canon",
    "castWith": [
     "bryce",
     "evelyn",
     "frau",
     "geo",
     "rio",
     "ezra",
     "raye",
     "god",
     "mr_han_sr"
    ]
   }
  ],
  "knownCharacters": [
   "bryce",
   "evelyn",
   "frau",
   "geo",
   "rio",
   "ezra",
   "raye",
   "god",
   "mr_han_sr"
  ]
 },
 "charlie": {
  "canonRoute": "haley-nolan",
  "totalPassages": 51,
  "routes": [
   {
    "channel": "haley-nolan",
    "passages": 46,
    "share": 0.902,
    "first": "2020-09-14",
    "last": "2020-09-17",
    "kind": "canon",
    "castWith": [
     "nolan",
     "alistair",
     "alistair_turayne",
     "caroline",
     "alyce_char",
     "ryder",
     "cruz",
     "moros",
     "lachesis",
     "renee",
     "clothos",
     "audrey"
    ]
   },
   {
    "channel": "cruz-nicole-dollar-store",
    "passages": 1,
    "share": 0.0196,
    "first": "2020-09-16",
    "last": "2020-09-16",
    "kind": "route",
    "castWith": [
     "cruz",
     "raz",
     "lance",
     "lachesis",
     "bryce",
     "nolan",
     "renee",
     "aphrodite",
     "clothos",
     "atropos",
     "nicole_wolf",
     "nicole_sg3"
    ]
   },
   {
    "channel": "haleys-wish",
    "passages": 1,
    "share": 0.0196,
    "first": "2023-04-26",
    "last": "2023-04-26",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "evelyn",
     "sebastian_siren",
     "kya_sg1",
     "sebastian_vamp",
     "haley_human",
     "polly",
     "cruz",
     "dimitri",
     "haley_wolf",
     "haley_sg3",
     "skipper"
    ]
   },
   {
    "channel": "eat-speak-rp-repeat",
    "passages": 1,
    "share": 0.0196,
    "first": "2026-03-29",
    "last": "2026-03-29",
    "kind": "ooc",
    "castWith": [
     "eric",
     "cruz",
     "lindon",
     "april",
     "lance",
     "felix_fairy",
     "brooke",
     "cyrus_fairy",
     "malakai",
     "god",
     "jack",
     "pam"
    ]
   },
   {
    "channel": "ooc",
    "passages": 1,
    "share": 0.0196,
    "first": "2020-12-19",
    "last": "2020-12-19",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 1,
    "share": 0.0196,
    "first": "2016-09-11",
    "last": "2016-09-11",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika"
    ]
   }
  ],
  "knownCharacters": [
   "nolan",
   "alistair",
   "alistair_turayne",
   "caroline",
   "alyce_char",
   "ryder",
   "cruz",
   "moros",
   "lachesis",
   "renee",
   "clothos",
   "audrey"
  ]
 },
 "chiara": {
  "canonRoute": "evelyn-college-2",
  "totalPassages": 14,
  "routes": [
   {
    "channel": "evelyn-college-2",
    "passages": 10,
    "share": 0.7143,
    "first": "2021-01-29",
    "last": "2021-01-29",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "darren",
     "dimitri",
     "lex",
     "hades",
     "raye",
     "jon",
     "ares",
     "kaleb",
     "cruz",
     "kya_sg3",
     "ari"
    ]
   },
   {
    "channel": "lance-decides",
    "passages": 3,
    "share": 0.2143,
    "first": "2024-12-16",
    "last": "2024-12-17",
    "kind": "route",
    "castWith": [
     "lance",
     "rin",
     "lucifer",
     "lachesis",
     "nicole_human",
     "god",
     "cupid_eros",
     "roman",
     "asrius",
     "hera",
     "zeus",
     "aphrodite"
    ]
   },
   {
    "channel": "human-not-human",
    "passages": 1,
    "share": 0.0714,
    "first": "2022-10-16",
    "last": "2022-10-16",
    "kind": "route",
    "castWith": [
     "dillon",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "sebastian_vamp",
     "drisella",
     "god",
     "blair",
     "madeline",
     "tanya",
     "topps",
     "starlet"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "darren",
   "dimitri",
   "lex",
   "hades",
   "raye",
   "jon",
   "ares",
   "kaleb",
   "cruz",
   "kya_sg3",
   "ari"
  ]
 },
 "christopher_donovan": {
  "canonRoute": "nicole-x-cruz",
  "totalPassages": 4,
  "routes": [
   {
    "channel": "nicole-x-cruz",
    "passages": 4,
    "share": 1.0,
    "first": "2020-08-29",
    "last": "2020-08-29",
    "kind": "canon",
    "castWith": [
     "otto",
     "cruz",
     "jones",
     "nicole_human",
     "duran",
     "sorsha",
     "kya_sg1",
     "lucifer",
     "nicole_wolf",
     "kya_sg3",
     "nicole_sg3",
     "jonathan_donovan"
    ]
   }
  ],
  "knownCharacters": [
   "otto",
   "cruz",
   "jones",
   "nicole_human",
   "duran",
   "sorsha",
   "kya_sg1",
   "lucifer",
   "nicole_wolf",
   "kya_sg3",
   "nicole_sg3",
   "jonathan_donovan"
  ]
 },
 "ciarnan": {
  "canonRoute": "the-kingdom-fallon",
  "totalPassages": 10,
  "routes": [
   {
    "channel": "the-kingdom-fallon",
    "passages": 10,
    "share": 1.0,
    "first": "2021-05-28",
    "last": "2021-06-01",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "eva",
     "rory",
     "raye",
     "fiadh",
     "finn",
     "cailte",
     "senan",
     "diarmund",
     "fiann",
     "goll",
     "kaleb"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "eva",
   "rory",
   "raye",
   "fiadh",
   "finn",
   "cailte",
   "senan",
   "diarmund",
   "fiann",
   "goll",
   "kaleb"
  ]
 },
 "ciel": {
  "canonRoute": "an-accidentally-valerian-summer-with-cordelia",
  "totalPassages": 84,
  "routes": [
   {
    "channel": "an-accidentally-valerian-summer-with-cordelia",
    "passages": 84,
    "share": 1.0,
    "first": "2021-03-21",
    "last": "2021-05-17",
    "kind": "canon",
    "castWith": [
     "nolan",
     "lupe",
     "arsene",
     "delia",
     "dale",
     "jessica",
     "cruz",
     "clairette",
     "may",
     "tina",
     "cyrena",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "nolan",
   "lupe",
   "arsene",
   "delia",
   "dale",
   "jessica",
   "cruz",
   "clairette",
   "may",
   "tina",
   "cyrena",
   "will"
  ]
 },
 "clairette": {
  "canonRoute": "an-accidentally-valerian-summer-with-cordelia",
  "totalPassages": 6,
  "routes": [
   {
    "channel": "an-accidentally-valerian-summer-with-cordelia",
    "passages": 6,
    "share": 1.0,
    "first": "2021-03-12",
    "last": "2021-04-07",
    "kind": "canon",
    "castWith": [
     "ciel",
     "nolan",
     "lupe",
     "arsene",
     "delia",
     "dale",
     "jessica",
     "cruz",
     "may",
     "tina",
     "cyrena",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "ciel",
   "nolan",
   "lupe",
   "arsene",
   "delia",
   "dale",
   "jessica",
   "cruz",
   "may",
   "tina",
   "cyrena",
   "will"
  ]
 },
 "clint": {
  "canonRoute": "cruz-is-not-dead",
  "totalPassages": 11,
  "routes": [
   {
    "channel": "cruz-is-not-dead",
    "passages": 10,
    "share": 0.9091,
    "first": "2022-04-14",
    "last": "2022-04-23",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "cruz",
     "ford",
     "ryder",
     "lucifer",
     "bryce",
     "audrey",
     "apollo",
     "ares",
     "god",
     "hades",
     "nolan"
    ]
   },
   {
    "channel": "tyrant-evie",
    "passages": 1,
    "share": 0.0909,
    "first": "2021-12-30",
    "last": "2021-12-30",
    "kind": "route",
    "castWith": [
     "evelyn",
     "bryce",
     "cruz",
     "myra",
     "ares",
     "hermes",
     "rio",
     "hades",
     "frau",
     "zeus",
     "nolan",
     "audrey"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "cruz",
   "ford",
   "ryder",
   "lucifer",
   "bryce",
   "audrey",
   "apollo",
   "ares",
   "god",
   "hades",
   "nolan"
  ]
 },
 "clothos": {
  "canonRoute": "lance-mating",
  "totalPassages": 285,
  "routes": [
   {
    "channel": "switched-roles-lachesis",
    "passages": 75,
    "share": 0.2632,
    "first": "2023-10-09",
    "last": "2023-11-17",
    "kind": "au",
    "castWith": [
     "lachesis",
     "ford",
     "god",
     "lucifer",
     "cruz",
     "atropos",
     "rowan",
     "vaughn",
     "ryder",
     "brax",
     "dimitri",
     "ramiel"
    ]
   },
   {
    "channel": "lance-mating",
    "passages": 45,
    "share": 0.1579,
    "first": "2021-08-20",
    "last": "2021-08-30",
    "kind": "canon",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "ryder",
     "hades",
     "nolan",
     "nicole_human",
     "audrey",
     "moros",
     "atropos",
     "nicole_wolf",
     "nicole_sg3"
    ]
   },
   {
    "channel": "fordsplosion",
    "passages": 26,
    "share": 0.0912,
    "first": "2024-02-09",
    "last": "2024-02-14",
    "kind": "route",
    "castWith": [
     "ford",
     "lachesis",
     "lucifer",
     "cruz",
     "ryder",
     "god",
     "asrius",
     "ethan",
     "eva",
     "atropos",
     "may",
     "evelyn"
    ]
   },
   {
    "channel": "lachesis-reincarnated",
    "passages": 16,
    "share": 0.0561,
    "first": "2022-06-11",
    "last": "2022-07-02",
    "kind": "route",
    "castWith": [
     "lance",
     "alyk",
     "lachesis",
     "haley_wolf",
     "demeter",
     "moros",
     "haley_human",
     "nicole_human",
     "atropos",
     "cruz",
     "apollo",
     "arthur_turayne"
    ]
   },
   {
    "channel": "cruz-nicole-dollar-store",
    "passages": 16,
    "share": 0.0561,
    "first": "2020-09-12",
    "last": "2020-09-21",
    "kind": "route",
    "castWith": [
     "cruz",
     "raz",
     "lance",
     "lachesis",
     "bryce",
     "nolan",
     "renee",
     "aphrodite",
     "atropos",
     "nicole_wolf",
     "nicole_sg3",
     "moros"
    ]
   },
   {
    "channel": "nicolexcruz-true-mates",
    "passages": 12,
    "share": 0.0421,
    "first": "2024-03-25",
    "last": "2024-04-08",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "nolan",
     "trix",
     "diana",
     "nicole_human",
     "audrey",
     "asrius",
     "lucifer",
     "atropos",
     "bryce"
    ]
   },
   {
    "channel": "lance-origin-route",
    "passages": 11,
    "share": 0.0386,
    "first": "2021-05-19",
    "last": "2021-05-24",
    "kind": "route",
    "castWith": [
     "lance",
     "lachesis",
     "nicole_human",
     "ryder",
     "moros",
     "atropos",
     "god",
     "nicole_wolf",
     "nicole_sg3",
     "hades",
     "haley_human",
     "cruz"
    ]
   },
   {
    "channel": "haley-nolan",
    "passages": 10,
    "share": 0.0351,
    "first": "2020-09-15",
    "last": "2020-09-17",
    "kind": "route",
    "castWith": [
     "nolan",
     "charlie",
     "alistair",
     "alistair_turayne",
     "caroline",
     "alyce_char",
     "ryder",
     "cruz",
     "moros",
     "lachesis",
     "renee",
     "audrey"
    ]
   },
   {
    "channel": "atropos-in-hell",
    "passages": 10,
    "share": 0.0351,
    "first": "2021-05-27",
    "last": "2021-06-04",
    "kind": "route",
    "castWith": [
     "lucifer",
     "atropos",
     "moros",
     "lachesis",
     "haley_wolf",
     "god",
     "gabriel",
     "lance",
     "hades",
     "mary_cataldi",
     "haley_human",
     "cupid_eros"
    ]
   },
   {
    "channel": "chance-route-ft-lance",
    "passages": 9,
    "share": 0.0316,
    "first": "2021-09-27",
    "last": "2021-10-17",
    "kind": "route",
    "castWith": [
     "lachesis",
     "chance",
     "lance",
     "god",
     "aphrodite",
     "atropos",
     "zeus",
     "moros",
     "ares",
     "hades",
     "may",
     "will"
    ]
   },
   {
    "channel": "yandere-cruz",
    "passages": 9,
    "share": 0.0316,
    "first": "2022-10-29",
    "last": "2022-10-29",
    "kind": "route",
    "castWith": [
     "lance",
     "cruz",
     "evelyn",
     "moros",
     "ares",
     "alyce_char",
     "atropos",
     "dimitri",
     "lachesis",
     "cupid_eros",
     "hades",
     "diana"
    ]
   },
   {
    "channel": "plz-love-lachesis",
    "passages": 7,
    "share": 0.0246,
    "first": "2022-11-12",
    "last": "2022-11-22",
    "kind": "route",
    "castWith": [
     "lachesis",
     "ramiel",
     "lance",
     "god",
     "lucifer",
     "apollo",
     "levi",
     "aion",
     "atropos",
     "zeus",
     "zadkiel",
     "asrius"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "lance",
   "lachesis",
   "ryder",
   "hades",
   "nolan",
   "nicole_human",
   "audrey",
   "moros",
   "atropos",
   "nicole_wolf",
   "nicole_sg3"
  ]
 },
 "collin_keller": {
  "canonRoute": "frau-collin",
  "totalPassages": 74,
  "routes": [
   {
    "channel": "frau-collin",
    "passages": 72,
    "share": 0.973,
    "first": "2020-12-02",
    "last": "2020-12-26",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "cruz",
     "rowan",
     "frau",
     "arland_rees",
     "ezra",
     "felix_fairy",
     "rikki",
     "park",
     "alyce_char",
     "myra",
     "allie"
    ]
   },
   {
    "channel": "ooc",
    "passages": 2,
    "share": 0.027,
    "first": "2020-12-03",
    "last": "2020-12-27",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "cruz",
   "rowan",
   "frau",
   "arland_rees",
   "ezra",
   "felix_fairy",
   "rikki",
   "park",
   "alyce_char",
   "myra",
   "allie"
  ]
 },
 "conan": {
  "canonRoute": null,
  "routes": [],
  "knownCharacters": [],
  "totalPassages": 0
 },
 "cooper": {
  "canonRoute": "cruz-x-nicole",
  "totalPassages": 2,
  "routes": [
   {
    "channel": "cruz-x-nicole",
    "passages": 2,
    "share": 1.0,
    "first": "2020-08-02",
    "last": "2020-08-02",
    "kind": "canon",
    "castWith": [
     "cruz",
     "lance",
     "hermes",
     "audrey",
     "peter",
     "ares",
     "nicole_wolf",
     "nicole_sg3",
     "alyce_char",
     "red",
     "trix",
     "nicole_human"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "lance",
   "hermes",
   "audrey",
   "peter",
   "ares",
   "nicole_wolf",
   "nicole_sg3",
   "alyce_char",
   "red",
   "trix",
   "nicole_human"
  ]
 },
 "crom": {
  "canonRoute": "wizards-chamber",
  "totalPassages": 52,
  "routes": [
   {
    "channel": "wizards-chamber",
    "passages": 25,
    "share": 0.4808,
    "first": "2020-04-28",
    "last": "2020-04-29",
    "kind": "canon",
    "castWith": [
     "ezra",
     "kya_sg3",
     "kya_sg1",
     "jane",
     "kris",
     "primrose",
     "kyo",
     "polly",
     "will"
    ]
   },
   {
    "channel": "hot-boi-arena-cruz",
    "passages": 12,
    "share": 0.2308,
    "first": "2022-06-05",
    "last": "2022-06-10",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "frau",
     "lyden",
     "ezra",
     "junta",
     "alyce_char",
     "ryder",
     "may",
     "rowan",
     "ares",
     "hades"
    ]
   },
   {
    "channel": "aquarium",
    "passages": 7,
    "share": 0.1346,
    "first": "2020-04-29",
    "last": "2020-04-29",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "ezra",
     "kya_sg1",
     "polly",
     "sebastian_vamp",
     "skipper",
     "sebastian_siren",
     "lira",
     "kyo",
     "evelyn",
     "kaleb",
     "kris"
    ]
   },
   {
    "channel": "kinley-reset-route",
    "passages": 4,
    "share": 0.0769,
    "first": "2022-02-24",
    "last": "2022-02-24",
    "kind": "route",
    "castWith": [
     "kinley",
     "lander",
     "shadow",
     "tate",
     "aaron",
     "raye",
     "zain_demigod",
     "natalia",
     "apollo",
     "god",
     "jova",
     "aphrodite"
    ]
   },
   {
    "channel": "flirty-sebastian-immortuos",
    "passages": 3,
    "share": 0.0577,
    "first": "2021-12-20",
    "last": "2021-12-21",
    "kind": "route",
    "castWith": [
     "amelda",
     "sebastian_vamp",
     "kya_sg3",
     "sebastian_siren",
     "kya_sg1",
     "aurelia",
     "may",
     "val",
     "kaleb",
     "james",
     "dillon"
    ]
   },
   {
    "channel": "ooc",
    "passages": 1,
    "share": 0.0192,
    "first": "2020-04-28",
    "last": "2020-04-28",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   }
  ],
  "knownCharacters": [
   "ezra",
   "kya_sg3",
   "kya_sg1",
   "jane",
   "kris",
   "primrose",
   "kyo",
   "polly",
   "will"
  ]
 },
 "cyrena": {
  "canonRoute": "an-accidentally-valerian-summer-with-cordelia",
  "totalPassages": 5,
  "routes": [
   {
    "channel": "an-accidentally-valerian-summer-with-cordelia",
    "passages": 5,
    "share": 1.0,
    "first": "2021-03-12",
    "last": "2021-04-07",
    "kind": "canon",
    "castWith": [
     "ciel",
     "nolan",
     "lupe",
     "arsene",
     "delia",
     "dale",
     "jessica",
     "cruz",
     "clairette",
     "may",
     "tina",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "ciel",
   "nolan",
   "lupe",
   "arsene",
   "delia",
   "dale",
   "jessica",
   "cruz",
   "clairette",
   "may",
   "tina",
   "will"
  ]
 },
 "dale": {
  "canonRoute": "an-accidentally-valerian-summer-with-cordelia",
  "totalPassages": 11,
  "routes": [
   {
    "channel": "an-accidentally-valerian-summer-with-cordelia",
    "passages": 11,
    "share": 1.0,
    "first": "2021-04-23",
    "last": "2021-04-26",
    "kind": "canon",
    "castWith": [
     "ciel",
     "nolan",
     "lupe",
     "arsene",
     "delia",
     "jessica",
     "cruz",
     "clairette",
     "may",
     "tina",
     "cyrena",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "ciel",
   "nolan",
   "lupe",
   "arsene",
   "delia",
   "jessica",
   "cruz",
   "clairette",
   "may",
   "tina",
   "cyrena",
   "will"
  ]
 },
 "damien": {
  "canonRoute": "fall-fairies",
  "totalPassages": 75,
  "routes": [
   {
    "channel": "fall-fairies",
    "passages": 74,
    "share": 0.9867,
    "first": "2021-10-25",
    "last": "2021-11-16",
    "kind": "canon",
    "castWith": [
     "matare",
     "autumn",
     "retin",
     "draven",
     "fayette",
     "sir_tyde",
     "may",
     "maleos",
     "silvia",
     "jaden",
     "will",
     "roman"
    ]
   },
   {
    "channel": "ooc",
    "passages": 1,
    "share": 0.0133,
    "first": "2020-04-26",
    "last": "2020-04-26",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   }
  ],
  "knownCharacters": [
   "matare",
   "autumn",
   "retin",
   "draven",
   "fayette",
   "sir_tyde",
   "may",
   "maleos",
   "silvia",
   "jaden",
   "will",
   "roman"
  ]
 },
 "danielle_donovan": {
  "canonRoute": "lachesis-reincarnated",
  "totalPassages": 4,
  "routes": [
   {
    "channel": "lachesis-reincarnated",
    "passages": 2,
    "share": 0.5,
    "first": "2022-06-11",
    "last": "2022-06-11",
    "kind": "canon",
    "castWith": [
     "lance",
     "alyk",
     "lachesis",
     "haley_wolf",
     "clothos",
     "demeter",
     "moros",
     "haley_human",
     "nicole_human",
     "atropos",
     "cruz",
     "apollo"
    ]
   },
   {
    "channel": "nicole-x-cruz",
    "passages": 2,
    "share": 0.5,
    "first": "2020-08-29",
    "last": "2020-08-29",
    "kind": "route",
    "castWith": [
     "otto",
     "cruz",
     "jones",
     "nicole_human",
     "duran",
     "sorsha",
     "kya_sg1",
     "lucifer",
     "nicole_wolf",
     "kya_sg3",
     "nicole_sg3",
     "christopher_donovan"
    ]
   }
  ],
  "knownCharacters": [
   "lance",
   "alyk",
   "lachesis",
   "haley_wolf",
   "clothos",
   "demeter",
   "moros",
   "haley_human",
   "nicole_human",
   "atropos",
   "cruz",
   "apollo"
  ]
 },
 "danica": {
  "canonRoute": null,
  "routes": [],
  "knownCharacters": [],
  "totalPassages": 0
 },
 "dante": {
  "canonRoute": "Lindon + Ford",
  "totalPassages": 90,
  "routes": [
   {
    "channel": "Lindon + Ford",
    "passages": 46,
    "share": 0.5111,
    "first": "2026-05-28",
    "last": "2026-06-01",
    "kind": "canon",
    "castWith": [
     "ford",
     "lindon",
     "tim",
     "felix_fairy",
     "nicole_human",
     "park",
     "nicole_wolf",
     "nicole_sg3",
     "ben",
     "may",
     "will",
     "ezra"
    ]
   },
   {
    "channel": "atropos-goes-to-second-hell",
    "passages": 20,
    "share": 0.2222,
    "first": "2022-07-02",
    "last": "2022-07-10",
    "kind": "route",
    "castWith": [
     "moros",
     "atropos",
     "lachesis",
     "ares",
     "clothos",
     "may",
     "aphrodite",
     "apollo",
     "hermes",
     "god"
    ]
   },
   {
    "channel": "atropos-reincarnated",
    "passages": 13,
    "share": 0.1444,
    "first": "2022-06-29",
    "last": "2022-07-01",
    "kind": "route",
    "castWith": [
     "moros",
     "apollo",
     "haley_wolf",
     "atropos",
     "zeus",
     "zephyr",
     "lachesis",
     "clothos",
     "aphrodite",
     "hera",
     "haley_human",
     "nicole_human"
    ]
   },
   {
    "channel": "RP - 6/2/2026",
    "passages": 11,
    "share": 0.1222,
    "first": "2026-06-03",
    "last": "2026-06-03",
    "kind": "route",
    "castWith": [
     "ford",
     "lindon"
    ]
   }
  ],
  "knownCharacters": [
   "ford",
   "lindon",
   "tim",
   "felix_fairy",
   "nicole_human",
   "park",
   "nicole_wolf",
   "nicole_sg3",
   "ben",
   "may",
   "will",
   "ezra"
  ]
 },
 "darius": {
  "canonRoute": "you-have-me-roman",
  "totalPassages": 55,
  "routes": [
   {
    "channel": "you-have-me-roman",
    "passages": 55,
    "share": 1.0,
    "first": "2022-11-11",
    "last": "2022-11-16",
    "kind": "canon",
    "castWith": [
     "titus",
     "roman",
     "kya_sg3",
     "dillon",
     "kya_sg1",
     "evelyn",
     "stellar",
     "easton",
     "deven",
     "will",
     "lachesis",
     "darren"
    ]
   }
  ],
  "knownCharacters": [
   "titus",
   "roman",
   "kya_sg3",
   "dillon",
   "kya_sg1",
   "evelyn",
   "stellar",
   "easton",
   "deven",
   "will",
   "lachesis",
   "darren"
  ]
 },
 "dash": {
  "canonRoute": "kyas-choice",
  "totalPassages": 8,
  "routes": [
   {
    "channel": "kyas-choice",
    "passages": 6,
    "share": 0.75,
    "first": "2022-05-15",
    "last": "2022-05-16",
    "kind": "canon",
    "castWith": [
     "taren",
     "kya_sg3",
     "keller",
     "gale",
     "kya_sg1",
     "atropos",
     "haley_human",
     "kaleb",
     "skipper",
     "summer",
     "will"
    ]
   },
   {
    "channel": "human-lachesis",
    "passages": 1,
    "share": 0.125,
    "first": "2024-10-29",
    "last": "2024-10-29",
    "kind": "route",
    "castWith": [
     "nicole_human",
     "brax",
     "lachesis",
     "lance",
     "vaughn",
     "rowan",
     "god",
     "alyce_char",
     "moros",
     "ford",
     "atropos",
     "cruz"
    ]
   },
   {
    "channel": "ooc",
    "passages": 1,
    "share": 0.125,
    "first": "2020-11-22",
    "last": "2020-11-22",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   }
  ],
  "knownCharacters": [
   "taren",
   "kya_sg3",
   "keller",
   "gale",
   "kya_sg1",
   "atropos",
   "haley_human",
   "kaleb",
   "skipper",
   "summer",
   "will"
  ]
 },
 "davidson": {
  "canonRoute": "cruz-x-nicole",
  "totalPassages": 1,
  "routes": [
   {
    "channel": "cruz-x-nicole",
    "passages": 1,
    "share": 1.0,
    "first": "2020-08-03",
    "last": "2020-08-03",
    "kind": "canon",
    "castWith": [
     "cruz",
     "lance",
     "hermes",
     "audrey",
     "peter",
     "ares",
     "nicole_wolf",
     "nicole_sg3",
     "alyce_char",
     "red",
     "trix",
     "nicole_human"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "lance",
   "hermes",
   "audrey",
   "peter",
   "ares",
   "nicole_wolf",
   "nicole_sg3",
   "alyce_char",
   "red",
   "trix",
   "nicole_human"
  ]
 },
 "delia": {
  "canonRoute": "an-accidentally-valerian-summer-with-cordelia",
  "totalPassages": 21,
  "routes": [
   {
    "channel": "an-accidentally-valerian-summer-with-cordelia",
    "passages": 21,
    "share": 1.0,
    "first": "2021-04-11",
    "last": "2021-04-26",
    "kind": "canon",
    "castWith": [
     "ciel",
     "nolan",
     "lupe",
     "arsene",
     "dale",
     "jessica",
     "cruz",
     "clairette",
     "may",
     "tina",
     "cyrena",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "ciel",
   "nolan",
   "lupe",
   "arsene",
   "dale",
   "jessica",
   "cruz",
   "clairette",
   "may",
   "tina",
   "cyrena",
   "will"
  ]
 },
 "demeter": {
  "canonRoute": "1-real-cruz",
  "totalPassages": 28,
  "routes": [
   {
    "channel": "1-real-cruz",
    "passages": 9,
    "share": 0.3214,
    "first": "2023-01-05",
    "last": "2023-01-14",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "ares",
     "lance",
     "selma",
     "zeus",
     "lindon",
     "hera",
     "ryder",
     "apollo",
     "nolan"
    ]
   },
   {
    "channel": "mt-olympus",
    "passages": 8,
    "share": 0.2857,
    "first": "2020-03-29",
    "last": "2020-06-27",
    "kind": "route",
    "castWith": [
     "evelyn",
     "libion",
     "ares",
     "rex",
     "persephone",
     "bion",
     "hades",
     "aphrodite",
     "hercules",
     "zeus",
     "athena",
     "zerden"
    ]
   },
   {
    "channel": "lachesis-reincarnated",
    "passages": 4,
    "share": 0.1429,
    "first": "2022-06-14",
    "last": "2022-06-14",
    "kind": "route",
    "castWith": [
     "lance",
     "alyk",
     "lachesis",
     "haley_wolf",
     "clothos",
     "moros",
     "haley_human",
     "nicole_human",
     "atropos",
     "cruz",
     "apollo",
     "arthur_turayne"
    ]
   },
   {
    "channel": "ocroute2-cruz-in-for-love",
    "passages": 2,
    "share": 0.0714,
    "first": "2022-02-06",
    "last": "2022-02-07",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "dimitri",
     "hades",
     "zeus",
     "hera",
     "aphrodite",
     "god",
     "bryce",
     "amanda",
     "lachesis",
     "hermes"
    ]
   },
   {
    "channel": "sabrinas-apartment",
    "passages": 2,
    "share": 0.0714,
    "first": "2020-06-06",
    "last": "2020-06-06",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "sabrina_witch",
     "aphrodite",
     "halo",
     "hiro",
     "ares",
     "athena",
     "god",
     "roman"
    ]
   },
   {
    "channel": "heaven",
    "passages": 2,
    "share": 0.0714,
    "first": "2020-03-28",
    "last": "2020-03-28",
    "kind": "route",
    "castWith": [
     "evelyn",
     "libion",
     "cruz",
     "bryce",
     "bion",
     "hades",
     "persephone",
     "god",
     "aphrodite",
     "apollo",
     "rika"
    ]
   },
   {
    "channel": "the-blacklight",
    "passages": 1,
    "share": 0.0357,
    "first": "2020-05-01",
    "last": "2020-05-01",
    "kind": "route",
    "castWith": [
     "evelyn",
     "darren",
     "lucius",
     "lacie",
     "kiro",
     "lex",
     "milo",
     "kya_sg3",
     "kya_sg1",
     "cruz",
     "rowan",
     "kaleb"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "cruz",
   "bryce",
   "ares",
   "lance",
   "selma",
   "zeus",
   "lindon",
   "hera",
   "ryder",
   "apollo",
   "nolan"
  ]
 },
 "deven": {
  "canonRoute": "you-have-me-roman",
  "totalPassages": 3,
  "routes": [
   {
    "channel": "you-have-me-roman",
    "passages": 3,
    "share": 1.0,
    "first": "2022-11-13",
    "last": "2022-11-13",
    "kind": "canon",
    "castWith": [
     "darius",
     "titus",
     "roman",
     "kya_sg3",
     "dillon",
     "kya_sg1",
     "evelyn",
     "stellar",
     "easton",
     "will",
     "lachesis",
     "darren"
    ]
   }
  ],
  "knownCharacters": [
   "darius",
   "titus",
   "roman",
   "kya_sg3",
   "dillon",
   "kya_sg1",
   "evelyn",
   "stellar",
   "easton",
   "will",
   "lachesis",
   "darren"
  ]
 },
 "diarmund": {
  "canonRoute": "the-kingdom-fallon",
  "totalPassages": 6,
  "routes": [
   {
    "channel": "the-kingdom-fallon",
    "passages": 6,
    "share": 1.0,
    "first": "2021-06-01",
    "last": "2021-06-12",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "eva",
     "rory",
     "raye",
     "fiadh",
     "ciarnan",
     "finn",
     "cailte",
     "senan",
     "fiann",
     "goll",
     "kaleb"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "eva",
   "rory",
   "raye",
   "fiadh",
   "ciarnan",
   "finn",
   "cailte",
   "senan",
   "fiann",
   "goll",
   "kaleb"
  ]
 },
 "dike": {
  "canonRoute": "nevada",
  "totalPassages": 56,
  "routes": [
   {
    "channel": "nevada",
    "passages": 18,
    "share": 0.3214,
    "first": "2020-05-18",
    "last": "2020-05-20",
    "kind": "canon",
    "castWith": [
     "hiro",
     "evelyn",
     "darren",
     "cupid_eros",
     "apollo",
     "ares",
     "hades",
     "will",
     "athena",
     "lucius",
     "god",
     "zeus"
    ]
   },
   {
    "channel": "mount-olympus",
    "passages": 12,
    "share": 0.2143,
    "first": "2020-06-06",
    "last": "2020-06-07",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "sabrina_witch",
     "hiro",
     "stella",
     "hades",
     "will"
    ]
   },
   {
    "channel": "ooc",
    "passages": 8,
    "share": 0.1429,
    "first": "2020-06-06",
    "last": "2020-06-07",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "school-gym",
    "passages": 5,
    "share": 0.0893,
    "first": "2020-06-09",
    "last": "2020-06-10",
    "kind": "route",
    "castWith": [
     "evelyn",
     "rex",
     "aaron",
     "diana",
     "milo",
     "kya_sg3",
     "kya_sg1",
     "roman",
     "frau",
     "dimitri",
     "sebastian_vamp",
     "raye"
    ]
   },
   {
    "channel": "dining-hall",
    "passages": 4,
    "share": 0.0714,
    "first": "2020-06-08",
    "last": "2020-06-08",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "bryce",
     "rex",
     "milo",
     "aaron",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "lex",
     "sebastian_vamp",
     "agnar"
    ]
   },
   {
    "channel": "auditorium",
    "passages": 3,
    "share": 0.0536,
    "first": "2020-06-08",
    "last": "2020-06-14",
    "kind": "route",
    "castWith": [
     "rex",
     "evelyn",
     "diana",
     "milo",
     "dimitri",
     "athena",
     "audrey",
     "saph",
     "bryce",
     "kaleb",
     "roman",
     "rio"
    ]
   },
   {
    "channel": "ocroute2-cruz-in-for-love",
    "passages": 2,
    "share": 0.0357,
    "first": "2022-02-03",
    "last": "2022-02-06",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "dimitri",
     "hades",
     "zeus",
     "hera",
     "aphrodite",
     "god",
     "bryce",
     "amanda",
     "lachesis",
     "hermes"
    ]
   },
   {
    "channel": "athena-class",
    "passages": 2,
    "share": 0.0357,
    "first": "2020-06-18",
    "last": "2020-06-18",
    "kind": "route",
    "castWith": [
     "rex",
     "evelyn",
     "kiro",
     "diana",
     "milo",
     "cupid_eros",
     "athena",
     "dimitri",
     "kya_sg1",
     "aaron",
     "kya_sg3",
     "hiro"
    ]
   },
   {
    "channel": "spam",
    "passages": 1,
    "share": 0.0179,
    "first": "2020-05-18",
    "last": "2020-05-18",
    "kind": "route",
    "castWith": [
     "cruz",
     "ezra",
     "ace",
     "hiro",
     "victor"
    ]
   },
   {
    "channel": "greek-house",
    "passages": 1,
    "share": 0.0179,
    "first": "2020-05-20",
    "last": "2020-05-20",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hiro",
     "darren",
     "lex",
     "kiro",
     "raye",
     "kya_sg3",
     "ares",
     "riku",
     "kya_sg1",
     "lacie",
     "aphrodite"
    ]
   }
  ],
  "knownCharacters": [
   "hiro",
   "evelyn",
   "darren",
   "cupid_eros",
   "apollo",
   "ares",
   "hades",
   "will",
   "athena",
   "lucius",
   "god",
   "zeus"
  ]
 },
 "dodge": {
  "canonRoute": "lets-abduct-evie",
  "totalPassages": 59,
  "routes": [
   {
    "channel": "lets-abduct-evie",
    "passages": 59,
    "share": 1.0,
    "first": "2021-06-14",
    "last": "2021-07-16",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "dimitri",
     "ryoto",
     "ms_tia",
     "kaleb",
     "frau",
     "aki",
     "cruz",
     "talbot",
     "ares",
     "zeus",
     "hera"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "dimitri",
   "ryoto",
   "ms_tia",
   "kaleb",
   "frau",
   "aki",
   "cruz",
   "talbot",
   "ares",
   "zeus",
   "hera"
  ]
 },
 "donal": {
  "canonRoute": "evelyn-college-2",
  "totalPassages": 10,
  "routes": [
   {
    "channel": "evelyn-college-2",
    "passages": 10,
    "share": 1.0,
    "first": "2021-01-01",
    "last": "2021-01-03",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "darren",
     "dimitri",
     "lex",
     "hades",
     "raye",
     "jon",
     "ares",
     "kaleb",
     "cruz",
     "kya_sg3",
     "ari"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "darren",
   "dimitri",
   "lex",
   "hades",
   "raye",
   "jon",
   "ares",
   "kaleb",
   "cruz",
   "kya_sg3",
   "ari"
  ]
 },
 "donnelly_macdonagh": {
  "canonRoute": "cutie-prince-dream",
  "totalPassages": 61,
  "routes": [
   {
    "channel": "cutie-prince-dream",
    "passages": 61,
    "share": 1.0,
    "first": "2022-07-12",
    "last": "2022-08-05",
    "kind": "canon",
    "castWith": [
     "oliver_macdonagh",
     "sebastian_siren",
     "kya_sg3",
     "kya_sg1",
     "sebastian_vamp",
     "raz",
     "dillon",
     "kaleb",
     "may",
     "atropos",
     "val",
     "vanessa"
    ]
   }
  ],
  "knownCharacters": [
   "oliver_macdonagh",
   "sebastian_siren",
   "kya_sg3",
   "kya_sg1",
   "sebastian_vamp",
   "raz",
   "dillon",
   "kaleb",
   "may",
   "atropos",
   "val",
   "vanessa"
  ]
 },
 "drake": {
  "canonRoute": "cupid-hq",
  "totalPassages": 16,
  "routes": [
   {
    "channel": "cupid-hq",
    "passages": 11,
    "share": 0.6875,
    "first": "2020-06-03",
    "last": "2020-06-05",
    "kind": "canon",
    "castWith": [
     "cupid_eros",
     "sabrina_witch",
     "tim",
     "halo",
     "god",
     "aphrodite",
     "pam",
     "stan",
     "tom",
     "hiro",
     "ares",
     "hades"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 3,
    "share": 0.1875,
    "first": "2020-07-11",
    "last": "2020-07-11",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika"
    ]
   },
   {
    "channel": "ooc",
    "passages": 2,
    "share": 0.125,
    "first": "2020-06-04",
    "last": "2020-06-04",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   }
  ],
  "knownCharacters": [
   "cupid_eros",
   "sabrina_witch",
   "tim",
   "halo",
   "god",
   "aphrodite",
   "pam",
   "stan",
   "tom",
   "hiro",
   "ares",
   "hades"
  ]
 },
 "draven": {
  "canonRoute": "fall-fairies",
  "totalPassages": 18,
  "routes": [
   {
    "channel": "fall-fairies",
    "passages": 17,
    "share": 0.9444,
    "first": "2021-11-01",
    "last": "2021-11-08",
    "kind": "canon",
    "castWith": [
     "damien",
     "matare",
     "autumn",
     "retin",
     "fayette",
     "sir_tyde",
     "may",
     "maleos",
     "silvia",
     "jaden",
     "will",
     "roman"
    ]
   },
   {
    "channel": "Ford",
    "passages": 1,
    "share": 0.0556,
    "first": "2026-04-07",
    "last": "2026-04-07",
    "kind": "route",
    "castWith": [
     "ford",
     "cruz",
     "nicole_human",
     "trix",
     "nolan",
     "alyce_char",
     "ryder",
     "richard_antore",
     "bryce",
     "allie",
     "diana",
     "audrey"
    ]
   }
  ],
  "knownCharacters": [
   "damien",
   "matare",
   "autumn",
   "retin",
   "fayette",
   "sir_tyde",
   "may",
   "maleos",
   "silvia",
   "jaden",
   "will",
   "roman"
  ]
 },
 "drey": {
  "canonRoute": "haley-is-haley",
  "totalPassages": 3,
  "routes": [
   {
    "channel": "haley-is-haley",
    "passages": 3,
    "share": 1.0,
    "first": "2024-01-25",
    "last": "2024-01-26",
    "kind": "canon",
    "castWith": [
     "alva",
     "moros",
     "atropos",
     "nolan",
     "alyce_char",
     "haley_wolf",
     "lachesis",
     "ryder",
     "haley_sg3",
     "bryce",
     "apollo",
     "cruz"
    ]
   }
  ],
  "knownCharacters": [
   "alva",
   "moros",
   "atropos",
   "nolan",
   "alyce_char",
   "haley_wolf",
   "lachesis",
   "ryder",
   "haley_sg3",
   "bryce",
   "apollo",
   "cruz"
  ]
 },
 "drisella": {
  "canonRoute": "human-not-human",
  "totalPassages": 5,
  "routes": [
   {
    "channel": "human-not-human",
    "passages": 5,
    "share": 1.0,
    "first": "2022-10-17",
    "last": "2022-10-19",
    "kind": "canon",
    "castWith": [
     "dillon",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "sebastian_vamp",
     "god",
     "blair",
     "madeline",
     "tanya",
     "topps",
     "starlet",
     "ever"
    ]
   }
  ],
  "knownCharacters": [
   "dillon",
   "kya_sg3",
   "kya_sg1",
   "sebastian_siren",
   "sebastian_vamp",
   "god",
   "blair",
   "madeline",
   "tanya",
   "topps",
   "starlet",
   "ever"
  ]
 },
 "duran": {
  "canonRoute": "nicole-x-cruz",
  "totalPassages": 7,
  "routes": [
   {
    "channel": "nicole-x-cruz",
    "passages": 7,
    "share": 1.0,
    "first": "2020-09-07",
    "last": "2020-09-07",
    "kind": "canon",
    "castWith": [
     "otto",
     "cruz",
     "jones",
     "nicole_human",
     "sorsha",
     "kya_sg1",
     "lucifer",
     "nicole_wolf",
     "kya_sg3",
     "nicole_sg3",
     "christopher_donovan",
     "jonathan_donovan"
    ]
   }
  ],
  "knownCharacters": [
   "otto",
   "cruz",
   "jones",
   "nicole_human",
   "sorsha",
   "kya_sg1",
   "lucifer",
   "nicole_wolf",
   "kya_sg3",
   "nicole_sg3",
   "christopher_donovan",
   "jonathan_donovan"
  ]
 },
 "easton": {
  "canonRoute": "you-have-me-roman",
  "totalPassages": 4,
  "routes": [
   {
    "channel": "you-have-me-roman",
    "passages": 4,
    "share": 1.0,
    "first": "2022-11-08",
    "last": "2022-11-11",
    "kind": "canon",
    "castWith": [
     "darius",
     "titus",
     "roman",
     "kya_sg3",
     "dillon",
     "kya_sg1",
     "evelyn",
     "stellar",
     "deven",
     "will",
     "lachesis",
     "darren"
    ]
   }
  ],
  "knownCharacters": [
   "darius",
   "titus",
   "roman",
   "kya_sg3",
   "dillon",
   "kya_sg1",
   "evelyn",
   "stellar",
   "deven",
   "will",
   "lachesis",
   "darren"
  ]
 },
 "edward": {
  "canonRoute": "cruz-x-human",
  "totalPassages": 7,
  "routes": [
   {
    "channel": "ooc",
    "passages": 3,
    "share": 0.4286,
    "first": "2020-05-04",
    "last": "2020-05-04",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "cruz-x-human",
    "passages": 2,
    "share": 0.2857,
    "first": "2021-03-31",
    "last": "2021-04-01",
    "kind": "canon",
    "castWith": [
     "cruz",
     "skye",
     "nolan",
     "ryder",
     "audrey",
     "troy",
     "adrien",
     "bryce",
     "airi",
     "natasha",
     "diana",
     "will"
    ]
   },
   {
    "channel": "growing-up-ezra",
    "passages": 2,
    "share": 0.2857,
    "first": "2023-01-29",
    "last": "2023-01-30",
    "kind": "route",
    "castWith": [
     "ezra",
     "kya_sg3",
     "primrose",
     "dillon",
     "jane",
     "kya_sg1",
     "kaleb",
     "sebastian_vamp",
     "raye",
     "sebastian_siren",
     "ace",
     "uncle_khan"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "skye",
   "nolan",
   "ryder",
   "audrey",
   "troy",
   "adrien",
   "bryce",
   "airi",
   "natasha",
   "diana",
   "will"
  ]
 },
 "eli": {
  "canonRoute": "twins-princes-and-murder",
  "totalPassages": 60,
  "routes": [
   {
    "channel": "twins-princes-and-murder",
    "passages": 57,
    "share": 0.95,
    "first": "2023-02-11",
    "last": "2023-02-23",
    "kind": "canon",
    "castWith": [
     "hadrian",
     "kyo",
     "amoura",
     "amelda"
    ]
   },
   {
    "channel": "fae-courts",
    "passages": 2,
    "share": 0.0333,
    "first": "2024-10-07",
    "last": "2024-10-08",
    "kind": "route",
    "castWith": [
     "elias",
     "prince_andrew",
     "will",
     "ever",
     "frederick",
     "may"
    ]
   },
   {
    "channel": "3-haleys-hades-fanfic",
    "passages": 1,
    "share": 0.0167,
    "first": "2023-02-23",
    "last": "2023-02-23",
    "kind": "au",
    "castWith": [
     "hades",
     "kyo",
     "persephone",
     "amoura",
     "kya_sg3",
     "kya_sg1",
     "kaleb",
     "dillon",
     "apollo",
     "sebastian_vamp",
     "sebastian_siren",
     "god"
    ]
   }
  ],
  "knownCharacters": [
   "hadrian",
   "kyo",
   "amoura",
   "amelda"
  ]
 },
 "elias": {
  "canonRoute": "fae-courts",
  "totalPassages": 44,
  "routes": [
   {
    "channel": "fae-courts",
    "passages": 44,
    "share": 1.0,
    "first": "2024-10-04",
    "last": "2024-10-21",
    "kind": "canon",
    "castWith": [
     "prince_andrew",
     "will",
     "eli",
     "ever",
     "frederick",
     "may"
    ]
   }
  ],
  "knownCharacters": [
   "prince_andrew",
   "will",
   "eli",
   "ever",
   "frederick",
   "may"
  ]
 },
 "elizabeth_the_third": {
  "canonRoute": "mm_chatroom",
  "totalPassages": 55,
  "routes": [
   {
    "channel": "mm_chatroom",
    "passages": 12,
    "share": 0.2182,
    "first": "2016-09-08",
    "last": "2020-03-20",
    "kind": "canon",
    "castWith": [
     "kaleb",
     "evelyn",
     "rika",
     "mr_han_sr",
     "cruz",
     "god",
     "mr_clien",
     "bryce",
     "ever",
     "marie_antoinette",
     "tom"
    ]
   },
   {
    "channel": "c_and_r_building",
    "passages": 7,
    "share": 0.1273,
    "first": "2016-09-29",
    "last": "2016-09-30",
    "kind": "route",
    "castWith": [
     "kaleb",
     "mr_han_sr",
     "kya_sg3",
     "may"
    ]
   },
   {
    "channel": "jumins_apartment",
    "passages": 5,
    "share": 0.0909,
    "first": "2018-10-25",
    "last": "2020-03-25",
    "kind": "route",
    "castWith": [
     "kaleb",
     "mr_han_sr",
     "kya_sg3",
     "evelyn",
     "cruz"
    ]
   },
   {
    "channel": "road",
    "passages": 5,
    "share": 0.0909,
    "first": "2020-03-23",
    "last": "2020-03-23",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "kaleb",
     "dimitri",
     "kya_sg3",
     "mr_han_sr"
    ]
   },
   {
    "channel": "val",
    "passages": 4,
    "share": 0.0727,
    "first": "2020-11-04",
    "last": "2020-11-07",
    "kind": "route",
    "castWith": [
     "val",
     "kya_sg3",
     "kaleb",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "evelyn",
     "vanessa",
     "ezra",
     "raye",
     "alan",
     "tyrion"
    ]
   },
   {
    "channel": "chat",
    "passages": 4,
    "share": 0.0727,
    "first": "2020-04-14",
    "last": "2020-04-14",
    "kind": "route",
    "castWith": [
     "evelyn",
     "mr_han_sr",
     "kaleb",
     "ezra",
     "god",
     "ray"
    ]
   },
   {
    "channel": "human-evie",
    "passages": 3,
    "share": 0.0545,
    "first": "2020-10-21",
    "last": "2020-10-21",
    "kind": "route",
    "castWith": [
     "evelyn",
     "kaleb",
     "frau",
     "cruz",
     "mr_han_sr",
     "audrey",
     "richard_antore",
     "diana",
     "ares",
     "quincy_antore",
     "nereda",
     "ever"
    ]
   },
   {
    "channel": "meeting-room",
    "passages": 3,
    "share": 0.0545,
    "first": "2020-04-17",
    "last": "2020-04-17",
    "kind": "route",
    "castWith": [
     "kaleb",
     "ezra",
     "kya_sg3",
     "raye",
     "evelyn",
     "alistair_turayne",
     "alistair",
     "mr_han_sr",
     "kya_sg1",
     "thorne",
     "prince_zain",
     "sune"
    ]
   },
   {
    "channel": "phone_calls",
    "passages": 3,
    "share": 0.0545,
    "first": "2016-09-24",
    "last": "2016-09-24",
    "kind": "route",
    "castWith": [
     "kaleb",
     "evelyn",
     "ezra",
     "cruz",
     "raye",
     "bryce",
     "kya_sg3",
     "god",
     "rika"
    ]
   },
   {
    "channel": "ooc",
    "passages": 2,
    "share": 0.0364,
    "first": "2020-04-17",
    "last": "2020-11-05",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 2,
    "share": 0.0364,
    "first": "2016-09-17",
    "last": "2016-09-24",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika"
    ]
   },
   {
    "channel": "jaehee-apartment",
    "passages": 1,
    "share": 0.0182,
    "first": "2020-07-30",
    "last": "2020-07-30",
    "kind": "route",
    "castWith": [
     "evelyn",
     "kaleb",
     "ezra",
     "mr_han_sr",
     "kya_sg3",
     "kya_sg1",
     "ace",
     "alistair",
     "alistair_turayne"
    ]
   }
  ],
  "knownCharacters": [
   "kaleb",
   "evelyn",
   "rika",
   "mr_han_sr",
   "cruz",
   "god",
   "mr_clien",
   "bryce",
   "ever",
   "marie_antoinette",
   "tom"
  ]
 },
 "elodie": {
  "canonRoute": null,
  "routes": [],
  "knownCharacters": [],
  "totalPassages": 0
 },
 "emanuel": {
  "canonRoute": null,
  "totalPassages": 5,
  "routes": [
   {
    "channel": "switched-roles-kya",
    "passages": 5,
    "share": 1.0,
    "first": "2023-10-16",
    "last": "2023-10-16",
    "kind": "au",
    "castWith": [
     "diana",
     "kya_sg3",
     "raye",
     "ezra",
     "tate",
     "kya_sg1",
     "aphrodite",
     "alistair_turayne",
     "alistair",
     "kaleb",
     "cupid_eros",
     "emmanuel"
    ]
   }
  ],
  "knownCharacters": []
 },
 "emmanuel": {
  "canonRoute": null,
  "totalPassages": 2,
  "routes": [
   {
    "channel": "switched-roles-kya",
    "passages": 2,
    "share": 1.0,
    "first": "2023-10-16",
    "last": "2023-10-16",
    "kind": "au",
    "castWith": [
     "diana",
     "kya_sg3",
     "raye",
     "ezra",
     "tate",
     "emanuel",
     "kya_sg1",
     "aphrodite",
     "alistair_turayne",
     "alistair",
     "kaleb",
     "cupid_eros"
    ]
   }
  ],
  "knownCharacters": []
 },
 "emilia_satella": {
  "canonRoute": "kyas_penthouse",
  "totalPassages": 4,
  "routes": [
   {
    "channel": "ooc",
    "passages": 3,
    "share": 0.75,
    "first": "2020-05-09",
    "last": "2020-05-09",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "kyas_penthouse",
    "passages": 1,
    "share": 0.25,
    "first": "2016-09-14",
    "last": "2016-09-14",
    "kind": "canon",
    "castWith": [
     "kaleb",
     "evelyn",
     "raye",
     "ezra",
     "kya_sg3",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "mr_han_sr",
     "bryce",
     "god",
     "cruz"
    ]
   }
  ],
  "knownCharacters": [
   "kaleb",
   "evelyn",
   "raye",
   "ezra",
   "kya_sg3",
   "alistair",
   "alistair_turayne",
   "kya_sg1",
   "mr_han_sr",
   "bryce",
   "god",
   "cruz"
  ]
 },
 "eric": {
  "canonRoute": "Eric - 5/1/2026",
  "totalPassages": 196,
  "routes": [
   {
    "channel": "ooc",
    "passages": 69,
    "share": 0.352,
    "first": "2020-04-14",
    "last": "2020-12-25",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex",
     "agnar"
    ]
   },
   {
    "channel": "eat-speak-rp-repeat",
    "passages": 51,
    "share": 0.2602,
    "first": "2026-03-08",
    "last": "2026-04-03",
    "kind": "ooc",
    "castWith": [
     "cruz",
     "lindon",
     "april",
     "lance",
     "felix_fairy",
     "brooke",
     "cyrus_fairy",
     "malakai",
     "god",
     "jack",
     "pam",
     "ezra"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 26,
    "share": 0.1327,
    "first": "2020-03-21",
    "last": "2020-07-23",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika",
     "nolan"
    ]
   },
   {
    "channel": "general",
    "passages": 22,
    "share": 0.1122,
    "first": "2020-07-31",
    "last": "2020-08-29",
    "kind": "ooc",
    "castWith": [
     "ezra",
     "cruz",
     "james",
     "apollo",
     "lance",
     "aaron",
     "silas_mirace",
     "raye",
     "moros",
     "ace",
     "kaleb",
     "hermes"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 15,
    "share": 0.0765,
    "first": "2020-04-05",
    "last": "2020-06-01",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "the-restaurant-chat-channel",
    "passages": 6,
    "share": 0.0306,
    "first": "2024-06-11",
    "last": "2025-01-30",
    "kind": "ooc",
    "castWith": [
     "cruz",
     "brooke",
     "eva",
     "will",
     "evelyn",
     "shane",
     "micah",
     "god",
     "may"
    ]
   },
   {
    "channel": "wifey-chat",
    "passages": 2,
    "share": 0.0102,
    "first": "2020-07-12",
    "last": "2020-07-15",
    "kind": "ooc",
    "castWith": [
     "god",
     "bryce",
     "ever"
    ]
   },
   {
    "channel": "Eric - 5/1/2026",
    "passages": 2,
    "share": 0.0102,
    "first": "2026-05-01",
    "last": "2026-05-01",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "raye",
     "ezra",
     "kaleb",
     "uncle_khan"
    ]
   },
   {
    "channel": "secret-wifey-chat",
    "passages": 1,
    "share": 0.0051,
    "first": "2020-06-01",
    "last": "2020-06-01",
    "kind": "ooc",
    "castWith": []
   },
   {
    "channel": "kyas_penthouse",
    "passages": 1,
    "share": 0.0051,
    "first": "2016-09-10",
    "last": "2016-09-10",
    "kind": "route",
    "castWith": [
     "kaleb",
     "evelyn",
     "raye",
     "ezra",
     "kya_sg3",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "mr_han_sr",
     "bryce",
     "god",
     "cruz"
    ]
   },
   {
    "channel": "Haley - 5/2/2026",
    "passages": 1,
    "share": 0.0051,
    "first": "2026-05-02",
    "last": "2026-05-02",
    "kind": "route",
    "castWith": [
     "alistair",
     "sebastian_vamp",
     "val",
     "alistair_turayne"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "raye",
   "ezra",
   "kaleb",
   "uncle_khan"
  ]
 },
 "estella": {
  "canonRoute": "the-spa",
  "totalPassages": 5,
  "routes": [
   {
    "channel": "the-spa",
    "passages": 5,
    "share": 1.0,
    "first": "2020-04-05",
    "last": "2020-04-05",
    "kind": "canon",
    "castWith": [
     "rio",
     "geo",
     "evelyn",
     "bryce",
     "frau"
    ]
   }
  ],
  "knownCharacters": [
   "rio",
   "geo",
   "evelyn",
   "bryce",
   "frau"
  ]
 },
 "evan": {
  "canonRoute": "human-kieran",
  "totalPassages": 34,
  "routes": [
   {
    "channel": "human-kieran",
    "passages": 32,
    "share": 0.9412,
    "first": "2024-01-02",
    "last": "2024-01-09",
    "kind": "canon",
    "castWith": [
     "kieran",
     "peter",
     "raz",
     "mei",
     "gemma",
     "ms_tia",
     "will"
    ]
   },
   {
    "channel": "kierans-back",
    "passages": 2,
    "share": 0.0588,
    "first": "2025-03-13",
    "last": "2025-04-13",
    "kind": "route",
    "castWith": [
     "raz",
     "kieran",
     "peter",
     "may"
    ]
   }
  ],
  "knownCharacters": [
   "kieran",
   "peter",
   "raz",
   "mei",
   "gemma",
   "ms_tia",
   "will"
  ]
 },
 "exis": {
  "canonRoute": "ramesville",
  "totalPassages": 62,
  "routes": [
   {
    "channel": "ramesville",
    "passages": 28,
    "share": 0.4516,
    "first": "2020-04-11",
    "last": "2020-06-01",
    "kind": "canon",
    "castWith": [
     "stella",
     "talon_char",
     "ronin_tempus",
     "melisende",
     "raze",
     "satella",
     "dimitri",
     "vanessa",
     "raye",
     "raz",
     "will"
    ]
   },
   {
    "channel": "country-road-take-me-home",
    "passages": 11,
    "share": 0.1774,
    "first": "2020-04-12",
    "last": "2020-04-12",
    "kind": "route",
    "castWith": [
     "stella",
     "ronin_tempus",
     "talon_char",
     "melisende",
     "dimitri",
     "raze",
     "yuu",
     "god",
     "will"
    ]
   },
   {
    "channel": "abandoned-building",
    "passages": 10,
    "share": 0.1613,
    "first": "2020-04-13",
    "last": "2020-04-13",
    "kind": "route",
    "castWith": [
     "stella",
     "ronin_tempus",
     "satella",
     "talon_char",
     "melisende",
     "raze"
    ]
   },
   {
    "channel": "mages-tower",
    "passages": 8,
    "share": 0.129,
    "first": "2020-04-11",
    "last": "2020-04-11",
    "kind": "route",
    "castWith": [
     "stella",
     "talon_char",
     "melisende",
     "ronin_tempus"
    ]
   },
   {
    "channel": "ooc",
    "passages": 3,
    "share": 0.0484,
    "first": "2020-06-07",
    "last": "2020-06-07",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "troterra-kingdom",
    "passages": 1,
    "share": 0.0161,
    "first": "2020-06-01",
    "last": "2020-06-01",
    "kind": "route",
    "castWith": [
     "stella",
     "ronin_tempus",
     "raze",
     "talon_char",
     "melisende",
     "dimitri",
     "satella",
     "silas_mirace",
     "vincent",
     "god",
     "may",
     "mikaela_hyakuya"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 1,
    "share": 0.0161,
    "first": "2020-04-13",
    "last": "2020-04-13",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   }
  ],
  "knownCharacters": [
   "stella",
   "talon_char",
   "ronin_tempus",
   "melisende",
   "raze",
   "satella",
   "dimitri",
   "vanessa",
   "raye",
   "raz",
   "will"
  ]
 },
 "fawn": {
  "canonRoute": "kingdom-of-temprum",
  "totalPassages": 8,
  "routes": [
   {
    "channel": "kingdom-of-temprum",
    "passages": 7,
    "share": 0.875,
    "first": "2020-05-24",
    "last": "2020-05-24",
    "kind": "canon",
    "castWith": [
     "aria",
     "bennett",
     "benji",
     "ajax",
     "naveed",
     "bast",
     "solum",
     "caria",
     "neitl",
     "batiuba",
     "will",
     "kaleb"
    ]
   },
   {
    "channel": "nicole-x-cruz",
    "passages": 1,
    "share": 0.125,
    "first": "2020-09-04",
    "last": "2020-09-04",
    "kind": "route",
    "castWith": [
     "otto",
     "cruz",
     "jones",
     "nicole_human",
     "duran",
     "sorsha",
     "kya_sg1",
     "lucifer",
     "nicole_wolf",
     "kya_sg3",
     "nicole_sg3",
     "christopher_donovan"
    ]
   }
  ],
  "knownCharacters": [
   "aria",
   "bennett",
   "benji",
   "ajax",
   "naveed",
   "bast",
   "solum",
   "caria",
   "neitl",
   "batiuba",
   "will",
   "kaleb"
  ]
 },
 "fayette": {
  "canonRoute": "fall-fairies",
  "totalPassages": 13,
  "routes": [
   {
    "channel": "fall-fairies",
    "passages": 13,
    "share": 1.0,
    "first": "2021-11-14",
    "last": "2021-11-16",
    "kind": "canon",
    "castWith": [
     "damien",
     "matare",
     "autumn",
     "retin",
     "draven",
     "sir_tyde",
     "may",
     "maleos",
     "silvia",
     "jaden",
     "will",
     "roman"
    ]
   }
  ],
  "knownCharacters": [
   "damien",
   "matare",
   "autumn",
   "retin",
   "draven",
   "sir_tyde",
   "may",
   "maleos",
   "silvia",
   "jaden",
   "will",
   "roman"
  ]
 },
 "fez": {
  "canonRoute": "cruz-x-human",
  "totalPassages": 1,
  "routes": [
   {
    "channel": "cruz-x-human",
    "passages": 1,
    "share": 1.0,
    "first": "2021-05-02",
    "last": "2021-05-02",
    "kind": "canon",
    "castWith": [
     "cruz",
     "skye",
     "nolan",
     "ryder",
     "audrey",
     "troy",
     "adrien",
     "bryce",
     "airi",
     "natasha",
     "diana",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "skye",
   "nolan",
   "ryder",
   "audrey",
   "troy",
   "adrien",
   "bryce",
   "airi",
   "natasha",
   "diana",
   "will"
  ]
 },
 "fiadh": {
  "canonRoute": "the-kingdom-fallon",
  "totalPassages": 15,
  "routes": [
   {
    "channel": "the-kingdom-fallon",
    "passages": 15,
    "share": 1.0,
    "first": "2021-05-28",
    "last": "2021-06-01",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "eva",
     "rory",
     "raye",
     "ciarnan",
     "finn",
     "cailte",
     "senan",
     "diarmund",
     "fiann",
     "goll",
     "kaleb"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "eva",
   "rory",
   "raye",
   "ciarnan",
   "finn",
   "cailte",
   "senan",
   "diarmund",
   "fiann",
   "goll",
   "kaleb"
  ]
 },
 "fiann": {
  "canonRoute": "the-kingdom-fallon",
  "totalPassages": 5,
  "routes": [
   {
    "channel": "the-kingdom-fallon",
    "passages": 5,
    "share": 1.0,
    "first": "2021-06-01",
    "last": "2021-06-01",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "eva",
     "rory",
     "raye",
     "fiadh",
     "ciarnan",
     "finn",
     "cailte",
     "senan",
     "diarmund",
     "goll",
     "kaleb"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "eva",
   "rory",
   "raye",
   "fiadh",
   "ciarnan",
   "finn",
   "cailte",
   "senan",
   "diarmund",
   "goll",
   "kaleb"
  ]
 },
 "finn": {
  "canonRoute": "the-kingdom-fallon",
  "totalPassages": 9,
  "routes": [
   {
    "channel": "the-kingdom-fallon",
    "passages": 9,
    "share": 1.0,
    "first": "2021-06-01",
    "last": "2021-06-04",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "eva",
     "rory",
     "raye",
     "fiadh",
     "ciarnan",
     "cailte",
     "senan",
     "diarmund",
     "fiann",
     "goll",
     "kaleb"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "eva",
   "rory",
   "raye",
   "fiadh",
   "ciarnan",
   "cailte",
   "senan",
   "diarmund",
   "fiann",
   "goll",
   "kaleb"
  ]
 },
 "frank": {
  "canonRoute": "kya-sold-off",
  "totalPassages": 30,
  "routes": [
   {
    "channel": "kya-sold-off",
    "passages": 13,
    "share": 0.4333,
    "first": "2021-07-19",
    "last": "2021-07-29",
    "kind": "canon",
    "castWith": [
     "leiden",
     "melody",
     "callan",
     "kya_sg3",
     "kya_sg1",
     "umu",
     "evelyn",
     "kaleb",
     "garrett",
     "god",
     "may",
     "will"
    ]
   },
   {
    "channel": "kya-senior-year",
    "passages": 8,
    "share": 0.2667,
    "first": "2021-07-14",
    "last": "2021-07-14",
    "kind": "route",
    "castWith": [
     "callan",
     "ezra",
     "leiden",
     "melody",
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "raye",
     "tate",
     "sebastian_vamp",
     "dillon",
     "sebastian_siren"
    ]
   },
   {
    "channel": "theo-uoki-castle",
    "passages": 4,
    "share": 0.1333,
    "first": "2020-04-03",
    "last": "2020-04-03",
    "kind": "route",
    "castWith": [
     "stella",
     "theo_uoki",
     "raze",
     "melisende",
     "tom",
     "yuu",
     "silas_mirace",
     "vincent",
     "ronin_tempus"
    ]
   },
   {
    "channel": "indifference",
    "passages": 2,
    "share": 0.0667,
    "first": "2023-03-29",
    "last": "2023-03-29",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "alyce_char",
     "dimitri",
     "ryder",
     "rio",
     "ace",
     "moros",
     "geo",
     "nolan",
     "audrey"
    ]
   },
   {
    "channel": "ww-war-au",
    "passages": 1,
    "share": 0.0333,
    "first": "2021-12-02",
    "last": "2021-12-02",
    "kind": "au",
    "castWith": [
     "evelyn",
     "cruz",
     "ace",
     "ezra",
     "lindon",
     "kaleb",
     "rowan",
     "bryce",
     "lance",
     "raye",
     "nolan",
     "primrose"
    ]
   },
   {
    "channel": "heavenbound-missions",
    "passages": 1,
    "share": 0.0333,
    "first": "2025-10-22",
    "last": "2025-10-22",
    "kind": "route",
    "castWith": [
     "vaughn",
     "lindon",
     "god",
     "ares",
     "brax",
     "primrose",
     "aphrodite",
     "nicole_human",
     "nicole_wolf",
     "nicole_sg3",
     "beatrice",
     "will"
    ]
   },
   {
    "channel": "haleys-alistair-wish",
    "passages": 1,
    "share": 0.0333,
    "first": "2023-05-01",
    "last": "2023-05-01",
    "kind": "route",
    "castWith": [
     "ezra",
     "evelyn",
     "alistair_turayne",
     "alistair",
     "raye",
     "kaleb",
     "james",
     "dimitri",
     "haley_wolf",
     "haley_sg3",
     "uncle_khan",
     "haley_human"
    ]
   }
  ],
  "knownCharacters": [
   "leiden",
   "melody",
   "callan",
   "kya_sg3",
   "kya_sg1",
   "umu",
   "evelyn",
   "kaleb",
   "garrett",
   "god",
   "may",
   "will"
  ]
 },
 "frederick": {
  "canonRoute": "kierans-lives",
  "totalPassages": 14,
  "routes": [
   {
    "channel": "kierans-lives",
    "passages": 13,
    "share": 0.9286,
    "first": "2024-01-18",
    "last": "2024-01-22",
    "kind": "canon",
    "castWith": [
     "kieran",
     "peter",
     "may"
    ]
   },
   {
    "channel": "fae-courts",
    "passages": 1,
    "share": 0.0714,
    "first": "2024-09-24",
    "last": "2024-09-24",
    "kind": "route",
    "castWith": [
     "elias",
     "prince_andrew",
     "will",
     "eli",
     "ever",
     "may"
    ]
   }
  ],
  "knownCharacters": [
   "kieran",
   "peter",
   "may"
  ]
 },
 "gabs": {
  "canonRoute": "kaleb-kya-finally",
  "totalPassages": 9,
  "routes": [
   {
    "channel": "kaleb-kya-finally",
    "passages": 9,
    "share": 1.0,
    "first": "2021-02-15",
    "last": "2021-02-16",
    "kind": "canon",
    "castWith": [
     "kaleb",
     "kya_sg3",
     "kya_sg1",
     "evelyn",
     "sebastian_siren",
     "sebastian_vamp",
     "apollo",
     "uncle_khan",
     "alexander",
     "dimitri",
     "kyo",
     "ami"
    ]
   }
  ],
  "knownCharacters": [
   "kaleb",
   "kya_sg3",
   "kya_sg1",
   "evelyn",
   "sebastian_siren",
   "sebastian_vamp",
   "apollo",
   "uncle_khan",
   "alexander",
   "dimitri",
   "kyo",
   "ami"
  ]
 },
 "gabriel": {
  "canonRoute": "haggle-for-the-girl",
  "totalPassages": 43,
  "routes": [
   {
    "channel": "haggle-for-the-girl",
    "passages": 35,
    "share": 0.814,
    "first": "2024-01-10",
    "last": "2024-01-21",
    "kind": "canon",
    "castWith": [
     "lachesis",
     "lucifer",
     "asrius",
     "god",
     "lonnie",
     "ramiel",
     "lance",
     "hades",
     "alyk",
     "aphrodite",
     "atropos",
     "zeus"
    ]
   },
   {
    "channel": "atropos-in-hell",
    "passages": 6,
    "share": 0.1395,
    "first": "2021-06-04",
    "last": "2021-06-07",
    "kind": "route",
    "castWith": [
     "lucifer",
     "atropos",
     "moros",
     "lachesis",
     "haley_wolf",
     "god",
     "clothos",
     "lance",
     "hades",
     "mary_cataldi",
     "haley_human",
     "cupid_eros"
    ]
   },
   {
    "channel": "a-demons-jewel",
    "passages": 1,
    "share": 0.0233,
    "first": "2022-02-07",
    "last": "2022-02-07",
    "kind": "route",
    "castWith": [
     "tallia",
     "adrianne",
     "lucifer",
     "god",
     "will",
     "may",
     "prince_teregan"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 1,
    "share": 0.0233,
    "first": "2025-02-03",
    "last": "2025-02-03",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "ryder",
     "ford",
     "vaughn",
     "lance",
     "bryce",
     "shane",
     "dimitri",
     "allie",
     "micah",
     "audrey"
    ]
   }
  ],
  "knownCharacters": [
   "lachesis",
   "lucifer",
   "asrius",
   "god",
   "lonnie",
   "ramiel",
   "lance",
   "hades",
   "alyk",
   "aphrodite",
   "atropos",
   "zeus"
  ]
 },
 "gale": {
  "canonRoute": "kyas-choice",
  "totalPassages": 14,
  "routes": [
   {
    "channel": "kyas-choice",
    "passages": 11,
    "share": 0.7857,
    "first": "2022-05-16",
    "last": "2022-05-16",
    "kind": "canon",
    "castWith": [
     "taren",
     "kya_sg3",
     "keller",
     "kya_sg1",
     "dash",
     "atropos",
     "haley_human",
     "kaleb",
     "skipper",
     "summer",
     "will"
    ]
   },
   {
    "channel": "haley-nolan",
    "passages": 3,
    "share": 0.2143,
    "first": "2020-09-10",
    "last": "2020-09-10",
    "kind": "route",
    "castWith": [
     "nolan",
     "charlie",
     "alistair",
     "alistair_turayne",
     "caroline",
     "alyce_char",
     "ryder",
     "cruz",
     "moros",
     "lachesis",
     "renee",
     "clothos"
    ]
   }
  ],
  "knownCharacters": [
   "taren",
   "kya_sg3",
   "keller",
   "kya_sg1",
   "dash",
   "atropos",
   "haley_human",
   "kaleb",
   "skipper",
   "summer",
   "will"
  ]
 },
 "gambit": {
  "canonRoute": "dimitri-route-end",
  "totalPassages": 69,
  "routes": [
   {
    "channel": "dimitri-route-end",
    "passages": 49,
    "share": 0.7101,
    "first": "2021-01-29",
    "last": "2021-02-12",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "dimitri",
     "uri",
     "jones",
     "ares",
     "bryce",
     "kaleb",
     "frau",
     "mr_han_sr",
     "zeus",
     "kya_sg3",
     "uncle_khan"
    ]
   },
   {
    "channel": "dimitri-castle",
    "passages": 13,
    "share": 0.1884,
    "first": "2020-07-22",
    "last": "2020-07-25",
    "kind": "route",
    "castWith": [
     "dimitri",
     "evelyn",
     "stella",
     "ronin_tempus",
     "kaleb",
     "melisende",
     "mr_han_sr",
     "frau",
     "silas_mirace",
     "theo_uoki",
     "toko",
     "raye"
    ]
   },
   {
    "channel": "werewolf-dimitri",
    "passages": 5,
    "share": 0.0725,
    "first": "2021-11-01",
    "last": "2021-11-01",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "kaleb",
     "slater",
     "kya_sg3",
     "frau",
     "god",
     "lionel",
     "byron",
     "uncle_khan",
     "kelli",
     "liera"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 1,
    "share": 0.0145,
    "first": "2025-02-17",
    "last": "2025-02-17",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "ryder",
     "ford",
     "vaughn",
     "lance",
     "bryce",
     "shane",
     "dimitri",
     "allie",
     "micah",
     "audrey"
    ]
   },
   {
    "channel": "ooc",
    "passages": 1,
    "share": 0.0145,
    "first": "2020-12-19",
    "last": "2020-12-19",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "dimitri",
   "uri",
   "jones",
   "ares",
   "bryce",
   "kaleb",
   "frau",
   "mr_han_sr",
   "zeus",
   "kya_sg3",
   "uncle_khan"
  ]
 },
 "garrett": {
  "canonRoute": "human-lachesis",
  "totalPassages": 17,
  "routes": [
   {
    "channel": "human-lachesis",
    "passages": 10,
    "share": 0.5882,
    "first": "2024-10-18",
    "last": "2024-10-21",
    "kind": "canon",
    "castWith": [
     "nicole_human",
     "brax",
     "lachesis",
     "lance",
     "vaughn",
     "rowan",
     "god",
     "alyce_char",
     "moros",
     "ford",
     "atropos",
     "cruz"
    ]
   },
   {
    "channel": "kya-senior-year",
    "passages": 5,
    "share": 0.2941,
    "first": "2021-07-03",
    "last": "2021-07-03",
    "kind": "route",
    "castWith": [
     "callan",
     "ezra",
     "leiden",
     "melody",
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "raye",
     "tate",
     "sebastian_vamp",
     "dillon",
     "sebastian_siren"
    ]
   },
   {
    "channel": "kya-sold-off",
    "passages": 2,
    "share": 0.1176,
    "first": "2021-07-18",
    "last": "2021-07-18",
    "kind": "route",
    "castWith": [
     "leiden",
     "melody",
     "callan",
     "kya_sg3",
     "frank",
     "kya_sg1",
     "umu",
     "evelyn",
     "kaleb",
     "god",
     "may",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "nicole_human",
   "brax",
   "lachesis",
   "lance",
   "vaughn",
   "rowan",
   "god",
   "alyce_char",
   "moros",
   "ford",
   "atropos",
   "cruz"
  ]
 },
 "gemma": {
  "canonRoute": "human-kieran",
  "totalPassages": 6,
  "routes": [
   {
    "channel": "human-kieran",
    "passages": 5,
    "share": 0.8333,
    "first": "2024-01-02",
    "last": "2024-01-04",
    "kind": "canon",
    "castWith": [
     "kieran",
     "peter",
     "raz",
     "evan",
     "mei",
     "ms_tia",
     "will"
    ]
   },
   {
    "channel": "kieran-ezra",
    "passages": 1,
    "share": 0.1667,
    "first": "2023-10-10",
    "last": "2023-10-10",
    "kind": "route",
    "castWith": [
     "kieran",
     "ezra",
     "raz",
     "lily",
     "peter",
     "primrose",
     "rosalie",
     "ace"
    ]
   }
  ],
  "knownCharacters": [
   "kieran",
   "peter",
   "raz",
   "evan",
   "mei",
   "ms_tia",
   "will"
  ]
 },
 "george_campbell": {
  "canonRoute": "peter",
  "totalPassages": 10,
  "routes": [
   {
    "channel": "peter",
    "passages": 4,
    "share": 0.4,
    "first": "2023-09-27",
    "last": "2023-09-28",
    "kind": "canon",
    "castWith": [
     "peter",
     "kieran",
     "raz",
     "paul"
    ]
   },
   {
    "channel": "1-real-cruz",
    "passages": 3,
    "share": 0.3,
    "first": "2022-12-24",
    "last": "2022-12-24",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "ares",
     "lance",
     "selma",
     "zeus",
     "lindon",
     "hera",
     "ryder",
     "apollo",
     "nolan"
    ]
   },
   {
    "channel": "trident-and-the-elders",
    "passages": 1,
    "share": 0.1,
    "first": "2022-10-24",
    "last": "2022-10-24",
    "kind": "route",
    "castWith": [
     "james",
     "kya_sg3",
     "raz",
     "kya_sg1",
     "val",
     "apollo",
     "sebastian_vamp",
     "junta",
     "sebastian_siren",
     "vanessa",
     "tim",
     "kaleb"
    ]
   },
   {
    "channel": "an-accidentally-valerian-summer-with-cordelia",
    "passages": 1,
    "share": 0.1,
    "first": "2021-03-10",
    "last": "2021-03-10",
    "kind": "route",
    "castWith": [
     "ciel",
     "nolan",
     "lupe",
     "arsene",
     "delia",
     "dale",
     "jessica",
     "cruz",
     "clairette",
     "may",
     "tina",
     "cyrena"
    ]
   },
   {
    "channel": "misc",
    "passages": 1,
    "share": 0.1,
    "first": "2020-06-08",
    "last": "2020-06-08",
    "kind": "route",
    "castWith": [
     "aaron",
     "rowan",
     "evelyn",
     "kya_sg3",
     "kya_sg1",
     "lucius",
     "sabrina_witch",
     "sebastian_vamp",
     "sebastian_siren",
     "rex",
     "cupid_eros",
     "nellie"
    ]
   }
  ],
  "knownCharacters": [
   "peter",
   "kieran",
   "raz",
   "paul"
  ]
 },
 "gersemi": {
  "canonRoute": "kya-college-2",
  "totalPassages": 2,
  "routes": [
   {
    "channel": "kya-college-2",
    "passages": 2,
    "share": 1.0,
    "first": "2021-01-05",
    "last": "2021-01-05",
    "kind": "canon",
    "castWith": [
     "lily",
     "zander",
     "kya_sg3",
     "kya_sg1",
     "ari",
     "sebastian_siren",
     "raye",
     "prince_zed",
     "sebastian_vamp",
     "midori_naga",
     "penelope_valk",
     "bell_lily_of_fell"
    ]
   }
  ],
  "knownCharacters": [
   "lily",
   "zander",
   "kya_sg3",
   "kya_sg1",
   "ari",
   "sebastian_siren",
   "raye",
   "prince_zed",
   "sebastian_vamp",
   "midori_naga",
   "penelope_valk",
   "bell_lily_of_fell"
  ]
 },
 "god": {
  "canonRoute": "haggle-for-the-girl",
  "totalPassages": 715,
  "routes": [
   {
    "channel": "switched-roles-lachesis",
    "passages": 116,
    "share": 0.1622,
    "first": "2023-10-09",
    "last": "2023-11-25",
    "kind": "au",
    "castWith": [
     "lachesis",
     "ford",
     "lucifer",
     "cruz",
     "clothos",
     "atropos",
     "rowan",
     "vaughn",
     "ryder",
     "brax",
     "dimitri",
     "ramiel"
    ]
   },
   {
    "channel": "haggle-for-the-girl",
    "passages": 98,
    "share": 0.1371,
    "first": "2023-12-16",
    "last": "2024-01-21",
    "kind": "canon",
    "castWith": [
     "lachesis",
     "lucifer",
     "asrius",
     "lonnie",
     "ramiel",
     "gabriel",
     "lance",
     "hades",
     "alyk",
     "aphrodite",
     "atropos",
     "zeus"
    ]
   },
   {
    "channel": "plz-love-lachesis",
    "passages": 61,
    "share": 0.0853,
    "first": "2022-11-11",
    "last": "2022-11-26",
    "kind": "route",
    "castWith": [
     "lachesis",
     "ramiel",
     "lance",
     "lucifer",
     "apollo",
     "levi",
     "aion",
     "atropos",
     "zeus",
     "zadkiel",
     "clothos",
     "asrius"
    ]
   },
   {
    "channel": "oops-its-heaven",
    "passages": 49,
    "share": 0.0685,
    "first": "2022-08-09",
    "last": "2022-09-10",
    "kind": "route",
    "castWith": [
     "lachesis",
     "lance",
     "ramiel",
     "aldo",
     "lucifer",
     "atropos",
     "mary_cataldi",
     "hades",
     "clothos",
     "zeus"
    ]
   },
   {
    "channel": "human-lachesis",
    "passages": 30,
    "share": 0.042,
    "first": "2024-09-24",
    "last": "2024-11-22",
    "kind": "route",
    "castWith": [
     "nicole_human",
     "brax",
     "lachesis",
     "lance",
     "vaughn",
     "rowan",
     "alyce_char",
     "moros",
     "ford",
     "atropos",
     "cruz",
     "nicole_wolf"
    ]
   },
   {
    "channel": "chance-route-ft-lance",
    "passages": 20,
    "share": 0.028,
    "first": "2021-09-25",
    "last": "2021-10-06",
    "kind": "route",
    "castWith": [
     "lachesis",
     "chance",
     "lance",
     "aphrodite",
     "atropos",
     "clothos",
     "zeus",
     "moros",
     "ares",
     "hades",
     "may",
     "will"
    ]
   },
   {
    "channel": "no-time-like-the-present",
    "passages": 18,
    "share": 0.0252,
    "first": "2023-09-28",
    "last": "2023-10-08",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "lance",
     "ryder",
     "allie",
     "cruz",
     "micah",
     "aspen",
     "trix",
     "diana",
     "evelyn",
     "audrey"
    ]
   },
   {
    "channel": "fordsplosion",
    "passages": 18,
    "share": 0.0252,
    "first": "2024-02-09",
    "last": "2024-03-19",
    "kind": "route",
    "castWith": [
     "ford",
     "lachesis",
     "lucifer",
     "cruz",
     "clothos",
     "ryder",
     "asrius",
     "ethan",
     "eva",
     "atropos",
     "may",
     "evelyn"
    ]
   },
   {
    "channel": "heavenbound-missions",
    "passages": 17,
    "share": 0.0238,
    "first": "2025-10-07",
    "last": "2025-10-16",
    "kind": "route",
    "castWith": [
     "vaughn",
     "lindon",
     "ares",
     "brax",
     "primrose",
     "aphrodite",
     "nicole_human",
     "nicole_wolf",
     "nicole_sg3",
     "beatrice",
     "will",
     "cruz"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 15,
    "share": 0.021,
    "first": "2016-09-08",
    "last": "2020-04-01",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "rika",
     "nolan"
    ]
   },
   {
    "channel": "a-tricky-micah-cruz-route",
    "passages": 14,
    "share": 0.0196,
    "first": "2023-09-14",
    "last": "2023-09-22",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "ryder",
     "cruz",
     "micah",
     "trix",
     "allie",
     "evelyn",
     "roger",
     "audrey",
     "bryce",
     "diana"
    ]
   },
   {
    "channel": "atropos-in-hell",
    "passages": 12,
    "share": 0.0168,
    "first": "2021-05-29",
    "last": "2021-06-12",
    "kind": "route",
    "castWith": [
     "lucifer",
     "atropos",
     "moros",
     "lachesis",
     "haley_wolf",
     "clothos",
     "gabriel",
     "lance",
     "hades",
     "mary_cataldi",
     "haley_human",
     "cupid_eros"
    ]
   }
  ],
  "knownCharacters": [
   "lachesis",
   "lucifer",
   "asrius",
   "lonnie",
   "ramiel",
   "gabriel",
   "lance",
   "hades",
   "alyk",
   "aphrodite",
   "atropos",
   "zeus"
  ]
 },
 "goll": {
  "canonRoute": "the-kingdom-fallon",
  "totalPassages": 5,
  "routes": [
   {
    "channel": "the-kingdom-fallon",
    "passages": 5,
    "share": 1.0,
    "first": "2021-06-01",
    "last": "2021-06-04",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "eva",
     "rory",
     "raye",
     "fiadh",
     "ciarnan",
     "finn",
     "cailte",
     "senan",
     "diarmund",
     "fiann",
     "kaleb"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "eva",
   "rory",
   "raye",
   "fiadh",
   "ciarnan",
   "finn",
   "cailte",
   "senan",
   "diarmund",
   "fiann",
   "kaleb"
  ]
 },
 "gracie": {
  "canonRoute": "haley-finds-out-shes-cool-2",
  "totalPassages": 11,
  "routes": [
   {
    "channel": "haley-finds-out-shes-cool-2",
    "passages": 11,
    "share": 1.0,
    "first": "2022-11-29",
    "last": "2022-12-04",
    "kind": "canon",
    "castWith": [
     "moros",
     "atropos",
     "haley_human",
     "jinko",
     "lance",
     "may",
     "lachesis",
     "athena",
     "clothos",
     "haley_wolf",
     "peter",
     "apollo"
    ]
   }
  ],
  "knownCharacters": [
   "moros",
   "atropos",
   "haley_human",
   "jinko",
   "lance",
   "may",
   "lachesis",
   "athena",
   "clothos",
   "haley_wolf",
   "peter",
   "apollo"
  ]
 },
 "hadrian": {
  "canonRoute": "twins-princes-and-murder",
  "totalPassages": 96,
  "routes": [
   {
    "channel": "twins-princes-and-murder",
    "passages": 94,
    "share": 0.9792,
    "first": "2023-02-09",
    "last": "2023-02-23",
    "kind": "canon",
    "castWith": [
     "kyo",
     "amoura",
     "eli",
     "amelda"
    ]
   },
   {
    "channel": "dillon-knows",
    "passages": 1,
    "share": 0.0104,
    "first": "2025-12-12",
    "last": "2025-12-12",
    "kind": "route",
    "castWith": [
     "dillon",
     "kyo",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "kaleb",
     "sebastian_vamp",
     "ever",
     "will",
     "lachesis",
     "amoura",
     "may"
    ]
   },
   {
    "channel": "3-haleys-hades-fanfic",
    "passages": 1,
    "share": 0.0104,
    "first": "2023-02-23",
    "last": "2023-02-23",
    "kind": "au",
    "castWith": [
     "hades",
     "kyo",
     "persephone",
     "amoura",
     "kya_sg3",
     "kya_sg1",
     "kaleb",
     "dillon",
     "apollo",
     "sebastian_vamp",
     "sebastian_siren",
     "eli"
    ]
   }
  ],
  "knownCharacters": [
   "kyo",
   "amoura",
   "eli",
   "amelda"
  ]
 },
 "harley": {
  "canonRoute": "cruz-x-nicole",
  "totalPassages": 2,
  "routes": [
   {
    "channel": "cruz-x-nicole",
    "passages": 1,
    "share": 0.5,
    "first": "2020-08-03",
    "last": "2020-08-03",
    "kind": "canon",
    "castWith": [
     "cruz",
     "lance",
     "hermes",
     "audrey",
     "peter",
     "ares",
     "nicole_wolf",
     "nicole_sg3",
     "alyce_char",
     "red",
     "trix",
     "nicole_human"
    ]
   },
   {
    "channel": "california",
    "passages": 1,
    "share": 0.5,
    "first": "2020-05-14",
    "last": "2020-05-14",
    "kind": "route",
    "castWith": [
     "hiro",
     "evelyn",
     "ares",
     "ezra",
     "bryce",
     "ace",
     "kiro",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "lance",
   "hermes",
   "audrey",
   "peter",
   "ares",
   "nicole_wolf",
   "nicole_sg3",
   "alyce_char",
   "red",
   "trix",
   "nicole_human"
  ]
 },
 "hera": {
  "canonRoute": "1-real-cruz",
  "totalPassages": 111,
  "routes": [
   {
    "channel": "1-real-cruz",
    "passages": 33,
    "share": 0.2973,
    "first": "2022-10-25",
    "last": "2023-01-24",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "ares",
     "lance",
     "selma",
     "zeus",
     "lindon",
     "ryder",
     "apollo",
     "nolan",
     "diana"
    ]
   },
   {
    "channel": "evelyn-college-2",
    "passages": 16,
    "share": 0.1441,
    "first": "2021-01-18",
    "last": "2021-07-02",
    "kind": "route",
    "castWith": [
     "evelyn",
     "darren",
     "dimitri",
     "lex",
     "hades",
     "raye",
     "jon",
     "ares",
     "kaleb",
     "cruz",
     "kya_sg3",
     "ari"
    ]
   },
   {
    "channel": "ocroute2-cruz-in-for-love",
    "passages": 12,
    "share": 0.1081,
    "first": "2022-02-01",
    "last": "2022-02-11",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "dimitri",
     "hades",
     "zeus",
     "aphrodite",
     "god",
     "bryce",
     "amanda",
     "lachesis",
     "hermes",
     "nolan"
    ]
   },
   {
    "channel": "lets-abduct-evie",
    "passages": 8,
    "share": 0.0721,
    "first": "2021-07-02",
    "last": "2021-07-29",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "ryoto",
     "dodge",
     "ms_tia",
     "kaleb",
     "frau",
     "aki",
     "cruz",
     "talbot",
     "ares",
     "zeus"
    ]
   },
   {
    "channel": "lance-mating",
    "passages": 6,
    "share": 0.0541,
    "first": "2021-08-30",
    "last": "2021-08-30",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "clothos",
     "ryder",
     "hades",
     "nolan",
     "nicole_human",
     "audrey",
     "moros",
     "atropos",
     "nicole_wolf"
    ]
   },
   {
    "channel": "dimitri-route-end",
    "passages": 4,
    "share": 0.036,
    "first": "2021-02-03",
    "last": "2021-02-16",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "uri",
     "gambit",
     "jones",
     "ares",
     "bryce",
     "kaleb",
     "frau",
     "mr_han_sr",
     "zeus",
     "kya_sg3"
    ]
   },
   {
    "channel": "atropos-reincarnated",
    "passages": 4,
    "share": 0.036,
    "first": "2022-06-12",
    "last": "2022-06-28",
    "kind": "route",
    "castWith": [
     "moros",
     "apollo",
     "haley_wolf",
     "atropos",
     "zeus",
     "zephyr",
     "dante",
     "lachesis",
     "clothos",
     "aphrodite",
     "haley_human",
     "nicole_human"
    ]
   },
   {
    "channel": "haggle-for-the-girl",
    "passages": 3,
    "share": 0.027,
    "first": "2023-12-17",
    "last": "2023-12-28",
    "kind": "route",
    "castWith": [
     "lachesis",
     "lucifer",
     "asrius",
     "god",
     "lonnie",
     "ramiel",
     "gabriel",
     "lance",
     "hades",
     "alyk",
     "aphrodite",
     "atropos"
    ]
   },
   {
    "channel": "cruz-nicole-dollar-store",
    "passages": 3,
    "share": 0.027,
    "first": "2020-09-16",
    "last": "2020-09-16",
    "kind": "route",
    "castWith": [
     "cruz",
     "raz",
     "lance",
     "lachesis",
     "bryce",
     "nolan",
     "renee",
     "aphrodite",
     "clothos",
     "atropos",
     "nicole_wolf",
     "nicole_sg3"
    ]
   },
   {
    "channel": "kinley-is-a-nondecisive-butt",
    "passages": 3,
    "share": 0.027,
    "first": "2022-04-08",
    "last": "2022-04-08",
    "kind": "route",
    "castWith": [
     "zain_demigod",
     "kinley",
     "apollo",
     "lex",
     "cupid_eros",
     "lachesis",
     "sebastian_vamp",
     "sebastian_siren",
     "ben",
     "god",
     "will",
     "zeus"
    ]
   },
   {
    "channel": "chance-route-ft-lance",
    "passages": 2,
    "share": 0.018,
    "first": "2021-10-25",
    "last": "2021-10-25",
    "kind": "route",
    "castWith": [
     "lachesis",
     "chance",
     "lance",
     "god",
     "aphrodite",
     "atropos",
     "clothos",
     "zeus",
     "moros",
     "ares",
     "hades",
     "may"
    ]
   },
   {
    "channel": "lance-decides",
    "passages": 2,
    "share": 0.018,
    "first": "2024-12-28",
    "last": "2024-12-28",
    "kind": "route",
    "castWith": [
     "lance",
     "rin",
     "lucifer",
     "lachesis",
     "nicole_human",
     "god",
     "chiara",
     "cupid_eros",
     "roman",
     "asrius",
     "zeus",
     "aphrodite"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "cruz",
   "bryce",
   "ares",
   "lance",
   "selma",
   "zeus",
   "lindon",
   "ryder",
   "apollo",
   "nolan",
   "diana"
  ]
 },
 "hnoss": {
  "canonRoute": "kya-college-2",
  "totalPassages": 2,
  "routes": [
   {
    "channel": "kya-college-2",
    "passages": 2,
    "share": 1.0,
    "first": "2021-01-05",
    "last": "2021-01-05",
    "kind": "canon",
    "castWith": [
     "lily",
     "zander",
     "kya_sg3",
     "kya_sg1",
     "ari",
     "sebastian_siren",
     "raye",
     "prince_zed",
     "sebastian_vamp",
     "midori_naga",
     "penelope_valk",
     "bell_lily_of_fell"
    ]
   }
  ],
  "knownCharacters": [
   "lily",
   "zander",
   "kya_sg3",
   "kya_sg1",
   "ari",
   "sebastian_siren",
   "raye",
   "prince_zed",
   "sebastian_vamp",
   "midori_naga",
   "penelope_valk",
   "bell_lily_of_fell"
  ]
 },
 "hunter": {
  "canonRoute": "rogue-wolf-hot-cruz",
  "totalPassages": 42,
  "routes": [
   {
    "channel": "rogue-wolf-hot-cruz",
    "passages": 42,
    "share": 1.0,
    "first": "2021-03-01",
    "last": "2021-03-16",
    "kind": "canon",
    "castWith": [
     "cruz",
     "ryder",
     "trix",
     "audrey",
     "lance",
     "alyce_char",
     "bryce",
     "nolan",
     "diana",
     "will",
     "ever",
     "aphrodite"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "ryder",
   "trix",
   "audrey",
   "lance",
   "alyce_char",
   "bryce",
   "nolan",
   "diana",
   "will",
   "ever",
   "aphrodite"
  ]
 },
 "hyun_ryu": {
  "canonRoute": "the-great-husbando-race",
  "totalPassages": 2,
  "routes": [
   {
    "channel": "the-great-husbando-race",
    "passages": 1,
    "share": 0.5,
    "first": "2020-06-23",
    "last": "2020-06-23",
    "kind": "canon",
    "castWith": [
     "kira",
     "ray",
     "leon",
     "cupid_eros",
     "loki",
     "riku",
     "victor",
     "evelyn",
     "junta",
     "ben",
     "jack",
     "kent"
    ]
   },
   {
    "channel": "zens_parents_suburban_house",
    "passages": 1,
    "share": 0.5,
    "first": "2018-03-16",
    "last": "2018-03-16",
    "kind": "route",
    "castWith": [
     "ever"
    ]
   }
  ],
  "knownCharacters": [
   "kira",
   "ray",
   "leon",
   "cupid_eros",
   "loki",
   "riku",
   "victor",
   "evelyn",
   "junta",
   "ben",
   "jack",
   "kent"
  ]
 },
 "ida": {
  "canonRoute": "fall-fairies",
  "totalPassages": 1,
  "routes": [
   {
    "channel": "fall-fairies",
    "passages": 1,
    "share": 1.0,
    "first": "2021-10-25",
    "last": "2021-10-25",
    "kind": "canon",
    "castWith": [
     "damien",
     "matare",
     "autumn",
     "retin",
     "draven",
     "fayette",
     "sir_tyde",
     "may",
     "maleos",
     "silvia",
     "jaden",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "damien",
   "matare",
   "autumn",
   "retin",
   "draven",
   "fayette",
   "sir_tyde",
   "may",
   "maleos",
   "silvia",
   "jaden",
   "will"
  ]
 },
 "ivy_morris": {
  "canonRoute": "evelyns_mansion",
  "totalPassages": 20,
  "routes": [
   {
    "channel": "evelyns_mansion",
    "passages": 17,
    "share": 0.85,
    "first": "2016-09-21",
    "last": "2016-09-24",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "kaleb",
     "cruz",
     "kya_sg3",
     "marta",
     "kya_sg1",
     "frau",
     "mr_han_sr",
     "sebastian_vamp",
     "god",
     "seuk",
     "dimitri"
    ]
   },
   {
    "channel": "junta-is-best-boi",
    "passages": 1,
    "share": 0.05,
    "first": "2023-12-08",
    "last": "2023-12-08",
    "kind": "route",
    "castWith": [
     "junta",
     "ezra",
     "madison_astor",
     "lily",
     "val",
     "natasha",
     "primrose",
     "belinda",
     "james",
     "may",
     "sebastian_vamp",
     "tim"
    ]
   },
   {
    "channel": "brothel",
    "passages": 1,
    "share": 0.05,
    "first": "2020-04-25",
    "last": "2020-04-25",
    "kind": "route",
    "castWith": [
     "ezra",
     "evelyn",
     "rowan",
     "kya_sg3",
     "kya_sg1",
     "primrose",
     "lily",
     "kaleb",
     "nellie",
     "lissa",
     "raye",
     "ace"
    ]
   },
   {
    "channel": "dorms",
    "passages": 1,
    "share": 0.05,
    "first": "2020-04-29",
    "last": "2020-04-29",
    "kind": "route",
    "castWith": [
     "agnar",
     "kya_sg3",
     "agmund",
     "evelyn",
     "raye",
     "cole",
     "kya_sg1",
     "riku",
     "kaleb",
     "penelope_valk",
     "loki",
     "svira"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "kaleb",
   "cruz",
   "kya_sg3",
   "marta",
   "kya_sg1",
   "frau",
   "mr_han_sr",
   "sebastian_vamp",
   "god",
   "seuk",
   "dimitri"
  ]
 },
 "jace": {
  "canonRoute": "kya-werewolf",
  "totalPassages": 124,
  "routes": [
   {
    "channel": "kya-werewolf",
    "passages": 124,
    "share": 1.0,
    "first": "2021-08-17",
    "last": "2021-09-26",
    "kind": "canon",
    "castWith": [
     "raphael",
     "trey",
     "dillon",
     "kya_sg3",
     "scott",
     "kya_sg1",
     "ezra",
     "sebastian_siren",
     "kaleb",
     "sebastian_vamp",
     "evelyn",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "raphael",
   "trey",
   "dillon",
   "kya_sg3",
   "scott",
   "kya_sg1",
   "ezra",
   "sebastian_siren",
   "kaleb",
   "sebastian_vamp",
   "evelyn",
   "will"
  ]
 },
 "jack": {
  "canonRoute": "cruz-sucks-ford-fucks",
  "totalPassages": 32,
  "routes": [
   {
    "channel": "cruz-sucks-ford-fucks",
    "passages": 12,
    "share": 0.375,
    "first": "2024-05-18",
    "last": "2024-06-03",
    "kind": "canon",
    "castWith": [
     "ford",
     "cruz",
     "evelyn",
     "audrey",
     "bryce",
     "dimitri",
     "rowan",
     "nolan",
     "ryder",
     "lonnie",
     "lyden",
     "alyce_char"
    ]
   },
   {
    "channel": "not-a-landbond-route",
    "passages": 6,
    "share": 0.1875,
    "first": "2022-01-06",
    "last": "2022-01-07",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "evelyn",
     "sebastian_vamp",
     "ezra",
     "raye",
     "kaleb",
     "alistair",
     "alistair_turayne",
     "uncle_khan",
     "polly"
    ]
   },
   {
    "channel": "eat-speak-rp-repeat",
    "passages": 3,
    "share": 0.0938,
    "first": "2026-03-10",
    "last": "2026-03-27",
    "kind": "ooc",
    "castWith": [
     "eric",
     "cruz",
     "lindon",
     "april",
     "lance",
     "felix_fairy",
     "brooke",
     "cyrus_fairy",
     "malakai",
     "god",
     "pam",
     "ezra"
    ]
   },
   {
    "channel": "shane-micah-wish",
    "passages": 2,
    "share": 0.0625,
    "first": "2023-12-12",
    "last": "2023-12-12",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "cruz",
     "micah",
     "ryder",
     "god",
     "trix",
     "ever",
     "diana",
     "lucifer",
     "rex",
     "keller"
    ]
   },
   {
    "channel": "junta-is-best-boi",
    "passages": 1,
    "share": 0.0312,
    "first": "2023-12-03",
    "last": "2023-12-03",
    "kind": "route",
    "castWith": [
     "junta",
     "ezra",
     "madison_astor",
     "lily",
     "val",
     "natasha",
     "primrose",
     "belinda",
     "james",
     "may",
     "sebastian_vamp",
     "tim"
    ]
   },
   {
    "channel": "lachesis-reincarnated",
    "passages": 1,
    "share": 0.0312,
    "first": "2022-06-11",
    "last": "2022-06-11",
    "kind": "route",
    "castWith": [
     "lance",
     "alyk",
     "lachesis",
     "haley_wolf",
     "clothos",
     "demeter",
     "moros",
     "haley_human",
     "nicole_human",
     "atropos",
     "cruz",
     "apollo"
    ]
   },
   {
    "channel": "starry-night",
    "passages": 1,
    "share": 0.0312,
    "first": "2025-07-28",
    "last": "2025-07-28",
    "kind": "route",
    "castWith": [
     "haley_human",
     "adrien",
     "haley_wolf",
     "haley_sg3",
     "dillon",
     "may"
    ]
   },
   {
    "channel": "werewolf-dimitri",
    "passages": 1,
    "share": 0.0312,
    "first": "2021-10-28",
    "last": "2021-10-28",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "kaleb",
     "slater",
     "kya_sg3",
     "frau",
     "god",
     "lionel",
     "byron",
     "gambit",
     "uncle_khan",
     "kelli"
    ]
   },
   {
    "channel": "indifference",
    "passages": 1,
    "share": 0.0312,
    "first": "2023-03-28",
    "last": "2023-03-28",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "alyce_char",
     "dimitri",
     "ryder",
     "rio",
     "ace",
     "moros",
     "geo",
     "nolan",
     "audrey"
    ]
   },
   {
    "channel": "parabus",
    "passages": 1,
    "share": 0.0312,
    "first": "2020-06-04",
    "last": "2020-06-04",
    "kind": "route",
    "castWith": [
     "evelyn",
     "lucius",
     "rex",
     "rowan",
     "laito",
     "boko",
     "ryan",
     "stash",
     "raye",
     "mr_han_sr",
     "cruz",
     "kya_sg3"
    ]
   },
   {
    "channel": "ooc",
    "passages": 1,
    "share": 0.0312,
    "first": "2020-05-10",
    "last": "2020-05-10",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "the-great-husbando-race",
    "passages": 1,
    "share": 0.0312,
    "first": "2020-06-13",
    "last": "2020-06-13",
    "kind": "route",
    "castWith": [
     "kira",
     "ray",
     "leon",
     "cupid_eros",
     "loki",
     "riku",
     "victor",
     "evelyn",
     "junta",
     "ben",
     "hyun_ryu",
     "kent"
    ]
   }
  ],
  "knownCharacters": [
   "ford",
   "cruz",
   "evelyn",
   "audrey",
   "bryce",
   "dimitri",
   "rowan",
   "nolan",
   "ryder",
   "lonnie",
   "lyden",
   "alyce_char"
  ]
 },
 "jaden": {
  "canonRoute": "fall-fairies",
  "totalPassages": 2,
  "routes": [
   {
    "channel": "fall-fairies",
    "passages": 2,
    "share": 1.0,
    "first": "2021-10-29",
    "last": "2021-10-29",
    "kind": "canon",
    "castWith": [
     "damien",
     "matare",
     "autumn",
     "retin",
     "draven",
     "fayette",
     "sir_tyde",
     "may",
     "maleos",
     "silvia",
     "will",
     "roman"
    ]
   }
  ],
  "knownCharacters": [
   "damien",
   "matare",
   "autumn",
   "retin",
   "draven",
   "fayette",
   "sir_tyde",
   "may",
   "maleos",
   "silvia",
   "will",
   "roman"
  ]
 },
 "jane": {
  "canonRoute": "wizards-chamber",
  "totalPassages": 28,
  "routes": [
   {
    "channel": "wizards-chamber",
    "passages": 6,
    "share": 0.2143,
    "first": "2020-04-28",
    "last": "2020-04-29",
    "kind": "canon",
    "castWith": [
     "ezra",
     "crom",
     "kya_sg3",
     "kya_sg1",
     "kris",
     "primrose",
     "kyo",
     "polly",
     "will"
    ]
   },
   {
    "channel": "growing-up-ezra",
    "passages": 5,
    "share": 0.1786,
    "first": "2023-01-31",
    "last": "2023-01-31",
    "kind": "route",
    "castWith": [
     "ezra",
     "kya_sg3",
     "primrose",
     "dillon",
     "kya_sg1",
     "kaleb",
     "edward",
     "sebastian_vamp",
     "raye",
     "sebastian_siren",
     "ace",
     "uncle_khan"
    ]
   },
   {
    "channel": "high-school-ezra-kya",
    "passages": 4,
    "share": 0.1429,
    "first": "2021-02-18",
    "last": "2021-02-18",
    "kind": "route",
    "castWith": [
     "ezra",
     "kya_sg3",
     "maria",
     "rachel",
     "kaleb",
     "kya_sg1",
     "evelyn",
     "willie",
     "primrose",
     "lily",
     "ace",
     "uncle_khan"
    ]
   },
   {
    "channel": "ezra-normalish-life",
    "passages": 4,
    "share": 0.1429,
    "first": "2022-08-10",
    "last": "2022-08-15",
    "kind": "route",
    "castWith": [
     "ezra",
     "sam",
     "kya_sg3",
     "kya_sg1",
     "raz",
     "james",
     "evelyn",
     "kaleb",
     "bell_lily_of_fell",
     "vanessa",
     "val",
     "tim"
    ]
   },
   {
    "channel": "mother-ettore-house",
    "passages": 3,
    "share": 0.1071,
    "first": "2020-04-28",
    "last": "2020-04-28",
    "kind": "route",
    "castWith": [
     "ezra",
     "kya_sg1",
     "kya_sg3"
    ]
   },
   {
    "channel": "ezra-with-good-parents",
    "passages": 2,
    "share": 0.0714,
    "first": "2024-06-05",
    "last": "2024-06-09",
    "kind": "route",
    "castWith": [
     "dillon",
     "ezra",
     "kya_sg3",
     "kya_sg1",
     "alistair",
     "kaleb",
     "uncle_khan",
     "alistair_turayne",
     "may"
    ]
   },
   {
    "channel": "don\u2019t-buy-me-love",
    "passages": 2,
    "share": 0.0714,
    "first": "2023-12-12",
    "last": "2023-12-12",
    "kind": "route",
    "castWith": [
     "ezra",
     "trace_spellbook",
     "primrose",
     "madison_astor",
     "kya_sg3",
     "kya_sg1",
     "dimitri",
     "hades",
     "evelyn",
     "junta",
     "may",
     "reginald"
    ]
   },
   {
    "channel": "border",
    "passages": 2,
    "share": 0.0714,
    "first": "2020-04-28",
    "last": "2020-04-28",
    "kind": "route",
    "castWith": [
     "ezra",
     "kya_sg1",
     "kya_sg3",
     "hades"
    ]
   }
  ],
  "knownCharacters": [
   "ezra",
   "crom",
   "kya_sg3",
   "kya_sg1",
   "kris",
   "primrose",
   "kyo",
   "polly",
   "will"
  ]
 },
 "jenning": {
  "canonRoute": "lance-nicole-2",
  "totalPassages": 51,
  "routes": [
   {
    "channel": "lance-nicole-2",
    "passages": 51,
    "share": 1.0,
    "first": "2022-11-28",
    "last": "2022-12-08",
    "kind": "canon",
    "castWith": [
     "brax",
     "vaughn",
     "lance",
     "cruz",
     "lachesis",
     "nicole_human",
     "nicole_wolf",
     "nicole_sg3",
     "clothos",
     "atropos",
     "rowan",
     "roman"
    ]
   }
  ],
  "knownCharacters": [
   "brax",
   "vaughn",
   "lance",
   "cruz",
   "lachesis",
   "nicole_human",
   "nicole_wolf",
   "nicole_sg3",
   "clothos",
   "atropos",
   "rowan",
   "roman"
  ]
 },
 "jessica": {
  "canonRoute": "an-accidentally-valerian-summer-with-cordelia",
  "totalPassages": 20,
  "routes": [
   {
    "channel": "an-accidentally-valerian-summer-with-cordelia",
    "passages": 9,
    "share": 0.45,
    "first": "2021-03-16",
    "last": "2021-04-23",
    "kind": "canon",
    "castWith": [
     "ciel",
     "nolan",
     "lupe",
     "arsene",
     "delia",
     "dale",
     "cruz",
     "clairette",
     "may",
     "tina",
     "cyrena",
     "will"
    ]
   },
   {
    "channel": "ww-war-au",
    "passages": 6,
    "share": 0.3,
    "first": "2021-12-02",
    "last": "2021-12-02",
    "kind": "au",
    "castWith": [
     "evelyn",
     "cruz",
     "ace",
     "ezra",
     "lindon",
     "kaleb",
     "rowan",
     "bryce",
     "lance",
     "raye",
     "nolan",
     "primrose"
    ]
   },
   {
    "channel": "kya-werewolf",
    "passages": 2,
    "share": 0.1,
    "first": "2021-09-12",
    "last": "2021-09-12",
    "kind": "route",
    "castWith": [
     "jace",
     "raphael",
     "trey",
     "dillon",
     "kya_sg3",
     "scott",
     "kya_sg1",
     "ezra",
     "sebastian_siren",
     "kaleb",
     "sebastian_vamp",
     "evelyn"
    ]
   },
   {
    "channel": "cruz-is-not-dead",
    "passages": 2,
    "share": 0.1,
    "first": "2022-05-14",
    "last": "2022-05-14",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "ford",
     "ryder",
     "lucifer",
     "bryce",
     "audrey",
     "apollo",
     "ares",
     "god",
     "clint",
     "hades"
    ]
   },
   {
    "channel": "the-bachelorette-season-kya",
    "passages": 1,
    "share": 0.05,
    "first": "2021-05-21",
    "last": "2021-05-21",
    "kind": "route",
    "castWith": [
     "apollo",
     "evelyn",
     "kya_sg3",
     "kya_sg1",
     "carole",
     "hermes",
     "aphrodite",
     "ares",
     "may",
     "skipper",
     "god",
     "hera"
    ]
   }
  ],
  "knownCharacters": [
   "ciel",
   "nolan",
   "lupe",
   "arsene",
   "delia",
   "dale",
   "cruz",
   "clairette",
   "may",
   "tina",
   "cyrena",
   "will"
  ]
 },
 "jinko": {
  "canonRoute": "haley-finds-out-shes-cool-2",
  "totalPassages": 6,
  "routes": [
   {
    "channel": "haley-finds-out-shes-cool-2",
    "passages": 6,
    "share": 1.0,
    "first": "2022-12-05",
    "last": "2022-12-08",
    "kind": "canon",
    "castWith": [
     "moros",
     "atropos",
     "gracie",
     "haley_human",
     "lance",
     "may",
     "lachesis",
     "athena",
     "clothos",
     "haley_wolf",
     "peter",
     "apollo"
    ]
   }
  ],
  "knownCharacters": [
   "moros",
   "atropos",
   "gracie",
   "haley_human",
   "lance",
   "may",
   "lachesis",
   "athena",
   "clothos",
   "haley_wolf",
   "peter",
   "apollo"
  ]
 },
 "jonathan_donovan": {
  "canonRoute": "nicole-x-cruz",
  "totalPassages": 4,
  "routes": [
   {
    "channel": "nicole-x-cruz",
    "passages": 4,
    "share": 1.0,
    "first": "2020-08-29",
    "last": "2020-08-29",
    "kind": "canon",
    "castWith": [
     "otto",
     "cruz",
     "jones",
     "nicole_human",
     "duran",
     "sorsha",
     "kya_sg1",
     "lucifer",
     "nicole_wolf",
     "kya_sg3",
     "nicole_sg3",
     "christopher_donovan"
    ]
   }
  ],
  "knownCharacters": [
   "otto",
   "cruz",
   "jones",
   "nicole_human",
   "duran",
   "sorsha",
   "kya_sg1",
   "lucifer",
   "nicole_wolf",
   "kya_sg3",
   "nicole_sg3",
   "christopher_donovan"
  ]
 },
 "jones": {
  "canonRoute": "nicole-x-cruz",
  "totalPassages": 65,
  "routes": [
   {
    "channel": "nicole-x-cruz",
    "passages": 34,
    "share": 0.5231,
    "first": "2020-08-29",
    "last": "2020-09-07",
    "kind": "canon",
    "castWith": [
     "otto",
     "cruz",
     "nicole_human",
     "duran",
     "sorsha",
     "kya_sg1",
     "lucifer",
     "nicole_wolf",
     "kya_sg3",
     "nicole_sg3",
     "christopher_donovan",
     "jonathan_donovan"
    ]
   },
   {
    "channel": "dimitri-route-end",
    "passages": 24,
    "share": 0.3692,
    "first": "2021-02-03",
    "last": "2021-02-10",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "uri",
     "gambit",
     "ares",
     "bryce",
     "kaleb",
     "frau",
     "mr_han_sr",
     "zeus",
     "kya_sg3",
     "uncle_khan"
    ]
   },
   {
    "channel": "lets-abduct-evie",
    "passages": 3,
    "share": 0.0462,
    "first": "2021-06-28",
    "last": "2021-06-28",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "ryoto",
     "dodge",
     "ms_tia",
     "kaleb",
     "frau",
     "aki",
     "cruz",
     "talbot",
     "ares",
     "zeus"
    ]
   },
   {
    "channel": "nicoles-wish-brax-brother",
    "passages": 1,
    "share": 0.0154,
    "first": "2023-06-13",
    "last": "2023-06-13",
    "kind": "route",
    "castWith": [
     "ford",
     "cruz",
     "brax",
     "lance",
     "dimitri",
     "hades",
     "vaughn",
     "rowan",
     "nicole_human",
     "audrey",
     "diana",
     "evelyn"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 1,
    "share": 0.0154,
    "first": "2024-01-24",
    "last": "2024-01-24",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "ryder",
     "ford",
     "vaughn",
     "lance",
     "bryce",
     "shane",
     "dimitri",
     "allie",
     "micah",
     "audrey"
    ]
   },
   {
    "channel": "shane-micah-wish",
    "passages": 1,
    "share": 0.0154,
    "first": "2023-11-29",
    "last": "2023-11-29",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "cruz",
     "micah",
     "ryder",
     "god",
     "trix",
     "ever",
     "diana",
     "lucifer",
     "rex",
     "jack"
    ]
   },
   {
    "channel": "ooc",
    "passages": 1,
    "share": 0.0154,
    "first": "2020-04-18",
    "last": "2020-04-18",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   }
  ],
  "knownCharacters": [
   "otto",
   "cruz",
   "nicole_human",
   "duran",
   "sorsha",
   "kya_sg1",
   "lucifer",
   "nicole_wolf",
   "kya_sg3",
   "nicole_sg3",
   "christopher_donovan",
   "jonathan_donovan"
  ]
 },
 "jova": {
  "canonRoute": "kinley-reset-route",
  "totalPassages": 4,
  "routes": [
   {
    "channel": "kinley-reset-route",
    "passages": 4,
    "share": 1.0,
    "first": "2022-02-24",
    "last": "2022-02-24",
    "kind": "canon",
    "castWith": [
     "kinley",
     "lander",
     "shadow",
     "tate",
     "aaron",
     "raye",
     "zain_demigod",
     "natalia",
     "apollo",
     "crom",
     "god",
     "aphrodite"
    ]
   }
  ],
  "knownCharacters": [
   "kinley",
   "lander",
   "shadow",
   "tate",
   "aaron",
   "raye",
   "zain_demigod",
   "natalia",
   "apollo",
   "crom",
   "god",
   "aphrodite"
  ]
 },
 "kale": {
  "canonRoute": "reed-vamp-werecheetah",
  "totalPassages": 14,
  "routes": [
   {
    "channel": "reed-vamp-werecheetah",
    "passages": 14,
    "share": 1.0,
    "first": "2023-11-16",
    "last": "2023-11-22",
    "kind": "canon",
    "castWith": [
     "reed",
     "madison_astor",
     "raye",
     "arnold_astor",
     "may",
     "paul",
     "xavier",
     "zeke"
    ]
   }
  ],
  "knownCharacters": [
   "reed",
   "madison_astor",
   "raye",
   "arnold_astor",
   "may",
   "paul",
   "xavier",
   "zeke"
  ]
 },
 "kelli": {
  "canonRoute": "werewolf-dimitri",
  "totalPassages": 4,
  "routes": [
   {
    "channel": "werewolf-dimitri",
    "passages": 4,
    "share": 1.0,
    "first": "2021-10-28",
    "last": "2021-10-28",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "dimitri",
     "kaleb",
     "slater",
     "kya_sg3",
     "frau",
     "god",
     "lionel",
     "byron",
     "gambit",
     "uncle_khan",
     "liera"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "dimitri",
   "kaleb",
   "slater",
   "kya_sg3",
   "frau",
   "god",
   "lionel",
   "byron",
   "gambit",
   "uncle_khan",
   "liera"
  ]
 },
 "keller": {
  "canonRoute": "kyas-choice",
  "totalPassages": 15,
  "routes": [
   {
    "channel": "kyas-choice",
    "passages": 12,
    "share": 0.8,
    "first": "2022-05-15",
    "last": "2022-05-16",
    "kind": "canon",
    "castWith": [
     "taren",
     "kya_sg3",
     "gale",
     "kya_sg1",
     "dash",
     "atropos",
     "haley_human",
     "kaleb",
     "skipper",
     "summer",
     "will"
    ]
   },
   {
    "channel": "shane-micah-wish",
    "passages": 2,
    "share": 0.1333,
    "first": "2023-12-04",
    "last": "2023-12-04",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "cruz",
     "micah",
     "ryder",
     "god",
     "trix",
     "ever",
     "diana",
     "lucifer",
     "rex",
     "jack"
    ]
   },
   {
    "channel": "frau-collin",
    "passages": 1,
    "share": 0.0667,
    "first": "2020-12-02",
    "last": "2020-12-02",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "rowan",
     "frau",
     "collin_keller",
     "arland_rees",
     "ezra",
     "felix_fairy",
     "rikki",
     "park",
     "alyce_char",
     "myra"
    ]
   }
  ],
  "knownCharacters": [
   "taren",
   "kya_sg3",
   "gale",
   "kya_sg1",
   "dash",
   "atropos",
   "haley_human",
   "kaleb",
   "skipper",
   "summer",
   "will"
  ]
 },
 "kent": {
  "canonRoute": "mansion-grounds",
  "totalPassages": 62,
  "routes": [
   {
    "channel": "mansion-grounds",
    "passages": 27,
    "share": 0.4355,
    "first": "2020-04-09",
    "last": "2020-04-09",
    "kind": "canon",
    "castWith": [
     "aria",
     "miles",
     "ajax",
     "benji",
     "rin",
     "bennett",
     "ever"
    ]
   },
   {
    "channel": "foyer-living-room",
    "passages": 21,
    "share": 0.3387,
    "first": "2020-04-07",
    "last": "2020-05-22",
    "kind": "route",
    "castWith": [
     "aria",
     "benji",
     "bennett",
     "ajax",
     "ragland",
     "rin",
     "miles",
     "may"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 4,
    "share": 0.0645,
    "first": "2020-04-07",
    "last": "2020-05-21",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 3,
    "share": 0.0484,
    "first": "2017-06-25",
    "last": "2020-03-23",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika"
    ]
   },
   {
    "channel": "memory-char-bios",
    "passages": 2,
    "share": 0.0323,
    "first": "2020-04-01",
    "last": "2020-05-22",
    "kind": "route",
    "castWith": [
     "bennett",
     "benji",
     "miles",
     "ajax",
     "ragland",
     "rin",
     "aria"
    ]
   },
   {
    "channel": "eros-and-kent-wing",
    "passages": 1,
    "share": 0.0161,
    "first": "2020-04-12",
    "last": "2020-04-12",
    "kind": "route",
    "castWith": [
     "aria",
     "bennett",
     "ragland",
     "benji",
     "ajax",
     "miles",
     "will"
    ]
   },
   {
    "channel": "rin-and-ragland-wing",
    "passages": 1,
    "share": 0.0161,
    "first": "2020-04-12",
    "last": "2020-04-12",
    "kind": "route",
    "castWith": [
     "ragland",
     "aria",
     "rin",
     "ajax",
     "miles"
    ]
   },
   {
    "channel": "kingdom-of-welis",
    "passages": 1,
    "share": 0.0161,
    "first": "2020-04-13",
    "last": "2020-04-13",
    "kind": "route",
    "castWith": [
     "aria",
     "caria",
     "ajax",
     "batiuba",
     "ragland",
     "will"
    ]
   },
   {
    "channel": "ooc",
    "passages": 1,
    "share": 0.0161,
    "first": "2020-06-07",
    "last": "2020-06-07",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "the-great-husbando-race",
    "passages": 1,
    "share": 0.0161,
    "first": "2020-05-19",
    "last": "2020-05-19",
    "kind": "route",
    "castWith": [
     "kira",
     "ray",
     "leon",
     "cupid_eros",
     "loki",
     "riku",
     "victor",
     "evelyn",
     "junta",
     "ben",
     "hyun_ryu",
     "jack"
    ]
   }
  ],
  "knownCharacters": [
   "aria",
   "miles",
   "ajax",
   "benji",
   "rin",
   "bennett",
   "ever"
  ]
 },
 "killian": {
  "canonRoute": "warring-men",
  "totalPassages": 162,
  "routes": [
   {
    "channel": "warring-men",
    "passages": 104,
    "share": 0.642,
    "first": "2025-08-07",
    "last": "2025-10-06",
    "kind": "canon",
    "castWith": [
     "aelira",
     "arthur_turayne",
     "autumn",
     "summer",
     "terrance",
     "may",
     "ragland",
     "will"
    ]
   },
   {
    "channel": "terrance-and-the-forest",
    "passages": 51,
    "share": 0.3148,
    "first": "2025-10-08",
    "last": "2025-10-17",
    "kind": "route",
    "castWith": [
     "aelira",
     "terrance",
     "arthur_turayne",
     "may",
     "ford",
     "arnold_astor",
     "god",
     "lira"
    ]
   },
   {
    "channel": "the-arena",
    "passages": 5,
    "share": 0.0309,
    "first": "2020-04-02",
    "last": "2020-04-02",
    "kind": "route",
    "castWith": [
     "bryce",
     "evelyn",
     "mr_han_sr",
     "rio",
     "ever",
     "may"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 2,
    "share": 0.0123,
    "first": "2020-04-02",
    "last": "2020-04-03",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   }
  ],
  "knownCharacters": [
   "aelira",
   "arthur_turayne",
   "autumn",
   "summer",
   "terrance",
   "may",
   "ragland",
   "will"
  ]
 },
 "kim": {
  "canonRoute": "cruz-x-human",
  "totalPassages": 1,
  "routes": [
   {
    "channel": "cruz-x-human",
    "passages": 1,
    "share": 1.0,
    "first": "2021-05-02",
    "last": "2021-05-02",
    "kind": "canon",
    "castWith": [
     "cruz",
     "skye",
     "nolan",
     "ryder",
     "audrey",
     "troy",
     "adrien",
     "bryce",
     "airi",
     "natasha",
     "diana",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "skye",
   "nolan",
   "ryder",
   "audrey",
   "troy",
   "adrien",
   "bryce",
   "airi",
   "natasha",
   "diana",
   "will"
  ]
 },
 "kiro": {
  "canonRoute": "misc-location",
  "totalPassages": 120,
  "routes": [
   {
    "channel": "misc-location",
    "passages": 29,
    "share": 0.2417,
    "first": "2020-05-04",
    "last": "2020-05-10",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "riku",
     "ares",
     "hiro",
     "lex",
     "lance",
     "ezra",
     "lucius",
     "darren",
     "kaleb",
     "raye",
     "kya_sg3"
    ]
   },
   {
    "channel": "ooc",
    "passages": 27,
    "share": 0.225,
    "first": "2020-04-30",
    "last": "2020-06-20",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "greek-house",
    "passages": 20,
    "share": 0.1667,
    "first": "2020-05-06",
    "last": "2020-05-10",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hiro",
     "darren",
     "lex",
     "raye",
     "kya_sg3",
     "ares",
     "riku",
     "kya_sg1",
     "lacie",
     "aphrodite",
     "god"
    ]
   },
   {
    "channel": "the-blacklight",
    "passages": 15,
    "share": 0.125,
    "first": "2020-04-30",
    "last": "2020-05-01",
    "kind": "route",
    "castWith": [
     "evelyn",
     "darren",
     "lucius",
     "lacie",
     "lex",
     "milo",
     "kya_sg3",
     "kya_sg1",
     "cruz",
     "rowan",
     "kaleb",
     "aphrodite"
    ]
   },
   {
    "channel": "athena-class",
    "passages": 11,
    "share": 0.0917,
    "first": "2020-06-18",
    "last": "2020-06-18",
    "kind": "route",
    "castWith": [
     "rex",
     "evelyn",
     "diana",
     "milo",
     "cupid_eros",
     "athena",
     "dimitri",
     "dike",
     "kya_sg1",
     "aaron",
     "kya_sg3",
     "hiro"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 4,
    "share": 0.0333,
    "first": "2020-05-22",
    "last": "2020-05-30",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "staff-break-room",
    "passages": 4,
    "share": 0.0333,
    "first": "2020-06-14",
    "last": "2020-06-15",
    "kind": "route",
    "castWith": [
     "dimitri",
     "rex",
     "evelyn",
     "saph",
     "diana",
     "aaron",
     "milo",
     "skipper",
     "roman",
     "sebastian_vamp",
     "kya_sg3",
     "sebastian_siren"
    ]
   },
   {
    "channel": "dorms",
    "passages": 3,
    "share": 0.025,
    "first": "2020-05-05",
    "last": "2020-05-05",
    "kind": "route",
    "castWith": [
     "agnar",
     "kya_sg3",
     "agmund",
     "evelyn",
     "raye",
     "cole",
     "kya_sg1",
     "riku",
     "kaleb",
     "penelope_valk",
     "loki",
     "svira"
    ]
   },
   {
    "channel": "hiros-room",
    "passages": 2,
    "share": 0.0167,
    "first": "2020-05-10",
    "last": "2020-05-11",
    "kind": "route",
    "castWith": [
     "hiro",
     "evelyn",
     "darren",
     "ares",
     "riku",
     "lex",
     "hades",
     "lacie",
     "zeus"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 1,
    "share": 0.0083,
    "first": "2020-07-10",
    "last": "2020-07-10",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika"
    ]
   },
   {
    "channel": "general",
    "passages": 1,
    "share": 0.0083,
    "first": "2020-08-17",
    "last": "2020-08-17",
    "kind": "ooc",
    "castWith": [
     "ezra",
     "eric",
     "cruz",
     "james",
     "apollo",
     "lance",
     "aaron",
     "silas_mirace",
     "raye",
     "moros",
     "ace",
     "kaleb"
    ]
   },
   {
    "channel": "cafeteria",
    "passages": 1,
    "share": 0.0083,
    "first": "2020-05-13",
    "last": "2020-05-13",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hiro",
     "agnar",
     "agmund",
     "kya_sg3",
     "lex",
     "kaleb",
     "penelope_valk",
     "svira",
     "ares",
     "riku",
     "darren"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "riku",
   "ares",
   "hiro",
   "lex",
   "lance",
   "ezra",
   "lucius",
   "darren",
   "kaleb",
   "raye",
   "kya_sg3"
  ]
 },
 "knox": {
  "canonRoute": null,
  "totalPassages": 3,
  "routes": [
   {
    "channel": "ww-war-au",
    "passages": 3,
    "share": 1.0,
    "first": "2021-11-20",
    "last": "2021-11-22",
    "kind": "au",
    "castWith": [
     "evelyn",
     "cruz",
     "ace",
     "ezra",
     "lindon",
     "kaleb",
     "rowan",
     "bryce",
     "lance",
     "raye",
     "nolan",
     "primrose"
    ]
   }
  ],
  "knownCharacters": []
 },
 "kris": {
  "canonRoute": "junta-tim-soulmates",
  "totalPassages": 22,
  "routes": [
   {
    "channel": "junta-tim-soulmates",
    "passages": 13,
    "share": 0.5909,
    "first": "2023-09-13",
    "last": "2023-09-22",
    "kind": "canon",
    "castWith": [
     "junta",
     "tim",
     "kieran",
     "raz",
     "peter",
     "dalton",
     "val",
     "vanessa",
     "ever",
     "aphrodite",
     "natasha",
     "will"
    ]
   },
   {
    "channel": "wizards-chamber",
    "passages": 6,
    "share": 0.2727,
    "first": "2020-04-28",
    "last": "2020-04-29",
    "kind": "route",
    "castWith": [
     "ezra",
     "crom",
     "kya_sg3",
     "kya_sg1",
     "jane",
     "primrose",
     "kyo",
     "polly",
     "will"
    ]
   },
   {
    "channel": "aquarium",
    "passages": 2,
    "share": 0.0909,
    "first": "2020-04-29",
    "last": "2020-04-29",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "ezra",
     "kya_sg1",
     "polly",
     "sebastian_vamp",
     "skipper",
     "sebastian_siren",
     "lira",
     "kyo",
     "crom",
     "evelyn",
     "kaleb"
    ]
   },
   {
    "channel": "kyas_penthouse",
    "passages": 1,
    "share": 0.0455,
    "first": "2020-03-29",
    "last": "2020-03-29",
    "kind": "route",
    "castWith": [
     "kaleb",
     "evelyn",
     "raye",
     "ezra",
     "kya_sg3",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "mr_han_sr",
     "bryce",
     "god",
     "cruz"
    ]
   }
  ],
  "knownCharacters": [
   "junta",
   "tim",
   "kieran",
   "raz",
   "peter",
   "dalton",
   "val",
   "vanessa",
   "ever",
   "aphrodite",
   "natasha",
   "will"
  ]
 },
 "lacey": {
  "canonRoute": "human-not-human",
  "totalPassages": 1,
  "routes": [
   {
    "channel": "human-not-human",
    "passages": 1,
    "share": 1.0,
    "first": "2022-10-16",
    "last": "2022-10-16",
    "kind": "canon",
    "castWith": [
     "dillon",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "sebastian_vamp",
     "drisella",
     "god",
     "blair",
     "madeline",
     "tanya",
     "topps",
     "starlet"
    ]
   }
  ],
  "knownCharacters": [
   "dillon",
   "kya_sg3",
   "kya_sg1",
   "sebastian_siren",
   "sebastian_vamp",
   "drisella",
   "god",
   "blair",
   "madeline",
   "tanya",
   "topps",
   "starlet"
  ]
 },
 "lacie": {
  "canonRoute": "the-blacklight",
  "totalPassages": 49,
  "routes": [
   {
    "channel": "the-blacklight",
    "passages": 25,
    "share": 0.5102,
    "first": "2020-04-30",
    "last": "2020-05-01",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "darren",
     "lucius",
     "kiro",
     "lex",
     "milo",
     "kya_sg3",
     "kya_sg1",
     "cruz",
     "rowan",
     "kaleb",
     "aphrodite"
    ]
   },
   {
    "channel": "dorms",
    "passages": 9,
    "share": 0.1837,
    "first": "2020-05-01",
    "last": "2020-05-02",
    "kind": "route",
    "castWith": [
     "agnar",
     "kya_sg3",
     "agmund",
     "evelyn",
     "raye",
     "cole",
     "kya_sg1",
     "riku",
     "kaleb",
     "penelope_valk",
     "loki",
     "svira"
    ]
   },
   {
    "channel": "greek-house",
    "passages": 8,
    "share": 0.1633,
    "first": "2020-05-09",
    "last": "2020-05-09",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hiro",
     "darren",
     "lex",
     "kiro",
     "raye",
     "kya_sg3",
     "ares",
     "riku",
     "kya_sg1",
     "aphrodite",
     "god"
    ]
   },
   {
    "channel": "misc-location",
    "passages": 2,
    "share": 0.0408,
    "first": "2020-05-04",
    "last": "2020-05-12",
    "kind": "route",
    "castWith": [
     "evelyn",
     "riku",
     "ares",
     "kiro",
     "hiro",
     "lex",
     "lance",
     "ezra",
     "lucius",
     "darren",
     "kaleb",
     "raye"
    ]
   },
   {
    "channel": "coles-room",
    "passages": 2,
    "share": 0.0408,
    "first": "2020-05-09",
    "last": "2020-05-09",
    "kind": "route",
    "castWith": [
     "cole",
     "abraham",
     "kya_sg3",
     "hades",
     "raye",
     "riku"
    ]
   },
   {
    "channel": "hiros-room",
    "passages": 1,
    "share": 0.0204,
    "first": "2020-05-09",
    "last": "2020-05-09",
    "kind": "route",
    "castWith": [
     "hiro",
     "evelyn",
     "darren",
     "ares",
     "riku",
     "kiro",
     "lex",
     "hades",
     "zeus"
    ]
   },
   {
    "channel": "cafeteria",
    "passages": 1,
    "share": 0.0204,
    "first": "2020-05-13",
    "last": "2020-05-13",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hiro",
     "agnar",
     "agmund",
     "kya_sg3",
     "lex",
     "kaleb",
     "penelope_valk",
     "svira",
     "ares",
     "riku",
     "darren"
    ]
   },
   {
    "channel": "texas",
    "passages": 1,
    "share": 0.0204,
    "first": "2020-05-17",
    "last": "2020-05-17",
    "kind": "route",
    "castWith": [
     "hiro",
     "evelyn",
     "darren",
     "athena"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "darren",
   "lucius",
   "kiro",
   "lex",
   "milo",
   "kya_sg3",
   "kya_sg1",
   "cruz",
   "rowan",
   "kaleb",
   "aphrodite"
  ]
 },
 "laito": {
  "canonRoute": "parabus",
  "totalPassages": 26,
  "routes": [
   {
    "channel": "parabus",
    "passages": 25,
    "share": 0.9615,
    "first": "2020-06-04",
    "last": "2020-06-06",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "lucius",
     "rex",
     "rowan",
     "boko",
     "ryan",
     "stash",
     "raye",
     "mr_han_sr",
     "cruz",
     "kya_sg3",
     "kaleb"
    ]
   },
   {
    "channel": "bios",
    "passages": 1,
    "share": 0.0385,
    "first": "2020-06-05",
    "last": "2020-06-05",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "evelyn",
     "lucius",
     "athena",
     "bryce",
     "val",
     "hiro",
     "raz",
     "rex",
     "vanessa",
     "halo",
     "dalton"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "lucius",
   "rex",
   "rowan",
   "boko",
   "ryan",
   "stash",
   "raye",
   "mr_han_sr",
   "cruz",
   "kya_sg3",
   "kaleb"
  ]
 },
 "lander": {
  "canonRoute": "kinley-reset-route",
  "totalPassages": 31,
  "routes": [
   {
    "channel": "kinley-reset-route",
    "passages": 31,
    "share": 1.0,
    "first": "2022-02-19",
    "last": "2022-03-08",
    "kind": "canon",
    "castWith": [
     "kinley",
     "shadow",
     "tate",
     "aaron",
     "raye",
     "zain_demigod",
     "natalia",
     "apollo",
     "crom",
     "god",
     "jova",
     "aphrodite"
    ]
   }
  ],
  "knownCharacters": [
   "kinley",
   "shadow",
   "tate",
   "aaron",
   "raye",
   "zain_demigod",
   "natalia",
   "apollo",
   "crom",
   "god",
   "jova",
   "aphrodite"
  ]
 },
 "langley": {
  "canonRoute": "lets-abduct-evie",
  "totalPassages": 9,
  "routes": [
   {
    "channel": "fairy-au",
    "passages": 4,
    "share": 0.4444,
    "first": "2026-03-04",
    "last": "2026-03-04",
    "kind": "au",
    "castWith": [
     "malakai",
     "felix_fairy",
     "juliette_fairy",
     "cyrus_fairy",
     "nia_fairy",
     "gus_fairy",
     "god",
     "haley_human",
     "will"
    ]
   },
   {
    "channel": "fairy-au-bios",
    "passages": 3,
    "share": 0.3333,
    "first": "2026-03-13",
    "last": "2026-03-13",
    "kind": "au",
    "castWith": [
     "juliette_fairy",
     "malakai",
     "felix_fairy",
     "cyrus_fairy",
     "nia_fairy",
     "gus_fairy"
    ]
   },
   {
    "channel": "lets-abduct-evie",
    "passages": 2,
    "share": 0.2222,
    "first": "2021-07-28",
    "last": "2021-07-28",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "dimitri",
     "ryoto",
     "dodge",
     "ms_tia",
     "kaleb",
     "frau",
     "aki",
     "cruz",
     "talbot",
     "ares",
     "zeus"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "dimitri",
   "ryoto",
   "dodge",
   "ms_tia",
   "kaleb",
   "frau",
   "aki",
   "cruz",
   "talbot",
   "ares",
   "zeus"
  ]
 },
 "leiden": {
  "canonRoute": "kya-sold-off",
  "totalPassages": 187,
  "routes": [
   {
    "channel": "kya-sold-off",
    "passages": 133,
    "share": 0.7112,
    "first": "2021-07-15",
    "last": "2021-08-17",
    "kind": "canon",
    "castWith": [
     "melody",
     "callan",
     "kya_sg3",
     "frank",
     "kya_sg1",
     "umu",
     "evelyn",
     "kaleb",
     "garrett",
     "god",
     "may",
     "will"
    ]
   },
   {
    "channel": "kya-senior-year",
    "passages": 54,
    "share": 0.2888,
    "first": "2021-07-03",
    "last": "2021-07-15",
    "kind": "route",
    "castWith": [
     "callan",
     "ezra",
     "melody",
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "raye",
     "tate",
     "sebastian_vamp",
     "dillon",
     "sebastian_siren",
     "evelyn"
    ]
   }
  ],
  "knownCharacters": [
   "melody",
   "callan",
   "kya_sg3",
   "frank",
   "kya_sg1",
   "umu",
   "evelyn",
   "kaleb",
   "garrett",
   "god",
   "may",
   "will"
  ]
 },
 "levi": {
  "canonRoute": "plz-love-lachesis",
  "totalPassages": 44,
  "routes": [
   {
    "channel": "plz-love-lachesis",
    "passages": 43,
    "share": 0.9773,
    "first": "2022-11-11",
    "last": "2022-11-21",
    "kind": "canon",
    "castWith": [
     "lachesis",
     "ramiel",
     "lance",
     "god",
     "lucifer",
     "apollo",
     "aion",
     "atropos",
     "zeus",
     "zadkiel",
     "clothos",
     "asrius"
    ]
   },
   {
    "channel": "cruz-greek-party",
    "passages": 1,
    "share": 0.0227,
    "first": "2025-07-19",
    "last": "2025-07-19",
    "kind": "route",
    "castWith": [
     "cruz"
    ]
   }
  ],
  "knownCharacters": [
   "lachesis",
   "ramiel",
   "lance",
   "god",
   "lucifer",
   "apollo",
   "aion",
   "atropos",
   "zeus",
   "zadkiel",
   "clothos",
   "asrius"
  ]
 },
 "lex": {
  "canonRoute": "evelyn-college-2",
  "totalPassages": 272,
  "routes": [
   {
    "channel": "evelyn-college-2",
    "passages": 103,
    "share": 0.3787,
    "first": "2021-01-05",
    "last": "2021-01-26",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "darren",
     "dimitri",
     "hades",
     "raye",
     "jon",
     "ares",
     "kaleb",
     "cruz",
     "kya_sg3",
     "ari",
     "aibell"
    ]
   },
   {
    "channel": "ooc",
    "passages": 37,
    "share": 0.136,
    "first": "2020-05-06",
    "last": "2020-06-19",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "rex",
     "agnar"
    ]
   },
   {
    "channel": "greek-house",
    "passages": 31,
    "share": 0.114,
    "first": "2020-05-05",
    "last": "2020-05-08",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hiro",
     "darren",
     "kiro",
     "raye",
     "kya_sg3",
     "ares",
     "riku",
     "kya_sg1",
     "lacie",
     "aphrodite",
     "god"
    ]
   },
   {
    "channel": "misc-location",
    "passages": 24,
    "share": 0.0882,
    "first": "2020-05-04",
    "last": "2020-05-11",
    "kind": "route",
    "castWith": [
     "evelyn",
     "riku",
     "ares",
     "kiro",
     "hiro",
     "lance",
     "ezra",
     "lucius",
     "darren",
     "kaleb",
     "raye",
     "kya_sg3"
    ]
   },
   {
    "channel": "kinley-is-a-nondecisive-butt",
    "passages": 21,
    "share": 0.0772,
    "first": "2022-04-06",
    "last": "2022-04-11",
    "kind": "route",
    "castWith": [
     "zain_demigod",
     "kinley",
     "apollo",
     "cupid_eros",
     "hera",
     "lachesis",
     "sebastian_vamp",
     "sebastian_siren",
     "ben",
     "god",
     "will",
     "zeus"
    ]
   },
   {
    "channel": "1-real-cruz",
    "passages": 14,
    "share": 0.0515,
    "first": "2023-01-19",
    "last": "2023-01-22",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "ares",
     "lance",
     "selma",
     "zeus",
     "lindon",
     "hera",
     "ryder",
     "apollo",
     "nolan"
    ]
   },
   {
    "channel": "the-blacklight",
    "passages": 11,
    "share": 0.0404,
    "first": "2020-04-30",
    "last": "2020-05-01",
    "kind": "route",
    "castWith": [
     "evelyn",
     "darren",
     "lucius",
     "lacie",
     "kiro",
     "milo",
     "kya_sg3",
     "kya_sg1",
     "cruz",
     "rowan",
     "kaleb",
     "aphrodite"
    ]
   },
   {
    "channel": "cafeteria",
    "passages": 8,
    "share": 0.0294,
    "first": "2020-05-13",
    "last": "2020-05-13",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hiro",
     "agnar",
     "agmund",
     "kya_sg3",
     "kaleb",
     "penelope_valk",
     "svira",
     "ares",
     "riku",
     "darren",
     "kya_sg1"
    ]
   },
   {
    "channel": "dining-hall",
    "passages": 5,
    "share": 0.0184,
    "first": "2020-06-08",
    "last": "2020-06-08",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "bryce",
     "rex",
     "milo",
     "aaron",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "sebastian_vamp",
     "dike",
     "agnar"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 4,
    "share": 0.0147,
    "first": "2020-05-22",
    "last": "2020-05-30",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "dorms",
    "passages": 4,
    "share": 0.0147,
    "first": "2020-05-01",
    "last": "2020-05-05",
    "kind": "route",
    "castWith": [
     "agnar",
     "kya_sg3",
     "agmund",
     "evelyn",
     "raye",
     "cole",
     "kya_sg1",
     "riku",
     "kaleb",
     "penelope_valk",
     "loki",
     "svira"
    ]
   },
   {
    "channel": "mt-olympus",
    "passages": 3,
    "share": 0.011,
    "first": "2020-06-21",
    "last": "2020-06-24",
    "kind": "route",
    "castWith": [
     "evelyn",
     "libion",
     "ares",
     "rex",
     "persephone",
     "bion",
     "hades",
     "aphrodite",
     "hercules",
     "demeter",
     "zeus",
     "athena"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "darren",
   "dimitri",
   "hades",
   "raye",
   "jon",
   "ares",
   "kaleb",
   "cruz",
   "kya_sg3",
   "ari",
   "aibell"
  ]
 },
 "libion": {
  "canonRoute": "mt-olympus",
  "totalPassages": 119,
  "routes": [
   {
    "channel": "mt-olympus",
    "passages": 36,
    "share": 0.3025,
    "first": "2020-03-29",
    "last": "2020-03-30",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "ares",
     "rex",
     "persephone",
     "bion",
     "hades",
     "aphrodite",
     "hercules",
     "demeter",
     "zeus",
     "athena",
     "zerden"
    ]
   },
   {
    "channel": "hades-palace",
    "passages": 34,
    "share": 0.2857,
    "first": "2020-03-29",
    "last": "2020-03-29",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hades",
     "cruz",
     "bryce",
     "bion",
     "persephone",
     "will",
     "hercules",
     "hermes",
     "god"
    ]
   },
   {
    "channel": "heaven",
    "passages": 28,
    "share": 0.2353,
    "first": "2020-03-28",
    "last": "2020-03-30",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "bion",
     "hades",
     "persephone",
     "demeter",
     "god",
     "aphrodite",
     "apollo",
     "rika"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 20,
    "share": 0.1681,
    "first": "2020-03-29",
    "last": "2020-04-01",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "dimitri",
     "hades",
     "god",
     "rika",
     "nolan"
    ]
   },
   {
    "channel": "pack-cabin",
    "passages": 1,
    "share": 0.0084,
    "first": "2020-03-31",
    "last": "2020-03-31",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "kaleb",
     "bryce",
     "kya_sg3",
     "rika",
     "alistair",
     "ezra",
     "hades",
     "alistair_turayne",
     "ryder",
     "kya_sg1"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "ares",
   "rex",
   "persephone",
   "bion",
   "hades",
   "aphrodite",
   "hercules",
   "demeter",
   "zeus",
   "athena",
   "zerden"
  ]
 },
 "liera": {
  "canonRoute": "werewolf-dimitri",
  "totalPassages": 4,
  "routes": [
   {
    "channel": "werewolf-dimitri",
    "passages": 4,
    "share": 1.0,
    "first": "2021-10-28",
    "last": "2021-10-28",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "dimitri",
     "kaleb",
     "slater",
     "kya_sg3",
     "frau",
     "god",
     "lionel",
     "byron",
     "gambit",
     "uncle_khan",
     "kelli"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "dimitri",
   "kaleb",
   "slater",
   "kya_sg3",
   "frau",
   "god",
   "lionel",
   "byron",
   "gambit",
   "uncle_khan",
   "kelli"
  ]
 },
 "lionel": {
  "canonRoute": "werewolf-dimitri",
  "totalPassages": 10,
  "routes": [
   {
    "channel": "werewolf-dimitri",
    "passages": 6,
    "share": 0.6,
    "first": "2021-10-28",
    "last": "2021-10-28",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "dimitri",
     "kaleb",
     "slater",
     "kya_sg3",
     "frau",
     "god",
     "byron",
     "gambit",
     "uncle_khan",
     "kelli",
     "liera"
    ]
   },
   {
    "channel": "cruz-nicole-dollar-store",
    "passages": 4,
    "share": 0.4,
    "first": "2020-09-12",
    "last": "2020-09-12",
    "kind": "route",
    "castWith": [
     "cruz",
     "raz",
     "lance",
     "lachesis",
     "bryce",
     "nolan",
     "renee",
     "aphrodite",
     "clothos",
     "atropos",
     "nicole_wolf",
     "nicole_sg3"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "dimitri",
   "kaleb",
   "slater",
   "kya_sg3",
   "frau",
   "god",
   "byron",
   "gambit",
   "uncle_khan",
   "kelli",
   "liera"
  ]
 },
 "lira": {
  "canonRoute": "aquarium",
  "totalPassages": 27,
  "routes": [
   {
    "channel": "aquarium",
    "passages": 9,
    "share": 0.3333,
    "first": "2020-04-14",
    "last": "2020-04-14",
    "kind": "canon",
    "castWith": [
     "kya_sg3",
     "ezra",
     "kya_sg1",
     "polly",
     "sebastian_vamp",
     "skipper",
     "sebastian_siren",
     "kyo",
     "crom",
     "evelyn",
     "kaleb",
     "kris"
    ]
   },
   {
    "channel": "kya-senior-year",
    "passages": 7,
    "share": 0.2593,
    "first": "2021-06-25",
    "last": "2021-06-26",
    "kind": "route",
    "castWith": [
     "callan",
     "ezra",
     "leiden",
     "melody",
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "raye",
     "tate",
     "sebastian_vamp",
     "dillon",
     "sebastian_siren"
    ]
   },
   {
    "channel": "containment-cells",
    "passages": 7,
    "share": 0.2593,
    "first": "2020-04-26",
    "last": "2020-04-27",
    "kind": "route",
    "castWith": [
     "ezra",
     "evelyn",
     "ace",
     "kya_sg3",
     "rowan",
     "kya_sg1",
     "sebastian_vamp",
     "cruz",
     "sebastian_siren",
     "alistair",
     "alistair_turayne",
     "may"
    ]
   },
   {
    "channel": "brothel",
    "passages": 2,
    "share": 0.0741,
    "first": "2020-04-28",
    "last": "2020-04-28",
    "kind": "route",
    "castWith": [
     "ezra",
     "evelyn",
     "rowan",
     "kya_sg3",
     "kya_sg1",
     "primrose",
     "lily",
     "kaleb",
     "nellie",
     "lissa",
     "raye",
     "ace"
    ]
   },
   {
    "channel": "terrance-and-the-forest",
    "passages": 1,
    "share": 0.037,
    "first": "2025-10-08",
    "last": "2025-10-08",
    "kind": "route",
    "castWith": [
     "aelira",
     "terrance",
     "killian",
     "arthur_turayne",
     "may",
     "ford",
     "arnold_astor",
     "god"
    ]
   },
   {
    "channel": "Nicole - 7/21/2026",
    "passages": 1,
    "share": 0.037,
    "first": "2026-07-24",
    "last": "2026-07-24",
    "kind": "route",
    "castWith": [
     "ford",
     "cruz",
     "audrey",
     "trix",
     "ryder",
     "nicole_human",
     "nicole_wolf",
     "nicole_sg3",
     "nolan",
     "ace",
     "jack",
     "mr_han_sr"
    ]
   }
  ],
  "knownCharacters": [
   "kya_sg3",
   "ezra",
   "kya_sg1",
   "polly",
   "sebastian_vamp",
   "skipper",
   "sebastian_siren",
   "kyo",
   "crom",
   "evelyn",
   "kaleb",
   "kris"
  ]
 },
 "lissa": {
  "canonRoute": "brothel",
  "totalPassages": 9,
  "routes": [
   {
    "channel": "brothel",
    "passages": 9,
    "share": 1.0,
    "first": "2020-04-27",
    "last": "2020-04-27",
    "kind": "canon",
    "castWith": [
     "ezra",
     "evelyn",
     "rowan",
     "kya_sg3",
     "kya_sg1",
     "primrose",
     "lily",
     "kaleb",
     "nellie",
     "raye",
     "ace",
     "mr_han_sr"
    ]
   }
  ],
  "knownCharacters": [
   "ezra",
   "evelyn",
   "rowan",
   "kya_sg3",
   "kya_sg1",
   "primrose",
   "lily",
   "kaleb",
   "nellie",
   "raye",
   "ace",
   "mr_han_sr"
  ]
 },
 "liz": {
  "canonRoute": "vaughneo-and-juliet",
  "totalPassages": 6,
  "routes": [
   {
    "channel": "vaughneo-and-juliet",
    "passages": 5,
    "share": 0.8333,
    "first": "2025-12-06",
    "last": "2025-12-07",
    "kind": "canon",
    "castWith": [
     "vaughn",
     "brax",
     "lindon",
     "declan",
     "ares",
     "skye",
     "roman",
     "mary_cataldi",
     "nicole_human",
     "aphrodite",
     "ace",
     "ben"
    ]
   },
   {
    "channel": "werewolf-dimitri",
    "passages": 1,
    "share": 0.1667,
    "first": "2021-10-28",
    "last": "2021-10-28",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "kaleb",
     "slater",
     "kya_sg3",
     "frau",
     "god",
     "lionel",
     "byron",
     "gambit",
     "uncle_khan",
     "kelli"
    ]
   }
  ],
  "knownCharacters": [
   "vaughn",
   "brax",
   "lindon",
   "declan",
   "ares",
   "skye",
   "roman",
   "mary_cataldi",
   "nicole_human",
   "aphrodite",
   "ace",
   "ben"
  ]
 },
 "loki": {
  "canonRoute": "asgard",
  "totalPassages": 106,
  "routes": [
   {
    "channel": "asgard",
    "passages": 28,
    "share": 0.2642,
    "first": "2020-05-18",
    "last": "2020-05-21",
    "kind": "canon",
    "castWith": [
     "agnar",
     "agmund",
     "kya_sg3",
     "odin",
     "svira",
     "penelope_valk",
     "kya_sg1",
     "sif",
     "thor",
     "freya",
     "god",
     "frigg"
    ]
   },
   {
    "channel": "dorms",
    "passages": 19,
    "share": 0.1792,
    "first": "2020-05-08",
    "last": "2020-05-18",
    "kind": "route",
    "castWith": [
     "agnar",
     "kya_sg3",
     "agmund",
     "evelyn",
     "raye",
     "cole",
     "kya_sg1",
     "riku",
     "kaleb",
     "penelope_valk",
     "svira",
     "darren"
    ]
   },
   {
    "channel": "ooc",
    "passages": 18,
    "share": 0.1698,
    "first": "2020-05-08",
    "last": "2020-06-19",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "ag-ag",
    "passages": 16,
    "share": 0.1509,
    "first": "2022-10-03",
    "last": "2022-10-07",
    "kind": "route",
    "castWith": [
     "agnar",
     "agmund",
     "frigg",
     "odin",
     "kya_sg3",
     "freya",
     "penelope_valk",
     "will",
     "evelyn",
     "sebastian_vamp",
     "sebastian_siren",
     "hiro"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 6,
    "share": 0.0566,
    "first": "2020-05-21",
    "last": "2020-05-30",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "college-campus",
    "passages": 6,
    "share": 0.0566,
    "first": "2020-05-11",
    "last": "2020-05-13",
    "kind": "route",
    "castWith": [
     "agnar",
     "agmund",
     "kya_sg3",
     "penelope_valk",
     "evelyn",
     "svira",
     "rowan",
     "may",
     "jon",
     "kya_sg1",
     "kaleb",
     "darren"
    ]
   },
   {
    "channel": "agnar-agmus-house",
    "passages": 5,
    "share": 0.0472,
    "first": "2020-05-19",
    "last": "2020-05-19",
    "kind": "route",
    "castWith": [
     "agmund",
     "agnar",
     "kya_sg3"
    ]
   },
   {
    "channel": "new-fae-world",
    "passages": 4,
    "share": 0.0377,
    "first": "2025-05-26",
    "last": "2025-05-28",
    "kind": "route",
    "castWith": [
     "will"
    ]
   },
   {
    "channel": "the-great-husbando-race",
    "passages": 2,
    "share": 0.0189,
    "first": "2020-06-16",
    "last": "2020-07-03",
    "kind": "route",
    "castWith": [
     "kira",
     "ray",
     "leon",
     "cupid_eros",
     "riku",
     "victor",
     "evelyn",
     "junta",
     "ben",
     "hyun_ryu",
     "jack",
     "kent"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 2,
    "share": 0.0189,
    "first": "2020-03-28",
    "last": "2020-03-31",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika"
    ]
   }
  ],
  "knownCharacters": [
   "agnar",
   "agmund",
   "kya_sg3",
   "odin",
   "svira",
   "penelope_valk",
   "kya_sg1",
   "sif",
   "thor",
   "freya",
   "god",
   "frigg"
  ]
 },
 "lonnie": {
  "canonRoute": "haggle-for-the-girl",
  "totalPassages": 103,
  "routes": [
   {
    "channel": "haggle-for-the-girl",
    "passages": 97,
    "share": 0.9417,
    "first": "2023-12-17",
    "last": "2024-01-21",
    "kind": "canon",
    "castWith": [
     "lachesis",
     "lucifer",
     "asrius",
     "god",
     "ramiel",
     "gabriel",
     "lance",
     "hades",
     "alyk",
     "aphrodite",
     "atropos",
     "zeus"
    ]
   },
   {
    "channel": "cruz-sucks-ford-fucks",
    "passages": 6,
    "share": 0.0583,
    "first": "2024-05-31",
    "last": "2024-06-09",
    "kind": "route",
    "castWith": [
     "ford",
     "cruz",
     "evelyn",
     "audrey",
     "bryce",
     "jack",
     "dimitri",
     "rowan",
     "nolan",
     "ryder",
     "lyden",
     "alyce_char"
    ]
   }
  ],
  "knownCharacters": [
   "lachesis",
   "lucifer",
   "asrius",
   "god",
   "ramiel",
   "gabriel",
   "lance",
   "hades",
   "alyk",
   "aphrodite",
   "atropos",
   "zeus"
  ]
 },
 "lore": {
  "canonRoute": "to-the-max",
  "totalPassages": 2,
  "routes": [
   {
    "channel": "to-the-max",
    "passages": 2,
    "share": 1.0,
    "first": "2023-05-28",
    "last": "2023-05-29",
    "kind": "canon",
    "castWith": [
     "maxen_bryers",
     "addison",
     "trace_renton",
     "kya_sg3",
     "kya_sg1",
     "rick",
     "evelyn",
     "beatrice",
     "dillon",
     "budd",
     "paula",
     "diana"
    ]
   }
  ],
  "knownCharacters": [
   "maxen_bryers",
   "addison",
   "trace_renton",
   "kya_sg3",
   "kya_sg1",
   "rick",
   "evelyn",
   "beatrice",
   "dillon",
   "budd",
   "paula",
   "diana"
  ]
 },
 "lord_miros": {
  "canonRoute": "nicole-x-cruz",
  "totalPassages": 3,
  "routes": [
   {
    "channel": "nicole-x-cruz",
    "passages": 3,
    "share": 1.0,
    "first": "2020-09-07",
    "last": "2020-09-08",
    "kind": "canon",
    "castWith": [
     "otto",
     "cruz",
     "jones",
     "nicole_human",
     "duran",
     "sorsha",
     "kya_sg1",
     "lucifer",
     "nicole_wolf",
     "kya_sg3",
     "nicole_sg3",
     "christopher_donovan"
    ]
   }
  ],
  "knownCharacters": [
   "otto",
   "cruz",
   "jones",
   "nicole_human",
   "duran",
   "sorsha",
   "kya_sg1",
   "lucifer",
   "nicole_wolf",
   "kya_sg3",
   "nicole_sg3",
   "christopher_donovan"
  ]
 },
 "luca": {
  "canonRoute": "forest",
  "totalPassages": 73,
  "routes": [
   {
    "channel": "forest",
    "passages": 26,
    "share": 0.3562,
    "first": "2020-03-26",
    "last": "2020-03-27",
    "kind": "canon",
    "castWith": [
     "cruz",
     "evelyn",
     "bryce",
     "nolan"
    ]
   },
   {
    "channel": "pack_medic",
    "passages": 18,
    "share": 0.2466,
    "first": "2020-03-27",
    "last": "2020-03-27",
    "kind": "route",
    "castWith": [
     "evelyn",
     "ryder",
     "cruz",
     "bryce"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 10,
    "share": 0.137,
    "first": "2020-03-26",
    "last": "2020-03-29",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika"
    ]
   },
   {
    "channel": "pack_house",
    "passages": 7,
    "share": 0.0959,
    "first": "2020-03-27",
    "last": "2020-03-27",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "nolan",
     "bryce",
     "audrey",
     "allie",
     "alyce_char",
     "trix",
     "asmodeus",
     "ryder",
     "kaleb",
     "ezra"
    ]
   },
   {
    "channel": "lance-is-a-family-man",
    "passages": 6,
    "share": 0.0822,
    "first": "2024-04-30",
    "last": "2024-04-30",
    "kind": "route",
    "castWith": [
     "lance",
     "evelyn",
     "cruz",
     "audrey",
     "bryce",
     "lyden",
     "hermes",
     "roger",
     "dimitri",
     "hades",
     "diana",
     "zeus"
    ]
   },
   {
    "channel": "cruz-is-not-dead",
    "passages": 3,
    "share": 0.0411,
    "first": "2022-04-07",
    "last": "2022-04-08",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "ford",
     "ryder",
     "lucifer",
     "bryce",
     "audrey",
     "apollo",
     "ares",
     "god",
     "clint",
     "hades"
    ]
   },
   {
    "channel": "pack_meeting_room",
    "passages": 2,
    "share": 0.0274,
    "first": "2020-03-27",
    "last": "2020-03-27",
    "kind": "route",
    "castWith": [
     "bryce",
     "evelyn",
     "cruz",
     "nolan",
     "trix",
     "ryder",
     "alyce_char",
     "god",
     "will"
    ]
   },
   {
    "channel": "ww-war-au",
    "passages": 1,
    "share": 0.0137,
    "first": "2021-11-20",
    "last": "2021-11-20",
    "kind": "au",
    "castWith": [
     "evelyn",
     "cruz",
     "ace",
     "ezra",
     "lindon",
     "kaleb",
     "rowan",
     "bryce",
     "lance",
     "raye",
     "nolan",
     "primrose"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "evelyn",
   "bryce",
   "nolan"
  ]
 },
 "lucifer": {
  "canonRoute": "haggle-for-the-girl",
  "totalPassages": 779,
  "routes": [
   {
    "channel": "haggle-for-the-girl",
    "passages": 237,
    "share": 0.3042,
    "first": "2023-12-12",
    "last": "2024-01-22",
    "kind": "canon",
    "castWith": [
     "lachesis",
     "asrius",
     "god",
     "lonnie",
     "ramiel",
     "gabriel",
     "lance",
     "hades",
     "alyk",
     "aphrodite",
     "atropos",
     "zeus"
    ]
   },
   {
    "channel": "fordsplosion",
    "passages": 120,
    "share": 0.154,
    "first": "2024-02-09",
    "last": "2024-03-15",
    "kind": "route",
    "castWith": [
     "ford",
     "lachesis",
     "cruz",
     "clothos",
     "ryder",
     "god",
     "asrius",
     "ethan",
     "eva",
     "atropos",
     "may",
     "evelyn"
    ]
   },
   {
    "channel": "switched-roles-lachesis",
    "passages": 111,
    "share": 0.1425,
    "first": "2023-10-09",
    "last": "2023-11-25",
    "kind": "au",
    "castWith": [
     "lachesis",
     "ford",
     "god",
     "cruz",
     "clothos",
     "atropos",
     "rowan",
     "vaughn",
     "ryder",
     "brax",
     "dimitri",
     "ramiel"
    ]
   },
   {
    "channel": "atropos-in-hell",
    "passages": 106,
    "share": 0.1361,
    "first": "2021-05-24",
    "last": "2021-06-12",
    "kind": "route",
    "castWith": [
     "atropos",
     "moros",
     "lachesis",
     "haley_wolf",
     "god",
     "clothos",
     "gabriel",
     "lance",
     "hades",
     "mary_cataldi",
     "haley_human",
     "cupid_eros"
    ]
   },
   {
    "channel": "plz-love-lachesis",
    "passages": 52,
    "share": 0.0668,
    "first": "2022-11-14",
    "last": "2022-11-26",
    "kind": "route",
    "castWith": [
     "lachesis",
     "ramiel",
     "lance",
     "god",
     "apollo",
     "levi",
     "aion",
     "atropos",
     "zeus",
     "zadkiel",
     "clothos",
     "asrius"
    ]
   },
   {
    "channel": "cruz-is-not-dead",
    "passages": 47,
    "share": 0.0603,
    "first": "2022-05-14",
    "last": "2022-05-17",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "ford",
     "ryder",
     "bryce",
     "audrey",
     "apollo",
     "ares",
     "god",
     "clint",
     "hades",
     "nolan"
    ]
   },
   {
    "channel": "lance-decides",
    "passages": 33,
    "share": 0.0424,
    "first": "2024-12-15",
    "last": "2025-01-01",
    "kind": "route",
    "castWith": [
     "lance",
     "rin",
     "lachesis",
     "nicole_human",
     "god",
     "chiara",
     "cupid_eros",
     "roman",
     "asrius",
     "hera",
     "zeus",
     "aphrodite"
    ]
   },
   {
    "channel": "lachesis-off-the-rails",
    "passages": 31,
    "share": 0.0398,
    "first": "2025-09-01",
    "last": "2025-09-11",
    "kind": "route",
    "castWith": [
     "lance",
     "vaughn",
     "brax",
     "james",
     "atropos",
     "cruz",
     "lachesis",
     "ace",
     "lindon",
     "hades",
     "ezra",
     "nicole_human"
    ]
   },
   {
    "channel": "human-lachesis",
    "passages": 8,
    "share": 0.0103,
    "first": "2024-09-30",
    "last": "2024-10-23",
    "kind": "route",
    "castWith": [
     "nicole_human",
     "brax",
     "lachesis",
     "lance",
     "vaughn",
     "rowan",
     "god",
     "alyce_char",
     "moros",
     "ford",
     "atropos",
     "cruz"
    ]
   },
   {
    "channel": "nicole-x-cruz",
    "passages": 5,
    "share": 0.0064,
    "first": "2021-02-18",
    "last": "2021-02-18",
    "kind": "route",
    "castWith": [
     "otto",
     "cruz",
     "jones",
     "nicole_human",
     "duran",
     "sorsha",
     "kya_sg1",
     "nicole_wolf",
     "kya_sg3",
     "nicole_sg3",
     "christopher_donovan",
     "jonathan_donovan"
    ]
   },
   {
    "channel": "a-demons-jewel",
    "passages": 5,
    "share": 0.0064,
    "first": "2022-02-03",
    "last": "2022-02-11",
    "kind": "route",
    "castWith": [
     "tallia",
     "adrianne",
     "god",
     "will",
     "may",
     "gabriel",
     "prince_teregan"
    ]
   },
   {
    "channel": "oops-its-heaven",
    "passages": 4,
    "share": 0.0051,
    "first": "2022-08-09",
    "last": "2022-09-10",
    "kind": "route",
    "castWith": [
     "lachesis",
     "lance",
     "god",
     "ramiel",
     "aldo",
     "atropos",
     "mary_cataldi",
     "hades",
     "clothos",
     "zeus"
    ]
   }
  ],
  "knownCharacters": [
   "lachesis",
   "asrius",
   "god",
   "lonnie",
   "ramiel",
   "gabriel",
   "lance",
   "hades",
   "alyk",
   "aphrodite",
   "atropos",
   "zeus"
  ]
 },
 "lughaid": {
  "canonRoute": "the-kingdom-fallon",
  "totalPassages": 3,
  "routes": [
   {
    "channel": "the-kingdom-fallon",
    "passages": 3,
    "share": 1.0,
    "first": "2021-06-01",
    "last": "2021-06-10",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "eva",
     "rory",
     "raye",
     "fiadh",
     "ciarnan",
     "finn",
     "cailte",
     "senan",
     "diarmund",
     "fiann",
     "goll"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "eva",
   "rory",
   "raye",
   "fiadh",
   "ciarnan",
   "finn",
   "cailte",
   "senan",
   "diarmund",
   "fiann",
   "goll"
  ]
 },
 "lula": {
  "canonRoute": "aaron-haley",
  "totalPassages": 13,
  "routes": [
   {
    "channel": "aaron-haley",
    "passages": 9,
    "share": 0.6923,
    "first": "2023-01-15",
    "last": "2023-01-20",
    "kind": "canon",
    "castWith": [
     "aaron",
     "haley_human",
     "kya_sg3",
     "rowan",
     "kya_sg1",
     "trev",
     "god",
     "may"
    ]
   },
   {
    "channel": "haggle-for-the-girl",
    "passages": 4,
    "share": 0.3077,
    "first": "2023-12-13",
    "last": "2023-12-13",
    "kind": "route",
    "castWith": [
     "lachesis",
     "lucifer",
     "asrius",
     "god",
     "lonnie",
     "ramiel",
     "gabriel",
     "lance",
     "hades",
     "alyk",
     "aphrodite",
     "atropos"
    ]
   }
  ],
  "knownCharacters": [
   "aaron",
   "haley_human",
   "kya_sg3",
   "rowan",
   "kya_sg1",
   "trev",
   "god",
   "may"
  ]
 },
 "luna_rachel": {
  "canonRoute": "lance-nicole-2",
  "totalPassages": 2,
  "routes": [
   {
    "channel": "lance-nicole-2",
    "passages": 2,
    "share": 1.0,
    "first": "2022-12-14",
    "last": "2022-12-14",
    "kind": "canon",
    "castWith": [
     "brax",
     "vaughn",
     "lance",
     "jenning",
     "cruz",
     "lachesis",
     "nicole_human",
     "nicole_wolf",
     "nicole_sg3",
     "clothos",
     "atropos",
     "rowan"
    ]
   }
  ],
  "knownCharacters": [
   "brax",
   "vaughn",
   "lance",
   "jenning",
   "cruz",
   "lachesis",
   "nicole_human",
   "nicole_wolf",
   "nicole_sg3",
   "clothos",
   "atropos",
   "rowan"
  ]
 },
 "lupe": {
  "canonRoute": "an-accidentally-valerian-summer-with-cordelia",
  "totalPassages": 36,
  "routes": [
   {
    "channel": "an-accidentally-valerian-summer-with-cordelia",
    "passages": 36,
    "share": 1.0,
    "first": "2021-03-18",
    "last": "2021-05-03",
    "kind": "canon",
    "castWith": [
     "ciel",
     "nolan",
     "arsene",
     "delia",
     "dale",
     "jessica",
     "cruz",
     "clairette",
     "may",
     "tina",
     "cyrena",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "ciel",
   "nolan",
   "arsene",
   "delia",
   "dale",
   "jessica",
   "cruz",
   "clairette",
   "may",
   "tina",
   "cyrena",
   "will"
  ]
 },
 "madeline": {
  "canonRoute": "human-not-human",
  "totalPassages": 3,
  "routes": [
   {
    "channel": "human-not-human",
    "passages": 3,
    "share": 1.0,
    "first": "2022-10-17",
    "last": "2022-10-17",
    "kind": "canon",
    "castWith": [
     "dillon",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "sebastian_vamp",
     "drisella",
     "god",
     "blair",
     "tanya",
     "topps",
     "starlet",
     "ever"
    ]
   }
  ],
  "knownCharacters": [
   "dillon",
   "kya_sg3",
   "kya_sg1",
   "sebastian_siren",
   "sebastian_vamp",
   "drisella",
   "god",
   "blair",
   "tanya",
   "topps",
   "starlet",
   "ever"
  ]
 },
 "madison_astor": {
  "canonRoute": "junta-is-best-boi",
  "totalPassages": 133,
  "routes": [
   {
    "channel": "junta-is-best-boi",
    "passages": 78,
    "share": 0.5865,
    "first": "2023-11-24",
    "last": "2023-12-12",
    "kind": "canon",
    "castWith": [
     "junta",
     "ezra",
     "lily",
     "val",
     "natasha",
     "primrose",
     "belinda",
     "james",
     "may",
     "sebastian_vamp",
     "tim",
     "ace"
    ]
   },
   {
    "channel": "reed-vamp-werecheetah",
    "passages": 43,
    "share": 0.3233,
    "first": "2023-11-11",
    "last": "2023-11-24",
    "kind": "route",
    "castWith": [
     "reed",
     "kale",
     "raye",
     "arnold_astor",
     "may",
     "paul",
     "xavier",
     "zeke"
    ]
   },
   {
    "channel": "don\u2019t-buy-me-love",
    "passages": 12,
    "share": 0.0902,
    "first": "2023-12-12",
    "last": "2023-12-13",
    "kind": "route",
    "castWith": [
     "ezra",
     "trace_spellbook",
     "primrose",
     "kya_sg3",
     "kya_sg1",
     "dimitri",
     "hades",
     "evelyn",
     "junta",
     "jane",
     "may",
     "reginald"
    ]
   }
  ],
  "knownCharacters": [
   "junta",
   "ezra",
   "lily",
   "val",
   "natasha",
   "primrose",
   "belinda",
   "james",
   "may",
   "sebastian_vamp",
   "tim",
   "ace"
  ]
 },
 "maleos": {
  "canonRoute": "fall-fairies",
  "totalPassages": 4,
  "routes": [
   {
    "channel": "fall-fairies",
    "passages": 4,
    "share": 1.0,
    "first": "2021-11-16",
    "last": "2021-11-16",
    "kind": "canon",
    "castWith": [
     "damien",
     "matare",
     "autumn",
     "retin",
     "draven",
     "fayette",
     "sir_tyde",
     "may",
     "silvia",
     "jaden",
     "will",
     "roman"
    ]
   }
  ],
  "knownCharacters": [
   "damien",
   "matare",
   "autumn",
   "retin",
   "draven",
   "fayette",
   "sir_tyde",
   "may",
   "silvia",
   "jaden",
   "will",
   "roman"
  ]
 },
 "maria": {
  "canonRoute": "high-school-ezra-kya",
  "totalPassages": 12,
  "routes": [
   {
    "channel": "high-school-ezra-kya",
    "passages": 12,
    "share": 1.0,
    "first": "2021-02-23",
    "last": "2021-02-26",
    "kind": "canon",
    "castWith": [
     "ezra",
     "kya_sg3",
     "rachel",
     "kaleb",
     "kya_sg1",
     "evelyn",
     "willie",
     "jane",
     "primrose",
     "lily",
     "ace",
     "uncle_khan"
    ]
   }
  ],
  "knownCharacters": [
   "ezra",
   "kya_sg3",
   "rachel",
   "kaleb",
   "kya_sg1",
   "evelyn",
   "willie",
   "jane",
   "primrose",
   "lily",
   "ace",
   "uncle_khan"
  ]
 },
 "marie_antoinette": {
  "canonRoute": "lets-abduct-evie",
  "totalPassages": 4,
  "routes": [
   {
    "channel": "lets-abduct-evie",
    "passages": 1,
    "share": 0.25,
    "first": "2021-07-02",
    "last": "2021-07-02",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "dimitri",
     "ryoto",
     "dodge",
     "ms_tia",
     "kaleb",
     "frau",
     "aki",
     "cruz",
     "talbot",
     "ares",
     "zeus"
    ]
   },
   {
    "channel": "cruz-is-not-dead",
    "passages": 1,
    "share": 0.25,
    "first": "2022-05-14",
    "last": "2022-05-14",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "ford",
     "ryder",
     "lucifer",
     "bryce",
     "audrey",
     "apollo",
     "ares",
     "god",
     "clint",
     "hades"
    ]
   },
   {
    "channel": "dimitri-ralidanti",
    "passages": 1,
    "share": 0.25,
    "first": "2023-03-01",
    "last": "2023-03-01",
    "kind": "route",
    "castWith": [
     "ryder",
     "evelyn",
     "dimitri",
     "cruz",
     "nolan",
     "bryce",
     "audrey",
     "trix",
     "lyden",
     "alyce_char",
     "kya_sg3",
     "diana"
    ]
   },
   {
    "channel": "mm_chatroom",
    "passages": 1,
    "share": 0.25,
    "first": "2016-09-08",
    "last": "2016-09-08",
    "kind": "route",
    "castWith": [
     "kaleb",
     "evelyn",
     "rika",
     "mr_han_sr",
     "cruz",
     "elizabeth_the_third",
     "god",
     "mr_clien",
     "bryce",
     "ever",
     "tom"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "dimitri",
   "ryoto",
   "dodge",
   "ms_tia",
   "kaleb",
   "frau",
   "aki",
   "cruz",
   "talbot",
   "ares",
   "zeus"
  ]
 },
 "marta": {
  "canonRoute": "evelyns_mansion",
  "totalPassages": 13,
  "routes": [
   {
    "channel": "evelyns_mansion",
    "passages": 10,
    "share": 0.7692,
    "first": "2016-09-21",
    "last": "2016-09-23",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "kaleb",
     "cruz",
     "kya_sg3",
     "ivy_morris",
     "kya_sg1",
     "frau",
     "mr_han_sr",
     "sebastian_vamp",
     "god",
     "seuk",
     "dimitri"
    ]
   },
   {
    "channel": "han-family-mansion",
    "passages": 2,
    "share": 0.1538,
    "first": "2020-04-27",
    "last": "2020-04-27",
    "kind": "route",
    "castWith": [
     "evelyn",
     "ezra",
     "kaleb",
     "kya_sg3",
     "rowan",
     "mr_han_sr",
     "raye",
     "kya_sg1",
     "sune",
     "alistair",
     "alistair_turayne",
     "becca"
    ]
   },
   {
    "channel": "brothel",
    "passages": 1,
    "share": 0.0769,
    "first": "2020-04-25",
    "last": "2020-04-25",
    "kind": "route",
    "castWith": [
     "ezra",
     "evelyn",
     "rowan",
     "kya_sg3",
     "kya_sg1",
     "primrose",
     "lily",
     "kaleb",
     "nellie",
     "lissa",
     "raye",
     "ace"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "kaleb",
   "cruz",
   "kya_sg3",
   "ivy_morris",
   "kya_sg1",
   "frau",
   "mr_han_sr",
   "sebastian_vamp",
   "god",
   "seuk",
   "dimitri"
  ]
 },
 "mary_cataldi": {
  "canonRoute": "vaughneo-and-juliet",
  "totalPassages": 15,
  "routes": [
   {
    "channel": "vaughneo-and-juliet",
    "passages": 8,
    "share": 0.5333,
    "first": "2025-10-24",
    "last": "2025-11-02",
    "kind": "canon",
    "castWith": [
     "vaughn",
     "brax",
     "lindon",
     "declan",
     "ares",
     "skye",
     "roman",
     "liz",
     "nicole_human",
     "aphrodite",
     "ace",
     "ben"
    ]
   },
   {
    "channel": "oops-its-heaven",
    "passages": 2,
    "share": 0.1333,
    "first": "2022-08-10",
    "last": "2022-08-16",
    "kind": "route",
    "castWith": [
     "lachesis",
     "lance",
     "god",
     "ramiel",
     "aldo",
     "lucifer",
     "atropos",
     "hades",
     "clothos",
     "zeus"
    ]
   },
   {
    "channel": "normal-ish-to-not-kya",
    "passages": 2,
    "share": 0.1333,
    "first": "2022-06-08",
    "last": "2022-06-08",
    "kind": "route",
    "castWith": [
     "junta",
     "kya_sg3",
     "tim",
     "evelyn",
     "val",
     "dimitri",
     "vanessa"
    ]
   },
   {
    "channel": "atropos-in-hell",
    "passages": 2,
    "share": 0.1333,
    "first": "2021-05-24",
    "last": "2021-05-25",
    "kind": "route",
    "castWith": [
     "lucifer",
     "atropos",
     "moros",
     "lachesis",
     "haley_wolf",
     "god",
     "clothos",
     "gabriel",
     "lance",
     "hades",
     "haley_human",
     "cupid_eros"
    ]
   },
   {
    "channel": "vamperwolves",
    "passages": 1,
    "share": 0.0667,
    "first": "2023-04-22",
    "last": "2023-04-22",
    "kind": "route",
    "castWith": [
     "ryder",
     "evelyn",
     "cruz",
     "ares",
     "ford",
     "sebastian_vamp",
     "audrey",
     "alyce_char",
     "sebastian_siren",
     "rowan",
     "kaleb",
     "allie"
    ]
   }
  ],
  "knownCharacters": [
   "vaughn",
   "brax",
   "lindon",
   "declan",
   "ares",
   "skye",
   "roman",
   "liz",
   "nicole_human",
   "aphrodite",
   "ace",
   "ben"
  ]
 },
 "matare": {
  "canonRoute": "fall-fairies",
  "totalPassages": 39,
  "routes": [
   {
    "channel": "fall-fairies",
    "passages": 39,
    "share": 1.0,
    "first": "2021-10-26",
    "last": "2021-11-16",
    "kind": "canon",
    "castWith": [
     "damien",
     "autumn",
     "retin",
     "draven",
     "fayette",
     "sir_tyde",
     "may",
     "maleos",
     "silvia",
     "jaden",
     "will",
     "roman"
    ]
   }
  ],
  "knownCharacters": [
   "damien",
   "autumn",
   "retin",
   "draven",
   "fayette",
   "sir_tyde",
   "may",
   "maleos",
   "silvia",
   "jaden",
   "will",
   "roman"
  ]
 },
 "mateo_aurlease": {
  "canonRoute": "hottie-seb-is-dead",
  "totalPassages": 13,
  "routes": [
   {
    "channel": "hottie-seb-is-dead",
    "passages": 13,
    "share": 1.0,
    "first": "2022-10-30",
    "last": "2022-11-01",
    "kind": "canon",
    "castWith": [
     "dillon",
     "kya_sg3",
     "kya_sg1",
     "sebastian_vamp",
     "sebastian_siren",
     "evelyn",
     "ever",
     "apollo",
     "roger"
    ]
   }
  ],
  "knownCharacters": [
   "dillon",
   "kya_sg3",
   "kya_sg1",
   "sebastian_vamp",
   "sebastian_siren",
   "evelyn",
   "ever",
   "apollo",
   "roger"
  ]
 },
 "maxen_bryers": {
  "canonRoute": "to-the-max",
  "totalPassages": 65,
  "routes": [
   {
    "channel": "to-the-max",
    "passages": 32,
    "share": 0.4923,
    "first": "2023-05-14",
    "last": "2023-05-28",
    "kind": "canon",
    "castWith": [
     "addison",
     "trace_renton",
     "kya_sg3",
     "kya_sg1",
     "rick",
     "evelyn",
     "beatrice",
     "dillon",
     "budd",
     "lore",
     "paula",
     "diana"
    ]
   },
   {
    "channel": "kyatropos",
    "passages": 16,
    "share": 0.2462,
    "first": "2023-04-12",
    "last": "2023-04-21",
    "kind": "route",
    "castWith": [
     "nolan",
     "kya_sg3",
     "audrey",
     "kya_sg1",
     "atropos",
     "cruz",
     "alyce_char",
     "evelyn",
     "moros",
     "diana",
     "may"
    ]
   },
   {
    "channel": "kya-werewolf-summit",
    "passages": 16,
    "share": 0.2462,
    "first": "2024-10-22",
    "last": "2024-10-25",
    "kind": "route",
    "castWith": [
     "dillon",
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "rowan",
     "evelyn",
     "ever",
     "diana",
     "cruz",
     "bryce",
     "ezra",
     "ryder"
    ]
   },
   {
    "channel": "human-lachesis",
    "passages": 1,
    "share": 0.0154,
    "first": "2024-10-21",
    "last": "2024-10-21",
    "kind": "route",
    "castWith": [
     "nicole_human",
     "brax",
     "lachesis",
     "lance",
     "vaughn",
     "rowan",
     "god",
     "alyce_char",
     "moros",
     "ford",
     "atropos",
     "cruz"
    ]
   }
  ],
  "knownCharacters": [
   "addison",
   "trace_renton",
   "kya_sg3",
   "kya_sg1",
   "rick",
   "evelyn",
   "beatrice",
   "dillon",
   "budd",
   "lore",
   "paula",
   "diana"
  ]
 },
 "may": {
  "canonRoute": "college-campus",
  "totalPassages": 199,
  "routes": [
   {
    "channel": "college-campus",
    "passages": 17,
    "share": 0.0854,
    "first": "2020-05-09",
    "last": "2020-05-13",
    "kind": "canon",
    "castWith": [
     "agnar",
     "agmund",
     "kya_sg3",
     "penelope_valk",
     "evelyn",
     "svira",
     "rowan",
     "jon",
     "kya_sg1",
     "kaleb",
     "darren",
     "cole"
    ]
   },
   {
    "channel": "kya-college-2",
    "passages": 6,
    "share": 0.0302,
    "first": "2021-01-16",
    "last": "2021-01-26",
    "kind": "route",
    "castWith": [
     "lily",
     "zander",
     "kya_sg3",
     "kya_sg1",
     "ari",
     "sebastian_siren",
     "raye",
     "prince_zed",
     "sebastian_vamp",
     "midori_naga",
     "penelope_valk",
     "bell_lily_of_fell"
    ]
   },
   {
    "channel": "an-accidentally-valerian-summer-with-cordelia",
    "passages": 6,
    "share": 0.0302,
    "first": "2021-04-18",
    "last": "2021-05-17",
    "kind": "route",
    "castWith": [
     "ciel",
     "nolan",
     "lupe",
     "arsene",
     "delia",
     "dale",
     "jessica",
     "cruz",
     "clairette",
     "tina",
     "cyrena",
     "will"
    ]
   },
   {
    "channel": "fall-fairies",
    "passages": 5,
    "share": 0.0251,
    "first": "2021-10-25",
    "last": "2021-11-01",
    "kind": "route",
    "castWith": [
     "damien",
     "matare",
     "autumn",
     "retin",
     "draven",
     "fayette",
     "sir_tyde",
     "maleos",
     "silvia",
     "jaden",
     "will",
     "roman"
    ]
   },
   {
    "channel": "dorms",
    "passages": 5,
    "share": 0.0251,
    "first": "2020-05-08",
    "last": "2020-05-18",
    "kind": "route",
    "castWith": [
     "agnar",
     "kya_sg3",
     "agmund",
     "evelyn",
     "raye",
     "cole",
     "kya_sg1",
     "riku",
     "kaleb",
     "penelope_valk",
     "loki",
     "svira"
    ]
   },
   {
    "channel": "AU: Ford Steele \u2014 Branched at msg 89/600 (5/1/2026) (branched at msg 638)",
    "passages": 5,
    "share": 0.0251,
    "first": "2026-05-02",
    "last": "2026-05-07",
    "kind": "au",
    "castWith": [
     "ford",
     "cruz",
     "ryder",
     "nicole_human",
     "audrey",
     "nolan",
     "haley_human",
     "diana",
     "porscha_steele",
     "evelyn",
     "dimitri",
     "aaron"
    ]
   },
   {
    "channel": "haggle-for-the-girl",
    "passages": 4,
    "share": 0.0201,
    "first": "2023-12-22",
    "last": "2024-01-16",
    "kind": "route",
    "castWith": [
     "lachesis",
     "lucifer",
     "asrius",
     "god",
     "lonnie",
     "ramiel",
     "gabriel",
     "lance",
     "hades",
     "alyk",
     "aphrodite",
     "atropos"
    ]
   },
   {
    "channel": "haley-finds-out-shes-cool-2",
    "passages": 4,
    "share": 0.0201,
    "first": "2022-11-29",
    "last": "2022-12-05",
    "kind": "route",
    "castWith": [
     "moros",
     "atropos",
     "gracie",
     "haley_human",
     "jinko",
     "lance",
     "lachesis",
     "athena",
     "clothos",
     "haley_wolf",
     "peter",
     "apollo"
    ]
   },
   {
    "channel": "1920s-boardwalk",
    "passages": 3,
    "share": 0.0151,
    "first": "2022-05-19",
    "last": "2022-05-23",
    "kind": "route",
    "castWith": [
     "val",
     "ezra",
     "kya_sg3",
     "james",
     "alistair_turayne",
     "kya_sg1",
     "alistair",
     "vanessa",
     "sebastian_vamp",
     "sebastian_siren",
     "amelda",
     "junta"
    ]
   },
   {
    "channel": "flirty-sebastian-immortuos",
    "passages": 3,
    "share": 0.0151,
    "first": "2021-12-17",
    "last": "2021-12-21",
    "kind": "route",
    "castWith": [
     "amelda",
     "sebastian_vamp",
     "kya_sg3",
     "sebastian_siren",
     "kya_sg1",
     "aurelia",
     "crom",
     "val",
     "kaleb",
     "james",
     "dillon"
    ]
   },
   {
    "channel": "chance-route-ft-lance",
    "passages": 3,
    "share": 0.0151,
    "first": "2021-09-26",
    "last": "2021-09-29",
    "kind": "route",
    "castWith": [
     "lachesis",
     "chance",
     "lance",
     "god",
     "aphrodite",
     "atropos",
     "clothos",
     "zeus",
     "moros",
     "ares",
     "hades",
     "will"
    ]
   },
   {
    "channel": "double-bro-seb-cole",
    "passages": 3,
    "share": 0.0151,
    "first": "2025-05-14",
    "last": "2025-05-17",
    "kind": "route",
    "castWith": [
     "cole",
     "kaleb",
     "dillon",
     "kya_sg3",
     "kya_sg1",
     "kyo",
     "evelyn",
     "sebastian_siren",
     "amoura",
     "sebastian_vamp",
     "uncle_khan",
     "ace"
    ]
   }
  ],
  "knownCharacters": [
   "agnar",
   "agmund",
   "kya_sg3",
   "penelope_valk",
   "evelyn",
   "svira",
   "rowan",
   "jon",
   "kya_sg1",
   "kaleb",
   "darren",
   "cole"
  ]
 },
 "mei": {
  "canonRoute": "human-kieran",
  "totalPassages": 7,
  "routes": [
   {
    "channel": "human-kieran",
    "passages": 6,
    "share": 0.8571,
    "first": "2024-01-02",
    "last": "2024-01-05",
    "kind": "canon",
    "castWith": [
     "kieran",
     "peter",
     "raz",
     "evan",
     "gemma",
     "ms_tia",
     "will"
    ]
   },
   {
    "channel": "the-great-husbando-race",
    "passages": 1,
    "share": 0.1429,
    "first": "2020-06-17",
    "last": "2020-06-17",
    "kind": "route",
    "castWith": [
     "kira",
     "ray",
     "leon",
     "cupid_eros",
     "loki",
     "riku",
     "victor",
     "evelyn",
     "junta",
     "ben",
     "hyun_ryu",
     "jack"
    ]
   }
  ],
  "knownCharacters": [
   "kieran",
   "peter",
   "raz",
   "evan",
   "gemma",
   "ms_tia",
   "will"
  ]
 },
 "melisende": {
  "canonRoute": "troterra-kingdom",
  "totalPassages": 202,
  "routes": [
   {
    "channel": "troterra-kingdom",
    "passages": 67,
    "share": 0.3317,
    "first": "2020-04-01",
    "last": "2020-06-03",
    "kind": "canon",
    "castWith": [
     "stella",
     "ronin_tempus",
     "raze",
     "talon_char",
     "dimitri",
     "satella",
     "silas_mirace",
     "vincent",
     "exis",
     "god",
     "may",
     "mikaela_hyakuya"
    ]
   },
   {
    "channel": "ramesville",
    "passages": 34,
    "share": 0.1683,
    "first": "2020-04-01",
    "last": "2020-06-01",
    "kind": "route",
    "castWith": [
     "stella",
     "talon_char",
     "ronin_tempus",
     "exis",
     "raze",
     "satella",
     "dimitri",
     "vanessa",
     "raye",
     "raz",
     "will"
    ]
   },
   {
    "channel": "country-road-take-me-home",
    "passages": 27,
    "share": 0.1337,
    "first": "2020-04-12",
    "last": "2020-04-13",
    "kind": "route",
    "castWith": [
     "stella",
     "ronin_tempus",
     "talon_char",
     "dimitri",
     "raze",
     "exis",
     "yuu",
     "god",
     "will"
    ]
   },
   {
    "channel": "dimitri-castle",
    "passages": 16,
    "share": 0.0792,
    "first": "2020-04-06",
    "last": "2020-04-07",
    "kind": "route",
    "castWith": [
     "dimitri",
     "evelyn",
     "stella",
     "ronin_tempus",
     "kaleb",
     "mr_han_sr",
     "gambit",
     "frau",
     "silas_mirace",
     "theo_uoki",
     "toko",
     "raye"
    ]
   },
   {
    "channel": "mikaera-hyakuya-castle",
    "passages": 13,
    "share": 0.0644,
    "first": "2020-04-02",
    "last": "2020-04-02",
    "kind": "route",
    "castWith": [
     "stella",
     "yuu",
     "raze",
     "may"
    ]
   },
   {
    "channel": "silas-mirace-castle",
    "passages": 12,
    "share": 0.0594,
    "first": "2020-04-02",
    "last": "2020-04-03",
    "kind": "route",
    "castWith": [
     "stella",
     "silas_mirace",
     "raze",
     "may"
    ]
   },
   {
    "channel": "ronin-tempus-castle",
    "passages": 10,
    "share": 0.0495,
    "first": "2020-04-03",
    "last": "2020-04-04",
    "kind": "route",
    "castWith": [
     "stella",
     "ronin_tempus",
     "raze",
     "talon_char",
     "kya_sg3",
     "may",
     "silas_mirace",
     "will"
    ]
   },
   {
    "channel": "theo-uoki-castle",
    "passages": 7,
    "share": 0.0347,
    "first": "2020-04-03",
    "last": "2020-04-03",
    "kind": "route",
    "castWith": [
     "stella",
     "theo_uoki",
     "raze",
     "frank",
     "tom",
     "yuu",
     "silas_mirace",
     "vincent",
     "ronin_tempus"
    ]
   },
   {
    "channel": "abandoned-building",
    "passages": 7,
    "share": 0.0347,
    "first": "2020-04-13",
    "last": "2020-04-13",
    "kind": "route",
    "castWith": [
     "stella",
     "ronin_tempus",
     "exis",
     "satella",
     "talon_char",
     "raze"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 5,
    "share": 0.0248,
    "first": "2020-04-01",
    "last": "2020-04-13",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "prince-char-bios",
    "passages": 2,
    "share": 0.0099,
    "first": "2020-04-01",
    "last": "2020-05-22",
    "kind": "route",
    "castWith": [
     "ronin_tempus",
     "stella",
     "dimitri",
     "talon_char",
     "mikaela_hyakuya",
     "raze",
     "silas_mirace",
     "theo_uoki",
     "yuu",
     "vincent"
    ]
   },
   {
    "channel": "mages-tower",
    "passages": 2,
    "share": 0.0099,
    "first": "2020-04-11",
    "last": "2020-04-11",
    "kind": "route",
    "castWith": [
     "exis",
     "stella",
     "talon_char",
     "ronin_tempus"
    ]
   }
  ],
  "knownCharacters": [
   "stella",
   "ronin_tempus",
   "raze",
   "talon_char",
   "dimitri",
   "satella",
   "silas_mirace",
   "vincent",
   "exis",
   "god",
   "may",
   "mikaela_hyakuya"
  ]
 },
 "melody": {
  "canonRoute": "kya-sold-off",
  "totalPassages": 102,
  "routes": [
   {
    "channel": "kya-sold-off",
    "passages": 62,
    "share": 0.6078,
    "first": "2021-07-16",
    "last": "2021-08-17",
    "kind": "canon",
    "castWith": [
     "leiden",
     "callan",
     "kya_sg3",
     "frank",
     "kya_sg1",
     "umu",
     "evelyn",
     "kaleb",
     "garrett",
     "god",
     "may",
     "will"
    ]
   },
   {
    "channel": "kya-senior-year",
    "passages": 39,
    "share": 0.3824,
    "first": "2021-07-01",
    "last": "2021-07-14",
    "kind": "route",
    "castWith": [
     "callan",
     "ezra",
     "leiden",
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "raye",
     "tate",
     "sebastian_vamp",
     "dillon",
     "sebastian_siren",
     "evelyn"
    ]
   },
   {
    "channel": "kya-werewolf",
    "passages": 1,
    "share": 0.0098,
    "first": "2021-08-24",
    "last": "2021-08-24",
    "kind": "route",
    "castWith": [
     "jace",
     "raphael",
     "trey",
     "dillon",
     "kya_sg3",
     "scott",
     "kya_sg1",
     "ezra",
     "sebastian_siren",
     "kaleb",
     "sebastian_vamp",
     "evelyn"
    ]
   }
  ],
  "knownCharacters": [
   "leiden",
   "callan",
   "kya_sg3",
   "frank",
   "kya_sg1",
   "umu",
   "evelyn",
   "kaleb",
   "garrett",
   "god",
   "may",
   "will"
  ]
 },
 "mia": {
  "canonRoute": "presto-new-route",
  "totalPassages": 8,
  "routes": [
   {
    "channel": "presto-new-route",
    "passages": 3,
    "share": 0.375,
    "first": "2022-07-10",
    "last": "2022-07-11",
    "kind": "canon",
    "castWith": []
   },
   {
    "channel": "evelyns_mansion",
    "passages": 3,
    "share": 0.375,
    "first": "2016-09-21",
    "last": "2016-09-21",
    "kind": "route",
    "castWith": [
     "evelyn",
     "kaleb",
     "cruz",
     "kya_sg3",
     "ivy_morris",
     "marta",
     "kya_sg1",
     "frau",
     "mr_han_sr",
     "sebastian_vamp",
     "god",
     "seuk"
    ]
   },
   {
    "channel": "the-werewolf-harem-bandwagon",
    "passages": 1,
    "share": 0.125,
    "first": "2022-12-14",
    "last": "2022-12-14",
    "kind": "route",
    "castWith": [
     "declan",
     "koda",
     "haley_wolf",
     "haley_sg3",
     "diana",
     "god",
     "may"
    ]
   },
   {
    "channel": "brothel",
    "passages": 1,
    "share": 0.125,
    "first": "2020-04-25",
    "last": "2020-04-25",
    "kind": "route",
    "castWith": [
     "ezra",
     "evelyn",
     "rowan",
     "kya_sg3",
     "kya_sg1",
     "primrose",
     "lily",
     "kaleb",
     "nellie",
     "lissa",
     "raye",
     "ace"
    ]
   }
  ],
  "knownCharacters": []
 },
 "midori_naga": {
  "canonRoute": "kya-college-2",
  "totalPassages": 21,
  "routes": [
   {
    "channel": "kya-college-2",
    "passages": 19,
    "share": 0.9048,
    "first": "2021-01-13",
    "last": "2021-01-28",
    "kind": "canon",
    "castWith": [
     "lily",
     "zander",
     "kya_sg3",
     "kya_sg1",
     "ari",
     "sebastian_siren",
     "raye",
     "prince_zed",
     "sebastian_vamp",
     "penelope_valk",
     "bell_lily_of_fell",
     "agnar"
    ]
   },
   {
    "channel": "siren-places",
    "passages": 2,
    "share": 0.0952,
    "first": "2020-07-16",
    "last": "2020-07-17",
    "kind": "route",
    "castWith": [
     "sebastian_vamp",
     "sebastian_siren",
     "kya_sg1",
     "kya_sg3",
     "polly",
     "kaleb",
     "evelyn",
     "ever",
     "skipper",
     "kyo"
    ]
   }
  ],
  "knownCharacters": [
   "lily",
   "zander",
   "kya_sg3",
   "kya_sg1",
   "ari",
   "sebastian_siren",
   "raye",
   "prince_zed",
   "sebastian_vamp",
   "penelope_valk",
   "bell_lily_of_fell",
   "agnar"
  ]
 },
 "mikaela_hyakuya": {
  "canonRoute": "prince-char-bios",
  "totalPassages": 3,
  "routes": [
   {
    "channel": "prince-char-bios",
    "passages": 2,
    "share": 0.6667,
    "first": "2020-04-01",
    "last": "2020-05-21",
    "kind": "canon",
    "castWith": [
     "ronin_tempus",
     "stella",
     "dimitri",
     "talon_char",
     "melisende",
     "raze",
     "silas_mirace",
     "theo_uoki",
     "yuu",
     "vincent"
    ]
   },
   {
    "channel": "troterra-kingdom",
    "passages": 1,
    "share": 0.3333,
    "first": "2020-04-02",
    "last": "2020-04-02",
    "kind": "route",
    "castWith": [
     "stella",
     "ronin_tempus",
     "raze",
     "talon_char",
     "melisende",
     "dimitri",
     "satella",
     "silas_mirace",
     "vincent",
     "exis",
     "god",
     "may"
    ]
   }
  ],
  "knownCharacters": [
   "ronin_tempus",
   "stella",
   "dimitri",
   "talon_char",
   "melisende",
   "raze",
   "silas_mirace",
   "theo_uoki",
   "yuu",
   "vincent"
  ]
 },
 "miles": {
  "canonRoute": "mansion-grounds",
  "totalPassages": 40,
  "routes": [
   {
    "channel": "mansion-grounds",
    "passages": 19,
    "share": 0.475,
    "first": "2020-04-09",
    "last": "2020-04-09",
    "kind": "canon",
    "castWith": [
     "aria",
     "kent",
     "ajax",
     "benji",
     "rin",
     "bennett",
     "ever"
    ]
   },
   {
    "channel": "foyer-living-room",
    "passages": 13,
    "share": 0.325,
    "first": "2020-04-07",
    "last": "2020-05-22",
    "kind": "route",
    "castWith": [
     "aria",
     "benji",
     "bennett",
     "ajax",
     "ragland",
     "rin",
     "kent",
     "may"
    ]
   },
   {
    "channel": "memory-char-bios",
    "passages": 3,
    "share": 0.075,
    "first": "2020-04-01",
    "last": "2020-05-22",
    "kind": "route",
    "castWith": [
     "bennett",
     "benji",
     "ajax",
     "kent",
     "ragland",
     "rin",
     "aria"
    ]
   },
   {
    "channel": "rin-and-ragland-wing",
    "passages": 3,
    "share": 0.075,
    "first": "2020-04-12",
    "last": "2020-04-12",
    "kind": "route",
    "castWith": [
     "ragland",
     "aria",
     "rin",
     "ajax",
     "kent"
    ]
   },
   {
    "channel": "makeshift-attic-bedroom",
    "passages": 1,
    "share": 0.025,
    "first": "2020-04-08",
    "last": "2020-04-08",
    "kind": "route",
    "castWith": [
     "aria",
     "benji",
     "ragland",
     "bennett",
     "ajax"
    ]
   },
   {
    "channel": "eros-and-kent-wing",
    "passages": 1,
    "share": 0.025,
    "first": "2020-04-12",
    "last": "2020-04-12",
    "kind": "route",
    "castWith": [
     "aria",
     "bennett",
     "ragland",
     "benji",
     "ajax",
     "kent",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "aria",
   "kent",
   "ajax",
   "benji",
   "rin",
   "bennett",
   "ever"
  ]
 },
 "milo": {
  "canonRoute": "school-gym",
  "totalPassages": 76,
  "routes": [
   {
    "channel": "school-gym",
    "passages": 16,
    "share": 0.2105,
    "first": "2020-06-08",
    "last": "2020-06-10",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "rex",
     "aaron",
     "diana",
     "kya_sg3",
     "kya_sg1",
     "roman",
     "dike",
     "frau",
     "dimitri",
     "sebastian_vamp",
     "raye"
    ]
   },
   {
    "channel": "dining-hall",
    "passages": 12,
    "share": 0.1579,
    "first": "2020-06-08",
    "last": "2020-06-08",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "bryce",
     "rex",
     "aaron",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "lex",
     "sebastian_vamp",
     "dike",
     "agnar"
    ]
   },
   {
    "channel": "auditorium",
    "passages": 10,
    "share": 0.1316,
    "first": "2020-06-11",
    "last": "2020-06-14",
    "kind": "route",
    "castWith": [
     "rex",
     "evelyn",
     "diana",
     "dimitri",
     "athena",
     "dike",
     "audrey",
     "saph",
     "bryce",
     "kaleb",
     "roman",
     "rio"
    ]
   },
   {
    "channel": "ooc",
    "passages": 9,
    "share": 0.1184,
    "first": "2020-06-07",
    "last": "2020-06-09",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "athena-class",
    "passages": 9,
    "share": 0.1184,
    "first": "2020-06-18",
    "last": "2020-06-19",
    "kind": "route",
    "castWith": [
     "rex",
     "evelyn",
     "kiro",
     "diana",
     "cupid_eros",
     "athena",
     "dimitri",
     "dike",
     "kya_sg1",
     "aaron",
     "kya_sg3",
     "hiro"
    ]
   },
   {
    "channel": "the-blacklight",
    "passages": 9,
    "share": 0.1184,
    "first": "2020-04-30",
    "last": "2020-05-01",
    "kind": "route",
    "castWith": [
     "evelyn",
     "darren",
     "lucius",
     "lacie",
     "kiro",
     "lex",
     "kya_sg3",
     "kya_sg1",
     "cruz",
     "rowan",
     "kaleb",
     "aphrodite"
    ]
   },
   {
    "channel": "staff-break-room",
    "passages": 4,
    "share": 0.0526,
    "first": "2020-06-14",
    "last": "2020-06-15",
    "kind": "route",
    "castWith": [
     "dimitri",
     "rex",
     "evelyn",
     "saph",
     "diana",
     "aaron",
     "kiro",
     "skipper",
     "roman",
     "sebastian_vamp",
     "kya_sg3",
     "sebastian_siren"
    ]
   },
   {
    "channel": "misc-location",
    "passages": 3,
    "share": 0.0395,
    "first": "2020-05-04",
    "last": "2020-05-11",
    "kind": "route",
    "castWith": [
     "evelyn",
     "riku",
     "ares",
     "kiro",
     "hiro",
     "lex",
     "lance",
     "ezra",
     "lucius",
     "darren",
     "kaleb",
     "raye"
    ]
   },
   {
    "channel": "mt-olympus",
    "passages": 2,
    "share": 0.0263,
    "first": "2020-06-21",
    "last": "2020-06-24",
    "kind": "route",
    "castWith": [
     "evelyn",
     "libion",
     "ares",
     "rex",
     "persephone",
     "bion",
     "hades",
     "aphrodite",
     "hercules",
     "demeter",
     "zeus",
     "athena"
    ]
   },
   {
    "channel": "dorms",
    "passages": 2,
    "share": 0.0263,
    "first": "2020-05-01",
    "last": "2020-05-01",
    "kind": "route",
    "castWith": [
     "agnar",
     "kya_sg3",
     "agmund",
     "evelyn",
     "raye",
     "cole",
     "kya_sg1",
     "riku",
     "kaleb",
     "penelope_valk",
     "loki",
     "svira"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "rex",
   "aaron",
   "diana",
   "kya_sg3",
   "kya_sg1",
   "roman",
   "dike",
   "frau",
   "dimitri",
   "sebastian_vamp",
   "raye"
  ]
 },
 "minerva": {
  "canonRoute": "you-have-me-roman",
  "totalPassages": 1,
  "routes": [
   {
    "channel": "you-have-me-roman",
    "passages": 1,
    "share": 1.0,
    "first": "2022-11-08",
    "last": "2022-11-08",
    "kind": "canon",
    "castWith": [
     "darius",
     "titus",
     "roman",
     "kya_sg3",
     "dillon",
     "kya_sg1",
     "evelyn",
     "stellar",
     "easton",
     "deven",
     "will",
     "lachesis"
    ]
   }
  ],
  "knownCharacters": [
   "darius",
   "titus",
   "roman",
   "kya_sg3",
   "dillon",
   "kya_sg1",
   "evelyn",
   "stellar",
   "easton",
   "deven",
   "will",
   "lachesis"
  ]
 },
 "mirth": {
  "canonRoute": "haggle-for-the-girl",
  "totalPassages": 4,
  "routes": [
   {
    "channel": "haggle-for-the-girl",
    "passages": 4,
    "share": 1.0,
    "first": "2024-01-05",
    "last": "2024-01-05",
    "kind": "canon",
    "castWith": [
     "lachesis",
     "lucifer",
     "asrius",
     "god",
     "lonnie",
     "ramiel",
     "gabriel",
     "lance",
     "hades",
     "alyk",
     "aphrodite",
     "atropos"
    ]
   }
  ],
  "knownCharacters": [
   "lachesis",
   "lucifer",
   "asrius",
   "god",
   "lonnie",
   "ramiel",
   "gabriel",
   "lance",
   "hades",
   "alyk",
   "aphrodite",
   "atropos"
  ]
 },
 "mr_clien": {
  "canonRoute": "mm_chatroom",
  "totalPassages": 2,
  "routes": [
   {
    "channel": "mm_chatroom",
    "passages": 2,
    "share": 1.0,
    "first": "2016-09-08",
    "last": "2016-09-08",
    "kind": "canon",
    "castWith": [
     "kaleb",
     "evelyn",
     "rika",
     "mr_han_sr",
     "cruz",
     "elizabeth_the_third",
     "god",
     "bryce",
     "ever",
     "marie_antoinette",
     "tom"
    ]
   }
  ],
  "knownCharacters": [
   "kaleb",
   "evelyn",
   "rika",
   "mr_han_sr",
   "cruz",
   "elizabeth_the_third",
   "god",
   "bryce",
   "ever",
   "marie_antoinette",
   "tom"
  ]
 },
 "mr_han_sr": {
  "canonRoute": "meeting-room",
  "totalPassages": 263,
  "routes": [
   {
    "channel": "meeting-room",
    "passages": 28,
    "share": 0.1065,
    "first": "2020-03-26",
    "last": "2020-08-01",
    "kind": "canon",
    "castWith": [
     "kaleb",
     "ezra",
     "kya_sg3",
     "raye",
     "evelyn",
     "alistair_turayne",
     "alistair",
     "kya_sg1",
     "thorne",
     "prince_zain",
     "sune",
     "yuri_rekovich"
    ]
   },
   {
    "channel": "human-evie",
    "passages": 18,
    "share": 0.0684,
    "first": "2020-09-23",
    "last": "2020-10-21",
    "kind": "route",
    "castWith": [
     "evelyn",
     "kaleb",
     "frau",
     "cruz",
     "audrey",
     "richard_antore",
     "diana",
     "ares",
     "quincy_antore",
     "nereda",
     "elizabeth_the_third",
     "ever"
    ]
   },
   {
    "channel": "mm_chatroom",
    "passages": 18,
    "share": 0.0684,
    "first": "2016-09-08",
    "last": "2020-03-29",
    "kind": "route",
    "castWith": [
     "kaleb",
     "evelyn",
     "rika",
     "cruz",
     "elizabeth_the_third",
     "god",
     "mr_clien",
     "bryce",
     "ever",
     "marie_antoinette",
     "tom"
    ]
   },
   {
    "channel": "han-family-mansion",
    "passages": 16,
    "share": 0.0608,
    "first": "2020-04-14",
    "last": "2020-04-27",
    "kind": "route",
    "castWith": [
     "evelyn",
     "ezra",
     "kaleb",
     "kya_sg3",
     "rowan",
     "raye",
     "kya_sg1",
     "sune",
     "alistair",
     "alistair_turayne",
     "becca",
     "marta"
    ]
   },
   {
    "channel": "dimitri-castle",
    "passages": 15,
    "share": 0.057,
    "first": "2020-06-30",
    "last": "2020-07-23",
    "kind": "route",
    "castWith": [
     "dimitri",
     "evelyn",
     "stella",
     "ronin_tempus",
     "kaleb",
     "melisende",
     "gambit",
     "frau",
     "silas_mirace",
     "theo_uoki",
     "toko",
     "raye"
    ]
   },
   {
    "channel": "king-hans-office",
    "passages": 15,
    "share": 0.057,
    "first": "2020-04-01",
    "last": "2020-04-01",
    "kind": "route",
    "castWith": [
     "evelyn",
     "bryce",
     "kaleb"
    ]
   },
   {
    "channel": "jumins_apartment",
    "passages": 14,
    "share": 0.0532,
    "first": "2018-03-18",
    "last": "2020-03-25",
    "kind": "route",
    "castWith": [
     "kaleb",
     "elizabeth_the_third",
     "kya_sg3",
     "evelyn",
     "cruz"
    ]
   },
   {
    "channel": "val",
    "passages": 12,
    "share": 0.0456,
    "first": "2020-04-15",
    "last": "2020-12-16",
    "kind": "route",
    "castWith": [
     "val",
     "kya_sg3",
     "kaleb",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "evelyn",
     "vanessa",
     "ezra",
     "raye",
     "alan",
     "tyrion"
    ]
   },
   {
    "channel": "the-von-dabb-castle",
    "passages": 10,
    "share": 0.038,
    "first": "2020-04-01",
    "last": "2020-04-07",
    "kind": "route",
    "castWith": [
     "evelyn",
     "bryce",
     "rio",
     "frau",
     "geo",
     "alexei",
     "kaleb",
     "ezra",
     "bradshaw",
     "may",
     "kya_sg3",
     "will"
    ]
   },
   {
    "channel": "frau-collin",
    "passages": 8,
    "share": 0.0304,
    "first": "2020-11-10",
    "last": "2020-11-23",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "rowan",
     "frau",
     "collin_keller",
     "arland_rees",
     "ezra",
     "felix_fairy",
     "rikki",
     "park",
     "alyce_char",
     "myra"
    ]
   },
   {
    "channel": "dimitri-route-end",
    "passages": 6,
    "share": 0.0228,
    "first": "2021-01-29",
    "last": "2021-02-13",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "uri",
     "gambit",
     "jones",
     "ares",
     "bryce",
     "kaleb",
     "frau",
     "zeus",
     "kya_sg3",
     "uncle_khan"
    ]
   },
   {
    "channel": "evelyns_mansion",
    "passages": 6,
    "share": 0.0228,
    "first": "2016-09-26",
    "last": "2020-06-30",
    "kind": "route",
    "castWith": [
     "evelyn",
     "kaleb",
     "cruz",
     "kya_sg3",
     "ivy_morris",
     "marta",
     "kya_sg1",
     "frau",
     "sebastian_vamp",
     "god",
     "seuk",
     "dimitri"
    ]
   }
  ],
  "knownCharacters": [
   "kaleb",
   "ezra",
   "kya_sg3",
   "raye",
   "evelyn",
   "alistair_turayne",
   "alistair",
   "kya_sg1",
   "thorne",
   "prince_zain",
   "sune",
   "yuri_rekovich"
  ]
 },
 "ms_tia": {
  "canonRoute": "lets-abduct-evie",
  "totalPassages": 40,
  "routes": [
   {
    "channel": "lets-abduct-evie",
    "passages": 37,
    "share": 0.925,
    "first": "2021-07-05",
    "last": "2021-07-28",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "dimitri",
     "ryoto",
     "dodge",
     "kaleb",
     "frau",
     "aki",
     "cruz",
     "talbot",
     "ares",
     "zeus",
     "hera"
    ]
   },
   {
    "channel": "human-kieran",
    "passages": 3,
    "share": 0.075,
    "first": "2024-01-02",
    "last": "2024-01-04",
    "kind": "route",
    "castWith": [
     "kieran",
     "peter",
     "raz",
     "evan",
     "mei",
     "gemma",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "dimitri",
   "ryoto",
   "dodge",
   "kaleb",
   "frau",
   "aki",
   "cruz",
   "talbot",
   "ares",
   "zeus",
   "hera"
  ]
 },
 "myra": {
  "canonRoute": "tyrant-evie",
  "totalPassages": 74,
  "routes": [
   {
    "channel": "tyrant-evie",
    "passages": 26,
    "share": 0.3514,
    "first": "2021-12-19",
    "last": "2021-12-22",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "bryce",
     "cruz",
     "ares",
     "hermes",
     "rio",
     "hades",
     "frau",
     "zeus",
     "nolan",
     "audrey",
     "apollo"
    ]
   },
   {
    "channel": "northwest-pack-lodge",
    "passages": 13,
    "share": 0.1757,
    "first": "2020-04-19",
    "last": "2020-04-28",
    "kind": "route",
    "castWith": [
     "rowan",
     "evelyn",
     "lucius",
     "nellie",
     "cruz",
     "bryce",
     "will",
     "dimitri",
     "kaleb",
     "rio",
     "may",
     "mr_han_sr"
    ]
   },
   {
    "channel": "frau-collin",
    "passages": 11,
    "share": 0.1486,
    "first": "2020-04-17",
    "last": "2020-11-05",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "rowan",
     "frau",
     "collin_keller",
     "arland_rees",
     "ezra",
     "felix_fairy",
     "rikki",
     "park",
     "alyce_char",
     "allie"
    ]
   },
   {
    "channel": "pack-house",
    "passages": 7,
    "share": 0.0946,
    "first": "2020-04-18",
    "last": "2020-04-18",
    "kind": "route",
    "castWith": [
     "rowan",
     "evelyn",
     "cruz",
     "allie",
     "raye"
    ]
   },
   {
    "channel": "tyrant-evie-runs-away",
    "passages": 4,
    "share": 0.0541,
    "first": "2022-01-10",
    "last": "2022-01-24",
    "kind": "route",
    "castWith": [
     "evelyn",
     "bryce",
     "aspen",
     "rio",
     "ace",
     "kaleb",
     "kya_sg3",
     "alistair",
     "alistair_turayne",
     "ezra",
     "rowan",
     "eva"
    ]
   },
   {
    "channel": "brothel",
    "passages": 4,
    "share": 0.0541,
    "first": "2020-04-27",
    "last": "2020-04-27",
    "kind": "route",
    "castWith": [
     "ezra",
     "evelyn",
     "rowan",
     "kya_sg3",
     "kya_sg1",
     "primrose",
     "lily",
     "kaleb",
     "nellie",
     "lissa",
     "raye",
     "ace"
    ]
   },
   {
    "channel": "1-real-cruz",
    "passages": 3,
    "share": 0.0405,
    "first": "2022-10-11",
    "last": "2023-01-01",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "ares",
     "lance",
     "selma",
     "zeus",
     "lindon",
     "hera",
     "ryder",
     "apollo",
     "nolan"
    ]
   },
   {
    "channel": "row-dimitri",
    "passages": 3,
    "share": 0.0405,
    "first": "2022-12-16",
    "last": "2022-12-19",
    "kind": "route",
    "castWith": [
     "rowan",
     "dimitri",
     "evelyn",
     "kaleb",
     "ezra",
     "kya_sg3",
     "april"
    ]
   },
   {
    "channel": "almost-alpha-eva",
    "passages": 1,
    "share": 0.0135,
    "first": "2025-10-05",
    "last": "2025-10-05",
    "kind": "route",
    "castWith": [
     "eva",
     "cruz",
     "ford",
     "bryce",
     "shane",
     "ryder",
     "robert",
     "roger",
     "red",
     "audrey",
     "rowan",
     "diana"
    ]
   },
   {
    "channel": "human-lachesis",
    "passages": 1,
    "share": 0.0135,
    "first": "2024-10-22",
    "last": "2024-10-22",
    "kind": "route",
    "castWith": [
     "nicole_human",
     "brax",
     "lachesis",
     "lance",
     "vaughn",
     "rowan",
     "god",
     "alyce_char",
     "moros",
     "ford",
     "atropos",
     "cruz"
    ]
   },
   {
    "channel": "indifference",
    "passages": 1,
    "share": 0.0135,
    "first": "2024-04-13",
    "last": "2024-04-13",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "alyce_char",
     "dimitri",
     "ryder",
     "rio",
     "ace",
     "moros",
     "geo",
     "nolan",
     "audrey"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "bryce",
   "cruz",
   "ares",
   "hermes",
   "rio",
   "hades",
   "frau",
   "zeus",
   "nolan",
   "audrey",
   "apollo"
  ]
 },
 "natasha": {
  "canonRoute": "junta-is-best-boi",
  "totalPassages": 21,
  "routes": [
   {
    "channel": "junta-is-best-boi",
    "passages": 8,
    "share": 0.381,
    "first": "2023-12-07",
    "last": "2023-12-10",
    "kind": "canon",
    "castWith": [
     "junta",
     "ezra",
     "madison_astor",
     "lily",
     "val",
     "primrose",
     "belinda",
     "james",
     "may",
     "sebastian_vamp",
     "tim",
     "ace"
    ]
   },
   {
    "channel": "cruz-x-human",
    "passages": 4,
    "share": 0.1905,
    "first": "2021-03-31",
    "last": "2021-04-24",
    "kind": "route",
    "castWith": [
     "cruz",
     "skye",
     "nolan",
     "ryder",
     "audrey",
     "troy",
     "adrien",
     "bryce",
     "airi",
     "diana",
     "will",
     "allie"
    ]
   },
   {
    "channel": "junta-route",
    "passages": 4,
    "share": 0.1905,
    "first": "2022-11-28",
    "last": "2022-11-28",
    "kind": "route",
    "castWith": [
     "junta",
     "kya_sg3",
     "james",
     "kya_sg1",
     "apollo",
     "athena",
     "dillon",
     "kyo",
     "hermes",
     "belinda"
    ]
   },
   {
    "channel": "love-the-good-bois",
    "passages": 4,
    "share": 0.1905,
    "first": "2022-11-21",
    "last": "2022-11-22",
    "kind": "route",
    "castWith": [
     "ezra",
     "junta",
     "kya_sg3",
     "raz",
     "kya_sg1",
     "tim",
     "sebastian_vamp",
     "val",
     "evelyn",
     "kaleb",
     "skipper",
     "james"
    ]
   },
   {
    "channel": "junta-tim-soulmates",
    "passages": 1,
    "share": 0.0476,
    "first": "2023-09-21",
    "last": "2023-09-21",
    "kind": "route",
    "castWith": [
     "junta",
     "tim",
     "kieran",
     "raz",
     "peter",
     "kris",
     "dalton",
     "val",
     "vanessa",
     "ever",
     "aphrodite",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "junta",
   "ezra",
   "madison_astor",
   "lily",
   "val",
   "primrose",
   "belinda",
   "james",
   "may",
   "sebastian_vamp",
   "tim",
   "ace"
  ]
 },
 "naveed": {
  "canonRoute": "kingdom-of-temprum",
  "totalPassages": 8,
  "routes": [
   {
    "channel": "kingdom-of-temprum",
    "passages": 8,
    "share": 1.0,
    "first": "2020-05-24",
    "last": "2020-05-25",
    "kind": "canon",
    "castWith": [
     "aria",
     "bennett",
     "benji",
     "ajax",
     "fawn",
     "bast",
     "solum",
     "caria",
     "neitl",
     "batiuba",
     "will",
     "kaleb"
    ]
   }
  ],
  "knownCharacters": [
   "aria",
   "bennett",
   "benji",
   "ajax",
   "fawn",
   "bast",
   "solum",
   "caria",
   "neitl",
   "batiuba",
   "will",
   "kaleb"
  ]
 },
 "ned": {
  "canonRoute": "cruz-nicole-dollar-store",
  "totalPassages": 4,
  "routes": [
   {
    "channel": "cruz-nicole-dollar-store",
    "passages": 3,
    "share": 0.75,
    "first": "2020-09-08",
    "last": "2020-09-08",
    "kind": "canon",
    "castWith": [
     "cruz",
     "raz",
     "lance",
     "lachesis",
     "bryce",
     "nolan",
     "renee",
     "aphrodite",
     "clothos",
     "atropos",
     "nicole_wolf",
     "nicole_sg3"
    ]
   },
   {
    "channel": "evelyns_mansion",
    "passages": 1,
    "share": 0.25,
    "first": "2020-03-21",
    "last": "2020-03-21",
    "kind": "route",
    "castWith": [
     "evelyn",
     "kaleb",
     "cruz",
     "kya_sg3",
     "ivy_morris",
     "marta",
     "kya_sg1",
     "frau",
     "mr_han_sr",
     "sebastian_vamp",
     "god",
     "seuk"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "raz",
   "lance",
   "lachesis",
   "bryce",
   "nolan",
   "renee",
   "aphrodite",
   "clothos",
   "atropos",
   "nicole_wolf",
   "nicole_sg3"
  ]
 },
 "neitl": {
  "canonRoute": "kingdom-of-temprum",
  "totalPassages": 3,
  "routes": [
   {
    "channel": "kingdom-of-temprum",
    "passages": 3,
    "share": 1.0,
    "first": "2020-05-31",
    "last": "2020-05-31",
    "kind": "canon",
    "castWith": [
     "aria",
     "bennett",
     "benji",
     "ajax",
     "naveed",
     "fawn",
     "bast",
     "solum",
     "caria",
     "batiuba",
     "will",
     "kaleb"
    ]
   }
  ],
  "knownCharacters": [
   "aria",
   "bennett",
   "benji",
   "ajax",
   "naveed",
   "fawn",
   "bast",
   "solum",
   "caria",
   "batiuba",
   "will",
   "kaleb"
  ]
 },
 "nellie": {
  "canonRoute": "northwest-pack-lodge",
  "totalPassages": 59,
  "routes": [
   {
    "channel": "northwest-pack-lodge",
    "passages": 42,
    "share": 0.7119,
    "first": "2020-04-15",
    "last": "2020-04-28",
    "kind": "canon",
    "castWith": [
     "rowan",
     "evelyn",
     "lucius",
     "myra",
     "cruz",
     "bryce",
     "will",
     "dimitri",
     "kaleb",
     "rio",
     "may",
     "mr_han_sr"
    ]
   },
   {
    "channel": "brothel",
    "passages": 11,
    "share": 0.1864,
    "first": "2020-04-23",
    "last": "2020-04-27",
    "kind": "route",
    "castWith": [
     "ezra",
     "evelyn",
     "rowan",
     "kya_sg3",
     "kya_sg1",
     "primrose",
     "lily",
     "kaleb",
     "lissa",
     "raye",
     "ace",
     "mr_han_sr"
    ]
   },
   {
    "channel": "ooc",
    "passages": 5,
    "share": 0.0847,
    "first": "2020-04-22",
    "last": "2020-04-28",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "misc",
    "passages": 1,
    "share": 0.0169,
    "first": "2020-06-07",
    "last": "2020-06-07",
    "kind": "route",
    "castWith": [
     "aaron",
     "rowan",
     "evelyn",
     "kya_sg3",
     "kya_sg1",
     "lucius",
     "sabrina_witch",
     "sebastian_vamp",
     "sebastian_siren",
     "rex",
     "cupid_eros",
     "george_campbell"
    ]
   }
  ],
  "knownCharacters": [
   "rowan",
   "evelyn",
   "lucius",
   "myra",
   "cruz",
   "bryce",
   "will",
   "dimitri",
   "kaleb",
   "rio",
   "may",
   "mr_han_sr"
  ]
 },
 "nereda": {
  "canonRoute": "human-evie",
  "totalPassages": 4,
  "routes": [
   {
    "channel": "human-evie",
    "passages": 4,
    "share": 1.0,
    "first": "2021-02-26",
    "last": "2021-02-27",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "kaleb",
     "frau",
     "cruz",
     "mr_han_sr",
     "audrey",
     "richard_antore",
     "diana",
     "ares",
     "quincy_antore",
     "elizabeth_the_third",
     "ever"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "kaleb",
   "frau",
   "cruz",
   "mr_han_sr",
   "audrey",
   "richard_antore",
   "diana",
   "ares",
   "quincy_antore",
   "elizabeth_the_third",
   "ever"
  ]
 },
 "odin": {
  "canonRoute": "asgard",
  "totalPassages": 38,
  "routes": [
   {
    "channel": "asgard",
    "passages": 16,
    "share": 0.4211,
    "first": "2020-05-17",
    "last": "2020-05-21",
    "kind": "canon",
    "castWith": [
     "agnar",
     "agmund",
     "loki",
     "kya_sg3",
     "svira",
     "penelope_valk",
     "kya_sg1",
     "sif",
     "thor",
     "freya",
     "god",
     "frigg"
    ]
   },
   {
    "channel": "ag-ag",
    "passages": 11,
    "share": 0.2895,
    "first": "2022-10-03",
    "last": "2022-10-07",
    "kind": "route",
    "castWith": [
     "agnar",
     "agmund",
     "loki",
     "frigg",
     "kya_sg3",
     "freya",
     "penelope_valk",
     "will",
     "evelyn",
     "sebastian_vamp",
     "sebastian_siren",
     "hiro"
    ]
   },
   {
    "channel": "dorms",
    "passages": 6,
    "share": 0.1579,
    "first": "2020-05-08",
    "last": "2020-05-18",
    "kind": "route",
    "castWith": [
     "agnar",
     "kya_sg3",
     "agmund",
     "evelyn",
     "raye",
     "cole",
     "kya_sg1",
     "riku",
     "kaleb",
     "penelope_valk",
     "loki",
     "svira"
    ]
   },
   {
    "channel": "kya-college-2",
    "passages": 3,
    "share": 0.0789,
    "first": "2020-12-27",
    "last": "2020-12-28",
    "kind": "route",
    "castWith": [
     "lily",
     "zander",
     "kya_sg3",
     "kya_sg1",
     "ari",
     "sebastian_siren",
     "raye",
     "prince_zed",
     "sebastian_vamp",
     "midori_naga",
     "penelope_valk",
     "bell_lily_of_fell"
    ]
   },
   {
    "channel": "ooc",
    "passages": 1,
    "share": 0.0263,
    "first": "2020-05-19",
    "last": "2020-05-19",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "college-campus",
    "passages": 1,
    "share": 0.0263,
    "first": "2020-05-13",
    "last": "2020-05-13",
    "kind": "route",
    "castWith": [
     "agnar",
     "agmund",
     "kya_sg3",
     "penelope_valk",
     "evelyn",
     "svira",
     "rowan",
     "may",
     "jon",
     "kya_sg1",
     "kaleb",
     "darren"
    ]
   }
  ],
  "knownCharacters": [
   "agnar",
   "agmund",
   "loki",
   "kya_sg3",
   "svira",
   "penelope_valk",
   "kya_sg1",
   "sif",
   "thor",
   "freya",
   "god",
   "frigg"
  ]
 },
 "oliver_macdonagh": {
  "canonRoute": "cutie-prince-dream",
  "totalPassages": 52,
  "routes": [
   {
    "channel": "cutie-prince-dream",
    "passages": 52,
    "share": 1.0,
    "first": "2022-07-12",
    "last": "2022-08-06",
    "kind": "canon",
    "castWith": [
     "donnelly_macdonagh",
     "sebastian_siren",
     "kya_sg3",
     "kya_sg1",
     "sebastian_vamp",
     "raz",
     "dillon",
     "kaleb",
     "may",
     "atropos",
     "val",
     "vanessa"
    ]
   }
  ],
  "knownCharacters": [
   "donnelly_macdonagh",
   "sebastian_siren",
   "kya_sg3",
   "kya_sg1",
   "sebastian_vamp",
   "raz",
   "dillon",
   "kaleb",
   "may",
   "atropos",
   "val",
   "vanessa"
  ]
 },
 "pam": {
  "canonRoute": "cupid-hq",
  "totalPassages": 5,
  "routes": [
   {
    "channel": "eat-speak-rp-repeat",
    "passages": 3,
    "share": 0.6,
    "first": "2026-03-25",
    "last": "2026-03-27",
    "kind": "ooc",
    "castWith": [
     "eric",
     "cruz",
     "lindon",
     "april",
     "lance",
     "felix_fairy",
     "brooke",
     "cyrus_fairy",
     "malakai",
     "god",
     "jack",
     "ezra"
    ]
   },
   {
    "channel": "cupid-hq",
    "passages": 2,
    "share": 0.4,
    "first": "2020-06-03",
    "last": "2020-06-03",
    "kind": "canon",
    "castWith": [
     "cupid_eros",
     "sabrina_witch",
     "tim",
     "drake",
     "halo",
     "god",
     "aphrodite",
     "stan",
     "tom",
     "hiro",
     "ares",
     "hades"
    ]
   }
  ],
  "knownCharacters": [
   "cupid_eros",
   "sabrina_witch",
   "tim",
   "drake",
   "halo",
   "god",
   "aphrodite",
   "stan",
   "tom",
   "hiro",
   "ares",
   "hades"
  ]
 },
 "park": {
  "canonRoute": "frau-collin",
  "totalPassages": 20,
  "routes": [
   {
    "channel": "frau-collin",
    "passages": 15,
    "share": 0.75,
    "first": "2020-11-26",
    "last": "2020-12-02",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "cruz",
     "rowan",
     "frau",
     "collin_keller",
     "arland_rees",
     "ezra",
     "felix_fairy",
     "rikki",
     "alyce_char",
     "myra",
     "allie"
    ]
   },
   {
    "channel": "Lindon + Ford",
    "passages": 3,
    "share": 0.15,
    "first": "2026-05-20",
    "last": "2026-05-28",
    "kind": "route",
    "castWith": [
     "ford",
     "lindon",
     "tim",
     "dante",
     "felix_fairy",
     "nicole_human",
     "nicole_wolf",
     "nicole_sg3",
     "ben",
     "may",
     "will",
     "ezra"
    ]
   },
   {
    "channel": "cruz-nicole-dollar-store",
    "passages": 1,
    "share": 0.05,
    "first": "2020-09-08",
    "last": "2020-09-08",
    "kind": "route",
    "castWith": [
     "cruz",
     "raz",
     "lance",
     "lachesis",
     "bryce",
     "nolan",
     "renee",
     "aphrodite",
     "clothos",
     "atropos",
     "nicole_wolf",
     "nicole_sg3"
    ]
   },
   {
    "channel": "yandere-cruz",
    "passages": 1,
    "share": 0.05,
    "first": "2022-10-30",
    "last": "2022-10-30",
    "kind": "route",
    "castWith": [
     "lance",
     "cruz",
     "evelyn",
     "moros",
     "ares",
     "alyce_char",
     "clothos",
     "atropos",
     "dimitri",
     "lachesis",
     "cupid_eros",
     "hades"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "cruz",
   "rowan",
   "frau",
   "collin_keller",
   "arland_rees",
   "ezra",
   "felix_fairy",
   "rikki",
   "alyce_char",
   "myra",
   "allie"
  ]
 },
 "paul": {
  "canonRoute": "1920s-boardwalk",
  "totalPassages": 6,
  "routes": [
   {
    "channel": "1920s-boardwalk",
    "passages": 1,
    "share": 0.1667,
    "first": "2022-05-23",
    "last": "2022-05-23",
    "kind": "canon",
    "castWith": [
     "val",
     "ezra",
     "kya_sg3",
     "james",
     "alistair_turayne",
     "kya_sg1",
     "alistair",
     "vanessa",
     "sebastian_vamp",
     "sebastian_siren",
     "amelda",
     "junta"
    ]
   },
   {
    "channel": "sebby-of-the-pacific",
    "passages": 1,
    "share": 0.1667,
    "first": "2025-08-01",
    "last": "2025-08-01",
    "kind": "route",
    "castWith": [
     "dillon",
     "kaleb",
     "uncle_khan"
    ]
   },
   {
    "channel": "sebby",
    "passages": 1,
    "share": 0.1667,
    "first": "2022-09-28",
    "last": "2022-09-28",
    "kind": "route",
    "castWith": [
     "kya_sg1",
     "kya_sg3",
     "sebastian_vamp",
     "sebastian_siren",
     "polly"
    ]
   },
   {
    "channel": "peter",
    "passages": 1,
    "share": 0.1667,
    "first": "2023-09-25",
    "last": "2023-09-25",
    "kind": "route",
    "castWith": [
     "peter",
     "kieran",
     "raz",
     "george_campbell"
    ]
   },
   {
    "channel": "reed-vamp-werecheetah",
    "passages": 1,
    "share": 0.1667,
    "first": "2023-11-16",
    "last": "2023-11-16",
    "kind": "route",
    "castWith": [
     "reed",
     "madison_astor",
     "kale",
     "raye",
     "arnold_astor",
     "may",
     "xavier",
     "zeke"
    ]
   },
   {
    "channel": "pack_house",
    "passages": 1,
    "share": 0.1667,
    "first": "2020-03-26",
    "last": "2020-03-26",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "nolan",
     "bryce",
     "audrey",
     "allie",
     "alyce_char",
     "luca",
     "trix",
     "asmodeus",
     "ryder",
     "kaleb"
    ]
   }
  ],
  "knownCharacters": [
   "val",
   "ezra",
   "kya_sg3",
   "james",
   "alistair_turayne",
   "kya_sg1",
   "alistair",
   "vanessa",
   "sebastian_vamp",
   "sebastian_siren",
   "amelda",
   "junta"
  ]
 },
 "paula": {
  "canonRoute": "to-the-max",
  "totalPassages": 2,
  "routes": [
   {
    "channel": "to-the-max",
    "passages": 2,
    "share": 1.0,
    "first": "2023-05-28",
    "last": "2023-05-29",
    "kind": "canon",
    "castWith": [
     "maxen_bryers",
     "addison",
     "trace_renton",
     "kya_sg3",
     "kya_sg1",
     "rick",
     "evelyn",
     "beatrice",
     "dillon",
     "budd",
     "lore",
     "diana"
    ]
   }
  ],
  "knownCharacters": [
   "maxen_bryers",
   "addison",
   "trace_renton",
   "kya_sg3",
   "kya_sg1",
   "rick",
   "evelyn",
   "beatrice",
   "dillon",
   "budd",
   "lore",
   "diana"
  ]
 },
 "persephone": {
  "canonRoute": "mt-olympus",
  "totalPassages": 53,
  "routes": [
   {
    "channel": "mt-olympus",
    "passages": 18,
    "share": 0.3396,
    "first": "2020-03-29",
    "last": "2020-03-29",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "libion",
     "ares",
     "rex",
     "bion",
     "hades",
     "aphrodite",
     "hercules",
     "demeter",
     "zeus",
     "athena",
     "zerden"
    ]
   },
   {
    "channel": "3-haleys-hades-fanfic",
    "passages": 11,
    "share": 0.2075,
    "first": "2022-12-31",
    "last": "2023-02-07",
    "kind": "au",
    "castWith": [
     "hades",
     "kyo",
     "amoura",
     "kya_sg3",
     "kya_sg1",
     "kaleb",
     "dillon",
     "apollo",
     "sebastian_vamp",
     "sebastian_siren",
     "eli",
     "god"
    ]
   },
   {
    "channel": "hades-palace",
    "passages": 5,
    "share": 0.0943,
    "first": "2020-03-29",
    "last": "2020-03-29",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hades",
     "libion",
     "cruz",
     "bryce",
     "bion",
     "will",
     "hercules",
     "hermes",
     "god"
    ]
   },
   {
    "channel": "evelyn-college-2",
    "passages": 3,
    "share": 0.0566,
    "first": "2020-12-27",
    "last": "2021-01-13",
    "kind": "route",
    "castWith": [
     "evelyn",
     "darren",
     "dimitri",
     "lex",
     "hades",
     "raye",
     "jon",
     "ares",
     "kaleb",
     "cruz",
     "kya_sg3",
     "ari"
    ]
   },
   {
    "channel": "lachesis-off-the-rails",
    "passages": 3,
    "share": 0.0566,
    "first": "2025-09-09",
    "last": "2025-09-09",
    "kind": "route",
    "castWith": [
     "lance",
     "vaughn",
     "brax",
     "lucifer",
     "james",
     "atropos",
     "cruz",
     "lachesis",
     "ace",
     "lindon",
     "hades",
     "ezra"
    ]
   },
   {
    "channel": "ooc",
    "passages": 3,
    "share": 0.0566,
    "first": "2020-04-16",
    "last": "2020-04-28",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 3,
    "share": 0.0566,
    "first": "2020-03-29",
    "last": "2020-03-29",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika"
    ]
   },
   {
    "channel": "heaven",
    "passages": 3,
    "share": 0.0566,
    "first": "2020-03-28",
    "last": "2020-03-28",
    "kind": "route",
    "castWith": [
     "evelyn",
     "libion",
     "cruz",
     "bryce",
     "bion",
     "hades",
     "demeter",
     "god",
     "aphrodite",
     "apollo",
     "rika"
    ]
   },
   {
    "channel": "1-real-cruz",
    "passages": 1,
    "share": 0.0189,
    "first": "2023-01-14",
    "last": "2023-01-14",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "ares",
     "lance",
     "selma",
     "zeus",
     "lindon",
     "hera",
     "ryder",
     "apollo",
     "nolan"
    ]
   },
   {
    "channel": "ocroute2-cruz-in-for-love",
    "passages": 1,
    "share": 0.0189,
    "first": "2022-01-30",
    "last": "2022-01-30",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "dimitri",
     "hades",
     "zeus",
     "hera",
     "aphrodite",
     "god",
     "bryce",
     "amanda",
     "lachesis",
     "hermes"
    ]
   },
   {
    "channel": "lance-mating",
    "passages": 1,
    "share": 0.0189,
    "first": "2021-08-26",
    "last": "2021-08-26",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "clothos",
     "ryder",
     "hades",
     "nolan",
     "nicole_human",
     "audrey",
     "moros",
     "atropos",
     "nicole_wolf"
    ]
   },
   {
    "channel": "lance-decides",
    "passages": 1,
    "share": 0.0189,
    "first": "2024-12-17",
    "last": "2024-12-17",
    "kind": "route",
    "castWith": [
     "lance",
     "rin",
     "lucifer",
     "lachesis",
     "nicole_human",
     "god",
     "chiara",
     "cupid_eros",
     "roman",
     "asrius",
     "hera",
     "zeus"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "libion",
   "ares",
   "rex",
   "bion",
   "hades",
   "aphrodite",
   "hercules",
   "demeter",
   "zeus",
   "athena",
   "zerden"
  ]
 },
 "poppy": {
  "canonRoute": "cruz-nicole-dollar-store",
  "totalPassages": 1,
  "routes": [
   {
    "channel": "cruz-nicole-dollar-store",
    "passages": 1,
    "share": 1.0,
    "first": "2020-09-08",
    "last": "2020-09-08",
    "kind": "canon",
    "castWith": [
     "cruz",
     "raz",
     "lance",
     "lachesis",
     "bryce",
     "nolan",
     "renee",
     "aphrodite",
     "clothos",
     "atropos",
     "nicole_wolf",
     "nicole_sg3"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "raz",
   "lance",
   "lachesis",
   "bryce",
   "nolan",
   "renee",
   "aphrodite",
   "clothos",
   "atropos",
   "nicole_wolf",
   "nicole_sg3"
  ]
 },
 "poseidon": {
  "canonRoute": "1-real-cruz",
  "totalPassages": 33,
  "routes": [
   {
    "channel": "1-real-cruz",
    "passages": 15,
    "share": 0.4545,
    "first": "2023-01-13",
    "last": "2023-01-19",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "ares",
     "lance",
     "selma",
     "zeus",
     "lindon",
     "hera",
     "ryder",
     "apollo",
     "nolan"
    ]
   },
   {
    "channel": "mt-olympus",
    "passages": 3,
    "share": 0.0909,
    "first": "2020-03-29",
    "last": "2020-03-30",
    "kind": "route",
    "castWith": [
     "evelyn",
     "libion",
     "ares",
     "rex",
     "persephone",
     "bion",
     "hades",
     "aphrodite",
     "hercules",
     "demeter",
     "zeus",
     "athena"
    ]
   },
   {
    "channel": "kya-werewolf",
    "passages": 2,
    "share": 0.0606,
    "first": "2021-08-18",
    "last": "2021-08-18",
    "kind": "route",
    "castWith": [
     "jace",
     "raphael",
     "trey",
     "dillon",
     "kya_sg3",
     "scott",
     "kya_sg1",
     "ezra",
     "sebastian_siren",
     "kaleb",
     "sebastian_vamp",
     "evelyn"
    ]
   },
   {
    "channel": "vaughneo-and-juliet",
    "passages": 2,
    "share": 0.0606,
    "first": "2025-11-24",
    "last": "2025-11-24",
    "kind": "route",
    "castWith": [
     "vaughn",
     "brax",
     "lindon",
     "declan",
     "ares",
     "skye",
     "roman",
     "mary_cataldi",
     "liz",
     "nicole_human",
     "aphrodite",
     "ace"
    ]
   },
   {
    "channel": "kya-in-the-abyss",
    "passages": 2,
    "share": 0.0606,
    "first": "2025-10-27",
    "last": "2025-10-27",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "kya_sg1",
     "god",
     "kaleb",
     "dillon",
     "terrance",
     "will"
    ]
   },
   {
    "channel": "alistair-tailbond",
    "passages": 2,
    "share": 0.0606,
    "first": "2024-04-30",
    "last": "2024-04-30",
    "kind": "route",
    "castWith": [
     "kaleb",
     "kya_sg3",
     "alistair",
     "alistair_turayne",
     "ezra",
     "dillon",
     "kya_sg1",
     "sebastian_vamp",
     "raye",
     "uncle_khan",
     "evelyn",
     "sebastian_siren"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 2,
    "share": 0.0606,
    "first": "2020-03-30",
    "last": "2020-03-30",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika"
    ]
   },
   {
    "channel": "dillon-knows",
    "passages": 1,
    "share": 0.0303,
    "first": "2025-12-16",
    "last": "2025-12-16",
    "kind": "route",
    "castWith": [
     "dillon",
     "kyo",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "kaleb",
     "sebastian_vamp",
     "ever",
     "will",
     "lachesis",
     "amoura",
     "hadrian"
    ]
   },
   {
    "channel": "switched-roles-kya",
    "passages": 1,
    "share": 0.0303,
    "first": "2023-10-14",
    "last": "2023-10-14",
    "kind": "au",
    "castWith": [
     "diana",
     "kya_sg3",
     "raye",
     "ezra",
     "tate",
     "emanuel",
     "kya_sg1",
     "aphrodite",
     "alistair_turayne",
     "alistair",
     "kaleb",
     "cupid_eros"
    ]
   },
   {
    "channel": "50-shades-of-ezra",
    "passages": 1,
    "share": 0.0303,
    "first": "2021-10-05",
    "last": "2021-10-05",
    "kind": "route",
    "castWith": [
     "ezra",
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "dillon",
     "evelyn",
     "sebastian_vamp",
     "sebastian_siren",
     "primrose",
     "uncle_khan",
     "celestine",
     "alistair"
    ]
   },
   {
    "channel": "kya-seb-nice-uncle",
    "passages": 1,
    "share": 0.0303,
    "first": "2025-12-23",
    "last": "2025-12-23",
    "kind": "route",
    "castWith": [
     "dillon",
     "aaron",
     "kaleb",
     "kyo",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "polly",
     "evelyn",
     "sebastian_vamp",
     "frau",
     "ami"
    ]
   },
   {
    "channel": "dorms",
    "passages": 1,
    "share": 0.0303,
    "first": "2020-05-02",
    "last": "2020-05-02",
    "kind": "route",
    "castWith": [
     "agnar",
     "kya_sg3",
     "agmund",
     "evelyn",
     "raye",
     "cole",
     "kya_sg1",
     "riku",
     "kaleb",
     "penelope_valk",
     "loki",
     "svira"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "cruz",
   "bryce",
   "ares",
   "lance",
   "selma",
   "zeus",
   "lindon",
   "hera",
   "ryder",
   "apollo",
   "nolan"
  ]
 },
 "porscha_steele": {
  "canonRoute": "lance-mating",
  "totalPassages": 5,
  "routes": [
   {
    "channel": "AU: Ford Steele \u2014 Branched at msg 89/600 (5/1/2026) (branched at msg 638)",
    "passages": 3,
    "share": 0.6,
    "first": "2026-05-08",
    "last": "2026-05-08",
    "kind": "au",
    "castWith": [
     "ford",
     "cruz",
     "ryder",
     "nicole_human",
     "audrey",
     "nolan",
     "may",
     "haley_human",
     "diana",
     "evelyn",
     "dimitri",
     "aaron"
    ]
   },
   {
    "channel": "lance-mating",
    "passages": 1,
    "share": 0.2,
    "first": "2021-09-08",
    "last": "2021-09-08",
    "kind": "canon",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "clothos",
     "ryder",
     "hades",
     "nolan",
     "nicole_human",
     "audrey",
     "moros",
     "atropos",
     "nicole_wolf"
    ]
   },
   {
    "channel": "cruz-x-nicole",
    "passages": 1,
    "share": 0.2,
    "first": "2020-08-08",
    "last": "2020-08-08",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "hermes",
     "audrey",
     "peter",
     "ares",
     "nicole_wolf",
     "nicole_sg3",
     "alyce_char",
     "red",
     "trix",
     "nicole_human"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "lance",
   "lachesis",
   "clothos",
   "ryder",
   "hades",
   "nolan",
   "nicole_human",
   "audrey",
   "moros",
   "atropos",
   "nicole_wolf"
  ]
 },
 "prince_andrew": {
  "canonRoute": "fae-courts",
  "totalPassages": 8,
  "routes": [
   {
    "channel": "fae-courts",
    "passages": 3,
    "share": 0.375,
    "first": "2024-10-19",
    "last": "2024-10-21",
    "kind": "canon",
    "castWith": [
     "elias",
     "will",
     "eli",
     "ever",
     "frederick",
     "may"
    ]
   },
   {
    "channel": "dining-hall",
    "passages": 2,
    "share": 0.25,
    "first": "2020-06-08",
    "last": "2020-06-08",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "bryce",
     "rex",
     "milo",
     "aaron",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "lex",
     "sebastian_vamp",
     "dike"
    ]
   },
   {
    "channel": "haley-finds-out-shes-cool-2",
    "passages": 1,
    "share": 0.125,
    "first": "2022-12-05",
    "last": "2022-12-05",
    "kind": "route",
    "castWith": [
     "moros",
     "atropos",
     "gracie",
     "haley_human",
     "jinko",
     "lance",
     "may",
     "lachesis",
     "athena",
     "clothos",
     "haley_wolf",
     "peter"
    ]
   },
   {
    "channel": "the-kingdom-fallon",
    "passages": 1,
    "share": 0.125,
    "first": "2021-06-02",
    "last": "2021-06-02",
    "kind": "route",
    "castWith": [
     "evelyn",
     "eva",
     "rory",
     "raye",
     "fiadh",
     "ciarnan",
     "finn",
     "cailte",
     "senan",
     "diarmund",
     "fiann",
     "goll"
    ]
   },
   {
    "channel": "ooc",
    "passages": 1,
    "share": 0.125,
    "first": "2020-06-08",
    "last": "2020-06-08",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   }
  ],
  "knownCharacters": [
   "elias",
   "will",
   "eli",
   "ever",
   "frederick",
   "may"
  ]
 },
 "prince_teregan": {
  "canonRoute": "a-demons-jewel",
  "totalPassages": 1,
  "routes": [
   {
    "channel": "a-demons-jewel",
    "passages": 1,
    "share": 1.0,
    "first": "2022-02-01",
    "last": "2022-02-01",
    "kind": "canon",
    "castWith": [
     "tallia",
     "adrianne",
     "lucifer",
     "god",
     "will",
     "may",
     "gabriel"
    ]
   }
  ],
  "knownCharacters": [
   "tallia",
   "adrianne",
   "lucifer",
   "god",
   "will",
   "may",
   "gabriel"
  ]
 },
 "prince_zed": {
  "canonRoute": "kya-college-2",
  "totalPassages": 31,
  "routes": [
   {
    "channel": "kya-college-2",
    "passages": 31,
    "share": 1.0,
    "first": "2021-01-13",
    "last": "2021-01-21",
    "kind": "canon",
    "castWith": [
     "lily",
     "zander",
     "kya_sg3",
     "kya_sg1",
     "ari",
     "sebastian_siren",
     "raye",
     "sebastian_vamp",
     "midori_naga",
     "penelope_valk",
     "bell_lily_of_fell",
     "agnar"
    ]
   }
  ],
  "knownCharacters": [
   "lily",
   "zander",
   "kya_sg3",
   "kya_sg1",
   "ari",
   "sebastian_siren",
   "raye",
   "sebastian_vamp",
   "midori_naga",
   "penelope_valk",
   "bell_lily_of_fell",
   "agnar"
  ]
 },
 "prudence_vernon_specklebeck": {
  "canonRoute": "dimitri-route-end",
  "totalPassages": 2,
  "routes": [
   {
    "channel": "dimitri-route-end",
    "passages": 2,
    "share": 1.0,
    "first": "2021-02-13",
    "last": "2021-02-13",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "dimitri",
     "uri",
     "gambit",
     "jones",
     "ares",
     "bryce",
     "kaleb",
     "frau",
     "mr_han_sr",
     "zeus",
     "kya_sg3"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "dimitri",
   "uri",
   "gambit",
   "jones",
   "ares",
   "bryce",
   "kaleb",
   "frau",
   "mr_han_sr",
   "zeus",
   "kya_sg3"
  ]
 },
 "quincy_antore": {
  "canonRoute": "human-evie",
  "totalPassages": 6,
  "routes": [
   {
    "channel": "human-evie",
    "passages": 6,
    "share": 1.0,
    "first": "2021-02-25",
    "last": "2021-02-26",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "kaleb",
     "frau",
     "cruz",
     "mr_han_sr",
     "audrey",
     "richard_antore",
     "diana",
     "ares",
     "nereda",
     "elizabeth_the_third",
     "ever"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "kaleb",
   "frau",
   "cruz",
   "mr_han_sr",
   "audrey",
   "richard_antore",
   "diana",
   "ares",
   "nereda",
   "elizabeth_the_third",
   "ever"
  ]
 },
 "rachel": {
  "canonRoute": "high-school-ezra-kya",
  "totalPassages": 14,
  "routes": [
   {
    "channel": "high-school-ezra-kya",
    "passages": 12,
    "share": 0.8571,
    "first": "2021-02-23",
    "last": "2021-02-26",
    "kind": "canon",
    "castWith": [
     "ezra",
     "kya_sg3",
     "maria",
     "kaleb",
     "kya_sg1",
     "evelyn",
     "willie",
     "jane",
     "primrose",
     "lily",
     "ace",
     "uncle_khan"
    ]
   },
   {
    "channel": "lance-nicole-2",
    "passages": 1,
    "share": 0.0714,
    "first": "2022-12-14",
    "last": "2022-12-14",
    "kind": "route",
    "castWith": [
     "brax",
     "vaughn",
     "lance",
     "jenning",
     "cruz",
     "lachesis",
     "nicole_human",
     "nicole_wolf",
     "nicole_sg3",
     "clothos",
     "atropos",
     "rowan"
    ]
   },
   {
    "channel": "frau-collin",
    "passages": 1,
    "share": 0.0714,
    "first": "2020-12-07",
    "last": "2020-12-07",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "rowan",
     "frau",
     "collin_keller",
     "arland_rees",
     "ezra",
     "felix_fairy",
     "rikki",
     "park",
     "alyce_char",
     "myra"
    ]
   }
  ],
  "knownCharacters": [
   "ezra",
   "kya_sg3",
   "maria",
   "kaleb",
   "kya_sg1",
   "evelyn",
   "willie",
   "jane",
   "primrose",
   "lily",
   "ace",
   "uncle_khan"
  ]
 },
 "ragland": {
  "canonRoute": "foyer-living-room",
  "totalPassages": 86,
  "routes": [
   {
    "channel": "foyer-living-room",
    "passages": 35,
    "share": 0.407,
    "first": "2020-04-07",
    "last": "2020-05-22",
    "kind": "canon",
    "castWith": [
     "aria",
     "benji",
     "bennett",
     "ajax",
     "rin",
     "kent",
     "miles",
     "may"
    ]
   },
   {
    "channel": "rin-and-ragland-wing",
    "passages": 27,
    "share": 0.314,
    "first": "2020-04-11",
    "last": "2020-04-12",
    "kind": "route",
    "castWith": [
     "aria",
     "rin",
     "ajax",
     "miles",
     "kent"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 8,
    "share": 0.093,
    "first": "2020-04-09",
    "last": "2020-05-25",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "makeshift-attic-bedroom",
    "passages": 5,
    "share": 0.0581,
    "first": "2020-04-08",
    "last": "2020-04-08",
    "kind": "route",
    "castWith": [
     "aria",
     "benji",
     "bennett",
     "ajax",
     "miles"
    ]
   },
   {
    "channel": "eros-and-kent-wing",
    "passages": 3,
    "share": 0.0349,
    "first": "2020-04-10",
    "last": "2020-04-12",
    "kind": "route",
    "castWith": [
     "aria",
     "bennett",
     "benji",
     "ajax",
     "kent",
     "miles",
     "will"
    ]
   },
   {
    "channel": "kingdom-of-welis",
    "passages": 3,
    "share": 0.0349,
    "first": "2020-04-12",
    "last": "2020-04-13",
    "kind": "route",
    "castWith": [
     "aria",
     "caria",
     "ajax",
     "batiuba",
     "kent",
     "will"
    ]
   },
   {
    "channel": "memory-char-bios",
    "passages": 2,
    "share": 0.0233,
    "first": "2020-04-01",
    "last": "2020-05-22",
    "kind": "route",
    "castWith": [
     "bennett",
     "benji",
     "miles",
     "ajax",
     "kent",
     "rin",
     "aria"
    ]
   },
   {
    "channel": "warring-men",
    "passages": 1,
    "share": 0.0116,
    "first": "2025-09-16",
    "last": "2025-09-16",
    "kind": "route",
    "castWith": [
     "aelira",
     "killian",
     "arthur_turayne",
     "autumn",
     "summer",
     "terrance",
     "may",
     "will"
    ]
   },
   {
    "channel": "kingdom-of-temprum",
    "passages": 1,
    "share": 0.0116,
    "first": "2020-05-22",
    "last": "2020-05-22",
    "kind": "route",
    "castWith": [
     "aria",
     "bennett",
     "benji",
     "ajax",
     "naveed",
     "fawn",
     "bast",
     "solum",
     "caria",
     "neitl",
     "batiuba",
     "will"
    ]
   },
   {
    "channel": "ajax-and-miles-wing",
    "passages": 1,
    "share": 0.0116,
    "first": "2020-04-11",
    "last": "2020-04-11",
    "kind": "route",
    "castWith": [
     "ajax",
     "aria"
    ]
   }
  ],
  "knownCharacters": [
   "aria",
   "benji",
   "bennett",
   "ajax",
   "rin",
   "kent",
   "miles",
   "may"
  ]
 },
 "ramiel": {
  "canonRoute": "plz-love-lachesis",
  "totalPassages": 225,
  "routes": [
   {
    "channel": "plz-love-lachesis",
    "passages": 145,
    "share": 0.6444,
    "first": "2022-11-11",
    "last": "2022-11-26",
    "kind": "canon",
    "castWith": [
     "lachesis",
     "lance",
     "god",
     "lucifer",
     "apollo",
     "levi",
     "aion",
     "atropos",
     "zeus",
     "zadkiel",
     "clothos",
     "asrius"
    ]
   },
   {
    "channel": "haggle-for-the-girl",
    "passages": 41,
    "share": 0.1822,
    "first": "2023-12-17",
    "last": "2024-01-16",
    "kind": "route",
    "castWith": [
     "lachesis",
     "lucifer",
     "asrius",
     "god",
     "lonnie",
     "gabriel",
     "lance",
     "hades",
     "alyk",
     "aphrodite",
     "atropos",
     "zeus"
    ]
   },
   {
    "channel": "oops-its-heaven",
    "passages": 29,
    "share": 0.1289,
    "first": "2022-08-23",
    "last": "2022-09-10",
    "kind": "route",
    "castWith": [
     "lachesis",
     "lance",
     "god",
     "aldo",
     "lucifer",
     "atropos",
     "mary_cataldi",
     "hades",
     "clothos",
     "zeus"
    ]
   },
   {
    "channel": "switched-roles-lachesis",
    "passages": 8,
    "share": 0.0356,
    "first": "2023-10-16",
    "last": "2023-10-16",
    "kind": "au",
    "castWith": [
     "lachesis",
     "ford",
     "god",
     "lucifer",
     "cruz",
     "clothos",
     "atropos",
     "rowan",
     "vaughn",
     "ryder",
     "brax",
     "dimitri"
    ]
   },
   {
    "channel": "lance-nicole-2",
    "passages": 2,
    "share": 0.0089,
    "first": "2022-12-03",
    "last": "2022-12-12",
    "kind": "route",
    "castWith": [
     "brax",
     "vaughn",
     "lance",
     "jenning",
     "cruz",
     "lachesis",
     "nicole_human",
     "nicole_wolf",
     "nicole_sg3",
     "clothos",
     "atropos",
     "rowan"
    ]
   }
  ],
  "knownCharacters": [
   "lachesis",
   "lance",
   "god",
   "lucifer",
   "apollo",
   "levi",
   "aion",
   "atropos",
   "zeus",
   "zadkiel",
   "clothos",
   "asrius"
  ]
 },
 "raphael": {
  "canonRoute": "kya-werewolf",
  "totalPassages": 78,
  "routes": [
   {
    "channel": "kya-werewolf",
    "passages": 75,
    "share": 0.9615,
    "first": "2021-08-27",
    "last": "2021-09-26",
    "kind": "canon",
    "castWith": [
     "jace",
     "trey",
     "dillon",
     "kya_sg3",
     "scott",
     "kya_sg1",
     "ezra",
     "sebastian_siren",
     "kaleb",
     "sebastian_vamp",
     "evelyn",
     "will"
    ]
   },
   {
    "channel": "switched-roles-lachesis",
    "passages": 3,
    "share": 0.0385,
    "first": "2023-11-13",
    "last": "2023-11-13",
    "kind": "au",
    "castWith": [
     "lachesis",
     "ford",
     "god",
     "lucifer",
     "cruz",
     "clothos",
     "atropos",
     "rowan",
     "vaughn",
     "ryder",
     "brax",
     "dimitri"
    ]
   }
  ],
  "knownCharacters": [
   "jace",
   "trey",
   "dillon",
   "kya_sg3",
   "scott",
   "kya_sg1",
   "ezra",
   "sebastian_siren",
   "kaleb",
   "sebastian_vamp",
   "evelyn",
   "will"
  ]
 },
 "raquel_ratchet": {
  "canonRoute": "growing-up-cruz",
  "totalPassages": 7,
  "routes": [
   {
    "channel": "growing-up-cruz",
    "passages": 5,
    "share": 0.7143,
    "first": "2023-02-09",
    "last": "2023-02-10",
    "kind": "canon",
    "castWith": [
     "cruz",
     "evelyn",
     "allie",
     "kaleb",
     "audrey",
     "dimitri",
     "trix",
     "ford",
     "ryder",
     "lyden",
     "frau",
     "uncle_khan"
    ]
   },
   {
    "channel": "cruz-x-human",
    "passages": 2,
    "share": 0.2857,
    "first": "2021-04-01",
    "last": "2021-05-02",
    "kind": "route",
    "castWith": [
     "cruz",
     "skye",
     "nolan",
     "ryder",
     "audrey",
     "troy",
     "adrien",
     "bryce",
     "airi",
     "natasha",
     "diana",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "evelyn",
   "allie",
   "kaleb",
   "audrey",
   "dimitri",
   "trix",
   "ford",
   "ryder",
   "lyden",
   "frau",
   "uncle_khan"
  ]
 },
 "ray": {
  "canonRoute": "the-great-husbando-race",
  "totalPassages": 9,
  "routes": [
   {
    "channel": "the-great-husbando-race",
    "passages": 3,
    "share": 0.3333,
    "first": "2020-06-07",
    "last": "2020-06-07",
    "kind": "canon",
    "castWith": [
     "kira",
     "leon",
     "cupid_eros",
     "loki",
     "riku",
     "victor",
     "evelyn",
     "junta",
     "ben",
     "hyun_ryu",
     "jack",
     "kent"
    ]
   },
   {
    "channel": "cafe",
    "passages": 1,
    "share": 0.1111,
    "first": "2020-04-14",
    "last": "2020-04-14",
    "kind": "route",
    "castWith": [
     "alistair_turayne",
     "alistair",
     "evelyn",
     "kya_sg3",
     "kya_sg1",
     "mr_han_sr"
    ]
   },
   {
    "channel": "chat",
    "passages": 1,
    "share": 0.1111,
    "first": "2020-04-14",
    "last": "2020-04-14",
    "kind": "route",
    "castWith": [
     "evelyn",
     "elizabeth_the_third",
     "mr_han_sr",
     "kaleb",
     "ezra",
     "god"
    ]
   },
   {
    "channel": "dorms",
    "passages": 1,
    "share": 0.1111,
    "first": "2020-05-06",
    "last": "2020-05-06",
    "kind": "route",
    "castWith": [
     "agnar",
     "kya_sg3",
     "agmund",
     "evelyn",
     "raye",
     "cole",
     "kya_sg1",
     "riku",
     "kaleb",
     "penelope_valk",
     "loki",
     "svira"
    ]
   },
   {
    "channel": "mint_eye",
    "passages": 1,
    "share": 0.1111,
    "first": "2018-06-06",
    "last": "2018-06-06",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "kaleb"
    ]
   },
   {
    "channel": "kyas_penthouse",
    "passages": 1,
    "share": 0.1111,
    "first": "2020-03-29",
    "last": "2020-03-29",
    "kind": "route",
    "castWith": [
     "kaleb",
     "evelyn",
     "raye",
     "ezra",
     "kya_sg3",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "mr_han_sr",
     "bryce",
     "god",
     "cruz"
    ]
   },
   {
    "channel": "meeting-room",
    "passages": 1,
    "share": 0.1111,
    "first": "2020-03-31",
    "last": "2020-03-31",
    "kind": "route",
    "castWith": [
     "kaleb",
     "ezra",
     "kya_sg3",
     "raye",
     "evelyn",
     "alistair_turayne",
     "alistair",
     "mr_han_sr",
     "kya_sg1",
     "thorne",
     "prince_zain",
     "sune"
    ]
   }
  ],
  "knownCharacters": [
   "kira",
   "leon",
   "cupid_eros",
   "loki",
   "riku",
   "victor",
   "evelyn",
   "junta",
   "ben",
   "hyun_ryu",
   "jack",
   "kent"
  ]
 },
 "raze": {
  "canonRoute": "troterra-kingdom",
  "totalPassages": 192,
  "routes": [
   {
    "channel": "troterra-kingdom",
    "passages": 80,
    "share": 0.4167,
    "first": "2020-04-01",
    "last": "2020-06-03",
    "kind": "canon",
    "castWith": [
     "stella",
     "ronin_tempus",
     "talon_char",
     "melisende",
     "dimitri",
     "satella",
     "silas_mirace",
     "vincent",
     "exis",
     "god",
     "may",
     "mikaela_hyakuya"
    ]
   },
   {
    "channel": "ramesville",
    "passages": 26,
    "share": 0.1354,
    "first": "2020-04-01",
    "last": "2020-06-01",
    "kind": "route",
    "castWith": [
     "stella",
     "talon_char",
     "ronin_tempus",
     "melisende",
     "exis",
     "satella",
     "dimitri",
     "vanessa",
     "raye",
     "raz",
     "will"
    ]
   },
   {
    "channel": "ronin-tempus-castle",
    "passages": 21,
    "share": 0.1094,
    "first": "2020-04-03",
    "last": "2020-04-04",
    "kind": "route",
    "castWith": [
     "stella",
     "ronin_tempus",
     "melisende",
     "talon_char",
     "kya_sg3",
     "may",
     "silas_mirace",
     "will"
    ]
   },
   {
    "channel": "country-road-take-me-home",
    "passages": 18,
    "share": 0.0938,
    "first": "2020-04-12",
    "last": "2020-04-13",
    "kind": "route",
    "castWith": [
     "stella",
     "ronin_tempus",
     "talon_char",
     "melisende",
     "dimitri",
     "exis",
     "yuu",
     "god",
     "will"
    ]
   },
   {
    "channel": "silas-mirace-castle",
    "passages": 11,
    "share": 0.0573,
    "first": "2020-04-02",
    "last": "2020-04-03",
    "kind": "route",
    "castWith": [
     "stella",
     "silas_mirace",
     "melisende",
     "may"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 10,
    "share": 0.0521,
    "first": "2020-04-04",
    "last": "2020-04-13",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "theo-uoki-castle",
    "passages": 10,
    "share": 0.0521,
    "first": "2020-04-03",
    "last": "2020-04-03",
    "kind": "route",
    "castWith": [
     "stella",
     "theo_uoki",
     "melisende",
     "frank",
     "tom",
     "yuu",
     "silas_mirace",
     "vincent",
     "ronin_tempus"
    ]
   },
   {
    "channel": "abandoned-building",
    "passages": 7,
    "share": 0.0365,
    "first": "2020-04-13",
    "last": "2020-04-13",
    "kind": "route",
    "castWith": [
     "stella",
     "ronin_tempus",
     "exis",
     "satella",
     "talon_char",
     "melisende"
    ]
   },
   {
    "channel": "mikaera-hyakuya-castle",
    "passages": 3,
    "share": 0.0156,
    "first": "2020-04-02",
    "last": "2020-04-02",
    "kind": "route",
    "castWith": [
     "stella",
     "yuu",
     "melisende",
     "may"
    ]
   },
   {
    "channel": "ooc",
    "passages": 2,
    "share": 0.0104,
    "first": "2020-04-14",
    "last": "2020-04-14",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "prince-char-bios",
    "passages": 2,
    "share": 0.0104,
    "first": "2020-04-08",
    "last": "2020-05-22",
    "kind": "route",
    "castWith": [
     "ronin_tempus",
     "stella",
     "dimitri",
     "talon_char",
     "melisende",
     "mikaela_hyakuya",
     "silas_mirace",
     "theo_uoki",
     "yuu",
     "vincent"
    ]
   },
   {
    "channel": "dimitri-castle",
    "passages": 2,
    "share": 0.0104,
    "first": "2020-04-06",
    "last": "2020-04-06",
    "kind": "route",
    "castWith": [
     "dimitri",
     "evelyn",
     "stella",
     "ronin_tempus",
     "kaleb",
     "melisende",
     "mr_han_sr",
     "gambit",
     "frau",
     "silas_mirace",
     "theo_uoki",
     "toko"
    ]
   }
  ],
  "knownCharacters": [
   "stella",
   "ronin_tempus",
   "talon_char",
   "melisende",
   "dimitri",
   "satella",
   "silas_mirace",
   "vincent",
   "exis",
   "god",
   "may",
   "mikaela_hyakuya"
  ]
 },
 "reagan": {
  "canonRoute": "frau-collin",
  "totalPassages": 2,
  "routes": [
   {
    "channel": "frau-collin",
    "passages": 2,
    "share": 1.0,
    "first": "2020-11-25",
    "last": "2020-12-02",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "cruz",
     "rowan",
     "frau",
     "collin_keller",
     "arland_rees",
     "ezra",
     "felix_fairy",
     "rikki",
     "park",
     "alyce_char",
     "myra"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "cruz",
   "rowan",
   "frau",
   "collin_keller",
   "arland_rees",
   "ezra",
   "felix_fairy",
   "rikki",
   "park",
   "alyce_char",
   "myra"
  ]
 },
 "red": {
  "canonRoute": "cruz-x-nicole",
  "totalPassages": 27,
  "routes": [
   {
    "channel": "cruz-x-nicole",
    "passages": 18,
    "share": 0.6667,
    "first": "2020-08-10",
    "last": "2020-08-11",
    "kind": "canon",
    "castWith": [
     "cruz",
     "lance",
     "hermes",
     "audrey",
     "peter",
     "ares",
     "nicole_wolf",
     "nicole_sg3",
     "alyce_char",
     "trix",
     "nicole_human",
     "moros"
    ]
   },
   {
    "channel": "1-real-cruz",
    "passages": 7,
    "share": 0.2593,
    "first": "2022-12-21",
    "last": "2022-12-22",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "ares",
     "lance",
     "selma",
     "zeus",
     "lindon",
     "hera",
     "ryder",
     "apollo",
     "nolan"
    ]
   },
   {
    "channel": "almost-alpha-eva",
    "passages": 2,
    "share": 0.0741,
    "first": "2025-10-05",
    "last": "2025-10-06",
    "kind": "route",
    "castWith": [
     "eva",
     "cruz",
     "ford",
     "bryce",
     "shane",
     "ryder",
     "robert",
     "roger",
     "audrey",
     "rowan",
     "diana",
     "myra"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "lance",
   "hermes",
   "audrey",
   "peter",
   "ares",
   "nicole_wolf",
   "nicole_sg3",
   "alyce_char",
   "trix",
   "nicole_human",
   "moros"
  ]
 },
 "reginald": {
  "canonRoute": "reincarnation-with-alistair",
  "totalPassages": 8,
  "routes": [
   {
    "channel": "reincarnation-with-alistair",
    "passages": 3,
    "share": 0.375,
    "first": "2025-02-11",
    "last": "2025-02-13",
    "kind": "canon",
    "castWith": [
     "james",
     "dillon",
     "alistair",
     "alistair_turayne",
     "kya_sg3",
     "sebastian_vamp",
     "kya_sg1",
     "evelyn",
     "val",
     "haley_human",
     "sebastian_siren",
     "athena"
    ]
   },
   {
    "channel": "don\u2019t-buy-me-love",
    "passages": 2,
    "share": 0.25,
    "first": "2023-12-18",
    "last": "2023-12-19",
    "kind": "route",
    "castWith": [
     "ezra",
     "trace_spellbook",
     "primrose",
     "madison_astor",
     "kya_sg3",
     "kya_sg1",
     "dimitri",
     "hades",
     "evelyn",
     "junta",
     "jane",
     "may"
    ]
   },
   {
    "channel": "growing-up-cruz",
    "passages": 1,
    "share": 0.125,
    "first": "2023-02-08",
    "last": "2023-02-08",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "allie",
     "kaleb",
     "audrey",
     "raquel_ratchet",
     "dimitri",
     "trix",
     "ford",
     "ryder",
     "lyden",
     "frau"
    ]
   },
   {
    "channel": "dimitri-ralidanti",
    "passages": 1,
    "share": 0.125,
    "first": "2023-02-27",
    "last": "2023-02-27",
    "kind": "route",
    "castWith": [
     "ryder",
     "evelyn",
     "dimitri",
     "cruz",
     "nolan",
     "bryce",
     "audrey",
     "trix",
     "lyden",
     "alyce_char",
     "kya_sg3",
     "diana"
    ]
   },
   {
    "channel": "hall-of-portraits",
    "passages": 1,
    "share": 0.125,
    "first": "2020-04-04",
    "last": "2020-04-04",
    "kind": "route",
    "castWith": [
     "bryce",
     "evelyn",
     "frau",
     "geo"
    ]
   }
  ],
  "knownCharacters": [
   "james",
   "dillon",
   "alistair",
   "alistair_turayne",
   "kya_sg3",
   "sebastian_vamp",
   "kya_sg1",
   "evelyn",
   "val",
   "haley_human",
   "sebastian_siren",
   "athena"
  ]
 },
 "renee": {
  "canonRoute": "cruz-nicole-dollar-store",
  "totalPassages": 39,
  "routes": [
   {
    "channel": "cruz-nicole-dollar-store",
    "passages": 25,
    "share": 0.641,
    "first": "2020-09-13",
    "last": "2020-09-21",
    "kind": "canon",
    "castWith": [
     "cruz",
     "raz",
     "lance",
     "lachesis",
     "bryce",
     "nolan",
     "aphrodite",
     "clothos",
     "atropos",
     "nicole_wolf",
     "nicole_sg3",
     "moros"
    ]
   },
   {
    "channel": "haley-nolan",
    "passages": 11,
    "share": 0.2821,
    "first": "2020-09-13",
    "last": "2020-09-16",
    "kind": "route",
    "castWith": [
     "nolan",
     "charlie",
     "alistair",
     "alistair_turayne",
     "caroline",
     "alyce_char",
     "ryder",
     "cruz",
     "moros",
     "lachesis",
     "clothos",
     "audrey"
    ]
   },
   {
    "channel": "dimitri-saves-the-day",
    "passages": 1,
    "share": 0.0256,
    "first": "2022-03-30",
    "last": "2022-03-30",
    "kind": "route",
    "castWith": [
     "dimitri",
     "evelyn",
     "frau",
     "raz",
     "uncle_khan",
     "will"
    ]
   },
   {
    "channel": "to-the-max",
    "passages": 1,
    "share": 0.0256,
    "first": "2023-05-17",
    "last": "2023-05-17",
    "kind": "route",
    "castWith": [
     "maxen_bryers",
     "addison",
     "trace_renton",
     "kya_sg3",
     "kya_sg1",
     "rick",
     "evelyn",
     "beatrice",
     "dillon",
     "budd",
     "lore",
     "paula"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 1,
    "share": 0.0256,
    "first": "2016-10-29",
    "last": "2016-10-29",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "raz",
   "lance",
   "lachesis",
   "bryce",
   "nolan",
   "aphrodite",
   "clothos",
   "atropos",
   "nicole_wolf",
   "nicole_sg3",
   "moros"
  ]
 },
 "renni": {
  "canonRoute": "haggle-for-the-girl",
  "totalPassages": 2,
  "routes": [
   {
    "channel": "haggle-for-the-girl",
    "passages": 2,
    "share": 1.0,
    "first": "2023-12-13",
    "last": "2023-12-13",
    "kind": "canon",
    "castWith": [
     "lachesis",
     "lucifer",
     "asrius",
     "god",
     "lonnie",
     "ramiel",
     "gabriel",
     "lance",
     "hades",
     "alyk",
     "aphrodite",
     "atropos"
    ]
   }
  ],
  "knownCharacters": [
   "lachesis",
   "lucifer",
   "asrius",
   "god",
   "lonnie",
   "ramiel",
   "gabriel",
   "lance",
   "hades",
   "alyk",
   "aphrodite",
   "atropos"
  ]
 },
 "retin": {
  "canonRoute": "fall-fairies",
  "totalPassages": 32,
  "routes": [
   {
    "channel": "fall-fairies",
    "passages": 32,
    "share": 1.0,
    "first": "2021-11-01",
    "last": "2021-11-15",
    "kind": "canon",
    "castWith": [
     "damien",
     "matare",
     "autumn",
     "draven",
     "fayette",
     "sir_tyde",
     "may",
     "maleos",
     "silvia",
     "jaden",
     "will",
     "roman"
    ]
   }
  ],
  "knownCharacters": [
   "damien",
   "matare",
   "autumn",
   "draven",
   "fayette",
   "sir_tyde",
   "may",
   "maleos",
   "silvia",
   "jaden",
   "will",
   "roman"
  ]
 },
 "rhea": {
  "canonRoute": "mt-olympus",
  "totalPassages": 5,
  "routes": [
   {
    "channel": "mt-olympus",
    "passages": 4,
    "share": 0.8,
    "first": "2020-06-27",
    "last": "2020-06-27",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "libion",
     "ares",
     "rex",
     "persephone",
     "bion",
     "hades",
     "aphrodite",
     "hercules",
     "demeter",
     "zeus",
     "athena"
    ]
   },
   {
    "channel": "greek-house",
    "passages": 1,
    "share": 0.2,
    "first": "2020-05-07",
    "last": "2020-05-07",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hiro",
     "darren",
     "lex",
     "kiro",
     "raye",
     "kya_sg3",
     "ares",
     "riku",
     "kya_sg1",
     "lacie",
     "aphrodite"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "libion",
   "ares",
   "rex",
   "persephone",
   "bion",
   "hades",
   "aphrodite",
   "hercules",
   "demeter",
   "zeus",
   "athena"
  ]
 },
 "richard_antore": {
  "canonRoute": "human-evie",
  "totalPassages": 18,
  "routes": [
   {
    "channel": "human-evie",
    "passages": 13,
    "share": 0.7222,
    "first": "2020-09-23",
    "last": "2021-02-26",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "kaleb",
     "frau",
     "cruz",
     "mr_han_sr",
     "audrey",
     "diana",
     "ares",
     "quincy_antore",
     "nereda",
     "elizabeth_the_third",
     "ever"
    ]
   },
   {
    "channel": "Ford",
    "passages": 3,
    "share": 0.1667,
    "first": "2026-04-08",
    "last": "2026-04-09",
    "kind": "route",
    "castWith": [
     "ford",
     "cruz",
     "nicole_human",
     "trix",
     "nolan",
     "alyce_char",
     "ryder",
     "bryce",
     "allie",
     "diana",
     "audrey",
     "nicole_wolf"
    ]
   },
   {
    "channel": "esu",
    "passages": 1,
    "share": 0.0556,
    "first": "2025-01-15",
    "last": "2025-01-15",
    "kind": "route",
    "castWith": [
     "leon",
     "trenton",
     "bennett",
     "will"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 1,
    "share": 0.0556,
    "first": "2020-05-24",
    "last": "2020-05-24",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "kaleb",
   "frau",
   "cruz",
   "mr_han_sr",
   "audrey",
   "diana",
   "ares",
   "quincy_antore",
   "nereda",
   "elizabeth_the_third",
   "ever"
  ]
 },
 "rick": {
  "canonRoute": "to-the-max",
  "totalPassages": 5,
  "routes": [
   {
    "channel": "to-the-max",
    "passages": 5,
    "share": 1.0,
    "first": "2023-05-28",
    "last": "2023-05-29",
    "kind": "canon",
    "castWith": [
     "maxen_bryers",
     "addison",
     "trace_renton",
     "kya_sg3",
     "kya_sg1",
     "evelyn",
     "beatrice",
     "dillon",
     "budd",
     "lore",
     "paula",
     "diana"
    ]
   }
  ],
  "knownCharacters": [
   "maxen_bryers",
   "addison",
   "trace_renton",
   "kya_sg3",
   "kya_sg1",
   "evelyn",
   "beatrice",
   "dillon",
   "budd",
   "lore",
   "paula",
   "diana"
  ]
 },
 "rika": {
  "canonRoute": "mm_chatroom",
  "totalPassages": 69,
  "routes": [
   {
    "channel": "mm_chatroom",
    "passages": 20,
    "share": 0.2899,
    "first": "2016-09-08",
    "last": "2020-03-30",
    "kind": "canon",
    "castWith": [
     "kaleb",
     "evelyn",
     "mr_han_sr",
     "cruz",
     "elizabeth_the_third",
     "god",
     "mr_clien",
     "bryce",
     "ever",
     "marie_antoinette",
     "tom"
    ]
   },
   {
    "channel": "field-of-flowers",
    "passages": 17,
    "share": 0.2464,
    "first": "2020-03-30",
    "last": "2020-03-30",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "kaleb",
     "may",
     "mr_han_sr"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 15,
    "share": 0.2174,
    "first": "2016-09-08",
    "last": "2020-03-31",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "nolan"
    ]
   },
   {
    "channel": "pack-cabin",
    "passages": 6,
    "share": 0.087,
    "first": "2020-03-30",
    "last": "2020-03-31",
    "kind": "route",
    "castWith": [
     "cruz",
     "evelyn",
     "kaleb",
     "bryce",
     "kya_sg3",
     "alistair",
     "ezra",
     "hades",
     "alistair_turayne",
     "ryder",
     "kya_sg1",
     "nolan"
    ]
   },
   {
    "channel": "v_art_gallery",
    "passages": 4,
    "share": 0.058,
    "first": "2020-03-20",
    "last": "2020-03-20",
    "kind": "route",
    "castWith": [
     "kaleb",
     "evelyn"
    ]
   },
   {
    "channel": "val",
    "passages": 1,
    "share": 0.0145,
    "first": "2020-04-15",
    "last": "2020-04-15",
    "kind": "route",
    "castWith": [
     "val",
     "kya_sg3",
     "kaleb",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "evelyn",
     "vanessa",
     "ezra",
     "raye",
     "alan",
     "tyrion"
    ]
   },
   {
    "channel": "sevens_house",
    "passages": 1,
    "share": 0.0145,
    "first": "2016-09-10",
    "last": "2016-09-10",
    "kind": "route",
    "castWith": [
     "evelyn",
     "kaleb",
     "god",
     "roman",
     "will"
    ]
   },
   {
    "channel": "requests_and_ideas",
    "passages": 1,
    "share": 0.0145,
    "first": "2020-03-22",
    "last": "2020-03-22",
    "kind": "route",
    "castWith": [
     "kaleb",
     "evelyn",
     "cruz",
     "kya_sg3",
     "mr_han_sr"
    ]
   },
   {
    "channel": "kyas_penthouse",
    "passages": 1,
    "share": 0.0145,
    "first": "2020-03-27",
    "last": "2020-03-27",
    "kind": "route",
    "castWith": [
     "kaleb",
     "evelyn",
     "raye",
     "ezra",
     "kya_sg3",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "mr_han_sr",
     "bryce",
     "god",
     "cruz"
    ]
   },
   {
    "channel": "phone_calls",
    "passages": 1,
    "share": 0.0145,
    "first": "2020-03-23",
    "last": "2020-03-23",
    "kind": "route",
    "castWith": [
     "kaleb",
     "evelyn",
     "ezra",
     "cruz",
     "raye",
     "bryce",
     "kya_sg3",
     "elizabeth_the_third",
     "god"
    ]
   },
   {
    "channel": "heaven",
    "passages": 1,
    "share": 0.0145,
    "first": "2020-03-28",
    "last": "2020-03-28",
    "kind": "route",
    "castWith": [
     "evelyn",
     "libion",
     "cruz",
     "bryce",
     "bion",
     "hades",
     "persephone",
     "demeter",
     "god",
     "aphrodite",
     "apollo"
    ]
   },
   {
    "channel": "cell-block-tango",
    "passages": 1,
    "share": 0.0145,
    "first": "2020-03-31",
    "last": "2020-03-31",
    "kind": "route",
    "castWith": [
     "ezra",
     "kya_sg3",
     "alistair",
     "alistair_turayne",
     "evelyn",
     "bryce",
     "thorne",
     "kya_sg1",
     "kaleb",
     "cruz",
     "thor",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "kaleb",
   "evelyn",
   "mr_han_sr",
   "cruz",
   "elizabeth_the_third",
   "god",
   "mr_clien",
   "bryce",
   "ever",
   "marie_antoinette",
   "tom"
  ]
 },
 "rikki": {
  "canonRoute": "frau-collin",
  "totalPassages": 36,
  "routes": [
   {
    "channel": "frau-collin",
    "passages": 23,
    "share": 0.6389,
    "first": "2020-11-05",
    "last": "2020-11-10",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "cruz",
     "rowan",
     "frau",
     "collin_keller",
     "arland_rees",
     "ezra",
     "felix_fairy",
     "park",
     "alyce_char",
     "myra",
     "allie"
    ]
   },
   {
    "channel": "ww-war-au",
    "passages": 10,
    "share": 0.2778,
    "first": "2021-12-02",
    "last": "2021-12-10",
    "kind": "au",
    "castWith": [
     "evelyn",
     "cruz",
     "ace",
     "ezra",
     "lindon",
     "kaleb",
     "rowan",
     "bryce",
     "lance",
     "raye",
     "nolan",
     "primrose"
    ]
   },
   {
    "channel": "ooc",
    "passages": 2,
    "share": 0.0556,
    "first": "2020-11-07",
    "last": "2020-11-08",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "vampire-ww-war",
    "passages": 1,
    "share": 0.0278,
    "first": "2025-04-14",
    "last": "2025-04-14",
    "kind": "route",
    "castWith": [
     "lindon",
     "rowan",
     "ezra",
     "evelyn",
     "ace",
     "ares",
     "cruz",
     "kaleb",
     "ever",
     "frau"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "cruz",
   "rowan",
   "frau",
   "collin_keller",
   "arland_rees",
   "ezra",
   "felix_fairy",
   "park",
   "alyce_char",
   "myra",
   "allie"
  ]
 },
 "riku": {
  "canonRoute": "misc-location",
  "totalPassages": 144,
  "routes": [
   {
    "channel": "misc-location",
    "passages": 60,
    "share": 0.4167,
    "first": "2020-05-03",
    "last": "2020-05-11",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "ares",
     "kiro",
     "hiro",
     "lex",
     "lance",
     "ezra",
     "lucius",
     "darren",
     "kaleb",
     "raye",
     "kya_sg3"
    ]
   },
   {
    "channel": "dorms",
    "passages": 35,
    "share": 0.2431,
    "first": "2020-05-02",
    "last": "2020-05-05",
    "kind": "route",
    "castWith": [
     "agnar",
     "kya_sg3",
     "agmund",
     "evelyn",
     "raye",
     "cole",
     "kya_sg1",
     "kaleb",
     "penelope_valk",
     "loki",
     "svira",
     "darren"
    ]
   },
   {
    "channel": "ooc",
    "passages": 13,
    "share": 0.0903,
    "first": "2020-05-03",
    "last": "2020-06-19",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "greek-house",
    "passages": 13,
    "share": 0.0903,
    "first": "2020-05-06",
    "last": "2020-05-09",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hiro",
     "darren",
     "lex",
     "kiro",
     "raye",
     "kya_sg3",
     "ares",
     "kya_sg1",
     "lacie",
     "aphrodite",
     "god"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 4,
    "share": 0.0278,
    "first": "2020-07-08",
    "last": "2020-07-08",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 4,
    "share": 0.0278,
    "first": "2020-05-22",
    "last": "2020-05-30",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "beach-and-boardwalk",
    "passages": 4,
    "share": 0.0278,
    "first": "2020-05-04",
    "last": "2020-05-05",
    "kind": "route",
    "castWith": [
     "cole",
     "ezra",
     "kya_sg3",
     "kya_sg1",
     "skipper",
     "evelyn",
     "alistair",
     "alistair_turayne",
     "raye",
     "kaleb",
     "sebastian_vamp",
     "darren"
    ]
   },
   {
    "channel": "hiros-room",
    "passages": 3,
    "share": 0.0208,
    "first": "2020-05-09",
    "last": "2020-05-10",
    "kind": "route",
    "castWith": [
     "hiro",
     "evelyn",
     "darren",
     "ares",
     "kiro",
     "lex",
     "hades",
     "lacie",
     "zeus"
    ]
   },
   {
    "channel": "cafeteria",
    "passages": 3,
    "share": 0.0208,
    "first": "2020-05-13",
    "last": "2020-05-13",
    "kind": "route",
    "castWith": [
     "evelyn",
     "hiro",
     "agnar",
     "agmund",
     "kya_sg3",
     "lex",
     "kaleb",
     "penelope_valk",
     "svira",
     "ares",
     "darren",
     "kya_sg1"
    ]
   },
   {
    "channel": "car",
    "passages": 2,
    "share": 0.0139,
    "first": "2020-05-13",
    "last": "2020-05-13",
    "kind": "route",
    "castWith": [
     "hiro",
     "evelyn",
     "athena",
     "lucius",
     "apollo",
     "cruz",
     "ares",
     "will"
    ]
   },
   {
    "channel": "the-great-husbando-race",
    "passages": 2,
    "share": 0.0139,
    "first": "2020-06-03",
    "last": "2020-06-03",
    "kind": "route",
    "castWith": [
     "kira",
     "ray",
     "leon",
     "cupid_eros",
     "loki",
     "victor",
     "evelyn",
     "junta",
     "ben",
     "hyun_ryu",
     "jack",
     "kent"
    ]
   },
   {
    "channel": "coles-room",
    "passages": 1,
    "share": 0.0069,
    "first": "2020-05-06",
    "last": "2020-05-06",
    "kind": "route",
    "castWith": [
     "cole",
     "abraham",
     "kya_sg3",
     "hades",
     "lacie",
     "raye"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "ares",
   "kiro",
   "hiro",
   "lex",
   "lance",
   "ezra",
   "lucius",
   "darren",
   "kaleb",
   "raye",
   "kya_sg3"
  ]
 },
 "rin": {
  "canonRoute": "lance-decides",
  "totalPassages": 86,
  "routes": [
   {
    "channel": "lance-decides",
    "passages": 47,
    "share": 0.5465,
    "first": "2024-12-11",
    "last": "2025-01-01",
    "kind": "canon",
    "castWith": [
     "lance",
     "lucifer",
     "lachesis",
     "nicole_human",
     "god",
     "chiara",
     "cupid_eros",
     "roman",
     "asrius",
     "hera",
     "zeus",
     "aphrodite"
    ]
   },
   {
    "channel": "foyer-living-room",
    "passages": 24,
    "share": 0.2791,
    "first": "2020-04-08",
    "last": "2020-05-22",
    "kind": "route",
    "castWith": [
     "aria",
     "benji",
     "bennett",
     "ajax",
     "ragland",
     "kent",
     "miles",
     "may"
    ]
   },
   {
    "channel": "rin-and-ragland-wing",
    "passages": 6,
    "share": 0.0698,
    "first": "2020-04-11",
    "last": "2020-04-12",
    "kind": "route",
    "castWith": [
     "ragland",
     "aria",
     "ajax",
     "miles",
     "kent"
    ]
   },
   {
    "channel": "mansion-grounds",
    "passages": 4,
    "share": 0.0465,
    "first": "2020-04-09",
    "last": "2020-04-09",
    "kind": "route",
    "castWith": [
     "aria",
     "kent",
     "miles",
     "ajax",
     "benji",
     "bennett",
     "ever"
    ]
   },
   {
    "channel": "general",
    "passages": 2,
    "share": 0.0233,
    "first": "2020-08-09",
    "last": "2020-08-09",
    "kind": "ooc",
    "castWith": [
     "ezra",
     "eric",
     "cruz",
     "james",
     "apollo",
     "lance",
     "aaron",
     "silas_mirace",
     "raye",
     "moros",
     "ace",
     "kaleb"
    ]
   },
   {
    "channel": "memory-char-bios",
    "passages": 2,
    "share": 0.0233,
    "first": "2020-04-01",
    "last": "2020-05-22",
    "kind": "route",
    "castWith": [
     "bennett",
     "benji",
     "miles",
     "ajax",
     "kent",
     "ragland",
     "aria"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 1,
    "share": 0.0116,
    "first": "2020-04-09",
    "last": "2020-04-09",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   }
  ],
  "knownCharacters": [
   "lance",
   "lucifer",
   "lachesis",
   "nicole_human",
   "god",
   "chiara",
   "cupid_eros",
   "roman",
   "asrius",
   "hera",
   "zeus",
   "aphrodite"
  ]
 },
 "robert": {
  "canonRoute": "almost-alpha-eva",
  "totalPassages": 9,
  "routes": [
   {
    "channel": "almost-alpha-eva",
    "passages": 3,
    "share": 0.3333,
    "first": "2025-09-30",
    "last": "2025-10-03",
    "kind": "canon",
    "castWith": [
     "eva",
     "cruz",
     "ford",
     "bryce",
     "shane",
     "ryder",
     "roger",
     "red",
     "audrey",
     "rowan",
     "diana",
     "myra"
    ]
   },
   {
    "channel": "the-better-king",
    "passages": 3,
    "share": 0.3333,
    "first": "2022-09-29",
    "last": "2022-10-03",
    "kind": "route",
    "castWith": [
     "dimitri"
    ]
   },
   {
    "channel": "cruz-nicole-dollar-store",
    "passages": 2,
    "share": 0.2222,
    "first": "2020-09-16",
    "last": "2020-09-16",
    "kind": "route",
    "castWith": [
     "cruz",
     "raz",
     "lance",
     "lachesis",
     "bryce",
     "nolan",
     "renee",
     "aphrodite",
     "clothos",
     "atropos",
     "nicole_wolf",
     "nicole_sg3"
    ]
   },
   {
    "channel": "haggle-for-the-girl",
    "passages": 1,
    "share": 0.1111,
    "first": "2024-01-08",
    "last": "2024-01-08",
    "kind": "route",
    "castWith": [
     "lachesis",
     "lucifer",
     "asrius",
     "god",
     "lonnie",
     "ramiel",
     "gabriel",
     "lance",
     "hades",
     "alyk",
     "aphrodite",
     "atropos"
    ]
   }
  ],
  "knownCharacters": [
   "eva",
   "cruz",
   "ford",
   "bryce",
   "shane",
   "ryder",
   "roger",
   "red",
   "audrey",
   "rowan",
   "diana",
   "myra"
  ]
 },
 "roger": {
  "canonRoute": "a-tricky-micah-cruz-route",
  "totalPassages": 36,
  "routes": [
   {
    "channel": "a-tricky-micah-cruz-route",
    "passages": 19,
    "share": 0.5278,
    "first": "2023-08-24",
    "last": "2023-09-23",
    "kind": "canon",
    "castWith": [
     "eva",
     "shane",
     "ryder",
     "cruz",
     "micah",
     "trix",
     "allie",
     "evelyn",
     "audrey",
     "god",
     "bryce",
     "diana"
    ]
   },
   {
    "channel": "ares-phones-home",
    "passages": 6,
    "share": 0.1667,
    "first": "2024-06-14",
    "last": "2024-06-18",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "cruz",
     "ryder",
     "ares",
     "diana",
     "allie",
     "micah",
     "cupid_eros",
     "penelope_valk",
     "evelyn",
     "lance"
    ]
   },
   {
    "channel": "lance-is-a-family-man",
    "passages": 4,
    "share": 0.1111,
    "first": "2024-05-02",
    "last": "2024-05-03",
    "kind": "route",
    "castWith": [
     "lance",
     "evelyn",
     "cruz",
     "audrey",
     "luca",
     "bryce",
     "lyden",
     "hermes",
     "dimitri",
     "hades",
     "diana",
     "zeus"
    ]
   },
   {
    "channel": "almost-alpha-eva",
    "passages": 3,
    "share": 0.0833,
    "first": "2025-09-30",
    "last": "2025-10-02",
    "kind": "route",
    "castWith": [
     "eva",
     "cruz",
     "ford",
     "bryce",
     "shane",
     "ryder",
     "robert",
     "red",
     "audrey",
     "rowan",
     "diana",
     "myra"
    ]
   },
   {
    "channel": "cruz-x-human",
    "passages": 2,
    "share": 0.0556,
    "first": "2021-05-02",
    "last": "2021-05-05",
    "kind": "route",
    "castWith": [
     "cruz",
     "skye",
     "nolan",
     "ryder",
     "audrey",
     "troy",
     "adrien",
     "bryce",
     "airi",
     "natasha",
     "diana",
     "will"
    ]
   },
   {
    "channel": "hottie-seb-is-dead",
    "passages": 1,
    "share": 0.0278,
    "first": "2022-11-01",
    "last": "2022-11-01",
    "kind": "route",
    "castWith": [
     "dillon",
     "kya_sg3",
     "mateo_aurlease",
     "kya_sg1",
     "sebastian_vamp",
     "sebastian_siren",
     "evelyn",
     "ever",
     "apollo"
    ]
   },
   {
    "channel": "human-lachesis",
    "passages": 1,
    "share": 0.0278,
    "first": "2024-09-17",
    "last": "2024-09-17",
    "kind": "route",
    "castWith": [
     "nicole_human",
     "brax",
     "lachesis",
     "lance",
     "vaughn",
     "rowan",
     "god",
     "alyce_char",
     "moros",
     "ford",
     "atropos",
     "cruz"
    ]
   }
  ],
  "knownCharacters": [
   "eva",
   "shane",
   "ryder",
   "cruz",
   "micah",
   "trix",
   "allie",
   "evelyn",
   "audrey",
   "god",
   "bryce",
   "diana"
  ]
 },
 "ronin_tempus": {
  "canonRoute": "troterra-kingdom",
  "totalPassages": 423,
  "routes": [
   {
    "channel": "troterra-kingdom",
    "passages": 135,
    "share": 0.3191,
    "first": "2020-04-02",
    "last": "2020-06-03",
    "kind": "canon",
    "castWith": [
     "stella",
     "raze",
     "talon_char",
     "melisende",
     "dimitri",
     "satella",
     "silas_mirace",
     "vincent",
     "exis",
     "god",
     "may",
     "mikaela_hyakuya"
    ]
   },
   {
    "channel": "country-road-take-me-home",
    "passages": 99,
    "share": 0.234,
    "first": "2020-04-09",
    "last": "2020-04-13",
    "kind": "route",
    "castWith": [
     "stella",
     "talon_char",
     "melisende",
     "dimitri",
     "raze",
     "exis",
     "yuu",
     "god",
     "will"
    ]
   },
   {
    "channel": "ramesville",
    "passages": 47,
    "share": 0.1111,
    "first": "2020-04-10",
    "last": "2020-06-01",
    "kind": "route",
    "castWith": [
     "stella",
     "talon_char",
     "melisende",
     "exis",
     "raze",
     "satella",
     "dimitri",
     "vanessa",
     "raye",
     "raz",
     "will"
    ]
   },
   {
    "channel": "ronin-tempus-castle",
    "passages": 46,
    "share": 0.1087,
    "first": "2020-04-04",
    "last": "2020-04-04",
    "kind": "route",
    "castWith": [
     "stella",
     "raze",
     "melisende",
     "talon_char",
     "kya_sg3",
     "may",
     "silas_mirace",
     "will"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 38,
    "share": 0.0898,
    "first": "2020-04-04",
    "last": "2020-05-30",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz",
     "eric"
    ]
   },
   {
    "channel": "dimitri-castle",
    "passages": 20,
    "share": 0.0473,
    "first": "2020-04-06",
    "last": "2020-04-07",
    "kind": "route",
    "castWith": [
     "dimitri",
     "evelyn",
     "stella",
     "kaleb",
     "melisende",
     "mr_han_sr",
     "gambit",
     "frau",
     "silas_mirace",
     "theo_uoki",
     "toko",
     "raye"
    ]
   },
   {
    "channel": "abandoned-building",
    "passages": 14,
    "share": 0.0331,
    "first": "2020-04-13",
    "last": "2020-04-13",
    "kind": "route",
    "castWith": [
     "stella",
     "exis",
     "satella",
     "talon_char",
     "melisende",
     "raze"
    ]
   },
   {
    "channel": "ooc",
    "passages": 13,
    "share": 0.0307,
    "first": "2020-04-16",
    "last": "2020-06-19",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "prince-char-bios",
    "passages": 5,
    "share": 0.0118,
    "first": "2020-04-01",
    "last": "2020-05-22",
    "kind": "route",
    "castWith": [
     "stella",
     "dimitri",
     "talon_char",
     "melisende",
     "mikaela_hyakuya",
     "raze",
     "silas_mirace",
     "theo_uoki",
     "yuu",
     "vincent"
    ]
   },
   {
    "channel": "theo-uoki-castle",
    "passages": 2,
    "share": 0.0047,
    "first": "2020-04-03",
    "last": "2020-04-03",
    "kind": "route",
    "castWith": [
     "stella",
     "theo_uoki",
     "raze",
     "melisende",
     "frank",
     "tom",
     "yuu",
     "silas_mirace",
     "vincent"
    ]
   },
   {
    "channel": "mages-tower",
    "passages": 2,
    "share": 0.0047,
    "first": "2020-04-11",
    "last": "2020-04-11",
    "kind": "route",
    "castWith": [
     "exis",
     "stella",
     "talon_char",
     "melisende"
    ]
   },
   {
    "channel": "college-campus",
    "passages": 1,
    "share": 0.0024,
    "first": "2020-05-25",
    "last": "2020-05-25",
    "kind": "route",
    "castWith": [
     "agnar",
     "agmund",
     "kya_sg3",
     "penelope_valk",
     "evelyn",
     "svira",
     "rowan",
     "may",
     "jon",
     "kya_sg1",
     "kaleb",
     "darren"
    ]
   }
  ],
  "knownCharacters": [
   "stella",
   "raze",
   "talon_char",
   "melisende",
   "dimitri",
   "satella",
   "silas_mirace",
   "vincent",
   "exis",
   "god",
   "may",
   "mikaela_hyakuya"
  ]
 },
 "rory": {
  "canonRoute": "the-kingdom-fallon",
  "totalPassages": 29,
  "routes": [
   {
    "channel": "the-kingdom-fallon",
    "passages": 22,
    "share": 0.7586,
    "first": "2021-05-28",
    "last": "2021-06-04",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "eva",
     "raye",
     "fiadh",
     "ciarnan",
     "finn",
     "cailte",
     "senan",
     "diarmund",
     "fiann",
     "goll",
     "kaleb"
    ]
   },
   {
    "channel": "storm-peak",
    "passages": 7,
    "share": 0.2414,
    "first": "2025-04-14",
    "last": "2025-04-17",
    "kind": "route",
    "castWith": [
     "diana"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "eva",
   "raye",
   "fiadh",
   "ciarnan",
   "finn",
   "cailte",
   "senan",
   "diarmund",
   "fiann",
   "goll",
   "kaleb"
  ]
 },
 "rosalie": {
  "canonRoute": "kieran-ezra",
  "totalPassages": 8,
  "routes": [
   {
    "channel": "kieran-ezra",
    "passages": 7,
    "share": 0.875,
    "first": "2023-10-10",
    "last": "2023-10-10",
    "kind": "canon",
    "castWith": [
     "kieran",
     "ezra",
     "raz",
     "lily",
     "peter",
     "primrose",
     "ace",
     "gemma"
    ]
   },
   {
    "channel": "ooc",
    "passages": 1,
    "share": 0.125,
    "first": "2020-05-04",
    "last": "2020-05-04",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   }
  ],
  "knownCharacters": [
   "kieran",
   "ezra",
   "raz",
   "lily",
   "peter",
   "primrose",
   "ace",
   "gemma"
  ]
 },
 "rosie": {
  "canonRoute": "brothel",
  "totalPassages": 6,
  "routes": [
   {
    "channel": "brothel",
    "passages": 3,
    "share": 0.5,
    "first": "2020-04-23",
    "last": "2020-04-23",
    "kind": "canon",
    "castWith": [
     "ezra",
     "evelyn",
     "rowan",
     "kya_sg3",
     "kya_sg1",
     "primrose",
     "lily",
     "kaleb",
     "nellie",
     "lissa",
     "raye",
     "ace"
    ]
   },
   {
    "channel": "ace-route",
    "passages": 2,
    "share": 0.3333,
    "first": "2020-08-26",
    "last": "2020-08-26",
    "kind": "route",
    "castWith": [
     "evelyn",
     "ace",
     "ezra",
     "sebastian_vamp",
     "sebastian_siren",
     "kaleb",
     "kya_sg3",
     "kya_sg1",
     "felix_fairy",
     "mr_han_sr",
     "frau",
     "will"
    ]
   },
   {
    "channel": "containment-cells",
    "passages": 1,
    "share": 0.1667,
    "first": "2020-04-21",
    "last": "2020-04-21",
    "kind": "route",
    "castWith": [
     "ezra",
     "evelyn",
     "ace",
     "kya_sg3",
     "rowan",
     "kya_sg1",
     "lira",
     "sebastian_vamp",
     "cruz",
     "sebastian_siren",
     "alistair",
     "alistair_turayne"
    ]
   }
  ],
  "knownCharacters": [
   "ezra",
   "evelyn",
   "rowan",
   "kya_sg3",
   "kya_sg1",
   "primrose",
   "lily",
   "kaleb",
   "nellie",
   "lissa",
   "raye",
   "ace"
  ]
 },
 "ryan": {
  "canonRoute": "parabus",
  "totalPassages": 9,
  "routes": [
   {
    "channel": "parabus",
    "passages": 6,
    "share": 0.6667,
    "first": "2020-06-06",
    "last": "2020-06-06",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "lucius",
     "rex",
     "rowan",
     "laito",
     "boko",
     "stash",
     "raye",
     "mr_han_sr",
     "cruz",
     "kya_sg3",
     "kaleb"
    ]
   },
   {
    "channel": "an-accidentally-valerian-summer-with-cordelia",
    "passages": 1,
    "share": 0.1111,
    "first": "2021-03-07",
    "last": "2021-03-07",
    "kind": "route",
    "castWith": [
     "ciel",
     "nolan",
     "lupe",
     "arsene",
     "delia",
     "dale",
     "jessica",
     "cruz",
     "clairette",
     "may",
     "tina",
     "cyrena"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 1,
    "share": 0.1111,
    "first": "2020-07-03",
    "last": "2020-07-03",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika"
    ]
   },
   {
    "channel": "bios",
    "passages": 1,
    "share": 0.1111,
    "first": "2020-06-05",
    "last": "2020-06-05",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "evelyn",
     "lucius",
     "athena",
     "bryce",
     "val",
     "hiro",
     "raz",
     "rex",
     "vanessa",
     "halo",
     "dalton"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "lucius",
   "rex",
   "rowan",
   "laito",
   "boko",
   "stash",
   "raye",
   "mr_han_sr",
   "cruz",
   "kya_sg3",
   "kaleb"
  ]
 },
 "ryoto": {
  "canonRoute": "lets-abduct-evie",
  "totalPassages": 146,
  "routes": [
   {
    "channel": "lets-abduct-evie",
    "passages": 146,
    "share": 1.0,
    "first": "2021-07-04",
    "last": "2021-07-29",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "dimitri",
     "dodge",
     "ms_tia",
     "kaleb",
     "frau",
     "aki",
     "cruz",
     "talbot",
     "ares",
     "zeus",
     "hera"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "dimitri",
   "dodge",
   "ms_tia",
   "kaleb",
   "frau",
   "aki",
   "cruz",
   "talbot",
   "ares",
   "zeus",
   "hera"
  ]
 },
 "sam": {
  "canonRoute": "ezra-normalish-life",
  "totalPassages": 37,
  "routes": [
   {
    "channel": "ezra-normalish-life",
    "passages": 35,
    "share": 0.9459,
    "first": "2022-08-16",
    "last": "2022-09-09",
    "kind": "canon",
    "castWith": [
     "ezra",
     "kya_sg3",
     "kya_sg1",
     "raz",
     "james",
     "evelyn",
     "kaleb",
     "bell_lily_of_fell",
     "vanessa",
     "val",
     "jane",
     "tim"
    ]
   },
   {
    "channel": "lets-abduct-evie",
    "passages": 2,
    "share": 0.0541,
    "first": "2021-06-14",
    "last": "2021-06-14",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "ryoto",
     "dodge",
     "ms_tia",
     "kaleb",
     "frau",
     "aki",
     "cruz",
     "talbot",
     "ares",
     "zeus"
    ]
   }
  ],
  "knownCharacters": [
   "ezra",
   "kya_sg3",
   "kya_sg1",
   "raz",
   "james",
   "evelyn",
   "kaleb",
   "bell_lily_of_fell",
   "vanessa",
   "val",
   "jane",
   "tim"
  ]
 },
 "sandy": {
  "canonRoute": "val",
  "totalPassages": 9,
  "routes": [
   {
    "channel": "val",
    "passages": 7,
    "share": 0.7778,
    "first": "2020-12-26",
    "last": "2020-12-27",
    "kind": "canon",
    "castWith": [
     "val",
     "kya_sg3",
     "kaleb",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "evelyn",
     "vanessa",
     "ezra",
     "raye",
     "alan",
     "tyrion"
    ]
   },
   {
    "channel": "switched-roles-kya",
    "passages": 1,
    "share": 0.1111,
    "first": "2023-10-16",
    "last": "2023-10-16",
    "kind": "au",
    "castWith": [
     "diana",
     "kya_sg3",
     "raye",
     "ezra",
     "tate",
     "emanuel",
     "kya_sg1",
     "aphrodite",
     "alistair_turayne",
     "alistair",
     "kaleb",
     "cupid_eros"
    ]
   },
   {
    "channel": "ooc",
    "passages": 1,
    "share": 0.1111,
    "first": "2020-12-27",
    "last": "2020-12-27",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   }
  ],
  "knownCharacters": [
   "val",
   "kya_sg3",
   "kaleb",
   "alistair",
   "alistair_turayne",
   "kya_sg1",
   "evelyn",
   "vanessa",
   "ezra",
   "raye",
   "alan",
   "tyrion"
  ]
 },
 "santos": {
  "canonRoute": "nicole-x-cruz",
  "totalPassages": 4,
  "routes": [
   {
    "channel": "nicole-x-cruz",
    "passages": 4,
    "share": 1.0,
    "first": "2020-09-07",
    "last": "2020-09-07",
    "kind": "canon",
    "castWith": [
     "otto",
     "cruz",
     "jones",
     "nicole_human",
     "duran",
     "sorsha",
     "kya_sg1",
     "lucifer",
     "nicole_wolf",
     "kya_sg3",
     "nicole_sg3",
     "christopher_donovan"
    ]
   }
  ],
  "knownCharacters": [
   "otto",
   "cruz",
   "jones",
   "nicole_human",
   "duran",
   "sorsha",
   "kya_sg1",
   "lucifer",
   "nicole_wolf",
   "kya_sg3",
   "nicole_sg3",
   "christopher_donovan"
  ]
 },
 "saph": {
  "canonRoute": "staff-break-room",
  "totalPassages": 12,
  "routes": [
   {
    "channel": "staff-break-room",
    "passages": 10,
    "share": 0.8333,
    "first": "2020-06-14",
    "last": "2020-06-15",
    "kind": "canon",
    "castWith": [
     "dimitri",
     "rex",
     "evelyn",
     "diana",
     "aaron",
     "kiro",
     "milo",
     "skipper",
     "roman",
     "sebastian_vamp",
     "kya_sg3",
     "sebastian_siren"
    ]
   },
   {
    "channel": "auditorium",
    "passages": 2,
    "share": 0.1667,
    "first": "2020-06-14",
    "last": "2020-06-14",
    "kind": "route",
    "castWith": [
     "rex",
     "evelyn",
     "diana",
     "milo",
     "dimitri",
     "athena",
     "dike",
     "audrey",
     "bryce",
     "kaleb",
     "roman",
     "rio"
    ]
   }
  ],
  "knownCharacters": [
   "dimitri",
   "rex",
   "evelyn",
   "diana",
   "aaron",
   "kiro",
   "milo",
   "skipper",
   "roman",
   "sebastian_vamp",
   "kya_sg3",
   "sebastian_siren"
  ]
 },
 "satella": {
  "canonRoute": "ramesville",
  "totalPassages": 40,
  "routes": [
   {
    "channel": "ramesville",
    "passages": 13,
    "share": 0.325,
    "first": "2020-05-31",
    "last": "2020-06-01",
    "kind": "canon",
    "castWith": [
     "stella",
     "talon_char",
     "ronin_tempus",
     "melisende",
     "exis",
     "raze",
     "dimitri",
     "vanessa",
     "raye",
     "raz",
     "will"
    ]
   },
   {
    "channel": "troterra-kingdom",
    "passages": 10,
    "share": 0.25,
    "first": "2020-04-13",
    "last": "2020-06-03",
    "kind": "route",
    "castWith": [
     "stella",
     "ronin_tempus",
     "raze",
     "talon_char",
     "melisende",
     "dimitri",
     "silas_mirace",
     "vincent",
     "exis",
     "god",
     "may",
     "mikaela_hyakuya"
    ]
   },
   {
    "channel": "abandoned-building",
    "passages": 9,
    "share": 0.225,
    "first": "2020-04-13",
    "last": "2020-04-13",
    "kind": "route",
    "castWith": [
     "stella",
     "ronin_tempus",
     "exis",
     "talon_char",
     "melisende",
     "raze"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 5,
    "share": 0.125,
    "first": "2020-04-13",
    "last": "2020-06-03",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "ooc",
    "passages": 2,
    "share": 0.05,
    "first": "2020-04-14",
    "last": "2020-04-14",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "kyas_penthouse",
    "passages": 1,
    "share": 0.025,
    "first": "2016-09-14",
    "last": "2016-09-14",
    "kind": "route",
    "castWith": [
     "kaleb",
     "evelyn",
     "raye",
     "ezra",
     "kya_sg3",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "mr_han_sr",
     "bryce",
     "god",
     "cruz"
    ]
   }
  ],
  "knownCharacters": [
   "stella",
   "talon_char",
   "ronin_tempus",
   "melisende",
   "exis",
   "raze",
   "dimitri",
   "vanessa",
   "raye",
   "raz",
   "will"
  ]
 },
 "scott": {
  "canonRoute": "kya-werewolf",
  "totalPassages": 33,
  "routes": [
   {
    "channel": "kya-werewolf",
    "passages": 33,
    "share": 1.0,
    "first": "2021-08-17",
    "last": "2021-09-26",
    "kind": "canon",
    "castWith": [
     "jace",
     "raphael",
     "trey",
     "dillon",
     "kya_sg3",
     "kya_sg1",
     "ezra",
     "sebastian_siren",
     "kaleb",
     "sebastian_vamp",
     "evelyn",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "jace",
   "raphael",
   "trey",
   "dillon",
   "kya_sg3",
   "kya_sg1",
   "ezra",
   "sebastian_siren",
   "kaleb",
   "sebastian_vamp",
   "evelyn",
   "will"
  ]
 },
 "selina": {
  "canonRoute": "growing-up-ezra",
  "totalPassages": 1,
  "routes": [
   {
    "channel": "growing-up-ezra",
    "passages": 1,
    "share": 1.0,
    "first": "2023-01-29",
    "last": "2023-01-29",
    "kind": "canon",
    "castWith": [
     "ezra",
     "kya_sg3",
     "primrose",
     "dillon",
     "jane",
     "kya_sg1",
     "kaleb",
     "edward",
     "sebastian_vamp",
     "raye",
     "sebastian_siren",
     "ace"
    ]
   }
  ],
  "knownCharacters": [
   "ezra",
   "kya_sg3",
   "primrose",
   "dillon",
   "jane",
   "kya_sg1",
   "kaleb",
   "edward",
   "sebastian_vamp",
   "raye",
   "sebastian_siren",
   "ace"
  ]
 },
 "selma": {
  "canonRoute": "1-real-cruz",
  "totalPassages": 38,
  "routes": [
   {
    "channel": "1-real-cruz",
    "passages": 38,
    "share": 1.0,
    "first": "2022-12-24",
    "last": "2023-01-03",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "ares",
     "lance",
     "zeus",
     "lindon",
     "hera",
     "ryder",
     "apollo",
     "nolan",
     "diana"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "cruz",
   "bryce",
   "ares",
   "lance",
   "zeus",
   "lindon",
   "hera",
   "ryder",
   "apollo",
   "nolan",
   "diana"
  ]
 },
 "senan": {
  "canonRoute": "the-kingdom-fallon",
  "totalPassages": 7,
  "routes": [
   {
    "channel": "the-kingdom-fallon",
    "passages": 7,
    "share": 1.0,
    "first": "2021-05-28",
    "last": "2021-05-28",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "eva",
     "rory",
     "raye",
     "fiadh",
     "ciarnan",
     "finn",
     "cailte",
     "diarmund",
     "fiann",
     "goll",
     "kaleb"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "eva",
   "rory",
   "raye",
   "fiadh",
   "ciarnan",
   "finn",
   "cailte",
   "diarmund",
   "fiann",
   "goll",
   "kaleb"
  ]
 },
 "seuk": {
  "canonRoute": "evelyns_mansion",
  "totalPassages": 5,
  "routes": [
   {
    "channel": "evelyns_mansion",
    "passages": 5,
    "share": 1.0,
    "first": "2016-09-24",
    "last": "2016-09-25",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "kaleb",
     "cruz",
     "kya_sg3",
     "ivy_morris",
     "marta",
     "kya_sg1",
     "frau",
     "mr_han_sr",
     "sebastian_vamp",
     "god",
     "dimitri"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "kaleb",
   "cruz",
   "kya_sg3",
   "ivy_morris",
   "marta",
   "kya_sg1",
   "frau",
   "mr_han_sr",
   "sebastian_vamp",
   "god",
   "dimitri"
  ]
 },
 "shadow": {
  "canonRoute": "kinley-reset-route",
  "totalPassages": 31,
  "routes": [
   {
    "channel": "kinley-reset-route",
    "passages": 21,
    "share": 0.6774,
    "first": "2022-02-18",
    "last": "2022-03-03",
    "kind": "canon",
    "castWith": [
     "kinley",
     "lander",
     "tate",
     "aaron",
     "raye",
     "zain_demigod",
     "natalia",
     "apollo",
     "crom",
     "god",
     "jova",
     "aphrodite"
    ]
   },
   {
    "channel": "kya-senior-year",
    "passages": 5,
    "share": 0.1613,
    "first": "2021-06-14",
    "last": "2021-06-16",
    "kind": "route",
    "castWith": [
     "callan",
     "ezra",
     "leiden",
     "melody",
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "raye",
     "tate",
     "sebastian_vamp",
     "dillon",
     "sebastian_siren"
    ]
   },
   {
    "channel": "1-real-cruz",
    "passages": 1,
    "share": 0.0323,
    "first": "2022-10-26",
    "last": "2022-10-26",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "ares",
     "lance",
     "selma",
     "zeus",
     "lindon",
     "hera",
     "ryder",
     "apollo",
     "nolan"
    ]
   },
   {
    "channel": "nicoles-wish-brax-brother",
    "passages": 1,
    "share": 0.0323,
    "first": "2023-05-16",
    "last": "2023-05-16",
    "kind": "route",
    "castWith": [
     "ford",
     "cruz",
     "brax",
     "lance",
     "dimitri",
     "hades",
     "vaughn",
     "rowan",
     "nicole_human",
     "audrey",
     "diana",
     "evelyn"
    ]
   },
   {
    "channel": "ares-phones-home",
    "passages": 1,
    "share": 0.0323,
    "first": "2024-11-26",
    "last": "2024-11-26",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "cruz",
     "ryder",
     "ares",
     "roger",
     "diana",
     "allie",
     "micah",
     "cupid_eros",
     "penelope_valk",
     "evelyn"
    ]
   },
   {
    "channel": "an-accidentally-valerian-summer-with-cordelia",
    "passages": 1,
    "share": 0.0323,
    "first": "2021-03-04",
    "last": "2021-03-04",
    "kind": "route",
    "castWith": [
     "ciel",
     "nolan",
     "lupe",
     "arsene",
     "delia",
     "dale",
     "jessica",
     "cruz",
     "clairette",
     "may",
     "tina",
     "cyrena"
    ]
   },
   {
    "channel": "cruz-x-nicole",
    "passages": 1,
    "share": 0.0323,
    "first": "2020-08-21",
    "last": "2020-08-21",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "hermes",
     "audrey",
     "peter",
     "ares",
     "nicole_wolf",
     "nicole_sg3",
     "alyce_char",
     "red",
     "trix",
     "nicole_human"
    ]
   }
  ],
  "knownCharacters": [
   "kinley",
   "lander",
   "tate",
   "aaron",
   "raye",
   "zain_demigod",
   "natalia",
   "apollo",
   "crom",
   "god",
   "jova",
   "aphrodite"
  ]
 },
 "sif": {
  "canonRoute": "asgard",
  "totalPassages": 8,
  "routes": [
   {
    "channel": "asgard",
    "passages": 6,
    "share": 0.75,
    "first": "2020-05-17",
    "last": "2020-05-17",
    "kind": "canon",
    "castWith": [
     "agnar",
     "agmund",
     "loki",
     "kya_sg3",
     "odin",
     "svira",
     "penelope_valk",
     "kya_sg1",
     "thor",
     "freya",
     "god",
     "frigg"
    ]
   },
   {
    "channel": "val",
    "passages": 1,
    "share": 0.125,
    "first": "2020-12-02",
    "last": "2020-12-02",
    "kind": "route",
    "castWith": [
     "val",
     "kya_sg3",
     "kaleb",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "evelyn",
     "vanessa",
     "ezra",
     "raye",
     "alan",
     "tyrion"
    ]
   },
   {
    "channel": "dorms",
    "passages": 1,
    "share": 0.125,
    "first": "2020-05-08",
    "last": "2020-05-08",
    "kind": "route",
    "castWith": [
     "agnar",
     "kya_sg3",
     "agmund",
     "evelyn",
     "raye",
     "cole",
     "kya_sg1",
     "riku",
     "kaleb",
     "penelope_valk",
     "loki",
     "svira"
    ]
   }
  ],
  "knownCharacters": [
   "agnar",
   "agmund",
   "loki",
   "kya_sg3",
   "odin",
   "svira",
   "penelope_valk",
   "kya_sg1",
   "thor",
   "freya",
   "god",
   "frigg"
  ]
 },
 "silas_mirace": {
  "canonRoute": "silas-mirace-castle",
  "totalPassages": 94,
  "routes": [
   {
    "channel": "silas-mirace-castle",
    "passages": 50,
    "share": 0.5319,
    "first": "2020-04-02",
    "last": "2020-04-03",
    "kind": "canon",
    "castWith": [
     "stella",
     "melisende",
     "raze",
     "may"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 11,
    "share": 0.117,
    "first": "2020-04-02",
    "last": "2020-05-30",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 7,
    "share": 0.0745,
    "first": "2020-07-24",
    "last": "2020-07-25",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika"
    ]
   },
   {
    "channel": "ooc",
    "passages": 6,
    "share": 0.0638,
    "first": "2020-06-04",
    "last": "2020-06-19",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "troterra-kingdom",
    "passages": 6,
    "share": 0.0638,
    "first": "2020-04-02",
    "last": "2020-04-06",
    "kind": "route",
    "castWith": [
     "stella",
     "ronin_tempus",
     "raze",
     "talon_char",
     "melisende",
     "dimitri",
     "satella",
     "vincent",
     "exis",
     "god",
     "may",
     "mikaela_hyakuya"
    ]
   },
   {
    "channel": "dimitri-castle",
    "passages": 4,
    "share": 0.0426,
    "first": "2020-04-06",
    "last": "2020-04-07",
    "kind": "route",
    "castWith": [
     "dimitri",
     "evelyn",
     "stella",
     "ronin_tempus",
     "kaleb",
     "melisende",
     "mr_han_sr",
     "gambit",
     "frau",
     "theo_uoki",
     "toko",
     "raye"
    ]
   },
   {
    "channel": "general",
    "passages": 3,
    "share": 0.0319,
    "first": "2020-07-25",
    "last": "2020-08-09",
    "kind": "ooc",
    "castWith": [
     "ezra",
     "eric",
     "cruz",
     "james",
     "apollo",
     "lance",
     "aaron",
     "raye",
     "moros",
     "ace",
     "kaleb",
     "hermes"
    ]
   },
   {
    "channel": "theo-uoki-castle",
    "passages": 3,
    "share": 0.0319,
    "first": "2020-04-03",
    "last": "2020-04-03",
    "kind": "route",
    "castWith": [
     "stella",
     "theo_uoki",
     "raze",
     "melisende",
     "frank",
     "tom",
     "yuu",
     "vincent",
     "ronin_tempus"
    ]
   },
   {
    "channel": "prince-char-bios",
    "passages": 2,
    "share": 0.0213,
    "first": "2020-04-01",
    "last": "2020-05-22",
    "kind": "route",
    "castWith": [
     "ronin_tempus",
     "stella",
     "dimitri",
     "talon_char",
     "melisende",
     "mikaela_hyakuya",
     "raze",
     "theo_uoki",
     "yuu",
     "vincent"
    ]
   },
   {
    "channel": "haley-vampire-fanfic",
    "passages": 1,
    "share": 0.0106,
    "first": "2020-08-06",
    "last": "2020-08-06",
    "kind": "au",
    "castWith": [
     "alistair",
     "apollo",
     "alistair_turayne"
    ]
   },
   {
    "channel": "ronin-tempus-castle",
    "passages": 1,
    "share": 0.0106,
    "first": "2020-04-04",
    "last": "2020-04-04",
    "kind": "route",
    "castWith": [
     "stella",
     "ronin_tempus",
     "raze",
     "melisende",
     "talon_char",
     "kya_sg3",
     "may",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "stella",
   "melisende",
   "raze",
   "may"
  ]
 },
 "silvia": {
  "canonRoute": "fall-fairies",
  "totalPassages": 3,
  "routes": [
   {
    "channel": "fall-fairies",
    "passages": 3,
    "share": 1.0,
    "first": "2021-10-29",
    "last": "2021-10-29",
    "kind": "canon",
    "castWith": [
     "damien",
     "matare",
     "autumn",
     "retin",
     "draven",
     "fayette",
     "sir_tyde",
     "may",
     "maleos",
     "jaden",
     "will",
     "roman"
    ]
   }
  ],
  "knownCharacters": [
   "damien",
   "matare",
   "autumn",
   "retin",
   "draven",
   "fayette",
   "sir_tyde",
   "may",
   "maleos",
   "jaden",
   "will",
   "roman"
  ]
 },
 "sir_tyde": {
  "canonRoute": "fall-fairies",
  "totalPassages": 12,
  "routes": [
   {
    "channel": "fall-fairies",
    "passages": 12,
    "share": 1.0,
    "first": "2021-11-14",
    "last": "2021-11-16",
    "kind": "canon",
    "castWith": [
     "damien",
     "matare",
     "autumn",
     "retin",
     "draven",
     "fayette",
     "may",
     "maleos",
     "silvia",
     "jaden",
     "will",
     "roman"
    ]
   }
  ],
  "knownCharacters": [
   "damien",
   "matare",
   "autumn",
   "retin",
   "draven",
   "fayette",
   "may",
   "maleos",
   "silvia",
   "jaden",
   "will",
   "roman"
  ]
 },
 "skipper": {
  "canonRoute": "aquarium",
  "totalPassages": 81,
  "routes": [
   {
    "channel": "aquarium",
    "passages": 12,
    "share": 0.1481,
    "first": "2020-04-14",
    "last": "2020-04-19",
    "kind": "canon",
    "castWith": [
     "kya_sg3",
     "ezra",
     "kya_sg1",
     "polly",
     "sebastian_vamp",
     "sebastian_siren",
     "lira",
     "kyo",
     "crom",
     "evelyn",
     "kaleb",
     "kris"
    ]
   },
   {
    "channel": "aquarium-seb",
    "passages": 11,
    "share": 0.1358,
    "first": "2025-01-17",
    "last": "2025-01-21",
    "kind": "route",
    "castWith": [
     "sebastian_siren",
     "sebastian_vamp",
     "kya_sg3",
     "kya_sg1",
     "polly",
     "ezra",
     "dillon",
     "reed"
    ]
   },
   {
    "channel": "beach-and-boardwalk",
    "passages": 8,
    "share": 0.0988,
    "first": "2020-04-15",
    "last": "2020-05-03",
    "kind": "route",
    "castWith": [
     "cole",
     "ezra",
     "kya_sg3",
     "kya_sg1",
     "evelyn",
     "alistair",
     "alistair_turayne",
     "riku",
     "raye",
     "kaleb",
     "sebastian_vamp",
     "darren"
    ]
   },
   {
    "channel": "val",
    "passages": 8,
    "share": 0.0988,
    "first": "2020-04-15",
    "last": "2020-04-16",
    "kind": "route",
    "castWith": [
     "val",
     "kya_sg3",
     "kaleb",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "evelyn",
     "vanessa",
     "ezra",
     "raye",
     "alan",
     "tyrion"
    ]
   },
   {
    "channel": "kya-castle",
    "passages": 7,
    "share": 0.0864,
    "first": "2020-07-28",
    "last": "2020-07-29",
    "kind": "route",
    "castWith": [
     "evelyn",
     "yuri_rekovich",
     "kya_sg3",
     "sebastian_vamp",
     "sebastian_siren",
     "kaleb",
     "kya_sg1",
     "mr_han_sr",
     "will",
     "frau"
    ]
   },
   {
    "channel": "love-the-good-bois",
    "passages": 6,
    "share": 0.0741,
    "first": "2022-11-18",
    "last": "2022-11-26",
    "kind": "route",
    "castWith": [
     "ezra",
     "junta",
     "kya_sg3",
     "raz",
     "kya_sg1",
     "tim",
     "sebastian_vamp",
     "val",
     "evelyn",
     "kaleb",
     "james",
     "primrose"
    ]
   },
   {
    "channel": "fantastical-ezra",
    "passages": 4,
    "share": 0.0494,
    "first": "2025-02-17",
    "last": "2025-02-18",
    "kind": "route",
    "castWith": [
     "ezra",
     "dillon",
     "kaleb",
     "apollo",
     "kya_sg3",
     "james",
     "sebastian_vamp",
     "evelyn",
     "kya_sg1",
     "haley_human",
     "sebastian_siren",
     "polly"
    ]
   },
   {
    "channel": "haleys-wish",
    "passages": 3,
    "share": 0.037,
    "first": "2023-04-26",
    "last": "2023-04-26",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "evelyn",
     "sebastian_siren",
     "kya_sg1",
     "sebastian_vamp",
     "haley_human",
     "polly",
     "cruz",
     "dimitri",
     "haley_wolf",
     "haley_sg3",
     "kaleb"
    ]
   },
   {
    "channel": "ooc",
    "passages": 3,
    "share": 0.037,
    "first": "2020-05-13",
    "last": "2020-06-08",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "staff-break-room",
    "passages": 3,
    "share": 0.037,
    "first": "2020-06-08",
    "last": "2020-06-08",
    "kind": "route",
    "castWith": [
     "dimitri",
     "rex",
     "evelyn",
     "saph",
     "diana",
     "aaron",
     "kiro",
     "milo",
     "roman",
     "sebastian_vamp",
     "kya_sg3",
     "sebastian_siren"
    ]
   },
   {
    "channel": "surf-shack",
    "passages": 3,
    "share": 0.037,
    "first": "2020-04-30",
    "last": "2020-04-30",
    "kind": "route",
    "castWith": [
     "raye",
     "kya_sg3",
     "kya_sg1",
     "evelyn",
     "sebastian_vamp",
     "sebastian_siren"
    ]
   },
   {
    "channel": "alistair-reboot2",
    "passages": 2,
    "share": 0.0247,
    "first": "2022-05-01",
    "last": "2022-05-01",
    "kind": "au",
    "castWith": [
     "alistair",
     "alistair_turayne",
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "sebastian_vamp",
     "evelyn",
     "sebastian_siren",
     "dillon",
     "ezra",
     "kyo",
     "uncle_khan"
    ]
   }
  ],
  "knownCharacters": [
   "kya_sg3",
   "ezra",
   "kya_sg1",
   "polly",
   "sebastian_vamp",
   "sebastian_siren",
   "lira",
   "kyo",
   "crom",
   "evelyn",
   "kaleb",
   "kris"
  ]
 },
 "skylar": {
  "canonRoute": "plz-love-lachesis",
  "totalPassages": 2,
  "routes": [
   {
    "channel": "plz-love-lachesis",
    "passages": 2,
    "share": 1.0,
    "first": "2022-11-22",
    "last": "2022-11-22",
    "kind": "canon",
    "castWith": [
     "lachesis",
     "ramiel",
     "lance",
     "god",
     "lucifer",
     "apollo",
     "levi",
     "aion",
     "atropos",
     "zeus",
     "zadkiel",
     "clothos"
    ]
   }
  ],
  "knownCharacters": [
   "lachesis",
   "ramiel",
   "lance",
   "god",
   "lucifer",
   "apollo",
   "levi",
   "aion",
   "atropos",
   "zeus",
   "zadkiel",
   "clothos"
  ]
 },
 "slater": {
  "canonRoute": "werewolf-dimitri",
  "totalPassages": 11,
  "routes": [
   {
    "channel": "werewolf-dimitri",
    "passages": 11,
    "share": 1.0,
    "first": "2021-11-12",
    "last": "2021-11-17",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "dimitri",
     "kaleb",
     "kya_sg3",
     "frau",
     "god",
     "lionel",
     "byron",
     "gambit",
     "uncle_khan",
     "kelli",
     "liera"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "dimitri",
   "kaleb",
   "kya_sg3",
   "frau",
   "god",
   "lionel",
   "byron",
   "gambit",
   "uncle_khan",
   "kelli",
   "liera"
  ]
 },
 "solum": {
  "canonRoute": "kingdom-of-temprum",
  "totalPassages": 7,
  "routes": [
   {
    "channel": "kingdom-of-temprum",
    "passages": 6,
    "share": 0.8571,
    "first": "2020-05-22",
    "last": "2020-05-26",
    "kind": "canon",
    "castWith": [
     "aria",
     "bennett",
     "benji",
     "ajax",
     "naveed",
     "fawn",
     "bast",
     "caria",
     "neitl",
     "batiuba",
     "will",
     "kaleb"
    ]
   },
   {
    "channel": "kingdom-of-wellis",
    "passages": 1,
    "share": 0.1429,
    "first": "2020-06-01",
    "last": "2020-06-01",
    "kind": "route",
    "castWith": [
     "aria",
     "bennett",
     "benji",
     "caria",
     "ajax",
     "ever",
     "ben"
    ]
   }
  ],
  "knownCharacters": [
   "aria",
   "bennett",
   "benji",
   "ajax",
   "naveed",
   "fawn",
   "bast",
   "caria",
   "neitl",
   "batiuba",
   "will",
   "kaleb"
  ]
 },
 "sorsha": {
  "canonRoute": "nicole-x-cruz",
  "totalPassages": 6,
  "routes": [
   {
    "channel": "nicole-x-cruz",
    "passages": 6,
    "share": 1.0,
    "first": "2020-09-07",
    "last": "2020-09-07",
    "kind": "canon",
    "castWith": [
     "otto",
     "cruz",
     "jones",
     "nicole_human",
     "duran",
     "kya_sg1",
     "lucifer",
     "nicole_wolf",
     "kya_sg3",
     "nicole_sg3",
     "christopher_donovan",
     "jonathan_donovan"
    ]
   }
  ],
  "knownCharacters": [
   "otto",
   "cruz",
   "jones",
   "nicole_human",
   "duran",
   "kya_sg1",
   "lucifer",
   "nicole_wolf",
   "kya_sg3",
   "nicole_sg3",
   "christopher_donovan",
   "jonathan_donovan"
  ]
 },
 "spencer": {
  "canonRoute": null,
  "totalPassages": 1,
  "routes": [
   {
    "channel": "ww-war-au",
    "passages": 1,
    "share": 1.0,
    "first": "2021-11-20",
    "last": "2021-11-20",
    "kind": "au",
    "castWith": [
     "evelyn",
     "cruz",
     "ace",
     "ezra",
     "lindon",
     "kaleb",
     "rowan",
     "bryce",
     "lance",
     "raye",
     "nolan",
     "primrose"
    ]
   }
  ],
  "knownCharacters": []
 },
 "stan": {
  "canonRoute": "cupid-hq",
  "totalPassages": 2,
  "routes": [
   {
    "channel": "cupid-hq",
    "passages": 2,
    "share": 1.0,
    "first": "2020-06-03",
    "last": "2020-06-04",
    "kind": "canon",
    "castWith": [
     "cupid_eros",
     "sabrina_witch",
     "tim",
     "drake",
     "halo",
     "god",
     "aphrodite",
     "pam",
     "tom",
     "hiro",
     "ares",
     "hades"
    ]
   }
  ],
  "knownCharacters": [
   "cupid_eros",
   "sabrina_witch",
   "tim",
   "drake",
   "halo",
   "god",
   "aphrodite",
   "pam",
   "tom",
   "hiro",
   "ares",
   "hades"
  ]
 },
 "starlet": {
  "canonRoute": "human-not-human",
  "totalPassages": 2,
  "routes": [
   {
    "channel": "human-not-human",
    "passages": 2,
    "share": 1.0,
    "first": "2022-10-17",
    "last": "2022-10-17",
    "kind": "canon",
    "castWith": [
     "dillon",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "sebastian_vamp",
     "drisella",
     "god",
     "blair",
     "madeline",
     "tanya",
     "topps",
     "ever"
    ]
   }
  ],
  "knownCharacters": [
   "dillon",
   "kya_sg3",
   "kya_sg1",
   "sebastian_siren",
   "sebastian_vamp",
   "drisella",
   "god",
   "blair",
   "madeline",
   "tanya",
   "topps",
   "ever"
  ]
 },
 "stash": {
  "canonRoute": "parabus",
  "totalPassages": 7,
  "routes": [
   {
    "channel": "parabus",
    "passages": 5,
    "share": 0.7143,
    "first": "2020-06-03",
    "last": "2020-06-04",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "lucius",
     "rex",
     "rowan",
     "laito",
     "boko",
     "ryan",
     "raye",
     "mr_han_sr",
     "cruz",
     "kya_sg3",
     "kaleb"
    ]
   },
   {
    "channel": "bonfire",
    "passages": 1,
    "share": 0.1429,
    "first": "2020-06-05",
    "last": "2020-06-05",
    "kind": "route",
    "castWith": [
     "rex",
     "evelyn",
     "lucius",
     "boko",
     "rowan",
     "may"
    ]
   },
   {
    "channel": "bios",
    "passages": 1,
    "share": 0.1429,
    "first": "2020-06-05",
    "last": "2020-06-05",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "evelyn",
     "lucius",
     "athena",
     "bryce",
     "val",
     "hiro",
     "raz",
     "rex",
     "vanessa",
     "halo",
     "dalton"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "lucius",
   "rex",
   "rowan",
   "laito",
   "boko",
   "ryan",
   "raye",
   "mr_han_sr",
   "cruz",
   "kya_sg3",
   "kaleb"
  ]
 },
 "stellar": {
  "canonRoute": "you-have-me-roman",
  "totalPassages": 5,
  "routes": [
   {
    "channel": "you-have-me-roman",
    "passages": 5,
    "share": 1.0,
    "first": "2022-11-08",
    "last": "2022-11-11",
    "kind": "canon",
    "castWith": [
     "darius",
     "titus",
     "roman",
     "kya_sg3",
     "dillon",
     "kya_sg1",
     "evelyn",
     "easton",
     "deven",
     "will",
     "lachesis",
     "darren"
    ]
   }
  ],
  "knownCharacters": [
   "darius",
   "titus",
   "roman",
   "kya_sg3",
   "dillon",
   "kya_sg1",
   "evelyn",
   "easton",
   "deven",
   "will",
   "lachesis",
   "darren"
  ]
 },
 "stuart": {
  "canonRoute": "rogue-wolf-hot-cruz",
  "totalPassages": 2,
  "routes": [
   {
    "channel": "rogue-wolf-hot-cruz",
    "passages": 2,
    "share": 1.0,
    "first": "2021-03-06",
    "last": "2021-03-06",
    "kind": "canon",
    "castWith": [
     "cruz",
     "hunter",
     "ryder",
     "trix",
     "audrey",
     "lance",
     "alyce_char",
     "bryce",
     "nolan",
     "diana",
     "will",
     "ever"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "hunter",
   "ryder",
   "trix",
   "audrey",
   "lance",
   "alyce_char",
   "bryce",
   "nolan",
   "diana",
   "will",
   "ever"
  ]
 },
 "summer": {
  "canonRoute": "warring-men",
  "totalPassages": 4,
  "routes": [
   {
    "channel": "warring-men",
    "passages": 2,
    "share": 0.5,
    "first": "2025-08-08",
    "last": "2025-09-30",
    "kind": "canon",
    "castWith": [
     "aelira",
     "killian",
     "arthur_turayne",
     "autumn",
     "terrance",
     "may",
     "ragland",
     "will"
    ]
   },
   {
    "channel": "kyas-choice",
    "passages": 1,
    "share": 0.25,
    "first": "2022-05-15",
    "last": "2022-05-15",
    "kind": "route",
    "castWith": [
     "taren",
     "kya_sg3",
     "keller",
     "gale",
     "kya_sg1",
     "dash",
     "atropos",
     "haley_human",
     "kaleb",
     "skipper",
     "will"
    ]
   },
   {
    "channel": "alistair-x-human-kya",
    "passages": 1,
    "share": 0.25,
    "first": "2020-08-04",
    "last": "2020-08-04",
    "kind": "route",
    "castWith": [
     "haley_human",
     "alistair_turayne",
     "alistair",
     "apollo",
     "nicole_human",
     "ezra",
     "raye",
     "james",
     "atropos",
     "hades",
     "beatrice",
     "cruz"
    ]
   }
  ],
  "knownCharacters": [
   "aelira",
   "killian",
   "arthur_turayne",
   "autumn",
   "terrance",
   "may",
   "ragland",
   "will"
  ]
 },
 "sune": {
  "canonRoute": "meeting-room",
  "totalPassages": 16,
  "routes": [
   {
    "channel": "meeting-room",
    "passages": 8,
    "share": 0.5,
    "first": "2020-04-14",
    "last": "2020-04-14",
    "kind": "canon",
    "castWith": [
     "kaleb",
     "ezra",
     "kya_sg3",
     "raye",
     "evelyn",
     "alistair_turayne",
     "alistair",
     "mr_han_sr",
     "kya_sg1",
     "thorne",
     "prince_zain",
     "yuri_rekovich"
    ]
   },
   {
    "channel": "han-family-mansion",
    "passages": 6,
    "share": 0.375,
    "first": "2020-04-20",
    "last": "2020-04-21",
    "kind": "route",
    "castWith": [
     "evelyn",
     "ezra",
     "kaleb",
     "kya_sg3",
     "rowan",
     "mr_han_sr",
     "raye",
     "kya_sg1",
     "alistair",
     "alistair_turayne",
     "becca",
     "marta"
    ]
   },
   {
    "channel": "northwest-pack-lodge",
    "passages": 1,
    "share": 0.0625,
    "first": "2020-04-15",
    "last": "2020-04-15",
    "kind": "route",
    "castWith": [
     "rowan",
     "evelyn",
     "lucius",
     "nellie",
     "myra",
     "cruz",
     "bryce",
     "will",
     "dimitri",
     "kaleb",
     "rio",
     "may"
    ]
   },
   {
    "channel": "college-campus",
    "passages": 1,
    "share": 0.0625,
    "first": "2020-04-29",
    "last": "2020-04-29",
    "kind": "route",
    "castWith": [
     "agnar",
     "agmund",
     "kya_sg3",
     "penelope_valk",
     "evelyn",
     "svira",
     "rowan",
     "may",
     "jon",
     "kya_sg1",
     "kaleb",
     "darren"
    ]
   }
  ],
  "knownCharacters": [
   "kaleb",
   "ezra",
   "kya_sg3",
   "raye",
   "evelyn",
   "alistair_turayne",
   "alistair",
   "mr_han_sr",
   "kya_sg1",
   "thorne",
   "prince_zain",
   "yuri_rekovich"
  ]
 },
 "talbot": {
  "canonRoute": "lets-abduct-evie",
  "totalPassages": 12,
  "routes": [
   {
    "channel": "lets-abduct-evie",
    "passages": 11,
    "share": 0.9167,
    "first": "2021-07-17",
    "last": "2021-07-22",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "dimitri",
     "ryoto",
     "dodge",
     "ms_tia",
     "kaleb",
     "frau",
     "aki",
     "cruz",
     "ares",
     "zeus",
     "hera"
    ]
   },
   {
    "channel": "cruz-x-human",
    "passages": 1,
    "share": 0.0833,
    "first": "2021-05-02",
    "last": "2021-05-02",
    "kind": "route",
    "castWith": [
     "cruz",
     "skye",
     "nolan",
     "ryder",
     "audrey",
     "troy",
     "adrien",
     "bryce",
     "airi",
     "natasha",
     "diana",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "dimitri",
   "ryoto",
   "dodge",
   "ms_tia",
   "kaleb",
   "frau",
   "aki",
   "cruz",
   "ares",
   "zeus",
   "hera"
  ]
 },
 "tallia": {
  "canonRoute": "a-demons-jewel",
  "totalPassages": 33,
  "routes": [
   {
    "channel": "a-demons-jewel",
    "passages": 33,
    "share": 1.0,
    "first": "2022-02-01",
    "last": "2022-02-17",
    "kind": "canon",
    "castWith": [
     "adrianne",
     "lucifer",
     "god",
     "will",
     "may",
     "gabriel",
     "prince_teregan"
    ]
   }
  ],
  "knownCharacters": [
   "adrianne",
   "lucifer",
   "god",
   "will",
   "may",
   "gabriel",
   "prince_teregan"
  ]
 },
 "tanya": {
  "canonRoute": "human-not-human",
  "totalPassages": 3,
  "routes": [
   {
    "channel": "human-not-human",
    "passages": 3,
    "share": 1.0,
    "first": "2022-10-17",
    "last": "2022-10-17",
    "kind": "canon",
    "castWith": [
     "dillon",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "sebastian_vamp",
     "drisella",
     "god",
     "blair",
     "madeline",
     "topps",
     "starlet",
     "ever"
    ]
   }
  ],
  "knownCharacters": [
   "dillon",
   "kya_sg3",
   "kya_sg1",
   "sebastian_siren",
   "sebastian_vamp",
   "drisella",
   "god",
   "blair",
   "madeline",
   "topps",
   "starlet",
   "ever"
  ]
 },
 "taren": {
  "canonRoute": "kyas-choice",
  "totalPassages": 60,
  "routes": [
   {
    "channel": "kyas-choice",
    "passages": 60,
    "share": 1.0,
    "first": "2022-05-11",
    "last": "2022-05-16",
    "kind": "canon",
    "castWith": [
     "kya_sg3",
     "keller",
     "gale",
     "kya_sg1",
     "dash",
     "atropos",
     "haley_human",
     "kaleb",
     "skipper",
     "summer",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "kya_sg3",
   "keller",
   "gale",
   "kya_sg1",
   "dash",
   "atropos",
   "haley_human",
   "kaleb",
   "skipper",
   "summer",
   "will"
  ]
 },
 "tate": {
  "canonRoute": "kya-senior-year",
  "totalPassages": 62,
  "routes": [
   {
    "channel": "kya-senior-year",
    "passages": 28,
    "share": 0.4516,
    "first": "2021-06-14",
    "last": "2021-06-21",
    "kind": "canon",
    "castWith": [
     "callan",
     "ezra",
     "leiden",
     "melody",
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "raye",
     "sebastian_vamp",
     "dillon",
     "sebastian_siren",
     "evelyn"
    ]
   },
   {
    "channel": "kinley-reset-route",
    "passages": 18,
    "share": 0.2903,
    "first": "2022-02-17",
    "last": "2022-03-02",
    "kind": "route",
    "castWith": [
     "kinley",
     "lander",
     "shadow",
     "aaron",
     "raye",
     "zain_demigod",
     "natalia",
     "apollo",
     "crom",
     "god",
     "jova",
     "aphrodite"
    ]
   },
   {
    "channel": "alistares-at-his-phone-in-confusion",
    "passages": 9,
    "share": 0.1452,
    "first": "2024-06-13",
    "last": "2024-06-15",
    "kind": "route",
    "castWith": [
     "alistair",
     "haley_human",
     "alistair_turayne",
     "ezra"
    ]
   },
   {
    "channel": "switched-roles-kya",
    "passages": 6,
    "share": 0.0968,
    "first": "2023-10-15",
    "last": "2023-10-16",
    "kind": "au",
    "castWith": [
     "diana",
     "kya_sg3",
     "raye",
     "ezra",
     "emanuel",
     "kya_sg1",
     "aphrodite",
     "alistair_turayne",
     "alistair",
     "kaleb",
     "cupid_eros",
     "emmanuel"
    ]
   },
   {
    "channel": "no-time-like-the-present",
    "passages": 1,
    "share": 0.0161,
    "first": "2023-10-09",
    "last": "2023-10-09",
    "kind": "route",
    "castWith": [
     "eva",
     "shane",
     "lance",
     "ryder",
     "allie",
     "cruz",
     "micah",
     "god",
     "aspen",
     "trix",
     "diana",
     "evelyn"
    ]
   }
  ],
  "knownCharacters": [
   "callan",
   "ezra",
   "leiden",
   "melody",
   "kya_sg3",
   "kaleb",
   "kya_sg1",
   "raye",
   "sebastian_vamp",
   "dillon",
   "sebastian_siren",
   "evelyn"
  ]
 },
 "tazariah": {
  "canonRoute": "haggle-for-the-girl",
  "totalPassages": 1,
  "routes": [
   {
    "channel": "haggle-for-the-girl",
    "passages": 1,
    "share": 1.0,
    "first": "2023-12-13",
    "last": "2023-12-13",
    "kind": "canon",
    "castWith": [
     "lachesis",
     "lucifer",
     "asrius",
     "god",
     "lonnie",
     "ramiel",
     "gabriel",
     "lance",
     "hades",
     "alyk",
     "aphrodite",
     "atropos"
    ]
   }
  ],
  "knownCharacters": [
   "lachesis",
   "lucifer",
   "asrius",
   "god",
   "lonnie",
   "ramiel",
   "gabriel",
   "lance",
   "hades",
   "alyk",
   "aphrodite",
   "atropos"
  ]
 },
 "theo_uoki": {
  "canonRoute": "theo-uoki-castle",
  "totalPassages": 39,
  "routes": [
   {
    "channel": "theo-uoki-castle",
    "passages": 29,
    "share": 0.7436,
    "first": "2020-04-03",
    "last": "2020-04-03",
    "kind": "canon",
    "castWith": [
     "stella",
     "raze",
     "melisende",
     "frank",
     "tom",
     "yuu",
     "silas_mirace",
     "vincent",
     "ronin_tempus"
    ]
   },
   {
    "channel": "dimitri-castle",
    "passages": 3,
    "share": 0.0769,
    "first": "2020-04-06",
    "last": "2020-04-06",
    "kind": "route",
    "castWith": [
     "dimitri",
     "evelyn",
     "stella",
     "ronin_tempus",
     "kaleb",
     "melisende",
     "mr_han_sr",
     "gambit",
     "frau",
     "silas_mirace",
     "toko",
     "raye"
    ]
   },
   {
    "channel": "prince-char-bios",
    "passages": 2,
    "share": 0.0513,
    "first": "2020-04-01",
    "last": "2020-05-22",
    "kind": "route",
    "castWith": [
     "ronin_tempus",
     "stella",
     "dimitri",
     "talon_char",
     "melisende",
     "mikaela_hyakuya",
     "raze",
     "silas_mirace",
     "yuu",
     "vincent"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 2,
    "share": 0.0513,
    "first": "2020-04-06",
    "last": "2020-04-06",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "kya-senior-year",
    "passages": 1,
    "share": 0.0256,
    "first": "2021-07-03",
    "last": "2021-07-03",
    "kind": "route",
    "castWith": [
     "callan",
     "ezra",
     "leiden",
     "melody",
     "kya_sg3",
     "kaleb",
     "kya_sg1",
     "raye",
     "tate",
     "sebastian_vamp",
     "dillon",
     "sebastian_siren"
    ]
   },
   {
    "channel": "elders-layla",
    "passages": 1,
    "share": 0.0256,
    "first": "2020-09-08",
    "last": "2020-09-08",
    "kind": "route",
    "castWith": [
     "vanessa",
     "val",
     "layla",
     "tim",
     "james",
     "junta",
     "sebastian_vamp",
     "sebastian_siren",
     "apollo",
     "will"
    ]
   },
   {
    "channel": "troterra-kingdom",
    "passages": 1,
    "share": 0.0256,
    "first": "2020-04-02",
    "last": "2020-04-02",
    "kind": "route",
    "castWith": [
     "stella",
     "ronin_tempus",
     "raze",
     "talon_char",
     "melisende",
     "dimitri",
     "satella",
     "silas_mirace",
     "vincent",
     "exis",
     "god",
     "may"
    ]
   }
  ],
  "knownCharacters": [
   "stella",
   "raze",
   "melisende",
   "frank",
   "tom",
   "yuu",
   "silas_mirace",
   "vincent",
   "ronin_tempus"
  ]
 },
 "theodore": {
  "canonRoute": "human-evie",
  "totalPassages": 2,
  "routes": [
   {
    "channel": "human-evie",
    "passages": 2,
    "share": 1.0,
    "first": "2020-10-21",
    "last": "2020-10-21",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "kaleb",
     "frau",
     "cruz",
     "mr_han_sr",
     "audrey",
     "richard_antore",
     "diana",
     "ares",
     "quincy_antore",
     "nereda",
     "elizabeth_the_third"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "kaleb",
   "frau",
   "cruz",
   "mr_han_sr",
   "audrey",
   "richard_antore",
   "diana",
   "ares",
   "quincy_antore",
   "nereda",
   "elizabeth_the_third"
  ]
 },
 "thor": {
  "canonRoute": "asgard",
  "totalPassages": 22,
  "routes": [
   {
    "channel": "asgard",
    "passages": 5,
    "share": 0.2273,
    "first": "2020-05-17",
    "last": "2020-05-19",
    "kind": "canon",
    "castWith": [
     "agnar",
     "agmund",
     "loki",
     "kya_sg3",
     "odin",
     "svira",
     "penelope_valk",
     "kya_sg1",
     "sif",
     "freya",
     "god",
     "frigg"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 5,
    "share": 0.2273,
    "first": "2016-09-30",
    "last": "2020-04-01",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika"
    ]
   },
   {
    "channel": "ooc",
    "passages": 3,
    "share": 0.1364,
    "first": "2020-05-08",
    "last": "2020-05-08",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "meeting-room",
    "passages": 3,
    "share": 0.1364,
    "first": "2020-03-31",
    "last": "2020-03-31",
    "kind": "route",
    "castWith": [
     "kaleb",
     "ezra",
     "kya_sg3",
     "raye",
     "evelyn",
     "alistair_turayne",
     "alistair",
     "mr_han_sr",
     "kya_sg1",
     "thorne",
     "prince_zain",
     "sune"
    ]
   },
   {
    "channel": "alistairs-familys-castle",
    "passages": 3,
    "share": 0.1364,
    "first": "2020-03-31",
    "last": "2020-04-03",
    "kind": "route",
    "castWith": [
     "thorne",
     "kaleb",
     "evelyn",
     "cruz",
     "ezra",
     "kya_sg3",
     "alistair",
     "alistair_turayne",
     "bryce",
     "kya_sg1",
     "hades",
     "asmodeus"
    ]
   },
   {
    "channel": "evelyn-college-2",
    "passages": 1,
    "share": 0.0455,
    "first": "2021-01-03",
    "last": "2021-01-03",
    "kind": "route",
    "castWith": [
     "evelyn",
     "darren",
     "dimitri",
     "lex",
     "hades",
     "raye",
     "jon",
     "ares",
     "kaleb",
     "cruz",
     "kya_sg3",
     "ari"
    ]
   },
   {
    "channel": "dorms",
    "passages": 1,
    "share": 0.0455,
    "first": "2020-05-08",
    "last": "2020-05-08",
    "kind": "route",
    "castWith": [
     "agnar",
     "kya_sg3",
     "agmund",
     "evelyn",
     "raye",
     "cole",
     "kya_sg1",
     "riku",
     "kaleb",
     "penelope_valk",
     "loki",
     "svira"
    ]
   },
   {
    "channel": "cell-block-tango",
    "passages": 1,
    "share": 0.0455,
    "first": "2020-03-30",
    "last": "2020-03-30",
    "kind": "route",
    "castWith": [
     "ezra",
     "kya_sg3",
     "alistair",
     "alistair_turayne",
     "evelyn",
     "bryce",
     "thorne",
     "kya_sg1",
     "kaleb",
     "cruz",
     "rika",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "agnar",
   "agmund",
   "loki",
   "kya_sg3",
   "odin",
   "svira",
   "penelope_valk",
   "kya_sg1",
   "sif",
   "freya",
   "god",
   "frigg"
  ]
 },
 "thorne": {
  "canonRoute": "alistairs-familys-castle",
  "totalPassages": 80,
  "routes": [
   {
    "channel": "alistairs-familys-castle",
    "passages": 35,
    "share": 0.4375,
    "first": "2020-03-31",
    "last": "2020-04-03",
    "kind": "canon",
    "castWith": [
     "kaleb",
     "evelyn",
     "cruz",
     "ezra",
     "kya_sg3",
     "alistair",
     "alistair_turayne",
     "bryce",
     "kya_sg1",
     "hades",
     "asmodeus",
     "thor"
    ]
   },
   {
    "channel": "pack-beachhouse",
    "passages": 16,
    "share": 0.2,
    "first": "2020-04-03",
    "last": "2020-04-03",
    "kind": "route",
    "castWith": [
     "asmodeus",
     "kaleb",
     "evelyn"
    ]
   },
   {
    "channel": "meeting-room",
    "passages": 14,
    "share": 0.175,
    "first": "2020-03-31",
    "last": "2020-03-31",
    "kind": "route",
    "castWith": [
     "kaleb",
     "ezra",
     "kya_sg3",
     "raye",
     "evelyn",
     "alistair_turayne",
     "alistair",
     "mr_han_sr",
     "kya_sg1",
     "prince_zain",
     "sune",
     "yuri_rekovich"
    ]
   },
   {
    "channel": "cell-block-tango",
    "passages": 8,
    "share": 0.1,
    "first": "2020-03-30",
    "last": "2020-03-30",
    "kind": "route",
    "castWith": [
     "ezra",
     "kya_sg3",
     "alistair",
     "alistair_turayne",
     "evelyn",
     "bryce",
     "kya_sg1",
     "kaleb",
     "cruz",
     "rika",
     "thor",
     "will"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 4,
    "share": 0.05,
    "first": "2020-03-31",
    "last": "2020-04-01",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika"
    ]
   },
   {
    "channel": "kya-christmas-special",
    "passages": 2,
    "share": 0.025,
    "first": "2022-12-25",
    "last": "2022-12-25",
    "kind": "route",
    "castWith": [
     "kya_sg3",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "sebastian_vamp",
     "sebastian_siren"
    ]
   },
   {
    "channel": "ooc",
    "passages": 1,
    "share": 0.0125,
    "first": "2020-06-09",
    "last": "2020-06-09",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   }
  ],
  "knownCharacters": [
   "kaleb",
   "evelyn",
   "cruz",
   "ezra",
   "kya_sg3",
   "alistair",
   "alistair_turayne",
   "bryce",
   "kya_sg1",
   "hades",
   "asmodeus",
   "thor"
  ]
 },
 "tina": {
  "canonRoute": "an-accidentally-valerian-summer-with-cordelia",
  "totalPassages": 6,
  "routes": [
   {
    "channel": "an-accidentally-valerian-summer-with-cordelia",
    "passages": 6,
    "share": 1.0,
    "first": "2021-04-23",
    "last": "2021-04-26",
    "kind": "canon",
    "castWith": [
     "ciel",
     "nolan",
     "lupe",
     "arsene",
     "delia",
     "dale",
     "jessica",
     "cruz",
     "clairette",
     "may",
     "cyrena",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "ciel",
   "nolan",
   "lupe",
   "arsene",
   "delia",
   "dale",
   "jessica",
   "cruz",
   "clairette",
   "may",
   "cyrena",
   "will"
  ]
 },
 "toko": {
  "canonRoute": "dimitri-castle",
  "totalPassages": 3,
  "routes": [
   {
    "channel": "dimitri-castle",
    "passages": 3,
    "share": 1.0,
    "first": "2020-07-15",
    "last": "2020-07-15",
    "kind": "canon",
    "castWith": [
     "dimitri",
     "evelyn",
     "stella",
     "ronin_tempus",
     "kaleb",
     "melisende",
     "mr_han_sr",
     "gambit",
     "frau",
     "silas_mirace",
     "theo_uoki",
     "raye"
    ]
   }
  ],
  "knownCharacters": [
   "dimitri",
   "evelyn",
   "stella",
   "ronin_tempus",
   "kaleb",
   "melisende",
   "mr_han_sr",
   "gambit",
   "frau",
   "silas_mirace",
   "theo_uoki",
   "raye"
  ]
 },
 "tom": {
  "canonRoute": "theo-uoki-castle",
  "totalPassages": 8,
  "routes": [
   {
    "channel": "theo-uoki-castle",
    "passages": 4,
    "share": 0.5,
    "first": "2020-04-03",
    "last": "2020-04-03",
    "kind": "canon",
    "castWith": [
     "stella",
     "theo_uoki",
     "raze",
     "melisende",
     "frank",
     "yuu",
     "silas_mirace",
     "vincent",
     "ronin_tempus"
    ]
   },
   {
    "channel": "cupid-hq",
    "passages": 2,
    "share": 0.25,
    "first": "2020-06-03",
    "last": "2020-06-03",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "sabrina_witch",
     "tim",
     "drake",
     "halo",
     "god",
     "aphrodite",
     "pam",
     "stan",
     "hiro",
     "ares",
     "hades"
    ]
   },
   {
    "channel": "euro-prince-boy",
    "passages": 1,
    "share": 0.125,
    "first": "2024-08-28",
    "last": "2024-08-28",
    "kind": "route",
    "castWith": [
     "dimitri",
     "hades",
     "lex",
     "roman",
     "hera",
     "may",
     "troy",
     "will",
     "zeus"
    ]
   },
   {
    "channel": "mm_chatroom",
    "passages": 1,
    "share": 0.125,
    "first": "2020-03-21",
    "last": "2020-03-21",
    "kind": "route",
    "castWith": [
     "kaleb",
     "evelyn",
     "rika",
     "mr_han_sr",
     "cruz",
     "elizabeth_the_third",
     "god",
     "mr_clien",
     "bryce",
     "ever",
     "marie_antoinette"
    ]
   }
  ],
  "knownCharacters": [
   "stella",
   "theo_uoki",
   "raze",
   "melisende",
   "frank",
   "yuu",
   "silas_mirace",
   "vincent",
   "ronin_tempus"
  ]
 },
 "topps": {
  "canonRoute": "human-not-human",
  "totalPassages": 3,
  "routes": [
   {
    "channel": "human-not-human",
    "passages": 3,
    "share": 1.0,
    "first": "2022-10-17",
    "last": "2022-10-17",
    "kind": "canon",
    "castWith": [
     "dillon",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "sebastian_vamp",
     "drisella",
     "god",
     "blair",
     "madeline",
     "tanya",
     "starlet",
     "ever"
    ]
   }
  ],
  "knownCharacters": [
   "dillon",
   "kya_sg3",
   "kya_sg1",
   "sebastian_siren",
   "sebastian_vamp",
   "drisella",
   "god",
   "blair",
   "madeline",
   "tanya",
   "starlet",
   "ever"
  ]
 },
 "toren": {
  "canonRoute": "mystery-do-over",
  "totalPassages": 3,
  "routes": [
   {
    "channel": "mystery-do-over",
    "passages": 3,
    "share": 1.0,
    "first": "2024-02-06",
    "last": "2024-02-06",
    "kind": "canon",
    "castWith": [
     "dillon",
     "kaleb",
     "york",
     "evelyn",
     "becca",
     "camren",
     "kya_sg3",
     "kya_sg1",
     "uncle_khan"
    ]
   }
  ],
  "knownCharacters": [
   "dillon",
   "kaleb",
   "york",
   "evelyn",
   "becca",
   "camren",
   "kya_sg3",
   "kya_sg1",
   "uncle_khan"
  ]
 },
 "trace_spellbook": {
  "canonRoute": "don\u2019t-buy-me-love",
  "totalPassages": 28,
  "routes": [
   {
    "channel": "don\u2019t-buy-me-love",
    "passages": 28,
    "share": 1.0,
    "first": "2023-12-20",
    "last": "2023-12-28",
    "kind": "canon",
    "castWith": [
     "ezra",
     "primrose",
     "madison_astor",
     "kya_sg3",
     "kya_sg1",
     "dimitri",
     "hades",
     "evelyn",
     "junta",
     "jane",
     "may",
     "reginald"
    ]
   }
  ],
  "knownCharacters": [
   "ezra",
   "primrose",
   "madison_astor",
   "kya_sg3",
   "kya_sg1",
   "dimitri",
   "hades",
   "evelyn",
   "junta",
   "jane",
   "may",
   "reginald"
  ]
 },
 "trace_renton": {
  "canonRoute": "to-the-max",
  "totalPassages": 13,
  "routes": [
   {
    "channel": "to-the-max",
    "passages": 13,
    "share": 1.0,
    "first": "2023-05-16",
    "last": "2023-05-29",
    "kind": "canon",
    "castWith": [
     "maxen_bryers",
     "addison",
     "kya_sg3",
     "kya_sg1",
     "rick",
     "evelyn",
     "beatrice",
     "dillon",
     "budd",
     "lore",
     "paula",
     "diana"
    ]
   }
  ],
  "knownCharacters": [
   "maxen_bryers",
   "addison",
   "kya_sg3",
   "kya_sg1",
   "rick",
   "evelyn",
   "beatrice",
   "dillon",
   "budd",
   "lore",
   "paula",
   "diana"
  ]
 },
 "tracy_wethering": {
  "canonRoute": "human-not-human",
  "totalPassages": 1,
  "routes": [
   {
    "channel": "human-not-human",
    "passages": 1,
    "share": 1.0,
    "first": "2022-10-16",
    "last": "2022-10-16",
    "kind": "canon",
    "castWith": [
     "dillon",
     "kya_sg3",
     "kya_sg1",
     "sebastian_siren",
     "sebastian_vamp",
     "drisella",
     "god",
     "blair",
     "madeline",
     "tanya",
     "topps",
     "starlet"
    ]
   }
  ],
  "knownCharacters": [
   "dillon",
   "kya_sg3",
   "kya_sg1",
   "sebastian_siren",
   "sebastian_vamp",
   "drisella",
   "god",
   "blair",
   "madeline",
   "tanya",
   "topps",
   "starlet"
  ]
 },
 "troy": {
  "canonRoute": "cruz-x-human",
  "totalPassages": 14,
  "routes": [
   {
    "channel": "cruz-x-human",
    "passages": 11,
    "share": 0.7857,
    "first": "2021-04-26",
    "last": "2021-04-26",
    "kind": "canon",
    "castWith": [
     "cruz",
     "skye",
     "nolan",
     "ryder",
     "audrey",
     "adrien",
     "bryce",
     "airi",
     "natasha",
     "diana",
     "will",
     "allie"
    ]
   },
   {
    "channel": "lachesis-off-the-rails",
    "passages": 1,
    "share": 0.0714,
    "first": "2025-08-25",
    "last": "2025-08-25",
    "kind": "route",
    "castWith": [
     "lance",
     "vaughn",
     "brax",
     "lucifer",
     "james",
     "atropos",
     "cruz",
     "lachesis",
     "ace",
     "lindon",
     "hades",
     "ezra"
    ]
   },
   {
    "channel": "euro-prince-boy",
    "passages": 1,
    "share": 0.0714,
    "first": "2024-07-05",
    "last": "2024-07-05",
    "kind": "route",
    "castWith": [
     "dimitri",
     "hades",
     "lex",
     "roman",
     "hera",
     "may",
     "tom",
     "will",
     "zeus"
    ]
   },
   {
    "channel": "ooc",
    "passages": 1,
    "share": 0.0714,
    "first": "2020-05-08",
    "last": "2020-05-08",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   }
  ],
  "knownCharacters": [
   "cruz",
   "skye",
   "nolan",
   "ryder",
   "audrey",
   "adrien",
   "bryce",
   "airi",
   "natasha",
   "diana",
   "will",
   "allie"
  ]
 },
 "tyrion": {
  "canonRoute": "val",
  "totalPassages": 23,
  "routes": [
   {
    "channel": "val",
    "passages": 22,
    "share": 0.9565,
    "first": "2020-12-03",
    "last": "2020-12-26",
    "kind": "canon",
    "castWith": [
     "val",
     "kya_sg3",
     "kaleb",
     "alistair",
     "alistair_turayne",
     "kya_sg1",
     "evelyn",
     "vanessa",
     "ezra",
     "raye",
     "alan",
     "mr_han_sr"
    ]
   },
   {
    "channel": "kya-war-au",
    "passages": 1,
    "share": 0.0435,
    "first": "2021-12-02",
    "last": "2021-12-02",
    "kind": "au",
    "castWith": [
     "ezra",
     "kya_sg3",
     "james",
     "val",
     "kya_sg1",
     "vanessa",
     "kaleb",
     "raye",
     "sebastian_vamp",
     "sebastian_siren",
     "lily",
     "junta"
    ]
   }
  ],
  "knownCharacters": [
   "val",
   "kya_sg3",
   "kaleb",
   "alistair",
   "alistair_turayne",
   "kya_sg1",
   "evelyn",
   "vanessa",
   "ezra",
   "raye",
   "alan",
   "mr_han_sr"
  ]
 },
 "umu": {
  "canonRoute": "kya-sold-off",
  "totalPassages": 10,
  "routes": [
   {
    "channel": "kya-sold-off",
    "passages": 10,
    "share": 1.0,
    "first": "2021-07-15",
    "last": "2021-07-15",
    "kind": "canon",
    "castWith": [
     "leiden",
     "melody",
     "callan",
     "kya_sg3",
     "frank",
     "kya_sg1",
     "evelyn",
     "kaleb",
     "garrett",
     "god",
     "may",
     "will"
    ]
   }
  ],
  "knownCharacters": [
   "leiden",
   "melody",
   "callan",
   "kya_sg3",
   "frank",
   "kya_sg1",
   "evelyn",
   "kaleb",
   "garrett",
   "god",
   "may",
   "will"
  ]
 },
 "uri": {
  "canonRoute": "dimitri-route-end",
  "totalPassages": 80,
  "routes": [
   {
    "channel": "dimitri-route-end",
    "passages": 70,
    "share": 0.875,
    "first": "2021-02-08",
    "last": "2021-02-16",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "dimitri",
     "gambit",
     "jones",
     "ares",
     "bryce",
     "kaleb",
     "frau",
     "mr_han_sr",
     "zeus",
     "kya_sg3",
     "uncle_khan"
    ]
   },
   {
    "channel": "nicoles-wish-brax-brother",
    "passages": 9,
    "share": 0.1125,
    "first": "2023-05-19",
    "last": "2023-05-22",
    "kind": "route",
    "castWith": [
     "ford",
     "cruz",
     "brax",
     "lance",
     "dimitri",
     "hades",
     "vaughn",
     "rowan",
     "nicole_human",
     "audrey",
     "diana",
     "evelyn"
    ]
   },
   {
    "channel": "ww-war-au",
    "passages": 1,
    "share": 0.0125,
    "first": "2021-11-29",
    "last": "2021-11-29",
    "kind": "au",
    "castWith": [
     "evelyn",
     "cruz",
     "ace",
     "ezra",
     "lindon",
     "kaleb",
     "rowan",
     "bryce",
     "lance",
     "raye",
     "nolan",
     "primrose"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "dimitri",
   "gambit",
   "jones",
   "ares",
   "bryce",
   "kaleb",
   "frau",
   "mr_han_sr",
   "zeus",
   "kya_sg3",
   "uncle_khan"
  ]
 },
 "vincent": {
  "canonRoute": "troterra-kingdom",
  "totalPassages": 14,
  "routes": [
   {
    "channel": "ooc-gen",
    "passages": 4,
    "share": 0.2857,
    "first": "2020-04-07",
    "last": "2020-06-02",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "troterra-kingdom",
    "passages": 4,
    "share": 0.2857,
    "first": "2020-04-05",
    "last": "2020-04-07",
    "kind": "canon",
    "castWith": [
     "stella",
     "ronin_tempus",
     "raze",
     "talon_char",
     "melisende",
     "dimitri",
     "satella",
     "silas_mirace",
     "exis",
     "god",
     "may",
     "mikaela_hyakuya"
    ]
   },
   {
    "channel": "theo-uoki-castle",
    "passages": 3,
    "share": 0.2143,
    "first": "2020-04-03",
    "last": "2020-04-03",
    "kind": "route",
    "castWith": [
     "stella",
     "theo_uoki",
     "raze",
     "melisende",
     "frank",
     "tom",
     "yuu",
     "silas_mirace",
     "ronin_tempus"
    ]
   },
   {
    "channel": "dimitri-castle",
    "passages": 2,
    "share": 0.1429,
    "first": "2020-04-06",
    "last": "2020-04-06",
    "kind": "route",
    "castWith": [
     "dimitri",
     "evelyn",
     "stella",
     "ronin_tempus",
     "kaleb",
     "melisende",
     "mr_han_sr",
     "gambit",
     "frau",
     "silas_mirace",
     "theo_uoki",
     "toko"
    ]
   },
   {
    "channel": "prince-char-bios",
    "passages": 1,
    "share": 0.0714,
    "first": "2020-05-22",
    "last": "2020-05-22",
    "kind": "route",
    "castWith": [
     "ronin_tempus",
     "stella",
     "dimitri",
     "talon_char",
     "melisende",
     "mikaela_hyakuya",
     "raze",
     "silas_mirace",
     "theo_uoki",
     "yuu"
    ]
   }
  ],
  "knownCharacters": [
   "stella",
   "ronin_tempus",
   "raze",
   "talon_char",
   "melisende",
   "dimitri",
   "satella",
   "silas_mirace",
   "exis",
   "god",
   "may",
   "mikaela_hyakuya"
  ]
 },
 "victor": {
  "canonRoute": "the-great-husbando-race",
  "totalPassages": 12,
  "routes": [
   {
    "channel": "ooc",
    "passages": 4,
    "share": 0.3333,
    "first": "2020-04-18",
    "last": "2020-05-19",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 3,
    "share": 0.25,
    "first": "2020-03-20",
    "last": "2020-03-22",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika"
    ]
   },
   {
    "channel": "the-great-husbando-race",
    "passages": 2,
    "share": 0.1667,
    "first": "2020-06-03",
    "last": "2020-07-08",
    "kind": "canon",
    "castWith": [
     "kira",
     "ray",
     "leon",
     "cupid_eros",
     "loki",
     "riku",
     "evelyn",
     "junta",
     "ben",
     "hyun_ryu",
     "jack",
     "kent"
    ]
   },
   {
    "channel": "general",
    "passages": 1,
    "share": 0.0833,
    "first": "2020-08-18",
    "last": "2020-08-18",
    "kind": "ooc",
    "castWith": [
     "ezra",
     "eric",
     "cruz",
     "james",
     "apollo",
     "lance",
     "aaron",
     "silas_mirace",
     "raye",
     "moros",
     "ace",
     "kaleb"
    ]
   },
   {
    "channel": "spam",
    "passages": 1,
    "share": 0.0833,
    "first": "2020-04-22",
    "last": "2020-04-22",
    "kind": "route",
    "castWith": [
     "cruz",
     "ezra",
     "ace",
     "hiro",
     "dike"
    ]
   },
   {
    "channel": "troterra-kingdom",
    "passages": 1,
    "share": 0.0833,
    "first": "2020-04-08",
    "last": "2020-04-08",
    "kind": "route",
    "castWith": [
     "stella",
     "ronin_tempus",
     "raze",
     "talon_char",
     "melisende",
     "dimitri",
     "satella",
     "silas_mirace",
     "vincent",
     "exis",
     "god",
     "may"
    ]
   }
  ],
  "knownCharacters": [
   "kira",
   "ray",
   "leon",
   "cupid_eros",
   "loki",
   "riku",
   "evelyn",
   "junta",
   "ben",
   "hyun_ryu",
   "jack",
   "kent"
  ]
 },
 "will": {
  "canonRoute": "immortuos",
  "totalPassages": 299,
  "routes": [
   {
    "channel": "immortuos",
    "passages": 23,
    "share": 0.0769,
    "first": "2021-12-11",
    "last": "2021-12-16",
    "kind": "canon",
    "castWith": [
     "val",
     "james",
     "vanessa",
     "kya_sg3",
     "kya_sg1",
     "sebastian_vamp",
     "sebastian_siren",
     "junta",
     "kaleb",
     "aurelia",
     "may",
     "tim"
    ]
   },
   {
    "channel": "evelyn-college-2",
    "passages": 9,
    "share": 0.0301,
    "first": "2021-01-04",
    "last": "2021-01-28",
    "kind": "route",
    "castWith": [
     "evelyn",
     "darren",
     "dimitri",
     "lex",
     "hades",
     "raye",
     "jon",
     "ares",
     "kaleb",
     "cruz",
     "kya_sg3",
     "ari"
    ]
   },
   {
    "channel": "ooc",
    "passages": 9,
    "share": 0.0301,
    "first": "2020-04-16",
    "last": "2020-12-16",
    "kind": "ooc",
    "castWith": [
     "rowan",
     "ezra",
     "cruz",
     "lucius",
     "evelyn",
     "kaleb",
     "eric",
     "raye",
     "bryce",
     "darren",
     "lex",
     "rex"
    ]
   },
   {
    "channel": "out_of_character",
    "passages": 8,
    "share": 0.0268,
    "first": "2016-09-13",
    "last": "2020-07-23",
    "kind": "ooc",
    "castWith": [
     "kaleb",
     "cruz",
     "bryce",
     "evelyn",
     "ezra",
     "raye",
     "eric",
     "libion",
     "dimitri",
     "hades",
     "god",
     "rika"
    ]
   },
   {
    "channel": "kya-werewolf",
    "passages": 7,
    "share": 0.0234,
    "first": "2021-08-24",
    "last": "2021-09-26",
    "kind": "route",
    "castWith": [
     "jace",
     "raphael",
     "trey",
     "dillon",
     "kya_sg3",
     "scott",
     "kya_sg1",
     "ezra",
     "sebastian_siren",
     "kaleb",
     "sebastian_vamp",
     "evelyn"
    ]
   },
   {
    "channel": "frau-collin",
    "passages": 7,
    "share": 0.0234,
    "first": "2020-04-16",
    "last": "2020-12-26",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "rowan",
     "frau",
     "collin_keller",
     "arland_rees",
     "ezra",
     "felix_fairy",
     "rikki",
     "park",
     "alyce_char",
     "myra"
    ]
   },
   {
    "channel": "trix-villainous",
    "passages": 5,
    "share": 0.0167,
    "first": "2024-01-24",
    "last": "2025-02-04",
    "kind": "route",
    "castWith": [
     "cruz",
     "brax",
     "ryder",
     "ford",
     "vaughn",
     "lance",
     "bryce",
     "shane",
     "dimitri",
     "allie",
     "micah",
     "audrey"
    ]
   },
   {
    "channel": "an-accidentally-valerian-summer-with-cordelia",
    "passages": 5,
    "share": 0.0167,
    "first": "2021-03-09",
    "last": "2021-05-16",
    "kind": "route",
    "castWith": [
     "ciel",
     "nolan",
     "lupe",
     "arsene",
     "delia",
     "dale",
     "jessica",
     "cruz",
     "clairette",
     "may",
     "tina",
     "cyrena"
    ]
   },
   {
    "channel": "northwest-pack-lodge",
    "passages": 5,
    "share": 0.0167,
    "first": "2020-04-15",
    "last": "2020-04-28",
    "kind": "route",
    "castWith": [
     "rowan",
     "evelyn",
     "lucius",
     "nellie",
     "myra",
     "cruz",
     "bryce",
     "dimitri",
     "kaleb",
     "rio",
     "may",
     "mr_han_sr"
    ]
   },
   {
    "channel": "plz-love-lachesis",
    "passages": 4,
    "share": 0.0134,
    "first": "2022-11-13",
    "last": "2022-11-18",
    "kind": "route",
    "castWith": [
     "lachesis",
     "ramiel",
     "lance",
     "god",
     "lucifer",
     "apollo",
     "levi",
     "aion",
     "atropos",
     "zeus",
     "zadkiel",
     "clothos"
    ]
   },
   {
    "channel": "lance-mating",
    "passages": 4,
    "share": 0.0134,
    "first": "2021-08-22",
    "last": "2021-09-08",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "clothos",
     "ryder",
     "hades",
     "nolan",
     "nicole_human",
     "audrey",
     "moros",
     "atropos",
     "nicole_wolf"
    ]
   },
   {
    "channel": "lets-abduct-evie",
    "passages": 4,
    "share": 0.0134,
    "first": "2021-06-28",
    "last": "2021-07-23",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "ryoto",
     "dodge",
     "ms_tia",
     "kaleb",
     "frau",
     "aki",
     "cruz",
     "talbot",
     "ares",
     "zeus"
    ]
   }
  ],
  "knownCharacters": [
   "val",
   "james",
   "vanessa",
   "kya_sg3",
   "kya_sg1",
   "sebastian_vamp",
   "sebastian_siren",
   "junta",
   "kaleb",
   "aurelia",
   "may",
   "tim"
  ]
 },
 "willie": {
  "canonRoute": "high-school-ezra-kya",
  "totalPassages": 5,
  "routes": [
   {
    "channel": "high-school-ezra-kya",
    "passages": 5,
    "share": 1.0,
    "first": "2021-02-24",
    "last": "2021-02-25",
    "kind": "canon",
    "castWith": [
     "ezra",
     "kya_sg3",
     "maria",
     "rachel",
     "kaleb",
     "kya_sg1",
     "evelyn",
     "jane",
     "primrose",
     "lily",
     "ace",
     "uncle_khan"
    ]
   }
  ],
  "knownCharacters": [
   "ezra",
   "kya_sg3",
   "maria",
   "rachel",
   "kaleb",
   "kya_sg1",
   "evelyn",
   "jane",
   "primrose",
   "lily",
   "ace",
   "uncle_khan"
  ]
 },
 "wyatt": {
  "canonRoute": "cruz-is-not-dead",
  "totalPassages": 3,
  "routes": [
   {
    "channel": "cruz-is-not-dead",
    "passages": 3,
    "share": 1.0,
    "first": "2022-04-13",
    "last": "2022-04-14",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "cruz",
     "ford",
     "ryder",
     "lucifer",
     "bryce",
     "audrey",
     "apollo",
     "ares",
     "god",
     "clint",
     "hades"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "cruz",
   "ford",
   "ryder",
   "lucifer",
   "bryce",
   "audrey",
   "apollo",
   "ares",
   "god",
   "clint",
   "hades"
  ]
 },
 "xavier": {
  "canonRoute": "reed-vamp-werecheetah",
  "totalPassages": 1,
  "routes": [
   {
    "channel": "reed-vamp-werecheetah",
    "passages": 1,
    "share": 1.0,
    "first": "2023-11-16",
    "last": "2023-11-16",
    "kind": "canon",
    "castWith": [
     "reed",
     "madison_astor",
     "kale",
     "raye",
     "arnold_astor",
     "may",
     "paul",
     "zeke"
    ]
   }
  ],
  "knownCharacters": [
   "reed",
   "madison_astor",
   "kale",
   "raye",
   "arnold_astor",
   "may",
   "paul",
   "zeke"
  ]
 },
 "york": {
  "canonRoute": "mystery-do-over",
  "totalPassages": 15,
  "routes": [
   {
    "channel": "mystery-do-over",
    "passages": 15,
    "share": 1.0,
    "first": "2024-02-05",
    "last": "2024-02-10",
    "kind": "canon",
    "castWith": [
     "dillon",
     "kaleb",
     "evelyn",
     "becca",
     "camren",
     "toren",
     "kya_sg3",
     "kya_sg1",
     "uncle_khan"
    ]
   }
  ],
  "knownCharacters": [
   "dillon",
   "kaleb",
   "evelyn",
   "becca",
   "camren",
   "toren",
   "kya_sg3",
   "kya_sg1",
   "uncle_khan"
  ]
 },
 "yuri_rekovich": {
  "canonRoute": "kya-castle",
  "totalPassages": 38,
  "routes": [
   {
    "channel": "kya-castle",
    "passages": 27,
    "share": 0.7105,
    "first": "2020-07-28",
    "last": "2020-08-01",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "kya_sg3",
     "sebastian_vamp",
     "sebastian_siren",
     "kaleb",
     "skipper",
     "kya_sg1",
     "mr_han_sr",
     "will",
     "frau"
    ]
   },
   {
    "channel": "meeting-room",
    "passages": 7,
    "share": 0.1842,
    "first": "2020-07-31",
    "last": "2020-07-31",
    "kind": "route",
    "castWith": [
     "kaleb",
     "ezra",
     "kya_sg3",
     "raye",
     "evelyn",
     "alistair_turayne",
     "alistair",
     "mr_han_sr",
     "kya_sg1",
     "thorne",
     "prince_zain",
     "sune"
    ]
   },
   {
    "channel": "ace-route",
    "passages": 2,
    "share": 0.0526,
    "first": "2020-08-28",
    "last": "2020-08-28",
    "kind": "route",
    "castWith": [
     "evelyn",
     "ace",
     "ezra",
     "sebastian_vamp",
     "sebastian_siren",
     "kaleb",
     "kya_sg3",
     "kya_sg1",
     "felix_fairy",
     "mr_han_sr",
     "frau",
     "rosie"
    ]
   },
   {
    "channel": "general",
    "passages": 1,
    "share": 0.0263,
    "first": "2020-07-31",
    "last": "2020-07-31",
    "kind": "ooc",
    "castWith": [
     "ezra",
     "eric",
     "cruz",
     "james",
     "apollo",
     "lance",
     "aaron",
     "silas_mirace",
     "raye",
     "moros",
     "ace",
     "kaleb"
    ]
   },
   {
    "channel": "bios",
    "passages": 1,
    "share": 0.0263,
    "first": "2020-07-31",
    "last": "2020-07-31",
    "kind": "route",
    "castWith": [
     "cupid_eros",
     "evelyn",
     "lucius",
     "athena",
     "bryce",
     "val",
     "hiro",
     "raz",
     "rex",
     "vanessa",
     "halo",
     "dalton"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "kya_sg3",
   "sebastian_vamp",
   "sebastian_siren",
   "kaleb",
   "skipper",
   "kya_sg1",
   "mr_han_sr",
   "will",
   "frau"
  ]
 },
 "yuu": {
  "canonRoute": "mikaera-hyakuya-castle",
  "totalPassages": 33,
  "routes": [
   {
    "channel": "mikaera-hyakuya-castle",
    "passages": 19,
    "share": 0.5758,
    "first": "2020-04-02",
    "last": "2020-04-02",
    "kind": "canon",
    "castWith": [
     "stella",
     "melisende",
     "raze",
     "may"
    ]
   },
   {
    "channel": "ooc-gen",
    "passages": 5,
    "share": 0.1515,
    "first": "2020-04-02",
    "last": "2020-04-02",
    "kind": "ooc",
    "castWith": [
     "stella",
     "bryce",
     "talon_char",
     "ronin_tempus",
     "aria",
     "dimitri",
     "evelyn",
     "rio",
     "kaleb",
     "bennett",
     "geo",
     "cruz"
    ]
   },
   {
    "channel": "theo-uoki-castle",
    "passages": 4,
    "share": 0.1212,
    "first": "2020-04-03",
    "last": "2020-04-03",
    "kind": "route",
    "castWith": [
     "stella",
     "theo_uoki",
     "raze",
     "melisende",
     "frank",
     "tom",
     "silas_mirace",
     "vincent",
     "ronin_tempus"
    ]
   },
   {
    "channel": "prince-char-bios",
    "passages": 2,
    "share": 0.0606,
    "first": "2020-04-01",
    "last": "2020-05-21",
    "kind": "route",
    "castWith": [
     "ronin_tempus",
     "stella",
     "dimitri",
     "talon_char",
     "melisende",
     "mikaela_hyakuya",
     "raze",
     "silas_mirace",
     "theo_uoki",
     "vincent"
    ]
   },
   {
    "channel": "country-road-take-me-home",
    "passages": 2,
    "share": 0.0606,
    "first": "2020-04-12",
    "last": "2020-04-12",
    "kind": "route",
    "castWith": [
     "stella",
     "ronin_tempus",
     "talon_char",
     "melisende",
     "dimitri",
     "raze",
     "exis",
     "god",
     "will"
    ]
   },
   {
    "channel": "dimitri-castle",
    "passages": 1,
    "share": 0.0303,
    "first": "2020-04-07",
    "last": "2020-04-07",
    "kind": "route",
    "castWith": [
     "dimitri",
     "evelyn",
     "stella",
     "ronin_tempus",
     "kaleb",
     "melisende",
     "mr_han_sr",
     "gambit",
     "frau",
     "silas_mirace",
     "theo_uoki",
     "toko"
    ]
   }
  ],
  "knownCharacters": [
   "stella",
   "melisende",
   "raze",
   "may"
  ]
 },
 "zadkiel": {
  "canonRoute": "plz-love-lachesis",
  "totalPassages": 9,
  "routes": [
   {
    "channel": "plz-love-lachesis",
    "passages": 9,
    "share": 1.0,
    "first": "2022-11-11",
    "last": "2022-11-14",
    "kind": "canon",
    "castWith": [
     "lachesis",
     "ramiel",
     "lance",
     "god",
     "lucifer",
     "apollo",
     "levi",
     "aion",
     "atropos",
     "zeus",
     "clothos",
     "asrius"
    ]
   }
  ],
  "knownCharacters": [
   "lachesis",
   "ramiel",
   "lance",
   "god",
   "lucifer",
   "apollo",
   "levi",
   "aion",
   "atropos",
   "zeus",
   "clothos",
   "asrius"
  ]
 },
 "zain_demigod": {
  "canonRoute": "kinley-is-a-nondecisive-butt",
  "totalPassages": 64,
  "routes": [
   {
    "channel": "kinley-is-a-nondecisive-butt",
    "passages": 55,
    "share": 0.8594,
    "first": "2022-03-24",
    "last": "2022-04-06",
    "kind": "canon",
    "castWith": [
     "kinley",
     "apollo",
     "lex",
     "cupid_eros",
     "hera",
     "lachesis",
     "sebastian_vamp",
     "sebastian_siren",
     "ben",
     "god",
     "will",
     "zeus"
    ]
   },
   {
    "channel": "kinley-reset-route",
    "passages": 9,
    "share": 0.1406,
    "first": "2022-02-24",
    "last": "2022-02-26",
    "kind": "route",
    "castWith": [
     "kinley",
     "lander",
     "shadow",
     "tate",
     "aaron",
     "raye",
     "natalia",
     "apollo",
     "crom",
     "god",
     "jova",
     "aphrodite"
    ]
   }
  ],
  "knownCharacters": [
   "kinley",
   "apollo",
   "lex",
   "cupid_eros",
   "hera",
   "lachesis",
   "sebastian_vamp",
   "sebastian_siren",
   "ben",
   "god",
   "will",
   "zeus"
  ]
 },
 "prince_zain": {
  "canonRoute": "meeting-room",
  "totalPassages": 9,
  "routes": [
   {
    "channel": "meeting-room",
    "passages": 9,
    "share": 1.0,
    "first": "2020-07-30",
    "last": "2020-07-31",
    "kind": "canon",
    "castWith": [
     "kaleb",
     "ezra",
     "kya_sg3",
     "raye",
     "evelyn",
     "alistair_turayne",
     "alistair",
     "mr_han_sr",
     "kya_sg1",
     "thorne",
     "sune",
     "yuri_rekovich"
    ]
   }
  ],
  "knownCharacters": [
   "kaleb",
   "ezra",
   "kya_sg3",
   "raye",
   "evelyn",
   "alistair_turayne",
   "alistair",
   "mr_han_sr",
   "kya_sg1",
   "thorne",
   "sune",
   "yuri_rekovich"
  ]
 },
 "zander": {
  "canonRoute": "kya-college-2",
  "totalPassages": 91,
  "routes": [
   {
    "channel": "kya-college-2",
    "passages": 91,
    "share": 1.0,
    "first": "2021-01-21",
    "last": "2021-01-28",
    "kind": "canon",
    "castWith": [
     "lily",
     "kya_sg3",
     "kya_sg1",
     "ari",
     "sebastian_siren",
     "raye",
     "prince_zed",
     "sebastian_vamp",
     "midori_naga",
     "penelope_valk",
     "bell_lily_of_fell",
     "agnar"
    ]
   }
  ],
  "knownCharacters": [
   "lily",
   "kya_sg3",
   "kya_sg1",
   "ari",
   "sebastian_siren",
   "raye",
   "prince_zed",
   "sebastian_vamp",
   "midori_naga",
   "penelope_valk",
   "bell_lily_of_fell",
   "agnar"
  ]
 },
 "zantium": {
  "canonRoute": "evel-icole-x-ethan",
  "totalPassages": 5,
  "routes": [
   {
    "channel": "evel-icole-x-ethan",
    "passages": 5,
    "share": 1.0,
    "first": "2020-10-31",
    "last": "2020-11-01",
    "kind": "canon",
    "castWith": [
     "ezra",
     "evelyn",
     "ethan",
     "kaleb",
     "alistair",
     "alistair_turayne",
     "kya_sg3",
     "ace",
     "nicole_human",
     "bryce",
     "mr_han_sr",
     "kya_sg1"
    ]
   }
  ],
  "knownCharacters": [
   "ezra",
   "evelyn",
   "ethan",
   "kaleb",
   "alistair",
   "alistair_turayne",
   "kya_sg3",
   "ace",
   "nicole_human",
   "bryce",
   "mr_han_sr",
   "kya_sg1"
  ]
 },
 "zane": {
  "canonRoute": null,
  "totalPassages": 1,
  "routes": [
   {
    "channel": "ww-war-au",
    "passages": 1,
    "share": 1.0,
    "first": "2021-11-20",
    "last": "2021-11-20",
    "kind": "au",
    "castWith": [
     "evelyn",
     "cruz",
     "ace",
     "ezra",
     "lindon",
     "kaleb",
     "rowan",
     "bryce",
     "lance",
     "raye",
     "nolan",
     "primrose"
    ]
   }
  ],
  "knownCharacters": []
 },
 "zeke": {
  "canonRoute": "reed-vamp-werecheetah",
  "totalPassages": 1,
  "routes": [
   {
    "channel": "reed-vamp-werecheetah",
    "passages": 1,
    "share": 1.0,
    "first": "2023-11-16",
    "last": "2023-11-16",
    "kind": "canon",
    "castWith": [
     "reed",
     "madison_astor",
     "kale",
     "raye",
     "arnold_astor",
     "may",
     "paul",
     "xavier"
    ]
   }
  ],
  "knownCharacters": [
   "reed",
   "madison_astor",
   "kale",
   "raye",
   "arnold_astor",
   "may",
   "paul",
   "xavier"
  ]
 },
 "zerden": {
  "canonRoute": "mt-olympus",
  "totalPassages": 5,
  "routes": [
   {
    "channel": "mt-olympus",
    "passages": 5,
    "share": 1.0,
    "first": "2020-06-23",
    "last": "2020-06-24",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "libion",
     "ares",
     "rex",
     "persephone",
     "bion",
     "hades",
     "aphrodite",
     "hercules",
     "demeter",
     "zeus",
     "athena"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "libion",
   "ares",
   "rex",
   "persephone",
   "bion",
   "hades",
   "aphrodite",
   "hercules",
   "demeter",
   "zeus",
   "athena"
  ]
 },
 "zeus": {
  "canonRoute": "1-real-cruz",
  "totalPassages": 203,
  "routes": [
   {
    "channel": "1-real-cruz",
    "passages": 36,
    "share": 0.1773,
    "first": "2023-01-09",
    "last": "2023-01-23",
    "kind": "canon",
    "castWith": [
     "evelyn",
     "cruz",
     "bryce",
     "ares",
     "lance",
     "selma",
     "lindon",
     "hera",
     "ryder",
     "apollo",
     "nolan",
     "diana"
    ]
   },
   {
    "channel": "ocroute2-cruz-in-for-love",
    "passages": 26,
    "share": 0.1281,
    "first": "2022-02-07",
    "last": "2022-02-12",
    "kind": "route",
    "castWith": [
     "evelyn",
     "cruz",
     "dimitri",
     "hades",
     "hera",
     "aphrodite",
     "god",
     "bryce",
     "amanda",
     "lachesis",
     "hermes",
     "nolan"
    ]
   },
   {
    "channel": "atropos-reincarnated",
    "passages": 17,
    "share": 0.0837,
    "first": "2022-06-12",
    "last": "2022-06-30",
    "kind": "route",
    "castWith": [
     "moros",
     "apollo",
     "haley_wolf",
     "atropos",
     "zephyr",
     "dante",
     "lachesis",
     "clothos",
     "aphrodite",
     "hera",
     "haley_human",
     "nicole_human"
    ]
   },
   {
    "channel": "plz-love-lachesis",
    "passages": 11,
    "share": 0.0542,
    "first": "2022-11-11",
    "last": "2022-11-23",
    "kind": "route",
    "castWith": [
     "lachesis",
     "ramiel",
     "lance",
     "god",
     "lucifer",
     "apollo",
     "levi",
     "aion",
     "atropos",
     "zadkiel",
     "clothos",
     "asrius"
    ]
   },
   {
    "channel": "haggle-for-the-girl",
    "passages": 10,
    "share": 0.0493,
    "first": "2024-01-01",
    "last": "2024-01-20",
    "kind": "route",
    "castWith": [
     "lachesis",
     "lucifer",
     "asrius",
     "god",
     "lonnie",
     "ramiel",
     "gabriel",
     "lance",
     "hades",
     "alyk",
     "aphrodite",
     "atropos"
    ]
   },
   {
    "channel": "lets-abduct-evie",
    "passages": 10,
    "share": 0.0493,
    "first": "2021-07-15",
    "last": "2021-07-29",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "ryoto",
     "dodge",
     "ms_tia",
     "kaleb",
     "frau",
     "aki",
     "cruz",
     "talbot",
     "ares",
     "hera"
    ]
   },
   {
    "channel": "evelyn-college-2",
    "passages": 9,
    "share": 0.0443,
    "first": "2021-01-10",
    "last": "2021-01-26",
    "kind": "route",
    "castWith": [
     "evelyn",
     "darren",
     "dimitri",
     "lex",
     "hades",
     "raye",
     "jon",
     "ares",
     "kaleb",
     "cruz",
     "kya_sg3",
     "ari"
    ]
   },
   {
    "channel": "chance-route-ft-lance",
    "passages": 8,
    "share": 0.0394,
    "first": "2021-09-28",
    "last": "2021-10-26",
    "kind": "route",
    "castWith": [
     "lachesis",
     "chance",
     "lance",
     "god",
     "aphrodite",
     "atropos",
     "clothos",
     "moros",
     "ares",
     "hades",
     "may",
     "will"
    ]
   },
   {
    "channel": "mt-olympus",
    "passages": 8,
    "share": 0.0394,
    "first": "2020-03-29",
    "last": "2020-06-24",
    "kind": "route",
    "castWith": [
     "evelyn",
     "libion",
     "ares",
     "rex",
     "persephone",
     "bion",
     "hades",
     "aphrodite",
     "hercules",
     "demeter",
     "athena",
     "zerden"
    ]
   },
   {
    "channel": "lance-mating",
    "passages": 6,
    "share": 0.0296,
    "first": "2021-08-29",
    "last": "2021-08-30",
    "kind": "route",
    "castWith": [
     "cruz",
     "lance",
     "lachesis",
     "clothos",
     "ryder",
     "hades",
     "nolan",
     "nicole_human",
     "audrey",
     "moros",
     "atropos",
     "nicole_wolf"
    ]
   },
   {
    "channel": "dimitri-route-end",
    "passages": 6,
    "share": 0.0296,
    "first": "2021-02-03",
    "last": "2021-02-16",
    "kind": "route",
    "castWith": [
     "evelyn",
     "dimitri",
     "uri",
     "gambit",
     "jones",
     "ares",
     "bryce",
     "kaleb",
     "frau",
     "mr_han_sr",
     "kya_sg3",
     "uncle_khan"
    ]
   },
   {
    "channel": "dream-dude",
    "passages": 5,
    "share": 0.0246,
    "first": "2024-04-16",
    "last": "2024-04-22",
    "kind": "route",
    "castWith": [
     "hermes",
     "cupid_eros",
     "moros",
     "atropos",
     "lachesis",
     "apollo",
     "hercules",
     "haley_wolf",
     "haley_human",
     "nicole_human",
     "roman",
     "aphrodite"
    ]
   }
  ],
  "knownCharacters": [
   "evelyn",
   "cruz",
   "bryce",
   "ares",
   "lance",
   "selma",
   "lindon",
   "hera",
   "ryder",
   "apollo",
   "nolan",
   "diana"
  ]
 },
 "zephyr": {
  "canonRoute": "atropos-reincarnated",
  "totalPassages": 16,
  "routes": [
   {
    "channel": "atropos-reincarnated",
    "passages": 16,
    "share": 1.0,
    "first": "2022-06-14",
    "last": "2022-06-22",
    "kind": "canon",
    "castWith": [
     "moros",
     "apollo",
     "haley_wolf",
     "atropos",
     "zeus",
     "dante",
     "lachesis",
     "clothos",
     "aphrodite",
     "hera",
     "haley_human",
     "nicole_human"
    ]
   }
  ],
  "knownCharacters": [
   "moros",
   "apollo",
   "haley_wolf",
   "atropos",
   "zeus",
   "dante",
   "lachesis",
   "clothos",
   "aphrodite",
   "hera",
   "haley_human",
   "nicole_human"
  ]
 },
 "april": {
  "canonRoute": "actual-kaleb-romance",
  "totalPassages": 32,
  "routes": [
   {
    "channel": "actual-kaleb-romance",
    "passages": 21,
    "share": 0.6562,
    "first": "2022-09-28",
    "last": "2022-10-10",
    "kind": "canon",
    "castWith": [
     "kaleb",
     "will",
     "raz",
     "uncle_khan",
     "may"
    ]
   },
   {
    "channel": "eat-speak-rp-repeat",
    "passages": 7,
    "share": 0.2188,
    "first": "2026-03-19",
    "last": "2026-03-30",
    "kind": "ooc",
    "castWith": [
     "eric",
     "cruz",
     "lindon",
     "lance",
     "felix_fairy",
     "brooke",
     "cyrus_fairy",
     "malakai",
     "god",
     "jack",
     "pam",
     "ezra"
    ]
   },
   {
    "channel": "row-dimitri",
    "passages": 1,
    "share": 0.0312,
    "first": "2022-12-15",
    "last": "2022-12-15",
    "kind": "route",
    "castWith": [
     "rowan",
     "dimitri",
     "evelyn",
     "myra",
     "kaleb",
     "ezra",
     "kya_sg3"
    ]
   },
   {
    "channel": "human-lachesis",
    "passages": 1,
    "share": 0.0312,
    "first": "2024-10-04",
    "last": "2024-10-04",
    "kind": "route",
    "castWith": [
     "nicole_human",
     "brax",
     "lachesis",
     "lance",
     "vaughn",
     "rowan",
     "god",
     "alyce_char",
     "moros",
     "ford",
     "atropos",
     "cruz"
    ]
   },
   {
    "channel": "staff-break-room",
    "passages": 1,
    "share": 0.0312,
    "first": "2020-06-16",
    "last": "2020-06-16",
    "kind": "route",
    "castWith": [
     "dimitri",
     "rex",
     "evelyn",
     "saph",
     "diana",
     "aaron",
     "kiro",
     "milo",
     "skipper",
     "roman",
     "sebastian_vamp",
     "kya_sg3"
    ]
   },
   {
    "channel": "college-campus",
    "passages": 1,
    "share": 0.0312,
    "first": "2020-05-11",
    "last": "2020-05-11",
    "kind": "route",
    "castWith": [
     "agnar",
     "agmund",
     "kya_sg3",
     "penelope_valk",
     "evelyn",
     "svira",
     "rowan",
     "may",
     "jon",
     "kya_sg1",
     "kaleb",
     "darren"
    ]
   }
  ],
  "knownCharacters": [
   "kaleb",
   "will",
   "raz",
   "uncle_khan",
   "may"
  ]
 }
};
